export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  JSON: any;
  _text: any;
  citext: any;
  date: any;
  discover_status_enum: any;
  ed_type_enum: any;
  float8: any;
  hackathon_hosts_type_enum: any;
  hackathons_apply_mode_enum: any;
  hackathons_status_enum: any;
  hc_file_type_enum: any;
  hc_type_enum: any;
  hse_at_app_status_enum: any;
  hse_file_type_enum: any;
  hse_role_enum: any;
  hse_type_enum: any;
  jsonb: any;
  lquery: any;
  ltree: any;
  ltxtquery: any;
  numeric: any;
  pc_status_enum: any;
  projects_status_enum: any;
  skills_status_enum: any;
  teams_status_enum: any;
  timestamptz: any;
  ue_preferred_pronoun_enum: any;
  ue_t_shirt_size_enum: any;
  uh_role_enum: any;
  uh_status_enum: any;
  us_experience_enum: any;
  users_gender_enum: any;
  users_status_enum: any;
};

export type AddSchwagProductOutput = {
  __typename?: 'AddSchwagProductOutput';
  form_submitted: Scalars['Boolean'];
};

export type AmaOutput = {
  __typename?: 'AmaOutput';
  message_sent: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export enum CheerProjectChain {
  Arbitrum = 'ARBITRUM',
  Base = 'BASE',
  Optimism = 'OPTIMISM',
  Sepolia = 'SEPOLIA'
}

export type CheerProjectOutput = {
  __typename?: 'CheerProjectOutput';
  attestation: CheerProjectOutputAttestation;
  eas: CheerProjectOutputEasDetails;
  project_contribution_uuid: Scalars['String'];
};

export type CheerProjectOutputAttestation = {
  __typename?: 'CheerProjectOutputAttestation';
  attester: Scalars['String'];
  data: Scalars['JSON'];
  deadline: Scalars['BigInt'];
  schema: Scalars['String'];
  signature: Scalars['JSON'];
};

export type CheerProjectOutputEasDetails = {
  __typename?: 'CheerProjectOutputEASDetails';
  chain: CheerProjectChain;
  eas_contract_address: Scalars['String'];
  eas_proxy_contract_address: Scalars['String'];
};

export type CheerProjectSticker = {
  quantity: Scalars['Int'];
  uuid: Scalars['String'];
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

export type HackathonCredentialClaimOutput = {
  __typename?: 'HackathonCredentialClaimOutput';
  attestation: HackathonCredentialOutputAttestation;
  user_hackathon_credential_uuid: Scalars['String'];
};

export type HackathonCredentialOutputAttestation = {
  __typename?: 'HackathonCredentialOutputAttestation';
  attester: Scalars['String'];
  data: Scalars['JSON'];
  deadline: Scalars['BigInt'];
  schema: Scalars['String'];
  signature: Scalars['JSON'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type NominateBuilderOutput = {
  __typename?: 'NominateBuilderOutput';
  form_submitted: Scalars['Boolean'];
};

export type QuadraticVotingOutput = {
  __typename?: 'QuadraticVotingOutput';
  quadratic_voting_uuid: Scalars['String'];
};

export type QuadraticVotingProject = {
  uuid: Scalars['String'];
  votes: Scalars['Int'];
};

export type ReportCommentOutput = {
  __typename?: 'ReportCommentOutput';
  form_submitted: Scalars['Boolean'];
};

export type ReportProjectOutput = {
  __typename?: 'ReportProjectOutput';
  form_submitted: Scalars['Boolean'];
};

export enum ReportType {
  Harmful = 'HARMFUL',
  Plagiarism = 'PLAGIARISM',
  Recycling = 'RECYCLING',
  Spam = 'SPAM'
}

export type RsvpStakingOutput = {
  __typename?: 'RsvpStakingOutput';
  razorpay_order_id?: Maybe<Scalars['String']>;
  user_hackathon_staking_uuid: Scalars['String'];
};

export type SchwagFulfilmentFormOutput = {
  __typename?: 'SchwagFulfilmentFormOutput';
  emails_sent: Scalars['Boolean'];
};

export type ShippingAddress = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  full_name: Scalars['String'];
  phone_number: Scalars['String'];
  pin_code: Scalars['String'];
  state: Scalars['String'];
  t_shirt_size: Scalars['String'];
};

export type SiweConnectEthereumWalletOutput = {
  __typename?: 'SiweConnectEthereumWalletOutput';
  ethereum_wallet_connected: Scalars['Boolean'];
};

export type SiweDisconnectEthereumWalletOutput = {
  __typename?: 'SiweDisconnectEthereumWalletOutput';
  ethereum_wallet_connected: Scalars['Boolean'];
};

export type SiweGenerateNonceOutput = {
  __typename?: 'SiweGenerateNonceOutput';
  nonce: Scalars['String'];
};

export type SiweMessageInput = {
  address: Scalars['String'];
  chainId: Scalars['Int'];
  domain: Scalars['String'];
  issuedAt: Scalars['String'];
  nonce: Scalars['String'];
  statement: Scalars['String'];
  uri: Scalars['String'];
  version: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type SubmitSchwagShippingAddressOutput = {
  __typename?: 'SubmitSchwagShippingAddressOutput';
  form_submitted: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']>;
  _gt?: InputMaybe<Scalars['_text']>;
  _gte?: InputMaybe<Scalars['_text']>;
  _in?: InputMaybe<Array<Scalars['_text']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_text']>;
  _lte?: InputMaybe<Scalars['_text']>;
  _neq?: InputMaybe<Scalars['_text']>;
  _nin?: InputMaybe<Array<Scalars['_text']>>;
};

export type Add_Comment_To_Project_Args = {
  comment_value?: InputMaybe<Scalars['String']>;
  parent_comment_uuid?: InputMaybe<Scalars['String']>;
  project_uuid?: InputMaybe<Scalars['String']>;
};

export type Add_Hackathon_Edition_Args = {
  brand_uuid?: InputMaybe<Scalars['String']>;
  edition_value?: InputMaybe<Scalars['Int']>;
  hackathon_uuid?: InputMaybe<Scalars['String']>;
};

export type Add_Hackathon_Reminder_Args = {
  hackathon_uuid?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  line_1?: Maybe<Scalars['String']>;
  line_2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

/** aggregated selection of "address" */
export type Address_Aggregate = {
  __typename?: 'address_aggregate';
  aggregate?: Maybe<Address_Aggregate_Fields>;
  nodes: Array<Address>;
};

/** aggregate fields of "address" */
export type Address_Aggregate_Fields = {
  __typename?: 'address_aggregate_fields';
  avg?: Maybe<Address_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Address_Max_Fields>;
  min?: Maybe<Address_Min_Fields>;
  stddev?: Maybe<Address_Stddev_Fields>;
  stddev_pop?: Maybe<Address_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Address_Stddev_Samp_Fields>;
  sum?: Maybe<Address_Sum_Fields>;
  var_pop?: Maybe<Address_Var_Pop_Fields>;
  var_samp?: Maybe<Address_Var_Samp_Fields>;
  variance?: Maybe<Address_Variance_Fields>;
};


/** aggregate fields of "address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Address_Avg_Fields = {
  __typename?: 'address_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  line_1?: InputMaybe<String_Comparison_Exp>;
  line_2?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAddress = 'pk_address',
  /** unique or primary key constraint on columns "user_id" */
  UniqueUserIdAddress = 'unique_user_id_address',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidAddress = 'unique_uuid_address'
}

/** input type for incrementing numeric columns in table "address" */
export type Address_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  line_1?: InputMaybe<Scalars['String']>;
  line_2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: 'address_max_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  line_1?: Maybe<Scalars['String']>;
  line_2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: 'address_min_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  line_1?: Maybe<Scalars['String']>;
  line_2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_1?: InputMaybe<Order_By>;
  line_2?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Line_1 = 'line_1',
  /** column name */
  Line_2 = 'line_2',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  line_1?: InputMaybe<Scalars['String']>;
  line_2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Address_Stddev_Fields = {
  __typename?: 'address_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Address_Stddev_Pop_Fields = {
  __typename?: 'address_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Address_Stddev_Samp_Fields = {
  __typename?: 'address_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  line_1?: InputMaybe<Scalars['String']>;
  line_2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Address_Sum_Fields = {
  __typename?: 'address_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Line_1 = 'line_1',
  /** column name */
  Line_2 = 'line_2',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Zip = 'zip'
}

export type Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Address_Var_Pop_Fields = {
  __typename?: 'address_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Address_Var_Samp_Fields = {
  __typename?: 'address_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Address_Variance_Fields = {
  __typename?: 'address_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "articles" */
export type Articles = {
  __typename?: 'articles';
  created_at: Scalars['timestamptz'];
  desc?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  id: Scalars['Int'];
  img?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "articles" */
export type Articles_Aggregate = {
  __typename?: 'articles_aggregate';
  aggregate?: Maybe<Articles_Aggregate_Fields>;
  nodes: Array<Articles>;
};

/** aggregate fields of "articles" */
export type Articles_Aggregate_Fields = {
  __typename?: 'articles_aggregate_fields';
  avg?: Maybe<Articles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Articles_Max_Fields>;
  min?: Maybe<Articles_Min_Fields>;
  stddev?: Maybe<Articles_Stddev_Fields>;
  stddev_pop?: Maybe<Articles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Articles_Stddev_Samp_Fields>;
  sum?: Maybe<Articles_Sum_Fields>;
  var_pop?: Maybe<Articles_Var_Pop_Fields>;
  var_samp?: Maybe<Articles_Var_Samp_Fields>;
  variance?: Maybe<Articles_Variance_Fields>;
};


/** aggregate fields of "articles" */
export type Articles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Articles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Articles_Avg_Fields = {
  __typename?: 'articles_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "articles". All fields are combined with a logical 'AND'. */
export type Articles_Bool_Exp = {
  _and?: InputMaybe<Array<Articles_Bool_Exp>>;
  _not?: InputMaybe<Articles_Bool_Exp>;
  _or?: InputMaybe<Array<Articles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  img?: InputMaybe<String_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "articles" */
export enum Articles_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkArticles = 'pk_articles',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidArticles = 'unique_uuid_articles'
}

/** input type for incrementing numeric columns in table "articles" */
export type Articles_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "articles" */
export type Articles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  img?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Articles_Max_Fields = {
  __typename?: 'articles_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  img?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Articles_Min_Fields = {
  __typename?: 'articles_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  img?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "articles" */
export type Articles_Mutation_Response = {
  __typename?: 'articles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Articles>;
};

/** on_conflict condition type for table "articles" */
export type Articles_On_Conflict = {
  constraint: Articles_Constraint;
  update_columns?: Array<Articles_Update_Column>;
  where?: InputMaybe<Articles_Bool_Exp>;
};

/** Ordering options when selecting data from "articles". */
export type Articles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  img?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: articles */
export type Articles_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "articles" */
export enum Articles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  Img = 'img',
  /** column name */
  Link = 'link',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "articles" */
export type Articles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  img?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Articles_Stddev_Fields = {
  __typename?: 'articles_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Articles_Stddev_Pop_Fields = {
  __typename?: 'articles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Articles_Stddev_Samp_Fields = {
  __typename?: 'articles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "articles" */
export type Articles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Articles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Articles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  img?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Articles_Sum_Fields = {
  __typename?: 'articles_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "articles" */
export enum Articles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  Img = 'img',
  /** column name */
  Link = 'link',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Articles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Articles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Articles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Articles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Articles_Var_Pop_Fields = {
  __typename?: 'articles_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Articles_Var_Samp_Fields = {
  __typename?: 'articles_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Articles_Variance_Fields = {
  __typename?: 'articles_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']>;
  _gt?: InputMaybe<Scalars['citext']>;
  _gte?: InputMaybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']>;
  _in?: InputMaybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']>;
  _lt?: InputMaybe<Scalars['citext']>;
  _lte?: InputMaybe<Scalars['citext']>;
  _neq?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']>;
  _nin?: InputMaybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']>;
};

/** columns and relationships of "colleges" */
export type Colleges = {
  __typename?: 'colleges';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  short_name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
  uuid: Scalars['String'];
  verified?: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "colleges" */
export type Colleges_Aggregate = {
  __typename?: 'colleges_aggregate';
  aggregate?: Maybe<Colleges_Aggregate_Fields>;
  nodes: Array<Colleges>;
};

/** aggregate fields of "colleges" */
export type Colleges_Aggregate_Fields = {
  __typename?: 'colleges_aggregate_fields';
  avg?: Maybe<Colleges_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Colleges_Max_Fields>;
  min?: Maybe<Colleges_Min_Fields>;
  stddev?: Maybe<Colleges_Stddev_Fields>;
  stddev_pop?: Maybe<Colleges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Colleges_Stddev_Samp_Fields>;
  sum?: Maybe<Colleges_Sum_Fields>;
  var_pop?: Maybe<Colleges_Var_Pop_Fields>;
  var_samp?: Maybe<Colleges_Var_Samp_Fields>;
  variance?: Maybe<Colleges_Variance_Fields>;
};


/** aggregate fields of "colleges" */
export type Colleges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Colleges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Colleges_Avg_Fields = {
  __typename?: 'colleges_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "colleges". All fields are combined with a logical 'AND'. */
export type Colleges_Bool_Exp = {
  _and?: InputMaybe<Array<Colleges_Bool_Exp>>;
  _not?: InputMaybe<Colleges_Bool_Exp>;
  _or?: InputMaybe<Array<Colleges_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "colleges" */
export enum Colleges_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkColleges = 'pk_colleges',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidColleges = 'unique_uuid_colleges'
}

/** input type for incrementing numeric columns in table "colleges" */
export type Colleges_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "colleges" */
export type Colleges_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Colleges_Max_Fields = {
  __typename?: 'colleges_max_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Colleges_Min_Fields = {
  __typename?: 'colleges_min_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "colleges" */
export type Colleges_Mutation_Response = {
  __typename?: 'colleges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Colleges>;
};

/** input type for inserting object relation for remote table "colleges" */
export type Colleges_Obj_Rel_Insert_Input = {
  data: Colleges_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Colleges_On_Conflict>;
};

/** on_conflict condition type for table "colleges" */
export type Colleges_On_Conflict = {
  constraint: Colleges_Constraint;
  update_columns?: Array<Colleges_Update_Column>;
  where?: InputMaybe<Colleges_Bool_Exp>;
};

/** Ordering options when selecting data from "colleges". */
export type Colleges_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: colleges */
export type Colleges_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "colleges" */
export enum Colleges_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "colleges" */
export type Colleges_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Colleges_Stddev_Fields = {
  __typename?: 'colleges_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Colleges_Stddev_Pop_Fields = {
  __typename?: 'colleges_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Colleges_Stddev_Samp_Fields = {
  __typename?: 'colleges_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "colleges" */
export type Colleges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Colleges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Colleges_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Colleges_Sum_Fields = {
  __typename?: 'colleges_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "colleges" */
export enum Colleges_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

export type Colleges_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Colleges_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Colleges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Colleges_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Colleges_Var_Pop_Fields = {
  __typename?: 'colleges_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Colleges_Var_Samp_Fields = {
  __typename?: 'colleges_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Colleges_Variance_Fields = {
  __typename?: 'colleges_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** This table is used to store the comments */
export type Comments = {
  __typename?: 'comments';
  /** The computed value of the comment */
  _value?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  depth?: Maybe<Scalars['Int']>;
  /** An array relationship */
  descendants: Array<Comments>;
  /** An aggregate relationship */
  descendants_aggregate: Comments_Aggregate;
  downvote_count?: Maybe<Scalars['Int']>;
  hidden: Scalars['Boolean'];
  id: Scalars['Int'];
  is_project_flag_comment: Scalars['Boolean'];
  /** An object relationship */
  parent?: Maybe<Comments>;
  parent_comment_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['ltree']>;
  /** An object relationship */
  project_contribution?: Maybe<Project_Contributions>;
  project_contribution_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  report?: Maybe<Project_Reports>;
  report_id?: Maybe<Scalars['Int']>;
  report_resolved: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  upvote_count?: Maybe<Scalars['Int']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An array relationship */
  user_comment: Array<User_Comments>;
  /** An aggregate relationship */
  user_comment_aggregate: User_Comments_Aggregate;
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
  value: Scalars['String'];
};


/** This table is used to store the comments */
export type CommentsDescendantsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** This table is used to store the comments */
export type CommentsDescendants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** This table is used to store the comments */
export type CommentsUser_CommentArgs = {
  distinct_on?: InputMaybe<Array<User_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Comments_Order_By>>;
  where?: InputMaybe<User_Comments_Bool_Exp>;
};


/** This table is used to store the comments */
export type CommentsUser_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Comments_Order_By>>;
  where?: InputMaybe<User_Comments_Bool_Exp>;
};

/** aggregated selection of "comments" */
export type Comments_Aggregate = {
  __typename?: 'comments_aggregate';
  aggregate?: Maybe<Comments_Aggregate_Fields>;
  nodes: Array<Comments>;
};

export type Comments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Comments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Comments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Comments_Aggregate_Bool_Exp_Count>;
};

export type Comments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Comments_Select_Column_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Comments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Comments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Comments_Select_Column_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Comments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "comments" */
export type Comments_Aggregate_Fields = {
  __typename?: 'comments_aggregate_fields';
  avg?: Maybe<Comments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Comments_Max_Fields>;
  min?: Maybe<Comments_Min_Fields>;
  stddev?: Maybe<Comments_Stddev_Fields>;
  stddev_pop?: Maybe<Comments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Comments_Stddev_Samp_Fields>;
  sum?: Maybe<Comments_Sum_Fields>;
  var_pop?: Maybe<Comments_Var_Pop_Fields>;
  var_samp?: Maybe<Comments_Var_Samp_Fields>;
  variance?: Maybe<Comments_Variance_Fields>;
};


/** aggregate fields of "comments" */
export type Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "comments" */
export type Comments_Aggregate_Order_By = {
  avg?: InputMaybe<Comments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comments_Max_Order_By>;
  min?: InputMaybe<Comments_Min_Order_By>;
  stddev?: InputMaybe<Comments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Comments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Comments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Comments_Sum_Order_By>;
  var_pop?: InputMaybe<Comments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Comments_Var_Samp_Order_By>;
  variance?: InputMaybe<Comments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "comments" */
export type Comments_Arr_Rel_Insert_Input = {
  data: Array<Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** aggregate avg on columns */
export type Comments_Avg_Fields = {
  __typename?: 'comments_avg_fields';
  depth?: Maybe<Scalars['Float']>;
  downvote_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_comment_id?: Maybe<Scalars['Float']>;
  project_contribution_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  upvote_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "comments" */
export type Comments_Avg_Order_By = {
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "comments". All fields are combined with a logical 'AND'. */
export type Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Comments_Bool_Exp>>;
  _not?: InputMaybe<Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Comments_Bool_Exp>>;
  _value?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  depth?: InputMaybe<Int_Comparison_Exp>;
  descendants?: InputMaybe<Comments_Bool_Exp>;
  descendants_aggregate?: InputMaybe<Comments_Aggregate_Bool_Exp>;
  downvote_count?: InputMaybe<Int_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_project_flag_comment?: InputMaybe<Boolean_Comparison_Exp>;
  parent?: InputMaybe<Comments_Bool_Exp>;
  parent_comment_id?: InputMaybe<Int_Comparison_Exp>;
  path?: InputMaybe<Ltree_Comparison_Exp>;
  project_contribution?: InputMaybe<Project_Contributions_Bool_Exp>;
  project_contribution_id?: InputMaybe<Int_Comparison_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  report?: InputMaybe<Project_Reports_Bool_Exp>;
  report_id?: InputMaybe<Int_Comparison_Exp>;
  report_resolved?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  upvote_count?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_comment?: InputMaybe<User_Comments_Bool_Exp>;
  user_comment_aggregate?: InputMaybe<User_Comments_Aggregate_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "comments" */
export enum Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentsPkey = 'comments_pkey',
  /** unique or primary key constraint on columns "uuid" */
  CommentsUuidKey = 'comments_uuid_key'
}

/** input type for incrementing numeric columns in table "comments" */
export type Comments_Inc_Input = {
  downvote_count?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  parent_comment_id?: InputMaybe<Scalars['Int']>;
  project_contribution_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  report_id?: InputMaybe<Scalars['Int']>;
  upvote_count?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "comments" */
export type Comments_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  descendants?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  downvote_count?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_project_flag_comment?: InputMaybe<Scalars['Boolean']>;
  parent?: InputMaybe<Comments_Obj_Rel_Insert_Input>;
  parent_comment_id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['ltree']>;
  project_contribution?: InputMaybe<Project_Contributions_Obj_Rel_Insert_Input>;
  project_contribution_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  report?: InputMaybe<Project_Reports_Obj_Rel_Insert_Input>;
  report_id?: InputMaybe<Scalars['Int']>;
  report_resolved?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upvote_count?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_comment?: InputMaybe<User_Comments_Arr_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Comments_Max_Fields = {
  __typename?: 'comments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  depth?: Maybe<Scalars['Int']>;
  downvote_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent_comment_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['ltree']>;
  project_contribution_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  report_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  upvote_count?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "comments" */
export type Comments_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Comments_Min_Fields = {
  __typename?: 'comments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  depth?: Maybe<Scalars['Int']>;
  downvote_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent_comment_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['ltree']>;
  project_contribution_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  report_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  upvote_count?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "comments" */
export type Comments_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comments" */
export type Comments_Mutation_Response = {
  __typename?: 'comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Comments>;
};

/** input type for inserting object relation for remote table "comments" */
export type Comments_Obj_Rel_Insert_Input = {
  data: Comments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** on_conflict condition type for table "comments" */
export type Comments_On_Conflict = {
  constraint: Comments_Constraint;
  update_columns?: Array<Comments_Update_Column>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "comments". */
export type Comments_Order_By = {
  _value?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  depth?: InputMaybe<Order_By>;
  descendants_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_project_flag_comment?: InputMaybe<Order_By>;
  parent?: InputMaybe<Comments_Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  project_contribution?: InputMaybe<Project_Contributions_Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report?: InputMaybe<Project_Reports_Order_By>;
  report_id?: InputMaybe<Order_By>;
  report_resolved?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_comment_aggregate?: InputMaybe<User_Comments_Aggregate_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comments */
export type Comments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "comments" */
export enum Comments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Depth = 'depth',
  /** column name */
  DownvoteCount = 'downvote_count',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IsProjectFlagComment = 'is_project_flag_comment',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  Path = 'path',
  /** column name */
  ProjectContributionId = 'project_contribution_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ReportResolved = 'report_resolved',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpvoteCount = 'upvote_count',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

/** select "comments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "comments" */
export enum Comments_Select_Column_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsProjectFlagComment = 'is_project_flag_comment',
  /** column name */
  ReportResolved = 'report_resolved'
}

/** select "comments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "comments" */
export enum Comments_Select_Column_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsProjectFlagComment = 'is_project_flag_comment',
  /** column name */
  ReportResolved = 'report_resolved'
}

/** input type for updating data in table "comments" */
export type Comments_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  downvote_count?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_project_flag_comment?: InputMaybe<Scalars['Boolean']>;
  parent_comment_id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['ltree']>;
  project_contribution_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  report_id?: InputMaybe<Scalars['Int']>;
  report_resolved?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upvote_count?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Comments_Stddev_Fields = {
  __typename?: 'comments_stddev_fields';
  depth?: Maybe<Scalars['Float']>;
  downvote_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_comment_id?: Maybe<Scalars['Float']>;
  project_contribution_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  upvote_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "comments" */
export type Comments_Stddev_Order_By = {
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Comments_Stddev_Pop_Fields = {
  __typename?: 'comments_stddev_pop_fields';
  depth?: Maybe<Scalars['Float']>;
  downvote_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_comment_id?: Maybe<Scalars['Float']>;
  project_contribution_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  upvote_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "comments" */
export type Comments_Stddev_Pop_Order_By = {
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Comments_Stddev_Samp_Fields = {
  __typename?: 'comments_stddev_samp_fields';
  depth?: Maybe<Scalars['Float']>;
  downvote_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_comment_id?: Maybe<Scalars['Float']>;
  project_contribution_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  upvote_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "comments" */
export type Comments_Stddev_Samp_Order_By = {
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "comments" */
export type Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  depth?: InputMaybe<Scalars['Int']>;
  downvote_count?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_project_flag_comment?: InputMaybe<Scalars['Boolean']>;
  parent_comment_id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['ltree']>;
  project_contribution_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  report_id?: InputMaybe<Scalars['Int']>;
  report_resolved?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upvote_count?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Comments_Sum_Fields = {
  __typename?: 'comments_sum_fields';
  depth?: Maybe<Scalars['Int']>;
  downvote_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent_comment_id?: Maybe<Scalars['Int']>;
  project_contribution_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  report_id?: Maybe<Scalars['Int']>;
  upvote_count?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "comments" */
export type Comments_Sum_Order_By = {
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "comments" */
export enum Comments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DownvoteCount = 'downvote_count',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IsProjectFlagComment = 'is_project_flag_comment',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  Path = 'path',
  /** column name */
  ProjectContributionId = 'project_contribution_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ReportResolved = 'report_resolved',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpvoteCount = 'upvote_count',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

export type Comments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Comments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Comments_Var_Pop_Fields = {
  __typename?: 'comments_var_pop_fields';
  depth?: Maybe<Scalars['Float']>;
  downvote_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_comment_id?: Maybe<Scalars['Float']>;
  project_contribution_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  upvote_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "comments" */
export type Comments_Var_Pop_Order_By = {
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Comments_Var_Samp_Fields = {
  __typename?: 'comments_var_samp_fields';
  depth?: Maybe<Scalars['Float']>;
  downvote_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_comment_id?: Maybe<Scalars['Float']>;
  project_contribution_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  upvote_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "comments" */
export type Comments_Var_Samp_Order_By = {
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Comments_Variance_Fields = {
  __typename?: 'comments_variance_fields';
  depth?: Maybe<Scalars['Float']>;
  downvote_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_comment_id?: Maybe<Scalars['Float']>;
  project_contribution_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  upvote_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "comments" */
export type Comments_Variance_Order_By = {
  depth?: InputMaybe<Order_By>;
  downvote_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  upvote_count?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "company" */
export type Company = {
  __typename?: 'company';
  /** This function is used for adding the assets prefix to the favicon field */
  _favicon?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  domain?: Maybe<Scalars['citext']>;
  favicon?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_partner?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
  verified?: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "company" */
export type Company_Aggregate = {
  __typename?: 'company_aggregate';
  aggregate?: Maybe<Company_Aggregate_Fields>;
  nodes: Array<Company>;
};

/** aggregate fields of "company" */
export type Company_Aggregate_Fields = {
  __typename?: 'company_aggregate_fields';
  avg?: Maybe<Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Company_Max_Fields>;
  min?: Maybe<Company_Min_Fields>;
  stddev?: Maybe<Company_Stddev_Fields>;
  stddev_pop?: Maybe<Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Company_Stddev_Samp_Fields>;
  sum?: Maybe<Company_Sum_Fields>;
  var_pop?: Maybe<Company_Var_Pop_Fields>;
  var_samp?: Maybe<Company_Var_Samp_Fields>;
  variance?: Maybe<Company_Variance_Fields>;
};


/** aggregate fields of "company" */
export type Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Company_Avg_Fields = {
  __typename?: 'company_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp = {
  _and?: InputMaybe<Array<Company_Bool_Exp>>;
  _favicon?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Company_Bool_Exp>;
  _or?: InputMaybe<Array<Company_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  domain?: InputMaybe<Citext_Comparison_Exp>;
  favicon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_partner?: InputMaybe<Boolean_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "company" */
export enum Company_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCompany = 'pk_company',
  /** unique or primary key constraint on columns "domain" */
  UniqueDomainCompany = 'unique_domain_company',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidCompany = 'unique_uuid_company'
}

/** input type for incrementing numeric columns in table "company" */
export type Company_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company" */
export type Company_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  domain?: InputMaybe<Scalars['citext']>;
  favicon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_partner?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Company_Max_Fields = {
  __typename?: 'company_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  domain?: Maybe<Scalars['citext']>;
  favicon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Company_Min_Fields = {
  __typename?: 'company_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  domain?: Maybe<Scalars['citext']>;
  favicon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "company" */
export type Company_Mutation_Response = {
  __typename?: 'company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company>;
};

/** input type for inserting object relation for remote table "company" */
export type Company_Obj_Rel_Insert_Input = {
  data: Company_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Company_On_Conflict>;
};

/** on_conflict condition type for table "company" */
export type Company_On_Conflict = {
  constraint: Company_Constraint;
  update_columns?: Array<Company_Update_Column>;
  where?: InputMaybe<Company_Bool_Exp>;
};

/** Ordering options when selecting data from "company". */
export type Company_Order_By = {
  _favicon?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  favicon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_partner?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: company */
export type Company_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "company" */
export enum Company_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Domain = 'domain',
  /** column name */
  Favicon = 'favicon',
  /** column name */
  Id = 'id',
  /** column name */
  IsPartner = 'is_partner',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "company" */
export type Company_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  domain?: InputMaybe<Scalars['citext']>;
  favicon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_partner?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Company_Stddev_Fields = {
  __typename?: 'company_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Company_Stddev_Pop_Fields = {
  __typename?: 'company_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Company_Stddev_Samp_Fields = {
  __typename?: 'company_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company" */
export type Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  domain?: InputMaybe<Scalars['citext']>;
  favicon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_partner?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Company_Sum_Fields = {
  __typename?: 'company_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "company" */
export enum Company_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Domain = 'domain',
  /** column name */
  Favicon = 'favicon',
  /** column name */
  Id = 'id',
  /** column name */
  IsPartner = 'is_partner',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

export type Company_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Company_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Company_Set_Input>;
  /** filter the rows which have to be updated */
  where: Company_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Company_Var_Pop_Fields = {
  __typename?: 'company_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Company_Var_Samp_Fields = {
  __typename?: 'company_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Company_Variance_Fields = {
  __typename?: 'company_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "discover" */
export type Discover = {
  __typename?: 'discover';
  articles?: Maybe<Scalars['jsonb']>;
  builders?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  events?: Maybe<Scalars['jsonb']>;
  hackathons?: Maybe<Scalars['jsonb']>;
  ideas?: Maybe<Scalars['jsonb']>;
  projects?: Maybe<Scalars['jsonb']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  questions?: Maybe<Scalars['jsonb']>;
  status: Scalars['discover_status_enum'];
  tweets?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};


/** columns and relationships of "discover" */
export type DiscoverArticlesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "discover" */
export type DiscoverBuildersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "discover" */
export type DiscoverEventsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "discover" */
export type DiscoverHackathonsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "discover" */
export type DiscoverIdeasArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "discover" */
export type DiscoverProjectsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "discover" */
export type DiscoverQuestionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "discover" */
export type DiscoverTweetsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "discover" */
export type Discover_Aggregate = {
  __typename?: 'discover_aggregate';
  aggregate?: Maybe<Discover_Aggregate_Fields>;
  nodes: Array<Discover>;
};

/** aggregate fields of "discover" */
export type Discover_Aggregate_Fields = {
  __typename?: 'discover_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Discover_Max_Fields>;
  min?: Maybe<Discover_Min_Fields>;
};


/** aggregate fields of "discover" */
export type Discover_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discover_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Discover_Append_Input = {
  articles?: InputMaybe<Scalars['jsonb']>;
  builders?: InputMaybe<Scalars['jsonb']>;
  events?: InputMaybe<Scalars['jsonb']>;
  hackathons?: InputMaybe<Scalars['jsonb']>;
  ideas?: InputMaybe<Scalars['jsonb']>;
  projects?: InputMaybe<Scalars['jsonb']>;
  questions?: InputMaybe<Scalars['jsonb']>;
  tweets?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "discover". All fields are combined with a logical 'AND'. */
export type Discover_Bool_Exp = {
  _and?: InputMaybe<Array<Discover_Bool_Exp>>;
  _not?: InputMaybe<Discover_Bool_Exp>;
  _or?: InputMaybe<Array<Discover_Bool_Exp>>;
  articles?: InputMaybe<Jsonb_Comparison_Exp>;
  builders?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  events?: InputMaybe<Jsonb_Comparison_Exp>;
  hackathons?: InputMaybe<Jsonb_Comparison_Exp>;
  ideas?: InputMaybe<Jsonb_Comparison_Exp>;
  projects?: InputMaybe<Jsonb_Comparison_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  questions?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<Discover_Status_Enum_Comparison_Exp>;
  tweets?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "discover" */
export enum Discover_Constraint {
  /** unique or primary key constraint on columns "uuid" */
  DiscoverPkey = 'discover_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Discover_Delete_At_Path_Input = {
  articles?: InputMaybe<Array<Scalars['String']>>;
  builders?: InputMaybe<Array<Scalars['String']>>;
  events?: InputMaybe<Array<Scalars['String']>>;
  hackathons?: InputMaybe<Array<Scalars['String']>>;
  ideas?: InputMaybe<Array<Scalars['String']>>;
  projects?: InputMaybe<Array<Scalars['String']>>;
  questions?: InputMaybe<Array<Scalars['String']>>;
  tweets?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Discover_Delete_Elem_Input = {
  articles?: InputMaybe<Scalars['Int']>;
  builders?: InputMaybe<Scalars['Int']>;
  events?: InputMaybe<Scalars['Int']>;
  hackathons?: InputMaybe<Scalars['Int']>;
  ideas?: InputMaybe<Scalars['Int']>;
  projects?: InputMaybe<Scalars['Int']>;
  questions?: InputMaybe<Scalars['Int']>;
  tweets?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Discover_Delete_Key_Input = {
  articles?: InputMaybe<Scalars['String']>;
  builders?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Scalars['String']>;
  hackathons?: InputMaybe<Scalars['String']>;
  ideas?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Scalars['String']>;
  tweets?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "discover_events" */
export type Discover_Events = {
  __typename?: 'discover_events';
  /** A computed field, executes function "discover_events_image" */
  _image?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  discover: Scalars['Boolean'];
  end_time: Scalars['timestamptz'];
  id: Scalars['Int'];
  image: Scalars['String'];
  is_online: Scalars['Boolean'];
  location?: Maybe<Scalars['String']>;
  start_time: Scalars['timestamptz'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "discover_events" */
export type Discover_Events_Aggregate = {
  __typename?: 'discover_events_aggregate';
  aggregate?: Maybe<Discover_Events_Aggregate_Fields>;
  nodes: Array<Discover_Events>;
};

/** aggregate fields of "discover_events" */
export type Discover_Events_Aggregate_Fields = {
  __typename?: 'discover_events_aggregate_fields';
  avg?: Maybe<Discover_Events_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Discover_Events_Max_Fields>;
  min?: Maybe<Discover_Events_Min_Fields>;
  stddev?: Maybe<Discover_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Discover_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discover_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Discover_Events_Sum_Fields>;
  var_pop?: Maybe<Discover_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Discover_Events_Var_Samp_Fields>;
  variance?: Maybe<Discover_Events_Variance_Fields>;
};


/** aggregate fields of "discover_events" */
export type Discover_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discover_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Discover_Events_Avg_Fields = {
  __typename?: 'discover_events_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "discover_events". All fields are combined with a logical 'AND'. */
export type Discover_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Discover_Events_Bool_Exp>>;
  _image?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Discover_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Discover_Events_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discover?: InputMaybe<Boolean_Comparison_Exp>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "discover_events" */
export enum Discover_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  DiscoverEventsPkey = 'discover_events_pkey',
  /** unique or primary key constraint on columns "uuid" */
  DiscoverEventsUuidKey = 'discover_events_uuid_key'
}

/** input type for incrementing numeric columns in table "discover_events" */
export type Discover_Events_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "discover_events" */
export type Discover_Events_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  end_time?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_online?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Discover_Events_Max_Fields = {
  __typename?: 'discover_events_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Discover_Events_Min_Fields = {
  __typename?: 'discover_events_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "discover_events" */
export type Discover_Events_Mutation_Response = {
  __typename?: 'discover_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Discover_Events>;
};

/** on_conflict condition type for table "discover_events" */
export type Discover_Events_On_Conflict = {
  constraint: Discover_Events_Constraint;
  update_columns?: Array<Discover_Events_Update_Column>;
  where?: InputMaybe<Discover_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "discover_events". */
export type Discover_Events_Order_By = {
  _image?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discover?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discover_events */
export type Discover_Events_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "discover_events" */
export enum Discover_Events_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Discover = 'discover',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  Location = 'location',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "discover_events" */
export type Discover_Events_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  end_time?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_online?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Discover_Events_Stddev_Fields = {
  __typename?: 'discover_events_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Discover_Events_Stddev_Pop_Fields = {
  __typename?: 'discover_events_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Discover_Events_Stddev_Samp_Fields = {
  __typename?: 'discover_events_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "discover_events" */
export type Discover_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discover_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discover_Events_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  end_time?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_online?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Discover_Events_Sum_Fields = {
  __typename?: 'discover_events_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "discover_events" */
export enum Discover_Events_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Discover = 'discover',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  Location = 'location',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Discover_Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Discover_Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Discover_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Discover_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Discover_Events_Var_Pop_Fields = {
  __typename?: 'discover_events_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Discover_Events_Var_Samp_Fields = {
  __typename?: 'discover_events_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Discover_Events_Variance_Fields = {
  __typename?: 'discover_events_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "discover" */
export type Discover_Insert_Input = {
  articles?: InputMaybe<Scalars['jsonb']>;
  builders?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  events?: InputMaybe<Scalars['jsonb']>;
  hackathons?: InputMaybe<Scalars['jsonb']>;
  ideas?: InputMaybe<Scalars['jsonb']>;
  projects?: InputMaybe<Scalars['jsonb']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  questions?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['discover_status_enum']>;
  tweets?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Discover_Max_Fields = {
  __typename?: 'discover_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['discover_status_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Discover_Min_Fields = {
  __typename?: 'discover_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['discover_status_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "discover" */
export type Discover_Mutation_Response = {
  __typename?: 'discover_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Discover>;
};

/** on_conflict condition type for table "discover" */
export type Discover_On_Conflict = {
  constraint: Discover_Constraint;
  update_columns?: Array<Discover_Update_Column>;
  where?: InputMaybe<Discover_Bool_Exp>;
};

/** Ordering options when selecting data from "discover". */
export type Discover_Order_By = {
  articles?: InputMaybe<Order_By>;
  builders?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  events?: InputMaybe<Order_By>;
  hackathons?: InputMaybe<Order_By>;
  ideas?: InputMaybe<Order_By>;
  projects?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  questions?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tweets?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discover */
export type Discover_Pk_Columns_Input = {
  uuid: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Discover_Prepend_Input = {
  articles?: InputMaybe<Scalars['jsonb']>;
  builders?: InputMaybe<Scalars['jsonb']>;
  events?: InputMaybe<Scalars['jsonb']>;
  hackathons?: InputMaybe<Scalars['jsonb']>;
  ideas?: InputMaybe<Scalars['jsonb']>;
  projects?: InputMaybe<Scalars['jsonb']>;
  questions?: InputMaybe<Scalars['jsonb']>;
  tweets?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "discover" */
export enum Discover_Select_Column {
  /** column name */
  Articles = 'articles',
  /** column name */
  Builders = 'builders',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Events = 'events',
  /** column name */
  Hackathons = 'hackathons',
  /** column name */
  Ideas = 'ideas',
  /** column name */
  Projects = 'projects',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  Questions = 'questions',
  /** column name */
  Status = 'status',
  /** column name */
  Tweets = 'tweets',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "discover" */
export type Discover_Set_Input = {
  articles?: InputMaybe<Scalars['jsonb']>;
  builders?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  events?: InputMaybe<Scalars['jsonb']>;
  hackathons?: InputMaybe<Scalars['jsonb']>;
  ideas?: InputMaybe<Scalars['jsonb']>;
  projects?: InputMaybe<Scalars['jsonb']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  questions?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['discover_status_enum']>;
  tweets?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "discover_status_enum". All fields are combined with logical 'AND'. */
export type Discover_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['discover_status_enum']>;
  _gt?: InputMaybe<Scalars['discover_status_enum']>;
  _gte?: InputMaybe<Scalars['discover_status_enum']>;
  _in?: InputMaybe<Array<Scalars['discover_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['discover_status_enum']>;
  _lte?: InputMaybe<Scalars['discover_status_enum']>;
  _neq?: InputMaybe<Scalars['discover_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['discover_status_enum']>>;
};

/** Streaming cursor of the table "discover" */
export type Discover_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discover_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discover_Stream_Cursor_Value_Input = {
  articles?: InputMaybe<Scalars['jsonb']>;
  builders?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  events?: InputMaybe<Scalars['jsonb']>;
  hackathons?: InputMaybe<Scalars['jsonb']>;
  ideas?: InputMaybe<Scalars['jsonb']>;
  projects?: InputMaybe<Scalars['jsonb']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  questions?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['discover_status_enum']>;
  tweets?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** update columns of table "discover" */
export enum Discover_Update_Column {
  /** column name */
  Articles = 'articles',
  /** column name */
  Builders = 'builders',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Events = 'events',
  /** column name */
  Hackathons = 'hackathons',
  /** column name */
  Ideas = 'ideas',
  /** column name */
  Projects = 'projects',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  Questions = 'questions',
  /** column name */
  Status = 'status',
  /** column name */
  Tweets = 'tweets',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Discover_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Discover_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Discover_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Discover_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Discover_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Discover_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Discover_Set_Input>;
  /** filter the rows which have to be updated */
  where: Discover_Bool_Exp;
};

/** Boolean expression to compare columns of type "ed_type_enum". All fields are combined with logical 'AND'. */
export type Ed_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ed_type_enum']>;
  _gt?: InputMaybe<Scalars['ed_type_enum']>;
  _gte?: InputMaybe<Scalars['ed_type_enum']>;
  _in?: InputMaybe<Array<Scalars['ed_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ed_type_enum']>;
  _lte?: InputMaybe<Scalars['ed_type_enum']>;
  _neq?: InputMaybe<Scalars['ed_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['ed_type_enum']>>;
};

/** columns and relationships of "education_fields" */
export type Education_Fields = {
  __typename?: 'education_fields';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['citext'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "education_fields" */
export type Education_Fields_Aggregate = {
  __typename?: 'education_fields_aggregate';
  aggregate?: Maybe<Education_Fields_Aggregate_Fields>;
  nodes: Array<Education_Fields>;
};

/** aggregate fields of "education_fields" */
export type Education_Fields_Aggregate_Fields = {
  __typename?: 'education_fields_aggregate_fields';
  avg?: Maybe<Education_Fields_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Education_Fields_Max_Fields>;
  min?: Maybe<Education_Fields_Min_Fields>;
  stddev?: Maybe<Education_Fields_Stddev_Fields>;
  stddev_pop?: Maybe<Education_Fields_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Education_Fields_Stddev_Samp_Fields>;
  sum?: Maybe<Education_Fields_Sum_Fields>;
  var_pop?: Maybe<Education_Fields_Var_Pop_Fields>;
  var_samp?: Maybe<Education_Fields_Var_Samp_Fields>;
  variance?: Maybe<Education_Fields_Variance_Fields>;
};


/** aggregate fields of "education_fields" */
export type Education_Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Education_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Education_Fields_Avg_Fields = {
  __typename?: 'education_fields_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "education_fields". All fields are combined with a logical 'AND'. */
export type Education_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Education_Fields_Bool_Exp>>;
  _not?: InputMaybe<Education_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Education_Fields_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<Citext_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "education_fields" */
export enum Education_Fields_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEducationFields = 'pk_education_fields',
  /** unique or primary key constraint on columns "name" */
  UniqueNameEducationFields = 'unique_name_education_fields',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidEducationFields = 'unique_uuid_education_fields'
}

/** input type for incrementing numeric columns in table "education_fields" */
export type Education_Fields_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "education_fields" */
export type Education_Fields_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Education_Fields_Max_Fields = {
  __typename?: 'education_fields_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['citext']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Education_Fields_Min_Fields = {
  __typename?: 'education_fields_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['citext']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "education_fields" */
export type Education_Fields_Mutation_Response = {
  __typename?: 'education_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Education_Fields>;
};

/** input type for inserting object relation for remote table "education_fields" */
export type Education_Fields_Obj_Rel_Insert_Input = {
  data: Education_Fields_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Education_Fields_On_Conflict>;
};

/** on_conflict condition type for table "education_fields" */
export type Education_Fields_On_Conflict = {
  constraint: Education_Fields_Constraint;
  update_columns?: Array<Education_Fields_Update_Column>;
  where?: InputMaybe<Education_Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "education_fields". */
export type Education_Fields_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: education_fields */
export type Education_Fields_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "education_fields" */
export enum Education_Fields_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "education_fields" */
export type Education_Fields_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Education_Fields_Stddev_Fields = {
  __typename?: 'education_fields_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Education_Fields_Stddev_Pop_Fields = {
  __typename?: 'education_fields_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Education_Fields_Stddev_Samp_Fields = {
  __typename?: 'education_fields_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "education_fields" */
export type Education_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Education_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Education_Fields_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Education_Fields_Sum_Fields = {
  __typename?: 'education_fields_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "education_fields" */
export enum Education_Fields_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Education_Fields_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Education_Fields_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Education_Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Education_Fields_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Education_Fields_Var_Pop_Fields = {
  __typename?: 'education_fields_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Education_Fields_Var_Samp_Fields = {
  __typename?: 'education_fields_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Education_Fields_Variance_Fields = {
  __typename?: 'education_fields_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "educations" */
export type Educations = {
  __typename?: 'educations';
  /** An object relationship */
  college?: Maybe<Colleges>;
  college_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  current_college?: Maybe<Scalars['Boolean']>;
  degree_type?: Maybe<Scalars['ed_type_enum']>;
  education_field_id: Scalars['Int'];
  /** An object relationship */
  field?: Maybe<Education_Fields>;
  gpa?: Maybe<Scalars['Float']>;
  graduation_year?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "educations" */
export type Educations_Aggregate = {
  __typename?: 'educations_aggregate';
  aggregate?: Maybe<Educations_Aggregate_Fields>;
  nodes: Array<Educations>;
};

export type Educations_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Educations_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Educations_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Educations_Aggregate_Bool_Exp_Count>;
};

export type Educations_Aggregate_Bool_Exp_Bool_And = {
  arguments: Educations_Select_Column_Educations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Educations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Educations_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Educations_Select_Column_Educations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Educations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Educations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Educations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Educations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "educations" */
export type Educations_Aggregate_Fields = {
  __typename?: 'educations_aggregate_fields';
  avg?: Maybe<Educations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Educations_Max_Fields>;
  min?: Maybe<Educations_Min_Fields>;
  stddev?: Maybe<Educations_Stddev_Fields>;
  stddev_pop?: Maybe<Educations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Educations_Stddev_Samp_Fields>;
  sum?: Maybe<Educations_Sum_Fields>;
  var_pop?: Maybe<Educations_Var_Pop_Fields>;
  var_samp?: Maybe<Educations_Var_Samp_Fields>;
  variance?: Maybe<Educations_Variance_Fields>;
};


/** aggregate fields of "educations" */
export type Educations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Educations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "educations" */
export type Educations_Aggregate_Order_By = {
  avg?: InputMaybe<Educations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Educations_Max_Order_By>;
  min?: InputMaybe<Educations_Min_Order_By>;
  stddev?: InputMaybe<Educations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Educations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Educations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Educations_Sum_Order_By>;
  var_pop?: InputMaybe<Educations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Educations_Var_Samp_Order_By>;
  variance?: InputMaybe<Educations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "educations" */
export type Educations_Arr_Rel_Insert_Input = {
  data: Array<Educations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Educations_On_Conflict>;
};

/** aggregate avg on columns */
export type Educations_Avg_Fields = {
  __typename?: 'educations_avg_fields';
  college_id?: Maybe<Scalars['Float']>;
  education_field_id?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "educations" */
export type Educations_Avg_Order_By = {
  college_id?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "educations". All fields are combined with a logical 'AND'. */
export type Educations_Bool_Exp = {
  _and?: InputMaybe<Array<Educations_Bool_Exp>>;
  _not?: InputMaybe<Educations_Bool_Exp>;
  _or?: InputMaybe<Array<Educations_Bool_Exp>>;
  college?: InputMaybe<Colleges_Bool_Exp>;
  college_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_college?: InputMaybe<Boolean_Comparison_Exp>;
  degree_type?: InputMaybe<Ed_Type_Enum_Comparison_Exp>;
  education_field_id?: InputMaybe<Int_Comparison_Exp>;
  field?: InputMaybe<Education_Fields_Bool_Exp>;
  gpa?: InputMaybe<Float_Comparison_Exp>;
  graduation_year?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "educations" */
export enum Educations_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEducations = 'pk_educations',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidEducations = 'unique_uuid_educations'
}

/** input type for incrementing numeric columns in table "educations" */
export type Educations_Inc_Input = {
  college_id?: InputMaybe<Scalars['Int']>;
  education_field_id?: InputMaybe<Scalars['Int']>;
  gpa?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "educations" */
export type Educations_Insert_Input = {
  college?: InputMaybe<Colleges_Obj_Rel_Insert_Input>;
  college_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_college?: InputMaybe<Scalars['Boolean']>;
  degree_type?: InputMaybe<Scalars['ed_type_enum']>;
  education_field_id?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<Education_Fields_Obj_Rel_Insert_Input>;
  gpa?: InputMaybe<Scalars['Float']>;
  graduation_year?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Educations_Max_Fields = {
  __typename?: 'educations_max_fields';
  college_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  degree_type?: Maybe<Scalars['ed_type_enum']>;
  education_field_id?: Maybe<Scalars['Int']>;
  gpa?: Maybe<Scalars['Float']>;
  graduation_year?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "educations" */
export type Educations_Max_Order_By = {
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  degree_type?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  graduation_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Educations_Min_Fields = {
  __typename?: 'educations_min_fields';
  college_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  degree_type?: Maybe<Scalars['ed_type_enum']>;
  education_field_id?: Maybe<Scalars['Int']>;
  gpa?: Maybe<Scalars['Float']>;
  graduation_year?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "educations" */
export type Educations_Min_Order_By = {
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  degree_type?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  graduation_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "educations" */
export type Educations_Mutation_Response = {
  __typename?: 'educations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Educations>;
};

/** on_conflict condition type for table "educations" */
export type Educations_On_Conflict = {
  constraint: Educations_Constraint;
  update_columns?: Array<Educations_Update_Column>;
  where?: InputMaybe<Educations_Bool_Exp>;
};

/** Ordering options when selecting data from "educations". */
export type Educations_Order_By = {
  college?: InputMaybe<Colleges_Order_By>;
  college_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_college?: InputMaybe<Order_By>;
  degree_type?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Education_Fields_Order_By>;
  gpa?: InputMaybe<Order_By>;
  graduation_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: educations */
export type Educations_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "educations" */
export enum Educations_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentCollege = 'current_college',
  /** column name */
  DegreeType = 'degree_type',
  /** column name */
  EducationFieldId = 'education_field_id',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GraduationYear = 'graduation_year',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** select "educations_aggregate_bool_exp_bool_and_arguments_columns" columns of table "educations" */
export enum Educations_Select_Column_Educations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CurrentCollege = 'current_college'
}

/** select "educations_aggregate_bool_exp_bool_or_arguments_columns" columns of table "educations" */
export enum Educations_Select_Column_Educations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CurrentCollege = 'current_college'
}

/** input type for updating data in table "educations" */
export type Educations_Set_Input = {
  college_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_college?: InputMaybe<Scalars['Boolean']>;
  degree_type?: InputMaybe<Scalars['ed_type_enum']>;
  education_field_id?: InputMaybe<Scalars['Int']>;
  gpa?: InputMaybe<Scalars['Float']>;
  graduation_year?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Educations_Stddev_Fields = {
  __typename?: 'educations_stddev_fields';
  college_id?: Maybe<Scalars['Float']>;
  education_field_id?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "educations" */
export type Educations_Stddev_Order_By = {
  college_id?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Educations_Stddev_Pop_Fields = {
  __typename?: 'educations_stddev_pop_fields';
  college_id?: Maybe<Scalars['Float']>;
  education_field_id?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "educations" */
export type Educations_Stddev_Pop_Order_By = {
  college_id?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Educations_Stddev_Samp_Fields = {
  __typename?: 'educations_stddev_samp_fields';
  college_id?: Maybe<Scalars['Float']>;
  education_field_id?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "educations" */
export type Educations_Stddev_Samp_Order_By = {
  college_id?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "educations" */
export type Educations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Educations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Educations_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_college?: InputMaybe<Scalars['Boolean']>;
  degree_type?: InputMaybe<Scalars['ed_type_enum']>;
  education_field_id?: InputMaybe<Scalars['Int']>;
  gpa?: InputMaybe<Scalars['Float']>;
  graduation_year?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Educations_Sum_Fields = {
  __typename?: 'educations_sum_fields';
  college_id?: Maybe<Scalars['Int']>;
  education_field_id?: Maybe<Scalars['Int']>;
  gpa?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "educations" */
export type Educations_Sum_Order_By = {
  college_id?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "educations" */
export enum Educations_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentCollege = 'current_college',
  /** column name */
  DegreeType = 'degree_type',
  /** column name */
  EducationFieldId = 'education_field_id',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GraduationYear = 'graduation_year',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Educations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Educations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Educations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Educations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Educations_Var_Pop_Fields = {
  __typename?: 'educations_var_pop_fields';
  college_id?: Maybe<Scalars['Float']>;
  education_field_id?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "educations" */
export type Educations_Var_Pop_Order_By = {
  college_id?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Educations_Var_Samp_Fields = {
  __typename?: 'educations_var_samp_fields';
  college_id?: Maybe<Scalars['Float']>;
  education_field_id?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "educations" */
export type Educations_Var_Samp_Order_By = {
  college_id?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Educations_Variance_Fields = {
  __typename?: 'educations_variance_fields';
  college_id?: Maybe<Scalars['Float']>;
  education_field_id?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "educations" */
export type Educations_Variance_Order_By = {
  college_id?: InputMaybe<Order_By>;
  education_field_id?: InputMaybe<Order_By>;
  gpa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** This table is used as an enum table to store the types of experience */
export type Experience_Type = {
  __typename?: 'experience_type';
  value: Scalars['String'];
};

/** aggregated selection of "experience_type" */
export type Experience_Type_Aggregate = {
  __typename?: 'experience_type_aggregate';
  aggregate?: Maybe<Experience_Type_Aggregate_Fields>;
  nodes: Array<Experience_Type>;
};

/** aggregate fields of "experience_type" */
export type Experience_Type_Aggregate_Fields = {
  __typename?: 'experience_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Experience_Type_Max_Fields>;
  min?: Maybe<Experience_Type_Min_Fields>;
};


/** aggregate fields of "experience_type" */
export type Experience_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Experience_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "experience_type". All fields are combined with a logical 'AND'. */
export type Experience_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Experience_Type_Bool_Exp>>;
  _not?: InputMaybe<Experience_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Experience_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "experience_type" */
export enum Experience_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ExperienceTypePkey = 'experience_type_pkey'
}

export enum Experience_Type_Enum {
  Fulltime = 'FULLTIME',
  Internship = 'INTERNSHIP',
  PartTime = 'PART_TIME'
}

/** Boolean expression to compare columns of type "experience_type_enum". All fields are combined with logical 'AND'. */
export type Experience_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Experience_Type_Enum>;
  _in?: InputMaybe<Array<Experience_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Experience_Type_Enum>;
  _nin?: InputMaybe<Array<Experience_Type_Enum>>;
};

/** input type for inserting data into table "experience_type" */
export type Experience_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Experience_Type_Max_Fields = {
  __typename?: 'experience_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Experience_Type_Min_Fields = {
  __typename?: 'experience_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "experience_type" */
export type Experience_Type_Mutation_Response = {
  __typename?: 'experience_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Experience_Type>;
};

/** on_conflict condition type for table "experience_type" */
export type Experience_Type_On_Conflict = {
  constraint: Experience_Type_Constraint;
  update_columns?: Array<Experience_Type_Update_Column>;
  where?: InputMaybe<Experience_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "experience_type". */
export type Experience_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: experience_type */
export type Experience_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "experience_type" */
export enum Experience_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "experience_type" */
export type Experience_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "experience_type" */
export type Experience_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Experience_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Experience_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "experience_type" */
export enum Experience_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Experience_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Experience_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Experience_Type_Bool_Exp;
};

/** columns and relationships of "experiences" */
export type Experiences = {
  __typename?: 'experiences';
  /** An object relationship */
  company?: Maybe<Company>;
  company_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  current_company?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  location?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['date']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Experience_Type_Enum>;
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "experiences" */
export type Experiences_Aggregate = {
  __typename?: 'experiences_aggregate';
  aggregate?: Maybe<Experiences_Aggregate_Fields>;
  nodes: Array<Experiences>;
};

export type Experiences_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Experiences_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Experiences_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Experiences_Aggregate_Bool_Exp_Count>;
};

export type Experiences_Aggregate_Bool_Exp_Bool_And = {
  arguments: Experiences_Select_Column_Experiences_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Experiences_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Experiences_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Experiences_Select_Column_Experiences_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Experiences_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Experiences_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Experiences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Experiences_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "experiences" */
export type Experiences_Aggregate_Fields = {
  __typename?: 'experiences_aggregate_fields';
  avg?: Maybe<Experiences_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Experiences_Max_Fields>;
  min?: Maybe<Experiences_Min_Fields>;
  stddev?: Maybe<Experiences_Stddev_Fields>;
  stddev_pop?: Maybe<Experiences_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Experiences_Stddev_Samp_Fields>;
  sum?: Maybe<Experiences_Sum_Fields>;
  var_pop?: Maybe<Experiences_Var_Pop_Fields>;
  var_samp?: Maybe<Experiences_Var_Samp_Fields>;
  variance?: Maybe<Experiences_Variance_Fields>;
};


/** aggregate fields of "experiences" */
export type Experiences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Experiences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "experiences" */
export type Experiences_Aggregate_Order_By = {
  avg?: InputMaybe<Experiences_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Experiences_Max_Order_By>;
  min?: InputMaybe<Experiences_Min_Order_By>;
  stddev?: InputMaybe<Experiences_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Experiences_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Experiences_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Experiences_Sum_Order_By>;
  var_pop?: InputMaybe<Experiences_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Experiences_Var_Samp_Order_By>;
  variance?: InputMaybe<Experiences_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "experiences" */
export type Experiences_Arr_Rel_Insert_Input = {
  data: Array<Experiences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Experiences_On_Conflict>;
};

/** aggregate avg on columns */
export type Experiences_Avg_Fields = {
  __typename?: 'experiences_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "experiences" */
export type Experiences_Avg_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "experiences". All fields are combined with a logical 'AND'. */
export type Experiences_Bool_Exp = {
  _and?: InputMaybe<Array<Experiences_Bool_Exp>>;
  _not?: InputMaybe<Experiences_Bool_Exp>;
  _or?: InputMaybe<Array<Experiences_Bool_Exp>>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_company?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  end?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  start?: InputMaybe<Date_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Experience_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "experiences" */
export enum Experiences_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkExperiences = 'pk_experiences',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidExperiences = 'unique_uuid_experiences'
}

/** input type for incrementing numeric columns in table "experiences" */
export type Experiences_Inc_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "experiences" */
export type Experiences_Insert_Input = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_company?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['date']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Experience_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Experiences_Max_Fields = {
  __typename?: 'experiences_max_fields';
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['date']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "experiences" */
export type Experiences_Max_Order_By = {
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Experiences_Min_Fields = {
  __typename?: 'experiences_min_fields';
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['date']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "experiences" */
export type Experiences_Min_Order_By = {
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "experiences" */
export type Experiences_Mutation_Response = {
  __typename?: 'experiences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Experiences>;
};

/** on_conflict condition type for table "experiences" */
export type Experiences_On_Conflict = {
  constraint: Experiences_Constraint;
  update_columns?: Array<Experiences_Update_Column>;
  where?: InputMaybe<Experiences_Bool_Exp>;
};

/** Ordering options when selecting data from "experiences". */
export type Experiences_Order_By = {
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_company?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: experiences */
export type Experiences_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "experiences" */
export enum Experiences_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentCompany = 'current_company',
  /** column name */
  Description = 'description',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Start = 'start',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** select "experiences_aggregate_bool_exp_bool_and_arguments_columns" columns of table "experiences" */
export enum Experiences_Select_Column_Experiences_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CurrentCompany = 'current_company'
}

/** select "experiences_aggregate_bool_exp_bool_or_arguments_columns" columns of table "experiences" */
export enum Experiences_Select_Column_Experiences_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CurrentCompany = 'current_company'
}

/** input type for updating data in table "experiences" */
export type Experiences_Set_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_company?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['date']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Experience_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Experiences_Stddev_Fields = {
  __typename?: 'experiences_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "experiences" */
export type Experiences_Stddev_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Experiences_Stddev_Pop_Fields = {
  __typename?: 'experiences_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "experiences" */
export type Experiences_Stddev_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Experiences_Stddev_Samp_Fields = {
  __typename?: 'experiences_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "experiences" */
export type Experiences_Stddev_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "experiences" */
export type Experiences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Experiences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Experiences_Stream_Cursor_Value_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_company?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['date']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Experience_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Experiences_Sum_Fields = {
  __typename?: 'experiences_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "experiences" */
export type Experiences_Sum_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "experiences" */
export enum Experiences_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentCompany = 'current_company',
  /** column name */
  Description = 'description',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Start = 'start',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Experiences_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Experiences_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Experiences_Set_Input>;
  /** filter the rows which have to be updated */
  where: Experiences_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Experiences_Var_Pop_Fields = {
  __typename?: 'experiences_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "experiences" */
export type Experiences_Var_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Experiences_Var_Samp_Fields = {
  __typename?: 'experiences_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "experiences" */
export type Experiences_Var_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Experiences_Variance_Fields = {
  __typename?: 'experiences_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "experiences" */
export type Experiences_Variance_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** This table is used as an enum table to store the types of feature flags */
export type Feature_Flag_Types = {
  __typename?: 'feature_flag_types';
  value: Scalars['String'];
};

/** aggregated selection of "feature_flag_types" */
export type Feature_Flag_Types_Aggregate = {
  __typename?: 'feature_flag_types_aggregate';
  aggregate?: Maybe<Feature_Flag_Types_Aggregate_Fields>;
  nodes: Array<Feature_Flag_Types>;
};

/** aggregate fields of "feature_flag_types" */
export type Feature_Flag_Types_Aggregate_Fields = {
  __typename?: 'feature_flag_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Feature_Flag_Types_Max_Fields>;
  min?: Maybe<Feature_Flag_Types_Min_Fields>;
};


/** aggregate fields of "feature_flag_types" */
export type Feature_Flag_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Flag_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "feature_flag_types". All fields are combined with a logical 'AND'. */
export type Feature_Flag_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Flag_Types_Bool_Exp>>;
  _not?: InputMaybe<Feature_Flag_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Flag_Types_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_flag_types" */
export enum Feature_Flag_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  FeatureFlagTypesPkey = 'feature_flag_types_pkey'
}

export enum Feature_Flag_Types_Enum {
  AdminOnly = 'ADMIN_ONLY',
  OptIn = 'OPT_IN'
}

/** Boolean expression to compare columns of type "feature_flag_types_enum". All fields are combined with logical 'AND'. */
export type Feature_Flag_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Feature_Flag_Types_Enum>;
  _in?: InputMaybe<Array<Feature_Flag_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Feature_Flag_Types_Enum>;
  _nin?: InputMaybe<Array<Feature_Flag_Types_Enum>>;
};

/** input type for inserting data into table "feature_flag_types" */
export type Feature_Flag_Types_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Feature_Flag_Types_Max_Fields = {
  __typename?: 'feature_flag_types_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Feature_Flag_Types_Min_Fields = {
  __typename?: 'feature_flag_types_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "feature_flag_types" */
export type Feature_Flag_Types_Mutation_Response = {
  __typename?: 'feature_flag_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature_Flag_Types>;
};

/** on_conflict condition type for table "feature_flag_types" */
export type Feature_Flag_Types_On_Conflict = {
  constraint: Feature_Flag_Types_Constraint;
  update_columns?: Array<Feature_Flag_Types_Update_Column>;
  where?: InputMaybe<Feature_Flag_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_flag_types". */
export type Feature_Flag_Types_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_flag_types */
export type Feature_Flag_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "feature_flag_types" */
export enum Feature_Flag_Types_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "feature_flag_types" */
export type Feature_Flag_Types_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "feature_flag_types" */
export type Feature_Flag_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Flag_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Flag_Types_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "feature_flag_types" */
export enum Feature_Flag_Types_Update_Column {
  /** column name */
  Value = 'value'
}

export type Feature_Flag_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Flag_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Flag_Types_Bool_Exp;
};

/** This table is used to store the feature flags */
export type Feature_Flags = {
  __typename?: 'feature_flags';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Feature_Flag_Types_Enum;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "feature_flags" */
export type Feature_Flags_Aggregate = {
  __typename?: 'feature_flags_aggregate';
  aggregate?: Maybe<Feature_Flags_Aggregate_Fields>;
  nodes: Array<Feature_Flags>;
};

/** aggregate fields of "feature_flags" */
export type Feature_Flags_Aggregate_Fields = {
  __typename?: 'feature_flags_aggregate_fields';
  avg?: Maybe<Feature_Flags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feature_Flags_Max_Fields>;
  min?: Maybe<Feature_Flags_Min_Fields>;
  stddev?: Maybe<Feature_Flags_Stddev_Fields>;
  stddev_pop?: Maybe<Feature_Flags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feature_Flags_Stddev_Samp_Fields>;
  sum?: Maybe<Feature_Flags_Sum_Fields>;
  var_pop?: Maybe<Feature_Flags_Var_Pop_Fields>;
  var_samp?: Maybe<Feature_Flags_Var_Samp_Fields>;
  variance?: Maybe<Feature_Flags_Variance_Fields>;
};


/** aggregate fields of "feature_flags" */
export type Feature_Flags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Feature_Flags_Avg_Fields = {
  __typename?: 'feature_flags_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "feature_flags". All fields are combined with a logical 'AND'. */
export type Feature_Flags_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Flags_Bool_Exp>>;
  _not?: InputMaybe<Feature_Flags_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Flags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Feature_Flag_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_flags" */
export enum Feature_Flags_Constraint {
  /** unique or primary key constraint on columns "name" */
  FeatureFlagsNameKey = 'feature_flags_name_key',
  /** unique or primary key constraint on columns "id" */
  FeatureFlagsPkey = 'feature_flags_pkey',
  /** unique or primary key constraint on columns "uuid" */
  FeatureFlagsUuidKey = 'feature_flags_uuid_key'
}

/** input type for incrementing numeric columns in table "feature_flags" */
export type Feature_Flags_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feature_flags" */
export type Feature_Flags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Feature_Flag_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Feature_Flags_Max_Fields = {
  __typename?: 'feature_flags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Feature_Flags_Min_Fields = {
  __typename?: 'feature_flags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "feature_flags" */
export type Feature_Flags_Mutation_Response = {
  __typename?: 'feature_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature_Flags>;
};

/** input type for inserting object relation for remote table "feature_flags" */
export type Feature_Flags_Obj_Rel_Insert_Input = {
  data: Feature_Flags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};

/** on_conflict condition type for table "feature_flags" */
export type Feature_Flags_On_Conflict = {
  constraint: Feature_Flags_Constraint;
  update_columns?: Array<Feature_Flags_Update_Column>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_flags". */
export type Feature_Flags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_flags */
export type Feature_Flags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "feature_flags" */
export enum Feature_Flags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "feature_flags" */
export type Feature_Flags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Feature_Flag_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Feature_Flags_Stddev_Fields = {
  __typename?: 'feature_flags_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Feature_Flags_Stddev_Pop_Fields = {
  __typename?: 'feature_flags_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Feature_Flags_Stddev_Samp_Fields = {
  __typename?: 'feature_flags_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "feature_flags" */
export type Feature_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Flags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Feature_Flag_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Feature_Flags_Sum_Fields = {
  __typename?: 'feature_flags_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "feature_flags" */
export enum Feature_Flags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Feature_Flags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feature_Flags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Flags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feature_Flags_Var_Pop_Fields = {
  __typename?: 'feature_flags_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Feature_Flags_Var_Samp_Fields = {
  __typename?: 'feature_flags_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Feature_Flags_Variance_Fields = {
  __typename?: 'feature_flags_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "hackathon_bounties_status" */
export type Hackathon_Bounties_Status = {
  __typename?: 'hackathon_bounties_status';
  value: Scalars['String'];
};

/** aggregated selection of "hackathon_bounties_status" */
export type Hackathon_Bounties_Status_Aggregate = {
  __typename?: 'hackathon_bounties_status_aggregate';
  aggregate?: Maybe<Hackathon_Bounties_Status_Aggregate_Fields>;
  nodes: Array<Hackathon_Bounties_Status>;
};

/** aggregate fields of "hackathon_bounties_status" */
export type Hackathon_Bounties_Status_Aggregate_Fields = {
  __typename?: 'hackathon_bounties_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Bounties_Status_Max_Fields>;
  min?: Maybe<Hackathon_Bounties_Status_Min_Fields>;
};


/** aggregate fields of "hackathon_bounties_status" */
export type Hackathon_Bounties_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Bounties_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_bounties_status". All fields are combined with a logical 'AND'. */
export type Hackathon_Bounties_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Bounties_Status_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Bounties_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Bounties_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_bounties_status" */
export enum Hackathon_Bounties_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  HackathonBountiesStatusPkey = 'hackathon_bounties_status_pkey'
}

export enum Hackathon_Bounties_Status_Enum {
  Computed = 'COMPUTED',
  Finalized = 'FINALIZED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "hackathon_bounties_status_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Bounties_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Bounties_Status_Enum>;
  _in?: InputMaybe<Array<Hackathon_Bounties_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Bounties_Status_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Bounties_Status_Enum>>;
};

/** input type for inserting data into table "hackathon_bounties_status" */
export type Hackathon_Bounties_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Bounties_Status_Max_Fields = {
  __typename?: 'hackathon_bounties_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Bounties_Status_Min_Fields = {
  __typename?: 'hackathon_bounties_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_bounties_status" */
export type Hackathon_Bounties_Status_Mutation_Response = {
  __typename?: 'hackathon_bounties_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Bounties_Status>;
};

/** on_conflict condition type for table "hackathon_bounties_status" */
export type Hackathon_Bounties_Status_On_Conflict = {
  constraint: Hackathon_Bounties_Status_Constraint;
  update_columns?: Array<Hackathon_Bounties_Status_Update_Column>;
  where?: InputMaybe<Hackathon_Bounties_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_bounties_status". */
export type Hackathon_Bounties_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_bounties_status */
export type Hackathon_Bounties_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "hackathon_bounties_status" */
export enum Hackathon_Bounties_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_bounties_status" */
export type Hackathon_Bounties_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_bounties_status" */
export type Hackathon_Bounties_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Bounties_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Bounties_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_bounties_status" */
export enum Hackathon_Bounties_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Hackathon_Bounties_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Bounties_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Bounties_Status_Bool_Exp;
};

/** This table is used to store the hackathon brands */
export type Hackathon_Brands = {
  __typename?: 'hackathon_brands';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  hackathons: Array<Hackathons>;
  /** An aggregate relationship */
  hackathons_aggregate: Hackathons_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};


/** This table is used to store the hackathon brands */
export type Hackathon_BrandsHackathonsArgs = {
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


/** This table is used to store the hackathon brands */
export type Hackathon_BrandsHackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};

/** aggregated selection of "hackathon_brands" */
export type Hackathon_Brands_Aggregate = {
  __typename?: 'hackathon_brands_aggregate';
  aggregate?: Maybe<Hackathon_Brands_Aggregate_Fields>;
  nodes: Array<Hackathon_Brands>;
};

/** aggregate fields of "hackathon_brands" */
export type Hackathon_Brands_Aggregate_Fields = {
  __typename?: 'hackathon_brands_aggregate_fields';
  avg?: Maybe<Hackathon_Brands_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Brands_Max_Fields>;
  min?: Maybe<Hackathon_Brands_Min_Fields>;
  stddev?: Maybe<Hackathon_Brands_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Brands_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Brands_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Brands_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Brands_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Brands_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Brands_Variance_Fields>;
};


/** aggregate fields of "hackathon_brands" */
export type Hackathon_Brands_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Brands_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Hackathon_Brands_Avg_Fields = {
  __typename?: 'hackathon_brands_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hackathon_brands". All fields are combined with a logical 'AND'. */
export type Hackathon_Brands_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Brands_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Brands_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Brands_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathons?: InputMaybe<Hackathons_Bool_Exp>;
  hackathons_aggregate?: InputMaybe<Hackathons_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_brands" */
export enum Hackathon_Brands_Constraint {
  /** unique or primary key constraint on columns "name" */
  HackathonBrandsNameKey = 'hackathon_brands_name_key',
  /** unique or primary key constraint on columns "id" */
  HackathonBrandsPkey = 'hackathon_brands_pkey',
  /** unique or primary key constraint on columns "uuid" */
  HackathonBrandsUuidKey = 'hackathon_brands_uuid_key'
}

/** input type for incrementing numeric columns in table "hackathon_brands" */
export type Hackathon_Brands_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_brands" */
export type Hackathon_Brands_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathons?: InputMaybe<Hackathons_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Brands_Max_Fields = {
  __typename?: 'hackathon_brands_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Brands_Min_Fields = {
  __typename?: 'hackathon_brands_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_brands" */
export type Hackathon_Brands_Mutation_Response = {
  __typename?: 'hackathon_brands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Brands>;
};

/** input type for inserting object relation for remote table "hackathon_brands" */
export type Hackathon_Brands_Obj_Rel_Insert_Input = {
  data: Hackathon_Brands_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Brands_On_Conflict>;
};

/** on_conflict condition type for table "hackathon_brands" */
export type Hackathon_Brands_On_Conflict = {
  constraint: Hackathon_Brands_Constraint;
  update_columns?: Array<Hackathon_Brands_Update_Column>;
  where?: InputMaybe<Hackathon_Brands_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_brands". */
export type Hackathon_Brands_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathons_aggregate?: InputMaybe<Hackathons_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_brands */
export type Hackathon_Brands_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_brands" */
export enum Hackathon_Brands_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_brands" */
export type Hackathon_Brands_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Brands_Stddev_Fields = {
  __typename?: 'hackathon_brands_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Brands_Stddev_Pop_Fields = {
  __typename?: 'hackathon_brands_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Brands_Stddev_Samp_Fields = {
  __typename?: 'hackathon_brands_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hackathon_brands" */
export type Hackathon_Brands_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Brands_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Brands_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Brands_Sum_Fields = {
  __typename?: 'hackathon_brands_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "hackathon_brands" */
export enum Hackathon_Brands_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Brands_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Brands_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Brands_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Brands_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Brands_Var_Pop_Fields = {
  __typename?: 'hackathon_brands_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hackathon_Brands_Var_Samp_Fields = {
  __typename?: 'hackathon_brands_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hackathon_Brands_Variance_Fields = {
  __typename?: 'hackathon_brands_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "hackathon_checklists" */
export type Hackathon_Checklists = {
  __typename?: 'hackathon_checklists';
  created_at: Scalars['timestamptz'];
  desc?: Maybe<Scalars['String']>;
  file_type?: Maybe<Scalars['hc_file_type_enum']>;
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['hc_type_enum']>;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_hackathon_checklists: Array<User_Hackathon_Checklists>;
  /** An aggregate relationship */
  user_hackathon_checklists_aggregate: User_Hackathon_Checklists_Aggregate;
  uuid: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "hackathon_checklists" */
export type Hackathon_ChecklistsUser_Hackathon_ChecklistsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
};


/** columns and relationships of "hackathon_checklists" */
export type Hackathon_ChecklistsUser_Hackathon_Checklists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
};

/** aggregated selection of "hackathon_checklists" */
export type Hackathon_Checklists_Aggregate = {
  __typename?: 'hackathon_checklists_aggregate';
  aggregate?: Maybe<Hackathon_Checklists_Aggregate_Fields>;
  nodes: Array<Hackathon_Checklists>;
};

export type Hackathon_Checklists_Aggregate_Bool_Exp = {
  count?: InputMaybe<Hackathon_Checklists_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Checklists_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Checklists_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_checklists" */
export type Hackathon_Checklists_Aggregate_Fields = {
  __typename?: 'hackathon_checklists_aggregate_fields';
  avg?: Maybe<Hackathon_Checklists_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Checklists_Max_Fields>;
  min?: Maybe<Hackathon_Checklists_Min_Fields>;
  stddev?: Maybe<Hackathon_Checklists_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Checklists_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Checklists_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Checklists_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Checklists_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Checklists_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Checklists_Variance_Fields>;
};


/** aggregate fields of "hackathon_checklists" */
export type Hackathon_Checklists_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Checklists_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_checklists" */
export type Hackathon_Checklists_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Checklists_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Checklists_Max_Order_By>;
  min?: InputMaybe<Hackathon_Checklists_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Checklists_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Checklists_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Checklists_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Checklists_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Checklists_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Checklists_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Checklists_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_checklists" */
export type Hackathon_Checklists_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Checklists_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Checklists_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Checklists_Avg_Fields = {
  __typename?: 'hackathon_checklists_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_checklists". All fields are combined with a logical 'AND'. */
export type Hackathon_Checklists_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Checklists_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Checklists_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  file_type?: InputMaybe<Hc_File_Type_Enum_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  placeholder?: InputMaybe<String_Comparison_Exp>;
  section?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Hc_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_hackathon_checklists?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
  user_hackathon_checklists_aggregate?: InputMaybe<User_Hackathon_Checklists_Aggregate_Bool_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_checklists" */
export enum Hackathon_Checklists_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkHackathonChecklists = 'pk_hackathon_checklists',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHackathonChecklists = 'unique_uuid_hackathon_checklists'
}

/** input type for incrementing numeric columns in table "hackathon_checklists" */
export type Hackathon_Checklists_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_checklists" */
export type Hackathon_Checklists_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['hc_file_type_enum']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['hc_type_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_hackathon_checklists?: InputMaybe<User_Hackathon_Checklists_Arr_Rel_Insert_Input>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Checklists_Max_Fields = {
  __typename?: 'hackathon_checklists_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  file_type?: Maybe<Scalars['hc_file_type_enum']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['hc_type_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  section?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Checklists_Min_Fields = {
  __typename?: 'hackathon_checklists_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  file_type?: Maybe<Scalars['hc_file_type_enum']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['hc_type_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  section?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_checklists" */
export type Hackathon_Checklists_Mutation_Response = {
  __typename?: 'hackathon_checklists_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Checklists>;
};

/** on_conflict condition type for table "hackathon_checklists" */
export type Hackathon_Checklists_On_Conflict = {
  constraint: Hackathon_Checklists_Constraint;
  update_columns?: Array<Hackathon_Checklists_Update_Column>;
  where?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_checklists". */
export type Hackathon_Checklists_Order_By = {
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  section?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_hackathon_checklists_aggregate?: InputMaybe<User_Hackathon_Checklists_Aggregate_Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_checklists */
export type Hackathon_Checklists_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_checklists" */
export enum Hackathon_Checklists_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  FileType = 'file_type',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Placeholder = 'placeholder',
  /** column name */
  Section = 'section',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_checklists" */
export type Hackathon_Checklists_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['hc_file_type_enum']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['hc_type_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Checklists_Stddev_Fields = {
  __typename?: 'hackathon_checklists_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Checklists_Stddev_Pop_Fields = {
  __typename?: 'hackathon_checklists_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Checklists_Stddev_Samp_Fields = {
  __typename?: 'hackathon_checklists_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_checklists" */
export type Hackathon_Checklists_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Checklists_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Checklists_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['hc_file_type_enum']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['hc_type_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Checklists_Sum_Fields = {
  __typename?: 'hackathon_checklists_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_checklists" */
export enum Hackathon_Checklists_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  FileType = 'file_type',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Placeholder = 'placeholder',
  /** column name */
  Section = 'section',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

export type Hackathon_Checklists_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Checklists_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Checklists_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Checklists_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Checklists_Var_Pop_Fields = {
  __typename?: 'hackathon_checklists_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Checklists_Var_Samp_Fields = {
  __typename?: 'hackathon_checklists_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Checklists_Variance_Fields = {
  __typename?: 'hackathon_checklists_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_checklists" */
export type Hackathon_Checklists_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "hackathon_credential_eligible_entities" */
export type Hackathon_Credential_Eligible_Entities = {
  __typename?: 'hackathon_credential_eligible_entities';
  value: Scalars['String'];
};

/** aggregated selection of "hackathon_credential_eligible_entities" */
export type Hackathon_Credential_Eligible_Entities_Aggregate = {
  __typename?: 'hackathon_credential_eligible_entities_aggregate';
  aggregate?: Maybe<Hackathon_Credential_Eligible_Entities_Aggregate_Fields>;
  nodes: Array<Hackathon_Credential_Eligible_Entities>;
};

/** aggregate fields of "hackathon_credential_eligible_entities" */
export type Hackathon_Credential_Eligible_Entities_Aggregate_Fields = {
  __typename?: 'hackathon_credential_eligible_entities_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Credential_Eligible_Entities_Max_Fields>;
  min?: Maybe<Hackathon_Credential_Eligible_Entities_Min_Fields>;
};


/** aggregate fields of "hackathon_credential_eligible_entities" */
export type Hackathon_Credential_Eligible_Entities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_credential_eligible_entities". All fields are combined with a logical 'AND'. */
export type Hackathon_Credential_Eligible_Entities_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Credential_Eligible_Entities_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_credential_eligible_entities" */
export enum Hackathon_Credential_Eligible_Entities_Constraint {
  /** unique or primary key constraint on columns "value" */
  HackathonCredentialEligibleEntitiesPkey = 'hackathon_credential_eligible_entities_pkey'
}

export enum Hackathon_Credential_Eligible_Entities_Enum {
  Builder = 'BUILDER',
  Custom = 'CUSTOM',
  Judge = 'JUDGE',
  Organizer = 'ORGANIZER',
  Speaker = 'SPEAKER',
  Volunteer = 'VOLUNTEER',
  Winner = 'WINNER'
}

/** Boolean expression to compare columns of type "hackathon_credential_eligible_entities_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Credential_Eligible_Entities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum>;
  _in?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Enum>>;
};

/** input type for inserting data into table "hackathon_credential_eligible_entities" */
export type Hackathon_Credential_Eligible_Entities_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Credential_Eligible_Entities_Max_Fields = {
  __typename?: 'hackathon_credential_eligible_entities_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Credential_Eligible_Entities_Min_Fields = {
  __typename?: 'hackathon_credential_eligible_entities_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_credential_eligible_entities" */
export type Hackathon_Credential_Eligible_Entities_Mutation_Response = {
  __typename?: 'hackathon_credential_eligible_entities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Credential_Eligible_Entities>;
};

/** on_conflict condition type for table "hackathon_credential_eligible_entities" */
export type Hackathon_Credential_Eligible_Entities_On_Conflict = {
  constraint: Hackathon_Credential_Eligible_Entities_Constraint;
  update_columns?: Array<Hackathon_Credential_Eligible_Entities_Update_Column>;
  where?: InputMaybe<Hackathon_Credential_Eligible_Entities_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_credential_eligible_entities". */
export type Hackathon_Credential_Eligible_Entities_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_credential_eligible_entities */
export type Hackathon_Credential_Eligible_Entities_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "hackathon_credential_eligible_entities" */
export enum Hackathon_Credential_Eligible_Entities_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_credential_eligible_entities" */
export type Hackathon_Credential_Eligible_Entities_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_credential_eligible_entities" */
export type Hackathon_Credential_Eligible_Entities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Credential_Eligible_Entities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Credential_Eligible_Entities_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_credential_eligible_entities" */
export enum Hackathon_Credential_Eligible_Entities_Update_Column {
  /** column name */
  Value = 'value'
}

export type Hackathon_Credential_Eligible_Entities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Credential_Eligible_Entities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Credential_Eligible_Entities_Bool_Exp;
};

/** columns and relationships of "hackathon_credential_type" */
export type Hackathon_Credential_Type = {
  __typename?: 'hackathon_credential_type';
  value: Scalars['String'];
};

/** aggregated selection of "hackathon_credential_type" */
export type Hackathon_Credential_Type_Aggregate = {
  __typename?: 'hackathon_credential_type_aggregate';
  aggregate?: Maybe<Hackathon_Credential_Type_Aggregate_Fields>;
  nodes: Array<Hackathon_Credential_Type>;
};

/** aggregate fields of "hackathon_credential_type" */
export type Hackathon_Credential_Type_Aggregate_Fields = {
  __typename?: 'hackathon_credential_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Credential_Type_Max_Fields>;
  min?: Maybe<Hackathon_Credential_Type_Min_Fields>;
};


/** aggregate fields of "hackathon_credential_type" */
export type Hackathon_Credential_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Credential_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_credential_type". All fields are combined with a logical 'AND'. */
export type Hackathon_Credential_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Credential_Type_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Credential_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Credential_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_credential_type" */
export enum Hackathon_Credential_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  HackathonCredentialTypePkey = 'hackathon_credential_type_pkey'
}

export enum Hackathon_Credential_Type_Enum {
  Gif = 'GIF',
  Mp4 = 'MP4',
  Png = 'PNG',
  Svg = 'SVG'
}

/** Boolean expression to compare columns of type "hackathon_credential_type_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Credential_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Credential_Type_Enum>;
  _in?: InputMaybe<Array<Hackathon_Credential_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Credential_Type_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Credential_Type_Enum>>;
};

/** input type for inserting data into table "hackathon_credential_type" */
export type Hackathon_Credential_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Credential_Type_Max_Fields = {
  __typename?: 'hackathon_credential_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Credential_Type_Min_Fields = {
  __typename?: 'hackathon_credential_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_credential_type" */
export type Hackathon_Credential_Type_Mutation_Response = {
  __typename?: 'hackathon_credential_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Credential_Type>;
};

/** on_conflict condition type for table "hackathon_credential_type" */
export type Hackathon_Credential_Type_On_Conflict = {
  constraint: Hackathon_Credential_Type_Constraint;
  update_columns?: Array<Hackathon_Credential_Type_Update_Column>;
  where?: InputMaybe<Hackathon_Credential_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_credential_type". */
export type Hackathon_Credential_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_credential_type */
export type Hackathon_Credential_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "hackathon_credential_type" */
export enum Hackathon_Credential_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_credential_type" */
export type Hackathon_Credential_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_credential_type" */
export type Hackathon_Credential_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Credential_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Credential_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_credential_type" */
export enum Hackathon_Credential_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Hackathon_Credential_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Credential_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Credential_Type_Bool_Exp;
};

/** columns and relationships of "hackathon_credentials" */
export type Hackathon_Credentials = {
  __typename?: 'hackathon_credentials';
  aspect_ratio?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  credential_type?: Maybe<Hackathon_Credential_Type_Enum>;
  description?: Maybe<Scalars['String']>;
  eligible_entity: Hackathon_Credential_Eligible_Entities_Enum;
  finalized?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  hackathon: Hackathons;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  nft_hero_text?: Maybe<Scalars['String']>;
  primary_color?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "hackathon_credentials" */
export type Hackathon_Credentials_Aggregate = {
  __typename?: 'hackathon_credentials_aggregate';
  aggregate?: Maybe<Hackathon_Credentials_Aggregate_Fields>;
  nodes: Array<Hackathon_Credentials>;
};

/** aggregate fields of "hackathon_credentials" */
export type Hackathon_Credentials_Aggregate_Fields = {
  __typename?: 'hackathon_credentials_aggregate_fields';
  avg?: Maybe<Hackathon_Credentials_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Credentials_Max_Fields>;
  min?: Maybe<Hackathon_Credentials_Min_Fields>;
  stddev?: Maybe<Hackathon_Credentials_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Credentials_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Credentials_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Credentials_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Credentials_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Credentials_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Credentials_Variance_Fields>;
};


/** aggregate fields of "hackathon_credentials" */
export type Hackathon_Credentials_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Credentials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Hackathon_Credentials_Avg_Fields = {
  __typename?: 'hackathon_credentials_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hackathon_credentials". All fields are combined with a logical 'AND'. */
export type Hackathon_Credentials_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Credentials_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Credentials_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Credentials_Bool_Exp>>;
  aspect_ratio?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credential_type?: InputMaybe<Hackathon_Credential_Type_Enum_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  eligible_entity?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum_Comparison_Exp>;
  finalized?: InputMaybe<Boolean_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nft_contract_address?: InputMaybe<String_Comparison_Exp>;
  nft_hero_text?: InputMaybe<String_Comparison_Exp>;
  primary_color?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "hackathon_credentials_chain" */
export type Hackathon_Credentials_Chain = {
  __typename?: 'hackathon_credentials_chain';
  value: Scalars['String'];
};

/** aggregated selection of "hackathon_credentials_chain" */
export type Hackathon_Credentials_Chain_Aggregate = {
  __typename?: 'hackathon_credentials_chain_aggregate';
  aggregate?: Maybe<Hackathon_Credentials_Chain_Aggregate_Fields>;
  nodes: Array<Hackathon_Credentials_Chain>;
};

/** aggregate fields of "hackathon_credentials_chain" */
export type Hackathon_Credentials_Chain_Aggregate_Fields = {
  __typename?: 'hackathon_credentials_chain_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Credentials_Chain_Max_Fields>;
  min?: Maybe<Hackathon_Credentials_Chain_Min_Fields>;
};


/** aggregate fields of "hackathon_credentials_chain" */
export type Hackathon_Credentials_Chain_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Credentials_Chain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_credentials_chain". All fields are combined with a logical 'AND'. */
export type Hackathon_Credentials_Chain_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Credentials_Chain_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Credentials_Chain_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Credentials_Chain_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_credentials_chain" */
export enum Hackathon_Credentials_Chain_Constraint {
  /** unique or primary key constraint on columns "value" */
  HackathonCredentialsChainPkey = 'hackathon_credentials_chain_pkey'
}

export enum Hackathon_Credentials_Chain_Enum {
  Arbitrum = 'ARBITRUM',
  Base = 'BASE',
  Mainnet = 'MAINNET',
  Optimism = 'OPTIMISM',
  Sepolia = 'SEPOLIA'
}

/** Boolean expression to compare columns of type "hackathon_credentials_chain_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Credentials_Chain_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Credentials_Chain_Enum>;
  _in?: InputMaybe<Array<Hackathon_Credentials_Chain_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Credentials_Chain_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Credentials_Chain_Enum>>;
};

/** input type for inserting data into table "hackathon_credentials_chain" */
export type Hackathon_Credentials_Chain_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Credentials_Chain_Max_Fields = {
  __typename?: 'hackathon_credentials_chain_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Credentials_Chain_Min_Fields = {
  __typename?: 'hackathon_credentials_chain_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_credentials_chain" */
export type Hackathon_Credentials_Chain_Mutation_Response = {
  __typename?: 'hackathon_credentials_chain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Credentials_Chain>;
};

/** on_conflict condition type for table "hackathon_credentials_chain" */
export type Hackathon_Credentials_Chain_On_Conflict = {
  constraint: Hackathon_Credentials_Chain_Constraint;
  update_columns?: Array<Hackathon_Credentials_Chain_Update_Column>;
  where?: InputMaybe<Hackathon_Credentials_Chain_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_credentials_chain". */
export type Hackathon_Credentials_Chain_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_credentials_chain */
export type Hackathon_Credentials_Chain_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "hackathon_credentials_chain" */
export enum Hackathon_Credentials_Chain_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_credentials_chain" */
export type Hackathon_Credentials_Chain_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_credentials_chain" */
export type Hackathon_Credentials_Chain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Credentials_Chain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Credentials_Chain_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_credentials_chain" */
export enum Hackathon_Credentials_Chain_Update_Column {
  /** column name */
  Value = 'value'
}

export type Hackathon_Credentials_Chain_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Credentials_Chain_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Credentials_Chain_Bool_Exp;
};

/** unique or primary key constraints on table "hackathon_credentials" */
export enum Hackathon_Credentials_Constraint {
  /** unique or primary key constraint on columns "eligible_entity", "hackathon_id" */
  HackathonCredentialsHackathonIdEligibleEntityKey = 'hackathon_credentials_hackathon_id_eligible_entity_key',
  /** unique or primary key constraint on columns "id" */
  HackathonCredentialsPkey = 'hackathon_credentials_pkey',
  /** unique or primary key constraint on columns "uuid" */
  HackathonCredentialsUuidKey = 'hackathon_credentials_uuid_key'
}

/** input type for incrementing numeric columns in table "hackathon_credentials" */
export type Hackathon_Credentials_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_credentials" */
export type Hackathon_Credentials_Insert_Input = {
  aspect_ratio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credential_type?: InputMaybe<Hackathon_Credential_Type_Enum>;
  description?: InputMaybe<Scalars['String']>;
  eligible_entity?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum>;
  finalized?: InputMaybe<Scalars['Boolean']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  nft_hero_text?: InputMaybe<Scalars['String']>;
  primary_color?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Credentials_Max_Fields = {
  __typename?: 'hackathon_credentials_max_fields';
  aspect_ratio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  nft_hero_text?: Maybe<Scalars['String']>;
  primary_color?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Credentials_Min_Fields = {
  __typename?: 'hackathon_credentials_min_fields';
  aspect_ratio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  nft_hero_text?: Maybe<Scalars['String']>;
  primary_color?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_credentials" */
export type Hackathon_Credentials_Mutation_Response = {
  __typename?: 'hackathon_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Credentials>;
};

/** input type for inserting object relation for remote table "hackathon_credentials" */
export type Hackathon_Credentials_Obj_Rel_Insert_Input = {
  data: Hackathon_Credentials_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Credentials_On_Conflict>;
};

/** on_conflict condition type for table "hackathon_credentials" */
export type Hackathon_Credentials_On_Conflict = {
  constraint: Hackathon_Credentials_Constraint;
  update_columns?: Array<Hackathon_Credentials_Update_Column>;
  where?: InputMaybe<Hackathon_Credentials_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_credentials". */
export type Hackathon_Credentials_Order_By = {
  aspect_ratio?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credential_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eligible_entity?: InputMaybe<Order_By>;
  finalized?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nft_contract_address?: InputMaybe<Order_By>;
  nft_hero_text?: InputMaybe<Order_By>;
  primary_color?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_credentials */
export type Hackathon_Credentials_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_credentials" */
export enum Hackathon_Credentials_Select_Column {
  /** column name */
  AspectRatio = 'aspect_ratio',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CredentialType = 'credential_type',
  /** column name */
  Description = 'description',
  /** column name */
  EligibleEntity = 'eligible_entity',
  /** column name */
  Finalized = 'finalized',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NftContractAddress = 'nft_contract_address',
  /** column name */
  NftHeroText = 'nft_hero_text',
  /** column name */
  PrimaryColor = 'primary_color',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_credentials" */
export type Hackathon_Credentials_Set_Input = {
  aspect_ratio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credential_type?: InputMaybe<Hackathon_Credential_Type_Enum>;
  description?: InputMaybe<Scalars['String']>;
  eligible_entity?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum>;
  finalized?: InputMaybe<Scalars['Boolean']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  nft_hero_text?: InputMaybe<Scalars['String']>;
  primary_color?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Credentials_Stddev_Fields = {
  __typename?: 'hackathon_credentials_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Credentials_Stddev_Pop_Fields = {
  __typename?: 'hackathon_credentials_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Credentials_Stddev_Samp_Fields = {
  __typename?: 'hackathon_credentials_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hackathon_credentials" */
export type Hackathon_Credentials_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Credentials_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Credentials_Stream_Cursor_Value_Input = {
  aspect_ratio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credential_type?: InputMaybe<Hackathon_Credential_Type_Enum>;
  description?: InputMaybe<Scalars['String']>;
  eligible_entity?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum>;
  finalized?: InputMaybe<Scalars['Boolean']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  nft_hero_text?: InputMaybe<Scalars['String']>;
  primary_color?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Credentials_Sum_Fields = {
  __typename?: 'hackathon_credentials_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "hackathon_credentials" */
export enum Hackathon_Credentials_Update_Column {
  /** column name */
  AspectRatio = 'aspect_ratio',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CredentialType = 'credential_type',
  /** column name */
  Description = 'description',
  /** column name */
  EligibleEntity = 'eligible_entity',
  /** column name */
  Finalized = 'finalized',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NftContractAddress = 'nft_contract_address',
  /** column name */
  NftHeroText = 'nft_hero_text',
  /** column name */
  PrimaryColor = 'primary_color',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Credentials_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Credentials_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Credentials_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Credentials_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Credentials_Var_Pop_Fields = {
  __typename?: 'hackathon_credentials_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hackathon_Credentials_Var_Samp_Fields = {
  __typename?: 'hackathon_credentials_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hackathon_Credentials_Variance_Fields = {
  __typename?: 'hackathon_credentials_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "hackathon_email_templates" */
export type Hackathon_Email_Templates = {
  __typename?: 'hackathon_email_templates';
  acceptance_offline?: Maybe<Scalars['String']>;
  acceptance_offline_data?: Maybe<Scalars['String']>;
  acceptance_offline_subject?: Maybe<Scalars['String']>;
  acceptance_online?: Maybe<Scalars['String']>;
  acceptance_online_data?: Maybe<Scalars['String']>;
  acceptance_online_subject?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  rejection?: Maybe<Scalars['String']>;
  rejection_data?: Maybe<Scalars['String']>;
  rejection_subject?: Maybe<Scalars['String']>;
  rsvp_data?: Maybe<Scalars['String']>;
  rsvp_reminder_data?: Maybe<Scalars['String']>;
  rsvp_reminder_subject?: Maybe<Scalars['String']>;
  rsvp_subject?: Maybe<Scalars['String']>;
  submission_reminder_individual_data?: Maybe<Scalars['String']>;
  submission_reminder_individual_subject?: Maybe<Scalars['String']>;
  submission_reminder_team_data?: Maybe<Scalars['String']>;
  submission_reminder_team_subject?: Maybe<Scalars['String']>;
  team_acceptance_offline?: Maybe<Scalars['String']>;
  team_acceptance_offline_data?: Maybe<Scalars['String']>;
  team_acceptance_offline_subject?: Maybe<Scalars['String']>;
  team_acceptance_online?: Maybe<Scalars['String']>;
  team_acceptance_online_data?: Maybe<Scalars['String']>;
  team_acceptance_online_subject?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  user_hackathon_reminder_data?: Maybe<Scalars['String']>;
  user_hackathon_reminder_subject?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/** aggregated selection of "hackathon_email_templates" */
export type Hackathon_Email_Templates_Aggregate = {
  __typename?: 'hackathon_email_templates_aggregate';
  aggregate?: Maybe<Hackathon_Email_Templates_Aggregate_Fields>;
  nodes: Array<Hackathon_Email_Templates>;
};

/** aggregate fields of "hackathon_email_templates" */
export type Hackathon_Email_Templates_Aggregate_Fields = {
  __typename?: 'hackathon_email_templates_aggregate_fields';
  avg?: Maybe<Hackathon_Email_Templates_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Email_Templates_Max_Fields>;
  min?: Maybe<Hackathon_Email_Templates_Min_Fields>;
  stddev?: Maybe<Hackathon_Email_Templates_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Email_Templates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Email_Templates_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Email_Templates_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Email_Templates_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Email_Templates_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Email_Templates_Variance_Fields>;
};


/** aggregate fields of "hackathon_email_templates" */
export type Hackathon_Email_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Email_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Hackathon_Email_Templates_Avg_Fields = {
  __typename?: 'hackathon_email_templates_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hackathon_email_templates". All fields are combined with a logical 'AND'. */
export type Hackathon_Email_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Email_Templates_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Email_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Email_Templates_Bool_Exp>>;
  acceptance_offline?: InputMaybe<String_Comparison_Exp>;
  acceptance_offline_data?: InputMaybe<String_Comparison_Exp>;
  acceptance_offline_subject?: InputMaybe<String_Comparison_Exp>;
  acceptance_online?: InputMaybe<String_Comparison_Exp>;
  acceptance_online_data?: InputMaybe<String_Comparison_Exp>;
  acceptance_online_subject?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  rejection?: InputMaybe<String_Comparison_Exp>;
  rejection_data?: InputMaybe<String_Comparison_Exp>;
  rejection_subject?: InputMaybe<String_Comparison_Exp>;
  rsvp_data?: InputMaybe<String_Comparison_Exp>;
  rsvp_reminder_data?: InputMaybe<String_Comparison_Exp>;
  rsvp_reminder_subject?: InputMaybe<String_Comparison_Exp>;
  rsvp_subject?: InputMaybe<String_Comparison_Exp>;
  submission_reminder_individual_data?: InputMaybe<String_Comparison_Exp>;
  submission_reminder_individual_subject?: InputMaybe<String_Comparison_Exp>;
  submission_reminder_team_data?: InputMaybe<String_Comparison_Exp>;
  submission_reminder_team_subject?: InputMaybe<String_Comparison_Exp>;
  team_acceptance_offline?: InputMaybe<String_Comparison_Exp>;
  team_acceptance_offline_data?: InputMaybe<String_Comparison_Exp>;
  team_acceptance_offline_subject?: InputMaybe<String_Comparison_Exp>;
  team_acceptance_online?: InputMaybe<String_Comparison_Exp>;
  team_acceptance_online_data?: InputMaybe<String_Comparison_Exp>;
  team_acceptance_online_subject?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_hackathon_reminder_data?: InputMaybe<String_Comparison_Exp>;
  user_hackathon_reminder_subject?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_email_templates" */
export enum Hackathon_Email_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkHackathonEmailTemplates = 'pk_hackathon_email_templates',
  /** unique or primary key constraint on columns "hackathon_id" */
  UniqueHackathonIdHackathonEmailTemplates = 'unique_hackathon_id_hackathon_email_templates',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHackathonEmailTemplates = 'unique_uuid_hackathon_email_templates'
}

/** input type for incrementing numeric columns in table "hackathon_email_templates" */
export type Hackathon_Email_Templates_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_email_templates" */
export type Hackathon_Email_Templates_Insert_Input = {
  acceptance_offline?: InputMaybe<Scalars['String']>;
  acceptance_offline_data?: InputMaybe<Scalars['String']>;
  acceptance_offline_subject?: InputMaybe<Scalars['String']>;
  acceptance_online?: InputMaybe<Scalars['String']>;
  acceptance_online_data?: InputMaybe<Scalars['String']>;
  acceptance_online_subject?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['String']>;
  rejection_data?: InputMaybe<Scalars['String']>;
  rejection_subject?: InputMaybe<Scalars['String']>;
  rsvp_data?: InputMaybe<Scalars['String']>;
  rsvp_reminder_data?: InputMaybe<Scalars['String']>;
  rsvp_reminder_subject?: InputMaybe<Scalars['String']>;
  rsvp_subject?: InputMaybe<Scalars['String']>;
  submission_reminder_individual_data?: InputMaybe<Scalars['String']>;
  submission_reminder_individual_subject?: InputMaybe<Scalars['String']>;
  submission_reminder_team_data?: InputMaybe<Scalars['String']>;
  submission_reminder_team_subject?: InputMaybe<Scalars['String']>;
  team_acceptance_offline?: InputMaybe<Scalars['String']>;
  team_acceptance_offline_data?: InputMaybe<Scalars['String']>;
  team_acceptance_offline_subject?: InputMaybe<Scalars['String']>;
  team_acceptance_online?: InputMaybe<Scalars['String']>;
  team_acceptance_online_data?: InputMaybe<Scalars['String']>;
  team_acceptance_online_subject?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_hackathon_reminder_data?: InputMaybe<Scalars['String']>;
  user_hackathon_reminder_subject?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Email_Templates_Max_Fields = {
  __typename?: 'hackathon_email_templates_max_fields';
  acceptance_offline?: Maybe<Scalars['String']>;
  acceptance_offline_data?: Maybe<Scalars['String']>;
  acceptance_offline_subject?: Maybe<Scalars['String']>;
  acceptance_online?: Maybe<Scalars['String']>;
  acceptance_online_data?: Maybe<Scalars['String']>;
  acceptance_online_subject?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  rejection?: Maybe<Scalars['String']>;
  rejection_data?: Maybe<Scalars['String']>;
  rejection_subject?: Maybe<Scalars['String']>;
  rsvp_data?: Maybe<Scalars['String']>;
  rsvp_reminder_data?: Maybe<Scalars['String']>;
  rsvp_reminder_subject?: Maybe<Scalars['String']>;
  rsvp_subject?: Maybe<Scalars['String']>;
  submission_reminder_individual_data?: Maybe<Scalars['String']>;
  submission_reminder_individual_subject?: Maybe<Scalars['String']>;
  submission_reminder_team_data?: Maybe<Scalars['String']>;
  submission_reminder_team_subject?: Maybe<Scalars['String']>;
  team_acceptance_offline?: Maybe<Scalars['String']>;
  team_acceptance_offline_data?: Maybe<Scalars['String']>;
  team_acceptance_offline_subject?: Maybe<Scalars['String']>;
  team_acceptance_online?: Maybe<Scalars['String']>;
  team_acceptance_online_data?: Maybe<Scalars['String']>;
  team_acceptance_online_subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_hackathon_reminder_data?: Maybe<Scalars['String']>;
  user_hackathon_reminder_subject?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Email_Templates_Min_Fields = {
  __typename?: 'hackathon_email_templates_min_fields';
  acceptance_offline?: Maybe<Scalars['String']>;
  acceptance_offline_data?: Maybe<Scalars['String']>;
  acceptance_offline_subject?: Maybe<Scalars['String']>;
  acceptance_online?: Maybe<Scalars['String']>;
  acceptance_online_data?: Maybe<Scalars['String']>;
  acceptance_online_subject?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  rejection?: Maybe<Scalars['String']>;
  rejection_data?: Maybe<Scalars['String']>;
  rejection_subject?: Maybe<Scalars['String']>;
  rsvp_data?: Maybe<Scalars['String']>;
  rsvp_reminder_data?: Maybe<Scalars['String']>;
  rsvp_reminder_subject?: Maybe<Scalars['String']>;
  rsvp_subject?: Maybe<Scalars['String']>;
  submission_reminder_individual_data?: Maybe<Scalars['String']>;
  submission_reminder_individual_subject?: Maybe<Scalars['String']>;
  submission_reminder_team_data?: Maybe<Scalars['String']>;
  submission_reminder_team_subject?: Maybe<Scalars['String']>;
  team_acceptance_offline?: Maybe<Scalars['String']>;
  team_acceptance_offline_data?: Maybe<Scalars['String']>;
  team_acceptance_offline_subject?: Maybe<Scalars['String']>;
  team_acceptance_online?: Maybe<Scalars['String']>;
  team_acceptance_online_data?: Maybe<Scalars['String']>;
  team_acceptance_online_subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_hackathon_reminder_data?: Maybe<Scalars['String']>;
  user_hackathon_reminder_subject?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_email_templates" */
export type Hackathon_Email_Templates_Mutation_Response = {
  __typename?: 'hackathon_email_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Email_Templates>;
};

/** on_conflict condition type for table "hackathon_email_templates" */
export type Hackathon_Email_Templates_On_Conflict = {
  constraint: Hackathon_Email_Templates_Constraint;
  update_columns?: Array<Hackathon_Email_Templates_Update_Column>;
  where?: InputMaybe<Hackathon_Email_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_email_templates". */
export type Hackathon_Email_Templates_Order_By = {
  acceptance_offline?: InputMaybe<Order_By>;
  acceptance_offline_data?: InputMaybe<Order_By>;
  acceptance_offline_subject?: InputMaybe<Order_By>;
  acceptance_online?: InputMaybe<Order_By>;
  acceptance_online_data?: InputMaybe<Order_By>;
  acceptance_online_subject?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejection?: InputMaybe<Order_By>;
  rejection_data?: InputMaybe<Order_By>;
  rejection_subject?: InputMaybe<Order_By>;
  rsvp_data?: InputMaybe<Order_By>;
  rsvp_reminder_data?: InputMaybe<Order_By>;
  rsvp_reminder_subject?: InputMaybe<Order_By>;
  rsvp_subject?: InputMaybe<Order_By>;
  submission_reminder_individual_data?: InputMaybe<Order_By>;
  submission_reminder_individual_subject?: InputMaybe<Order_By>;
  submission_reminder_team_data?: InputMaybe<Order_By>;
  submission_reminder_team_subject?: InputMaybe<Order_By>;
  team_acceptance_offline?: InputMaybe<Order_By>;
  team_acceptance_offline_data?: InputMaybe<Order_By>;
  team_acceptance_offline_subject?: InputMaybe<Order_By>;
  team_acceptance_online?: InputMaybe<Order_By>;
  team_acceptance_online_data?: InputMaybe<Order_By>;
  team_acceptance_online_subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_hackathon_reminder_data?: InputMaybe<Order_By>;
  user_hackathon_reminder_subject?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_email_templates */
export type Hackathon_Email_Templates_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_email_templates" */
export enum Hackathon_Email_Templates_Select_Column {
  /** column name */
  AcceptanceOffline = 'acceptance_offline',
  /** column name */
  AcceptanceOfflineData = 'acceptance_offline_data',
  /** column name */
  AcceptanceOfflineSubject = 'acceptance_offline_subject',
  /** column name */
  AcceptanceOnline = 'acceptance_online',
  /** column name */
  AcceptanceOnlineData = 'acceptance_online_data',
  /** column name */
  AcceptanceOnlineSubject = 'acceptance_online_subject',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rejection = 'rejection',
  /** column name */
  RejectionData = 'rejection_data',
  /** column name */
  RejectionSubject = 'rejection_subject',
  /** column name */
  RsvpData = 'rsvp_data',
  /** column name */
  RsvpReminderData = 'rsvp_reminder_data',
  /** column name */
  RsvpReminderSubject = 'rsvp_reminder_subject',
  /** column name */
  RsvpSubject = 'rsvp_subject',
  /** column name */
  SubmissionReminderIndividualData = 'submission_reminder_individual_data',
  /** column name */
  SubmissionReminderIndividualSubject = 'submission_reminder_individual_subject',
  /** column name */
  SubmissionReminderTeamData = 'submission_reminder_team_data',
  /** column name */
  SubmissionReminderTeamSubject = 'submission_reminder_team_subject',
  /** column name */
  TeamAcceptanceOffline = 'team_acceptance_offline',
  /** column name */
  TeamAcceptanceOfflineData = 'team_acceptance_offline_data',
  /** column name */
  TeamAcceptanceOfflineSubject = 'team_acceptance_offline_subject',
  /** column name */
  TeamAcceptanceOnline = 'team_acceptance_online',
  /** column name */
  TeamAcceptanceOnlineData = 'team_acceptance_online_data',
  /** column name */
  TeamAcceptanceOnlineSubject = 'team_acceptance_online_subject',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserHackathonReminderData = 'user_hackathon_reminder_data',
  /** column name */
  UserHackathonReminderSubject = 'user_hackathon_reminder_subject',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_email_templates" */
export type Hackathon_Email_Templates_Set_Input = {
  acceptance_offline?: InputMaybe<Scalars['String']>;
  acceptance_offline_data?: InputMaybe<Scalars['String']>;
  acceptance_offline_subject?: InputMaybe<Scalars['String']>;
  acceptance_online?: InputMaybe<Scalars['String']>;
  acceptance_online_data?: InputMaybe<Scalars['String']>;
  acceptance_online_subject?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['String']>;
  rejection_data?: InputMaybe<Scalars['String']>;
  rejection_subject?: InputMaybe<Scalars['String']>;
  rsvp_data?: InputMaybe<Scalars['String']>;
  rsvp_reminder_data?: InputMaybe<Scalars['String']>;
  rsvp_reminder_subject?: InputMaybe<Scalars['String']>;
  rsvp_subject?: InputMaybe<Scalars['String']>;
  submission_reminder_individual_data?: InputMaybe<Scalars['String']>;
  submission_reminder_individual_subject?: InputMaybe<Scalars['String']>;
  submission_reminder_team_data?: InputMaybe<Scalars['String']>;
  submission_reminder_team_subject?: InputMaybe<Scalars['String']>;
  team_acceptance_offline?: InputMaybe<Scalars['String']>;
  team_acceptance_offline_data?: InputMaybe<Scalars['String']>;
  team_acceptance_offline_subject?: InputMaybe<Scalars['String']>;
  team_acceptance_online?: InputMaybe<Scalars['String']>;
  team_acceptance_online_data?: InputMaybe<Scalars['String']>;
  team_acceptance_online_subject?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_hackathon_reminder_data?: InputMaybe<Scalars['String']>;
  user_hackathon_reminder_subject?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Email_Templates_Stddev_Fields = {
  __typename?: 'hackathon_email_templates_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Email_Templates_Stddev_Pop_Fields = {
  __typename?: 'hackathon_email_templates_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Email_Templates_Stddev_Samp_Fields = {
  __typename?: 'hackathon_email_templates_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hackathon_email_templates" */
export type Hackathon_Email_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Email_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Email_Templates_Stream_Cursor_Value_Input = {
  acceptance_offline?: InputMaybe<Scalars['String']>;
  acceptance_offline_data?: InputMaybe<Scalars['String']>;
  acceptance_offline_subject?: InputMaybe<Scalars['String']>;
  acceptance_online?: InputMaybe<Scalars['String']>;
  acceptance_online_data?: InputMaybe<Scalars['String']>;
  acceptance_online_subject?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['String']>;
  rejection_data?: InputMaybe<Scalars['String']>;
  rejection_subject?: InputMaybe<Scalars['String']>;
  rsvp_data?: InputMaybe<Scalars['String']>;
  rsvp_reminder_data?: InputMaybe<Scalars['String']>;
  rsvp_reminder_subject?: InputMaybe<Scalars['String']>;
  rsvp_subject?: InputMaybe<Scalars['String']>;
  submission_reminder_individual_data?: InputMaybe<Scalars['String']>;
  submission_reminder_individual_subject?: InputMaybe<Scalars['String']>;
  submission_reminder_team_data?: InputMaybe<Scalars['String']>;
  submission_reminder_team_subject?: InputMaybe<Scalars['String']>;
  team_acceptance_offline?: InputMaybe<Scalars['String']>;
  team_acceptance_offline_data?: InputMaybe<Scalars['String']>;
  team_acceptance_offline_subject?: InputMaybe<Scalars['String']>;
  team_acceptance_online?: InputMaybe<Scalars['String']>;
  team_acceptance_online_data?: InputMaybe<Scalars['String']>;
  team_acceptance_online_subject?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_hackathon_reminder_data?: InputMaybe<Scalars['String']>;
  user_hackathon_reminder_subject?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Email_Templates_Sum_Fields = {
  __typename?: 'hackathon_email_templates_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "hackathon_email_templates" */
export enum Hackathon_Email_Templates_Update_Column {
  /** column name */
  AcceptanceOffline = 'acceptance_offline',
  /** column name */
  AcceptanceOfflineData = 'acceptance_offline_data',
  /** column name */
  AcceptanceOfflineSubject = 'acceptance_offline_subject',
  /** column name */
  AcceptanceOnline = 'acceptance_online',
  /** column name */
  AcceptanceOnlineData = 'acceptance_online_data',
  /** column name */
  AcceptanceOnlineSubject = 'acceptance_online_subject',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rejection = 'rejection',
  /** column name */
  RejectionData = 'rejection_data',
  /** column name */
  RejectionSubject = 'rejection_subject',
  /** column name */
  RsvpData = 'rsvp_data',
  /** column name */
  RsvpReminderData = 'rsvp_reminder_data',
  /** column name */
  RsvpReminderSubject = 'rsvp_reminder_subject',
  /** column name */
  RsvpSubject = 'rsvp_subject',
  /** column name */
  SubmissionReminderIndividualData = 'submission_reminder_individual_data',
  /** column name */
  SubmissionReminderIndividualSubject = 'submission_reminder_individual_subject',
  /** column name */
  SubmissionReminderTeamData = 'submission_reminder_team_data',
  /** column name */
  SubmissionReminderTeamSubject = 'submission_reminder_team_subject',
  /** column name */
  TeamAcceptanceOffline = 'team_acceptance_offline',
  /** column name */
  TeamAcceptanceOfflineData = 'team_acceptance_offline_data',
  /** column name */
  TeamAcceptanceOfflineSubject = 'team_acceptance_offline_subject',
  /** column name */
  TeamAcceptanceOnline = 'team_acceptance_online',
  /** column name */
  TeamAcceptanceOnlineData = 'team_acceptance_online_data',
  /** column name */
  TeamAcceptanceOnlineSubject = 'team_acceptance_online_subject',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserHackathonReminderData = 'user_hackathon_reminder_data',
  /** column name */
  UserHackathonReminderSubject = 'user_hackathon_reminder_subject',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Email_Templates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Email_Templates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Email_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Email_Templates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Email_Templates_Var_Pop_Fields = {
  __typename?: 'hackathon_email_templates_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hackathon_Email_Templates_Var_Samp_Fields = {
  __typename?: 'hackathon_email_templates_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hackathon_Email_Templates_Variance_Fields = {
  __typename?: 'hackathon_email_templates_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** This table is used to store the data for hackathon event groups which groups the events in a more logical order like Week1, Week2, Pre-Events */
export type Hackathon_Event_Groups = {
  __typename?: 'hackathon_event_groups';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  hackathon_events: Array<Hackathon_Events>;
  /** An aggregate relationship */
  hackathon_events_aggregate: Hackathon_Events_Aggregate;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};


/** This table is used to store the data for hackathon event groups which groups the events in a more logical order like Week1, Week2, Pre-Events */
export type Hackathon_Event_GroupsHackathon_EventsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Events_Order_By>>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};


/** This table is used to store the data for hackathon event groups which groups the events in a more logical order like Week1, Week2, Pre-Events */
export type Hackathon_Event_GroupsHackathon_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Events_Order_By>>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};

/** aggregated selection of "hackathon_event_groups" */
export type Hackathon_Event_Groups_Aggregate = {
  __typename?: 'hackathon_event_groups_aggregate';
  aggregate?: Maybe<Hackathon_Event_Groups_Aggregate_Fields>;
  nodes: Array<Hackathon_Event_Groups>;
};

export type Hackathon_Event_Groups_Aggregate_Bool_Exp = {
  count?: InputMaybe<Hackathon_Event_Groups_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Event_Groups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Event_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_event_groups" */
export type Hackathon_Event_Groups_Aggregate_Fields = {
  __typename?: 'hackathon_event_groups_aggregate_fields';
  avg?: Maybe<Hackathon_Event_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Event_Groups_Max_Fields>;
  min?: Maybe<Hackathon_Event_Groups_Min_Fields>;
  stddev?: Maybe<Hackathon_Event_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Event_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Event_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Event_Groups_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Event_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Event_Groups_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Event_Groups_Variance_Fields>;
};


/** aggregate fields of "hackathon_event_groups" */
export type Hackathon_Event_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Event_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Event_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Event_Groups_Max_Order_By>;
  min?: InputMaybe<Hackathon_Event_Groups_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Event_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Event_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Event_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Event_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Event_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Event_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Event_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Event_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Event_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Event_Groups_Avg_Fields = {
  __typename?: 'hackathon_event_groups_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_event_groups". All fields are combined with a logical 'AND'. */
export type Hackathon_Event_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Event_Groups_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Event_Groups_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon_events?: InputMaybe<Hackathon_Events_Bool_Exp>;
  hackathon_events_aggregate?: InputMaybe<Hackathon_Events_Aggregate_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_event_groups" */
export enum Hackathon_Event_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  HackathonEventGroupsPkey = 'hackathon_event_groups_pkey',
  /** unique or primary key constraint on columns "uuid" */
  HackathonEventGroupsUuidKey = 'hackathon_event_groups_uuid_key'
}

/** input type for incrementing numeric columns in table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_events?: InputMaybe<Hackathon_Events_Arr_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Event_Groups_Max_Fields = {
  __typename?: 'hackathon_event_groups_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Event_Groups_Min_Fields = {
  __typename?: 'hackathon_event_groups_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Mutation_Response = {
  __typename?: 'hackathon_event_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Event_Groups>;
};

/** input type for inserting object relation for remote table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Obj_Rel_Insert_Input = {
  data: Hackathon_Event_Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Event_Groups_On_Conflict>;
};

/** on_conflict condition type for table "hackathon_event_groups" */
export type Hackathon_Event_Groups_On_Conflict = {
  constraint: Hackathon_Event_Groups_Constraint;
  update_columns?: Array<Hackathon_Event_Groups_Update_Column>;
  where?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_event_groups". */
export type Hackathon_Event_Groups_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_events_aggregate?: InputMaybe<Hackathon_Events_Aggregate_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_event_groups */
export type Hackathon_Event_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_event_groups" */
export enum Hackathon_Event_Groups_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Event_Groups_Stddev_Fields = {
  __typename?: 'hackathon_event_groups_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Event_Groups_Stddev_Pop_Fields = {
  __typename?: 'hackathon_event_groups_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Event_Groups_Stddev_Samp_Fields = {
  __typename?: 'hackathon_event_groups_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Event_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Event_Groups_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Event_Groups_Sum_Fields = {
  __typename?: 'hackathon_event_groups_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_event_groups" */
export enum Hackathon_Event_Groups_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Event_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Event_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Event_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Event_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Event_Groups_Var_Pop_Fields = {
  __typename?: 'hackathon_event_groups_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Event_Groups_Var_Samp_Fields = {
  __typename?: 'hackathon_event_groups_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Event_Groups_Variance_Fields = {
  __typename?: 'hackathon_event_groups_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_event_groups" */
export type Hackathon_Event_Groups_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "hackathon_event_speakers" */
export type Hackathon_Event_Speakers = {
  __typename?: 'hackathon_event_speakers';
  created_at: Scalars['timestamptz'];
  hackathon_event_id: Scalars['Int'];
  judge_id: Scalars['Int'];
  /** An object relationship */
  speaker?: Maybe<Judges>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Aggregate = {
  __typename?: 'hackathon_event_speakers_aggregate';
  aggregate?: Maybe<Hackathon_Event_Speakers_Aggregate_Fields>;
  nodes: Array<Hackathon_Event_Speakers>;
};

export type Hackathon_Event_Speakers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Hackathon_Event_Speakers_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Event_Speakers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Event_Speakers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Aggregate_Fields = {
  __typename?: 'hackathon_event_speakers_aggregate_fields';
  avg?: Maybe<Hackathon_Event_Speakers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Event_Speakers_Max_Fields>;
  min?: Maybe<Hackathon_Event_Speakers_Min_Fields>;
  stddev?: Maybe<Hackathon_Event_Speakers_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Event_Speakers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Event_Speakers_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Event_Speakers_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Event_Speakers_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Event_Speakers_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Event_Speakers_Variance_Fields>;
};


/** aggregate fields of "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Event_Speakers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Event_Speakers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Event_Speakers_Max_Order_By>;
  min?: InputMaybe<Hackathon_Event_Speakers_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Event_Speakers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Event_Speakers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Event_Speakers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Event_Speakers_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Event_Speakers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Event_Speakers_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Event_Speakers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Event_Speakers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Event_Speakers_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Event_Speakers_Avg_Fields = {
  __typename?: 'hackathon_event_speakers_avg_fields';
  hackathon_event_id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Avg_Order_By = {
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_event_speakers". All fields are combined with a logical 'AND'. */
export type Hackathon_Event_Speakers_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Event_Speakers_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Event_Speakers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon_event_id?: InputMaybe<Int_Comparison_Exp>;
  judge_id?: InputMaybe<Int_Comparison_Exp>;
  speaker?: InputMaybe<Judges_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_event_speakers" */
export enum Hackathon_Event_Speakers_Constraint {
  /** unique or primary key constraint on columns "judge_id", "hackathon_event_id" */
  HackathonEventSpeakersPkey = 'hackathon_event_speakers_pkey'
}

/** input type for incrementing numeric columns in table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Inc_Input = {
  hackathon_event_id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_event_id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  speaker?: InputMaybe<Judges_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Hackathon_Event_Speakers_Max_Fields = {
  __typename?: 'hackathon_event_speakers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_event_id?: Maybe<Scalars['Int']>;
  judge_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Event_Speakers_Min_Fields = {
  __typename?: 'hackathon_event_speakers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_event_id?: Maybe<Scalars['Int']>;
  judge_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Mutation_Response = {
  __typename?: 'hackathon_event_speakers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Event_Speakers>;
};

/** on_conflict condition type for table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_On_Conflict = {
  constraint: Hackathon_Event_Speakers_Constraint;
  update_columns?: Array<Hackathon_Event_Speakers_Update_Column>;
  where?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_event_speakers". */
export type Hackathon_Event_Speakers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  speaker?: InputMaybe<Judges_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_event_speakers */
export type Hackathon_Event_Speakers_Pk_Columns_Input = {
  hackathon_event_id: Scalars['Int'];
  judge_id: Scalars['Int'];
};

/** select columns of table "hackathon_event_speakers" */
export enum Hackathon_Event_Speakers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonEventId = 'hackathon_event_id',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_event_id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Hackathon_Event_Speakers_Stddev_Fields = {
  __typename?: 'hackathon_event_speakers_stddev_fields';
  hackathon_event_id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Stddev_Order_By = {
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Event_Speakers_Stddev_Pop_Fields = {
  __typename?: 'hackathon_event_speakers_stddev_pop_fields';
  hackathon_event_id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Stddev_Pop_Order_By = {
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Event_Speakers_Stddev_Samp_Fields = {
  __typename?: 'hackathon_event_speakers_stddev_samp_fields';
  hackathon_event_id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Stddev_Samp_Order_By = {
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Event_Speakers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Event_Speakers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_event_id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Hackathon_Event_Speakers_Sum_Fields = {
  __typename?: 'hackathon_event_speakers_sum_fields';
  hackathon_event_id?: Maybe<Scalars['Int']>;
  judge_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Sum_Order_By = {
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_event_speakers" */
export enum Hackathon_Event_Speakers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonEventId = 'hackathon_event_id',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Hackathon_Event_Speakers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Event_Speakers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Event_Speakers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Event_Speakers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Event_Speakers_Var_Pop_Fields = {
  __typename?: 'hackathon_event_speakers_var_pop_fields';
  hackathon_event_id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Var_Pop_Order_By = {
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Event_Speakers_Var_Samp_Fields = {
  __typename?: 'hackathon_event_speakers_var_samp_fields';
  hackathon_event_id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Var_Samp_Order_By = {
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Event_Speakers_Variance_Fields = {
  __typename?: 'hackathon_event_speakers_variance_fields';
  hackathon_event_id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_event_speakers" */
export type Hackathon_Event_Speakers_Variance_Order_By = {
  hackathon_event_id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors = {
  __typename?: 'hackathon_event_sponsors';
  created_at: Scalars['timestamptz'];
  event_id: Scalars['Int'];
  /** An object relationship */
  sponsor: Sponsors;
  sponsor_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Aggregate = {
  __typename?: 'hackathon_event_sponsors_aggregate';
  aggregate?: Maybe<Hackathon_Event_Sponsors_Aggregate_Fields>;
  nodes: Array<Hackathon_Event_Sponsors>;
};

export type Hackathon_Event_Sponsors_Aggregate_Bool_Exp = {
  count?: InputMaybe<Hackathon_Event_Sponsors_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Event_Sponsors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Event_Sponsors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Aggregate_Fields = {
  __typename?: 'hackathon_event_sponsors_aggregate_fields';
  avg?: Maybe<Hackathon_Event_Sponsors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Event_Sponsors_Max_Fields>;
  min?: Maybe<Hackathon_Event_Sponsors_Min_Fields>;
  stddev?: Maybe<Hackathon_Event_Sponsors_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Event_Sponsors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Event_Sponsors_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Event_Sponsors_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Event_Sponsors_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Event_Sponsors_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Event_Sponsors_Variance_Fields>;
};


/** aggregate fields of "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Event_Sponsors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Event_Sponsors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Event_Sponsors_Max_Order_By>;
  min?: InputMaybe<Hackathon_Event_Sponsors_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Event_Sponsors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Event_Sponsors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Event_Sponsors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Event_Sponsors_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Event_Sponsors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Event_Sponsors_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Event_Sponsors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Event_Sponsors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Event_Sponsors_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Event_Sponsors_Avg_Fields = {
  __typename?: 'hackathon_event_sponsors_avg_fields';
  event_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_event_sponsors". All fields are combined with a logical 'AND'. */
export type Hackathon_Event_Sponsors_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Event_Sponsors_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Event_Sponsors_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  sponsor?: InputMaybe<Sponsors_Bool_Exp>;
  sponsor_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_event_sponsors" */
export enum Hackathon_Event_Sponsors_Constraint {
  /** unique or primary key constraint on columns "event_id", "sponsor_id" */
  HackathonEventSponsorsPkey = 'hackathon_event_sponsors_pkey',
  /** unique or primary key constraint on columns "uuid" */
  HackathonEventSponsorsUuidKey = 'hackathon_event_sponsors_uuid_key'
}

/** input type for incrementing numeric columns in table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['Int']>;
  sponsor?: InputMaybe<Sponsors_Obj_Rel_Insert_Input>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Event_Sponsors_Max_Fields = {
  __typename?: 'hackathon_event_sponsors_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Event_Sponsors_Min_Fields = {
  __typename?: 'hackathon_event_sponsors_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Mutation_Response = {
  __typename?: 'hackathon_event_sponsors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Event_Sponsors>;
};

/** on_conflict condition type for table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_On_Conflict = {
  constraint: Hackathon_Event_Sponsors_Constraint;
  update_columns?: Array<Hackathon_Event_Sponsors_Update_Column>;
  where?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_event_sponsors". */
export type Hackathon_Event_Sponsors_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  sponsor?: InputMaybe<Sponsors_Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_event_sponsors */
export type Hackathon_Event_Sponsors_Pk_Columns_Input = {
  event_id: Scalars['Int'];
  sponsor_id: Scalars['Int'];
};

/** select columns of table "hackathon_event_sponsors" */
export enum Hackathon_Event_Sponsors_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Event_Sponsors_Stddev_Fields = {
  __typename?: 'hackathon_event_sponsors_stddev_fields';
  event_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Event_Sponsors_Stddev_Pop_Fields = {
  __typename?: 'hackathon_event_sponsors_stddev_pop_fields';
  event_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Event_Sponsors_Stddev_Samp_Fields = {
  __typename?: 'hackathon_event_sponsors_stddev_samp_fields';
  event_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Event_Sponsors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Event_Sponsors_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Event_Sponsors_Sum_Fields = {
  __typename?: 'hackathon_event_sponsors_sum_fields';
  event_id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_event_sponsors" */
export enum Hackathon_Event_Sponsors_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Event_Sponsors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Event_Sponsors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Event_Sponsors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Event_Sponsors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Event_Sponsors_Var_Pop_Fields = {
  __typename?: 'hackathon_event_sponsors_var_pop_fields';
  event_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Event_Sponsors_Var_Samp_Fields = {
  __typename?: 'hackathon_event_sponsors_var_samp_fields';
  event_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Event_Sponsors_Variance_Fields = {
  __typename?: 'hackathon_event_sponsors_variance_fields';
  event_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_event_sponsors" */
export type Hackathon_Event_Sponsors_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "hackathon_event_type" */
export type Hackathon_Event_Type = {
  __typename?: 'hackathon_event_type';
  name: Scalars['String'];
};

/** aggregated selection of "hackathon_event_type" */
export type Hackathon_Event_Type_Aggregate = {
  __typename?: 'hackathon_event_type_aggregate';
  aggregate?: Maybe<Hackathon_Event_Type_Aggregate_Fields>;
  nodes: Array<Hackathon_Event_Type>;
};

/** aggregate fields of "hackathon_event_type" */
export type Hackathon_Event_Type_Aggregate_Fields = {
  __typename?: 'hackathon_event_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Event_Type_Max_Fields>;
  min?: Maybe<Hackathon_Event_Type_Min_Fields>;
};


/** aggregate fields of "hackathon_event_type" */
export type Hackathon_Event_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Event_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_event_type". All fields are combined with a logical 'AND'. */
export type Hackathon_Event_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Event_Type_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Event_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Event_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_event_type" */
export enum Hackathon_Event_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  HackathonEventTypePkey = 'hackathon_event_type_pkey'
}

export enum Hackathon_Event_Type_Enum {
  Brainstorming = 'Brainstorming',
  Discussion = 'Discussion',
  Judging = 'Judging',
  None = 'None',
  Panel = 'Panel',
  SponsorJudging = 'SponsorJudging',
  Talk = 'Talk',
  Workshop = 'Workshop'
}

/** Boolean expression to compare columns of type "hackathon_event_type_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Event_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Event_Type_Enum>;
  _in?: InputMaybe<Array<Hackathon_Event_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Event_Type_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Event_Type_Enum>>;
};

/** input type for inserting data into table "hackathon_event_type" */
export type Hackathon_Event_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Event_Type_Max_Fields = {
  __typename?: 'hackathon_event_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Event_Type_Min_Fields = {
  __typename?: 'hackathon_event_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_event_type" */
export type Hackathon_Event_Type_Mutation_Response = {
  __typename?: 'hackathon_event_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Event_Type>;
};

/** on_conflict condition type for table "hackathon_event_type" */
export type Hackathon_Event_Type_On_Conflict = {
  constraint: Hackathon_Event_Type_Constraint;
  update_columns?: Array<Hackathon_Event_Type_Update_Column>;
  where?: InputMaybe<Hackathon_Event_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_event_type". */
export type Hackathon_Event_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_event_type */
export type Hackathon_Event_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "hackathon_event_type" */
export enum Hackathon_Event_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "hackathon_event_type" */
export type Hackathon_Event_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_event_type" */
export type Hackathon_Event_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Event_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Event_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_event_type" */
export enum Hackathon_Event_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Hackathon_Event_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Event_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Event_Type_Bool_Exp;
};

/** columns and relationships of "hackathon_events" */
export type Hackathon_Events = {
  __typename?: 'hackathon_events';
  /** A computed to field to get a boolean representing whether a hackathon event is grouped */
  _is_hackathon_event_grouped?: Maybe<Scalars['Boolean']>;
  /** Returns the url of the hackathon event if the user is a root user or if the url_public is set to true */
  _url?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  google_maps_location_url?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  /** An object relationship */
  hackathon_event_group?: Maybe<Hackathon_Event_Groups>;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  location?: Maybe<Scalars['String']>;
  meeting_url?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  speakers: Array<Hackathon_Event_Speakers>;
  /** An aggregate relationship */
  speakers_aggregate: Hackathon_Event_Speakers_Aggregate;
  /** An array relationship */
  sponsors: Array<Hackathon_Event_Sponsors>;
  /** An aggregate relationship */
  sponsors_aggregate: Hackathon_Event_Sponsors_Aggregate;
  starts_at: Scalars['timestamptz'];
  title: Scalars['String'];
  type: Hackathon_Event_Type_Enum;
  updated_at: Scalars['timestamptz'];
  url?: Maybe<Scalars['String']>;
  url_public?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['String'];
};


/** columns and relationships of "hackathon_events" */
export type Hackathon_EventsSpeakersArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Speakers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Speakers_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
};


/** columns and relationships of "hackathon_events" */
export type Hackathon_EventsSpeakers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Speakers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Speakers_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
};


/** columns and relationships of "hackathon_events" */
export type Hackathon_EventsSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Sponsors_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
};


/** columns and relationships of "hackathon_events" */
export type Hackathon_EventsSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Sponsors_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
};

/** aggregated selection of "hackathon_events" */
export type Hackathon_Events_Aggregate = {
  __typename?: 'hackathon_events_aggregate';
  aggregate?: Maybe<Hackathon_Events_Aggregate_Fields>;
  nodes: Array<Hackathon_Events>;
};

export type Hackathon_Events_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Hackathon_Events_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Hackathon_Events_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Hackathon_Events_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Events_Aggregate_Bool_Exp_Bool_And = {
  arguments: Hackathon_Events_Select_Column_Hackathon_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Hackathon_Events_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Hackathon_Events_Select_Column_Hackathon_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Hackathon_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_events" */
export type Hackathon_Events_Aggregate_Fields = {
  __typename?: 'hackathon_events_aggregate_fields';
  avg?: Maybe<Hackathon_Events_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Events_Max_Fields>;
  min?: Maybe<Hackathon_Events_Min_Fields>;
  stddev?: Maybe<Hackathon_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Events_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Events_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Events_Variance_Fields>;
};


/** aggregate fields of "hackathon_events" */
export type Hackathon_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_events" */
export type Hackathon_Events_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Events_Max_Order_By>;
  min?: InputMaybe<Hackathon_Events_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Events_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Events_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_events" */
export type Hackathon_Events_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Events_Avg_Fields = {
  __typename?: 'hackathon_events_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_events" */
export type Hackathon_Events_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_events". All fields are combined with a logical 'AND'. */
export type Hackathon_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Events_Bool_Exp>>;
  _is_hackathon_event_grouped?: InputMaybe<Boolean_Comparison_Exp>;
  _not?: InputMaybe<Hackathon_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Events_Bool_Exp>>;
  _url?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  ends_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  google_maps_location_url?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_event_group?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  meeting_url?: InputMaybe<String_Comparison_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
  speakers?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
  speakers_aggregate?: InputMaybe<Hackathon_Event_Speakers_Aggregate_Bool_Exp>;
  sponsors?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
  sponsors_aggregate?: InputMaybe<Hackathon_Event_Sponsors_Aggregate_Bool_Exp>;
  starts_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Hackathon_Event_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  url_public?: InputMaybe<Boolean_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_events" */
export enum Hackathon_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  HackathonEventsPkey = 'hackathon_events_pkey',
  /** unique or primary key constraint on columns "uuid" */
  HackathonEventsUuidKey = 'hackathon_events_uuid_key'
}

/** input type for incrementing numeric columns in table "hackathon_events" */
export type Hackathon_Events_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_events" */
export type Hackathon_Events_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  google_maps_location_url?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_event_group?: InputMaybe<Hackathon_Event_Groups_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  meeting_url?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  speakers?: InputMaybe<Hackathon_Event_Speakers_Arr_Rel_Insert_Input>;
  sponsors?: InputMaybe<Hackathon_Event_Sponsors_Arr_Rel_Insert_Input>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Event_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  url_public?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Events_Max_Fields = {
  __typename?: 'hackathon_events_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  google_maps_location_url?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  meeting_url?: Maybe<Scalars['String']>;
  starts_at?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathon_events" */
export type Hackathon_Events_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  google_maps_location_url?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  meeting_url?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Events_Min_Fields = {
  __typename?: 'hackathon_events_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  google_maps_location_url?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  meeting_url?: Maybe<Scalars['String']>;
  starts_at?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathon_events" */
export type Hackathon_Events_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  google_maps_location_url?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  meeting_url?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_events" */
export type Hackathon_Events_Mutation_Response = {
  __typename?: 'hackathon_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Events>;
};

/** on_conflict condition type for table "hackathon_events" */
export type Hackathon_Events_On_Conflict = {
  constraint: Hackathon_Events_Constraint;
  update_columns?: Array<Hackathon_Events_Update_Column>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_events". */
export type Hackathon_Events_Order_By = {
  _is_hackathon_event_grouped?: InputMaybe<Order_By>;
  _url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  google_maps_location_url?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_event_group?: InputMaybe<Hackathon_Event_Groups_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  meeting_url?: InputMaybe<Order_By>;
  public?: InputMaybe<Order_By>;
  speakers_aggregate?: InputMaybe<Hackathon_Event_Speakers_Aggregate_Order_By>;
  sponsors_aggregate?: InputMaybe<Hackathon_Event_Sponsors_Aggregate_Order_By>;
  starts_at?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  url_public?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_events */
export type Hackathon_Events_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_events" */
export enum Hackathon_Events_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  GoogleMapsLocationUrl = 'google_maps_location_url',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  MeetingUrl = 'meeting_url',
  /** column name */
  Public = 'public',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UrlPublic = 'url_public',
  /** column name */
  Uuid = 'uuid'
}

/** select "hackathon_events_aggregate_bool_exp_bool_and_arguments_columns" columns of table "hackathon_events" */
export enum Hackathon_Events_Select_Column_Hackathon_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Public = 'public',
  /** column name */
  UrlPublic = 'url_public'
}

/** select "hackathon_events_aggregate_bool_exp_bool_or_arguments_columns" columns of table "hackathon_events" */
export enum Hackathon_Events_Select_Column_Hackathon_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Public = 'public',
  /** column name */
  UrlPublic = 'url_public'
}

/** input type for updating data in table "hackathon_events" */
export type Hackathon_Events_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  google_maps_location_url?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  meeting_url?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Event_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  url_public?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Events_Stddev_Fields = {
  __typename?: 'hackathon_events_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_events" */
export type Hackathon_Events_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Events_Stddev_Pop_Fields = {
  __typename?: 'hackathon_events_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_events" */
export type Hackathon_Events_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Events_Stddev_Samp_Fields = {
  __typename?: 'hackathon_events_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_events" */
export type Hackathon_Events_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_events" */
export type Hackathon_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Events_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  google_maps_location_url?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  meeting_url?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Event_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  url_public?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Events_Sum_Fields = {
  __typename?: 'hackathon_events_sum_fields';
  group_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_events" */
export type Hackathon_Events_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_events" */
export enum Hackathon_Events_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  GoogleMapsLocationUrl = 'google_maps_location_url',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  MeetingUrl = 'meeting_url',
  /** column name */
  Public = 'public',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UrlPublic = 'url_public',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Events_Var_Pop_Fields = {
  __typename?: 'hackathon_events_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_events" */
export type Hackathon_Events_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Events_Var_Samp_Fields = {
  __typename?: 'hackathon_events_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_events" */
export type Hackathon_Events_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Events_Variance_Fields = {
  __typename?: 'hackathon_events_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_events" */
export type Hackathon_Events_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "hackathon_faq" */
export type Hackathon_Faq = {
  __typename?: 'hackathon_faq';
  answer: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  order?: Maybe<Scalars['Int']>;
  question: Scalars['String'];
  type: Hackathon_Faq_Type_Enum;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "hackathon_faq" */
export type Hackathon_Faq_Aggregate = {
  __typename?: 'hackathon_faq_aggregate';
  aggregate?: Maybe<Hackathon_Faq_Aggregate_Fields>;
  nodes: Array<Hackathon_Faq>;
};

export type Hackathon_Faq_Aggregate_Bool_Exp = {
  count?: InputMaybe<Hackathon_Faq_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Faq_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Faq_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Faq_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_faq" */
export type Hackathon_Faq_Aggregate_Fields = {
  __typename?: 'hackathon_faq_aggregate_fields';
  avg?: Maybe<Hackathon_Faq_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Faq_Max_Fields>;
  min?: Maybe<Hackathon_Faq_Min_Fields>;
  stddev?: Maybe<Hackathon_Faq_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Faq_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Faq_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Faq_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Faq_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Faq_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Faq_Variance_Fields>;
};


/** aggregate fields of "hackathon_faq" */
export type Hackathon_Faq_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Faq_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_faq" */
export type Hackathon_Faq_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Faq_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Faq_Max_Order_By>;
  min?: InputMaybe<Hackathon_Faq_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Faq_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Faq_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Faq_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Faq_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Faq_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Faq_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Faq_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_faq" */
export type Hackathon_Faq_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Faq_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Faq_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Faq_Avg_Fields = {
  __typename?: 'hackathon_faq_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_faq". All fields are combined with a logical 'AND'. */
export type Hackathon_Faq_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Faq_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Faq_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Faq_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Hackathon_Faq_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_faq" */
export enum Hackathon_Faq_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkHackathonFaq = 'pk_hackathon_faq',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHackathonFaq = 'unique_uuid_hackathon_faq'
}

/** input type for incrementing numeric columns in table "hackathon_faq" */
export type Hackathon_Faq_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_faq" */
export type Hackathon_Faq_Insert_Input = {
  answer?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Faq_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Faq_Max_Fields = {
  __typename?: 'hackathon_faq_max_fields';
  answer?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Faq_Min_Fields = {
  __typename?: 'hackathon_faq_min_fields';
  answer?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_faq" */
export type Hackathon_Faq_Mutation_Response = {
  __typename?: 'hackathon_faq_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Faq>;
};

/** on_conflict condition type for table "hackathon_faq" */
export type Hackathon_Faq_On_Conflict = {
  constraint: Hackathon_Faq_Constraint;
  update_columns?: Array<Hackathon_Faq_Update_Column>;
  where?: InputMaybe<Hackathon_Faq_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_faq". */
export type Hackathon_Faq_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_faq */
export type Hackathon_Faq_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_faq" */
export enum Hackathon_Faq_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  Question = 'question',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_faq" */
export type Hackathon_Faq_Set_Input = {
  answer?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Faq_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Faq_Stddev_Fields = {
  __typename?: 'hackathon_faq_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Faq_Stddev_Pop_Fields = {
  __typename?: 'hackathon_faq_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Faq_Stddev_Samp_Fields = {
  __typename?: 'hackathon_faq_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_faq" */
export type Hackathon_Faq_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Faq_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Faq_Stream_Cursor_Value_Input = {
  answer?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Faq_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Faq_Sum_Fields = {
  __typename?: 'hackathon_faq_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "hackathon_faq_type" */
export type Hackathon_Faq_Type = {
  __typename?: 'hackathon_faq_type';
  value: Scalars['String'];
};

/** aggregated selection of "hackathon_faq_type" */
export type Hackathon_Faq_Type_Aggregate = {
  __typename?: 'hackathon_faq_type_aggregate';
  aggregate?: Maybe<Hackathon_Faq_Type_Aggregate_Fields>;
  nodes: Array<Hackathon_Faq_Type>;
};

/** aggregate fields of "hackathon_faq_type" */
export type Hackathon_Faq_Type_Aggregate_Fields = {
  __typename?: 'hackathon_faq_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Faq_Type_Max_Fields>;
  min?: Maybe<Hackathon_Faq_Type_Min_Fields>;
};


/** aggregate fields of "hackathon_faq_type" */
export type Hackathon_Faq_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Faq_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_faq_type". All fields are combined with a logical 'AND'. */
export type Hackathon_Faq_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Faq_Type_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Faq_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Faq_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_faq_type" */
export enum Hackathon_Faq_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  HackathonFaqTypePkey = 'hackathon_faq_type_pkey'
}

export enum Hackathon_Faq_Type_Enum {
  General = 'GENERAL',
  Judging = 'JUDGING',
  SponsorJudging = 'SPONSOR_JUDGING'
}

/** Boolean expression to compare columns of type "hackathon_faq_type_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Faq_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Faq_Type_Enum>;
  _in?: InputMaybe<Array<Hackathon_Faq_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Faq_Type_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Faq_Type_Enum>>;
};

/** input type for inserting data into table "hackathon_faq_type" */
export type Hackathon_Faq_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Faq_Type_Max_Fields = {
  __typename?: 'hackathon_faq_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Faq_Type_Min_Fields = {
  __typename?: 'hackathon_faq_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_faq_type" */
export type Hackathon_Faq_Type_Mutation_Response = {
  __typename?: 'hackathon_faq_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Faq_Type>;
};

/** on_conflict condition type for table "hackathon_faq_type" */
export type Hackathon_Faq_Type_On_Conflict = {
  constraint: Hackathon_Faq_Type_Constraint;
  update_columns?: Array<Hackathon_Faq_Type_Update_Column>;
  where?: InputMaybe<Hackathon_Faq_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_faq_type". */
export type Hackathon_Faq_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_faq_type */
export type Hackathon_Faq_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "hackathon_faq_type" */
export enum Hackathon_Faq_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_faq_type" */
export type Hackathon_Faq_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_faq_type" */
export type Hackathon_Faq_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Faq_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Faq_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_faq_type" */
export enum Hackathon_Faq_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Hackathon_Faq_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Faq_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Faq_Type_Bool_Exp;
};

/** update columns of table "hackathon_faq" */
export enum Hackathon_Faq_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  Question = 'question',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Faq_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Faq_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Faq_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Faq_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Faq_Var_Pop_Fields = {
  __typename?: 'hackathon_faq_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Faq_Var_Samp_Fields = {
  __typename?: 'hackathon_faq_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Faq_Variance_Fields = {
  __typename?: 'hackathon_faq_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_faq" */
export type Hackathon_Faq_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "hackathon_hashtags" */
export type Hackathon_Hashtags = {
  __typename?: 'hackathon_hashtags';
  created_at: Scalars['timestamptz'];
  hackathon_id: Scalars['Int'];
  hashtag_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "hackathon_hashtags" */
export type Hackathon_Hashtags_Aggregate = {
  __typename?: 'hackathon_hashtags_aggregate';
  aggregate?: Maybe<Hackathon_Hashtags_Aggregate_Fields>;
  nodes: Array<Hackathon_Hashtags>;
};

/** aggregate fields of "hackathon_hashtags" */
export type Hackathon_Hashtags_Aggregate_Fields = {
  __typename?: 'hackathon_hashtags_aggregate_fields';
  avg?: Maybe<Hackathon_Hashtags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Hashtags_Max_Fields>;
  min?: Maybe<Hackathon_Hashtags_Min_Fields>;
  stddev?: Maybe<Hackathon_Hashtags_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Hashtags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Hashtags_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Hashtags_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Hashtags_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Hashtags_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Hashtags_Variance_Fields>;
};


/** aggregate fields of "hackathon_hashtags" */
export type Hackathon_Hashtags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Hashtags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Hackathon_Hashtags_Avg_Fields = {
  __typename?: 'hackathon_hashtags_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hashtag_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hackathon_hashtags". All fields are combined with a logical 'AND'. */
export type Hackathon_Hashtags_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Hashtags_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Hashtags_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Hashtags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  hashtag_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_hashtags" */
export enum Hackathon_Hashtags_Constraint {
  /** unique or primary key constraint on columns "hashtag_id", "hackathon_id" */
  PkHackathonHashtags = 'pk_hackathon_hashtags',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHackathonHashtags = 'unique_uuid_hackathon_hashtags'
}

/** input type for incrementing numeric columns in table "hackathon_hashtags" */
export type Hackathon_Hashtags_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hashtag_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_hashtags" */
export type Hackathon_Hashtags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hashtag_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Hashtags_Max_Fields = {
  __typename?: 'hackathon_hashtags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hashtag_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Hashtags_Min_Fields = {
  __typename?: 'hackathon_hashtags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hashtag_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_hashtags" */
export type Hackathon_Hashtags_Mutation_Response = {
  __typename?: 'hackathon_hashtags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Hashtags>;
};

/** on_conflict condition type for table "hackathon_hashtags" */
export type Hackathon_Hashtags_On_Conflict = {
  constraint: Hackathon_Hashtags_Constraint;
  update_columns?: Array<Hackathon_Hashtags_Update_Column>;
  where?: InputMaybe<Hackathon_Hashtags_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_hashtags". */
export type Hackathon_Hashtags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hashtag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_hashtags */
export type Hackathon_Hashtags_Pk_Columns_Input = {
  hackathon_id: Scalars['Int'];
  hashtag_id: Scalars['Int'];
};

/** select columns of table "hackathon_hashtags" */
export enum Hackathon_Hashtags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HashtagId = 'hashtag_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_hashtags" */
export type Hackathon_Hashtags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hashtag_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Hashtags_Stddev_Fields = {
  __typename?: 'hackathon_hashtags_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hashtag_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Hashtags_Stddev_Pop_Fields = {
  __typename?: 'hackathon_hashtags_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hashtag_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Hashtags_Stddev_Samp_Fields = {
  __typename?: 'hackathon_hashtags_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hashtag_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hackathon_hashtags" */
export type Hackathon_Hashtags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Hashtags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Hashtags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hashtag_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Hashtags_Sum_Fields = {
  __typename?: 'hackathon_hashtags_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  hashtag_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "hackathon_hashtags" */
export enum Hackathon_Hashtags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HashtagId = 'hashtag_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Hashtags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Hashtags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Hashtags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Hashtags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Hashtags_Var_Pop_Fields = {
  __typename?: 'hackathon_hashtags_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hashtag_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hackathon_Hashtags_Var_Samp_Fields = {
  __typename?: 'hackathon_hashtags_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hashtag_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hackathon_Hashtags_Variance_Fields = {
  __typename?: 'hackathon_hashtags_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hashtag_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "hackathon_hosts" */
export type Hackathon_Hosts = {
  __typename?: 'hackathon_hosts';
  college_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  type: Scalars['hackathon_hosts_type_enum'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "hackathon_hosts" */
export type Hackathon_Hosts_Aggregate = {
  __typename?: 'hackathon_hosts_aggregate';
  aggregate?: Maybe<Hackathon_Hosts_Aggregate_Fields>;
  nodes: Array<Hackathon_Hosts>;
};

/** aggregate fields of "hackathon_hosts" */
export type Hackathon_Hosts_Aggregate_Fields = {
  __typename?: 'hackathon_hosts_aggregate_fields';
  avg?: Maybe<Hackathon_Hosts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Hosts_Max_Fields>;
  min?: Maybe<Hackathon_Hosts_Min_Fields>;
  stddev?: Maybe<Hackathon_Hosts_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Hosts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Hosts_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Hosts_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Hosts_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Hosts_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Hosts_Variance_Fields>;
};


/** aggregate fields of "hackathon_hosts" */
export type Hackathon_Hosts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Hosts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Hackathon_Hosts_Avg_Fields = {
  __typename?: 'hackathon_hosts_avg_fields';
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hackathon_hosts". All fields are combined with a logical 'AND'. */
export type Hackathon_Hosts_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Hosts_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Hosts_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Hosts_Bool_Exp>>;
  college_id?: InputMaybe<Int_Comparison_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Hackathon_Hosts_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_hosts" */
export enum Hackathon_Hosts_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkHackathonHosts = 'pk_hackathon_hosts',
  /** unique or primary key constraint on columns "hackathon_id" */
  UniqueHackathonIdHackathonHosts = 'unique_hackathon_id_hackathon_hosts',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHackathonHosts = 'unique_uuid_hackathon_hosts'
}

/** input type for incrementing numeric columns in table "hackathon_hosts" */
export type Hackathon_Hosts_Inc_Input = {
  college_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_hosts" */
export type Hackathon_Hosts_Insert_Input = {
  college_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['hackathon_hosts_type_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Hosts_Max_Fields = {
  __typename?: 'hackathon_hosts_max_fields';
  college_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['hackathon_hosts_type_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Hosts_Min_Fields = {
  __typename?: 'hackathon_hosts_min_fields';
  college_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['hackathon_hosts_type_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_hosts" */
export type Hackathon_Hosts_Mutation_Response = {
  __typename?: 'hackathon_hosts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Hosts>;
};

/** on_conflict condition type for table "hackathon_hosts" */
export type Hackathon_Hosts_On_Conflict = {
  constraint: Hackathon_Hosts_Constraint;
  update_columns?: Array<Hackathon_Hosts_Update_Column>;
  where?: InputMaybe<Hackathon_Hosts_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_hosts". */
export type Hackathon_Hosts_Order_By = {
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_hosts */
export type Hackathon_Hosts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_hosts" */
export enum Hackathon_Hosts_Select_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_hosts" */
export type Hackathon_Hosts_Set_Input = {
  college_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['hackathon_hosts_type_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Hosts_Stddev_Fields = {
  __typename?: 'hackathon_hosts_stddev_fields';
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Hosts_Stddev_Pop_Fields = {
  __typename?: 'hackathon_hosts_stddev_pop_fields';
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Hosts_Stddev_Samp_Fields = {
  __typename?: 'hackathon_hosts_stddev_samp_fields';
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hackathon_hosts" */
export type Hackathon_Hosts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Hosts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Hosts_Stream_Cursor_Value_Input = {
  college_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['hackathon_hosts_type_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Hosts_Sum_Fields = {
  __typename?: 'hackathon_hosts_sum_fields';
  college_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "hackathon_hosts_type_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Hosts_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['hackathon_hosts_type_enum']>;
  _gt?: InputMaybe<Scalars['hackathon_hosts_type_enum']>;
  _gte?: InputMaybe<Scalars['hackathon_hosts_type_enum']>;
  _in?: InputMaybe<Array<Scalars['hackathon_hosts_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['hackathon_hosts_type_enum']>;
  _lte?: InputMaybe<Scalars['hackathon_hosts_type_enum']>;
  _neq?: InputMaybe<Scalars['hackathon_hosts_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['hackathon_hosts_type_enum']>>;
};

/** update columns of table "hackathon_hosts" */
export enum Hackathon_Hosts_Update_Column {
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Hosts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Hosts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Hosts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Hosts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Hosts_Var_Pop_Fields = {
  __typename?: 'hackathon_hosts_var_pop_fields';
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hackathon_Hosts_Var_Samp_Fields = {
  __typename?: 'hackathon_hosts_var_samp_fields';
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hackathon_Hosts_Variance_Fields = {
  __typename?: 'hackathon_hosts_variance_fields';
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** This table is used as an enum table to store the types of a hackathon_note */
export type Hackathon_Note_Type = {
  __typename?: 'hackathon_note_type';
  value: Scalars['String'];
};

/** aggregated selection of "hackathon_note_type" */
export type Hackathon_Note_Type_Aggregate = {
  __typename?: 'hackathon_note_type_aggregate';
  aggregate?: Maybe<Hackathon_Note_Type_Aggregate_Fields>;
  nodes: Array<Hackathon_Note_Type>;
};

/** aggregate fields of "hackathon_note_type" */
export type Hackathon_Note_Type_Aggregate_Fields = {
  __typename?: 'hackathon_note_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Note_Type_Max_Fields>;
  min?: Maybe<Hackathon_Note_Type_Min_Fields>;
};


/** aggregate fields of "hackathon_note_type" */
export type Hackathon_Note_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Note_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_note_type". All fields are combined with a logical 'AND'. */
export type Hackathon_Note_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Note_Type_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Note_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Note_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_note_type" */
export enum Hackathon_Note_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  HackathonNoteTypePkey = 'hackathon_note_type_pkey'
}

export enum Hackathon_Note_Type_Enum {
  Applications = 'APPLICATIONS',
  Reviews = 'REVIEWS',
  Submissions = 'SUBMISSIONS'
}

/** Boolean expression to compare columns of type "hackathon_note_type_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Note_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Note_Type_Enum>;
  _in?: InputMaybe<Array<Hackathon_Note_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Note_Type_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Note_Type_Enum>>;
};

/** input type for inserting data into table "hackathon_note_type" */
export type Hackathon_Note_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Note_Type_Max_Fields = {
  __typename?: 'hackathon_note_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Note_Type_Min_Fields = {
  __typename?: 'hackathon_note_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_note_type" */
export type Hackathon_Note_Type_Mutation_Response = {
  __typename?: 'hackathon_note_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Note_Type>;
};

/** on_conflict condition type for table "hackathon_note_type" */
export type Hackathon_Note_Type_On_Conflict = {
  constraint: Hackathon_Note_Type_Constraint;
  update_columns?: Array<Hackathon_Note_Type_Update_Column>;
  where?: InputMaybe<Hackathon_Note_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_note_type". */
export type Hackathon_Note_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_note_type */
export type Hackathon_Note_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "hackathon_note_type" */
export enum Hackathon_Note_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_note_type" */
export type Hackathon_Note_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_note_type" */
export type Hackathon_Note_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Note_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Note_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_note_type" */
export enum Hackathon_Note_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Hackathon_Note_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Note_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Note_Type_Bool_Exp;
};

/** columns and relationships of "hackathon_notes" */
export type Hackathon_Notes = {
  __typename?: 'hackathon_notes';
  created_at: Scalars['timestamptz'];
  date: Scalars['date'];
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  note: Scalars['String'];
  type: Hackathon_Note_Type_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};

/** aggregated selection of "hackathon_notes" */
export type Hackathon_Notes_Aggregate = {
  __typename?: 'hackathon_notes_aggregate';
  aggregate?: Maybe<Hackathon_Notes_Aggregate_Fields>;
  nodes: Array<Hackathon_Notes>;
};

export type Hackathon_Notes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Hackathon_Notes_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Notes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Notes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_notes" */
export type Hackathon_Notes_Aggregate_Fields = {
  __typename?: 'hackathon_notes_aggregate_fields';
  avg?: Maybe<Hackathon_Notes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Notes_Max_Fields>;
  min?: Maybe<Hackathon_Notes_Min_Fields>;
  stddev?: Maybe<Hackathon_Notes_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Notes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Notes_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Notes_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Notes_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Notes_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Notes_Variance_Fields>;
};


/** aggregate fields of "hackathon_notes" */
export type Hackathon_Notes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_notes" */
export type Hackathon_Notes_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Notes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Notes_Max_Order_By>;
  min?: InputMaybe<Hackathon_Notes_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Notes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Notes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Notes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Notes_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Notes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Notes_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Notes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_notes" */
export type Hackathon_Notes_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Notes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Notes_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Notes_Avg_Fields = {
  __typename?: 'hackathon_notes_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_notes". All fields are combined with a logical 'AND'. */
export type Hackathon_Notes_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Notes_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Notes_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Notes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Hackathon_Note_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_notes" */
export enum Hackathon_Notes_Constraint {
  /** unique or primary key constraint on columns "id" */
  HackathonNotesPkey = 'hackathon_notes_pkey',
  /** unique or primary key constraint on columns "uuid" */
  HackathonNotesUuidKey = 'hackathon_notes_uuid_key'
}

/** input type for incrementing numeric columns in table "hackathon_notes" */
export type Hackathon_Notes_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_notes" */
export type Hackathon_Notes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Note_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Notes_Max_Fields = {
  __typename?: 'hackathon_notes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Notes_Min_Fields = {
  __typename?: 'hackathon_notes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_notes" */
export type Hackathon_Notes_Mutation_Response = {
  __typename?: 'hackathon_notes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Notes>;
};

/** on_conflict condition type for table "hackathon_notes" */
export type Hackathon_Notes_On_Conflict = {
  constraint: Hackathon_Notes_Constraint;
  update_columns?: Array<Hackathon_Notes_Update_Column>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_notes". */
export type Hackathon_Notes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_notes */
export type Hackathon_Notes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_notes" */
export enum Hackathon_Notes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_notes" */
export type Hackathon_Notes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Note_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Notes_Stddev_Fields = {
  __typename?: 'hackathon_notes_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Notes_Stddev_Pop_Fields = {
  __typename?: 'hackathon_notes_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Notes_Stddev_Samp_Fields = {
  __typename?: 'hackathon_notes_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_notes" */
export type Hackathon_Notes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Notes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Notes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Note_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Notes_Sum_Fields = {
  __typename?: 'hackathon_notes_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_notes" */
export enum Hackathon_Notes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Notes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Notes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Notes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Notes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Notes_Var_Pop_Fields = {
  __typename?: 'hackathon_notes_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Notes_Var_Samp_Fields = {
  __typename?: 'hackathon_notes_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Notes_Variance_Fields = {
  __typename?: 'hackathon_notes_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_notes" */
export type Hackathon_Notes_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** This table contains the emails of the users/organizers to whom the schwag shipment form is sent */
export type Hackathon_Schwags = {
  __typename?: 'hackathon_schwags';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** This field describe if the schwag shipment forms are sent by the organizers */
  email_sent?: Maybe<Scalars['Boolean']>;
  /** This field enables the schwag shipment functionality for a hackathon, this field is added to disable the functionality for old hackathons to whom the schwag is already shipped */
  enable?: Maybe<Scalars['Boolean']>;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  /** Array of emails of the organizing team members */
  organizers_email?: Maybe<Scalars['jsonb']>;
  /** Array of emails of the winning team members of the hackathon */
  participants_email?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid: Scalars['String'];
  /** Array of object containing the winning team and project details */
  winners?: Maybe<Scalars['jsonb']>;
};


/** This table contains the emails of the users/organizers to whom the schwag shipment form is sent */
export type Hackathon_SchwagsOrganizers_EmailArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table contains the emails of the users/organizers to whom the schwag shipment form is sent */
export type Hackathon_SchwagsParticipants_EmailArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table contains the emails of the users/organizers to whom the schwag shipment form is sent */
export type Hackathon_SchwagsWinnersArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "hackathon_schwags" */
export type Hackathon_Schwags_Aggregate = {
  __typename?: 'hackathon_schwags_aggregate';
  aggregate?: Maybe<Hackathon_Schwags_Aggregate_Fields>;
  nodes: Array<Hackathon_Schwags>;
};

/** aggregate fields of "hackathon_schwags" */
export type Hackathon_Schwags_Aggregate_Fields = {
  __typename?: 'hackathon_schwags_aggregate_fields';
  avg?: Maybe<Hackathon_Schwags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Schwags_Max_Fields>;
  min?: Maybe<Hackathon_Schwags_Min_Fields>;
  stddev?: Maybe<Hackathon_Schwags_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Schwags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Schwags_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Schwags_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Schwags_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Schwags_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Schwags_Variance_Fields>;
};


/** aggregate fields of "hackathon_schwags" */
export type Hackathon_Schwags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Schwags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Hackathon_Schwags_Append_Input = {
  /** Array of emails of the organizing team members */
  organizers_email?: InputMaybe<Scalars['jsonb']>;
  /** Array of emails of the winning team members of the hackathon */
  participants_email?: InputMaybe<Scalars['jsonb']>;
  /** Array of object containing the winning team and project details */
  winners?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Hackathon_Schwags_Avg_Fields = {
  __typename?: 'hackathon_schwags_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hackathon_schwags". All fields are combined with a logical 'AND'. */
export type Hackathon_Schwags_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Schwags_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Schwags_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Schwags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_sent?: InputMaybe<Boolean_Comparison_Exp>;
  enable?: InputMaybe<Boolean_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organizers_email?: InputMaybe<Jsonb_Comparison_Exp>;
  participants_email?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  winners?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_schwags" */
export enum Hackathon_Schwags_Constraint {
  /** unique or primary key constraint on columns "hackathon_id" */
  HackathonSchwagsHackathonIdUindex = 'hackathon_schwags_hackathon_id_uindex',
  /** unique or primary key constraint on columns "id" */
  HackathonSchwagsPk = 'hackathon_schwags_pk',
  /** unique or primary key constraint on columns "uuid" */
  HackathonSchwagsUuidKey = 'hackathon_schwags_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Hackathon_Schwags_Delete_At_Path_Input = {
  /** Array of emails of the organizing team members */
  organizers_email?: InputMaybe<Array<Scalars['String']>>;
  /** Array of emails of the winning team members of the hackathon */
  participants_email?: InputMaybe<Array<Scalars['String']>>;
  /** Array of object containing the winning team and project details */
  winners?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Hackathon_Schwags_Delete_Elem_Input = {
  /** Array of emails of the organizing team members */
  organizers_email?: InputMaybe<Scalars['Int']>;
  /** Array of emails of the winning team members of the hackathon */
  participants_email?: InputMaybe<Scalars['Int']>;
  /** Array of object containing the winning team and project details */
  winners?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Hackathon_Schwags_Delete_Key_Input = {
  /** Array of emails of the organizing team members */
  organizers_email?: InputMaybe<Scalars['String']>;
  /** Array of emails of the winning team members of the hackathon */
  participants_email?: InputMaybe<Scalars['String']>;
  /** Array of object containing the winning team and project details */
  winners?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "hackathon_schwags" */
export type Hackathon_Schwags_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_schwags" */
export type Hackathon_Schwags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** This field describe if the schwag shipment forms are sent by the organizers */
  email_sent?: InputMaybe<Scalars['Boolean']>;
  /** This field enables the schwag shipment functionality for a hackathon, this field is added to disable the functionality for old hackathons to whom the schwag is already shipped */
  enable?: InputMaybe<Scalars['Boolean']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** Array of emails of the organizing team members */
  organizers_email?: InputMaybe<Scalars['jsonb']>;
  /** Array of emails of the winning team members of the hackathon */
  participants_email?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  /** Array of object containing the winning team and project details */
  winners?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Hackathon_Schwags_Max_Fields = {
  __typename?: 'hackathon_schwags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Schwags_Min_Fields = {
  __typename?: 'hackathon_schwags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_schwags" */
export type Hackathon_Schwags_Mutation_Response = {
  __typename?: 'hackathon_schwags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Schwags>;
};

/** input type for inserting object relation for remote table "hackathon_schwags" */
export type Hackathon_Schwags_Obj_Rel_Insert_Input = {
  data: Hackathon_Schwags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Schwags_On_Conflict>;
};

/** on_conflict condition type for table "hackathon_schwags" */
export type Hackathon_Schwags_On_Conflict = {
  constraint: Hackathon_Schwags_Constraint;
  update_columns?: Array<Hackathon_Schwags_Update_Column>;
  where?: InputMaybe<Hackathon_Schwags_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_schwags". */
export type Hackathon_Schwags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_sent?: InputMaybe<Order_By>;
  enable?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizers_email?: InputMaybe<Order_By>;
  participants_email?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  winners?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_schwags */
export type Hackathon_Schwags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Hackathon_Schwags_Prepend_Input = {
  /** Array of emails of the organizing team members */
  organizers_email?: InputMaybe<Scalars['jsonb']>;
  /** Array of emails of the winning team members of the hackathon */
  participants_email?: InputMaybe<Scalars['jsonb']>;
  /** Array of object containing the winning team and project details */
  winners?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "hackathon_schwags" */
export enum Hackathon_Schwags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSent = 'email_sent',
  /** column name */
  Enable = 'enable',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizersEmail = 'organizers_email',
  /** column name */
  ParticipantsEmail = 'participants_email',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Winners = 'winners'
}

/** input type for updating data in table "hackathon_schwags" */
export type Hackathon_Schwags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** This field describe if the schwag shipment forms are sent by the organizers */
  email_sent?: InputMaybe<Scalars['Boolean']>;
  /** This field enables the schwag shipment functionality for a hackathon, this field is added to disable the functionality for old hackathons to whom the schwag is already shipped */
  enable?: InputMaybe<Scalars['Boolean']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** Array of emails of the organizing team members */
  organizers_email?: InputMaybe<Scalars['jsonb']>;
  /** Array of emails of the winning team members of the hackathon */
  participants_email?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  /** Array of object containing the winning team and project details */
  winners?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Hackathon_Schwags_Stddev_Fields = {
  __typename?: 'hackathon_schwags_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Schwags_Stddev_Pop_Fields = {
  __typename?: 'hackathon_schwags_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Schwags_Stddev_Samp_Fields = {
  __typename?: 'hackathon_schwags_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hackathon_schwags" */
export type Hackathon_Schwags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Schwags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Schwags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** This field describe if the schwag shipment forms are sent by the organizers */
  email_sent?: InputMaybe<Scalars['Boolean']>;
  /** This field enables the schwag shipment functionality for a hackathon, this field is added to disable the functionality for old hackathons to whom the schwag is already shipped */
  enable?: InputMaybe<Scalars['Boolean']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** Array of emails of the organizing team members */
  organizers_email?: InputMaybe<Scalars['jsonb']>;
  /** Array of emails of the winning team members of the hackathon */
  participants_email?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  /** Array of object containing the winning team and project details */
  winners?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Hackathon_Schwags_Sum_Fields = {
  __typename?: 'hackathon_schwags_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "hackathon_schwags" */
export enum Hackathon_Schwags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSent = 'email_sent',
  /** column name */
  Enable = 'enable',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizersEmail = 'organizers_email',
  /** column name */
  ParticipantsEmail = 'participants_email',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Winners = 'winners'
}

export type Hackathon_Schwags_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Hackathon_Schwags_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Hackathon_Schwags_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Hackathon_Schwags_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Hackathon_Schwags_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Schwags_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Hackathon_Schwags_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Schwags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Schwags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Schwags_Var_Pop_Fields = {
  __typename?: 'hackathon_schwags_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hackathon_Schwags_Var_Samp_Fields = {
  __typename?: 'hackathon_schwags_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hackathon_Schwags_Variance_Fields = {
  __typename?: 'hackathon_schwags_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "hackathon_scope_extras" */
export type Hackathon_Scope_Extras = {
  __typename?: 'hackathon_scope_extras';
  at_app_status?: Maybe<Scalars['hse_at_app_status_enum']>;
  created_at: Scalars['timestamptz'];
  desc?: Maybe<Scalars['String']>;
  file_type?: Maybe<Scalars['hse_file_type_enum']>;
  file_types: Scalars['_text'];
  hackathon_id: Scalars['Int'];
  hint?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['hse_role_enum']>;
  section?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['hse_type_enum']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user_hackathon_scope_extra?: Maybe<User_Hackathon_Extras>;
  /** An array relationship */
  user_hackathons: Array<User_Hackathons>;
  /** An aggregate relationship */
  user_hackathons_aggregate: User_Hackathons_Aggregate;
  uuid: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "hackathon_scope_extras" */
export type Hackathon_Scope_ExtrasUser_HackathonsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


/** columns and relationships of "hackathon_scope_extras" */
export type Hackathon_Scope_ExtrasUser_Hackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};

/** aggregated selection of "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Aggregate = {
  __typename?: 'hackathon_scope_extras_aggregate';
  aggregate?: Maybe<Hackathon_Scope_Extras_Aggregate_Fields>;
  nodes: Array<Hackathon_Scope_Extras>;
};

export type Hackathon_Scope_Extras_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Hackathon_Scope_Extras_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Hackathon_Scope_Extras_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Hackathon_Scope_Extras_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Scope_Extras_Aggregate_Bool_Exp_Bool_And = {
  arguments: Hackathon_Scope_Extras_Select_Column_Hackathon_Scope_Extras_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Hackathon_Scope_Extras_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Hackathon_Scope_Extras_Select_Column_Hackathon_Scope_Extras_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Hackathon_Scope_Extras_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Scope_Extras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Aggregate_Fields = {
  __typename?: 'hackathon_scope_extras_aggregate_fields';
  avg?: Maybe<Hackathon_Scope_Extras_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Scope_Extras_Max_Fields>;
  min?: Maybe<Hackathon_Scope_Extras_Min_Fields>;
  stddev?: Maybe<Hackathon_Scope_Extras_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Scope_Extras_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Scope_Extras_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Scope_Extras_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Scope_Extras_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Scope_Extras_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Scope_Extras_Variance_Fields>;
};


/** aggregate fields of "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Scope_Extras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Scope_Extras_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Scope_Extras_Max_Order_By>;
  min?: InputMaybe<Hackathon_Scope_Extras_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Scope_Extras_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Scope_Extras_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Scope_Extras_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Scope_Extras_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Scope_Extras_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Scope_Extras_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Scope_Extras_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Scope_Extras_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Scope_Extras_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Scope_Extras_Avg_Fields = {
  __typename?: 'hackathon_scope_extras_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_scope_extras". All fields are combined with a logical 'AND'. */
export type Hackathon_Scope_Extras_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Scope_Extras_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Scope_Extras_Bool_Exp>>;
  at_app_status?: InputMaybe<Hse_At_App_Status_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  file_type?: InputMaybe<Hse_File_Type_Enum_Comparison_Exp>;
  file_types?: InputMaybe<_Text_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  hint?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  placeholder?: InputMaybe<String_Comparison_Exp>;
  required?: InputMaybe<Boolean_Comparison_Exp>;
  role?: InputMaybe<Hse_Role_Enum_Comparison_Exp>;
  section?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Hse_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_hackathon_scope_extra?: InputMaybe<User_Hackathon_Extras_Bool_Exp>;
  user_hackathons?: InputMaybe<User_Hackathons_Bool_Exp>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Bool_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_scope_extras" */
export enum Hackathon_Scope_Extras_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkHackathonScopeExtras = 'pk_hackathon_scope_extras',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHackathonScopeExtras = 'unique_uuid_hackathon_scope_extras'
}

/** input type for incrementing numeric columns in table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Insert_Input = {
  at_app_status?: InputMaybe<Scalars['hse_at_app_status_enum']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['hse_file_type_enum']>;
  file_types?: InputMaybe<Scalars['_text']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholder?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['hse_role_enum']>;
  section?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['hse_type_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_hackathon_scope_extra?: InputMaybe<User_Hackathon_Extras_Obj_Rel_Insert_Input>;
  user_hackathons?: InputMaybe<User_Hackathons_Arr_Rel_Insert_Input>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Scope_Extras_Max_Fields = {
  __typename?: 'hackathon_scope_extras_max_fields';
  at_app_status?: Maybe<Scalars['hse_at_app_status_enum']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  file_type?: Maybe<Scalars['hse_file_type_enum']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hint?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['hse_role_enum']>;
  section?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['hse_type_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Max_Order_By = {
  at_app_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  section?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Scope_Extras_Min_Fields = {
  __typename?: 'hackathon_scope_extras_min_fields';
  at_app_status?: Maybe<Scalars['hse_at_app_status_enum']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  file_type?: Maybe<Scalars['hse_file_type_enum']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hint?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['hse_role_enum']>;
  section?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['hse_type_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Min_Order_By = {
  at_app_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  section?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Mutation_Response = {
  __typename?: 'hackathon_scope_extras_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Scope_Extras>;
};

/** on_conflict condition type for table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_On_Conflict = {
  constraint: Hackathon_Scope_Extras_Constraint;
  update_columns?: Array<Hackathon_Scope_Extras_Update_Column>;
  where?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_scope_extras". */
export type Hackathon_Scope_Extras_Order_By = {
  at_app_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  file_types?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  required?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  section?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_hackathon_scope_extra?: InputMaybe<User_Hackathon_Extras_Order_By>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_scope_extras */
export type Hackathon_Scope_Extras_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_scope_extras" */
export enum Hackathon_Scope_Extras_Select_Column {
  /** column name */
  AtAppStatus = 'at_app_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  FileType = 'file_type',
  /** column name */
  FileTypes = 'file_types',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Hint = 'hint',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Placeholder = 'placeholder',
  /** column name */
  Required = 'required',
  /** column name */
  Role = 'role',
  /** column name */
  Section = 'section',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

/** select "hackathon_scope_extras_aggregate_bool_exp_bool_and_arguments_columns" columns of table "hackathon_scope_extras" */
export enum Hackathon_Scope_Extras_Select_Column_Hackathon_Scope_Extras_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Required = 'required'
}

/** select "hackathon_scope_extras_aggregate_bool_exp_bool_or_arguments_columns" columns of table "hackathon_scope_extras" */
export enum Hackathon_Scope_Extras_Select_Column_Hackathon_Scope_Extras_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Required = 'required'
}

/** input type for updating data in table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Set_Input = {
  at_app_status?: InputMaybe<Scalars['hse_at_app_status_enum']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['hse_file_type_enum']>;
  file_types?: InputMaybe<Scalars['_text']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholder?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['hse_role_enum']>;
  section?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['hse_type_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Scope_Extras_Stddev_Fields = {
  __typename?: 'hackathon_scope_extras_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Scope_Extras_Stddev_Pop_Fields = {
  __typename?: 'hackathon_scope_extras_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Scope_Extras_Stddev_Samp_Fields = {
  __typename?: 'hackathon_scope_extras_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Scope_Extras_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Scope_Extras_Stream_Cursor_Value_Input = {
  at_app_status?: InputMaybe<Scalars['hse_at_app_status_enum']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['hse_file_type_enum']>;
  file_types?: InputMaybe<Scalars['_text']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholder?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['hse_role_enum']>;
  section?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['hse_type_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Scope_Extras_Sum_Fields = {
  __typename?: 'hackathon_scope_extras_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_scope_extras" */
export enum Hackathon_Scope_Extras_Update_Column {
  /** column name */
  AtAppStatus = 'at_app_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  FileType = 'file_type',
  /** column name */
  FileTypes = 'file_types',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Hint = 'hint',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Placeholder = 'placeholder',
  /** column name */
  Required = 'required',
  /** column name */
  Role = 'role',
  /** column name */
  Section = 'section',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

export type Hackathon_Scope_Extras_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Scope_Extras_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Scope_Extras_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Scope_Extras_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Scope_Extras_Var_Pop_Fields = {
  __typename?: 'hackathon_scope_extras_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Scope_Extras_Var_Samp_Fields = {
  __typename?: 'hackathon_scope_extras_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Scope_Extras_Variance_Fields = {
  __typename?: 'hackathon_scope_extras_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_scope_extras" */
export type Hackathon_Scope_Extras_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "hackathon_scopes" */
export type Hackathon_Scopes = {
  __typename?: 'hackathon_scopes';
  created_at: Scalars['timestamptz'];
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  /** Computed field to fetch the processed hackathon scopes */
  processed_scopes?: Maybe<Scalars['jsonb']>;
  scope?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};


/** columns and relationships of "hackathon_scopes" */
export type Hackathon_ScopesProcessed_ScopesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "hackathon_scopes" */
export type Hackathon_Scopes_Aggregate = {
  __typename?: 'hackathon_scopes_aggregate';
  aggregate?: Maybe<Hackathon_Scopes_Aggregate_Fields>;
  nodes: Array<Hackathon_Scopes>;
};

/** aggregate fields of "hackathon_scopes" */
export type Hackathon_Scopes_Aggregate_Fields = {
  __typename?: 'hackathon_scopes_aggregate_fields';
  avg?: Maybe<Hackathon_Scopes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Scopes_Max_Fields>;
  min?: Maybe<Hackathon_Scopes_Min_Fields>;
  stddev?: Maybe<Hackathon_Scopes_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Scopes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Scopes_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Scopes_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Scopes_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Scopes_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Scopes_Variance_Fields>;
};


/** aggregate fields of "hackathon_scopes" */
export type Hackathon_Scopes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Scopes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Hackathon_Scopes_Avg_Fields = {
  __typename?: 'hackathon_scopes_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hackathon_scopes". All fields are combined with a logical 'AND'. */
export type Hackathon_Scopes_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Scopes_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Scopes_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Scopes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  processed_scopes?: InputMaybe<Jsonb_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_scopes" */
export enum Hackathon_Scopes_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkHackathonScopes = 'pk_hackathon_scopes',
  /** unique or primary key constraint on columns "hackathon_id" */
  UniqueHackathonIdHackathonScopes = 'unique_hackathon_id_hackathon_scopes',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHackathonScopes = 'unique_uuid_hackathon_scopes'
}

/** input type for incrementing numeric columns in table "hackathon_scopes" */
export type Hackathon_Scopes_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_scopes" */
export type Hackathon_Scopes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Scopes_Max_Fields = {
  __typename?: 'hackathon_scopes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scope?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Scopes_Min_Fields = {
  __typename?: 'hackathon_scopes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scope?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_scopes" */
export type Hackathon_Scopes_Mutation_Response = {
  __typename?: 'hackathon_scopes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Scopes>;
};

/** input type for inserting object relation for remote table "hackathon_scopes" */
export type Hackathon_Scopes_Obj_Rel_Insert_Input = {
  data: Hackathon_Scopes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Scopes_On_Conflict>;
};

/** on_conflict condition type for table "hackathon_scopes" */
export type Hackathon_Scopes_On_Conflict = {
  constraint: Hackathon_Scopes_Constraint;
  update_columns?: Array<Hackathon_Scopes_Update_Column>;
  where?: InputMaybe<Hackathon_Scopes_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_scopes". */
export type Hackathon_Scopes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  processed_scopes?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_scopes */
export type Hackathon_Scopes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_scopes" */
export enum Hackathon_Scopes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Scope = 'scope',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_scopes" */
export type Hackathon_Scopes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Scopes_Stddev_Fields = {
  __typename?: 'hackathon_scopes_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Scopes_Stddev_Pop_Fields = {
  __typename?: 'hackathon_scopes_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Scopes_Stddev_Samp_Fields = {
  __typename?: 'hackathon_scopes_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hackathon_scopes" */
export type Hackathon_Scopes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Scopes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Scopes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Scopes_Sum_Fields = {
  __typename?: 'hackathon_scopes_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "hackathon_scopes" */
export enum Hackathon_Scopes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Scope = 'scope',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Scopes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Scopes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Scopes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Scopes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Scopes_Var_Pop_Fields = {
  __typename?: 'hackathon_scopes_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hackathon_Scopes_Var_Samp_Fields = {
  __typename?: 'hackathon_scopes_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hackathon_Scopes_Variance_Fields = {
  __typename?: 'hackathon_scopes_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "hackathon_settings" */
export type Hackathon_Settings = {
  __typename?: 'hackathon_settings';
  /** This function is used to prefix the ASSETS_URL */
  _logo?: Maybe<Scalars['String']>;
  ai_assisted_reviews_enabled: Scalars['Boolean'];
  ai_assisted_reviews_onboarding_completed: Scalars['Boolean'];
  allow_announcements_post_hackathon?: Maybe<Scalars['Boolean']>;
  allow_travel_reimbursement?: Maybe<Scalars['Boolean']>;
  apply_now_integrated?: Maybe<Scalars['Boolean']>;
  bounties_process_type?: Maybe<User_Hackathon_Bounties_Type_Enum>;
  bounties_status: Hackathon_Bounties_Status_Enum;
  cheer_enabled?: Maybe<Scalars['Boolean']>;
  coc_url?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['citext']>;
  created_at: Scalars['timestamptz'];
  current_phase?: Maybe<Scalars['Int']>;
  data_export_copy?: Maybe<Scalars['String']>;
  discord?: Maybe<Scalars['String']>;
  discord_bot_channel_name?: Maybe<Scalars['String']>;
  discord_checkin_enable?: Maybe<Scalars['Boolean']>;
  discord_guild_id?: Maybe<Scalars['String']>;
  discord_role?: Maybe<Scalars['String']>;
  eligible_entities?: Maybe<Scalars['_text']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  enable_bargraph?: Maybe<Scalars['Boolean']>;
  external_apply_url?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  farcaster?: Maybe<Scalars['String']>;
  featured_cover_img?: Maybe<Scalars['String']>;
  featured_cover_img_v2?: Maybe<Scalars['String']>;
  feedback_reminder_sent_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_credentials_chain?: Maybe<Hackathon_Credentials_Chain_Enum>;
  hackathon_id: Scalars['Int'];
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Int']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Int']>;
  hackers_guide_url?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  instagram?: Maybe<Scalars['String']>;
  is_hybrid?: Maybe<Scalars['Boolean']>;
  judging_enabled: Scalars['Boolean'];
  judging_ends_at?: Maybe<Scalars['timestamptz']>;
  judging_factors?: Maybe<Scalars['String']>;
  judging_starts_at?: Maybe<Scalars['timestamptz']>;
  kyc_submitted: Scalars['Boolean'];
  kyc_verified: Scalars['Boolean'];
  leaderboard_enabled: Scalars['Boolean'];
  linkedin?: Maybe<Scalars['String']>;
  location_latitude?: Maybe<Scalars['float8']>;
  location_longitude?: Maybe<Scalars['float8']>;
  logo?: Maybe<Scalars['String']>;
  max_judges_per_project?: Maybe<Scalars['Int']>;
  max_schwag_custom_entities: Scalars['Int'];
  medium?: Maybe<Scalars['String']>;
  mid_hackathon_checkin_enabled?: Maybe<Scalars['Boolean']>;
  mid_hackathon_checkin_ends_at?: Maybe<Scalars['timestamptz']>;
  mid_hackathon_checkin_starts_at?: Maybe<Scalars['timestamptz']>;
  min_judges_per_project?: Maybe<Scalars['Int']>;
  mou_place_of_signing?: Maybe<Scalars['String']>;
  mou_signatory_email_id?: Maybe<Scalars['String']>;
  mou_signatory_name?: Maybe<Scalars['String']>;
  mou_signatory_team?: Maybe<Scalars['String']>;
  mou_signatory_title?: Maybe<Scalars['String']>;
  mou_sponsor_tiers?: Maybe<Scalars['jsonb']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  notaccepted_msg?: Maybe<Scalars['String']>;
  offline_judge?: Maybe<Scalars['Boolean']>;
  on_chain_credentials_enabled?: Maybe<Scalars['Boolean']>;
  on_chain_credentials_gasless?: Maybe<Scalars['Boolean']>;
  online_hackathon_reminder?: Maybe<Scalars['Boolean']>;
  online_judging_enabled: Scalars['Boolean'];
  organizer_discord_channel_created?: Maybe<Scalars['Boolean']>;
  organizer_phone_number?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['Boolean']>;
  partner_logos_added?: Maybe<Scalars['Boolean']>;
  payment_mode?: Maybe<Scalars['String']>;
  percentage_complete?: Maybe<Scalars['Int']>;
  primary_color?: Maybe<Scalars['String']>;
  processed_schwag_entities?: Maybe<Scalars['_text']>;
  quadratic_voting_chain?: Maybe<Quadratic_Voting_Chain_Enum>;
  quadratic_voting_currency?: Maybe<Quadratic_Voting_Currency_Enum>;
  quadratic_voting_enabled: Scalars['Boolean'];
  quadratic_voting_ends_at?: Maybe<Scalars['timestamptz']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Int']>;
  quadratic_voting_results_announced: Scalars['Boolean'];
  quadratic_voting_starts_at?: Maybe<Scalars['timestamptz']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Int']>;
  razorpay_desc?: Maybe<Scalars['String']>;
  razorpay_title?: Maybe<Scalars['String']>;
  referral_prize_doc_link?: Maybe<Scalars['String']>;
  reg_ends_at?: Maybe<Scalars['timestamptz']>;
  reg_starts_at?: Maybe<Scalars['timestamptz']>;
  reminder_email_sent_at?: Maybe<Scalars['timestamptz']>;
  review?: Maybe<Scalars['Boolean']>;
  rsvp_time?: Maybe<Scalars['Int']>;
  schwag_organizers_count?: Maybe<Scalars['Int']>;
  schwag_winners_count?: Maybe<Scalars['Int']>;
  schwags_process_state: Scalars['String'];
  show_more_hackathons?: Maybe<Scalars['Boolean']>;
  site?: Maybe<Scalars['String']>;
  slack?: Maybe<Scalars['String']>;
  sponsor_judging_enabled: Scalars['Boolean'];
  staking_for_rsvp: Scalars['Boolean'];
  subdomain: Scalars['citext'];
  syncing_enabled: Scalars['Boolean'];
  telegram?: Maybe<Scalars['String']>;
  ticket_font_color?: Maybe<Scalars['String']>;
  ticket_img?: Maybe<Scalars['String']>;
  ticket_limit?: Maybe<Scalars['Int']>;
  ticket_limit_f?: Maybe<Scalars['Int']>;
  ticket_limit_m?: Maybe<Scalars['Int']>;
  ticket_msg1?: Maybe<Scalars['String']>;
  ticket_msg2?: Maybe<Scalars['String']>;
  ticket_refundable?: Maybe<Scalars['Boolean']>;
  tnc_url?: Maybe<Scalars['String']>;
  tokenproof_gating_enabled: Scalars['Boolean'];
  twitter?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  upload_option?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
  v2_application_enabled?: Maybe<Scalars['Boolean']>;
  voting?: Maybe<Scalars['Boolean']>;
  waitlist_msg?: Maybe<Scalars['String']>;
  whitelist_domain?: Maybe<Scalars['String']>;
  winner_announce_at?: Maybe<Scalars['timestamptz']>;
  winner_announced?: Maybe<Scalars['Boolean']>;
  women_only?: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "hackathon_settings" */
export type Hackathon_SettingsMou_Sponsor_TiersArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "hackathon_settings" */
export type Hackathon_Settings_Aggregate = {
  __typename?: 'hackathon_settings_aggregate';
  aggregate?: Maybe<Hackathon_Settings_Aggregate_Fields>;
  nodes: Array<Hackathon_Settings>;
};

/** aggregate fields of "hackathon_settings" */
export type Hackathon_Settings_Aggregate_Fields = {
  __typename?: 'hackathon_settings_aggregate_fields';
  avg?: Maybe<Hackathon_Settings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Settings_Max_Fields>;
  min?: Maybe<Hackathon_Settings_Min_Fields>;
  stddev?: Maybe<Hackathon_Settings_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Settings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Settings_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Settings_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Settings_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Settings_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Settings_Variance_Fields>;
};


/** aggregate fields of "hackathon_settings" */
export type Hackathon_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Hackathon_Settings_Append_Input = {
  mou_sponsor_tiers?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Hackathon_Settings_Avg_Fields = {
  __typename?: 'hackathon_settings_avg_fields';
  current_phase?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_latitude?: Maybe<Scalars['Float']>;
  location_longitude?: Maybe<Scalars['Float']>;
  max_judges_per_project?: Maybe<Scalars['Float']>;
  max_schwag_custom_entities?: Maybe<Scalars['Float']>;
  min_judges_per_project?: Maybe<Scalars['Float']>;
  percentage_complete?: Maybe<Scalars['Float']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Float']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Float']>;
  rsvp_time?: Maybe<Scalars['Float']>;
  schwag_organizers_count?: Maybe<Scalars['Float']>;
  schwag_winners_count?: Maybe<Scalars['Float']>;
  ticket_limit?: Maybe<Scalars['Float']>;
  ticket_limit_f?: Maybe<Scalars['Float']>;
  ticket_limit_m?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hackathon_settings". All fields are combined with a logical 'AND'. */
export type Hackathon_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Settings_Bool_Exp>>;
  _logo?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Hackathon_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Settings_Bool_Exp>>;
  ai_assisted_reviews_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  ai_assisted_reviews_onboarding_completed?: InputMaybe<Boolean_Comparison_Exp>;
  allow_announcements_post_hackathon?: InputMaybe<Boolean_Comparison_Exp>;
  allow_travel_reimbursement?: InputMaybe<Boolean_Comparison_Exp>;
  apply_now_integrated?: InputMaybe<Boolean_Comparison_Exp>;
  bounties_process_type?: InputMaybe<User_Hackathon_Bounties_Type_Enum_Comparison_Exp>;
  bounties_status?: InputMaybe<Hackathon_Bounties_Status_Enum_Comparison_Exp>;
  cheer_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  coc_url?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<Citext_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_phase?: InputMaybe<Int_Comparison_Exp>;
  data_export_copy?: InputMaybe<String_Comparison_Exp>;
  discord?: InputMaybe<String_Comparison_Exp>;
  discord_bot_channel_name?: InputMaybe<String_Comparison_Exp>;
  discord_checkin_enable?: InputMaybe<Boolean_Comparison_Exp>;
  discord_guild_id?: InputMaybe<String_Comparison_Exp>;
  discord_role?: InputMaybe<String_Comparison_Exp>;
  eligible_entities?: InputMaybe<_Text_Comparison_Exp>;
  email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  enable_bargraph?: InputMaybe<Boolean_Comparison_Exp>;
  external_apply_url?: InputMaybe<String_Comparison_Exp>;
  facebook?: InputMaybe<String_Comparison_Exp>;
  farcaster?: InputMaybe<String_Comparison_Exp>;
  featured_cover_img?: InputMaybe<String_Comparison_Exp>;
  featured_cover_img_v2?: InputMaybe<String_Comparison_Exp>;
  feedback_reminder_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_credentials_chain?: InputMaybe<Hackathon_Credentials_Chain_Enum_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  hackathon_schwags_participants_product_id?: InputMaybe<Int_Comparison_Exp>;
  hackathon_schwags_winners_product_id?: InputMaybe<Int_Comparison_Exp>;
  hackers_guide_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  is_hybrid?: InputMaybe<Boolean_Comparison_Exp>;
  judging_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  judging_ends_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  judging_factors?: InputMaybe<String_Comparison_Exp>;
  judging_starts_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  kyc_submitted?: InputMaybe<Boolean_Comparison_Exp>;
  kyc_verified?: InputMaybe<Boolean_Comparison_Exp>;
  leaderboard_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  linkedin?: InputMaybe<String_Comparison_Exp>;
  location_latitude?: InputMaybe<Float8_Comparison_Exp>;
  location_longitude?: InputMaybe<Float8_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  max_judges_per_project?: InputMaybe<Int_Comparison_Exp>;
  max_schwag_custom_entities?: InputMaybe<Int_Comparison_Exp>;
  medium?: InputMaybe<String_Comparison_Exp>;
  mid_hackathon_checkin_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  mid_hackathon_checkin_ends_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  mid_hackathon_checkin_starts_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  min_judges_per_project?: InputMaybe<Int_Comparison_Exp>;
  mou_place_of_signing?: InputMaybe<String_Comparison_Exp>;
  mou_signatory_email_id?: InputMaybe<String_Comparison_Exp>;
  mou_signatory_name?: InputMaybe<String_Comparison_Exp>;
  mou_signatory_team?: InputMaybe<String_Comparison_Exp>;
  mou_signatory_title?: InputMaybe<String_Comparison_Exp>;
  mou_sponsor_tiers?: InputMaybe<Jsonb_Comparison_Exp>;
  nft_contract_address?: InputMaybe<String_Comparison_Exp>;
  notaccepted_msg?: InputMaybe<String_Comparison_Exp>;
  offline_judge?: InputMaybe<Boolean_Comparison_Exp>;
  on_chain_credentials_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  on_chain_credentials_gasless?: InputMaybe<Boolean_Comparison_Exp>;
  online_hackathon_reminder?: InputMaybe<Boolean_Comparison_Exp>;
  online_judging_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  organizer_discord_channel_created?: InputMaybe<Boolean_Comparison_Exp>;
  organizer_phone_number?: InputMaybe<String_Comparison_Exp>;
  paid?: InputMaybe<Boolean_Comparison_Exp>;
  partner_logos_added?: InputMaybe<Boolean_Comparison_Exp>;
  payment_mode?: InputMaybe<String_Comparison_Exp>;
  percentage_complete?: InputMaybe<Int_Comparison_Exp>;
  primary_color?: InputMaybe<String_Comparison_Exp>;
  processed_schwag_entities?: InputMaybe<_Text_Comparison_Exp>;
  quadratic_voting_chain?: InputMaybe<Quadratic_Voting_Chain_Enum_Comparison_Exp>;
  quadratic_voting_currency?: InputMaybe<Quadratic_Voting_Currency_Enum_Comparison_Exp>;
  quadratic_voting_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  quadratic_voting_ends_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  quadratic_voting_prize_pool_amount?: InputMaybe<Int_Comparison_Exp>;
  quadratic_voting_results_announced?: InputMaybe<Boolean_Comparison_Exp>;
  quadratic_voting_starts_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  quadratic_voting_total_votes?: InputMaybe<Int_Comparison_Exp>;
  razorpay_desc?: InputMaybe<String_Comparison_Exp>;
  razorpay_title?: InputMaybe<String_Comparison_Exp>;
  referral_prize_doc_link?: InputMaybe<String_Comparison_Exp>;
  reg_ends_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reg_starts_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reminder_email_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  review?: InputMaybe<Boolean_Comparison_Exp>;
  rsvp_time?: InputMaybe<Int_Comparison_Exp>;
  schwag_organizers_count?: InputMaybe<Int_Comparison_Exp>;
  schwag_winners_count?: InputMaybe<Int_Comparison_Exp>;
  schwags_process_state?: InputMaybe<String_Comparison_Exp>;
  show_more_hackathons?: InputMaybe<Boolean_Comparison_Exp>;
  site?: InputMaybe<String_Comparison_Exp>;
  slack?: InputMaybe<String_Comparison_Exp>;
  sponsor_judging_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  staking_for_rsvp?: InputMaybe<Boolean_Comparison_Exp>;
  subdomain?: InputMaybe<Citext_Comparison_Exp>;
  syncing_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  telegram?: InputMaybe<String_Comparison_Exp>;
  ticket_font_color?: InputMaybe<String_Comparison_Exp>;
  ticket_img?: InputMaybe<String_Comparison_Exp>;
  ticket_limit?: InputMaybe<Int_Comparison_Exp>;
  ticket_limit_f?: InputMaybe<Int_Comparison_Exp>;
  ticket_limit_m?: InputMaybe<Int_Comparison_Exp>;
  ticket_msg1?: InputMaybe<String_Comparison_Exp>;
  ticket_msg2?: InputMaybe<String_Comparison_Exp>;
  ticket_refundable?: InputMaybe<Boolean_Comparison_Exp>;
  tnc_url?: InputMaybe<String_Comparison_Exp>;
  tokenproof_gating_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  upload_option?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  v2_application_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  voting?: InputMaybe<Boolean_Comparison_Exp>;
  waitlist_msg?: InputMaybe<String_Comparison_Exp>;
  whitelist_domain?: InputMaybe<String_Comparison_Exp>;
  winner_announce_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winner_announced?: InputMaybe<Boolean_Comparison_Exp>;
  women_only?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_settings" */
export enum Hackathon_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkHackathonSettings = 'pk_hackathon_settings',
  /** unique or primary key constraint on columns "hackathon_id" */
  UniqueHackathonIdHackathonSettings = 'unique_hackathon_id_hackathon_settings',
  /** unique or primary key constraint on columns "subdomain" */
  UniqueSubdomainHackathonSettings = 'unique_subdomain_hackathon_settings',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHackathonSettings = 'unique_uuid_hackathon_settings'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Hackathon_Settings_Delete_At_Path_Input = {
  mou_sponsor_tiers?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Hackathon_Settings_Delete_Elem_Input = {
  mou_sponsor_tiers?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Hackathon_Settings_Delete_Key_Input = {
  mou_sponsor_tiers?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "hackathon_settings" */
export type Hackathon_Settings_Inc_Input = {
  current_phase?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_schwags_participants_product_id?: InputMaybe<Scalars['Int']>;
  hackathon_schwags_winners_product_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  location_latitude?: InputMaybe<Scalars['float8']>;
  location_longitude?: InputMaybe<Scalars['float8']>;
  max_judges_per_project?: InputMaybe<Scalars['Int']>;
  max_schwag_custom_entities?: InputMaybe<Scalars['Int']>;
  min_judges_per_project?: InputMaybe<Scalars['Int']>;
  percentage_complete?: InputMaybe<Scalars['Int']>;
  quadratic_voting_prize_pool_amount?: InputMaybe<Scalars['Int']>;
  quadratic_voting_total_votes?: InputMaybe<Scalars['Int']>;
  rsvp_time?: InputMaybe<Scalars['Int']>;
  schwag_organizers_count?: InputMaybe<Scalars['Int']>;
  schwag_winners_count?: InputMaybe<Scalars['Int']>;
  ticket_limit?: InputMaybe<Scalars['Int']>;
  ticket_limit_f?: InputMaybe<Scalars['Int']>;
  ticket_limit_m?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_settings" */
export type Hackathon_Settings_Insert_Input = {
  ai_assisted_reviews_enabled?: InputMaybe<Scalars['Boolean']>;
  ai_assisted_reviews_onboarding_completed?: InputMaybe<Scalars['Boolean']>;
  allow_announcements_post_hackathon?: InputMaybe<Scalars['Boolean']>;
  allow_travel_reimbursement?: InputMaybe<Scalars['Boolean']>;
  apply_now_integrated?: InputMaybe<Scalars['Boolean']>;
  bounties_process_type?: InputMaybe<User_Hackathon_Bounties_Type_Enum>;
  bounties_status?: InputMaybe<Hackathon_Bounties_Status_Enum>;
  cheer_enabled?: InputMaybe<Scalars['Boolean']>;
  coc_url?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['citext']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_phase?: InputMaybe<Scalars['Int']>;
  data_export_copy?: InputMaybe<Scalars['String']>;
  discord?: InputMaybe<Scalars['String']>;
  discord_bot_channel_name?: InputMaybe<Scalars['String']>;
  discord_checkin_enable?: InputMaybe<Scalars['Boolean']>;
  discord_guild_id?: InputMaybe<Scalars['String']>;
  discord_role?: InputMaybe<Scalars['String']>;
  eligible_entities?: InputMaybe<Scalars['_text']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  enable_bargraph?: InputMaybe<Scalars['Boolean']>;
  external_apply_url?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  farcaster?: InputMaybe<Scalars['String']>;
  featured_cover_img?: InputMaybe<Scalars['String']>;
  featured_cover_img_v2?: InputMaybe<Scalars['String']>;
  feedback_reminder_sent_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_credentials_chain?: InputMaybe<Hackathon_Credentials_Chain_Enum>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_schwags_participants_product_id?: InputMaybe<Scalars['Int']>;
  hackathon_schwags_winners_product_id?: InputMaybe<Scalars['Int']>;
  hackers_guide_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_hybrid?: InputMaybe<Scalars['Boolean']>;
  judging_enabled?: InputMaybe<Scalars['Boolean']>;
  judging_ends_at?: InputMaybe<Scalars['timestamptz']>;
  judging_factors?: InputMaybe<Scalars['String']>;
  judging_starts_at?: InputMaybe<Scalars['timestamptz']>;
  kyc_submitted?: InputMaybe<Scalars['Boolean']>;
  kyc_verified?: InputMaybe<Scalars['Boolean']>;
  leaderboard_enabled?: InputMaybe<Scalars['Boolean']>;
  linkedin?: InputMaybe<Scalars['String']>;
  location_latitude?: InputMaybe<Scalars['float8']>;
  location_longitude?: InputMaybe<Scalars['float8']>;
  logo?: InputMaybe<Scalars['String']>;
  max_judges_per_project?: InputMaybe<Scalars['Int']>;
  max_schwag_custom_entities?: InputMaybe<Scalars['Int']>;
  medium?: InputMaybe<Scalars['String']>;
  mid_hackathon_checkin_enabled?: InputMaybe<Scalars['Boolean']>;
  mid_hackathon_checkin_ends_at?: InputMaybe<Scalars['timestamptz']>;
  mid_hackathon_checkin_starts_at?: InputMaybe<Scalars['timestamptz']>;
  min_judges_per_project?: InputMaybe<Scalars['Int']>;
  mou_place_of_signing?: InputMaybe<Scalars['String']>;
  mou_signatory_email_id?: InputMaybe<Scalars['String']>;
  mou_signatory_name?: InputMaybe<Scalars['String']>;
  mou_signatory_team?: InputMaybe<Scalars['String']>;
  mou_signatory_title?: InputMaybe<Scalars['String']>;
  mou_sponsor_tiers?: InputMaybe<Scalars['jsonb']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  notaccepted_msg?: InputMaybe<Scalars['String']>;
  offline_judge?: InputMaybe<Scalars['Boolean']>;
  on_chain_credentials_enabled?: InputMaybe<Scalars['Boolean']>;
  on_chain_credentials_gasless?: InputMaybe<Scalars['Boolean']>;
  online_hackathon_reminder?: InputMaybe<Scalars['Boolean']>;
  online_judging_enabled?: InputMaybe<Scalars['Boolean']>;
  organizer_discord_channel_created?: InputMaybe<Scalars['Boolean']>;
  organizer_phone_number?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  partner_logos_added?: InputMaybe<Scalars['Boolean']>;
  payment_mode?: InputMaybe<Scalars['String']>;
  percentage_complete?: InputMaybe<Scalars['Int']>;
  primary_color?: InputMaybe<Scalars['String']>;
  processed_schwag_entities?: InputMaybe<Scalars['_text']>;
  quadratic_voting_chain?: InputMaybe<Quadratic_Voting_Chain_Enum>;
  quadratic_voting_currency?: InputMaybe<Quadratic_Voting_Currency_Enum>;
  quadratic_voting_enabled?: InputMaybe<Scalars['Boolean']>;
  quadratic_voting_ends_at?: InputMaybe<Scalars['timestamptz']>;
  quadratic_voting_prize_pool_amount?: InputMaybe<Scalars['Int']>;
  quadratic_voting_results_announced?: InputMaybe<Scalars['Boolean']>;
  quadratic_voting_starts_at?: InputMaybe<Scalars['timestamptz']>;
  quadratic_voting_total_votes?: InputMaybe<Scalars['Int']>;
  razorpay_desc?: InputMaybe<Scalars['String']>;
  razorpay_title?: InputMaybe<Scalars['String']>;
  referral_prize_doc_link?: InputMaybe<Scalars['String']>;
  reg_ends_at?: InputMaybe<Scalars['timestamptz']>;
  reg_starts_at?: InputMaybe<Scalars['timestamptz']>;
  reminder_email_sent_at?: InputMaybe<Scalars['timestamptz']>;
  review?: InputMaybe<Scalars['Boolean']>;
  rsvp_time?: InputMaybe<Scalars['Int']>;
  schwag_organizers_count?: InputMaybe<Scalars['Int']>;
  schwag_winners_count?: InputMaybe<Scalars['Int']>;
  schwags_process_state?: InputMaybe<Scalars['String']>;
  show_more_hackathons?: InputMaybe<Scalars['Boolean']>;
  site?: InputMaybe<Scalars['String']>;
  slack?: InputMaybe<Scalars['String']>;
  sponsor_judging_enabled?: InputMaybe<Scalars['Boolean']>;
  staking_for_rsvp?: InputMaybe<Scalars['Boolean']>;
  subdomain?: InputMaybe<Scalars['citext']>;
  syncing_enabled?: InputMaybe<Scalars['Boolean']>;
  telegram?: InputMaybe<Scalars['String']>;
  ticket_font_color?: InputMaybe<Scalars['String']>;
  ticket_img?: InputMaybe<Scalars['String']>;
  ticket_limit?: InputMaybe<Scalars['Int']>;
  ticket_limit_f?: InputMaybe<Scalars['Int']>;
  ticket_limit_m?: InputMaybe<Scalars['Int']>;
  ticket_msg1?: InputMaybe<Scalars['String']>;
  ticket_msg2?: InputMaybe<Scalars['String']>;
  ticket_refundable?: InputMaybe<Scalars['Boolean']>;
  tnc_url?: InputMaybe<Scalars['String']>;
  tokenproof_gating_enabled?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upload_option?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  v2_application_enabled?: InputMaybe<Scalars['Boolean']>;
  voting?: InputMaybe<Scalars['Boolean']>;
  waitlist_msg?: InputMaybe<Scalars['String']>;
  whitelist_domain?: InputMaybe<Scalars['String']>;
  winner_announce_at?: InputMaybe<Scalars['timestamptz']>;
  winner_announced?: InputMaybe<Scalars['Boolean']>;
  women_only?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Hackathon_Settings_Max_Fields = {
  __typename?: 'hackathon_settings_max_fields';
  coc_url?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['citext']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_phase?: Maybe<Scalars['Int']>;
  data_export_copy?: Maybe<Scalars['String']>;
  discord?: Maybe<Scalars['String']>;
  discord_bot_channel_name?: Maybe<Scalars['String']>;
  discord_guild_id?: Maybe<Scalars['String']>;
  discord_role?: Maybe<Scalars['String']>;
  external_apply_url?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  farcaster?: Maybe<Scalars['String']>;
  featured_cover_img?: Maybe<Scalars['String']>;
  featured_cover_img_v2?: Maybe<Scalars['String']>;
  feedback_reminder_sent_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Int']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Int']>;
  hackers_guide_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  instagram?: Maybe<Scalars['String']>;
  judging_ends_at?: Maybe<Scalars['timestamptz']>;
  judging_factors?: Maybe<Scalars['String']>;
  judging_starts_at?: Maybe<Scalars['timestamptz']>;
  linkedin?: Maybe<Scalars['String']>;
  location_latitude?: Maybe<Scalars['float8']>;
  location_longitude?: Maybe<Scalars['float8']>;
  logo?: Maybe<Scalars['String']>;
  max_judges_per_project?: Maybe<Scalars['Int']>;
  max_schwag_custom_entities?: Maybe<Scalars['Int']>;
  medium?: Maybe<Scalars['String']>;
  mid_hackathon_checkin_ends_at?: Maybe<Scalars['timestamptz']>;
  mid_hackathon_checkin_starts_at?: Maybe<Scalars['timestamptz']>;
  min_judges_per_project?: Maybe<Scalars['Int']>;
  mou_place_of_signing?: Maybe<Scalars['String']>;
  mou_signatory_email_id?: Maybe<Scalars['String']>;
  mou_signatory_name?: Maybe<Scalars['String']>;
  mou_signatory_team?: Maybe<Scalars['String']>;
  mou_signatory_title?: Maybe<Scalars['String']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  notaccepted_msg?: Maybe<Scalars['String']>;
  organizer_phone_number?: Maybe<Scalars['String']>;
  payment_mode?: Maybe<Scalars['String']>;
  percentage_complete?: Maybe<Scalars['Int']>;
  primary_color?: Maybe<Scalars['String']>;
  quadratic_voting_ends_at?: Maybe<Scalars['timestamptz']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Int']>;
  quadratic_voting_starts_at?: Maybe<Scalars['timestamptz']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Int']>;
  razorpay_desc?: Maybe<Scalars['String']>;
  razorpay_title?: Maybe<Scalars['String']>;
  referral_prize_doc_link?: Maybe<Scalars['String']>;
  reg_ends_at?: Maybe<Scalars['timestamptz']>;
  reg_starts_at?: Maybe<Scalars['timestamptz']>;
  reminder_email_sent_at?: Maybe<Scalars['timestamptz']>;
  rsvp_time?: Maybe<Scalars['Int']>;
  schwag_organizers_count?: Maybe<Scalars['Int']>;
  schwag_winners_count?: Maybe<Scalars['Int']>;
  schwags_process_state?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  slack?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['citext']>;
  telegram?: Maybe<Scalars['String']>;
  ticket_font_color?: Maybe<Scalars['String']>;
  ticket_img?: Maybe<Scalars['String']>;
  ticket_limit?: Maybe<Scalars['Int']>;
  ticket_limit_f?: Maybe<Scalars['Int']>;
  ticket_limit_m?: Maybe<Scalars['Int']>;
  ticket_msg1?: Maybe<Scalars['String']>;
  ticket_msg2?: Maybe<Scalars['String']>;
  tnc_url?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  upload_option?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  waitlist_msg?: Maybe<Scalars['String']>;
  whitelist_domain?: Maybe<Scalars['String']>;
  winner_announce_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Hackathon_Settings_Min_Fields = {
  __typename?: 'hackathon_settings_min_fields';
  coc_url?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['citext']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_phase?: Maybe<Scalars['Int']>;
  data_export_copy?: Maybe<Scalars['String']>;
  discord?: Maybe<Scalars['String']>;
  discord_bot_channel_name?: Maybe<Scalars['String']>;
  discord_guild_id?: Maybe<Scalars['String']>;
  discord_role?: Maybe<Scalars['String']>;
  external_apply_url?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  farcaster?: Maybe<Scalars['String']>;
  featured_cover_img?: Maybe<Scalars['String']>;
  featured_cover_img_v2?: Maybe<Scalars['String']>;
  feedback_reminder_sent_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Int']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Int']>;
  hackers_guide_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  instagram?: Maybe<Scalars['String']>;
  judging_ends_at?: Maybe<Scalars['timestamptz']>;
  judging_factors?: Maybe<Scalars['String']>;
  judging_starts_at?: Maybe<Scalars['timestamptz']>;
  linkedin?: Maybe<Scalars['String']>;
  location_latitude?: Maybe<Scalars['float8']>;
  location_longitude?: Maybe<Scalars['float8']>;
  logo?: Maybe<Scalars['String']>;
  max_judges_per_project?: Maybe<Scalars['Int']>;
  max_schwag_custom_entities?: Maybe<Scalars['Int']>;
  medium?: Maybe<Scalars['String']>;
  mid_hackathon_checkin_ends_at?: Maybe<Scalars['timestamptz']>;
  mid_hackathon_checkin_starts_at?: Maybe<Scalars['timestamptz']>;
  min_judges_per_project?: Maybe<Scalars['Int']>;
  mou_place_of_signing?: Maybe<Scalars['String']>;
  mou_signatory_email_id?: Maybe<Scalars['String']>;
  mou_signatory_name?: Maybe<Scalars['String']>;
  mou_signatory_team?: Maybe<Scalars['String']>;
  mou_signatory_title?: Maybe<Scalars['String']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  notaccepted_msg?: Maybe<Scalars['String']>;
  organizer_phone_number?: Maybe<Scalars['String']>;
  payment_mode?: Maybe<Scalars['String']>;
  percentage_complete?: Maybe<Scalars['Int']>;
  primary_color?: Maybe<Scalars['String']>;
  quadratic_voting_ends_at?: Maybe<Scalars['timestamptz']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Int']>;
  quadratic_voting_starts_at?: Maybe<Scalars['timestamptz']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Int']>;
  razorpay_desc?: Maybe<Scalars['String']>;
  razorpay_title?: Maybe<Scalars['String']>;
  referral_prize_doc_link?: Maybe<Scalars['String']>;
  reg_ends_at?: Maybe<Scalars['timestamptz']>;
  reg_starts_at?: Maybe<Scalars['timestamptz']>;
  reminder_email_sent_at?: Maybe<Scalars['timestamptz']>;
  rsvp_time?: Maybe<Scalars['Int']>;
  schwag_organizers_count?: Maybe<Scalars['Int']>;
  schwag_winners_count?: Maybe<Scalars['Int']>;
  schwags_process_state?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  slack?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['citext']>;
  telegram?: Maybe<Scalars['String']>;
  ticket_font_color?: Maybe<Scalars['String']>;
  ticket_img?: Maybe<Scalars['String']>;
  ticket_limit?: Maybe<Scalars['Int']>;
  ticket_limit_f?: Maybe<Scalars['Int']>;
  ticket_limit_m?: Maybe<Scalars['Int']>;
  ticket_msg1?: Maybe<Scalars['String']>;
  ticket_msg2?: Maybe<Scalars['String']>;
  tnc_url?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  upload_option?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  waitlist_msg?: Maybe<Scalars['String']>;
  whitelist_domain?: Maybe<Scalars['String']>;
  winner_announce_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "hackathon_settings" */
export type Hackathon_Settings_Mutation_Response = {
  __typename?: 'hackathon_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Settings>;
};

/** input type for inserting object relation for remote table "hackathon_settings" */
export type Hackathon_Settings_Obj_Rel_Insert_Input = {
  data: Hackathon_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Settings_On_Conflict>;
};

/** on_conflict condition type for table "hackathon_settings" */
export type Hackathon_Settings_On_Conflict = {
  constraint: Hackathon_Settings_Constraint;
  update_columns?: Array<Hackathon_Settings_Update_Column>;
  where?: InputMaybe<Hackathon_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_settings". */
export type Hackathon_Settings_Order_By = {
  _logo?: InputMaybe<Order_By>;
  ai_assisted_reviews_enabled?: InputMaybe<Order_By>;
  ai_assisted_reviews_onboarding_completed?: InputMaybe<Order_By>;
  allow_announcements_post_hackathon?: InputMaybe<Order_By>;
  allow_travel_reimbursement?: InputMaybe<Order_By>;
  apply_now_integrated?: InputMaybe<Order_By>;
  bounties_process_type?: InputMaybe<Order_By>;
  bounties_status?: InputMaybe<Order_By>;
  cheer_enabled?: InputMaybe<Order_By>;
  coc_url?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_phase?: InputMaybe<Order_By>;
  data_export_copy?: InputMaybe<Order_By>;
  discord?: InputMaybe<Order_By>;
  discord_bot_channel_name?: InputMaybe<Order_By>;
  discord_checkin_enable?: InputMaybe<Order_By>;
  discord_guild_id?: InputMaybe<Order_By>;
  discord_role?: InputMaybe<Order_By>;
  eligible_entities?: InputMaybe<Order_By>;
  email_verified?: InputMaybe<Order_By>;
  enable_bargraph?: InputMaybe<Order_By>;
  external_apply_url?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  farcaster?: InputMaybe<Order_By>;
  featured_cover_img?: InputMaybe<Order_By>;
  featured_cover_img_v2?: InputMaybe<Order_By>;
  feedback_reminder_sent_at?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_credentials_chain?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hackathon_schwags_participants_product_id?: InputMaybe<Order_By>;
  hackathon_schwags_winners_product_id?: InputMaybe<Order_By>;
  hackers_guide_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  is_hybrid?: InputMaybe<Order_By>;
  judging_enabled?: InputMaybe<Order_By>;
  judging_ends_at?: InputMaybe<Order_By>;
  judging_factors?: InputMaybe<Order_By>;
  judging_starts_at?: InputMaybe<Order_By>;
  kyc_submitted?: InputMaybe<Order_By>;
  kyc_verified?: InputMaybe<Order_By>;
  leaderboard_enabled?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  location_latitude?: InputMaybe<Order_By>;
  location_longitude?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  max_judges_per_project?: InputMaybe<Order_By>;
  max_schwag_custom_entities?: InputMaybe<Order_By>;
  medium?: InputMaybe<Order_By>;
  mid_hackathon_checkin_enabled?: InputMaybe<Order_By>;
  mid_hackathon_checkin_ends_at?: InputMaybe<Order_By>;
  mid_hackathon_checkin_starts_at?: InputMaybe<Order_By>;
  min_judges_per_project?: InputMaybe<Order_By>;
  mou_place_of_signing?: InputMaybe<Order_By>;
  mou_signatory_email_id?: InputMaybe<Order_By>;
  mou_signatory_name?: InputMaybe<Order_By>;
  mou_signatory_team?: InputMaybe<Order_By>;
  mou_signatory_title?: InputMaybe<Order_By>;
  mou_sponsor_tiers?: InputMaybe<Order_By>;
  nft_contract_address?: InputMaybe<Order_By>;
  notaccepted_msg?: InputMaybe<Order_By>;
  offline_judge?: InputMaybe<Order_By>;
  on_chain_credentials_enabled?: InputMaybe<Order_By>;
  on_chain_credentials_gasless?: InputMaybe<Order_By>;
  online_hackathon_reminder?: InputMaybe<Order_By>;
  online_judging_enabled?: InputMaybe<Order_By>;
  organizer_discord_channel_created?: InputMaybe<Order_By>;
  organizer_phone_number?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  partner_logos_added?: InputMaybe<Order_By>;
  payment_mode?: InputMaybe<Order_By>;
  percentage_complete?: InputMaybe<Order_By>;
  primary_color?: InputMaybe<Order_By>;
  processed_schwag_entities?: InputMaybe<Order_By>;
  quadratic_voting_chain?: InputMaybe<Order_By>;
  quadratic_voting_currency?: InputMaybe<Order_By>;
  quadratic_voting_enabled?: InputMaybe<Order_By>;
  quadratic_voting_ends_at?: InputMaybe<Order_By>;
  quadratic_voting_prize_pool_amount?: InputMaybe<Order_By>;
  quadratic_voting_results_announced?: InputMaybe<Order_By>;
  quadratic_voting_starts_at?: InputMaybe<Order_By>;
  quadratic_voting_total_votes?: InputMaybe<Order_By>;
  razorpay_desc?: InputMaybe<Order_By>;
  razorpay_title?: InputMaybe<Order_By>;
  referral_prize_doc_link?: InputMaybe<Order_By>;
  reg_ends_at?: InputMaybe<Order_By>;
  reg_starts_at?: InputMaybe<Order_By>;
  reminder_email_sent_at?: InputMaybe<Order_By>;
  review?: InputMaybe<Order_By>;
  rsvp_time?: InputMaybe<Order_By>;
  schwag_organizers_count?: InputMaybe<Order_By>;
  schwag_winners_count?: InputMaybe<Order_By>;
  schwags_process_state?: InputMaybe<Order_By>;
  show_more_hackathons?: InputMaybe<Order_By>;
  site?: InputMaybe<Order_By>;
  slack?: InputMaybe<Order_By>;
  sponsor_judging_enabled?: InputMaybe<Order_By>;
  staking_for_rsvp?: InputMaybe<Order_By>;
  subdomain?: InputMaybe<Order_By>;
  syncing_enabled?: InputMaybe<Order_By>;
  telegram?: InputMaybe<Order_By>;
  ticket_font_color?: InputMaybe<Order_By>;
  ticket_img?: InputMaybe<Order_By>;
  ticket_limit?: InputMaybe<Order_By>;
  ticket_limit_f?: InputMaybe<Order_By>;
  ticket_limit_m?: InputMaybe<Order_By>;
  ticket_msg1?: InputMaybe<Order_By>;
  ticket_msg2?: InputMaybe<Order_By>;
  ticket_refundable?: InputMaybe<Order_By>;
  tnc_url?: InputMaybe<Order_By>;
  tokenproof_gating_enabled?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upload_option?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  v2_application_enabled?: InputMaybe<Order_By>;
  voting?: InputMaybe<Order_By>;
  waitlist_msg?: InputMaybe<Order_By>;
  whitelist_domain?: InputMaybe<Order_By>;
  winner_announce_at?: InputMaybe<Order_By>;
  winner_announced?: InputMaybe<Order_By>;
  women_only?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_settings */
export type Hackathon_Settings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Hackathon_Settings_Prepend_Input = {
  mou_sponsor_tiers?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "hackathon_settings" */
export enum Hackathon_Settings_Select_Column {
  /** column name */
  AiAssistedReviewsEnabled = 'ai_assisted_reviews_enabled',
  /** column name */
  AiAssistedReviewsOnboardingCompleted = 'ai_assisted_reviews_onboarding_completed',
  /** column name */
  AllowAnnouncementsPostHackathon = 'allow_announcements_post_hackathon',
  /** column name */
  AllowTravelReimbursement = 'allow_travel_reimbursement',
  /** column name */
  ApplyNowIntegrated = 'apply_now_integrated',
  /** column name */
  BountiesProcessType = 'bounties_process_type',
  /** column name */
  BountiesStatus = 'bounties_status',
  /** column name */
  CheerEnabled = 'cheer_enabled',
  /** column name */
  CocUrl = 'coc_url',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPhase = 'current_phase',
  /** column name */
  DataExportCopy = 'data_export_copy',
  /** column name */
  Discord = 'discord',
  /** column name */
  DiscordBotChannelName = 'discord_bot_channel_name',
  /** column name */
  DiscordCheckinEnable = 'discord_checkin_enable',
  /** column name */
  DiscordGuildId = 'discord_guild_id',
  /** column name */
  DiscordRole = 'discord_role',
  /** column name */
  EligibleEntities = 'eligible_entities',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  EnableBargraph = 'enable_bargraph',
  /** column name */
  ExternalApplyUrl = 'external_apply_url',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Farcaster = 'farcaster',
  /** column name */
  FeaturedCoverImg = 'featured_cover_img',
  /** column name */
  FeaturedCoverImgV2 = 'featured_cover_img_v2',
  /** column name */
  FeedbackReminderSentAt = 'feedback_reminder_sent_at',
  /** column name */
  HackathonCredentialsChain = 'hackathon_credentials_chain',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HackathonSchwagsParticipantsProductId = 'hackathon_schwags_participants_product_id',
  /** column name */
  HackathonSchwagsWinnersProductId = 'hackathon_schwags_winners_product_id',
  /** column name */
  HackersGuideUrl = 'hackers_guide_url',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsHybrid = 'is_hybrid',
  /** column name */
  JudgingEnabled = 'judging_enabled',
  /** column name */
  JudgingEndsAt = 'judging_ends_at',
  /** column name */
  JudgingFactors = 'judging_factors',
  /** column name */
  JudgingStartsAt = 'judging_starts_at',
  /** column name */
  KycSubmitted = 'kyc_submitted',
  /** column name */
  KycVerified = 'kyc_verified',
  /** column name */
  LeaderboardEnabled = 'leaderboard_enabled',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  LocationLatitude = 'location_latitude',
  /** column name */
  LocationLongitude = 'location_longitude',
  /** column name */
  Logo = 'logo',
  /** column name */
  MaxJudgesPerProject = 'max_judges_per_project',
  /** column name */
  MaxSchwagCustomEntities = 'max_schwag_custom_entities',
  /** column name */
  Medium = 'medium',
  /** column name */
  MidHackathonCheckinEnabled = 'mid_hackathon_checkin_enabled',
  /** column name */
  MidHackathonCheckinEndsAt = 'mid_hackathon_checkin_ends_at',
  /** column name */
  MidHackathonCheckinStartsAt = 'mid_hackathon_checkin_starts_at',
  /** column name */
  MinJudgesPerProject = 'min_judges_per_project',
  /** column name */
  MouPlaceOfSigning = 'mou_place_of_signing',
  /** column name */
  MouSignatoryEmailId = 'mou_signatory_email_id',
  /** column name */
  MouSignatoryName = 'mou_signatory_name',
  /** column name */
  MouSignatoryTeam = 'mou_signatory_team',
  /** column name */
  MouSignatoryTitle = 'mou_signatory_title',
  /** column name */
  MouSponsorTiers = 'mou_sponsor_tiers',
  /** column name */
  NftContractAddress = 'nft_contract_address',
  /** column name */
  NotacceptedMsg = 'notaccepted_msg',
  /** column name */
  OfflineJudge = 'offline_judge',
  /** column name */
  OnChainCredentialsEnabled = 'on_chain_credentials_enabled',
  /** column name */
  OnChainCredentialsGasless = 'on_chain_credentials_gasless',
  /** column name */
  OnlineHackathonReminder = 'online_hackathon_reminder',
  /** column name */
  OnlineJudgingEnabled = 'online_judging_enabled',
  /** column name */
  OrganizerDiscordChannelCreated = 'organizer_discord_channel_created',
  /** column name */
  OrganizerPhoneNumber = 'organizer_phone_number',
  /** column name */
  Paid = 'paid',
  /** column name */
  PartnerLogosAdded = 'partner_logos_added',
  /** column name */
  PaymentMode = 'payment_mode',
  /** column name */
  PercentageComplete = 'percentage_complete',
  /** column name */
  PrimaryColor = 'primary_color',
  /** column name */
  ProcessedSchwagEntities = 'processed_schwag_entities',
  /** column name */
  QuadraticVotingChain = 'quadratic_voting_chain',
  /** column name */
  QuadraticVotingCurrency = 'quadratic_voting_currency',
  /** column name */
  QuadraticVotingEnabled = 'quadratic_voting_enabled',
  /** column name */
  QuadraticVotingEndsAt = 'quadratic_voting_ends_at',
  /** column name */
  QuadraticVotingPrizePoolAmount = 'quadratic_voting_prize_pool_amount',
  /** column name */
  QuadraticVotingResultsAnnounced = 'quadratic_voting_results_announced',
  /** column name */
  QuadraticVotingStartsAt = 'quadratic_voting_starts_at',
  /** column name */
  QuadraticVotingTotalVotes = 'quadratic_voting_total_votes',
  /** column name */
  RazorpayDesc = 'razorpay_desc',
  /** column name */
  RazorpayTitle = 'razorpay_title',
  /** column name */
  ReferralPrizeDocLink = 'referral_prize_doc_link',
  /** column name */
  RegEndsAt = 'reg_ends_at',
  /** column name */
  RegStartsAt = 'reg_starts_at',
  /** column name */
  ReminderEmailSentAt = 'reminder_email_sent_at',
  /** column name */
  Review = 'review',
  /** column name */
  RsvpTime = 'rsvp_time',
  /** column name */
  SchwagOrganizersCount = 'schwag_organizers_count',
  /** column name */
  SchwagWinnersCount = 'schwag_winners_count',
  /** column name */
  SchwagsProcessState = 'schwags_process_state',
  /** column name */
  ShowMoreHackathons = 'show_more_hackathons',
  /** column name */
  Site = 'site',
  /** column name */
  Slack = 'slack',
  /** column name */
  SponsorJudgingEnabled = 'sponsor_judging_enabled',
  /** column name */
  StakingForRsvp = 'staking_for_rsvp',
  /** column name */
  Subdomain = 'subdomain',
  /** column name */
  SyncingEnabled = 'syncing_enabled',
  /** column name */
  Telegram = 'telegram',
  /** column name */
  TicketFontColor = 'ticket_font_color',
  /** column name */
  TicketImg = 'ticket_img',
  /** column name */
  TicketLimit = 'ticket_limit',
  /** column name */
  TicketLimitF = 'ticket_limit_f',
  /** column name */
  TicketLimitM = 'ticket_limit_m',
  /** column name */
  TicketMsg1 = 'ticket_msg1',
  /** column name */
  TicketMsg2 = 'ticket_msg2',
  /** column name */
  TicketRefundable = 'ticket_refundable',
  /** column name */
  TncUrl = 'tnc_url',
  /** column name */
  TokenproofGatingEnabled = 'tokenproof_gating_enabled',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadOption = 'upload_option',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  V2ApplicationEnabled = 'v2_application_enabled',
  /** column name */
  Voting = 'voting',
  /** column name */
  WaitlistMsg = 'waitlist_msg',
  /** column name */
  WhitelistDomain = 'whitelist_domain',
  /** column name */
  WinnerAnnounceAt = 'winner_announce_at',
  /** column name */
  WinnerAnnounced = 'winner_announced',
  /** column name */
  WomenOnly = 'women_only'
}

/** input type for updating data in table "hackathon_settings" */
export type Hackathon_Settings_Set_Input = {
  ai_assisted_reviews_enabled?: InputMaybe<Scalars['Boolean']>;
  ai_assisted_reviews_onboarding_completed?: InputMaybe<Scalars['Boolean']>;
  allow_announcements_post_hackathon?: InputMaybe<Scalars['Boolean']>;
  allow_travel_reimbursement?: InputMaybe<Scalars['Boolean']>;
  apply_now_integrated?: InputMaybe<Scalars['Boolean']>;
  bounties_process_type?: InputMaybe<User_Hackathon_Bounties_Type_Enum>;
  bounties_status?: InputMaybe<Hackathon_Bounties_Status_Enum>;
  cheer_enabled?: InputMaybe<Scalars['Boolean']>;
  coc_url?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['citext']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_phase?: InputMaybe<Scalars['Int']>;
  data_export_copy?: InputMaybe<Scalars['String']>;
  discord?: InputMaybe<Scalars['String']>;
  discord_bot_channel_name?: InputMaybe<Scalars['String']>;
  discord_checkin_enable?: InputMaybe<Scalars['Boolean']>;
  discord_guild_id?: InputMaybe<Scalars['String']>;
  discord_role?: InputMaybe<Scalars['String']>;
  eligible_entities?: InputMaybe<Scalars['_text']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  enable_bargraph?: InputMaybe<Scalars['Boolean']>;
  external_apply_url?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  farcaster?: InputMaybe<Scalars['String']>;
  featured_cover_img?: InputMaybe<Scalars['String']>;
  featured_cover_img_v2?: InputMaybe<Scalars['String']>;
  feedback_reminder_sent_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_credentials_chain?: InputMaybe<Hackathon_Credentials_Chain_Enum>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_schwags_participants_product_id?: InputMaybe<Scalars['Int']>;
  hackathon_schwags_winners_product_id?: InputMaybe<Scalars['Int']>;
  hackers_guide_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_hybrid?: InputMaybe<Scalars['Boolean']>;
  judging_enabled?: InputMaybe<Scalars['Boolean']>;
  judging_ends_at?: InputMaybe<Scalars['timestamptz']>;
  judging_factors?: InputMaybe<Scalars['String']>;
  judging_starts_at?: InputMaybe<Scalars['timestamptz']>;
  kyc_submitted?: InputMaybe<Scalars['Boolean']>;
  kyc_verified?: InputMaybe<Scalars['Boolean']>;
  leaderboard_enabled?: InputMaybe<Scalars['Boolean']>;
  linkedin?: InputMaybe<Scalars['String']>;
  location_latitude?: InputMaybe<Scalars['float8']>;
  location_longitude?: InputMaybe<Scalars['float8']>;
  logo?: InputMaybe<Scalars['String']>;
  max_judges_per_project?: InputMaybe<Scalars['Int']>;
  max_schwag_custom_entities?: InputMaybe<Scalars['Int']>;
  medium?: InputMaybe<Scalars['String']>;
  mid_hackathon_checkin_enabled?: InputMaybe<Scalars['Boolean']>;
  mid_hackathon_checkin_ends_at?: InputMaybe<Scalars['timestamptz']>;
  mid_hackathon_checkin_starts_at?: InputMaybe<Scalars['timestamptz']>;
  min_judges_per_project?: InputMaybe<Scalars['Int']>;
  mou_place_of_signing?: InputMaybe<Scalars['String']>;
  mou_signatory_email_id?: InputMaybe<Scalars['String']>;
  mou_signatory_name?: InputMaybe<Scalars['String']>;
  mou_signatory_team?: InputMaybe<Scalars['String']>;
  mou_signatory_title?: InputMaybe<Scalars['String']>;
  mou_sponsor_tiers?: InputMaybe<Scalars['jsonb']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  notaccepted_msg?: InputMaybe<Scalars['String']>;
  offline_judge?: InputMaybe<Scalars['Boolean']>;
  on_chain_credentials_enabled?: InputMaybe<Scalars['Boolean']>;
  on_chain_credentials_gasless?: InputMaybe<Scalars['Boolean']>;
  online_hackathon_reminder?: InputMaybe<Scalars['Boolean']>;
  online_judging_enabled?: InputMaybe<Scalars['Boolean']>;
  organizer_discord_channel_created?: InputMaybe<Scalars['Boolean']>;
  organizer_phone_number?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  partner_logos_added?: InputMaybe<Scalars['Boolean']>;
  payment_mode?: InputMaybe<Scalars['String']>;
  percentage_complete?: InputMaybe<Scalars['Int']>;
  primary_color?: InputMaybe<Scalars['String']>;
  processed_schwag_entities?: InputMaybe<Scalars['_text']>;
  quadratic_voting_chain?: InputMaybe<Quadratic_Voting_Chain_Enum>;
  quadratic_voting_currency?: InputMaybe<Quadratic_Voting_Currency_Enum>;
  quadratic_voting_enabled?: InputMaybe<Scalars['Boolean']>;
  quadratic_voting_ends_at?: InputMaybe<Scalars['timestamptz']>;
  quadratic_voting_prize_pool_amount?: InputMaybe<Scalars['Int']>;
  quadratic_voting_results_announced?: InputMaybe<Scalars['Boolean']>;
  quadratic_voting_starts_at?: InputMaybe<Scalars['timestamptz']>;
  quadratic_voting_total_votes?: InputMaybe<Scalars['Int']>;
  razorpay_desc?: InputMaybe<Scalars['String']>;
  razorpay_title?: InputMaybe<Scalars['String']>;
  referral_prize_doc_link?: InputMaybe<Scalars['String']>;
  reg_ends_at?: InputMaybe<Scalars['timestamptz']>;
  reg_starts_at?: InputMaybe<Scalars['timestamptz']>;
  reminder_email_sent_at?: InputMaybe<Scalars['timestamptz']>;
  review?: InputMaybe<Scalars['Boolean']>;
  rsvp_time?: InputMaybe<Scalars['Int']>;
  schwag_organizers_count?: InputMaybe<Scalars['Int']>;
  schwag_winners_count?: InputMaybe<Scalars['Int']>;
  schwags_process_state?: InputMaybe<Scalars['String']>;
  show_more_hackathons?: InputMaybe<Scalars['Boolean']>;
  site?: InputMaybe<Scalars['String']>;
  slack?: InputMaybe<Scalars['String']>;
  sponsor_judging_enabled?: InputMaybe<Scalars['Boolean']>;
  staking_for_rsvp?: InputMaybe<Scalars['Boolean']>;
  subdomain?: InputMaybe<Scalars['citext']>;
  syncing_enabled?: InputMaybe<Scalars['Boolean']>;
  telegram?: InputMaybe<Scalars['String']>;
  ticket_font_color?: InputMaybe<Scalars['String']>;
  ticket_img?: InputMaybe<Scalars['String']>;
  ticket_limit?: InputMaybe<Scalars['Int']>;
  ticket_limit_f?: InputMaybe<Scalars['Int']>;
  ticket_limit_m?: InputMaybe<Scalars['Int']>;
  ticket_msg1?: InputMaybe<Scalars['String']>;
  ticket_msg2?: InputMaybe<Scalars['String']>;
  ticket_refundable?: InputMaybe<Scalars['Boolean']>;
  tnc_url?: InputMaybe<Scalars['String']>;
  tokenproof_gating_enabled?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upload_option?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  v2_application_enabled?: InputMaybe<Scalars['Boolean']>;
  voting?: InputMaybe<Scalars['Boolean']>;
  waitlist_msg?: InputMaybe<Scalars['String']>;
  whitelist_domain?: InputMaybe<Scalars['String']>;
  winner_announce_at?: InputMaybe<Scalars['timestamptz']>;
  winner_announced?: InputMaybe<Scalars['Boolean']>;
  women_only?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Hackathon_Settings_Stddev_Fields = {
  __typename?: 'hackathon_settings_stddev_fields';
  current_phase?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_latitude?: Maybe<Scalars['Float']>;
  location_longitude?: Maybe<Scalars['Float']>;
  max_judges_per_project?: Maybe<Scalars['Float']>;
  max_schwag_custom_entities?: Maybe<Scalars['Float']>;
  min_judges_per_project?: Maybe<Scalars['Float']>;
  percentage_complete?: Maybe<Scalars['Float']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Float']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Float']>;
  rsvp_time?: Maybe<Scalars['Float']>;
  schwag_organizers_count?: Maybe<Scalars['Float']>;
  schwag_winners_count?: Maybe<Scalars['Float']>;
  ticket_limit?: Maybe<Scalars['Float']>;
  ticket_limit_f?: Maybe<Scalars['Float']>;
  ticket_limit_m?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Settings_Stddev_Pop_Fields = {
  __typename?: 'hackathon_settings_stddev_pop_fields';
  current_phase?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_latitude?: Maybe<Scalars['Float']>;
  location_longitude?: Maybe<Scalars['Float']>;
  max_judges_per_project?: Maybe<Scalars['Float']>;
  max_schwag_custom_entities?: Maybe<Scalars['Float']>;
  min_judges_per_project?: Maybe<Scalars['Float']>;
  percentage_complete?: Maybe<Scalars['Float']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Float']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Float']>;
  rsvp_time?: Maybe<Scalars['Float']>;
  schwag_organizers_count?: Maybe<Scalars['Float']>;
  schwag_winners_count?: Maybe<Scalars['Float']>;
  ticket_limit?: Maybe<Scalars['Float']>;
  ticket_limit_f?: Maybe<Scalars['Float']>;
  ticket_limit_m?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Settings_Stddev_Samp_Fields = {
  __typename?: 'hackathon_settings_stddev_samp_fields';
  current_phase?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_latitude?: Maybe<Scalars['Float']>;
  location_longitude?: Maybe<Scalars['Float']>;
  max_judges_per_project?: Maybe<Scalars['Float']>;
  max_schwag_custom_entities?: Maybe<Scalars['Float']>;
  min_judges_per_project?: Maybe<Scalars['Float']>;
  percentage_complete?: Maybe<Scalars['Float']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Float']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Float']>;
  rsvp_time?: Maybe<Scalars['Float']>;
  schwag_organizers_count?: Maybe<Scalars['Float']>;
  schwag_winners_count?: Maybe<Scalars['Float']>;
  ticket_limit?: Maybe<Scalars['Float']>;
  ticket_limit_f?: Maybe<Scalars['Float']>;
  ticket_limit_m?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hackathon_settings" */
export type Hackathon_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Settings_Stream_Cursor_Value_Input = {
  ai_assisted_reviews_enabled?: InputMaybe<Scalars['Boolean']>;
  ai_assisted_reviews_onboarding_completed?: InputMaybe<Scalars['Boolean']>;
  allow_announcements_post_hackathon?: InputMaybe<Scalars['Boolean']>;
  allow_travel_reimbursement?: InputMaybe<Scalars['Boolean']>;
  apply_now_integrated?: InputMaybe<Scalars['Boolean']>;
  bounties_process_type?: InputMaybe<User_Hackathon_Bounties_Type_Enum>;
  bounties_status?: InputMaybe<Hackathon_Bounties_Status_Enum>;
  cheer_enabled?: InputMaybe<Scalars['Boolean']>;
  coc_url?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['citext']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_phase?: InputMaybe<Scalars['Int']>;
  data_export_copy?: InputMaybe<Scalars['String']>;
  discord?: InputMaybe<Scalars['String']>;
  discord_bot_channel_name?: InputMaybe<Scalars['String']>;
  discord_checkin_enable?: InputMaybe<Scalars['Boolean']>;
  discord_guild_id?: InputMaybe<Scalars['String']>;
  discord_role?: InputMaybe<Scalars['String']>;
  eligible_entities?: InputMaybe<Scalars['_text']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  enable_bargraph?: InputMaybe<Scalars['Boolean']>;
  external_apply_url?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  farcaster?: InputMaybe<Scalars['String']>;
  featured_cover_img?: InputMaybe<Scalars['String']>;
  featured_cover_img_v2?: InputMaybe<Scalars['String']>;
  feedback_reminder_sent_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_credentials_chain?: InputMaybe<Hackathon_Credentials_Chain_Enum>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_schwags_participants_product_id?: InputMaybe<Scalars['Int']>;
  hackathon_schwags_winners_product_id?: InputMaybe<Scalars['Int']>;
  hackers_guide_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_hybrid?: InputMaybe<Scalars['Boolean']>;
  judging_enabled?: InputMaybe<Scalars['Boolean']>;
  judging_ends_at?: InputMaybe<Scalars['timestamptz']>;
  judging_factors?: InputMaybe<Scalars['String']>;
  judging_starts_at?: InputMaybe<Scalars['timestamptz']>;
  kyc_submitted?: InputMaybe<Scalars['Boolean']>;
  kyc_verified?: InputMaybe<Scalars['Boolean']>;
  leaderboard_enabled?: InputMaybe<Scalars['Boolean']>;
  linkedin?: InputMaybe<Scalars['String']>;
  location_latitude?: InputMaybe<Scalars['float8']>;
  location_longitude?: InputMaybe<Scalars['float8']>;
  logo?: InputMaybe<Scalars['String']>;
  max_judges_per_project?: InputMaybe<Scalars['Int']>;
  max_schwag_custom_entities?: InputMaybe<Scalars['Int']>;
  medium?: InputMaybe<Scalars['String']>;
  mid_hackathon_checkin_enabled?: InputMaybe<Scalars['Boolean']>;
  mid_hackathon_checkin_ends_at?: InputMaybe<Scalars['timestamptz']>;
  mid_hackathon_checkin_starts_at?: InputMaybe<Scalars['timestamptz']>;
  min_judges_per_project?: InputMaybe<Scalars['Int']>;
  mou_place_of_signing?: InputMaybe<Scalars['String']>;
  mou_signatory_email_id?: InputMaybe<Scalars['String']>;
  mou_signatory_name?: InputMaybe<Scalars['String']>;
  mou_signatory_team?: InputMaybe<Scalars['String']>;
  mou_signatory_title?: InputMaybe<Scalars['String']>;
  mou_sponsor_tiers?: InputMaybe<Scalars['jsonb']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  notaccepted_msg?: InputMaybe<Scalars['String']>;
  offline_judge?: InputMaybe<Scalars['Boolean']>;
  on_chain_credentials_enabled?: InputMaybe<Scalars['Boolean']>;
  on_chain_credentials_gasless?: InputMaybe<Scalars['Boolean']>;
  online_hackathon_reminder?: InputMaybe<Scalars['Boolean']>;
  online_judging_enabled?: InputMaybe<Scalars['Boolean']>;
  organizer_discord_channel_created?: InputMaybe<Scalars['Boolean']>;
  organizer_phone_number?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  partner_logos_added?: InputMaybe<Scalars['Boolean']>;
  payment_mode?: InputMaybe<Scalars['String']>;
  percentage_complete?: InputMaybe<Scalars['Int']>;
  primary_color?: InputMaybe<Scalars['String']>;
  processed_schwag_entities?: InputMaybe<Scalars['_text']>;
  quadratic_voting_chain?: InputMaybe<Quadratic_Voting_Chain_Enum>;
  quadratic_voting_currency?: InputMaybe<Quadratic_Voting_Currency_Enum>;
  quadratic_voting_enabled?: InputMaybe<Scalars['Boolean']>;
  quadratic_voting_ends_at?: InputMaybe<Scalars['timestamptz']>;
  quadratic_voting_prize_pool_amount?: InputMaybe<Scalars['Int']>;
  quadratic_voting_results_announced?: InputMaybe<Scalars['Boolean']>;
  quadratic_voting_starts_at?: InputMaybe<Scalars['timestamptz']>;
  quadratic_voting_total_votes?: InputMaybe<Scalars['Int']>;
  razorpay_desc?: InputMaybe<Scalars['String']>;
  razorpay_title?: InputMaybe<Scalars['String']>;
  referral_prize_doc_link?: InputMaybe<Scalars['String']>;
  reg_ends_at?: InputMaybe<Scalars['timestamptz']>;
  reg_starts_at?: InputMaybe<Scalars['timestamptz']>;
  reminder_email_sent_at?: InputMaybe<Scalars['timestamptz']>;
  review?: InputMaybe<Scalars['Boolean']>;
  rsvp_time?: InputMaybe<Scalars['Int']>;
  schwag_organizers_count?: InputMaybe<Scalars['Int']>;
  schwag_winners_count?: InputMaybe<Scalars['Int']>;
  schwags_process_state?: InputMaybe<Scalars['String']>;
  show_more_hackathons?: InputMaybe<Scalars['Boolean']>;
  site?: InputMaybe<Scalars['String']>;
  slack?: InputMaybe<Scalars['String']>;
  sponsor_judging_enabled?: InputMaybe<Scalars['Boolean']>;
  staking_for_rsvp?: InputMaybe<Scalars['Boolean']>;
  subdomain?: InputMaybe<Scalars['citext']>;
  syncing_enabled?: InputMaybe<Scalars['Boolean']>;
  telegram?: InputMaybe<Scalars['String']>;
  ticket_font_color?: InputMaybe<Scalars['String']>;
  ticket_img?: InputMaybe<Scalars['String']>;
  ticket_limit?: InputMaybe<Scalars['Int']>;
  ticket_limit_f?: InputMaybe<Scalars['Int']>;
  ticket_limit_m?: InputMaybe<Scalars['Int']>;
  ticket_msg1?: InputMaybe<Scalars['String']>;
  ticket_msg2?: InputMaybe<Scalars['String']>;
  ticket_refundable?: InputMaybe<Scalars['Boolean']>;
  tnc_url?: InputMaybe<Scalars['String']>;
  tokenproof_gating_enabled?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upload_option?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  v2_application_enabled?: InputMaybe<Scalars['Boolean']>;
  voting?: InputMaybe<Scalars['Boolean']>;
  waitlist_msg?: InputMaybe<Scalars['String']>;
  whitelist_domain?: InputMaybe<Scalars['String']>;
  winner_announce_at?: InputMaybe<Scalars['timestamptz']>;
  winner_announced?: InputMaybe<Scalars['Boolean']>;
  women_only?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Hackathon_Settings_Sum_Fields = {
  __typename?: 'hackathon_settings_sum_fields';
  current_phase?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Int']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location_latitude?: Maybe<Scalars['float8']>;
  location_longitude?: Maybe<Scalars['float8']>;
  max_judges_per_project?: Maybe<Scalars['Int']>;
  max_schwag_custom_entities?: Maybe<Scalars['Int']>;
  min_judges_per_project?: Maybe<Scalars['Int']>;
  percentage_complete?: Maybe<Scalars['Int']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Int']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Int']>;
  rsvp_time?: Maybe<Scalars['Int']>;
  schwag_organizers_count?: Maybe<Scalars['Int']>;
  schwag_winners_count?: Maybe<Scalars['Int']>;
  ticket_limit?: Maybe<Scalars['Int']>;
  ticket_limit_f?: Maybe<Scalars['Int']>;
  ticket_limit_m?: Maybe<Scalars['Int']>;
};

/** update columns of table "hackathon_settings" */
export enum Hackathon_Settings_Update_Column {
  /** column name */
  AiAssistedReviewsEnabled = 'ai_assisted_reviews_enabled',
  /** column name */
  AiAssistedReviewsOnboardingCompleted = 'ai_assisted_reviews_onboarding_completed',
  /** column name */
  AllowAnnouncementsPostHackathon = 'allow_announcements_post_hackathon',
  /** column name */
  AllowTravelReimbursement = 'allow_travel_reimbursement',
  /** column name */
  ApplyNowIntegrated = 'apply_now_integrated',
  /** column name */
  BountiesProcessType = 'bounties_process_type',
  /** column name */
  BountiesStatus = 'bounties_status',
  /** column name */
  CheerEnabled = 'cheer_enabled',
  /** column name */
  CocUrl = 'coc_url',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPhase = 'current_phase',
  /** column name */
  DataExportCopy = 'data_export_copy',
  /** column name */
  Discord = 'discord',
  /** column name */
  DiscordBotChannelName = 'discord_bot_channel_name',
  /** column name */
  DiscordCheckinEnable = 'discord_checkin_enable',
  /** column name */
  DiscordGuildId = 'discord_guild_id',
  /** column name */
  DiscordRole = 'discord_role',
  /** column name */
  EligibleEntities = 'eligible_entities',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  EnableBargraph = 'enable_bargraph',
  /** column name */
  ExternalApplyUrl = 'external_apply_url',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Farcaster = 'farcaster',
  /** column name */
  FeaturedCoverImg = 'featured_cover_img',
  /** column name */
  FeaturedCoverImgV2 = 'featured_cover_img_v2',
  /** column name */
  FeedbackReminderSentAt = 'feedback_reminder_sent_at',
  /** column name */
  HackathonCredentialsChain = 'hackathon_credentials_chain',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HackathonSchwagsParticipantsProductId = 'hackathon_schwags_participants_product_id',
  /** column name */
  HackathonSchwagsWinnersProductId = 'hackathon_schwags_winners_product_id',
  /** column name */
  HackersGuideUrl = 'hackers_guide_url',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsHybrid = 'is_hybrid',
  /** column name */
  JudgingEnabled = 'judging_enabled',
  /** column name */
  JudgingEndsAt = 'judging_ends_at',
  /** column name */
  JudgingFactors = 'judging_factors',
  /** column name */
  JudgingStartsAt = 'judging_starts_at',
  /** column name */
  KycSubmitted = 'kyc_submitted',
  /** column name */
  KycVerified = 'kyc_verified',
  /** column name */
  LeaderboardEnabled = 'leaderboard_enabled',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  LocationLatitude = 'location_latitude',
  /** column name */
  LocationLongitude = 'location_longitude',
  /** column name */
  Logo = 'logo',
  /** column name */
  MaxJudgesPerProject = 'max_judges_per_project',
  /** column name */
  MaxSchwagCustomEntities = 'max_schwag_custom_entities',
  /** column name */
  Medium = 'medium',
  /** column name */
  MidHackathonCheckinEnabled = 'mid_hackathon_checkin_enabled',
  /** column name */
  MidHackathonCheckinEndsAt = 'mid_hackathon_checkin_ends_at',
  /** column name */
  MidHackathonCheckinStartsAt = 'mid_hackathon_checkin_starts_at',
  /** column name */
  MinJudgesPerProject = 'min_judges_per_project',
  /** column name */
  MouPlaceOfSigning = 'mou_place_of_signing',
  /** column name */
  MouSignatoryEmailId = 'mou_signatory_email_id',
  /** column name */
  MouSignatoryName = 'mou_signatory_name',
  /** column name */
  MouSignatoryTeam = 'mou_signatory_team',
  /** column name */
  MouSignatoryTitle = 'mou_signatory_title',
  /** column name */
  MouSponsorTiers = 'mou_sponsor_tiers',
  /** column name */
  NftContractAddress = 'nft_contract_address',
  /** column name */
  NotacceptedMsg = 'notaccepted_msg',
  /** column name */
  OfflineJudge = 'offline_judge',
  /** column name */
  OnChainCredentialsEnabled = 'on_chain_credentials_enabled',
  /** column name */
  OnChainCredentialsGasless = 'on_chain_credentials_gasless',
  /** column name */
  OnlineHackathonReminder = 'online_hackathon_reminder',
  /** column name */
  OnlineJudgingEnabled = 'online_judging_enabled',
  /** column name */
  OrganizerDiscordChannelCreated = 'organizer_discord_channel_created',
  /** column name */
  OrganizerPhoneNumber = 'organizer_phone_number',
  /** column name */
  Paid = 'paid',
  /** column name */
  PartnerLogosAdded = 'partner_logos_added',
  /** column name */
  PaymentMode = 'payment_mode',
  /** column name */
  PercentageComplete = 'percentage_complete',
  /** column name */
  PrimaryColor = 'primary_color',
  /** column name */
  ProcessedSchwagEntities = 'processed_schwag_entities',
  /** column name */
  QuadraticVotingChain = 'quadratic_voting_chain',
  /** column name */
  QuadraticVotingCurrency = 'quadratic_voting_currency',
  /** column name */
  QuadraticVotingEnabled = 'quadratic_voting_enabled',
  /** column name */
  QuadraticVotingEndsAt = 'quadratic_voting_ends_at',
  /** column name */
  QuadraticVotingPrizePoolAmount = 'quadratic_voting_prize_pool_amount',
  /** column name */
  QuadraticVotingResultsAnnounced = 'quadratic_voting_results_announced',
  /** column name */
  QuadraticVotingStartsAt = 'quadratic_voting_starts_at',
  /** column name */
  QuadraticVotingTotalVotes = 'quadratic_voting_total_votes',
  /** column name */
  RazorpayDesc = 'razorpay_desc',
  /** column name */
  RazorpayTitle = 'razorpay_title',
  /** column name */
  ReferralPrizeDocLink = 'referral_prize_doc_link',
  /** column name */
  RegEndsAt = 'reg_ends_at',
  /** column name */
  RegStartsAt = 'reg_starts_at',
  /** column name */
  ReminderEmailSentAt = 'reminder_email_sent_at',
  /** column name */
  Review = 'review',
  /** column name */
  RsvpTime = 'rsvp_time',
  /** column name */
  SchwagOrganizersCount = 'schwag_organizers_count',
  /** column name */
  SchwagWinnersCount = 'schwag_winners_count',
  /** column name */
  SchwagsProcessState = 'schwags_process_state',
  /** column name */
  ShowMoreHackathons = 'show_more_hackathons',
  /** column name */
  Site = 'site',
  /** column name */
  Slack = 'slack',
  /** column name */
  SponsorJudgingEnabled = 'sponsor_judging_enabled',
  /** column name */
  StakingForRsvp = 'staking_for_rsvp',
  /** column name */
  Subdomain = 'subdomain',
  /** column name */
  SyncingEnabled = 'syncing_enabled',
  /** column name */
  Telegram = 'telegram',
  /** column name */
  TicketFontColor = 'ticket_font_color',
  /** column name */
  TicketImg = 'ticket_img',
  /** column name */
  TicketLimit = 'ticket_limit',
  /** column name */
  TicketLimitF = 'ticket_limit_f',
  /** column name */
  TicketLimitM = 'ticket_limit_m',
  /** column name */
  TicketMsg1 = 'ticket_msg1',
  /** column name */
  TicketMsg2 = 'ticket_msg2',
  /** column name */
  TicketRefundable = 'ticket_refundable',
  /** column name */
  TncUrl = 'tnc_url',
  /** column name */
  TokenproofGatingEnabled = 'tokenproof_gating_enabled',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadOption = 'upload_option',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  V2ApplicationEnabled = 'v2_application_enabled',
  /** column name */
  Voting = 'voting',
  /** column name */
  WaitlistMsg = 'waitlist_msg',
  /** column name */
  WhitelistDomain = 'whitelist_domain',
  /** column name */
  WinnerAnnounceAt = 'winner_announce_at',
  /** column name */
  WinnerAnnounced = 'winner_announced',
  /** column name */
  WomenOnly = 'women_only'
}

export type Hackathon_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Hackathon_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Hackathon_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Hackathon_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Hackathon_Settings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Settings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Hackathon_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Settings_Var_Pop_Fields = {
  __typename?: 'hackathon_settings_var_pop_fields';
  current_phase?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_latitude?: Maybe<Scalars['Float']>;
  location_longitude?: Maybe<Scalars['Float']>;
  max_judges_per_project?: Maybe<Scalars['Float']>;
  max_schwag_custom_entities?: Maybe<Scalars['Float']>;
  min_judges_per_project?: Maybe<Scalars['Float']>;
  percentage_complete?: Maybe<Scalars['Float']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Float']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Float']>;
  rsvp_time?: Maybe<Scalars['Float']>;
  schwag_organizers_count?: Maybe<Scalars['Float']>;
  schwag_winners_count?: Maybe<Scalars['Float']>;
  ticket_limit?: Maybe<Scalars['Float']>;
  ticket_limit_f?: Maybe<Scalars['Float']>;
  ticket_limit_m?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hackathon_Settings_Var_Samp_Fields = {
  __typename?: 'hackathon_settings_var_samp_fields';
  current_phase?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_latitude?: Maybe<Scalars['Float']>;
  location_longitude?: Maybe<Scalars['Float']>;
  max_judges_per_project?: Maybe<Scalars['Float']>;
  max_schwag_custom_entities?: Maybe<Scalars['Float']>;
  min_judges_per_project?: Maybe<Scalars['Float']>;
  percentage_complete?: Maybe<Scalars['Float']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Float']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Float']>;
  rsvp_time?: Maybe<Scalars['Float']>;
  schwag_organizers_count?: Maybe<Scalars['Float']>;
  schwag_winners_count?: Maybe<Scalars['Float']>;
  ticket_limit?: Maybe<Scalars['Float']>;
  ticket_limit_f?: Maybe<Scalars['Float']>;
  ticket_limit_m?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hackathon_Settings_Variance_Fields = {
  __typename?: 'hackathon_settings_variance_fields';
  current_phase?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_participants_product_id?: Maybe<Scalars['Float']>;
  hackathon_schwags_winners_product_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_latitude?: Maybe<Scalars['Float']>;
  location_longitude?: Maybe<Scalars['Float']>;
  max_judges_per_project?: Maybe<Scalars['Float']>;
  max_schwag_custom_entities?: Maybe<Scalars['Float']>;
  min_judges_per_project?: Maybe<Scalars['Float']>;
  percentage_complete?: Maybe<Scalars['Float']>;
  quadratic_voting_prize_pool_amount?: Maybe<Scalars['Float']>;
  quadratic_voting_total_votes?: Maybe<Scalars['Float']>;
  rsvp_time?: Maybe<Scalars['Float']>;
  schwag_organizers_count?: Maybe<Scalars['Float']>;
  schwag_winners_count?: Maybe<Scalars['Float']>;
  ticket_limit?: Maybe<Scalars['Float']>;
  ticket_limit_f?: Maybe<Scalars['Float']>;
  ticket_limit_m?: Maybe<Scalars['Float']>;
};

/** This table is used as an enum table to store the types of hackathon staking currencies */
export type Hackathon_Staking_Currency = {
  __typename?: 'hackathon_staking_currency';
  value: Scalars['String'];
};

/** aggregated selection of "hackathon_staking_currency" */
export type Hackathon_Staking_Currency_Aggregate = {
  __typename?: 'hackathon_staking_currency_aggregate';
  aggregate?: Maybe<Hackathon_Staking_Currency_Aggregate_Fields>;
  nodes: Array<Hackathon_Staking_Currency>;
};

/** aggregate fields of "hackathon_staking_currency" */
export type Hackathon_Staking_Currency_Aggregate_Fields = {
  __typename?: 'hackathon_staking_currency_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Staking_Currency_Max_Fields>;
  min?: Maybe<Hackathon_Staking_Currency_Min_Fields>;
};


/** aggregate fields of "hackathon_staking_currency" */
export type Hackathon_Staking_Currency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Staking_Currency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_staking_currency". All fields are combined with a logical 'AND'. */
export type Hackathon_Staking_Currency_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Staking_Currency_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Staking_Currency_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Staking_Currency_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_staking_currency" */
export enum Hackathon_Staking_Currency_Constraint {
  /** unique or primary key constraint on columns "value" */
  HackathonStakingCurrencyPkey = 'hackathon_staking_currency_pkey'
}

export enum Hackathon_Staking_Currency_Enum {
  Eth = 'ETH',
  Inr = 'INR',
  Usd = 'USD'
}

/** Boolean expression to compare columns of type "hackathon_staking_currency_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Staking_Currency_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Staking_Currency_Enum>;
  _in?: InputMaybe<Array<Hackathon_Staking_Currency_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Staking_Currency_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Staking_Currency_Enum>>;
};

/** input type for inserting data into table "hackathon_staking_currency" */
export type Hackathon_Staking_Currency_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Staking_Currency_Max_Fields = {
  __typename?: 'hackathon_staking_currency_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Staking_Currency_Min_Fields = {
  __typename?: 'hackathon_staking_currency_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_staking_currency" */
export type Hackathon_Staking_Currency_Mutation_Response = {
  __typename?: 'hackathon_staking_currency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Staking_Currency>;
};

/** on_conflict condition type for table "hackathon_staking_currency" */
export type Hackathon_Staking_Currency_On_Conflict = {
  constraint: Hackathon_Staking_Currency_Constraint;
  update_columns?: Array<Hackathon_Staking_Currency_Update_Column>;
  where?: InputMaybe<Hackathon_Staking_Currency_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_staking_currency". */
export type Hackathon_Staking_Currency_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_staking_currency */
export type Hackathon_Staking_Currency_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "hackathon_staking_currency" */
export enum Hackathon_Staking_Currency_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_staking_currency" */
export type Hackathon_Staking_Currency_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_staking_currency" */
export type Hackathon_Staking_Currency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Staking_Currency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Staking_Currency_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_staking_currency" */
export enum Hackathon_Staking_Currency_Update_Column {
  /** column name */
  Value = 'value'
}

export type Hackathon_Staking_Currency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Staking_Currency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Staking_Currency_Bool_Exp;
};

/** This table is used as an enum table to store the types of hackathon staking */
export type Hackathon_Staking_Type = {
  __typename?: 'hackathon_staking_type';
  value: Scalars['String'];
};

/** aggregated selection of "hackathon_staking_type" */
export type Hackathon_Staking_Type_Aggregate = {
  __typename?: 'hackathon_staking_type_aggregate';
  aggregate?: Maybe<Hackathon_Staking_Type_Aggregate_Fields>;
  nodes: Array<Hackathon_Staking_Type>;
};

/** aggregate fields of "hackathon_staking_type" */
export type Hackathon_Staking_Type_Aggregate_Fields = {
  __typename?: 'hackathon_staking_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Staking_Type_Max_Fields>;
  min?: Maybe<Hackathon_Staking_Type_Min_Fields>;
};


/** aggregate fields of "hackathon_staking_type" */
export type Hackathon_Staking_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Staking_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_staking_type". All fields are combined with a logical 'AND'. */
export type Hackathon_Staking_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Staking_Type_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Staking_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Staking_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_staking_type" */
export enum Hackathon_Staking_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  HackathonStakingTypePkey = 'hackathon_staking_type_pkey'
}

export enum Hackathon_Staking_Type_Enum {
  Crypto = 'CRYPTO',
  Fiat = 'FIAT'
}

/** Boolean expression to compare columns of type "hackathon_staking_type_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Staking_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Staking_Type_Enum>;
  _in?: InputMaybe<Array<Hackathon_Staking_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Staking_Type_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Staking_Type_Enum>>;
};

/** input type for inserting data into table "hackathon_staking_type" */
export type Hackathon_Staking_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Staking_Type_Max_Fields = {
  __typename?: 'hackathon_staking_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Staking_Type_Min_Fields = {
  __typename?: 'hackathon_staking_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_staking_type" */
export type Hackathon_Staking_Type_Mutation_Response = {
  __typename?: 'hackathon_staking_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Staking_Type>;
};

/** on_conflict condition type for table "hackathon_staking_type" */
export type Hackathon_Staking_Type_On_Conflict = {
  constraint: Hackathon_Staking_Type_Constraint;
  update_columns?: Array<Hackathon_Staking_Type_Update_Column>;
  where?: InputMaybe<Hackathon_Staking_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_staking_type". */
export type Hackathon_Staking_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_staking_type */
export type Hackathon_Staking_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "hackathon_staking_type" */
export enum Hackathon_Staking_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_staking_type" */
export type Hackathon_Staking_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_staking_type" */
export type Hackathon_Staking_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Staking_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Staking_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_staking_type" */
export enum Hackathon_Staking_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Hackathon_Staking_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Staking_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Staking_Type_Bool_Exp;
};

/** This table is used to store the staking information for a hackathon */
export type Hackathon_Stakings = {
  __typename?: 'hackathon_stakings';
  amount: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  currency: Hackathon_Staking_Currency_Enum;
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Hackathon_Staking_Type_Enum;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "hackathon_stakings" */
export type Hackathon_Stakings_Aggregate = {
  __typename?: 'hackathon_stakings_aggregate';
  aggregate?: Maybe<Hackathon_Stakings_Aggregate_Fields>;
  nodes: Array<Hackathon_Stakings>;
};

export type Hackathon_Stakings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Hackathon_Stakings_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Stakings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Stakings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_stakings" */
export type Hackathon_Stakings_Aggregate_Fields = {
  __typename?: 'hackathon_stakings_aggregate_fields';
  avg?: Maybe<Hackathon_Stakings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Stakings_Max_Fields>;
  min?: Maybe<Hackathon_Stakings_Min_Fields>;
  stddev?: Maybe<Hackathon_Stakings_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Stakings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Stakings_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Stakings_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Stakings_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Stakings_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Stakings_Variance_Fields>;
};


/** aggregate fields of "hackathon_stakings" */
export type Hackathon_Stakings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Stakings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_stakings" */
export type Hackathon_Stakings_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Stakings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Stakings_Max_Order_By>;
  min?: InputMaybe<Hackathon_Stakings_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Stakings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Stakings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Stakings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Stakings_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Stakings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Stakings_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Stakings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_stakings" */
export type Hackathon_Stakings_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Stakings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Stakings_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Stakings_Avg_Fields = {
  __typename?: 'hackathon_stakings_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_stakings". All fields are combined with a logical 'AND'. */
export type Hackathon_Stakings_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Stakings_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Stakings_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Hackathon_Staking_Currency_Enum_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Hackathon_Staking_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_stakings" */
export enum Hackathon_Stakings_Constraint {
  /** unique or primary key constraint on columns "hackathon_id", "currency" */
  HackathonStakingsHackathonIdCurrencyKey = 'hackathon_stakings_hackathon_id_currency_key',
  /** unique or primary key constraint on columns "type", "hackathon_id", "currency" */
  HackathonStakingsHackathonIdCurrencyTypeKey = 'hackathon_stakings_hackathon_id_currency_type_key',
  /** unique or primary key constraint on columns "name", "hackathon_id" */
  HackathonStakingsHackathonIdNameKey = 'hackathon_stakings_hackathon_id_name_key',
  /** unique or primary key constraint on columns "id" */
  HackathonStakingsPkey = 'hackathon_stakings_pkey',
  /** unique or primary key constraint on columns "uuid" */
  HackathonStakingsUuidKey = 'hackathon_stakings_uuid_key'
}

/** input type for incrementing numeric columns in table "hackathon_stakings" */
export type Hackathon_Stakings_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_stakings" */
export type Hackathon_Stakings_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Hackathon_Staking_Currency_Enum>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Staking_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Stakings_Max_Fields = {
  __typename?: 'hackathon_stakings_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Stakings_Min_Fields = {
  __typename?: 'hackathon_stakings_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_stakings" */
export type Hackathon_Stakings_Mutation_Response = {
  __typename?: 'hackathon_stakings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Stakings>;
};

/** input type for inserting object relation for remote table "hackathon_stakings" */
export type Hackathon_Stakings_Obj_Rel_Insert_Input = {
  data: Hackathon_Stakings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Stakings_On_Conflict>;
};

/** on_conflict condition type for table "hackathon_stakings" */
export type Hackathon_Stakings_On_Conflict = {
  constraint: Hackathon_Stakings_Constraint;
  update_columns?: Array<Hackathon_Stakings_Update_Column>;
  where?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_stakings". */
export type Hackathon_Stakings_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_stakings */
export type Hackathon_Stakings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_stakings" */
export enum Hackathon_Stakings_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_stakings" */
export type Hackathon_Stakings_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Hackathon_Staking_Currency_Enum>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Staking_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Stakings_Stddev_Fields = {
  __typename?: 'hackathon_stakings_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Stakings_Stddev_Pop_Fields = {
  __typename?: 'hackathon_stakings_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Stakings_Stddev_Samp_Fields = {
  __typename?: 'hackathon_stakings_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_stakings" */
export type Hackathon_Stakings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Stakings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Stakings_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Hackathon_Staking_Currency_Enum>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Staking_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Stakings_Sum_Fields = {
  __typename?: 'hackathon_stakings_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_stakings" */
export enum Hackathon_Stakings_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Stakings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Stakings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Stakings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Stakings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Stakings_Var_Pop_Fields = {
  __typename?: 'hackathon_stakings_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Stakings_Var_Samp_Fields = {
  __typename?: 'hackathon_stakings_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Stakings_Variance_Fields = {
  __typename?: 'hackathon_stakings_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_stakings" */
export type Hackathon_Stakings_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "hackathon_themes" */
export type Hackathon_Themes = {
  __typename?: 'hackathon_themes';
  created_at: Scalars['timestamptz'];
  hackathon_id: Scalars['Int'];
  /** An object relationship */
  theme?: Maybe<Themes>;
  theme_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "hackathon_themes" */
export type Hackathon_Themes_Aggregate = {
  __typename?: 'hackathon_themes_aggregate';
  aggregate?: Maybe<Hackathon_Themes_Aggregate_Fields>;
  nodes: Array<Hackathon_Themes>;
};

export type Hackathon_Themes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Hackathon_Themes_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Themes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Themes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Themes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_themes" */
export type Hackathon_Themes_Aggregate_Fields = {
  __typename?: 'hackathon_themes_aggregate_fields';
  avg?: Maybe<Hackathon_Themes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Themes_Max_Fields>;
  min?: Maybe<Hackathon_Themes_Min_Fields>;
  stddev?: Maybe<Hackathon_Themes_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Themes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Themes_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Themes_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Themes_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Themes_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Themes_Variance_Fields>;
};


/** aggregate fields of "hackathon_themes" */
export type Hackathon_Themes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Themes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_themes" */
export type Hackathon_Themes_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Themes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Themes_Max_Order_By>;
  min?: InputMaybe<Hackathon_Themes_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Themes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Themes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Themes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Themes_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Themes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Themes_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Themes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_themes" */
export type Hackathon_Themes_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Themes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Themes_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Themes_Avg_Fields = {
  __typename?: 'hackathon_themes_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  theme_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_themes". All fields are combined with a logical 'AND'. */
export type Hackathon_Themes_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Themes_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Themes_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Themes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  theme?: InputMaybe<Themes_Bool_Exp>;
  theme_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_themes" */
export enum Hackathon_Themes_Constraint {
  /** unique or primary key constraint on columns "theme_id", "hackathon_id" */
  PkHackathonThemes = 'pk_hackathon_themes',
  /** unique or primary key constraint on columns "theme_id", "hackathon_id" */
  UniqueHackathonIdThemeIdHackathonThemes = 'unique_hackathon_id_theme_id_hackathon_themes'
}

/** input type for incrementing numeric columns in table "hackathon_themes" */
export type Hackathon_Themes_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  theme_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_themes" */
export type Hackathon_Themes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  theme?: InputMaybe<Themes_Obj_Rel_Insert_Input>;
  theme_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Hackathon_Themes_Max_Fields = {
  __typename?: 'hackathon_themes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  theme_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Themes_Min_Fields = {
  __typename?: 'hackathon_themes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  theme_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_themes" */
export type Hackathon_Themes_Mutation_Response = {
  __typename?: 'hackathon_themes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Themes>;
};

/** on_conflict condition type for table "hackathon_themes" */
export type Hackathon_Themes_On_Conflict = {
  constraint: Hackathon_Themes_Constraint;
  update_columns?: Array<Hackathon_Themes_Update_Column>;
  where?: InputMaybe<Hackathon_Themes_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_themes". */
export type Hackathon_Themes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  theme?: InputMaybe<Themes_Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_themes */
export type Hackathon_Themes_Pk_Columns_Input = {
  hackathon_id: Scalars['Int'];
  theme_id: Scalars['Int'];
};

/** select columns of table "hackathon_themes" */
export enum Hackathon_Themes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  ThemeId = 'theme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "hackathon_themes" */
export type Hackathon_Themes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  theme_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Hackathon_Themes_Stddev_Fields = {
  __typename?: 'hackathon_themes_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  theme_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Themes_Stddev_Pop_Fields = {
  __typename?: 'hackathon_themes_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  theme_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Themes_Stddev_Samp_Fields = {
  __typename?: 'hackathon_themes_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  theme_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_themes" */
export type Hackathon_Themes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Themes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Themes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  theme_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Hackathon_Themes_Sum_Fields = {
  __typename?: 'hackathon_themes_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  theme_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_themes" */
export enum Hackathon_Themes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  ThemeId = 'theme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Hackathon_Themes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Themes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Themes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Themes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Themes_Var_Pop_Fields = {
  __typename?: 'hackathon_themes_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  theme_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Themes_Var_Samp_Fields = {
  __typename?: 'hackathon_themes_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  theme_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Themes_Variance_Fields = {
  __typename?: 'hackathon_themes_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  theme_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_themes" */
export type Hackathon_Themes_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
};

/** This table is used to store hackathon tracks */
export type Hackathon_Tracks = {
  __typename?: 'hackathon_tracks';
  amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  currency?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "hackathon_tracks" */
export type Hackathon_Tracks_Aggregate = {
  __typename?: 'hackathon_tracks_aggregate';
  aggregate?: Maybe<Hackathon_Tracks_Aggregate_Fields>;
  nodes: Array<Hackathon_Tracks>;
};

export type Hackathon_Tracks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Hackathon_Tracks_Aggregate_Bool_Exp_Count>;
};

export type Hackathon_Tracks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathon_Tracks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathon_tracks" */
export type Hackathon_Tracks_Aggregate_Fields = {
  __typename?: 'hackathon_tracks_aggregate_fields';
  avg?: Maybe<Hackathon_Tracks_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Tracks_Max_Fields>;
  min?: Maybe<Hackathon_Tracks_Min_Fields>;
  stddev?: Maybe<Hackathon_Tracks_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathon_Tracks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathon_Tracks_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathon_Tracks_Sum_Fields>;
  var_pop?: Maybe<Hackathon_Tracks_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathon_Tracks_Var_Samp_Fields>;
  variance?: Maybe<Hackathon_Tracks_Variance_Fields>;
};


/** aggregate fields of "hackathon_tracks" */
export type Hackathon_Tracks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Tracks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathon_tracks" */
export type Hackathon_Tracks_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathon_Tracks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathon_Tracks_Max_Order_By>;
  min?: InputMaybe<Hackathon_Tracks_Min_Order_By>;
  stddev?: InputMaybe<Hackathon_Tracks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathon_Tracks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathon_Tracks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathon_Tracks_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathon_Tracks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathon_Tracks_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathon_Tracks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "hackathon_tracks" */
export type Hackathon_Tracks_Arr_Rel_Insert_Input = {
  data: Array<Hackathon_Tracks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Tracks_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathon_Tracks_Avg_Fields = {
  __typename?: 'hackathon_tracks_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathon_tracks". All fields are combined with a logical 'AND'. */
export type Hackathon_Tracks_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Tracks_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Tracks_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_tracks" */
export enum Hackathon_Tracks_Constraint {
  /** unique or primary key constraint on columns "id" */
  HackathonTracksPkey = 'hackathon_tracks_pkey',
  /** unique or primary key constraint on columns "uuid" */
  HackathonTracksUuidKey = 'hackathon_tracks_uuid_key'
}

/** input type for incrementing numeric columns in table "hackathon_tracks" */
export type Hackathon_Tracks_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathon_tracks" */
export type Hackathon_Tracks_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Tracks_Max_Fields = {
  __typename?: 'hackathon_tracks_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathon_Tracks_Min_Fields = {
  __typename?: 'hackathon_tracks_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathon_tracks" */
export type Hackathon_Tracks_Mutation_Response = {
  __typename?: 'hackathon_tracks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Tracks>;
};

/** input type for inserting object relation for remote table "hackathon_tracks" */
export type Hackathon_Tracks_Obj_Rel_Insert_Input = {
  data: Hackathon_Tracks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathon_Tracks_On_Conflict>;
};

/** on_conflict condition type for table "hackathon_tracks" */
export type Hackathon_Tracks_On_Conflict = {
  constraint: Hackathon_Tracks_Constraint;
  update_columns?: Array<Hackathon_Tracks_Update_Column>;
  where?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_tracks". */
export type Hackathon_Tracks_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_tracks */
export type Hackathon_Tracks_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hackathon_tracks" */
export enum Hackathon_Tracks_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Desc = 'desc',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "hackathon_tracks" */
export type Hackathon_Tracks_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Hackathon_Tracks_Stddev_Fields = {
  __typename?: 'hackathon_tracks_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathon_Tracks_Stddev_Pop_Fields = {
  __typename?: 'hackathon_tracks_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathon_Tracks_Stddev_Samp_Fields = {
  __typename?: 'hackathon_tracks_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathon_tracks" */
export type Hackathon_Tracks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Tracks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Tracks_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Hackathon_Tracks_Sum_Fields = {
  __typename?: 'hackathon_tracks_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "hackathon_tracks" */
export enum Hackathon_Tracks_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Desc = 'desc',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Hackathon_Tracks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathon_Tracks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Tracks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Tracks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathon_Tracks_Var_Pop_Fields = {
  __typename?: 'hackathon_tracks_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathon_Tracks_Var_Samp_Fields = {
  __typename?: 'hackathon_tracks_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathon_Tracks_Variance_Fields = {
  __typename?: 'hackathon_tracks_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathon_tracks" */
export type Hackathon_Tracks_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** This table is used as an enum table to store the types of a hackathon */
export type Hackathon_Type = {
  __typename?: 'hackathon_type';
  value: Scalars['String'];
};

/** aggregated selection of "hackathon_type" */
export type Hackathon_Type_Aggregate = {
  __typename?: 'hackathon_type_aggregate';
  aggregate?: Maybe<Hackathon_Type_Aggregate_Fields>;
  nodes: Array<Hackathon_Type>;
};

/** aggregate fields of "hackathon_type" */
export type Hackathon_Type_Aggregate_Fields = {
  __typename?: 'hackathon_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hackathon_Type_Max_Fields>;
  min?: Maybe<Hackathon_Type_Min_Fields>;
};


/** aggregate fields of "hackathon_type" */
export type Hackathon_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathon_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "hackathon_type". All fields are combined with a logical 'AND'. */
export type Hackathon_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathon_Type_Bool_Exp>>;
  _not?: InputMaybe<Hackathon_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathon_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathon_type" */
export enum Hackathon_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  HackathonTypePkey = 'hackathon_type_pkey'
}

export enum Hackathon_Type_Enum {
  Fellowship = 'FELLOWSHIP',
  Grant = 'GRANT',
  Hackathon = 'HACKATHON',
  Workshop = 'WORKSHOP'
}

/** Boolean expression to compare columns of type "hackathon_type_enum". All fields are combined with logical 'AND'. */
export type Hackathon_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hackathon_Type_Enum>;
  _in?: InputMaybe<Array<Hackathon_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Hackathon_Type_Enum>;
  _nin?: InputMaybe<Array<Hackathon_Type_Enum>>;
};

/** input type for inserting data into table "hackathon_type" */
export type Hackathon_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hackathon_Type_Max_Fields = {
  __typename?: 'hackathon_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hackathon_Type_Min_Fields = {
  __typename?: 'hackathon_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hackathon_type" */
export type Hackathon_Type_Mutation_Response = {
  __typename?: 'hackathon_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathon_Type>;
};

/** on_conflict condition type for table "hackathon_type" */
export type Hackathon_Type_On_Conflict = {
  constraint: Hackathon_Type_Constraint;
  update_columns?: Array<Hackathon_Type_Update_Column>;
  where?: InputMaybe<Hackathon_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathon_type". */
export type Hackathon_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathon_type */
export type Hackathon_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "hackathon_type" */
export enum Hackathon_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hackathon_type" */
export type Hackathon_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hackathon_type" */
export type Hackathon_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathon_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathon_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hackathon_type" */
export enum Hackathon_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Hackathon_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathon_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathon_Type_Bool_Exp;
};

/** columns and relationships of "hackathons" */
export type Hackathons = {
  __typename?: 'hackathons';
  /** This function is used to prefix the ASSETS_URL */
  _cover_img?: Maybe<Scalars['String']>;
  /** This function is used for adding the assets prefix to the favicon field */
  _favicon?: Maybe<Scalars['String']>;
  apply_mode?: Maybe<Scalars['hackathons_apply_mode_enum']>;
  approx_participant?: Maybe<Scalars['String']>;
  /** An object relationship */
  brand?: Maybe<Hackathon_Brands>;
  brand_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  checklists: Array<Hackathon_Checklists>;
  /** An aggregate relationship */
  checklists_aggregate: Hackathon_Checklists_Aggregate;
  city?: Maybe<Scalars['String']>;
  college_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  cover_img?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  desc?: Maybe<Scalars['String']>;
  devfolio_official?: Maybe<Scalars['Boolean']>;
  discover: Scalars['Boolean'];
  edition?: Maybe<Scalars['Int']>;
  edition_name?: Maybe<Scalars['String']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  events: Array<Hackathon_Events>;
  /** An aggregate relationship */
  events_aggregate: Hackathon_Events_Aggregate;
  /** An array relationship */
  faqs: Array<Hackathon_Faq>;
  /** An aggregate relationship */
  faqs_aggregate: Hackathon_Faq_Aggregate;
  /** This field stores the favicon image location for the hackathon */
  favicon?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  /** This boolean flag indicates if the hackathon is a fellowship */
  fellowship: Scalars['Boolean'];
  /** An array relationship */
  hackathon_event_groups: Array<Hackathon_Event_Groups>;
  /** An aggregate relationship */
  hackathon_event_groups_aggregate: Hackathon_Event_Groups_Aggregate;
  id: Scalars['Int'];
  is_online?: Maybe<Scalars['Boolean']>;
  is_university_hackathon: Scalars['Boolean'];
  /** An array relationship */
  judges: Array<Judges>;
  /** An aggregate relationship */
  judges_aggregate: Judges_Aggregate;
  location?: Maybe<Scalars['String']>;
  name: Scalars['citext'];
  /** An array relationship */
  notes: Array<Hackathon_Notes>;
  /** An aggregate relationship */
  notes_aggregate: Hackathon_Notes_Aggregate;
  participants_count?: Maybe<Scalars['Int']>;
  participants_details?: Maybe<Scalars['jsonb']>;
  private?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  prize_tracks: Array<Prize_Tracks>;
  /** An aggregate relationship */
  prize_tracks_aggregate: Prize_Tracks_Aggregate;
  /** An array relationship */
  prizes: Array<Prizes>;
  /** An aggregate relationship */
  prizes_aggregate: Prizes_Aggregate;
  projects_submitted?: Maybe<Scalars['Int']>;
  rating: Scalars['numeric'];
  /** An object relationship */
  schwags?: Maybe<Hackathon_Schwags>;
  /** An object relationship */
  scope?: Maybe<Hackathon_Scopes>;
  /** An array relationship */
  scope_extras: Array<Hackathon_Scope_Extras>;
  /** An aggregate relationship */
  scope_extras_aggregate: Hackathon_Scope_Extras_Aggregate;
  /** An object relationship */
  settings?: Maybe<Hackathon_Settings>;
  slug?: Maybe<Scalars['citext']>;
  /** An array relationship */
  sponsor_tiers: Array<Sponsor_Tiers>;
  /** An aggregate relationship */
  sponsor_tiers_aggregate: Sponsor_Tiers_Aggregate;
  /** An array relationship */
  stakings: Array<Hackathon_Stakings>;
  /** An aggregate relationship */
  stakings_aggregate: Hackathon_Stakings_Aggregate;
  starts_at?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['hackathons_status_enum']>;
  tagline?: Maybe<Scalars['String']>;
  team_min?: Maybe<Scalars['Int']>;
  team_size?: Maybe<Scalars['Int']>;
  themed?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  themes: Array<Hackathon_Themes>;
  /** An aggregate relationship */
  themes_aggregate: Hackathon_Themes_Aggregate;
  timezone?: Maybe<Scalars['String']>;
  /** An array relationship */
  tracks: Array<Hackathon_Tracks>;
  /** An aggregate relationship */
  tracks_aggregate: Hackathon_Tracks_Aggregate;
  type: Hackathon_Type_Enum;
  updated_at: Scalars['timestamptz'];
  uri?: Maybe<Scalars['String']>;
  /** An array relationship */
  user_hackathon_bounties: Array<User_Hackathon_Bounties>;
  /** An aggregate relationship */
  user_hackathon_bounties_aggregate: User_Hackathon_Bounties_Aggregate;
  /** An array relationship */
  user_hackathons: Array<User_Hackathons>;
  /** An aggregate relationship */
  user_hackathons_aggregate: User_Hackathons_Aggregate;
  uuid: Scalars['String'];
  verified?: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "hackathons" */
export type HackathonsChecklistsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsChecklists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsEventsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Events_Order_By>>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Events_Order_By>>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsFaqsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsFaqs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsHackathon_Event_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Groups_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsHackathon_Event_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Groups_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsJudgesArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsJudges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsNotesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Notes_Order_By>>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Notes_Order_By>>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsParticipants_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "hackathons" */
export type HackathonsPrize_TracksArgs = {
  distinct_on?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Tracks_Order_By>>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsPrize_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Tracks_Order_By>>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsPrizesArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsPrizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsScope_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scope_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scope_Extras_Order_By>>;
  where?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsScope_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scope_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scope_Extras_Order_By>>;
  where?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsSponsor_TiersArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Tiers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Tiers_Order_By>>;
  where?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsSponsor_Tiers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Tiers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Tiers_Order_By>>;
  where?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsStakingsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsStakings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsThemesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Themes_Order_By>>;
  where?: InputMaybe<Hackathon_Themes_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsThemes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Themes_Order_By>>;
  where?: InputMaybe<Hackathon_Themes_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsTracksArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Tracks_Order_By>>;
  where?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsTracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Tracks_Order_By>>;
  where?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsUser_Hackathon_BountiesArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsUser_Hackathon_Bounties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsUser_HackathonsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


/** columns and relationships of "hackathons" */
export type HackathonsUser_Hackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};

/** aggregated selection of "hackathons" */
export type Hackathons_Aggregate = {
  __typename?: 'hackathons_aggregate';
  aggregate?: Maybe<Hackathons_Aggregate_Fields>;
  nodes: Array<Hackathons>;
};

export type Hackathons_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Hackathons_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Hackathons_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Hackathons_Aggregate_Bool_Exp_Count>;
};

export type Hackathons_Aggregate_Bool_Exp_Bool_And = {
  arguments: Hackathons_Select_Column_Hackathons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Hackathons_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Hackathons_Select_Column_Hackathons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Hackathons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Hackathons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Hackathons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "hackathons" */
export type Hackathons_Aggregate_Fields = {
  __typename?: 'hackathons_aggregate_fields';
  avg?: Maybe<Hackathons_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hackathons_Max_Fields>;
  min?: Maybe<Hackathons_Min_Fields>;
  stddev?: Maybe<Hackathons_Stddev_Fields>;
  stddev_pop?: Maybe<Hackathons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hackathons_Stddev_Samp_Fields>;
  sum?: Maybe<Hackathons_Sum_Fields>;
  var_pop?: Maybe<Hackathons_Var_Pop_Fields>;
  var_samp?: Maybe<Hackathons_Var_Samp_Fields>;
  variance?: Maybe<Hackathons_Variance_Fields>;
};


/** aggregate fields of "hackathons" */
export type Hackathons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hackathons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "hackathons" */
export type Hackathons_Aggregate_Order_By = {
  avg?: InputMaybe<Hackathons_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hackathons_Max_Order_By>;
  min?: InputMaybe<Hackathons_Min_Order_By>;
  stddev?: InputMaybe<Hackathons_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hackathons_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hackathons_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hackathons_Sum_Order_By>;
  var_pop?: InputMaybe<Hackathons_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hackathons_Var_Samp_Order_By>;
  variance?: InputMaybe<Hackathons_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Hackathons_Append_Input = {
  participants_details?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to compare columns of type "hackathons_apply_mode_enum". All fields are combined with logical 'AND'. */
export type Hackathons_Apply_Mode_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['hackathons_apply_mode_enum']>;
  _gt?: InputMaybe<Scalars['hackathons_apply_mode_enum']>;
  _gte?: InputMaybe<Scalars['hackathons_apply_mode_enum']>;
  _in?: InputMaybe<Array<Scalars['hackathons_apply_mode_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['hackathons_apply_mode_enum']>;
  _lte?: InputMaybe<Scalars['hackathons_apply_mode_enum']>;
  _neq?: InputMaybe<Scalars['hackathons_apply_mode_enum']>;
  _nin?: InputMaybe<Array<Scalars['hackathons_apply_mode_enum']>>;
};

/** input type for inserting array relation for remote table "hackathons" */
export type Hackathons_Arr_Rel_Insert_Input = {
  data: Array<Hackathons_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathons_On_Conflict>;
};

/** aggregate avg on columns */
export type Hackathons_Avg_Fields = {
  __typename?: 'hackathons_avg_fields';
  brand_id?: Maybe<Scalars['Float']>;
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  participants_count?: Maybe<Scalars['Float']>;
  projects_submitted?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  team_min?: Maybe<Scalars['Float']>;
  team_size?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "hackathons" */
export type Hackathons_Avg_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hackathons". All fields are combined with a logical 'AND'. */
export type Hackathons_Bool_Exp = {
  _and?: InputMaybe<Array<Hackathons_Bool_Exp>>;
  _cover_img?: InputMaybe<String_Comparison_Exp>;
  _favicon?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Hackathons_Bool_Exp>;
  _or?: InputMaybe<Array<Hackathons_Bool_Exp>>;
  apply_mode?: InputMaybe<Hackathons_Apply_Mode_Enum_Comparison_Exp>;
  approx_participant?: InputMaybe<String_Comparison_Exp>;
  brand?: InputMaybe<Hackathon_Brands_Bool_Exp>;
  brand_id?: InputMaybe<Int_Comparison_Exp>;
  checklists?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
  checklists_aggregate?: InputMaybe<Hackathon_Checklists_Aggregate_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  college_id?: InputMaybe<Int_Comparison_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  cover_img?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  devfolio_official?: InputMaybe<Boolean_Comparison_Exp>;
  discover?: InputMaybe<Boolean_Comparison_Exp>;
  edition?: InputMaybe<Int_Comparison_Exp>;
  edition_name?: InputMaybe<String_Comparison_Exp>;
  ends_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  events?: InputMaybe<Hackathon_Events_Bool_Exp>;
  events_aggregate?: InputMaybe<Hackathon_Events_Aggregate_Bool_Exp>;
  faqs?: InputMaybe<Hackathon_Faq_Bool_Exp>;
  faqs_aggregate?: InputMaybe<Hackathon_Faq_Aggregate_Bool_Exp>;
  favicon?: InputMaybe<String_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  fellowship?: InputMaybe<Boolean_Comparison_Exp>;
  hackathon_event_groups?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
  hackathon_event_groups_aggregate?: InputMaybe<Hackathon_Event_Groups_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_university_hackathon?: InputMaybe<Boolean_Comparison_Exp>;
  judges?: InputMaybe<Judges_Bool_Exp>;
  judges_aggregate?: InputMaybe<Judges_Aggregate_Bool_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<Citext_Comparison_Exp>;
  notes?: InputMaybe<Hackathon_Notes_Bool_Exp>;
  notes_aggregate?: InputMaybe<Hackathon_Notes_Aggregate_Bool_Exp>;
  participants_count?: InputMaybe<Int_Comparison_Exp>;
  participants_details?: InputMaybe<Jsonb_Comparison_Exp>;
  private?: InputMaybe<Boolean_Comparison_Exp>;
  prize_tracks?: InputMaybe<Prize_Tracks_Bool_Exp>;
  prize_tracks_aggregate?: InputMaybe<Prize_Tracks_Aggregate_Bool_Exp>;
  prizes?: InputMaybe<Prizes_Bool_Exp>;
  prizes_aggregate?: InputMaybe<Prizes_Aggregate_Bool_Exp>;
  projects_submitted?: InputMaybe<Int_Comparison_Exp>;
  rating?: InputMaybe<Numeric_Comparison_Exp>;
  schwags?: InputMaybe<Hackathon_Schwags_Bool_Exp>;
  scope?: InputMaybe<Hackathon_Scopes_Bool_Exp>;
  scope_extras?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
  scope_extras_aggregate?: InputMaybe<Hackathon_Scope_Extras_Aggregate_Bool_Exp>;
  settings?: InputMaybe<Hackathon_Settings_Bool_Exp>;
  slug?: InputMaybe<Citext_Comparison_Exp>;
  sponsor_tiers?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
  sponsor_tiers_aggregate?: InputMaybe<Sponsor_Tiers_Aggregate_Bool_Exp>;
  stakings?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
  stakings_aggregate?: InputMaybe<Hackathon_Stakings_Aggregate_Bool_Exp>;
  starts_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Hackathons_Status_Enum_Comparison_Exp>;
  tagline?: InputMaybe<String_Comparison_Exp>;
  team_min?: InputMaybe<Int_Comparison_Exp>;
  team_size?: InputMaybe<Int_Comparison_Exp>;
  themed?: InputMaybe<Boolean_Comparison_Exp>;
  themes?: InputMaybe<Hackathon_Themes_Bool_Exp>;
  themes_aggregate?: InputMaybe<Hackathon_Themes_Aggregate_Bool_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  tracks?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
  tracks_aggregate?: InputMaybe<Hackathon_Tracks_Aggregate_Bool_Exp>;
  type?: InputMaybe<Hackathon_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uri?: InputMaybe<String_Comparison_Exp>;
  user_hackathon_bounties?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
  user_hackathon_bounties_aggregate?: InputMaybe<User_Hackathon_Bounties_Aggregate_Bool_Exp>;
  user_hackathons?: InputMaybe<User_Hackathons_Bool_Exp>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Bool_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "hackathons" */
export enum Hackathons_Constraint {
  /** unique or primary key constraint on columns "edition", "brand_id" */
  HackathonsBrandIdEdition = 'hackathons_brand_id_edition',
  /** unique or primary key constraint on columns "id" */
  PkHackathons = 'pk_hackathons',
  /** unique or primary key constraint on columns "name" */
  UniqueNameHackathons = 'unique_name_hackathons',
  /** unique or primary key constraint on columns "slug" */
  UniqueSlugHackathons = 'unique_slug_hackathons',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHackathons = 'unique_uuid_hackathons'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Hackathons_Delete_At_Path_Input = {
  participants_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Hackathons_Delete_Elem_Input = {
  participants_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Hackathons_Delete_Key_Input = {
  participants_details?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "hackathons" */
export type Hackathons_Inc_Input = {
  brand_id?: InputMaybe<Scalars['Int']>;
  college_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  edition?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  participants_count?: InputMaybe<Scalars['Int']>;
  projects_submitted?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['numeric']>;
  team_min?: InputMaybe<Scalars['Int']>;
  team_size?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hackathons" */
export type Hackathons_Insert_Input = {
  apply_mode?: InputMaybe<Scalars['hackathons_apply_mode_enum']>;
  approx_participant?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Hackathon_Brands_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['Int']>;
  checklists?: InputMaybe<Hackathon_Checklists_Arr_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']>;
  college_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  cover_img?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  devfolio_official?: InputMaybe<Scalars['Boolean']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  edition?: InputMaybe<Scalars['Int']>;
  edition_name?: InputMaybe<Scalars['String']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  events?: InputMaybe<Hackathon_Events_Arr_Rel_Insert_Input>;
  faqs?: InputMaybe<Hackathon_Faq_Arr_Rel_Insert_Input>;
  /** This field stores the favicon image location for the hackathon */
  favicon?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  /** This boolean flag indicates if the hackathon is a fellowship */
  fellowship?: InputMaybe<Scalars['Boolean']>;
  hackathon_event_groups?: InputMaybe<Hackathon_Event_Groups_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_online?: InputMaybe<Scalars['Boolean']>;
  is_university_hackathon?: InputMaybe<Scalars['Boolean']>;
  judges?: InputMaybe<Judges_Arr_Rel_Insert_Input>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['citext']>;
  notes?: InputMaybe<Hackathon_Notes_Arr_Rel_Insert_Input>;
  participants_count?: InputMaybe<Scalars['Int']>;
  participants_details?: InputMaybe<Scalars['jsonb']>;
  private?: InputMaybe<Scalars['Boolean']>;
  prize_tracks?: InputMaybe<Prize_Tracks_Arr_Rel_Insert_Input>;
  prizes?: InputMaybe<Prizes_Arr_Rel_Insert_Input>;
  projects_submitted?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['numeric']>;
  schwags?: InputMaybe<Hackathon_Schwags_Obj_Rel_Insert_Input>;
  scope?: InputMaybe<Hackathon_Scopes_Obj_Rel_Insert_Input>;
  scope_extras?: InputMaybe<Hackathon_Scope_Extras_Arr_Rel_Insert_Input>;
  settings?: InputMaybe<Hackathon_Settings_Obj_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['citext']>;
  sponsor_tiers?: InputMaybe<Sponsor_Tiers_Arr_Rel_Insert_Input>;
  stakings?: InputMaybe<Hackathon_Stakings_Arr_Rel_Insert_Input>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['hackathons_status_enum']>;
  tagline?: InputMaybe<Scalars['String']>;
  team_min?: InputMaybe<Scalars['Int']>;
  team_size?: InputMaybe<Scalars['Int']>;
  themed?: InputMaybe<Scalars['Boolean']>;
  themes?: InputMaybe<Hackathon_Themes_Arr_Rel_Insert_Input>;
  timezone?: InputMaybe<Scalars['String']>;
  tracks?: InputMaybe<Hackathon_Tracks_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Hackathon_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uri?: InputMaybe<Scalars['String']>;
  user_hackathon_bounties?: InputMaybe<User_Hackathon_Bounties_Arr_Rel_Insert_Input>;
  user_hackathons?: InputMaybe<User_Hackathons_Arr_Rel_Insert_Input>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Hackathons_Max_Fields = {
  __typename?: 'hackathons_max_fields';
  apply_mode?: Maybe<Scalars['hackathons_apply_mode_enum']>;
  approx_participant?: Maybe<Scalars['String']>;
  brand_id?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  college_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  cover_img?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['Int']>;
  edition_name?: Maybe<Scalars['String']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  /** This field stores the favicon image location for the hackathon */
  favicon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['citext']>;
  participants_count?: Maybe<Scalars['Int']>;
  projects_submitted?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['numeric']>;
  slug?: Maybe<Scalars['citext']>;
  starts_at?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['hackathons_status_enum']>;
  tagline?: Maybe<Scalars['String']>;
  team_min?: Maybe<Scalars['Int']>;
  team_size?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uri?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "hackathons" */
export type Hackathons_Max_Order_By = {
  apply_mode?: InputMaybe<Order_By>;
  approx_participant?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  cover_img?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  edition_name?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  /** This field stores the favicon image location for the hackathon */
  favicon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uri?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Hackathons_Min_Fields = {
  __typename?: 'hackathons_min_fields';
  apply_mode?: Maybe<Scalars['hackathons_apply_mode_enum']>;
  approx_participant?: Maybe<Scalars['String']>;
  brand_id?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  college_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  cover_img?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['Int']>;
  edition_name?: Maybe<Scalars['String']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  /** This field stores the favicon image location for the hackathon */
  favicon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['citext']>;
  participants_count?: Maybe<Scalars['Int']>;
  projects_submitted?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['numeric']>;
  slug?: Maybe<Scalars['citext']>;
  starts_at?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['hackathons_status_enum']>;
  tagline?: Maybe<Scalars['String']>;
  team_min?: Maybe<Scalars['Int']>;
  team_size?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uri?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "hackathons" */
export type Hackathons_Min_Order_By = {
  apply_mode?: InputMaybe<Order_By>;
  approx_participant?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  cover_img?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  edition_name?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  /** This field stores the favicon image location for the hackathon */
  favicon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uri?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "hackathons" */
export type Hackathons_Mutation_Response = {
  __typename?: 'hackathons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hackathons>;
};

/** input type for inserting object relation for remote table "hackathons" */
export type Hackathons_Obj_Rel_Insert_Input = {
  data: Hackathons_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hackathons_On_Conflict>;
};

/** on_conflict condition type for table "hackathons" */
export type Hackathons_On_Conflict = {
  constraint: Hackathons_Constraint;
  update_columns?: Array<Hackathons_Update_Column>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};

/** Ordering options when selecting data from "hackathons". */
export type Hackathons_Order_By = {
  _cover_img?: InputMaybe<Order_By>;
  _favicon?: InputMaybe<Order_By>;
  apply_mode?: InputMaybe<Order_By>;
  approx_participant?: InputMaybe<Order_By>;
  brand?: InputMaybe<Hackathon_Brands_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  checklists_aggregate?: InputMaybe<Hackathon_Checklists_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  cover_img?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  devfolio_official?: InputMaybe<Order_By>;
  discover?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  edition_name?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Hackathon_Events_Aggregate_Order_By>;
  faqs_aggregate?: InputMaybe<Hackathon_Faq_Aggregate_Order_By>;
  favicon?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  fellowship?: InputMaybe<Order_By>;
  hackathon_event_groups_aggregate?: InputMaybe<Hackathon_Event_Groups_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_university_hackathon?: InputMaybe<Order_By>;
  judges_aggregate?: InputMaybe<Judges_Aggregate_Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Hackathon_Notes_Aggregate_Order_By>;
  participants_count?: InputMaybe<Order_By>;
  participants_details?: InputMaybe<Order_By>;
  private?: InputMaybe<Order_By>;
  prize_tracks_aggregate?: InputMaybe<Prize_Tracks_Aggregate_Order_By>;
  prizes_aggregate?: InputMaybe<Prizes_Aggregate_Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  schwags?: InputMaybe<Hackathon_Schwags_Order_By>;
  scope?: InputMaybe<Hackathon_Scopes_Order_By>;
  scope_extras_aggregate?: InputMaybe<Hackathon_Scope_Extras_Aggregate_Order_By>;
  settings?: InputMaybe<Hackathon_Settings_Order_By>;
  slug?: InputMaybe<Order_By>;
  sponsor_tiers_aggregate?: InputMaybe<Sponsor_Tiers_Aggregate_Order_By>;
  stakings_aggregate?: InputMaybe<Hackathon_Stakings_Aggregate_Order_By>;
  starts_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
  themed?: InputMaybe<Order_By>;
  themes_aggregate?: InputMaybe<Hackathon_Themes_Aggregate_Order_By>;
  timezone?: InputMaybe<Order_By>;
  tracks_aggregate?: InputMaybe<Hackathon_Tracks_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uri?: InputMaybe<Order_By>;
  user_hackathon_bounties_aggregate?: InputMaybe<User_Hackathon_Bounties_Aggregate_Order_By>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Order_By>;
  uuid?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hackathons */
export type Hackathons_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Hackathons_Prepend_Input = {
  participants_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "hackathons" */
export enum Hackathons_Select_Column {
  /** column name */
  ApplyMode = 'apply_mode',
  /** column name */
  ApproxParticipant = 'approx_participant',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  City = 'city',
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CoverImg = 'cover_img',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  DevfolioOfficial = 'devfolio_official',
  /** column name */
  Discover = 'discover',
  /** column name */
  Edition = 'edition',
  /** column name */
  EditionName = 'edition_name',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  Favicon = 'favicon',
  /** column name */
  Featured = 'featured',
  /** column name */
  Fellowship = 'fellowship',
  /** column name */
  Id = 'id',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  IsUniversityHackathon = 'is_university_hackathon',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  ParticipantsCount = 'participants_count',
  /** column name */
  ParticipantsDetails = 'participants_details',
  /** column name */
  Private = 'private',
  /** column name */
  ProjectsSubmitted = 'projects_submitted',
  /** column name */
  Rating = 'rating',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  TeamMin = 'team_min',
  /** column name */
  TeamSize = 'team_size',
  /** column name */
  Themed = 'themed',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uri = 'uri',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

/** select "hackathons_aggregate_bool_exp_bool_and_arguments_columns" columns of table "hackathons" */
export enum Hackathons_Select_Column_Hackathons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DevfolioOfficial = 'devfolio_official',
  /** column name */
  Discover = 'discover',
  /** column name */
  Featured = 'featured',
  /** column name */
  Fellowship = 'fellowship',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  IsUniversityHackathon = 'is_university_hackathon',
  /** column name */
  Private = 'private',
  /** column name */
  Themed = 'themed',
  /** column name */
  Verified = 'verified'
}

/** select "hackathons_aggregate_bool_exp_bool_or_arguments_columns" columns of table "hackathons" */
export enum Hackathons_Select_Column_Hackathons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DevfolioOfficial = 'devfolio_official',
  /** column name */
  Discover = 'discover',
  /** column name */
  Featured = 'featured',
  /** column name */
  Fellowship = 'fellowship',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  IsUniversityHackathon = 'is_university_hackathon',
  /** column name */
  Private = 'private',
  /** column name */
  Themed = 'themed',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "hackathons" */
export type Hackathons_Set_Input = {
  apply_mode?: InputMaybe<Scalars['hackathons_apply_mode_enum']>;
  approx_participant?: InputMaybe<Scalars['String']>;
  brand_id?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  college_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  cover_img?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  devfolio_official?: InputMaybe<Scalars['Boolean']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  edition?: InputMaybe<Scalars['Int']>;
  edition_name?: InputMaybe<Scalars['String']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  /** This field stores the favicon image location for the hackathon */
  favicon?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  /** This boolean flag indicates if the hackathon is a fellowship */
  fellowship?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_online?: InputMaybe<Scalars['Boolean']>;
  is_university_hackathon?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['citext']>;
  participants_count?: InputMaybe<Scalars['Int']>;
  participants_details?: InputMaybe<Scalars['jsonb']>;
  private?: InputMaybe<Scalars['Boolean']>;
  projects_submitted?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['citext']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['hackathons_status_enum']>;
  tagline?: InputMaybe<Scalars['String']>;
  team_min?: InputMaybe<Scalars['Int']>;
  team_size?: InputMaybe<Scalars['Int']>;
  themed?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uri?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to compare columns of type "hackathons_status_enum". All fields are combined with logical 'AND'. */
export type Hackathons_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['hackathons_status_enum']>;
  _gt?: InputMaybe<Scalars['hackathons_status_enum']>;
  _gte?: InputMaybe<Scalars['hackathons_status_enum']>;
  _in?: InputMaybe<Array<Scalars['hackathons_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['hackathons_status_enum']>;
  _lte?: InputMaybe<Scalars['hackathons_status_enum']>;
  _neq?: InputMaybe<Scalars['hackathons_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['hackathons_status_enum']>>;
};

/** aggregate stddev on columns */
export type Hackathons_Stddev_Fields = {
  __typename?: 'hackathons_stddev_fields';
  brand_id?: Maybe<Scalars['Float']>;
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  participants_count?: Maybe<Scalars['Float']>;
  projects_submitted?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  team_min?: Maybe<Scalars['Float']>;
  team_size?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "hackathons" */
export type Hackathons_Stddev_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Hackathons_Stddev_Pop_Fields = {
  __typename?: 'hackathons_stddev_pop_fields';
  brand_id?: Maybe<Scalars['Float']>;
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  participants_count?: Maybe<Scalars['Float']>;
  projects_submitted?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  team_min?: Maybe<Scalars['Float']>;
  team_size?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "hackathons" */
export type Hackathons_Stddev_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Hackathons_Stddev_Samp_Fields = {
  __typename?: 'hackathons_stddev_samp_fields';
  brand_id?: Maybe<Scalars['Float']>;
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  participants_count?: Maybe<Scalars['Float']>;
  projects_submitted?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  team_min?: Maybe<Scalars['Float']>;
  team_size?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "hackathons" */
export type Hackathons_Stddev_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hackathons" */
export type Hackathons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hackathons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hackathons_Stream_Cursor_Value_Input = {
  apply_mode?: InputMaybe<Scalars['hackathons_apply_mode_enum']>;
  approx_participant?: InputMaybe<Scalars['String']>;
  brand_id?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  college_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  cover_img?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  devfolio_official?: InputMaybe<Scalars['Boolean']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  edition?: InputMaybe<Scalars['Int']>;
  edition_name?: InputMaybe<Scalars['String']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  /** This field stores the favicon image location for the hackathon */
  favicon?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  /** This boolean flag indicates if the hackathon is a fellowship */
  fellowship?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_online?: InputMaybe<Scalars['Boolean']>;
  is_university_hackathon?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['citext']>;
  participants_count?: InputMaybe<Scalars['Int']>;
  participants_details?: InputMaybe<Scalars['jsonb']>;
  private?: InputMaybe<Scalars['Boolean']>;
  projects_submitted?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['citext']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['hackathons_status_enum']>;
  tagline?: InputMaybe<Scalars['String']>;
  team_min?: InputMaybe<Scalars['Int']>;
  team_size?: InputMaybe<Scalars['Int']>;
  themed?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uri?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Hackathons_Sum_Fields = {
  __typename?: 'hackathons_sum_fields';
  brand_id?: Maybe<Scalars['Int']>;
  college_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  edition?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  participants_count?: Maybe<Scalars['Int']>;
  projects_submitted?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['numeric']>;
  team_min?: Maybe<Scalars['Int']>;
  team_size?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "hackathons" */
export type Hackathons_Sum_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
};

/** update columns of table "hackathons" */
export enum Hackathons_Update_Column {
  /** column name */
  ApplyMode = 'apply_mode',
  /** column name */
  ApproxParticipant = 'approx_participant',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  City = 'city',
  /** column name */
  CollegeId = 'college_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CoverImg = 'cover_img',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  DevfolioOfficial = 'devfolio_official',
  /** column name */
  Discover = 'discover',
  /** column name */
  Edition = 'edition',
  /** column name */
  EditionName = 'edition_name',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  Favicon = 'favicon',
  /** column name */
  Featured = 'featured',
  /** column name */
  Fellowship = 'fellowship',
  /** column name */
  Id = 'id',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  IsUniversityHackathon = 'is_university_hackathon',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  ParticipantsCount = 'participants_count',
  /** column name */
  ParticipantsDetails = 'participants_details',
  /** column name */
  Private = 'private',
  /** column name */
  ProjectsSubmitted = 'projects_submitted',
  /** column name */
  Rating = 'rating',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  TeamMin = 'team_min',
  /** column name */
  TeamSize = 'team_size',
  /** column name */
  Themed = 'themed',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uri = 'uri',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

export type Hackathons_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Hackathons_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Hackathons_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Hackathons_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Hackathons_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hackathons_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Hackathons_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hackathons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hackathons_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hackathons_Var_Pop_Fields = {
  __typename?: 'hackathons_var_pop_fields';
  brand_id?: Maybe<Scalars['Float']>;
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  participants_count?: Maybe<Scalars['Float']>;
  projects_submitted?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  team_min?: Maybe<Scalars['Float']>;
  team_size?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "hackathons" */
export type Hackathons_Var_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Hackathons_Var_Samp_Fields = {
  __typename?: 'hackathons_var_samp_fields';
  brand_id?: Maybe<Scalars['Float']>;
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  participants_count?: Maybe<Scalars['Float']>;
  projects_submitted?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  team_min?: Maybe<Scalars['Float']>;
  team_size?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "hackathons" */
export type Hackathons_Var_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Hackathons_Variance_Fields = {
  __typename?: 'hackathons_variance_fields';
  brand_id?: Maybe<Scalars['Float']>;
  college_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  participants_count?: Maybe<Scalars['Float']>;
  projects_submitted?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  team_min?: Maybe<Scalars['Float']>;
  team_size?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "hackathons" */
export type Hackathons_Variance_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  college_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  edition?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participants_count?: InputMaybe<Order_By>;
  projects_submitted?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  team_min?: InputMaybe<Order_By>;
  team_size?: InputMaybe<Order_By>;
};

/** columns and relationships of "hashtags" */
export type Hashtags = {
  __typename?: 'hashtags';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['citext'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
  verified?: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "hashtags" */
export type Hashtags_Aggregate = {
  __typename?: 'hashtags_aggregate';
  aggregate?: Maybe<Hashtags_Aggregate_Fields>;
  nodes: Array<Hashtags>;
};

/** aggregate fields of "hashtags" */
export type Hashtags_Aggregate_Fields = {
  __typename?: 'hashtags_aggregate_fields';
  avg?: Maybe<Hashtags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hashtags_Max_Fields>;
  min?: Maybe<Hashtags_Min_Fields>;
  stddev?: Maybe<Hashtags_Stddev_Fields>;
  stddev_pop?: Maybe<Hashtags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hashtags_Stddev_Samp_Fields>;
  sum?: Maybe<Hashtags_Sum_Fields>;
  var_pop?: Maybe<Hashtags_Var_Pop_Fields>;
  var_samp?: Maybe<Hashtags_Var_Samp_Fields>;
  variance?: Maybe<Hashtags_Variance_Fields>;
};


/** aggregate fields of "hashtags" */
export type Hashtags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hashtags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Hashtags_Avg_Fields = {
  __typename?: 'hashtags_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hashtags". All fields are combined with a logical 'AND'. */
export type Hashtags_Bool_Exp = {
  _and?: InputMaybe<Array<Hashtags_Bool_Exp>>;
  _not?: InputMaybe<Hashtags_Bool_Exp>;
  _or?: InputMaybe<Array<Hashtags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<Citext_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "hashtags" */
export enum Hashtags_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkHashtags = 'pk_hashtags',
  /** unique or primary key constraint on columns "name" */
  UniqueNameHashtags = 'unique_name_hashtags',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidHashtags = 'unique_uuid_hashtags'
}

/** input type for incrementing numeric columns in table "hashtags" */
export type Hashtags_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hashtags" */
export type Hashtags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Hashtags_Max_Fields = {
  __typename?: 'hashtags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['citext']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hashtags_Min_Fields = {
  __typename?: 'hashtags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['citext']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hashtags" */
export type Hashtags_Mutation_Response = {
  __typename?: 'hashtags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hashtags>;
};

/** input type for inserting object relation for remote table "hashtags" */
export type Hashtags_Obj_Rel_Insert_Input = {
  data: Hashtags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hashtags_On_Conflict>;
};

/** on_conflict condition type for table "hashtags" */
export type Hashtags_On_Conflict = {
  constraint: Hashtags_Constraint;
  update_columns?: Array<Hashtags_Update_Column>;
  where?: InputMaybe<Hashtags_Bool_Exp>;
};

/** Ordering options when selecting data from "hashtags". */
export type Hashtags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hashtags */
export type Hashtags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "hashtags" */
export enum Hashtags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "hashtags" */
export type Hashtags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Hashtags_Stddev_Fields = {
  __typename?: 'hashtags_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hashtags_Stddev_Pop_Fields = {
  __typename?: 'hashtags_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hashtags_Stddev_Samp_Fields = {
  __typename?: 'hashtags_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hashtags" */
export type Hashtags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hashtags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hashtags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Hashtags_Sum_Fields = {
  __typename?: 'hashtags_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "hashtags" */
export enum Hashtags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

export type Hashtags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hashtags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hashtags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hashtags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hashtags_Var_Pop_Fields = {
  __typename?: 'hashtags_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hashtags_Var_Samp_Fields = {
  __typename?: 'hashtags_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hashtags_Variance_Fields = {
  __typename?: 'hashtags_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "hc_file_type_enum". All fields are combined with logical 'AND'. */
export type Hc_File_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['hc_file_type_enum']>;
  _gt?: InputMaybe<Scalars['hc_file_type_enum']>;
  _gte?: InputMaybe<Scalars['hc_file_type_enum']>;
  _in?: InputMaybe<Array<Scalars['hc_file_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['hc_file_type_enum']>;
  _lte?: InputMaybe<Scalars['hc_file_type_enum']>;
  _neq?: InputMaybe<Scalars['hc_file_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['hc_file_type_enum']>>;
};

/** Boolean expression to compare columns of type "hc_type_enum". All fields are combined with logical 'AND'. */
export type Hc_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['hc_type_enum']>;
  _gt?: InputMaybe<Scalars['hc_type_enum']>;
  _gte?: InputMaybe<Scalars['hc_type_enum']>;
  _in?: InputMaybe<Array<Scalars['hc_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['hc_type_enum']>;
  _lte?: InputMaybe<Scalars['hc_type_enum']>;
  _neq?: InputMaybe<Scalars['hc_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['hc_type_enum']>>;
};

/** Boolean expression to compare columns of type "hse_at_app_status_enum". All fields are combined with logical 'AND'. */
export type Hse_At_App_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['hse_at_app_status_enum']>;
  _gt?: InputMaybe<Scalars['hse_at_app_status_enum']>;
  _gte?: InputMaybe<Scalars['hse_at_app_status_enum']>;
  _in?: InputMaybe<Array<Scalars['hse_at_app_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['hse_at_app_status_enum']>;
  _lte?: InputMaybe<Scalars['hse_at_app_status_enum']>;
  _neq?: InputMaybe<Scalars['hse_at_app_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['hse_at_app_status_enum']>>;
};

/** Boolean expression to compare columns of type "hse_file_type_enum". All fields are combined with logical 'AND'. */
export type Hse_File_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['hse_file_type_enum']>;
  _gt?: InputMaybe<Scalars['hse_file_type_enum']>;
  _gte?: InputMaybe<Scalars['hse_file_type_enum']>;
  _in?: InputMaybe<Array<Scalars['hse_file_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['hse_file_type_enum']>;
  _lte?: InputMaybe<Scalars['hse_file_type_enum']>;
  _neq?: InputMaybe<Scalars['hse_file_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['hse_file_type_enum']>>;
};

/** Boolean expression to compare columns of type "hse_role_enum". All fields are combined with logical 'AND'. */
export type Hse_Role_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['hse_role_enum']>;
  _gt?: InputMaybe<Scalars['hse_role_enum']>;
  _gte?: InputMaybe<Scalars['hse_role_enum']>;
  _in?: InputMaybe<Array<Scalars['hse_role_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['hse_role_enum']>;
  _lte?: InputMaybe<Scalars['hse_role_enum']>;
  _neq?: InputMaybe<Scalars['hse_role_enum']>;
  _nin?: InputMaybe<Array<Scalars['hse_role_enum']>>;
};

/** Boolean expression to compare columns of type "hse_type_enum". All fields are combined with logical 'AND'. */
export type Hse_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['hse_type_enum']>;
  _gt?: InputMaybe<Scalars['hse_type_enum']>;
  _gte?: InputMaybe<Scalars['hse_type_enum']>;
  _in?: InputMaybe<Array<Scalars['hse_type_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['hse_type_enum']>;
  _lte?: InputMaybe<Scalars['hse_type_enum']>;
  _neq?: InputMaybe<Scalars['hse_type_enum']>;
  _nin?: InputMaybe<Array<Scalars['hse_type_enum']>>;
};

/** columns and relationships of "idea_stats" */
export type Idea_Stats = {
  __typename?: 'idea_stats';
  building: Scalars['Int'];
  built: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  idea_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
  want: Scalars['Int'];
};

/** aggregated selection of "idea_stats" */
export type Idea_Stats_Aggregate = {
  __typename?: 'idea_stats_aggregate';
  aggregate?: Maybe<Idea_Stats_Aggregate_Fields>;
  nodes: Array<Idea_Stats>;
};

/** aggregate fields of "idea_stats" */
export type Idea_Stats_Aggregate_Fields = {
  __typename?: 'idea_stats_aggregate_fields';
  avg?: Maybe<Idea_Stats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Idea_Stats_Max_Fields>;
  min?: Maybe<Idea_Stats_Min_Fields>;
  stddev?: Maybe<Idea_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Idea_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Idea_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Idea_Stats_Sum_Fields>;
  var_pop?: Maybe<Idea_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Idea_Stats_Var_Samp_Fields>;
  variance?: Maybe<Idea_Stats_Variance_Fields>;
};


/** aggregate fields of "idea_stats" */
export type Idea_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Idea_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Idea_Stats_Avg_Fields = {
  __typename?: 'idea_stats_avg_fields';
  building?: Maybe<Scalars['Float']>;
  built?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  want?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "idea_stats". All fields are combined with a logical 'AND'. */
export type Idea_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Idea_Stats_Bool_Exp>>;
  _not?: InputMaybe<Idea_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Idea_Stats_Bool_Exp>>;
  building?: InputMaybe<Int_Comparison_Exp>;
  built?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  idea_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  want?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "idea_stats" */
export enum Idea_Stats_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkIdeaStats = 'pk_idea_stats',
  /** unique or primary key constraint on columns "idea_id" */
  UniqueIdeaIdIdeaStats = 'unique_idea_id_idea_stats',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidIdeaStats = 'unique_uuid_idea_stats'
}

/** input type for incrementing numeric columns in table "idea_stats" */
export type Idea_Stats_Inc_Input = {
  building?: InputMaybe<Scalars['Int']>;
  built?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  want?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "idea_stats" */
export type Idea_Stats_Insert_Input = {
  building?: InputMaybe<Scalars['Int']>;
  built?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  want?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Idea_Stats_Max_Fields = {
  __typename?: 'idea_stats_max_fields';
  building?: Maybe<Scalars['Int']>;
  built?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  idea_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  want?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Idea_Stats_Min_Fields = {
  __typename?: 'idea_stats_min_fields';
  building?: Maybe<Scalars['Int']>;
  built?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  idea_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  want?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "idea_stats" */
export type Idea_Stats_Mutation_Response = {
  __typename?: 'idea_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Idea_Stats>;
};

/** input type for inserting object relation for remote table "idea_stats" */
export type Idea_Stats_Obj_Rel_Insert_Input = {
  data: Idea_Stats_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Idea_Stats_On_Conflict>;
};

/** on_conflict condition type for table "idea_stats" */
export type Idea_Stats_On_Conflict = {
  constraint: Idea_Stats_Constraint;
  update_columns?: Array<Idea_Stats_Update_Column>;
  where?: InputMaybe<Idea_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "idea_stats". */
export type Idea_Stats_Order_By = {
  building?: InputMaybe<Order_By>;
  built?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  want?: InputMaybe<Order_By>;
};

/** primary key columns input for table: idea_stats */
export type Idea_Stats_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "idea_stats" */
export enum Idea_Stats_Select_Column {
  /** column name */
  Building = 'building',
  /** column name */
  Built = 'built',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdeaId = 'idea_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Want = 'want'
}

/** input type for updating data in table "idea_stats" */
export type Idea_Stats_Set_Input = {
  building?: InputMaybe<Scalars['Int']>;
  built?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  want?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Idea_Stats_Stddev_Fields = {
  __typename?: 'idea_stats_stddev_fields';
  building?: Maybe<Scalars['Float']>;
  built?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  want?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Idea_Stats_Stddev_Pop_Fields = {
  __typename?: 'idea_stats_stddev_pop_fields';
  building?: Maybe<Scalars['Float']>;
  built?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  want?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Idea_Stats_Stddev_Samp_Fields = {
  __typename?: 'idea_stats_stddev_samp_fields';
  building?: Maybe<Scalars['Float']>;
  built?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  want?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "idea_stats" */
export type Idea_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Idea_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Idea_Stats_Stream_Cursor_Value_Input = {
  building?: InputMaybe<Scalars['Int']>;
  built?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  want?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Idea_Stats_Sum_Fields = {
  __typename?: 'idea_stats_sum_fields';
  building?: Maybe<Scalars['Int']>;
  built?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  idea_id?: Maybe<Scalars['Int']>;
  want?: Maybe<Scalars['Int']>;
};

/** update columns of table "idea_stats" */
export enum Idea_Stats_Update_Column {
  /** column name */
  Building = 'building',
  /** column name */
  Built = 'built',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdeaId = 'idea_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Want = 'want'
}

export type Idea_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Idea_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Idea_Stats_Set_Input>;
  /** filter the rows which have to be updated */
  where: Idea_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Idea_Stats_Var_Pop_Fields = {
  __typename?: 'idea_stats_var_pop_fields';
  building?: Maybe<Scalars['Float']>;
  built?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  want?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Idea_Stats_Var_Samp_Fields = {
  __typename?: 'idea_stats_var_samp_fields';
  building?: Maybe<Scalars['Float']>;
  built?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  want?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Idea_Stats_Variance_Fields = {
  __typename?: 'idea_stats_variance_fields';
  building?: Maybe<Scalars['Float']>;
  built?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  want?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ideas" */
export type Ideas = {
  __typename?: 'ideas';
  author?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  discover: Scalars['Boolean'];
  id: Scalars['Int'];
  idea?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['citext']>;
  source?: Maybe<Scalars['String']>;
  /** An object relationship */
  stats?: Maybe<Idea_Stats>;
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
  verify?: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "ideas" */
export type Ideas_Aggregate = {
  __typename?: 'ideas_aggregate';
  aggregate?: Maybe<Ideas_Aggregate_Fields>;
  nodes: Array<Ideas>;
};

/** aggregate fields of "ideas" */
export type Ideas_Aggregate_Fields = {
  __typename?: 'ideas_aggregate_fields';
  avg?: Maybe<Ideas_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ideas_Max_Fields>;
  min?: Maybe<Ideas_Min_Fields>;
  stddev?: Maybe<Ideas_Stddev_Fields>;
  stddev_pop?: Maybe<Ideas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ideas_Stddev_Samp_Fields>;
  sum?: Maybe<Ideas_Sum_Fields>;
  var_pop?: Maybe<Ideas_Var_Pop_Fields>;
  var_samp?: Maybe<Ideas_Var_Samp_Fields>;
  variance?: Maybe<Ideas_Variance_Fields>;
};


/** aggregate fields of "ideas" */
export type Ideas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ideas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ideas_Avg_Fields = {
  __typename?: 'ideas_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ideas". All fields are combined with a logical 'AND'. */
export type Ideas_Bool_Exp = {
  _and?: InputMaybe<Array<Ideas_Bool_Exp>>;
  _not?: InputMaybe<Ideas_Bool_Exp>;
  _or?: InputMaybe<Array<Ideas_Bool_Exp>>;
  author?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discover?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  idea?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<Citext_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  stats?: InputMaybe<Idea_Stats_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  verify?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "ideas" */
export enum Ideas_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkIdeas = 'pk_ideas',
  /** unique or primary key constraint on columns "slug" */
  UniqueSlugIdeas = 'unique_slug_ideas',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidIdeas = 'unique_uuid_ideas'
}

/** input type for incrementing numeric columns in table "ideas" */
export type Ideas_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ideas" */
export type Ideas_Insert_Input = {
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  idea?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['citext']>;
  source?: InputMaybe<Scalars['String']>;
  stats?: InputMaybe<Idea_Stats_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  verify?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Ideas_Max_Fields = {
  __typename?: 'ideas_max_fields';
  author?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  idea?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['citext']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ideas_Min_Fields = {
  __typename?: 'ideas_min_fields';
  author?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  idea?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['citext']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ideas" */
export type Ideas_Mutation_Response = {
  __typename?: 'ideas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ideas>;
};

/** input type for inserting object relation for remote table "ideas" */
export type Ideas_Obj_Rel_Insert_Input = {
  data: Ideas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ideas_On_Conflict>;
};

/** on_conflict condition type for table "ideas" */
export type Ideas_On_Conflict = {
  constraint: Ideas_Constraint;
  update_columns?: Array<Ideas_Update_Column>;
  where?: InputMaybe<Ideas_Bool_Exp>;
};

/** Ordering options when selecting data from "ideas". */
export type Ideas_Order_By = {
  author?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discover?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stats?: InputMaybe<Idea_Stats_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  verify?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ideas */
export type Ideas_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ideas" */
export enum Ideas_Select_Column {
  /** column name */
  Author = 'author',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Discover = 'discover',
  /** column name */
  Id = 'id',
  /** column name */
  Idea = 'idea',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verify = 'verify'
}

/** input type for updating data in table "ideas" */
export type Ideas_Set_Input = {
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  idea?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['citext']>;
  source?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  verify?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Ideas_Stddev_Fields = {
  __typename?: 'ideas_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ideas_Stddev_Pop_Fields = {
  __typename?: 'ideas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ideas_Stddev_Samp_Fields = {
  __typename?: 'ideas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ideas" */
export type Ideas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ideas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ideas_Stream_Cursor_Value_Input = {
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  idea?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['citext']>;
  source?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  verify?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Ideas_Sum_Fields = {
  __typename?: 'ideas_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "ideas" */
export enum Ideas_Update_Column {
  /** column name */
  Author = 'author',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Discover = 'discover',
  /** column name */
  Id = 'id',
  /** column name */
  Idea = 'idea',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verify = 'verify'
}

export type Ideas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ideas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ideas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ideas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ideas_Var_Pop_Fields = {
  __typename?: 'ideas_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ideas_Var_Samp_Fields = {
  __typename?: 'ideas_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ideas_Variance_Fields = {
  __typename?: 'ideas_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "judges" */
export type Judges = {
  __typename?: 'judges';
  /** This function is used to prefix the ASSETS_URL */
  _profile_img?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  discord?: Maybe<Scalars['String']>;
  eligible_for_judging?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['citext']>;
  facebook?: Maybe<Scalars['String']>;
  farcaster?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  /** An object relationship */
  hackathon: Hackathons;
  hackathon_id: Scalars['Int'];
  hidden: Scalars['Boolean'];
  id: Scalars['Int'];
  instagram?: Maybe<Scalars['String']>;
  is_mentor?: Maybe<Scalars['Boolean']>;
  job_title?: Maybe<Scalars['String']>;
  judging_invite_sent?: Maybe<Scalars['Boolean']>;
  linkedin?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  profile_img?: Maybe<Scalars['String']>;
  /** An array relationship */
  project_judgments: Array<Project_Judgments>;
  /** An aggregate relationship */
  project_judgments_aggregate: Project_Judgments_Aggregate;
  reminder_email_3_sent?: Maybe<Scalars['Boolean']>;
  reminder_email_24_sent?: Maybe<Scalars['Boolean']>;
  slack?: Maybe<Scalars['String']>;
  /** An object relationship */
  sponsor?: Maybe<Sponsors>;
  sponsor_id?: Maybe<Scalars['Int']>;
  telegram?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};


/** columns and relationships of "judges" */
export type JudgesProject_JudgmentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judgments_Order_By>>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};


/** columns and relationships of "judges" */
export type JudgesProject_Judgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judgments_Order_By>>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};

/** aggregated selection of "judges" */
export type Judges_Aggregate = {
  __typename?: 'judges_aggregate';
  aggregate?: Maybe<Judges_Aggregate_Fields>;
  nodes: Array<Judges>;
};

export type Judges_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Judges_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Judges_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Judges_Aggregate_Bool_Exp_Count>;
};

export type Judges_Aggregate_Bool_Exp_Bool_And = {
  arguments: Judges_Select_Column_Judges_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Judges_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Judges_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Judges_Select_Column_Judges_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Judges_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Judges_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Judges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Judges_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "judges" */
export type Judges_Aggregate_Fields = {
  __typename?: 'judges_aggregate_fields';
  avg?: Maybe<Judges_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Judges_Max_Fields>;
  min?: Maybe<Judges_Min_Fields>;
  stddev?: Maybe<Judges_Stddev_Fields>;
  stddev_pop?: Maybe<Judges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Judges_Stddev_Samp_Fields>;
  sum?: Maybe<Judges_Sum_Fields>;
  var_pop?: Maybe<Judges_Var_Pop_Fields>;
  var_samp?: Maybe<Judges_Var_Samp_Fields>;
  variance?: Maybe<Judges_Variance_Fields>;
};


/** aggregate fields of "judges" */
export type Judges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Judges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "judges" */
export type Judges_Aggregate_Order_By = {
  avg?: InputMaybe<Judges_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Judges_Max_Order_By>;
  min?: InputMaybe<Judges_Min_Order_By>;
  stddev?: InputMaybe<Judges_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Judges_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Judges_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Judges_Sum_Order_By>;
  var_pop?: InputMaybe<Judges_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Judges_Var_Samp_Order_By>;
  variance?: InputMaybe<Judges_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "judges" */
export type Judges_Arr_Rel_Insert_Input = {
  data: Array<Judges_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Judges_On_Conflict>;
};

/** aggregate avg on columns */
export type Judges_Avg_Fields = {
  __typename?: 'judges_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "judges" */
export type Judges_Avg_Order_By = {
  company_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "judges". All fields are combined with a logical 'AND'. */
export type Judges_Bool_Exp = {
  _and?: InputMaybe<Array<Judges_Bool_Exp>>;
  _not?: InputMaybe<Judges_Bool_Exp>;
  _or?: InputMaybe<Array<Judges_Bool_Exp>>;
  _profile_img?: InputMaybe<String_Comparison_Exp>;
  about?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discord?: InputMaybe<String_Comparison_Exp>;
  eligible_for_judging?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  facebook?: InputMaybe<String_Comparison_Exp>;
  farcaster?: InputMaybe<String_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  is_mentor?: InputMaybe<Boolean_Comparison_Exp>;
  job_title?: InputMaybe<String_Comparison_Exp>;
  judging_invite_sent?: InputMaybe<Boolean_Comparison_Exp>;
  linkedin?: InputMaybe<String_Comparison_Exp>;
  medium?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  profile_img?: InputMaybe<String_Comparison_Exp>;
  project_judgments?: InputMaybe<Project_Judgments_Bool_Exp>;
  project_judgments_aggregate?: InputMaybe<Project_Judgments_Aggregate_Bool_Exp>;
  reminder_email_3_sent?: InputMaybe<Boolean_Comparison_Exp>;
  reminder_email_24_sent?: InputMaybe<Boolean_Comparison_Exp>;
  slack?: InputMaybe<String_Comparison_Exp>;
  sponsor?: InputMaybe<Sponsors_Bool_Exp>;
  sponsor_id?: InputMaybe<Int_Comparison_Exp>;
  telegram?: InputMaybe<String_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "judges" */
export enum Judges_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkJudges = 'pk_judges',
  /** unique or primary key constraint on columns "email", "hackathon_id" */
  UniqueHackathonIdEmail = 'unique_hackathon_id_email',
  /** unique or primary key constraint on columns "email", "user_id", "hackathon_id" */
  UniqueIdEmailUserId = 'unique_id_email_user_id',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidJudges = 'unique_uuid_judges'
}

/** input type for incrementing numeric columns in table "judges" */
export type Judges_Inc_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "judges" */
export type Judges_Insert_Input = {
  about?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discord?: InputMaybe<Scalars['String']>;
  eligible_for_judging?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['citext']>;
  facebook?: InputMaybe<Scalars['String']>;
  farcaster?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_mentor?: InputMaybe<Scalars['Boolean']>;
  job_title?: InputMaybe<Scalars['String']>;
  judging_invite_sent?: InputMaybe<Scalars['Boolean']>;
  linkedin?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  profile_img?: InputMaybe<Scalars['String']>;
  project_judgments?: InputMaybe<Project_Judgments_Arr_Rel_Insert_Input>;
  reminder_email_3_sent?: InputMaybe<Scalars['Boolean']>;
  reminder_email_24_sent?: InputMaybe<Scalars['Boolean']>;
  slack?: InputMaybe<Scalars['String']>;
  sponsor?: InputMaybe<Sponsors_Obj_Rel_Insert_Input>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  telegram?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Judges_Max_Fields = {
  __typename?: 'judges_max_fields';
  about?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discord?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  facebook?: Maybe<Scalars['String']>;
  farcaster?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  instagram?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  profile_img?: Maybe<Scalars['String']>;
  slack?: Maybe<Scalars['String']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  telegram?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "judges" */
export type Judges_Max_Order_By = {
  about?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discord?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  farcaster?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  medium?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  profile_img?: InputMaybe<Order_By>;
  slack?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  telegram?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Judges_Min_Fields = {
  __typename?: 'judges_min_fields';
  about?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discord?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  facebook?: Maybe<Scalars['String']>;
  farcaster?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  instagram?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  profile_img?: Maybe<Scalars['String']>;
  slack?: Maybe<Scalars['String']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  telegram?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "judges" */
export type Judges_Min_Order_By = {
  about?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discord?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  farcaster?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  medium?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  profile_img?: InputMaybe<Order_By>;
  slack?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  telegram?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "judges" */
export type Judges_Mutation_Response = {
  __typename?: 'judges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Judges>;
};

/** input type for inserting object relation for remote table "judges" */
export type Judges_Obj_Rel_Insert_Input = {
  data: Judges_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Judges_On_Conflict>;
};

/** on_conflict condition type for table "judges" */
export type Judges_On_Conflict = {
  constraint: Judges_Constraint;
  update_columns?: Array<Judges_Update_Column>;
  where?: InputMaybe<Judges_Bool_Exp>;
};

/** Ordering options when selecting data from "judges". */
export type Judges_Order_By = {
  _profile_img?: InputMaybe<Order_By>;
  about?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discord?: InputMaybe<Order_By>;
  eligible_for_judging?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  farcaster?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  is_mentor?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  judging_invite_sent?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  medium?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  profile_img?: InputMaybe<Order_By>;
  project_judgments_aggregate?: InputMaybe<Project_Judgments_Aggregate_Order_By>;
  reminder_email_3_sent?: InputMaybe<Order_By>;
  reminder_email_24_sent?: InputMaybe<Order_By>;
  slack?: InputMaybe<Order_By>;
  sponsor?: InputMaybe<Sponsors_Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  telegram?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: judges */
export type Judges_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "judges" */
export enum Judges_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Discord = 'discord',
  /** column name */
  EligibleForJudging = 'eligible_for_judging',
  /** column name */
  Email = 'email',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Farcaster = 'farcaster',
  /** column name */
  Featured = 'featured',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsMentor = 'is_mentor',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  JudgingInviteSent = 'judging_invite_sent',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  Medium = 'medium',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ProfileImg = 'profile_img',
  /** column name */
  ReminderEmail_3Sent = 'reminder_email_3_sent',
  /** column name */
  ReminderEmail_24Sent = 'reminder_email_24_sent',
  /** column name */
  Slack = 'slack',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  Telegram = 'telegram',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Website = 'website'
}

/** select "judges_aggregate_bool_exp_bool_and_arguments_columns" columns of table "judges" */
export enum Judges_Select_Column_Judges_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EligibleForJudging = 'eligible_for_judging',
  /** column name */
  Featured = 'featured',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsMentor = 'is_mentor',
  /** column name */
  JudgingInviteSent = 'judging_invite_sent',
  /** column name */
  ReminderEmail_3Sent = 'reminder_email_3_sent',
  /** column name */
  ReminderEmail_24Sent = 'reminder_email_24_sent'
}

/** select "judges_aggregate_bool_exp_bool_or_arguments_columns" columns of table "judges" */
export enum Judges_Select_Column_Judges_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EligibleForJudging = 'eligible_for_judging',
  /** column name */
  Featured = 'featured',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsMentor = 'is_mentor',
  /** column name */
  JudgingInviteSent = 'judging_invite_sent',
  /** column name */
  ReminderEmail_3Sent = 'reminder_email_3_sent',
  /** column name */
  ReminderEmail_24Sent = 'reminder_email_24_sent'
}

/** input type for updating data in table "judges" */
export type Judges_Set_Input = {
  about?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discord?: InputMaybe<Scalars['String']>;
  eligible_for_judging?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['citext']>;
  facebook?: InputMaybe<Scalars['String']>;
  farcaster?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_mentor?: InputMaybe<Scalars['Boolean']>;
  job_title?: InputMaybe<Scalars['String']>;
  judging_invite_sent?: InputMaybe<Scalars['Boolean']>;
  linkedin?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  profile_img?: InputMaybe<Scalars['String']>;
  reminder_email_3_sent?: InputMaybe<Scalars['Boolean']>;
  reminder_email_24_sent?: InputMaybe<Scalars['Boolean']>;
  slack?: InputMaybe<Scalars['String']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  telegram?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Judges_Stddev_Fields = {
  __typename?: 'judges_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "judges" */
export type Judges_Stddev_Order_By = {
  company_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Judges_Stddev_Pop_Fields = {
  __typename?: 'judges_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "judges" */
export type Judges_Stddev_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Judges_Stddev_Samp_Fields = {
  __typename?: 'judges_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "judges" */
export type Judges_Stddev_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "judges" */
export type Judges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Judges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Judges_Stream_Cursor_Value_Input = {
  about?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discord?: InputMaybe<Scalars['String']>;
  eligible_for_judging?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['citext']>;
  facebook?: InputMaybe<Scalars['String']>;
  farcaster?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_mentor?: InputMaybe<Scalars['Boolean']>;
  job_title?: InputMaybe<Scalars['String']>;
  judging_invite_sent?: InputMaybe<Scalars['Boolean']>;
  linkedin?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  profile_img?: InputMaybe<Scalars['String']>;
  reminder_email_3_sent?: InputMaybe<Scalars['Boolean']>;
  reminder_email_24_sent?: InputMaybe<Scalars['Boolean']>;
  slack?: InputMaybe<Scalars['String']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  telegram?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Judges_Sum_Fields = {
  __typename?: 'judges_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "judges" */
export type Judges_Sum_Order_By = {
  company_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "judges" */
export enum Judges_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Discord = 'discord',
  /** column name */
  EligibleForJudging = 'eligible_for_judging',
  /** column name */
  Email = 'email',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Farcaster = 'farcaster',
  /** column name */
  Featured = 'featured',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsMentor = 'is_mentor',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  JudgingInviteSent = 'judging_invite_sent',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  Medium = 'medium',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ProfileImg = 'profile_img',
  /** column name */
  ReminderEmail_3Sent = 'reminder_email_3_sent',
  /** column name */
  ReminderEmail_24Sent = 'reminder_email_24_sent',
  /** column name */
  Slack = 'slack',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  Telegram = 'telegram',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Website = 'website'
}

export type Judges_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Judges_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Judges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Judges_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Judges_Var_Pop_Fields = {
  __typename?: 'judges_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "judges" */
export type Judges_Var_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Judges_Var_Samp_Fields = {
  __typename?: 'judges_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "judges" */
export type Judges_Var_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Judges_Variance_Fields = {
  __typename?: 'judges_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "judges" */
export type Judges_Variance_Order_By = {
  company_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** This table is used to store judging rooms */
export type Judging_Rooms = {
  __typename?: 'judging_rooms';
  available: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An array relationship */
  judges: Array<Room_Judges>;
  /** An aggregate relationship */
  judges_aggregate: Room_Judges_Aggregate;
  name: Scalars['String'];
  order: Scalars['Int'];
  /** An array relationship */
  projects: Array<Project_Judgments>;
  /** An aggregate relationship */
  projects_aggregate: Project_Judgments_Aggregate;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};


/** This table is used to store judging rooms */
export type Judging_RoomsJudgesArgs = {
  distinct_on?: InputMaybe<Array<Room_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Judges_Order_By>>;
  where?: InputMaybe<Room_Judges_Bool_Exp>;
};


/** This table is used to store judging rooms */
export type Judging_RoomsJudges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Judges_Order_By>>;
  where?: InputMaybe<Room_Judges_Bool_Exp>;
};


/** This table is used to store judging rooms */
export type Judging_RoomsProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judgments_Order_By>>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};


/** This table is used to store judging rooms */
export type Judging_RoomsProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judgments_Order_By>>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};

/** aggregated selection of "judging_rooms" */
export type Judging_Rooms_Aggregate = {
  __typename?: 'judging_rooms_aggregate';
  aggregate?: Maybe<Judging_Rooms_Aggregate_Fields>;
  nodes: Array<Judging_Rooms>;
};

/** aggregate fields of "judging_rooms" */
export type Judging_Rooms_Aggregate_Fields = {
  __typename?: 'judging_rooms_aggregate_fields';
  avg?: Maybe<Judging_Rooms_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Judging_Rooms_Max_Fields>;
  min?: Maybe<Judging_Rooms_Min_Fields>;
  stddev?: Maybe<Judging_Rooms_Stddev_Fields>;
  stddev_pop?: Maybe<Judging_Rooms_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Judging_Rooms_Stddev_Samp_Fields>;
  sum?: Maybe<Judging_Rooms_Sum_Fields>;
  var_pop?: Maybe<Judging_Rooms_Var_Pop_Fields>;
  var_samp?: Maybe<Judging_Rooms_Var_Samp_Fields>;
  variance?: Maybe<Judging_Rooms_Variance_Fields>;
};


/** aggregate fields of "judging_rooms" */
export type Judging_Rooms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Judging_Rooms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Judging_Rooms_Avg_Fields = {
  __typename?: 'judging_rooms_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "judging_rooms". All fields are combined with a logical 'AND'. */
export type Judging_Rooms_Bool_Exp = {
  _and?: InputMaybe<Array<Judging_Rooms_Bool_Exp>>;
  _not?: InputMaybe<Judging_Rooms_Bool_Exp>;
  _or?: InputMaybe<Array<Judging_Rooms_Bool_Exp>>;
  available?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  judges?: InputMaybe<Room_Judges_Bool_Exp>;
  judges_aggregate?: InputMaybe<Room_Judges_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  projects?: InputMaybe<Project_Judgments_Bool_Exp>;
  projects_aggregate?: InputMaybe<Project_Judgments_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "judging_rooms" */
export enum Judging_Rooms_Constraint {
  /** unique or primary key constraint on columns "id" */
  JudgingRoomsPkey = 'judging_rooms_pkey',
  /** unique or primary key constraint on columns "uuid" */
  JudgingRoomsUuidKey = 'judging_rooms_uuid_key'
}

/** input type for incrementing numeric columns in table "judging_rooms" */
export type Judging_Rooms_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "judging_rooms" */
export type Judging_Rooms_Insert_Input = {
  available?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  judges?: InputMaybe<Room_Judges_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  projects?: InputMaybe<Project_Judgments_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Judging_Rooms_Max_Fields = {
  __typename?: 'judging_rooms_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Judging_Rooms_Min_Fields = {
  __typename?: 'judging_rooms_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "judging_rooms" */
export type Judging_Rooms_Mutation_Response = {
  __typename?: 'judging_rooms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Judging_Rooms>;
};

/** input type for inserting object relation for remote table "judging_rooms" */
export type Judging_Rooms_Obj_Rel_Insert_Input = {
  data: Judging_Rooms_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Judging_Rooms_On_Conflict>;
};

/** on_conflict condition type for table "judging_rooms" */
export type Judging_Rooms_On_Conflict = {
  constraint: Judging_Rooms_Constraint;
  update_columns?: Array<Judging_Rooms_Update_Column>;
  where?: InputMaybe<Judging_Rooms_Bool_Exp>;
};

/** Ordering options when selecting data from "judging_rooms". */
export type Judging_Rooms_Order_By = {
  available?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judges_aggregate?: InputMaybe<Room_Judges_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Project_Judgments_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: judging_rooms */
export type Judging_Rooms_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "judging_rooms" */
export enum Judging_Rooms_Select_Column {
  /** column name */
  Available = 'available',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "judging_rooms" */
export type Judging_Rooms_Set_Input = {
  available?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Judging_Rooms_Stddev_Fields = {
  __typename?: 'judging_rooms_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Judging_Rooms_Stddev_Pop_Fields = {
  __typename?: 'judging_rooms_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Judging_Rooms_Stddev_Samp_Fields = {
  __typename?: 'judging_rooms_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "judging_rooms" */
export type Judging_Rooms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Judging_Rooms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Judging_Rooms_Stream_Cursor_Value_Input = {
  available?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Judging_Rooms_Sum_Fields = {
  __typename?: 'judging_rooms_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "judging_rooms" */
export enum Judging_Rooms_Update_Column {
  /** column name */
  Available = 'available',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Judging_Rooms_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Judging_Rooms_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Judging_Rooms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Judging_Rooms_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Judging_Rooms_Var_Pop_Fields = {
  __typename?: 'judging_rooms_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Judging_Rooms_Var_Samp_Fields = {
  __typename?: 'judging_rooms_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Judging_Rooms_Variance_Fields = {
  __typename?: 'judging_rooms_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

export type Like_Project_Args = {
  like_project?: InputMaybe<Scalars['Boolean']>;
  project_uuid?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type Ltree_Comparison_Exp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: InputMaybe<Scalars['ltree']>;
  /** does array contain an ancestor of `ltree`? */
  _ancestor_any?: InputMaybe<Array<Scalars['ltree']>>;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: InputMaybe<Scalars['ltree']>;
  /** does array contain a descendant of `ltree`? */
  _descendant_any?: InputMaybe<Array<Scalars['ltree']>>;
  _eq?: InputMaybe<Scalars['ltree']>;
  _gt?: InputMaybe<Scalars['ltree']>;
  _gte?: InputMaybe<Scalars['ltree']>;
  _in?: InputMaybe<Array<Scalars['ltree']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ltree']>;
  _lte?: InputMaybe<Scalars['ltree']>;
  /** does `ltree` match `lquery`? */
  _matches?: InputMaybe<Scalars['lquery']>;
  /** does `ltree` match any `lquery` in array? */
  _matches_any?: InputMaybe<Array<Scalars['String']>>;
  /** does `ltree` match `ltxtquery`? */
  _matches_fulltext?: InputMaybe<Scalars['ltxtquery']>;
  _neq?: InputMaybe<Scalars['ltree']>;
  _nin?: InputMaybe<Array<Scalars['ltree']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** The mutation that is used to create a new schwag product */
  addSchwagProduct?: Maybe<AddSchwagProductOutput>;
  /** execute VOLATILE function "add_comment_to_project" which returns "comments" */
  add_comment_to_project: Array<Comments>;
  /** execute VOLATILE function "add_hackathon_edition" which returns "hackathons" */
  add_hackathon_edition: Array<Hackathons>;
  /** execute VOLATILE function "add_hackathon_reminder" which returns "user_hackathon_reminders" */
  add_hackathon_reminder: Array<User_Hackathon_Reminders>;
  /** The mutation that can be used to send AMA messages to builders */
  builderAma: AmaOutput;
  /** The mutation that can be used to vote for a project */
  cheerProject: CheerProjectOutput;
  /** The mutation that can be used claim a hackathon credential */
  claimHackathonCredential: HackathonCredentialClaimOutput;
  /** delete data from the table: "address" */
  delete_address?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk?: Maybe<Address>;
  /** delete data from the table: "articles" */
  delete_articles?: Maybe<Articles_Mutation_Response>;
  /** delete single row from the table: "articles" */
  delete_articles_by_pk?: Maybe<Articles>;
  /** delete data from the table: "colleges" */
  delete_colleges?: Maybe<Colleges_Mutation_Response>;
  /** delete single row from the table: "colleges" */
  delete_colleges_by_pk?: Maybe<Colleges>;
  /** delete data from the table: "comments" */
  delete_comments?: Maybe<Comments_Mutation_Response>;
  /** delete single row from the table: "comments" */
  delete_comments_by_pk?: Maybe<Comments>;
  /** delete data from the table: "company" */
  delete_company?: Maybe<Company_Mutation_Response>;
  /** delete single row from the table: "company" */
  delete_company_by_pk?: Maybe<Company>;
  /** delete data from the table: "discover" */
  delete_discover?: Maybe<Discover_Mutation_Response>;
  /** delete single row from the table: "discover" */
  delete_discover_by_pk?: Maybe<Discover>;
  /** delete data from the table: "discover_events" */
  delete_discover_events?: Maybe<Discover_Events_Mutation_Response>;
  /** delete single row from the table: "discover_events" */
  delete_discover_events_by_pk?: Maybe<Discover_Events>;
  /** delete data from the table: "education_fields" */
  delete_education_fields?: Maybe<Education_Fields_Mutation_Response>;
  /** delete single row from the table: "education_fields" */
  delete_education_fields_by_pk?: Maybe<Education_Fields>;
  /** delete data from the table: "educations" */
  delete_educations?: Maybe<Educations_Mutation_Response>;
  /** delete single row from the table: "educations" */
  delete_educations_by_pk?: Maybe<Educations>;
  /** delete data from the table: "experience_type" */
  delete_experience_type?: Maybe<Experience_Type_Mutation_Response>;
  /** delete single row from the table: "experience_type" */
  delete_experience_type_by_pk?: Maybe<Experience_Type>;
  /** delete data from the table: "experiences" */
  delete_experiences?: Maybe<Experiences_Mutation_Response>;
  /** delete single row from the table: "experiences" */
  delete_experiences_by_pk?: Maybe<Experiences>;
  /** delete data from the table: "feature_flag_types" */
  delete_feature_flag_types?: Maybe<Feature_Flag_Types_Mutation_Response>;
  /** delete single row from the table: "feature_flag_types" */
  delete_feature_flag_types_by_pk?: Maybe<Feature_Flag_Types>;
  /** delete data from the table: "feature_flags" */
  delete_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** delete single row from the table: "feature_flags" */
  delete_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** delete data from the table: "hackathon_bounties_status" */
  delete_hackathon_bounties_status?: Maybe<Hackathon_Bounties_Status_Mutation_Response>;
  /** delete single row from the table: "hackathon_bounties_status" */
  delete_hackathon_bounties_status_by_pk?: Maybe<Hackathon_Bounties_Status>;
  /** delete data from the table: "hackathon_brands" */
  delete_hackathon_brands?: Maybe<Hackathon_Brands_Mutation_Response>;
  /** delete single row from the table: "hackathon_brands" */
  delete_hackathon_brands_by_pk?: Maybe<Hackathon_Brands>;
  /** delete data from the table: "hackathon_checklists" */
  delete_hackathon_checklists?: Maybe<Hackathon_Checklists_Mutation_Response>;
  /** delete single row from the table: "hackathon_checklists" */
  delete_hackathon_checklists_by_pk?: Maybe<Hackathon_Checklists>;
  /** delete data from the table: "hackathon_credential_eligible_entities" */
  delete_hackathon_credential_eligible_entities?: Maybe<Hackathon_Credential_Eligible_Entities_Mutation_Response>;
  /** delete single row from the table: "hackathon_credential_eligible_entities" */
  delete_hackathon_credential_eligible_entities_by_pk?: Maybe<Hackathon_Credential_Eligible_Entities>;
  /** delete data from the table: "hackathon_credential_type" */
  delete_hackathon_credential_type?: Maybe<Hackathon_Credential_Type_Mutation_Response>;
  /** delete single row from the table: "hackathon_credential_type" */
  delete_hackathon_credential_type_by_pk?: Maybe<Hackathon_Credential_Type>;
  /** delete data from the table: "hackathon_credentials" */
  delete_hackathon_credentials?: Maybe<Hackathon_Credentials_Mutation_Response>;
  /** delete single row from the table: "hackathon_credentials" */
  delete_hackathon_credentials_by_pk?: Maybe<Hackathon_Credentials>;
  /** delete data from the table: "hackathon_credentials_chain" */
  delete_hackathon_credentials_chain?: Maybe<Hackathon_Credentials_Chain_Mutation_Response>;
  /** delete single row from the table: "hackathon_credentials_chain" */
  delete_hackathon_credentials_chain_by_pk?: Maybe<Hackathon_Credentials_Chain>;
  /** delete data from the table: "hackathon_email_templates" */
  delete_hackathon_email_templates?: Maybe<Hackathon_Email_Templates_Mutation_Response>;
  /** delete single row from the table: "hackathon_email_templates" */
  delete_hackathon_email_templates_by_pk?: Maybe<Hackathon_Email_Templates>;
  /** delete data from the table: "hackathon_event_groups" */
  delete_hackathon_event_groups?: Maybe<Hackathon_Event_Groups_Mutation_Response>;
  /** delete single row from the table: "hackathon_event_groups" */
  delete_hackathon_event_groups_by_pk?: Maybe<Hackathon_Event_Groups>;
  /** delete data from the table: "hackathon_event_speakers" */
  delete_hackathon_event_speakers?: Maybe<Hackathon_Event_Speakers_Mutation_Response>;
  /** delete single row from the table: "hackathon_event_speakers" */
  delete_hackathon_event_speakers_by_pk?: Maybe<Hackathon_Event_Speakers>;
  /** delete data from the table: "hackathon_event_sponsors" */
  delete_hackathon_event_sponsors?: Maybe<Hackathon_Event_Sponsors_Mutation_Response>;
  /** delete single row from the table: "hackathon_event_sponsors" */
  delete_hackathon_event_sponsors_by_pk?: Maybe<Hackathon_Event_Sponsors>;
  /** delete data from the table: "hackathon_event_type" */
  delete_hackathon_event_type?: Maybe<Hackathon_Event_Type_Mutation_Response>;
  /** delete single row from the table: "hackathon_event_type" */
  delete_hackathon_event_type_by_pk?: Maybe<Hackathon_Event_Type>;
  /** delete data from the table: "hackathon_events" */
  delete_hackathon_events?: Maybe<Hackathon_Events_Mutation_Response>;
  /** delete single row from the table: "hackathon_events" */
  delete_hackathon_events_by_pk?: Maybe<Hackathon_Events>;
  /** delete data from the table: "hackathon_faq" */
  delete_hackathon_faq?: Maybe<Hackathon_Faq_Mutation_Response>;
  /** delete single row from the table: "hackathon_faq" */
  delete_hackathon_faq_by_pk?: Maybe<Hackathon_Faq>;
  /** delete data from the table: "hackathon_faq_type" */
  delete_hackathon_faq_type?: Maybe<Hackathon_Faq_Type_Mutation_Response>;
  /** delete single row from the table: "hackathon_faq_type" */
  delete_hackathon_faq_type_by_pk?: Maybe<Hackathon_Faq_Type>;
  /** delete data from the table: "hackathon_hashtags" */
  delete_hackathon_hashtags?: Maybe<Hackathon_Hashtags_Mutation_Response>;
  /** delete single row from the table: "hackathon_hashtags" */
  delete_hackathon_hashtags_by_pk?: Maybe<Hackathon_Hashtags>;
  /** delete data from the table: "hackathon_hosts" */
  delete_hackathon_hosts?: Maybe<Hackathon_Hosts_Mutation_Response>;
  /** delete single row from the table: "hackathon_hosts" */
  delete_hackathon_hosts_by_pk?: Maybe<Hackathon_Hosts>;
  /** delete data from the table: "hackathon_note_type" */
  delete_hackathon_note_type?: Maybe<Hackathon_Note_Type_Mutation_Response>;
  /** delete single row from the table: "hackathon_note_type" */
  delete_hackathon_note_type_by_pk?: Maybe<Hackathon_Note_Type>;
  /** delete data from the table: "hackathon_notes" */
  delete_hackathon_notes?: Maybe<Hackathon_Notes_Mutation_Response>;
  /** delete single row from the table: "hackathon_notes" */
  delete_hackathon_notes_by_pk?: Maybe<Hackathon_Notes>;
  /** delete data from the table: "hackathon_schwags" */
  delete_hackathon_schwags?: Maybe<Hackathon_Schwags_Mutation_Response>;
  /** delete single row from the table: "hackathon_schwags" */
  delete_hackathon_schwags_by_pk?: Maybe<Hackathon_Schwags>;
  /** delete data from the table: "hackathon_scope_extras" */
  delete_hackathon_scope_extras?: Maybe<Hackathon_Scope_Extras_Mutation_Response>;
  /** delete single row from the table: "hackathon_scope_extras" */
  delete_hackathon_scope_extras_by_pk?: Maybe<Hackathon_Scope_Extras>;
  /** delete data from the table: "hackathon_scopes" */
  delete_hackathon_scopes?: Maybe<Hackathon_Scopes_Mutation_Response>;
  /** delete single row from the table: "hackathon_scopes" */
  delete_hackathon_scopes_by_pk?: Maybe<Hackathon_Scopes>;
  /** delete data from the table: "hackathon_settings" */
  delete_hackathon_settings?: Maybe<Hackathon_Settings_Mutation_Response>;
  /** delete single row from the table: "hackathon_settings" */
  delete_hackathon_settings_by_pk?: Maybe<Hackathon_Settings>;
  /** delete data from the table: "hackathon_staking_currency" */
  delete_hackathon_staking_currency?: Maybe<Hackathon_Staking_Currency_Mutation_Response>;
  /** delete single row from the table: "hackathon_staking_currency" */
  delete_hackathon_staking_currency_by_pk?: Maybe<Hackathon_Staking_Currency>;
  /** delete data from the table: "hackathon_staking_type" */
  delete_hackathon_staking_type?: Maybe<Hackathon_Staking_Type_Mutation_Response>;
  /** delete single row from the table: "hackathon_staking_type" */
  delete_hackathon_staking_type_by_pk?: Maybe<Hackathon_Staking_Type>;
  /** delete data from the table: "hackathon_stakings" */
  delete_hackathon_stakings?: Maybe<Hackathon_Stakings_Mutation_Response>;
  /** delete single row from the table: "hackathon_stakings" */
  delete_hackathon_stakings_by_pk?: Maybe<Hackathon_Stakings>;
  /** delete data from the table: "hackathon_themes" */
  delete_hackathon_themes?: Maybe<Hackathon_Themes_Mutation_Response>;
  /** delete single row from the table: "hackathon_themes" */
  delete_hackathon_themes_by_pk?: Maybe<Hackathon_Themes>;
  /** delete data from the table: "hackathon_tracks" */
  delete_hackathon_tracks?: Maybe<Hackathon_Tracks_Mutation_Response>;
  /** delete single row from the table: "hackathon_tracks" */
  delete_hackathon_tracks_by_pk?: Maybe<Hackathon_Tracks>;
  /** delete data from the table: "hackathon_type" */
  delete_hackathon_type?: Maybe<Hackathon_Type_Mutation_Response>;
  /** delete single row from the table: "hackathon_type" */
  delete_hackathon_type_by_pk?: Maybe<Hackathon_Type>;
  /** delete data from the table: "hackathons" */
  delete_hackathons?: Maybe<Hackathons_Mutation_Response>;
  /** delete single row from the table: "hackathons" */
  delete_hackathons_by_pk?: Maybe<Hackathons>;
  /** delete data from the table: "hashtags" */
  delete_hashtags?: Maybe<Hashtags_Mutation_Response>;
  /** delete single row from the table: "hashtags" */
  delete_hashtags_by_pk?: Maybe<Hashtags>;
  /** delete data from the table: "idea_stats" */
  delete_idea_stats?: Maybe<Idea_Stats_Mutation_Response>;
  /** delete single row from the table: "idea_stats" */
  delete_idea_stats_by_pk?: Maybe<Idea_Stats>;
  /** delete data from the table: "ideas" */
  delete_ideas?: Maybe<Ideas_Mutation_Response>;
  /** delete single row from the table: "ideas" */
  delete_ideas_by_pk?: Maybe<Ideas>;
  /** delete data from the table: "judges" */
  delete_judges?: Maybe<Judges_Mutation_Response>;
  /** delete single row from the table: "judges" */
  delete_judges_by_pk?: Maybe<Judges>;
  /** delete data from the table: "judging_rooms" */
  delete_judging_rooms?: Maybe<Judging_Rooms_Mutation_Response>;
  /** delete single row from the table: "judging_rooms" */
  delete_judging_rooms_by_pk?: Maybe<Judging_Rooms>;
  /** delete data from the table: "notification_types" */
  delete_notification_types?: Maybe<Notification_Types_Mutation_Response>;
  /** delete single row from the table: "notification_types" */
  delete_notification_types_by_pk?: Maybe<Notification_Types>;
  /** delete data from the table: "notifications" */
  delete_notifications?: Maybe<Notifications_Mutation_Response>;
  /** delete single row from the table: "notifications" */
  delete_notifications_by_pk?: Maybe<Notifications>;
  /** delete data from the table: "oauth" */
  delete_oauth?: Maybe<Oauth_Mutation_Response>;
  /** delete single row from the table: "oauth" */
  delete_oauth_by_pk?: Maybe<Oauth>;
  /** delete data from the table: "oauth_providers" */
  delete_oauth_providers?: Maybe<Oauth_Providers_Mutation_Response>;
  /** delete single row from the table: "oauth_providers" */
  delete_oauth_providers_by_pk?: Maybe<Oauth_Providers>;
  /** delete data from the table: "permissions" */
  delete_permissions?: Maybe<Permissions_Mutation_Response>;
  /** delete single row from the table: "permissions" */
  delete_permissions_by_pk?: Maybe<Permissions>;
  /** delete data from the table: "prize_sponsors" */
  delete_prize_sponsors?: Maybe<Prize_Sponsors_Mutation_Response>;
  /** delete single row from the table: "prize_sponsors" */
  delete_prize_sponsors_by_pk?: Maybe<Prize_Sponsors>;
  /** delete data from the table: "prize_tracks" */
  delete_prize_tracks?: Maybe<Prize_Tracks_Mutation_Response>;
  /** delete single row from the table: "prize_tracks" */
  delete_prize_tracks_by_pk?: Maybe<Prize_Tracks>;
  /** delete data from the table: "prizes" */
  delete_prizes?: Maybe<Prizes_Mutation_Response>;
  /** delete single row from the table: "prizes" */
  delete_prizes_by_pk?: Maybe<Prizes>;
  /** delete data from the table: "profiles" */
  delete_profiles?: Maybe<Profiles_Mutation_Response>;
  /** delete single row from the table: "profiles" */
  delete_profiles_by_pk?: Maybe<Profiles>;
  /** delete data from the table: "project_commits" */
  delete_project_commits?: Maybe<Project_Commits_Mutation_Response>;
  /** delete single row from the table: "project_commits" */
  delete_project_commits_by_pk?: Maybe<Project_Commits>;
  /** delete data from the table: "project_contribution_stickers" */
  delete_project_contribution_stickers?: Maybe<Project_Contribution_Stickers_Mutation_Response>;
  /** delete single row from the table: "project_contribution_stickers" */
  delete_project_contribution_stickers_by_pk?: Maybe<Project_Contribution_Stickers>;
  /** delete data from the table: "project_contribution_tx_network_type" */
  delete_project_contribution_tx_network_type?: Maybe<Project_Contribution_Tx_Network_Type_Mutation_Response>;
  /** delete single row from the table: "project_contribution_tx_network_type" */
  delete_project_contribution_tx_network_type_by_pk?: Maybe<Project_Contribution_Tx_Network_Type>;
  /** delete data from the table: "project_contributions" */
  delete_project_contributions?: Maybe<Project_Contributions_Mutation_Response>;
  /** delete single row from the table: "project_contributions" */
  delete_project_contributions_by_pk?: Maybe<Project_Contributions>;
  /** delete data from the table: "project_contributions_type" */
  delete_project_contributions_type?: Maybe<Project_Contributions_Type_Mutation_Response>;
  /** delete single row from the table: "project_contributions_type" */
  delete_project_contributions_type_by_pk?: Maybe<Project_Contributions_Type>;
  /** delete data from the table: "project_hashtags" */
  delete_project_hashtags?: Maybe<Project_Hashtags_Mutation_Response>;
  /** delete single row from the table: "project_hashtags" */
  delete_project_hashtags_by_pk?: Maybe<Project_Hashtags>;
  /** delete data from the table: "project_judges" */
  delete_project_judges?: Maybe<Project_Judges_Mutation_Response>;
  /** delete single row from the table: "project_judges" */
  delete_project_judges_by_pk?: Maybe<Project_Judges>;
  /** delete data from the table: "project_judging_submission_type" */
  delete_project_judging_submission_type?: Maybe<Project_Judging_Submission_Type_Mutation_Response>;
  /** delete single row from the table: "project_judging_submission_type" */
  delete_project_judging_submission_type_by_pk?: Maybe<Project_Judging_Submission_Type>;
  /** delete data from the table: "project_judgments" */
  delete_project_judgments?: Maybe<Project_Judgments_Mutation_Response>;
  /** delete single row from the table: "project_judgments" */
  delete_project_judgments_by_pk?: Maybe<Project_Judgments>;
  /** delete data from the table: "project_report_type" */
  delete_project_report_type?: Maybe<Project_Report_Type_Mutation_Response>;
  /** delete single row from the table: "project_report_type" */
  delete_project_report_type_by_pk?: Maybe<Project_Report_Type>;
  /** delete data from the table: "project_reports" */
  delete_project_reports?: Maybe<Project_Reports_Mutation_Response>;
  /** delete single row from the table: "project_reports" */
  delete_project_reports_by_pk?: Maybe<Project_Reports>;
  /** delete data from the table: "project_tracks" */
  delete_project_tracks?: Maybe<Project_Tracks_Mutation_Response>;
  /** delete single row from the table: "project_tracks" */
  delete_project_tracks_by_pk?: Maybe<Project_Tracks>;
  /** delete data from the table: "projects" */
  delete_projects?: Maybe<Projects_Mutation_Response>;
  /** delete single row from the table: "projects" */
  delete_projects_by_pk?: Maybe<Projects>;
  /** delete data from the table: "projects_funding" */
  delete_projects_funding?: Maybe<Projects_Funding_Mutation_Response>;
  /** delete single row from the table: "projects_funding" */
  delete_projects_funding_by_pk?: Maybe<Projects_Funding>;
  /** delete data from the table: "quadratic_voting" */
  delete_quadratic_voting?: Maybe<Quadratic_Voting_Mutation_Response>;
  /** delete single row from the table: "quadratic_voting" */
  delete_quadratic_voting_by_pk?: Maybe<Quadratic_Voting>;
  /** delete data from the table: "quadratic_voting_chain" */
  delete_quadratic_voting_chain?: Maybe<Quadratic_Voting_Chain_Mutation_Response>;
  /** delete single row from the table: "quadratic_voting_chain" */
  delete_quadratic_voting_chain_by_pk?: Maybe<Quadratic_Voting_Chain>;
  /** delete data from the table: "quadratic_voting_currency" */
  delete_quadratic_voting_currency?: Maybe<Quadratic_Voting_Currency_Mutation_Response>;
  /** delete single row from the table: "quadratic_voting_currency" */
  delete_quadratic_voting_currency_by_pk?: Maybe<Quadratic_Voting_Currency>;
  /** delete data from the table: "quadratic_voting_projects" */
  delete_quadratic_voting_projects?: Maybe<Quadratic_Voting_Projects_Mutation_Response>;
  /** delete single row from the table: "quadratic_voting_projects" */
  delete_quadratic_voting_projects_by_pk?: Maybe<Quadratic_Voting_Projects>;
  /** delete data from the table: "quadratic_voting_request_access" */
  delete_quadratic_voting_request_access?: Maybe<Quadratic_Voting_Request_Access_Mutation_Response>;
  /** delete single row from the table: "quadratic_voting_request_access" */
  delete_quadratic_voting_request_access_by_pk?: Maybe<Quadratic_Voting_Request_Access>;
  /** delete data from the table: "quadratic_voting_request_access_status" */
  delete_quadratic_voting_request_access_status?: Maybe<Quadratic_Voting_Request_Access_Status_Mutation_Response>;
  /** delete single row from the table: "quadratic_voting_request_access_status" */
  delete_quadratic_voting_request_access_status_by_pk?: Maybe<Quadratic_Voting_Request_Access_Status>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "room_judges" */
  delete_room_judges?: Maybe<Room_Judges_Mutation_Response>;
  /** delete single row from the table: "room_judges" */
  delete_room_judges_by_pk?: Maybe<Room_Judges>;
  /** delete data from the table: "schwag_tracks" */
  delete_schwag_tracks?: Maybe<Schwag_Tracks_Mutation_Response>;
  /** delete single row from the table: "schwag_tracks" */
  delete_schwag_tracks_by_pk?: Maybe<Schwag_Tracks>;
  /** delete data from the table: "schwags.allowed_org_winner_count" */
  delete_schwags_allowed_org_winner_count?: Maybe<Schwags_Allowed_Org_Winner_Count_Mutation_Response>;
  /** delete data from the table: "shop.countries" */
  delete_shop_countries?: Maybe<Shop_Countries_Mutation_Response>;
  /** delete single row from the table: "shop.countries" */
  delete_shop_countries_by_pk?: Maybe<Shop_Countries>;
  /** delete data from the table: "shop.coupon_discount_type" */
  delete_shop_coupon_discount_type?: Maybe<Shop_Coupon_Discount_Type_Mutation_Response>;
  /** delete single row from the table: "shop.coupon_discount_type" */
  delete_shop_coupon_discount_type_by_pk?: Maybe<Shop_Coupon_Discount_Type>;
  /** delete data from the table: "shop.coupon_type" */
  delete_shop_coupon_type?: Maybe<Shop_Coupon_Type_Mutation_Response>;
  /** delete single row from the table: "shop.coupon_type" */
  delete_shop_coupon_type_by_pk?: Maybe<Shop_Coupon_Type>;
  /** delete data from the table: "shop.coupons" */
  delete_shop_coupons?: Maybe<Shop_Coupons_Mutation_Response>;
  /** delete single row from the table: "shop.coupons" */
  delete_shop_coupons_by_pk?: Maybe<Shop_Coupons>;
  /** delete data from the table: "shop.hsn" */
  delete_shop_hsn?: Maybe<Shop_Hsn_Mutation_Response>;
  /** delete single row from the table: "shop.hsn" */
  delete_shop_hsn_by_pk?: Maybe<Shop_Hsn>;
  /** delete data from the table: "shop.hsn_mappings" */
  delete_shop_hsn_mappings?: Maybe<Shop_Hsn_Mappings_Mutation_Response>;
  /** delete single row from the table: "shop.hsn_mappings" */
  delete_shop_hsn_mappings_by_pk?: Maybe<Shop_Hsn_Mappings>;
  /** delete data from the table: "shop.inventory_skus" */
  delete_shop_inventory_skus?: Maybe<Shop_Inventory_Skus_Mutation_Response>;
  /** delete single row from the table: "shop.inventory_skus" */
  delete_shop_inventory_skus_by_pk?: Maybe<Shop_Inventory_Skus>;
  /** delete data from the table: "shop.order_payment_status" */
  delete_shop_order_payment_status?: Maybe<Shop_Order_Payment_Status_Mutation_Response>;
  /** delete single row from the table: "shop.order_payment_status" */
  delete_shop_order_payment_status_by_pk?: Maybe<Shop_Order_Payment_Status>;
  /** delete data from the table: "shop.order_products" */
  delete_shop_order_products?: Maybe<Shop_Order_Products_Mutation_Response>;
  /** delete single row from the table: "shop.order_products" */
  delete_shop_order_products_by_pk?: Maybe<Shop_Order_Products>;
  /** delete data from the table: "shop.orders" */
  delete_shop_orders?: Maybe<Shop_Orders_Mutation_Response>;
  /** delete single row from the table: "shop.orders" */
  delete_shop_orders_by_pk?: Maybe<Shop_Orders>;
  /** delete data from the table: "shop.product_type" */
  delete_shop_product_type?: Maybe<Shop_Product_Type_Mutation_Response>;
  /** delete single row from the table: "shop.product_type" */
  delete_shop_product_type_by_pk?: Maybe<Shop_Product_Type>;
  /** delete data from the table: "shop.products" */
  delete_shop_products?: Maybe<Shop_Products_Mutation_Response>;
  /** delete single row from the table: "shop.products" */
  delete_shop_products_by_pk?: Maybe<Shop_Products>;
  /** delete data from the table: "shop.shipping_addresses" */
  delete_shop_shipping_addresses?: Maybe<Shop_Shipping_Addresses_Mutation_Response>;
  /** delete single row from the table: "shop.shipping_addresses" */
  delete_shop_shipping_addresses_by_pk?: Maybe<Shop_Shipping_Addresses>;
  /** delete data from the table: "shop.states" */
  delete_shop_states?: Maybe<Shop_States_Mutation_Response>;
  /** delete single row from the table: "shop.states" */
  delete_shop_states_by_pk?: Maybe<Shop_States>;
  /** delete data from the table: "skills" */
  delete_skills?: Maybe<Skills_Mutation_Response>;
  /** delete single row from the table: "skills" */
  delete_skills_by_pk?: Maybe<Skills>;
  /** delete data from the table: "speaker_slot_status" */
  delete_speaker_slot_status?: Maybe<Speaker_Slot_Status_Mutation_Response>;
  /** delete single row from the table: "speaker_slot_status" */
  delete_speaker_slot_status_by_pk?: Maybe<Speaker_Slot_Status>;
  /** delete data from the table: "sponsor_judgments" */
  delete_sponsor_judgments?: Maybe<Sponsor_Judgments_Mutation_Response>;
  /** delete single row from the table: "sponsor_judgments" */
  delete_sponsor_judgments_by_pk?: Maybe<Sponsor_Judgments>;
  /** delete data from the table: "sponsor_tiers" */
  delete_sponsor_tiers?: Maybe<Sponsor_Tiers_Mutation_Response>;
  /** delete single row from the table: "sponsor_tiers" */
  delete_sponsor_tiers_by_pk?: Maybe<Sponsor_Tiers>;
  /** delete data from the table: "sponsors" */
  delete_sponsors?: Maybe<Sponsors_Mutation_Response>;
  /** delete single row from the table: "sponsors" */
  delete_sponsors_by_pk?: Maybe<Sponsors>;
  /** delete data from the table: "stickers" */
  delete_stickers?: Maybe<Stickers_Mutation_Response>;
  /** delete single row from the table: "stickers" */
  delete_stickers_by_pk?: Maybe<Stickers>;
  /** delete data from the table: "sumsub_applicants" */
  delete_sumsub_applicants?: Maybe<Sumsub_Applicants_Mutation_Response>;
  /** delete single row from the table: "sumsub_applicants" */
  delete_sumsub_applicants_by_pk?: Maybe<Sumsub_Applicants>;
  /** delete data from the table: "sumsub_applicants_review_status" */
  delete_sumsub_applicants_review_status?: Maybe<Sumsub_Applicants_Review_Status_Mutation_Response>;
  /** delete single row from the table: "sumsub_applicants_review_status" */
  delete_sumsub_applicants_review_status_by_pk?: Maybe<Sumsub_Applicants_Review_Status>;
  /** delete data from the table: "synaps_kyc_session_status" */
  delete_synaps_kyc_session_status?: Maybe<Synaps_Kyc_Session_Status_Mutation_Response>;
  /** delete single row from the table: "synaps_kyc_session_status" */
  delete_synaps_kyc_session_status_by_pk?: Maybe<Synaps_Kyc_Session_Status>;
  /** delete data from the table: "synaps_kyc_sessions" */
  delete_synaps_kyc_sessions?: Maybe<Synaps_Kyc_Sessions_Mutation_Response>;
  /** delete single row from the table: "synaps_kyc_sessions" */
  delete_synaps_kyc_sessions_by_pk?: Maybe<Synaps_Kyc_Sessions>;
  /** delete data from the table: "teams" */
  delete_teams?: Maybe<Teams_Mutation_Response>;
  /** delete single row from the table: "teams" */
  delete_teams_by_pk?: Maybe<Teams>;
  /** delete data from the table: "themes" */
  delete_themes?: Maybe<Themes_Mutation_Response>;
  /** delete single row from the table: "themes" */
  delete_themes_by_pk?: Maybe<Themes>;
  /** delete data from the table: "twitter_cards" */
  delete_twitter_cards?: Maybe<Twitter_Cards_Mutation_Response>;
  /** delete single row from the table: "twitter_cards" */
  delete_twitter_cards_by_pk?: Maybe<Twitter_Cards>;
  /** delete data from the table: "user_api_tokens" */
  delete_user_api_tokens?: Maybe<User_Api_Tokens_Mutation_Response>;
  /** delete single row from the table: "user_api_tokens" */
  delete_user_api_tokens_by_pk?: Maybe<User_Api_Tokens>;
  /** delete data from the table: "user_comments" */
  delete_user_comments?: Maybe<User_Comments_Mutation_Response>;
  /** delete single row from the table: "user_comments" */
  delete_user_comments_by_pk?: Maybe<User_Comments>;
  /** delete data from the table: "user_extras" */
  delete_user_extras?: Maybe<User_Extras_Mutation_Response>;
  /** delete single row from the table: "user_extras" */
  delete_user_extras_by_pk?: Maybe<User_Extras>;
  /** delete data from the table: "user_feature_flags" */
  delete_user_feature_flags?: Maybe<User_Feature_Flags_Mutation_Response>;
  /** delete single row from the table: "user_feature_flags" */
  delete_user_feature_flags_by_pk?: Maybe<User_Feature_Flags>;
  /** delete data from the table: "user_hackathon_bounties" */
  delete_user_hackathon_bounties?: Maybe<User_Hackathon_Bounties_Mutation_Response>;
  /** delete data from the table: "user_hackathon_bounties_bounty_type" */
  delete_user_hackathon_bounties_bounty_type?: Maybe<User_Hackathon_Bounties_Bounty_Type_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_bounties_bounty_type" */
  delete_user_hackathon_bounties_bounty_type_by_pk?: Maybe<User_Hackathon_Bounties_Bounty_Type>;
  /** delete single row from the table: "user_hackathon_bounties" */
  delete_user_hackathon_bounties_by_pk?: Maybe<User_Hackathon_Bounties>;
  /** delete data from the table: "user_hackathon_bounties_currency" */
  delete_user_hackathon_bounties_currency?: Maybe<User_Hackathon_Bounties_Currency_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_bounties_currency" */
  delete_user_hackathon_bounties_currency_by_pk?: Maybe<User_Hackathon_Bounties_Currency>;
  /** delete data from the table: "user_hackathon_bounties_status" */
  delete_user_hackathon_bounties_status?: Maybe<User_Hackathon_Bounties_Status_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_bounties_status" */
  delete_user_hackathon_bounties_status_by_pk?: Maybe<User_Hackathon_Bounties_Status>;
  /** delete data from the table: "user_hackathon_bounties_type" */
  delete_user_hackathon_bounties_type?: Maybe<User_Hackathon_Bounties_Type_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_bounties_type" */
  delete_user_hackathon_bounties_type_by_pk?: Maybe<User_Hackathon_Bounties_Type>;
  /** delete data from the table: "user_hackathon_checklists" */
  delete_user_hackathon_checklists?: Maybe<User_Hackathon_Checklists_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_checklists" */
  delete_user_hackathon_checklists_by_pk?: Maybe<User_Hackathon_Checklists>;
  /** delete data from the table: "user_hackathon_credentials" */
  delete_user_hackathon_credentials?: Maybe<User_Hackathon_Credentials_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_credentials" */
  delete_user_hackathon_credentials_by_pk?: Maybe<User_Hackathon_Credentials>;
  /** delete data from the table: "user_hackathon_credentials_status" */
  delete_user_hackathon_credentials_status?: Maybe<User_Hackathon_Credentials_Status_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_credentials_status" */
  delete_user_hackathon_credentials_status_by_pk?: Maybe<User_Hackathon_Credentials_Status>;
  /** delete data from the table: "user_hackathon_extras" */
  delete_user_hackathon_extras?: Maybe<User_Hackathon_Extras_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_extras" */
  delete_user_hackathon_extras_by_pk?: Maybe<User_Hackathon_Extras>;
  /** delete data from the table: "user_hackathon_feedbacks" */
  delete_user_hackathon_feedbacks?: Maybe<User_Hackathon_Feedbacks_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_feedbacks" */
  delete_user_hackathon_feedbacks_by_pk?: Maybe<User_Hackathon_Feedbacks>;
  /** delete data from the table: "user_hackathon_reminders" */
  delete_user_hackathon_reminders?: Maybe<User_Hackathon_Reminders_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_reminders" */
  delete_user_hackathon_reminders_by_pk?: Maybe<User_Hackathon_Reminders>;
  /** delete data from the table: "user_hackathon_schwags" */
  delete_user_hackathon_schwags?: Maybe<User_Hackathon_Schwags_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_schwags" */
  delete_user_hackathon_schwags_by_pk?: Maybe<User_Hackathon_Schwags>;
  /** delete data from the table: "user_hackathon_staking_razorpay_payment_status" */
  delete_user_hackathon_staking_razorpay_payment_status?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_staking_razorpay_payment_status" */
  delete_user_hackathon_staking_razorpay_payment_status_by_pk?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status>;
  /** delete data from the table: "user_hackathon_staking_status" */
  delete_user_hackathon_staking_status?: Maybe<User_Hackathon_Staking_Status_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_staking_status" */
  delete_user_hackathon_staking_status_by_pk?: Maybe<User_Hackathon_Staking_Status>;
  /** delete data from the table: "user_hackathon_stakings" */
  delete_user_hackathon_stakings?: Maybe<User_Hackathon_Stakings_Mutation_Response>;
  /** delete single row from the table: "user_hackathon_stakings" */
  delete_user_hackathon_stakings_by_pk?: Maybe<User_Hackathon_Stakings>;
  /** delete data from the table: "user_hackathons" */
  delete_user_hackathons?: Maybe<User_Hackathons_Mutation_Response>;
  /** delete single row from the table: "user_hackathons" */
  delete_user_hackathons_by_pk?: Maybe<User_Hackathons>;
  /** delete data from the table: "user_idea_stats" */
  delete_user_idea_stats?: Maybe<User_Idea_Stats_Mutation_Response>;
  /** delete single row from the table: "user_idea_stats" */
  delete_user_idea_stats_by_pk?: Maybe<User_Idea_Stats>;
  /** delete data from the table: "user_kyc_status" */
  delete_user_kyc_status?: Maybe<User_Kyc_Status_Mutation_Response>;
  /** delete single row from the table: "user_kyc_status" */
  delete_user_kyc_status_by_pk?: Maybe<User_Kyc_Status>;
  /** delete data from the table: "user_permissions" */
  delete_user_permissions?: Maybe<User_Permissions_Mutation_Response>;
  /** delete single row from the table: "user_permissions" */
  delete_user_permissions_by_pk?: Maybe<User_Permissions>;
  /** delete data from the table: "user_profile_rss_feed_platforms" */
  delete_user_profile_rss_feed_platforms?: Maybe<User_Profile_Rss_Feed_Platforms_Mutation_Response>;
  /** delete single row from the table: "user_profile_rss_feed_platforms" */
  delete_user_profile_rss_feed_platforms_by_pk?: Maybe<User_Profile_Rss_Feed_Platforms>;
  /** delete data from the table: "user_profile_rss_feeds" */
  delete_user_profile_rss_feeds?: Maybe<User_Profile_Rss_Feeds_Mutation_Response>;
  /** delete single row from the table: "user_profile_rss_feeds" */
  delete_user_profile_rss_feeds_by_pk?: Maybe<User_Profile_Rss_Feeds>;
  /** delete data from the table: "user_profiles" */
  delete_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** delete single row from the table: "user_profiles" */
  delete_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** delete data from the table: "user_project_meta" */
  delete_user_project_meta?: Maybe<User_Project_Meta_Mutation_Response>;
  /** delete single row from the table: "user_project_meta" */
  delete_user_project_meta_by_pk?: Maybe<User_Project_Meta>;
  /** delete data from the table: "user_projects" */
  delete_user_projects?: Maybe<User_Projects_Mutation_Response>;
  /** delete single row from the table: "user_projects" */
  delete_user_projects_by_pk?: Maybe<User_Projects>;
  /** delete data from the table: "user_public_profile_layout" */
  delete_user_public_profile_layout?: Maybe<User_Public_Profile_Layout_Mutation_Response>;
  /** delete single row from the table: "user_public_profile_layout" */
  delete_user_public_profile_layout_by_pk?: Maybe<User_Public_Profile_Layout>;
  /** delete data from the table: "user_public_profile_projects" */
  delete_user_public_profile_projects?: Maybe<User_Public_Profile_Projects_Mutation_Response>;
  /** delete single row from the table: "user_public_profile_projects" */
  delete_user_public_profile_projects_by_pk?: Maybe<User_Public_Profile_Projects>;
  /** delete data from the table: "user_roles" */
  delete_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** delete single row from the table: "user_roles" */
  delete_user_roles_by_pk?: Maybe<User_Roles>;
  /** delete data from the table: "user_saved_searches" */
  delete_user_saved_searches?: Maybe<User_Saved_Searches_Mutation_Response>;
  /** delete single row from the table: "user_saved_searches" */
  delete_user_saved_searches_by_pk?: Maybe<User_Saved_Searches>;
  /** delete data from the table: "user_skills" */
  delete_user_skills?: Maybe<User_Skills_Mutation_Response>;
  /** delete single row from the table: "user_skills" */
  delete_user_skills_by_pk?: Maybe<User_Skills>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "winners" */
  delete_winners?: Maybe<Winners_Mutation_Response>;
  /** delete single row from the table: "winners" */
  delete_winners_by_pk?: Maybe<Winners>;
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>;
  /** insert data into the table: "articles" */
  insert_articles?: Maybe<Articles_Mutation_Response>;
  /** insert a single row into the table: "articles" */
  insert_articles_one?: Maybe<Articles>;
  /** insert data into the table: "colleges" */
  insert_colleges?: Maybe<Colleges_Mutation_Response>;
  /** insert a single row into the table: "colleges" */
  insert_colleges_one?: Maybe<Colleges>;
  /** insert data into the table: "comments" */
  insert_comments?: Maybe<Comments_Mutation_Response>;
  /** insert a single row into the table: "comments" */
  insert_comments_one?: Maybe<Comments>;
  /** insert data into the table: "company" */
  insert_company?: Maybe<Company_Mutation_Response>;
  /** insert a single row into the table: "company" */
  insert_company_one?: Maybe<Company>;
  /** insert data into the table: "discover" */
  insert_discover?: Maybe<Discover_Mutation_Response>;
  /** insert data into the table: "discover_events" */
  insert_discover_events?: Maybe<Discover_Events_Mutation_Response>;
  /** insert a single row into the table: "discover_events" */
  insert_discover_events_one?: Maybe<Discover_Events>;
  /** insert a single row into the table: "discover" */
  insert_discover_one?: Maybe<Discover>;
  /** insert data into the table: "education_fields" */
  insert_education_fields?: Maybe<Education_Fields_Mutation_Response>;
  /** insert a single row into the table: "education_fields" */
  insert_education_fields_one?: Maybe<Education_Fields>;
  /** insert data into the table: "educations" */
  insert_educations?: Maybe<Educations_Mutation_Response>;
  /** insert a single row into the table: "educations" */
  insert_educations_one?: Maybe<Educations>;
  /** insert data into the table: "experience_type" */
  insert_experience_type?: Maybe<Experience_Type_Mutation_Response>;
  /** insert a single row into the table: "experience_type" */
  insert_experience_type_one?: Maybe<Experience_Type>;
  /** insert data into the table: "experiences" */
  insert_experiences?: Maybe<Experiences_Mutation_Response>;
  /** insert a single row into the table: "experiences" */
  insert_experiences_one?: Maybe<Experiences>;
  /** insert data into the table: "feature_flag_types" */
  insert_feature_flag_types?: Maybe<Feature_Flag_Types_Mutation_Response>;
  /** insert a single row into the table: "feature_flag_types" */
  insert_feature_flag_types_one?: Maybe<Feature_Flag_Types>;
  /** insert data into the table: "feature_flags" */
  insert_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** insert a single row into the table: "feature_flags" */
  insert_feature_flags_one?: Maybe<Feature_Flags>;
  /** insert data into the table: "hackathon_bounties_status" */
  insert_hackathon_bounties_status?: Maybe<Hackathon_Bounties_Status_Mutation_Response>;
  /** insert a single row into the table: "hackathon_bounties_status" */
  insert_hackathon_bounties_status_one?: Maybe<Hackathon_Bounties_Status>;
  /** insert data into the table: "hackathon_brands" */
  insert_hackathon_brands?: Maybe<Hackathon_Brands_Mutation_Response>;
  /** insert a single row into the table: "hackathon_brands" */
  insert_hackathon_brands_one?: Maybe<Hackathon_Brands>;
  /** insert data into the table: "hackathon_checklists" */
  insert_hackathon_checklists?: Maybe<Hackathon_Checklists_Mutation_Response>;
  /** insert a single row into the table: "hackathon_checklists" */
  insert_hackathon_checklists_one?: Maybe<Hackathon_Checklists>;
  /** insert data into the table: "hackathon_credential_eligible_entities" */
  insert_hackathon_credential_eligible_entities?: Maybe<Hackathon_Credential_Eligible_Entities_Mutation_Response>;
  /** insert a single row into the table: "hackathon_credential_eligible_entities" */
  insert_hackathon_credential_eligible_entities_one?: Maybe<Hackathon_Credential_Eligible_Entities>;
  /** insert data into the table: "hackathon_credential_type" */
  insert_hackathon_credential_type?: Maybe<Hackathon_Credential_Type_Mutation_Response>;
  /** insert a single row into the table: "hackathon_credential_type" */
  insert_hackathon_credential_type_one?: Maybe<Hackathon_Credential_Type>;
  /** insert data into the table: "hackathon_credentials" */
  insert_hackathon_credentials?: Maybe<Hackathon_Credentials_Mutation_Response>;
  /** insert data into the table: "hackathon_credentials_chain" */
  insert_hackathon_credentials_chain?: Maybe<Hackathon_Credentials_Chain_Mutation_Response>;
  /** insert a single row into the table: "hackathon_credentials_chain" */
  insert_hackathon_credentials_chain_one?: Maybe<Hackathon_Credentials_Chain>;
  /** insert a single row into the table: "hackathon_credentials" */
  insert_hackathon_credentials_one?: Maybe<Hackathon_Credentials>;
  /** insert data into the table: "hackathon_email_templates" */
  insert_hackathon_email_templates?: Maybe<Hackathon_Email_Templates_Mutation_Response>;
  /** insert a single row into the table: "hackathon_email_templates" */
  insert_hackathon_email_templates_one?: Maybe<Hackathon_Email_Templates>;
  /** insert data into the table: "hackathon_event_groups" */
  insert_hackathon_event_groups?: Maybe<Hackathon_Event_Groups_Mutation_Response>;
  /** insert a single row into the table: "hackathon_event_groups" */
  insert_hackathon_event_groups_one?: Maybe<Hackathon_Event_Groups>;
  /** insert data into the table: "hackathon_event_speakers" */
  insert_hackathon_event_speakers?: Maybe<Hackathon_Event_Speakers_Mutation_Response>;
  /** insert a single row into the table: "hackathon_event_speakers" */
  insert_hackathon_event_speakers_one?: Maybe<Hackathon_Event_Speakers>;
  /** insert data into the table: "hackathon_event_sponsors" */
  insert_hackathon_event_sponsors?: Maybe<Hackathon_Event_Sponsors_Mutation_Response>;
  /** insert a single row into the table: "hackathon_event_sponsors" */
  insert_hackathon_event_sponsors_one?: Maybe<Hackathon_Event_Sponsors>;
  /** insert data into the table: "hackathon_event_type" */
  insert_hackathon_event_type?: Maybe<Hackathon_Event_Type_Mutation_Response>;
  /** insert a single row into the table: "hackathon_event_type" */
  insert_hackathon_event_type_one?: Maybe<Hackathon_Event_Type>;
  /** insert data into the table: "hackathon_events" */
  insert_hackathon_events?: Maybe<Hackathon_Events_Mutation_Response>;
  /** insert a single row into the table: "hackathon_events" */
  insert_hackathon_events_one?: Maybe<Hackathon_Events>;
  /** insert data into the table: "hackathon_faq" */
  insert_hackathon_faq?: Maybe<Hackathon_Faq_Mutation_Response>;
  /** insert a single row into the table: "hackathon_faq" */
  insert_hackathon_faq_one?: Maybe<Hackathon_Faq>;
  /** insert data into the table: "hackathon_faq_type" */
  insert_hackathon_faq_type?: Maybe<Hackathon_Faq_Type_Mutation_Response>;
  /** insert a single row into the table: "hackathon_faq_type" */
  insert_hackathon_faq_type_one?: Maybe<Hackathon_Faq_Type>;
  /** insert data into the table: "hackathon_hashtags" */
  insert_hackathon_hashtags?: Maybe<Hackathon_Hashtags_Mutation_Response>;
  /** insert a single row into the table: "hackathon_hashtags" */
  insert_hackathon_hashtags_one?: Maybe<Hackathon_Hashtags>;
  /** insert data into the table: "hackathon_hosts" */
  insert_hackathon_hosts?: Maybe<Hackathon_Hosts_Mutation_Response>;
  /** insert a single row into the table: "hackathon_hosts" */
  insert_hackathon_hosts_one?: Maybe<Hackathon_Hosts>;
  /** insert data into the table: "hackathon_note_type" */
  insert_hackathon_note_type?: Maybe<Hackathon_Note_Type_Mutation_Response>;
  /** insert a single row into the table: "hackathon_note_type" */
  insert_hackathon_note_type_one?: Maybe<Hackathon_Note_Type>;
  /** insert data into the table: "hackathon_notes" */
  insert_hackathon_notes?: Maybe<Hackathon_Notes_Mutation_Response>;
  /** insert a single row into the table: "hackathon_notes" */
  insert_hackathon_notes_one?: Maybe<Hackathon_Notes>;
  /** insert data into the table: "hackathon_schwags" */
  insert_hackathon_schwags?: Maybe<Hackathon_Schwags_Mutation_Response>;
  /** insert a single row into the table: "hackathon_schwags" */
  insert_hackathon_schwags_one?: Maybe<Hackathon_Schwags>;
  /** insert data into the table: "hackathon_scope_extras" */
  insert_hackathon_scope_extras?: Maybe<Hackathon_Scope_Extras_Mutation_Response>;
  /** insert a single row into the table: "hackathon_scope_extras" */
  insert_hackathon_scope_extras_one?: Maybe<Hackathon_Scope_Extras>;
  /** insert data into the table: "hackathon_scopes" */
  insert_hackathon_scopes?: Maybe<Hackathon_Scopes_Mutation_Response>;
  /** insert a single row into the table: "hackathon_scopes" */
  insert_hackathon_scopes_one?: Maybe<Hackathon_Scopes>;
  /** insert data into the table: "hackathon_settings" */
  insert_hackathon_settings?: Maybe<Hackathon_Settings_Mutation_Response>;
  /** insert a single row into the table: "hackathon_settings" */
  insert_hackathon_settings_one?: Maybe<Hackathon_Settings>;
  /** insert data into the table: "hackathon_staking_currency" */
  insert_hackathon_staking_currency?: Maybe<Hackathon_Staking_Currency_Mutation_Response>;
  /** insert a single row into the table: "hackathon_staking_currency" */
  insert_hackathon_staking_currency_one?: Maybe<Hackathon_Staking_Currency>;
  /** insert data into the table: "hackathon_staking_type" */
  insert_hackathon_staking_type?: Maybe<Hackathon_Staking_Type_Mutation_Response>;
  /** insert a single row into the table: "hackathon_staking_type" */
  insert_hackathon_staking_type_one?: Maybe<Hackathon_Staking_Type>;
  /** insert data into the table: "hackathon_stakings" */
  insert_hackathon_stakings?: Maybe<Hackathon_Stakings_Mutation_Response>;
  /** insert a single row into the table: "hackathon_stakings" */
  insert_hackathon_stakings_one?: Maybe<Hackathon_Stakings>;
  /** insert data into the table: "hackathon_themes" */
  insert_hackathon_themes?: Maybe<Hackathon_Themes_Mutation_Response>;
  /** insert a single row into the table: "hackathon_themes" */
  insert_hackathon_themes_one?: Maybe<Hackathon_Themes>;
  /** insert data into the table: "hackathon_tracks" */
  insert_hackathon_tracks?: Maybe<Hackathon_Tracks_Mutation_Response>;
  /** insert a single row into the table: "hackathon_tracks" */
  insert_hackathon_tracks_one?: Maybe<Hackathon_Tracks>;
  /** insert data into the table: "hackathon_type" */
  insert_hackathon_type?: Maybe<Hackathon_Type_Mutation_Response>;
  /** insert a single row into the table: "hackathon_type" */
  insert_hackathon_type_one?: Maybe<Hackathon_Type>;
  /** insert data into the table: "hackathons" */
  insert_hackathons?: Maybe<Hackathons_Mutation_Response>;
  /** insert a single row into the table: "hackathons" */
  insert_hackathons_one?: Maybe<Hackathons>;
  /** insert data into the table: "hashtags" */
  insert_hashtags?: Maybe<Hashtags_Mutation_Response>;
  /** insert a single row into the table: "hashtags" */
  insert_hashtags_one?: Maybe<Hashtags>;
  /** insert data into the table: "idea_stats" */
  insert_idea_stats?: Maybe<Idea_Stats_Mutation_Response>;
  /** insert a single row into the table: "idea_stats" */
  insert_idea_stats_one?: Maybe<Idea_Stats>;
  /** insert data into the table: "ideas" */
  insert_ideas?: Maybe<Ideas_Mutation_Response>;
  /** insert a single row into the table: "ideas" */
  insert_ideas_one?: Maybe<Ideas>;
  /** insert data into the table: "judges" */
  insert_judges?: Maybe<Judges_Mutation_Response>;
  /** insert a single row into the table: "judges" */
  insert_judges_one?: Maybe<Judges>;
  /** insert data into the table: "judging_rooms" */
  insert_judging_rooms?: Maybe<Judging_Rooms_Mutation_Response>;
  /** insert a single row into the table: "judging_rooms" */
  insert_judging_rooms_one?: Maybe<Judging_Rooms>;
  /** insert data into the table: "notification_types" */
  insert_notification_types?: Maybe<Notification_Types_Mutation_Response>;
  /** insert a single row into the table: "notification_types" */
  insert_notification_types_one?: Maybe<Notification_Types>;
  /** insert data into the table: "notifications" */
  insert_notifications?: Maybe<Notifications_Mutation_Response>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: Maybe<Notifications>;
  /** insert data into the table: "oauth" */
  insert_oauth?: Maybe<Oauth_Mutation_Response>;
  /** insert a single row into the table: "oauth" */
  insert_oauth_one?: Maybe<Oauth>;
  /** insert data into the table: "oauth_providers" */
  insert_oauth_providers?: Maybe<Oauth_Providers_Mutation_Response>;
  /** insert a single row into the table: "oauth_providers" */
  insert_oauth_providers_one?: Maybe<Oauth_Providers>;
  /** insert data into the table: "permissions" */
  insert_permissions?: Maybe<Permissions_Mutation_Response>;
  /** insert a single row into the table: "permissions" */
  insert_permissions_one?: Maybe<Permissions>;
  /** insert data into the table: "prize_sponsors" */
  insert_prize_sponsors?: Maybe<Prize_Sponsors_Mutation_Response>;
  /** insert a single row into the table: "prize_sponsors" */
  insert_prize_sponsors_one?: Maybe<Prize_Sponsors>;
  /** insert data into the table: "prize_tracks" */
  insert_prize_tracks?: Maybe<Prize_Tracks_Mutation_Response>;
  /** insert a single row into the table: "prize_tracks" */
  insert_prize_tracks_one?: Maybe<Prize_Tracks>;
  /** insert data into the table: "prizes" */
  insert_prizes?: Maybe<Prizes_Mutation_Response>;
  /** insert a single row into the table: "prizes" */
  insert_prizes_one?: Maybe<Prizes>;
  /** insert data into the table: "profiles" */
  insert_profiles?: Maybe<Profiles_Mutation_Response>;
  /** insert a single row into the table: "profiles" */
  insert_profiles_one?: Maybe<Profiles>;
  /** insert data into the table: "project_commits" */
  insert_project_commits?: Maybe<Project_Commits_Mutation_Response>;
  /** insert a single row into the table: "project_commits" */
  insert_project_commits_one?: Maybe<Project_Commits>;
  /** insert data into the table: "project_contribution_stickers" */
  insert_project_contribution_stickers?: Maybe<Project_Contribution_Stickers_Mutation_Response>;
  /** insert a single row into the table: "project_contribution_stickers" */
  insert_project_contribution_stickers_one?: Maybe<Project_Contribution_Stickers>;
  /** insert data into the table: "project_contribution_tx_network_type" */
  insert_project_contribution_tx_network_type?: Maybe<Project_Contribution_Tx_Network_Type_Mutation_Response>;
  /** insert a single row into the table: "project_contribution_tx_network_type" */
  insert_project_contribution_tx_network_type_one?: Maybe<Project_Contribution_Tx_Network_Type>;
  /** insert data into the table: "project_contributions" */
  insert_project_contributions?: Maybe<Project_Contributions_Mutation_Response>;
  /** insert a single row into the table: "project_contributions" */
  insert_project_contributions_one?: Maybe<Project_Contributions>;
  /** insert data into the table: "project_contributions_type" */
  insert_project_contributions_type?: Maybe<Project_Contributions_Type_Mutation_Response>;
  /** insert a single row into the table: "project_contributions_type" */
  insert_project_contributions_type_one?: Maybe<Project_Contributions_Type>;
  /** insert data into the table: "project_hashtags" */
  insert_project_hashtags?: Maybe<Project_Hashtags_Mutation_Response>;
  /** insert a single row into the table: "project_hashtags" */
  insert_project_hashtags_one?: Maybe<Project_Hashtags>;
  /** insert data into the table: "project_judges" */
  insert_project_judges?: Maybe<Project_Judges_Mutation_Response>;
  /** insert a single row into the table: "project_judges" */
  insert_project_judges_one?: Maybe<Project_Judges>;
  /** insert data into the table: "project_judging_submission_type" */
  insert_project_judging_submission_type?: Maybe<Project_Judging_Submission_Type_Mutation_Response>;
  /** insert a single row into the table: "project_judging_submission_type" */
  insert_project_judging_submission_type_one?: Maybe<Project_Judging_Submission_Type>;
  /** insert data into the table: "project_judgments" */
  insert_project_judgments?: Maybe<Project_Judgments_Mutation_Response>;
  /** insert a single row into the table: "project_judgments" */
  insert_project_judgments_one?: Maybe<Project_Judgments>;
  /** insert data into the table: "project_report_type" */
  insert_project_report_type?: Maybe<Project_Report_Type_Mutation_Response>;
  /** insert a single row into the table: "project_report_type" */
  insert_project_report_type_one?: Maybe<Project_Report_Type>;
  /** insert data into the table: "project_reports" */
  insert_project_reports?: Maybe<Project_Reports_Mutation_Response>;
  /** insert a single row into the table: "project_reports" */
  insert_project_reports_one?: Maybe<Project_Reports>;
  /** insert data into the table: "project_tracks" */
  insert_project_tracks?: Maybe<Project_Tracks_Mutation_Response>;
  /** insert a single row into the table: "project_tracks" */
  insert_project_tracks_one?: Maybe<Project_Tracks>;
  /** insert data into the table: "projects" */
  insert_projects?: Maybe<Projects_Mutation_Response>;
  /** insert data into the table: "projects_funding" */
  insert_projects_funding?: Maybe<Projects_Funding_Mutation_Response>;
  /** insert a single row into the table: "projects_funding" */
  insert_projects_funding_one?: Maybe<Projects_Funding>;
  /** insert a single row into the table: "projects" */
  insert_projects_one?: Maybe<Projects>;
  /** insert data into the table: "quadratic_voting" */
  insert_quadratic_voting?: Maybe<Quadratic_Voting_Mutation_Response>;
  /** insert data into the table: "quadratic_voting_chain" */
  insert_quadratic_voting_chain?: Maybe<Quadratic_Voting_Chain_Mutation_Response>;
  /** insert a single row into the table: "quadratic_voting_chain" */
  insert_quadratic_voting_chain_one?: Maybe<Quadratic_Voting_Chain>;
  /** insert data into the table: "quadratic_voting_currency" */
  insert_quadratic_voting_currency?: Maybe<Quadratic_Voting_Currency_Mutation_Response>;
  /** insert a single row into the table: "quadratic_voting_currency" */
  insert_quadratic_voting_currency_one?: Maybe<Quadratic_Voting_Currency>;
  /** insert a single row into the table: "quadratic_voting" */
  insert_quadratic_voting_one?: Maybe<Quadratic_Voting>;
  /** insert data into the table: "quadratic_voting_projects" */
  insert_quadratic_voting_projects?: Maybe<Quadratic_Voting_Projects_Mutation_Response>;
  /** insert a single row into the table: "quadratic_voting_projects" */
  insert_quadratic_voting_projects_one?: Maybe<Quadratic_Voting_Projects>;
  /** insert data into the table: "quadratic_voting_request_access" */
  insert_quadratic_voting_request_access?: Maybe<Quadratic_Voting_Request_Access_Mutation_Response>;
  /** insert a single row into the table: "quadratic_voting_request_access" */
  insert_quadratic_voting_request_access_one?: Maybe<Quadratic_Voting_Request_Access>;
  /** insert data into the table: "quadratic_voting_request_access_status" */
  insert_quadratic_voting_request_access_status?: Maybe<Quadratic_Voting_Request_Access_Status_Mutation_Response>;
  /** insert a single row into the table: "quadratic_voting_request_access_status" */
  insert_quadratic_voting_request_access_status_one?: Maybe<Quadratic_Voting_Request_Access_Status>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "room_judges" */
  insert_room_judges?: Maybe<Room_Judges_Mutation_Response>;
  /** insert a single row into the table: "room_judges" */
  insert_room_judges_one?: Maybe<Room_Judges>;
  /** insert data into the table: "schwag_tracks" */
  insert_schwag_tracks?: Maybe<Schwag_Tracks_Mutation_Response>;
  /** insert a single row into the table: "schwag_tracks" */
  insert_schwag_tracks_one?: Maybe<Schwag_Tracks>;
  /** insert data into the table: "schwags.allowed_org_winner_count" */
  insert_schwags_allowed_org_winner_count?: Maybe<Schwags_Allowed_Org_Winner_Count_Mutation_Response>;
  /** insert a single row into the table: "schwags.allowed_org_winner_count" */
  insert_schwags_allowed_org_winner_count_one?: Maybe<Schwags_Allowed_Org_Winner_Count>;
  /** insert data into the table: "shop.countries" */
  insert_shop_countries?: Maybe<Shop_Countries_Mutation_Response>;
  /** insert a single row into the table: "shop.countries" */
  insert_shop_countries_one?: Maybe<Shop_Countries>;
  /** insert data into the table: "shop.coupon_discount_type" */
  insert_shop_coupon_discount_type?: Maybe<Shop_Coupon_Discount_Type_Mutation_Response>;
  /** insert a single row into the table: "shop.coupon_discount_type" */
  insert_shop_coupon_discount_type_one?: Maybe<Shop_Coupon_Discount_Type>;
  /** insert data into the table: "shop.coupon_type" */
  insert_shop_coupon_type?: Maybe<Shop_Coupon_Type_Mutation_Response>;
  /** insert a single row into the table: "shop.coupon_type" */
  insert_shop_coupon_type_one?: Maybe<Shop_Coupon_Type>;
  /** insert data into the table: "shop.coupons" */
  insert_shop_coupons?: Maybe<Shop_Coupons_Mutation_Response>;
  /** insert a single row into the table: "shop.coupons" */
  insert_shop_coupons_one?: Maybe<Shop_Coupons>;
  /** insert data into the table: "shop.hsn" */
  insert_shop_hsn?: Maybe<Shop_Hsn_Mutation_Response>;
  /** insert data into the table: "shop.hsn_mappings" */
  insert_shop_hsn_mappings?: Maybe<Shop_Hsn_Mappings_Mutation_Response>;
  /** insert a single row into the table: "shop.hsn_mappings" */
  insert_shop_hsn_mappings_one?: Maybe<Shop_Hsn_Mappings>;
  /** insert a single row into the table: "shop.hsn" */
  insert_shop_hsn_one?: Maybe<Shop_Hsn>;
  /** insert data into the table: "shop.inventory_skus" */
  insert_shop_inventory_skus?: Maybe<Shop_Inventory_Skus_Mutation_Response>;
  /** insert a single row into the table: "shop.inventory_skus" */
  insert_shop_inventory_skus_one?: Maybe<Shop_Inventory_Skus>;
  /** insert data into the table: "shop.order_payment_status" */
  insert_shop_order_payment_status?: Maybe<Shop_Order_Payment_Status_Mutation_Response>;
  /** insert a single row into the table: "shop.order_payment_status" */
  insert_shop_order_payment_status_one?: Maybe<Shop_Order_Payment_Status>;
  /** insert data into the table: "shop.order_products" */
  insert_shop_order_products?: Maybe<Shop_Order_Products_Mutation_Response>;
  /** insert a single row into the table: "shop.order_products" */
  insert_shop_order_products_one?: Maybe<Shop_Order_Products>;
  /** insert data into the table: "shop.orders" */
  insert_shop_orders?: Maybe<Shop_Orders_Mutation_Response>;
  /** insert a single row into the table: "shop.orders" */
  insert_shop_orders_one?: Maybe<Shop_Orders>;
  /** insert data into the table: "shop.product_type" */
  insert_shop_product_type?: Maybe<Shop_Product_Type_Mutation_Response>;
  /** insert a single row into the table: "shop.product_type" */
  insert_shop_product_type_one?: Maybe<Shop_Product_Type>;
  /** insert data into the table: "shop.products" */
  insert_shop_products?: Maybe<Shop_Products_Mutation_Response>;
  /** insert a single row into the table: "shop.products" */
  insert_shop_products_one?: Maybe<Shop_Products>;
  /** insert data into the table: "shop.shipping_addresses" */
  insert_shop_shipping_addresses?: Maybe<Shop_Shipping_Addresses_Mutation_Response>;
  /** insert a single row into the table: "shop.shipping_addresses" */
  insert_shop_shipping_addresses_one?: Maybe<Shop_Shipping_Addresses>;
  /** insert data into the table: "shop.states" */
  insert_shop_states?: Maybe<Shop_States_Mutation_Response>;
  /** insert a single row into the table: "shop.states" */
  insert_shop_states_one?: Maybe<Shop_States>;
  /** insert data into the table: "skills" */
  insert_skills?: Maybe<Skills_Mutation_Response>;
  /** insert a single row into the table: "skills" */
  insert_skills_one?: Maybe<Skills>;
  /** insert data into the table: "speaker_slot_status" */
  insert_speaker_slot_status?: Maybe<Speaker_Slot_Status_Mutation_Response>;
  /** insert a single row into the table: "speaker_slot_status" */
  insert_speaker_slot_status_one?: Maybe<Speaker_Slot_Status>;
  /** insert data into the table: "sponsor_judgments" */
  insert_sponsor_judgments?: Maybe<Sponsor_Judgments_Mutation_Response>;
  /** insert a single row into the table: "sponsor_judgments" */
  insert_sponsor_judgments_one?: Maybe<Sponsor_Judgments>;
  /** insert data into the table: "sponsor_tiers" */
  insert_sponsor_tiers?: Maybe<Sponsor_Tiers_Mutation_Response>;
  /** insert a single row into the table: "sponsor_tiers" */
  insert_sponsor_tiers_one?: Maybe<Sponsor_Tiers>;
  /** insert data into the table: "sponsors" */
  insert_sponsors?: Maybe<Sponsors_Mutation_Response>;
  /** insert a single row into the table: "sponsors" */
  insert_sponsors_one?: Maybe<Sponsors>;
  /** insert data into the table: "stickers" */
  insert_stickers?: Maybe<Stickers_Mutation_Response>;
  /** insert a single row into the table: "stickers" */
  insert_stickers_one?: Maybe<Stickers>;
  /** insert data into the table: "sumsub_applicants" */
  insert_sumsub_applicants?: Maybe<Sumsub_Applicants_Mutation_Response>;
  /** insert a single row into the table: "sumsub_applicants" */
  insert_sumsub_applicants_one?: Maybe<Sumsub_Applicants>;
  /** insert data into the table: "sumsub_applicants_review_status" */
  insert_sumsub_applicants_review_status?: Maybe<Sumsub_Applicants_Review_Status_Mutation_Response>;
  /** insert a single row into the table: "sumsub_applicants_review_status" */
  insert_sumsub_applicants_review_status_one?: Maybe<Sumsub_Applicants_Review_Status>;
  /** insert data into the table: "synaps_kyc_session_status" */
  insert_synaps_kyc_session_status?: Maybe<Synaps_Kyc_Session_Status_Mutation_Response>;
  /** insert a single row into the table: "synaps_kyc_session_status" */
  insert_synaps_kyc_session_status_one?: Maybe<Synaps_Kyc_Session_Status>;
  /** insert data into the table: "synaps_kyc_sessions" */
  insert_synaps_kyc_sessions?: Maybe<Synaps_Kyc_Sessions_Mutation_Response>;
  /** insert a single row into the table: "synaps_kyc_sessions" */
  insert_synaps_kyc_sessions_one?: Maybe<Synaps_Kyc_Sessions>;
  /** insert data into the table: "teams" */
  insert_teams?: Maybe<Teams_Mutation_Response>;
  /** insert a single row into the table: "teams" */
  insert_teams_one?: Maybe<Teams>;
  /** insert data into the table: "themes" */
  insert_themes?: Maybe<Themes_Mutation_Response>;
  /** insert a single row into the table: "themes" */
  insert_themes_one?: Maybe<Themes>;
  /** insert data into the table: "twitter_cards" */
  insert_twitter_cards?: Maybe<Twitter_Cards_Mutation_Response>;
  /** insert a single row into the table: "twitter_cards" */
  insert_twitter_cards_one?: Maybe<Twitter_Cards>;
  /** insert data into the table: "user_api_tokens" */
  insert_user_api_tokens?: Maybe<User_Api_Tokens_Mutation_Response>;
  /** insert a single row into the table: "user_api_tokens" */
  insert_user_api_tokens_one?: Maybe<User_Api_Tokens>;
  /** insert data into the table: "user_comments" */
  insert_user_comments?: Maybe<User_Comments_Mutation_Response>;
  /** insert a single row into the table: "user_comments" */
  insert_user_comments_one?: Maybe<User_Comments>;
  /** insert data into the table: "user_extras" */
  insert_user_extras?: Maybe<User_Extras_Mutation_Response>;
  /** insert a single row into the table: "user_extras" */
  insert_user_extras_one?: Maybe<User_Extras>;
  /** insert data into the table: "user_feature_flags" */
  insert_user_feature_flags?: Maybe<User_Feature_Flags_Mutation_Response>;
  /** insert a single row into the table: "user_feature_flags" */
  insert_user_feature_flags_one?: Maybe<User_Feature_Flags>;
  /** insert data into the table: "user_hackathon_bounties" */
  insert_user_hackathon_bounties?: Maybe<User_Hackathon_Bounties_Mutation_Response>;
  /** insert data into the table: "user_hackathon_bounties_bounty_type" */
  insert_user_hackathon_bounties_bounty_type?: Maybe<User_Hackathon_Bounties_Bounty_Type_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_bounties_bounty_type" */
  insert_user_hackathon_bounties_bounty_type_one?: Maybe<User_Hackathon_Bounties_Bounty_Type>;
  /** insert data into the table: "user_hackathon_bounties_currency" */
  insert_user_hackathon_bounties_currency?: Maybe<User_Hackathon_Bounties_Currency_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_bounties_currency" */
  insert_user_hackathon_bounties_currency_one?: Maybe<User_Hackathon_Bounties_Currency>;
  /** insert a single row into the table: "user_hackathon_bounties" */
  insert_user_hackathon_bounties_one?: Maybe<User_Hackathon_Bounties>;
  /** insert data into the table: "user_hackathon_bounties_status" */
  insert_user_hackathon_bounties_status?: Maybe<User_Hackathon_Bounties_Status_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_bounties_status" */
  insert_user_hackathon_bounties_status_one?: Maybe<User_Hackathon_Bounties_Status>;
  /** insert data into the table: "user_hackathon_bounties_type" */
  insert_user_hackathon_bounties_type?: Maybe<User_Hackathon_Bounties_Type_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_bounties_type" */
  insert_user_hackathon_bounties_type_one?: Maybe<User_Hackathon_Bounties_Type>;
  /** insert data into the table: "user_hackathon_checklists" */
  insert_user_hackathon_checklists?: Maybe<User_Hackathon_Checklists_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_checklists" */
  insert_user_hackathon_checklists_one?: Maybe<User_Hackathon_Checklists>;
  /** insert data into the table: "user_hackathon_credentials" */
  insert_user_hackathon_credentials?: Maybe<User_Hackathon_Credentials_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_credentials" */
  insert_user_hackathon_credentials_one?: Maybe<User_Hackathon_Credentials>;
  /** insert data into the table: "user_hackathon_credentials_status" */
  insert_user_hackathon_credentials_status?: Maybe<User_Hackathon_Credentials_Status_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_credentials_status" */
  insert_user_hackathon_credentials_status_one?: Maybe<User_Hackathon_Credentials_Status>;
  /** insert data into the table: "user_hackathon_extras" */
  insert_user_hackathon_extras?: Maybe<User_Hackathon_Extras_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_extras" */
  insert_user_hackathon_extras_one?: Maybe<User_Hackathon_Extras>;
  /** insert data into the table: "user_hackathon_feedbacks" */
  insert_user_hackathon_feedbacks?: Maybe<User_Hackathon_Feedbacks_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_feedbacks" */
  insert_user_hackathon_feedbacks_one?: Maybe<User_Hackathon_Feedbacks>;
  /** insert data into the table: "user_hackathon_reminders" */
  insert_user_hackathon_reminders?: Maybe<User_Hackathon_Reminders_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_reminders" */
  insert_user_hackathon_reminders_one?: Maybe<User_Hackathon_Reminders>;
  /** insert data into the table: "user_hackathon_schwags" */
  insert_user_hackathon_schwags?: Maybe<User_Hackathon_Schwags_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_schwags" */
  insert_user_hackathon_schwags_one?: Maybe<User_Hackathon_Schwags>;
  /** insert data into the table: "user_hackathon_staking_razorpay_payment_status" */
  insert_user_hackathon_staking_razorpay_payment_status?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_staking_razorpay_payment_status" */
  insert_user_hackathon_staking_razorpay_payment_status_one?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status>;
  /** insert data into the table: "user_hackathon_staking_status" */
  insert_user_hackathon_staking_status?: Maybe<User_Hackathon_Staking_Status_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_staking_status" */
  insert_user_hackathon_staking_status_one?: Maybe<User_Hackathon_Staking_Status>;
  /** insert data into the table: "user_hackathon_stakings" */
  insert_user_hackathon_stakings?: Maybe<User_Hackathon_Stakings_Mutation_Response>;
  /** insert a single row into the table: "user_hackathon_stakings" */
  insert_user_hackathon_stakings_one?: Maybe<User_Hackathon_Stakings>;
  /** insert data into the table: "user_hackathons" */
  insert_user_hackathons?: Maybe<User_Hackathons_Mutation_Response>;
  /** insert a single row into the table: "user_hackathons" */
  insert_user_hackathons_one?: Maybe<User_Hackathons>;
  /** insert data into the table: "user_idea_stats" */
  insert_user_idea_stats?: Maybe<User_Idea_Stats_Mutation_Response>;
  /** insert a single row into the table: "user_idea_stats" */
  insert_user_idea_stats_one?: Maybe<User_Idea_Stats>;
  /** insert data into the table: "user_kyc_status" */
  insert_user_kyc_status?: Maybe<User_Kyc_Status_Mutation_Response>;
  /** insert a single row into the table: "user_kyc_status" */
  insert_user_kyc_status_one?: Maybe<User_Kyc_Status>;
  /** insert data into the table: "user_permissions" */
  insert_user_permissions?: Maybe<User_Permissions_Mutation_Response>;
  /** insert a single row into the table: "user_permissions" */
  insert_user_permissions_one?: Maybe<User_Permissions>;
  /** insert data into the table: "user_profile_rss_feed_platforms" */
  insert_user_profile_rss_feed_platforms?: Maybe<User_Profile_Rss_Feed_Platforms_Mutation_Response>;
  /** insert a single row into the table: "user_profile_rss_feed_platforms" */
  insert_user_profile_rss_feed_platforms_one?: Maybe<User_Profile_Rss_Feed_Platforms>;
  /** insert data into the table: "user_profile_rss_feeds" */
  insert_user_profile_rss_feeds?: Maybe<User_Profile_Rss_Feeds_Mutation_Response>;
  /** insert a single row into the table: "user_profile_rss_feeds" */
  insert_user_profile_rss_feeds_one?: Maybe<User_Profile_Rss_Feeds>;
  /** insert data into the table: "user_profiles" */
  insert_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** insert a single row into the table: "user_profiles" */
  insert_user_profiles_one?: Maybe<User_Profiles>;
  /** insert data into the table: "user_project_meta" */
  insert_user_project_meta?: Maybe<User_Project_Meta_Mutation_Response>;
  /** insert a single row into the table: "user_project_meta" */
  insert_user_project_meta_one?: Maybe<User_Project_Meta>;
  /** insert data into the table: "user_projects" */
  insert_user_projects?: Maybe<User_Projects_Mutation_Response>;
  /** insert a single row into the table: "user_projects" */
  insert_user_projects_one?: Maybe<User_Projects>;
  /** insert data into the table: "user_public_profile_layout" */
  insert_user_public_profile_layout?: Maybe<User_Public_Profile_Layout_Mutation_Response>;
  /** insert a single row into the table: "user_public_profile_layout" */
  insert_user_public_profile_layout_one?: Maybe<User_Public_Profile_Layout>;
  /** insert data into the table: "user_public_profile_projects" */
  insert_user_public_profile_projects?: Maybe<User_Public_Profile_Projects_Mutation_Response>;
  /** insert a single row into the table: "user_public_profile_projects" */
  insert_user_public_profile_projects_one?: Maybe<User_Public_Profile_Projects>;
  /** insert data into the table: "user_roles" */
  insert_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** insert a single row into the table: "user_roles" */
  insert_user_roles_one?: Maybe<User_Roles>;
  /** insert data into the table: "user_saved_searches" */
  insert_user_saved_searches?: Maybe<User_Saved_Searches_Mutation_Response>;
  /** insert a single row into the table: "user_saved_searches" */
  insert_user_saved_searches_one?: Maybe<User_Saved_Searches>;
  /** insert data into the table: "user_skills" */
  insert_user_skills?: Maybe<User_Skills_Mutation_Response>;
  /** insert a single row into the table: "user_skills" */
  insert_user_skills_one?: Maybe<User_Skills>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "winners" */
  insert_winners?: Maybe<Winners_Mutation_Response>;
  /** insert a single row into the table: "winners" */
  insert_winners_one?: Maybe<Winners>;
  /** execute VOLATILE function "like_project" which returns "user_project_meta" */
  like_project: Array<User_Project_Meta>;
  /** The mutation that can be used to nominate a builder */
  nominateBuilder: NominateBuilderOutput;
  /** The mutation that can be used to vote for projects in a hackathon */
  quadraticVoting: QuadraticVotingOutput;
  /** execute VOLATILE function "refresh_hackathon_participants_details" which returns "hackathons" */
  refresh_hackathon_participants_details: Array<Hackathons>;
  /** execute VOLATILE function "refresh_hackathon_participants_details_single" which returns "hackathons" */
  refresh_hackathon_participants_details_single: Array<Hackathons>;
  /** execute VOLATILE function "remove_hackathon_edition" which returns "hackathons" */
  remove_hackathon_edition: Array<Hackathons>;
  /** execute VOLATILE function "remove_hackathon_reminder" which returns "user_hackathon_reminders" */
  remove_hackathon_reminder: Array<User_Hackathon_Reminders>;
  /** The mutation that can be used to report a comment */
  reportComment: ReportCommentOutput;
  /** The mutation that can be used to report a project */
  reportProject: ReportProjectOutput;
  /** The mutation that can be used to stake for rsvp */
  rsvpStaking: RsvpStakingOutput;
  shop_placeOrder?: Maybe<Shop_PlaceOrderOutput>;
  /** The mutation used to connect the Ethereum wallet to the users Devfolio Account */
  siwe_connectEthereumWallet: SiweConnectEthereumWalletOutput;
  /** The mutation used to disconnect the Ethereum wallet from the Devfolio Account */
  siwe_disconnectEthereumWallet: SiweDisconnectEthereumWalletOutput;
  /** This mutation is used to generate a nonce for the user to perform siwe operations */
  siwe_generateNonce: SiweGenerateNonceOutput;
  submitSchwagFulfilmentForm?: Maybe<SchwagFulfilmentFormOutput>;
  submitSchwagShippingAddress?: Maybe<SubmitSchwagShippingAddressOutput>;
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>;
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "articles" */
  update_articles?: Maybe<Articles_Mutation_Response>;
  /** update single row of the table: "articles" */
  update_articles_by_pk?: Maybe<Articles>;
  /** update multiples rows of table: "articles" */
  update_articles_many?: Maybe<Array<Maybe<Articles_Mutation_Response>>>;
  /** update data of the table: "colleges" */
  update_colleges?: Maybe<Colleges_Mutation_Response>;
  /** update single row of the table: "colleges" */
  update_colleges_by_pk?: Maybe<Colleges>;
  /** update multiples rows of table: "colleges" */
  update_colleges_many?: Maybe<Array<Maybe<Colleges_Mutation_Response>>>;
  /** update data of the table: "comments" */
  update_comments?: Maybe<Comments_Mutation_Response>;
  /** update single row of the table: "comments" */
  update_comments_by_pk?: Maybe<Comments>;
  /** update multiples rows of table: "comments" */
  update_comments_many?: Maybe<Array<Maybe<Comments_Mutation_Response>>>;
  /** update data of the table: "company" */
  update_company?: Maybe<Company_Mutation_Response>;
  /** update single row of the table: "company" */
  update_company_by_pk?: Maybe<Company>;
  /** update multiples rows of table: "company" */
  update_company_many?: Maybe<Array<Maybe<Company_Mutation_Response>>>;
  /** update data of the table: "discover" */
  update_discover?: Maybe<Discover_Mutation_Response>;
  /** update single row of the table: "discover" */
  update_discover_by_pk?: Maybe<Discover>;
  /** update data of the table: "discover_events" */
  update_discover_events?: Maybe<Discover_Events_Mutation_Response>;
  /** update single row of the table: "discover_events" */
  update_discover_events_by_pk?: Maybe<Discover_Events>;
  /** update multiples rows of table: "discover_events" */
  update_discover_events_many?: Maybe<Array<Maybe<Discover_Events_Mutation_Response>>>;
  /** update multiples rows of table: "discover" */
  update_discover_many?: Maybe<Array<Maybe<Discover_Mutation_Response>>>;
  /** update data of the table: "education_fields" */
  update_education_fields?: Maybe<Education_Fields_Mutation_Response>;
  /** update single row of the table: "education_fields" */
  update_education_fields_by_pk?: Maybe<Education_Fields>;
  /** update multiples rows of table: "education_fields" */
  update_education_fields_many?: Maybe<Array<Maybe<Education_Fields_Mutation_Response>>>;
  /** update data of the table: "educations" */
  update_educations?: Maybe<Educations_Mutation_Response>;
  /** update single row of the table: "educations" */
  update_educations_by_pk?: Maybe<Educations>;
  /** update multiples rows of table: "educations" */
  update_educations_many?: Maybe<Array<Maybe<Educations_Mutation_Response>>>;
  /** update data of the table: "experience_type" */
  update_experience_type?: Maybe<Experience_Type_Mutation_Response>;
  /** update single row of the table: "experience_type" */
  update_experience_type_by_pk?: Maybe<Experience_Type>;
  /** update multiples rows of table: "experience_type" */
  update_experience_type_many?: Maybe<Array<Maybe<Experience_Type_Mutation_Response>>>;
  /** update data of the table: "experiences" */
  update_experiences?: Maybe<Experiences_Mutation_Response>;
  /** update single row of the table: "experiences" */
  update_experiences_by_pk?: Maybe<Experiences>;
  /** update multiples rows of table: "experiences" */
  update_experiences_many?: Maybe<Array<Maybe<Experiences_Mutation_Response>>>;
  /** update data of the table: "feature_flag_types" */
  update_feature_flag_types?: Maybe<Feature_Flag_Types_Mutation_Response>;
  /** update single row of the table: "feature_flag_types" */
  update_feature_flag_types_by_pk?: Maybe<Feature_Flag_Types>;
  /** update multiples rows of table: "feature_flag_types" */
  update_feature_flag_types_many?: Maybe<Array<Maybe<Feature_Flag_Types_Mutation_Response>>>;
  /** update data of the table: "feature_flags" */
  update_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** update single row of the table: "feature_flags" */
  update_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** update multiples rows of table: "feature_flags" */
  update_feature_flags_many?: Maybe<Array<Maybe<Feature_Flags_Mutation_Response>>>;
  /** update data of the table: "hackathon_bounties_status" */
  update_hackathon_bounties_status?: Maybe<Hackathon_Bounties_Status_Mutation_Response>;
  /** update single row of the table: "hackathon_bounties_status" */
  update_hackathon_bounties_status_by_pk?: Maybe<Hackathon_Bounties_Status>;
  /** update multiples rows of table: "hackathon_bounties_status" */
  update_hackathon_bounties_status_many?: Maybe<Array<Maybe<Hackathon_Bounties_Status_Mutation_Response>>>;
  /** update data of the table: "hackathon_brands" */
  update_hackathon_brands?: Maybe<Hackathon_Brands_Mutation_Response>;
  /** update single row of the table: "hackathon_brands" */
  update_hackathon_brands_by_pk?: Maybe<Hackathon_Brands>;
  /** update multiples rows of table: "hackathon_brands" */
  update_hackathon_brands_many?: Maybe<Array<Maybe<Hackathon_Brands_Mutation_Response>>>;
  /** update data of the table: "hackathon_checklists" */
  update_hackathon_checklists?: Maybe<Hackathon_Checklists_Mutation_Response>;
  /** update single row of the table: "hackathon_checklists" */
  update_hackathon_checklists_by_pk?: Maybe<Hackathon_Checklists>;
  /** update multiples rows of table: "hackathon_checklists" */
  update_hackathon_checklists_many?: Maybe<Array<Maybe<Hackathon_Checklists_Mutation_Response>>>;
  /** update data of the table: "hackathon_credential_eligible_entities" */
  update_hackathon_credential_eligible_entities?: Maybe<Hackathon_Credential_Eligible_Entities_Mutation_Response>;
  /** update single row of the table: "hackathon_credential_eligible_entities" */
  update_hackathon_credential_eligible_entities_by_pk?: Maybe<Hackathon_Credential_Eligible_Entities>;
  /** update multiples rows of table: "hackathon_credential_eligible_entities" */
  update_hackathon_credential_eligible_entities_many?: Maybe<Array<Maybe<Hackathon_Credential_Eligible_Entities_Mutation_Response>>>;
  /** update data of the table: "hackathon_credential_type" */
  update_hackathon_credential_type?: Maybe<Hackathon_Credential_Type_Mutation_Response>;
  /** update single row of the table: "hackathon_credential_type" */
  update_hackathon_credential_type_by_pk?: Maybe<Hackathon_Credential_Type>;
  /** update multiples rows of table: "hackathon_credential_type" */
  update_hackathon_credential_type_many?: Maybe<Array<Maybe<Hackathon_Credential_Type_Mutation_Response>>>;
  /** update data of the table: "hackathon_credentials" */
  update_hackathon_credentials?: Maybe<Hackathon_Credentials_Mutation_Response>;
  /** update single row of the table: "hackathon_credentials" */
  update_hackathon_credentials_by_pk?: Maybe<Hackathon_Credentials>;
  /** update data of the table: "hackathon_credentials_chain" */
  update_hackathon_credentials_chain?: Maybe<Hackathon_Credentials_Chain_Mutation_Response>;
  /** update single row of the table: "hackathon_credentials_chain" */
  update_hackathon_credentials_chain_by_pk?: Maybe<Hackathon_Credentials_Chain>;
  /** update multiples rows of table: "hackathon_credentials_chain" */
  update_hackathon_credentials_chain_many?: Maybe<Array<Maybe<Hackathon_Credentials_Chain_Mutation_Response>>>;
  /** update multiples rows of table: "hackathon_credentials" */
  update_hackathon_credentials_many?: Maybe<Array<Maybe<Hackathon_Credentials_Mutation_Response>>>;
  /** update data of the table: "hackathon_email_templates" */
  update_hackathon_email_templates?: Maybe<Hackathon_Email_Templates_Mutation_Response>;
  /** update single row of the table: "hackathon_email_templates" */
  update_hackathon_email_templates_by_pk?: Maybe<Hackathon_Email_Templates>;
  /** update multiples rows of table: "hackathon_email_templates" */
  update_hackathon_email_templates_many?: Maybe<Array<Maybe<Hackathon_Email_Templates_Mutation_Response>>>;
  /** update data of the table: "hackathon_event_groups" */
  update_hackathon_event_groups?: Maybe<Hackathon_Event_Groups_Mutation_Response>;
  /** update single row of the table: "hackathon_event_groups" */
  update_hackathon_event_groups_by_pk?: Maybe<Hackathon_Event_Groups>;
  /** update multiples rows of table: "hackathon_event_groups" */
  update_hackathon_event_groups_many?: Maybe<Array<Maybe<Hackathon_Event_Groups_Mutation_Response>>>;
  /** update data of the table: "hackathon_event_speakers" */
  update_hackathon_event_speakers?: Maybe<Hackathon_Event_Speakers_Mutation_Response>;
  /** update single row of the table: "hackathon_event_speakers" */
  update_hackathon_event_speakers_by_pk?: Maybe<Hackathon_Event_Speakers>;
  /** update multiples rows of table: "hackathon_event_speakers" */
  update_hackathon_event_speakers_many?: Maybe<Array<Maybe<Hackathon_Event_Speakers_Mutation_Response>>>;
  /** update data of the table: "hackathon_event_sponsors" */
  update_hackathon_event_sponsors?: Maybe<Hackathon_Event_Sponsors_Mutation_Response>;
  /** update single row of the table: "hackathon_event_sponsors" */
  update_hackathon_event_sponsors_by_pk?: Maybe<Hackathon_Event_Sponsors>;
  /** update multiples rows of table: "hackathon_event_sponsors" */
  update_hackathon_event_sponsors_many?: Maybe<Array<Maybe<Hackathon_Event_Sponsors_Mutation_Response>>>;
  /** update data of the table: "hackathon_event_type" */
  update_hackathon_event_type?: Maybe<Hackathon_Event_Type_Mutation_Response>;
  /** update single row of the table: "hackathon_event_type" */
  update_hackathon_event_type_by_pk?: Maybe<Hackathon_Event_Type>;
  /** update multiples rows of table: "hackathon_event_type" */
  update_hackathon_event_type_many?: Maybe<Array<Maybe<Hackathon_Event_Type_Mutation_Response>>>;
  /** update data of the table: "hackathon_events" */
  update_hackathon_events?: Maybe<Hackathon_Events_Mutation_Response>;
  /** update single row of the table: "hackathon_events" */
  update_hackathon_events_by_pk?: Maybe<Hackathon_Events>;
  /** update multiples rows of table: "hackathon_events" */
  update_hackathon_events_many?: Maybe<Array<Maybe<Hackathon_Events_Mutation_Response>>>;
  /** update data of the table: "hackathon_faq" */
  update_hackathon_faq?: Maybe<Hackathon_Faq_Mutation_Response>;
  /** update single row of the table: "hackathon_faq" */
  update_hackathon_faq_by_pk?: Maybe<Hackathon_Faq>;
  /** update multiples rows of table: "hackathon_faq" */
  update_hackathon_faq_many?: Maybe<Array<Maybe<Hackathon_Faq_Mutation_Response>>>;
  /** update data of the table: "hackathon_faq_type" */
  update_hackathon_faq_type?: Maybe<Hackathon_Faq_Type_Mutation_Response>;
  /** update single row of the table: "hackathon_faq_type" */
  update_hackathon_faq_type_by_pk?: Maybe<Hackathon_Faq_Type>;
  /** update multiples rows of table: "hackathon_faq_type" */
  update_hackathon_faq_type_many?: Maybe<Array<Maybe<Hackathon_Faq_Type_Mutation_Response>>>;
  /** update data of the table: "hackathon_hashtags" */
  update_hackathon_hashtags?: Maybe<Hackathon_Hashtags_Mutation_Response>;
  /** update single row of the table: "hackathon_hashtags" */
  update_hackathon_hashtags_by_pk?: Maybe<Hackathon_Hashtags>;
  /** update multiples rows of table: "hackathon_hashtags" */
  update_hackathon_hashtags_many?: Maybe<Array<Maybe<Hackathon_Hashtags_Mutation_Response>>>;
  /** update data of the table: "hackathon_hosts" */
  update_hackathon_hosts?: Maybe<Hackathon_Hosts_Mutation_Response>;
  /** update single row of the table: "hackathon_hosts" */
  update_hackathon_hosts_by_pk?: Maybe<Hackathon_Hosts>;
  /** update multiples rows of table: "hackathon_hosts" */
  update_hackathon_hosts_many?: Maybe<Array<Maybe<Hackathon_Hosts_Mutation_Response>>>;
  /** update data of the table: "hackathon_note_type" */
  update_hackathon_note_type?: Maybe<Hackathon_Note_Type_Mutation_Response>;
  /** update single row of the table: "hackathon_note_type" */
  update_hackathon_note_type_by_pk?: Maybe<Hackathon_Note_Type>;
  /** update multiples rows of table: "hackathon_note_type" */
  update_hackathon_note_type_many?: Maybe<Array<Maybe<Hackathon_Note_Type_Mutation_Response>>>;
  /** update data of the table: "hackathon_notes" */
  update_hackathon_notes?: Maybe<Hackathon_Notes_Mutation_Response>;
  /** update single row of the table: "hackathon_notes" */
  update_hackathon_notes_by_pk?: Maybe<Hackathon_Notes>;
  /** update multiples rows of table: "hackathon_notes" */
  update_hackathon_notes_many?: Maybe<Array<Maybe<Hackathon_Notes_Mutation_Response>>>;
  /** update data of the table: "hackathon_schwags" */
  update_hackathon_schwags?: Maybe<Hackathon_Schwags_Mutation_Response>;
  /** update single row of the table: "hackathon_schwags" */
  update_hackathon_schwags_by_pk?: Maybe<Hackathon_Schwags>;
  /** update multiples rows of table: "hackathon_schwags" */
  update_hackathon_schwags_many?: Maybe<Array<Maybe<Hackathon_Schwags_Mutation_Response>>>;
  /** update data of the table: "hackathon_scope_extras" */
  update_hackathon_scope_extras?: Maybe<Hackathon_Scope_Extras_Mutation_Response>;
  /** update single row of the table: "hackathon_scope_extras" */
  update_hackathon_scope_extras_by_pk?: Maybe<Hackathon_Scope_Extras>;
  /** update multiples rows of table: "hackathon_scope_extras" */
  update_hackathon_scope_extras_many?: Maybe<Array<Maybe<Hackathon_Scope_Extras_Mutation_Response>>>;
  /** update data of the table: "hackathon_scopes" */
  update_hackathon_scopes?: Maybe<Hackathon_Scopes_Mutation_Response>;
  /** update single row of the table: "hackathon_scopes" */
  update_hackathon_scopes_by_pk?: Maybe<Hackathon_Scopes>;
  /** update multiples rows of table: "hackathon_scopes" */
  update_hackathon_scopes_many?: Maybe<Array<Maybe<Hackathon_Scopes_Mutation_Response>>>;
  /** update data of the table: "hackathon_settings" */
  update_hackathon_settings?: Maybe<Hackathon_Settings_Mutation_Response>;
  /** update single row of the table: "hackathon_settings" */
  update_hackathon_settings_by_pk?: Maybe<Hackathon_Settings>;
  /** update multiples rows of table: "hackathon_settings" */
  update_hackathon_settings_many?: Maybe<Array<Maybe<Hackathon_Settings_Mutation_Response>>>;
  /** update data of the table: "hackathon_staking_currency" */
  update_hackathon_staking_currency?: Maybe<Hackathon_Staking_Currency_Mutation_Response>;
  /** update single row of the table: "hackathon_staking_currency" */
  update_hackathon_staking_currency_by_pk?: Maybe<Hackathon_Staking_Currency>;
  /** update multiples rows of table: "hackathon_staking_currency" */
  update_hackathon_staking_currency_many?: Maybe<Array<Maybe<Hackathon_Staking_Currency_Mutation_Response>>>;
  /** update data of the table: "hackathon_staking_type" */
  update_hackathon_staking_type?: Maybe<Hackathon_Staking_Type_Mutation_Response>;
  /** update single row of the table: "hackathon_staking_type" */
  update_hackathon_staking_type_by_pk?: Maybe<Hackathon_Staking_Type>;
  /** update multiples rows of table: "hackathon_staking_type" */
  update_hackathon_staking_type_many?: Maybe<Array<Maybe<Hackathon_Staking_Type_Mutation_Response>>>;
  /** update data of the table: "hackathon_stakings" */
  update_hackathon_stakings?: Maybe<Hackathon_Stakings_Mutation_Response>;
  /** update single row of the table: "hackathon_stakings" */
  update_hackathon_stakings_by_pk?: Maybe<Hackathon_Stakings>;
  /** update multiples rows of table: "hackathon_stakings" */
  update_hackathon_stakings_many?: Maybe<Array<Maybe<Hackathon_Stakings_Mutation_Response>>>;
  /** update data of the table: "hackathon_themes" */
  update_hackathon_themes?: Maybe<Hackathon_Themes_Mutation_Response>;
  /** update single row of the table: "hackathon_themes" */
  update_hackathon_themes_by_pk?: Maybe<Hackathon_Themes>;
  /** update multiples rows of table: "hackathon_themes" */
  update_hackathon_themes_many?: Maybe<Array<Maybe<Hackathon_Themes_Mutation_Response>>>;
  /** update data of the table: "hackathon_tracks" */
  update_hackathon_tracks?: Maybe<Hackathon_Tracks_Mutation_Response>;
  /** update single row of the table: "hackathon_tracks" */
  update_hackathon_tracks_by_pk?: Maybe<Hackathon_Tracks>;
  /** update multiples rows of table: "hackathon_tracks" */
  update_hackathon_tracks_many?: Maybe<Array<Maybe<Hackathon_Tracks_Mutation_Response>>>;
  /** update data of the table: "hackathon_type" */
  update_hackathon_type?: Maybe<Hackathon_Type_Mutation_Response>;
  /** update single row of the table: "hackathon_type" */
  update_hackathon_type_by_pk?: Maybe<Hackathon_Type>;
  /** update multiples rows of table: "hackathon_type" */
  update_hackathon_type_many?: Maybe<Array<Maybe<Hackathon_Type_Mutation_Response>>>;
  /** update data of the table: "hackathons" */
  update_hackathons?: Maybe<Hackathons_Mutation_Response>;
  /** update single row of the table: "hackathons" */
  update_hackathons_by_pk?: Maybe<Hackathons>;
  /** update multiples rows of table: "hackathons" */
  update_hackathons_many?: Maybe<Array<Maybe<Hackathons_Mutation_Response>>>;
  /** update data of the table: "hashtags" */
  update_hashtags?: Maybe<Hashtags_Mutation_Response>;
  /** update single row of the table: "hashtags" */
  update_hashtags_by_pk?: Maybe<Hashtags>;
  /** update multiples rows of table: "hashtags" */
  update_hashtags_many?: Maybe<Array<Maybe<Hashtags_Mutation_Response>>>;
  /** update data of the table: "idea_stats" */
  update_idea_stats?: Maybe<Idea_Stats_Mutation_Response>;
  /** update single row of the table: "idea_stats" */
  update_idea_stats_by_pk?: Maybe<Idea_Stats>;
  /** update multiples rows of table: "idea_stats" */
  update_idea_stats_many?: Maybe<Array<Maybe<Idea_Stats_Mutation_Response>>>;
  /** update data of the table: "ideas" */
  update_ideas?: Maybe<Ideas_Mutation_Response>;
  /** update single row of the table: "ideas" */
  update_ideas_by_pk?: Maybe<Ideas>;
  /** update multiples rows of table: "ideas" */
  update_ideas_many?: Maybe<Array<Maybe<Ideas_Mutation_Response>>>;
  /** update data of the table: "judges" */
  update_judges?: Maybe<Judges_Mutation_Response>;
  /** update single row of the table: "judges" */
  update_judges_by_pk?: Maybe<Judges>;
  /** update multiples rows of table: "judges" */
  update_judges_many?: Maybe<Array<Maybe<Judges_Mutation_Response>>>;
  /** update data of the table: "judging_rooms" */
  update_judging_rooms?: Maybe<Judging_Rooms_Mutation_Response>;
  /** update single row of the table: "judging_rooms" */
  update_judging_rooms_by_pk?: Maybe<Judging_Rooms>;
  /** update multiples rows of table: "judging_rooms" */
  update_judging_rooms_many?: Maybe<Array<Maybe<Judging_Rooms_Mutation_Response>>>;
  /** update data of the table: "notification_types" */
  update_notification_types?: Maybe<Notification_Types_Mutation_Response>;
  /** update single row of the table: "notification_types" */
  update_notification_types_by_pk?: Maybe<Notification_Types>;
  /** update multiples rows of table: "notification_types" */
  update_notification_types_many?: Maybe<Array<Maybe<Notification_Types_Mutation_Response>>>;
  /** update data of the table: "notifications" */
  update_notifications?: Maybe<Notifications_Mutation_Response>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: Maybe<Notifications>;
  /** update multiples rows of table: "notifications" */
  update_notifications_many?: Maybe<Array<Maybe<Notifications_Mutation_Response>>>;
  /** update data of the table: "oauth" */
  update_oauth?: Maybe<Oauth_Mutation_Response>;
  /** update single row of the table: "oauth" */
  update_oauth_by_pk?: Maybe<Oauth>;
  /** update multiples rows of table: "oauth" */
  update_oauth_many?: Maybe<Array<Maybe<Oauth_Mutation_Response>>>;
  /** update data of the table: "oauth_providers" */
  update_oauth_providers?: Maybe<Oauth_Providers_Mutation_Response>;
  /** update single row of the table: "oauth_providers" */
  update_oauth_providers_by_pk?: Maybe<Oauth_Providers>;
  /** update multiples rows of table: "oauth_providers" */
  update_oauth_providers_many?: Maybe<Array<Maybe<Oauth_Providers_Mutation_Response>>>;
  /** update data of the table: "permissions" */
  update_permissions?: Maybe<Permissions_Mutation_Response>;
  /** update single row of the table: "permissions" */
  update_permissions_by_pk?: Maybe<Permissions>;
  /** update multiples rows of table: "permissions" */
  update_permissions_many?: Maybe<Array<Maybe<Permissions_Mutation_Response>>>;
  /** update data of the table: "prize_sponsors" */
  update_prize_sponsors?: Maybe<Prize_Sponsors_Mutation_Response>;
  /** update single row of the table: "prize_sponsors" */
  update_prize_sponsors_by_pk?: Maybe<Prize_Sponsors>;
  /** update multiples rows of table: "prize_sponsors" */
  update_prize_sponsors_many?: Maybe<Array<Maybe<Prize_Sponsors_Mutation_Response>>>;
  /** update data of the table: "prize_tracks" */
  update_prize_tracks?: Maybe<Prize_Tracks_Mutation_Response>;
  /** update single row of the table: "prize_tracks" */
  update_prize_tracks_by_pk?: Maybe<Prize_Tracks>;
  /** update multiples rows of table: "prize_tracks" */
  update_prize_tracks_many?: Maybe<Array<Maybe<Prize_Tracks_Mutation_Response>>>;
  /** update data of the table: "prizes" */
  update_prizes?: Maybe<Prizes_Mutation_Response>;
  /** update single row of the table: "prizes" */
  update_prizes_by_pk?: Maybe<Prizes>;
  /** update multiples rows of table: "prizes" */
  update_prizes_many?: Maybe<Array<Maybe<Prizes_Mutation_Response>>>;
  /** update data of the table: "profiles" */
  update_profiles?: Maybe<Profiles_Mutation_Response>;
  /** update single row of the table: "profiles" */
  update_profiles_by_pk?: Maybe<Profiles>;
  /** update multiples rows of table: "profiles" */
  update_profiles_many?: Maybe<Array<Maybe<Profiles_Mutation_Response>>>;
  /** update data of the table: "project_commits" */
  update_project_commits?: Maybe<Project_Commits_Mutation_Response>;
  /** update single row of the table: "project_commits" */
  update_project_commits_by_pk?: Maybe<Project_Commits>;
  /** update multiples rows of table: "project_commits" */
  update_project_commits_many?: Maybe<Array<Maybe<Project_Commits_Mutation_Response>>>;
  /** update data of the table: "project_contribution_stickers" */
  update_project_contribution_stickers?: Maybe<Project_Contribution_Stickers_Mutation_Response>;
  /** update single row of the table: "project_contribution_stickers" */
  update_project_contribution_stickers_by_pk?: Maybe<Project_Contribution_Stickers>;
  /** update multiples rows of table: "project_contribution_stickers" */
  update_project_contribution_stickers_many?: Maybe<Array<Maybe<Project_Contribution_Stickers_Mutation_Response>>>;
  /** update data of the table: "project_contribution_tx_network_type" */
  update_project_contribution_tx_network_type?: Maybe<Project_Contribution_Tx_Network_Type_Mutation_Response>;
  /** update single row of the table: "project_contribution_tx_network_type" */
  update_project_contribution_tx_network_type_by_pk?: Maybe<Project_Contribution_Tx_Network_Type>;
  /** update multiples rows of table: "project_contribution_tx_network_type" */
  update_project_contribution_tx_network_type_many?: Maybe<Array<Maybe<Project_Contribution_Tx_Network_Type_Mutation_Response>>>;
  /** update data of the table: "project_contributions" */
  update_project_contributions?: Maybe<Project_Contributions_Mutation_Response>;
  /** update single row of the table: "project_contributions" */
  update_project_contributions_by_pk?: Maybe<Project_Contributions>;
  /** update multiples rows of table: "project_contributions" */
  update_project_contributions_many?: Maybe<Array<Maybe<Project_Contributions_Mutation_Response>>>;
  /** update data of the table: "project_contributions_type" */
  update_project_contributions_type?: Maybe<Project_Contributions_Type_Mutation_Response>;
  /** update single row of the table: "project_contributions_type" */
  update_project_contributions_type_by_pk?: Maybe<Project_Contributions_Type>;
  /** update multiples rows of table: "project_contributions_type" */
  update_project_contributions_type_many?: Maybe<Array<Maybe<Project_Contributions_Type_Mutation_Response>>>;
  /** update data of the table: "project_hashtags" */
  update_project_hashtags?: Maybe<Project_Hashtags_Mutation_Response>;
  /** update single row of the table: "project_hashtags" */
  update_project_hashtags_by_pk?: Maybe<Project_Hashtags>;
  /** update multiples rows of table: "project_hashtags" */
  update_project_hashtags_many?: Maybe<Array<Maybe<Project_Hashtags_Mutation_Response>>>;
  /** update data of the table: "project_judges" */
  update_project_judges?: Maybe<Project_Judges_Mutation_Response>;
  /** update single row of the table: "project_judges" */
  update_project_judges_by_pk?: Maybe<Project_Judges>;
  /** update multiples rows of table: "project_judges" */
  update_project_judges_many?: Maybe<Array<Maybe<Project_Judges_Mutation_Response>>>;
  /** update data of the table: "project_judging_submission_type" */
  update_project_judging_submission_type?: Maybe<Project_Judging_Submission_Type_Mutation_Response>;
  /** update single row of the table: "project_judging_submission_type" */
  update_project_judging_submission_type_by_pk?: Maybe<Project_Judging_Submission_Type>;
  /** update multiples rows of table: "project_judging_submission_type" */
  update_project_judging_submission_type_many?: Maybe<Array<Maybe<Project_Judging_Submission_Type_Mutation_Response>>>;
  /** update data of the table: "project_judgments" */
  update_project_judgments?: Maybe<Project_Judgments_Mutation_Response>;
  /** update single row of the table: "project_judgments" */
  update_project_judgments_by_pk?: Maybe<Project_Judgments>;
  /** update multiples rows of table: "project_judgments" */
  update_project_judgments_many?: Maybe<Array<Maybe<Project_Judgments_Mutation_Response>>>;
  /** update data of the table: "project_report_type" */
  update_project_report_type?: Maybe<Project_Report_Type_Mutation_Response>;
  /** update single row of the table: "project_report_type" */
  update_project_report_type_by_pk?: Maybe<Project_Report_Type>;
  /** update multiples rows of table: "project_report_type" */
  update_project_report_type_many?: Maybe<Array<Maybe<Project_Report_Type_Mutation_Response>>>;
  /** update data of the table: "project_reports" */
  update_project_reports?: Maybe<Project_Reports_Mutation_Response>;
  /** update single row of the table: "project_reports" */
  update_project_reports_by_pk?: Maybe<Project_Reports>;
  /** update multiples rows of table: "project_reports" */
  update_project_reports_many?: Maybe<Array<Maybe<Project_Reports_Mutation_Response>>>;
  /** update data of the table: "project_tracks" */
  update_project_tracks?: Maybe<Project_Tracks_Mutation_Response>;
  /** update single row of the table: "project_tracks" */
  update_project_tracks_by_pk?: Maybe<Project_Tracks>;
  /** update multiples rows of table: "project_tracks" */
  update_project_tracks_many?: Maybe<Array<Maybe<Project_Tracks_Mutation_Response>>>;
  /** update data of the table: "projects" */
  update_projects?: Maybe<Projects_Mutation_Response>;
  /** update single row of the table: "projects" */
  update_projects_by_pk?: Maybe<Projects>;
  /** update data of the table: "projects_funding" */
  update_projects_funding?: Maybe<Projects_Funding_Mutation_Response>;
  /** update single row of the table: "projects_funding" */
  update_projects_funding_by_pk?: Maybe<Projects_Funding>;
  /** update multiples rows of table: "projects_funding" */
  update_projects_funding_many?: Maybe<Array<Maybe<Projects_Funding_Mutation_Response>>>;
  /** update multiples rows of table: "projects" */
  update_projects_many?: Maybe<Array<Maybe<Projects_Mutation_Response>>>;
  /** update data of the table: "quadratic_voting" */
  update_quadratic_voting?: Maybe<Quadratic_Voting_Mutation_Response>;
  /** update single row of the table: "quadratic_voting" */
  update_quadratic_voting_by_pk?: Maybe<Quadratic_Voting>;
  /** update data of the table: "quadratic_voting_chain" */
  update_quadratic_voting_chain?: Maybe<Quadratic_Voting_Chain_Mutation_Response>;
  /** update single row of the table: "quadratic_voting_chain" */
  update_quadratic_voting_chain_by_pk?: Maybe<Quadratic_Voting_Chain>;
  /** update multiples rows of table: "quadratic_voting_chain" */
  update_quadratic_voting_chain_many?: Maybe<Array<Maybe<Quadratic_Voting_Chain_Mutation_Response>>>;
  /** update data of the table: "quadratic_voting_currency" */
  update_quadratic_voting_currency?: Maybe<Quadratic_Voting_Currency_Mutation_Response>;
  /** update single row of the table: "quadratic_voting_currency" */
  update_quadratic_voting_currency_by_pk?: Maybe<Quadratic_Voting_Currency>;
  /** update multiples rows of table: "quadratic_voting_currency" */
  update_quadratic_voting_currency_many?: Maybe<Array<Maybe<Quadratic_Voting_Currency_Mutation_Response>>>;
  /** update multiples rows of table: "quadratic_voting" */
  update_quadratic_voting_many?: Maybe<Array<Maybe<Quadratic_Voting_Mutation_Response>>>;
  /** update data of the table: "quadratic_voting_projects" */
  update_quadratic_voting_projects?: Maybe<Quadratic_Voting_Projects_Mutation_Response>;
  /** update single row of the table: "quadratic_voting_projects" */
  update_quadratic_voting_projects_by_pk?: Maybe<Quadratic_Voting_Projects>;
  /** update multiples rows of table: "quadratic_voting_projects" */
  update_quadratic_voting_projects_many?: Maybe<Array<Maybe<Quadratic_Voting_Projects_Mutation_Response>>>;
  /** update data of the table: "quadratic_voting_request_access" */
  update_quadratic_voting_request_access?: Maybe<Quadratic_Voting_Request_Access_Mutation_Response>;
  /** update single row of the table: "quadratic_voting_request_access" */
  update_quadratic_voting_request_access_by_pk?: Maybe<Quadratic_Voting_Request_Access>;
  /** update multiples rows of table: "quadratic_voting_request_access" */
  update_quadratic_voting_request_access_many?: Maybe<Array<Maybe<Quadratic_Voting_Request_Access_Mutation_Response>>>;
  /** update data of the table: "quadratic_voting_request_access_status" */
  update_quadratic_voting_request_access_status?: Maybe<Quadratic_Voting_Request_Access_Status_Mutation_Response>;
  /** update single row of the table: "quadratic_voting_request_access_status" */
  update_quadratic_voting_request_access_status_by_pk?: Maybe<Quadratic_Voting_Request_Access_Status>;
  /** update multiples rows of table: "quadratic_voting_request_access_status" */
  update_quadratic_voting_request_access_status_many?: Maybe<Array<Maybe<Quadratic_Voting_Request_Access_Status_Mutation_Response>>>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  update_roles_many?: Maybe<Array<Maybe<Roles_Mutation_Response>>>;
  /** update data of the table: "room_judges" */
  update_room_judges?: Maybe<Room_Judges_Mutation_Response>;
  /** update single row of the table: "room_judges" */
  update_room_judges_by_pk?: Maybe<Room_Judges>;
  /** update multiples rows of table: "room_judges" */
  update_room_judges_many?: Maybe<Array<Maybe<Room_Judges_Mutation_Response>>>;
  /** update data of the table: "schwag_tracks" */
  update_schwag_tracks?: Maybe<Schwag_Tracks_Mutation_Response>;
  /** update single row of the table: "schwag_tracks" */
  update_schwag_tracks_by_pk?: Maybe<Schwag_Tracks>;
  /** update multiples rows of table: "schwag_tracks" */
  update_schwag_tracks_many?: Maybe<Array<Maybe<Schwag_Tracks_Mutation_Response>>>;
  /** update data of the table: "schwags.allowed_org_winner_count" */
  update_schwags_allowed_org_winner_count?: Maybe<Schwags_Allowed_Org_Winner_Count_Mutation_Response>;
  /** update multiples rows of table: "schwags.allowed_org_winner_count" */
  update_schwags_allowed_org_winner_count_many?: Maybe<Array<Maybe<Schwags_Allowed_Org_Winner_Count_Mutation_Response>>>;
  /** update data of the table: "shop.countries" */
  update_shop_countries?: Maybe<Shop_Countries_Mutation_Response>;
  /** update single row of the table: "shop.countries" */
  update_shop_countries_by_pk?: Maybe<Shop_Countries>;
  /** update multiples rows of table: "shop.countries" */
  update_shop_countries_many?: Maybe<Array<Maybe<Shop_Countries_Mutation_Response>>>;
  /** update data of the table: "shop.coupon_discount_type" */
  update_shop_coupon_discount_type?: Maybe<Shop_Coupon_Discount_Type_Mutation_Response>;
  /** update single row of the table: "shop.coupon_discount_type" */
  update_shop_coupon_discount_type_by_pk?: Maybe<Shop_Coupon_Discount_Type>;
  /** update multiples rows of table: "shop.coupon_discount_type" */
  update_shop_coupon_discount_type_many?: Maybe<Array<Maybe<Shop_Coupon_Discount_Type_Mutation_Response>>>;
  /** update data of the table: "shop.coupon_type" */
  update_shop_coupon_type?: Maybe<Shop_Coupon_Type_Mutation_Response>;
  /** update single row of the table: "shop.coupon_type" */
  update_shop_coupon_type_by_pk?: Maybe<Shop_Coupon_Type>;
  /** update multiples rows of table: "shop.coupon_type" */
  update_shop_coupon_type_many?: Maybe<Array<Maybe<Shop_Coupon_Type_Mutation_Response>>>;
  /** update data of the table: "shop.coupons" */
  update_shop_coupons?: Maybe<Shop_Coupons_Mutation_Response>;
  /** update single row of the table: "shop.coupons" */
  update_shop_coupons_by_pk?: Maybe<Shop_Coupons>;
  /** update multiples rows of table: "shop.coupons" */
  update_shop_coupons_many?: Maybe<Array<Maybe<Shop_Coupons_Mutation_Response>>>;
  /** update data of the table: "shop.hsn" */
  update_shop_hsn?: Maybe<Shop_Hsn_Mutation_Response>;
  /** update single row of the table: "shop.hsn" */
  update_shop_hsn_by_pk?: Maybe<Shop_Hsn>;
  /** update multiples rows of table: "shop.hsn" */
  update_shop_hsn_many?: Maybe<Array<Maybe<Shop_Hsn_Mutation_Response>>>;
  /** update data of the table: "shop.hsn_mappings" */
  update_shop_hsn_mappings?: Maybe<Shop_Hsn_Mappings_Mutation_Response>;
  /** update single row of the table: "shop.hsn_mappings" */
  update_shop_hsn_mappings_by_pk?: Maybe<Shop_Hsn_Mappings>;
  /** update multiples rows of table: "shop.hsn_mappings" */
  update_shop_hsn_mappings_many?: Maybe<Array<Maybe<Shop_Hsn_Mappings_Mutation_Response>>>;
  /** update data of the table: "shop.inventory_skus" */
  update_shop_inventory_skus?: Maybe<Shop_Inventory_Skus_Mutation_Response>;
  /** update single row of the table: "shop.inventory_skus" */
  update_shop_inventory_skus_by_pk?: Maybe<Shop_Inventory_Skus>;
  /** update multiples rows of table: "shop.inventory_skus" */
  update_shop_inventory_skus_many?: Maybe<Array<Maybe<Shop_Inventory_Skus_Mutation_Response>>>;
  /** update data of the table: "shop.order_payment_status" */
  update_shop_order_payment_status?: Maybe<Shop_Order_Payment_Status_Mutation_Response>;
  /** update single row of the table: "shop.order_payment_status" */
  update_shop_order_payment_status_by_pk?: Maybe<Shop_Order_Payment_Status>;
  /** update multiples rows of table: "shop.order_payment_status" */
  update_shop_order_payment_status_many?: Maybe<Array<Maybe<Shop_Order_Payment_Status_Mutation_Response>>>;
  /** update data of the table: "shop.order_products" */
  update_shop_order_products?: Maybe<Shop_Order_Products_Mutation_Response>;
  /** update single row of the table: "shop.order_products" */
  update_shop_order_products_by_pk?: Maybe<Shop_Order_Products>;
  /** update multiples rows of table: "shop.order_products" */
  update_shop_order_products_many?: Maybe<Array<Maybe<Shop_Order_Products_Mutation_Response>>>;
  /** update data of the table: "shop.orders" */
  update_shop_orders?: Maybe<Shop_Orders_Mutation_Response>;
  /** update single row of the table: "shop.orders" */
  update_shop_orders_by_pk?: Maybe<Shop_Orders>;
  /** update multiples rows of table: "shop.orders" */
  update_shop_orders_many?: Maybe<Array<Maybe<Shop_Orders_Mutation_Response>>>;
  /** update data of the table: "shop.product_type" */
  update_shop_product_type?: Maybe<Shop_Product_Type_Mutation_Response>;
  /** update single row of the table: "shop.product_type" */
  update_shop_product_type_by_pk?: Maybe<Shop_Product_Type>;
  /** update multiples rows of table: "shop.product_type" */
  update_shop_product_type_many?: Maybe<Array<Maybe<Shop_Product_Type_Mutation_Response>>>;
  /** update data of the table: "shop.products" */
  update_shop_products?: Maybe<Shop_Products_Mutation_Response>;
  /** update single row of the table: "shop.products" */
  update_shop_products_by_pk?: Maybe<Shop_Products>;
  /** update multiples rows of table: "shop.products" */
  update_shop_products_many?: Maybe<Array<Maybe<Shop_Products_Mutation_Response>>>;
  /** update data of the table: "shop.shipping_addresses" */
  update_shop_shipping_addresses?: Maybe<Shop_Shipping_Addresses_Mutation_Response>;
  /** update single row of the table: "shop.shipping_addresses" */
  update_shop_shipping_addresses_by_pk?: Maybe<Shop_Shipping_Addresses>;
  /** update multiples rows of table: "shop.shipping_addresses" */
  update_shop_shipping_addresses_many?: Maybe<Array<Maybe<Shop_Shipping_Addresses_Mutation_Response>>>;
  /** update data of the table: "shop.states" */
  update_shop_states?: Maybe<Shop_States_Mutation_Response>;
  /** update single row of the table: "shop.states" */
  update_shop_states_by_pk?: Maybe<Shop_States>;
  /** update multiples rows of table: "shop.states" */
  update_shop_states_many?: Maybe<Array<Maybe<Shop_States_Mutation_Response>>>;
  /** update data of the table: "skills" */
  update_skills?: Maybe<Skills_Mutation_Response>;
  /** update single row of the table: "skills" */
  update_skills_by_pk?: Maybe<Skills>;
  /** update multiples rows of table: "skills" */
  update_skills_many?: Maybe<Array<Maybe<Skills_Mutation_Response>>>;
  /** update data of the table: "speaker_slot_status" */
  update_speaker_slot_status?: Maybe<Speaker_Slot_Status_Mutation_Response>;
  /** update single row of the table: "speaker_slot_status" */
  update_speaker_slot_status_by_pk?: Maybe<Speaker_Slot_Status>;
  /** update multiples rows of table: "speaker_slot_status" */
  update_speaker_slot_status_many?: Maybe<Array<Maybe<Speaker_Slot_Status_Mutation_Response>>>;
  /** update data of the table: "sponsor_judgments" */
  update_sponsor_judgments?: Maybe<Sponsor_Judgments_Mutation_Response>;
  /** update single row of the table: "sponsor_judgments" */
  update_sponsor_judgments_by_pk?: Maybe<Sponsor_Judgments>;
  /** update multiples rows of table: "sponsor_judgments" */
  update_sponsor_judgments_many?: Maybe<Array<Maybe<Sponsor_Judgments_Mutation_Response>>>;
  /** update data of the table: "sponsor_tiers" */
  update_sponsor_tiers?: Maybe<Sponsor_Tiers_Mutation_Response>;
  /** update single row of the table: "sponsor_tiers" */
  update_sponsor_tiers_by_pk?: Maybe<Sponsor_Tiers>;
  /** update multiples rows of table: "sponsor_tiers" */
  update_sponsor_tiers_many?: Maybe<Array<Maybe<Sponsor_Tiers_Mutation_Response>>>;
  /** update data of the table: "sponsors" */
  update_sponsors?: Maybe<Sponsors_Mutation_Response>;
  /** update single row of the table: "sponsors" */
  update_sponsors_by_pk?: Maybe<Sponsors>;
  /** update multiples rows of table: "sponsors" */
  update_sponsors_many?: Maybe<Array<Maybe<Sponsors_Mutation_Response>>>;
  /** update data of the table: "stickers" */
  update_stickers?: Maybe<Stickers_Mutation_Response>;
  /** update single row of the table: "stickers" */
  update_stickers_by_pk?: Maybe<Stickers>;
  /** update multiples rows of table: "stickers" */
  update_stickers_many?: Maybe<Array<Maybe<Stickers_Mutation_Response>>>;
  /** update data of the table: "sumsub_applicants" */
  update_sumsub_applicants?: Maybe<Sumsub_Applicants_Mutation_Response>;
  /** update single row of the table: "sumsub_applicants" */
  update_sumsub_applicants_by_pk?: Maybe<Sumsub_Applicants>;
  /** update multiples rows of table: "sumsub_applicants" */
  update_sumsub_applicants_many?: Maybe<Array<Maybe<Sumsub_Applicants_Mutation_Response>>>;
  /** update data of the table: "sumsub_applicants_review_status" */
  update_sumsub_applicants_review_status?: Maybe<Sumsub_Applicants_Review_Status_Mutation_Response>;
  /** update single row of the table: "sumsub_applicants_review_status" */
  update_sumsub_applicants_review_status_by_pk?: Maybe<Sumsub_Applicants_Review_Status>;
  /** update multiples rows of table: "sumsub_applicants_review_status" */
  update_sumsub_applicants_review_status_many?: Maybe<Array<Maybe<Sumsub_Applicants_Review_Status_Mutation_Response>>>;
  /** update data of the table: "synaps_kyc_session_status" */
  update_synaps_kyc_session_status?: Maybe<Synaps_Kyc_Session_Status_Mutation_Response>;
  /** update single row of the table: "synaps_kyc_session_status" */
  update_synaps_kyc_session_status_by_pk?: Maybe<Synaps_Kyc_Session_Status>;
  /** update multiples rows of table: "synaps_kyc_session_status" */
  update_synaps_kyc_session_status_many?: Maybe<Array<Maybe<Synaps_Kyc_Session_Status_Mutation_Response>>>;
  /** update data of the table: "synaps_kyc_sessions" */
  update_synaps_kyc_sessions?: Maybe<Synaps_Kyc_Sessions_Mutation_Response>;
  /** update single row of the table: "synaps_kyc_sessions" */
  update_synaps_kyc_sessions_by_pk?: Maybe<Synaps_Kyc_Sessions>;
  /** update multiples rows of table: "synaps_kyc_sessions" */
  update_synaps_kyc_sessions_many?: Maybe<Array<Maybe<Synaps_Kyc_Sessions_Mutation_Response>>>;
  /** update data of the table: "teams" */
  update_teams?: Maybe<Teams_Mutation_Response>;
  /** update single row of the table: "teams" */
  update_teams_by_pk?: Maybe<Teams>;
  /** update multiples rows of table: "teams" */
  update_teams_many?: Maybe<Array<Maybe<Teams_Mutation_Response>>>;
  /** update data of the table: "themes" */
  update_themes?: Maybe<Themes_Mutation_Response>;
  /** update single row of the table: "themes" */
  update_themes_by_pk?: Maybe<Themes>;
  /** update multiples rows of table: "themes" */
  update_themes_many?: Maybe<Array<Maybe<Themes_Mutation_Response>>>;
  /** update data of the table: "twitter_cards" */
  update_twitter_cards?: Maybe<Twitter_Cards_Mutation_Response>;
  /** update single row of the table: "twitter_cards" */
  update_twitter_cards_by_pk?: Maybe<Twitter_Cards>;
  /** update multiples rows of table: "twitter_cards" */
  update_twitter_cards_many?: Maybe<Array<Maybe<Twitter_Cards_Mutation_Response>>>;
  /** update data of the table: "user_api_tokens" */
  update_user_api_tokens?: Maybe<User_Api_Tokens_Mutation_Response>;
  /** update single row of the table: "user_api_tokens" */
  update_user_api_tokens_by_pk?: Maybe<User_Api_Tokens>;
  /** update multiples rows of table: "user_api_tokens" */
  update_user_api_tokens_many?: Maybe<Array<Maybe<User_Api_Tokens_Mutation_Response>>>;
  /** update data of the table: "user_comments" */
  update_user_comments?: Maybe<User_Comments_Mutation_Response>;
  /** update single row of the table: "user_comments" */
  update_user_comments_by_pk?: Maybe<User_Comments>;
  /** update multiples rows of table: "user_comments" */
  update_user_comments_many?: Maybe<Array<Maybe<User_Comments_Mutation_Response>>>;
  /** update data of the table: "user_extras" */
  update_user_extras?: Maybe<User_Extras_Mutation_Response>;
  /** update single row of the table: "user_extras" */
  update_user_extras_by_pk?: Maybe<User_Extras>;
  /** update multiples rows of table: "user_extras" */
  update_user_extras_many?: Maybe<Array<Maybe<User_Extras_Mutation_Response>>>;
  /** update data of the table: "user_feature_flags" */
  update_user_feature_flags?: Maybe<User_Feature_Flags_Mutation_Response>;
  /** update single row of the table: "user_feature_flags" */
  update_user_feature_flags_by_pk?: Maybe<User_Feature_Flags>;
  /** update multiples rows of table: "user_feature_flags" */
  update_user_feature_flags_many?: Maybe<Array<Maybe<User_Feature_Flags_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_bounties" */
  update_user_hackathon_bounties?: Maybe<User_Hackathon_Bounties_Mutation_Response>;
  /** update data of the table: "user_hackathon_bounties_bounty_type" */
  update_user_hackathon_bounties_bounty_type?: Maybe<User_Hackathon_Bounties_Bounty_Type_Mutation_Response>;
  /** update single row of the table: "user_hackathon_bounties_bounty_type" */
  update_user_hackathon_bounties_bounty_type_by_pk?: Maybe<User_Hackathon_Bounties_Bounty_Type>;
  /** update multiples rows of table: "user_hackathon_bounties_bounty_type" */
  update_user_hackathon_bounties_bounty_type_many?: Maybe<Array<Maybe<User_Hackathon_Bounties_Bounty_Type_Mutation_Response>>>;
  /** update single row of the table: "user_hackathon_bounties" */
  update_user_hackathon_bounties_by_pk?: Maybe<User_Hackathon_Bounties>;
  /** update data of the table: "user_hackathon_bounties_currency" */
  update_user_hackathon_bounties_currency?: Maybe<User_Hackathon_Bounties_Currency_Mutation_Response>;
  /** update single row of the table: "user_hackathon_bounties_currency" */
  update_user_hackathon_bounties_currency_by_pk?: Maybe<User_Hackathon_Bounties_Currency>;
  /** update multiples rows of table: "user_hackathon_bounties_currency" */
  update_user_hackathon_bounties_currency_many?: Maybe<Array<Maybe<User_Hackathon_Bounties_Currency_Mutation_Response>>>;
  /** update multiples rows of table: "user_hackathon_bounties" */
  update_user_hackathon_bounties_many?: Maybe<Array<Maybe<User_Hackathon_Bounties_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_bounties_status" */
  update_user_hackathon_bounties_status?: Maybe<User_Hackathon_Bounties_Status_Mutation_Response>;
  /** update single row of the table: "user_hackathon_bounties_status" */
  update_user_hackathon_bounties_status_by_pk?: Maybe<User_Hackathon_Bounties_Status>;
  /** update multiples rows of table: "user_hackathon_bounties_status" */
  update_user_hackathon_bounties_status_many?: Maybe<Array<Maybe<User_Hackathon_Bounties_Status_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_bounties_type" */
  update_user_hackathon_bounties_type?: Maybe<User_Hackathon_Bounties_Type_Mutation_Response>;
  /** update single row of the table: "user_hackathon_bounties_type" */
  update_user_hackathon_bounties_type_by_pk?: Maybe<User_Hackathon_Bounties_Type>;
  /** update multiples rows of table: "user_hackathon_bounties_type" */
  update_user_hackathon_bounties_type_many?: Maybe<Array<Maybe<User_Hackathon_Bounties_Type_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_checklists" */
  update_user_hackathon_checklists?: Maybe<User_Hackathon_Checklists_Mutation_Response>;
  /** update single row of the table: "user_hackathon_checklists" */
  update_user_hackathon_checklists_by_pk?: Maybe<User_Hackathon_Checklists>;
  /** update multiples rows of table: "user_hackathon_checklists" */
  update_user_hackathon_checklists_many?: Maybe<Array<Maybe<User_Hackathon_Checklists_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_credentials" */
  update_user_hackathon_credentials?: Maybe<User_Hackathon_Credentials_Mutation_Response>;
  /** update single row of the table: "user_hackathon_credentials" */
  update_user_hackathon_credentials_by_pk?: Maybe<User_Hackathon_Credentials>;
  /** update multiples rows of table: "user_hackathon_credentials" */
  update_user_hackathon_credentials_many?: Maybe<Array<Maybe<User_Hackathon_Credentials_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_credentials_status" */
  update_user_hackathon_credentials_status?: Maybe<User_Hackathon_Credentials_Status_Mutation_Response>;
  /** update single row of the table: "user_hackathon_credentials_status" */
  update_user_hackathon_credentials_status_by_pk?: Maybe<User_Hackathon_Credentials_Status>;
  /** update multiples rows of table: "user_hackathon_credentials_status" */
  update_user_hackathon_credentials_status_many?: Maybe<Array<Maybe<User_Hackathon_Credentials_Status_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_extras" */
  update_user_hackathon_extras?: Maybe<User_Hackathon_Extras_Mutation_Response>;
  /** update single row of the table: "user_hackathon_extras" */
  update_user_hackathon_extras_by_pk?: Maybe<User_Hackathon_Extras>;
  /** update multiples rows of table: "user_hackathon_extras" */
  update_user_hackathon_extras_many?: Maybe<Array<Maybe<User_Hackathon_Extras_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_feedbacks" */
  update_user_hackathon_feedbacks?: Maybe<User_Hackathon_Feedbacks_Mutation_Response>;
  /** update single row of the table: "user_hackathon_feedbacks" */
  update_user_hackathon_feedbacks_by_pk?: Maybe<User_Hackathon_Feedbacks>;
  /** update multiples rows of table: "user_hackathon_feedbacks" */
  update_user_hackathon_feedbacks_many?: Maybe<Array<Maybe<User_Hackathon_Feedbacks_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_reminders" */
  update_user_hackathon_reminders?: Maybe<User_Hackathon_Reminders_Mutation_Response>;
  /** update single row of the table: "user_hackathon_reminders" */
  update_user_hackathon_reminders_by_pk?: Maybe<User_Hackathon_Reminders>;
  /** update multiples rows of table: "user_hackathon_reminders" */
  update_user_hackathon_reminders_many?: Maybe<Array<Maybe<User_Hackathon_Reminders_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_schwags" */
  update_user_hackathon_schwags?: Maybe<User_Hackathon_Schwags_Mutation_Response>;
  /** update single row of the table: "user_hackathon_schwags" */
  update_user_hackathon_schwags_by_pk?: Maybe<User_Hackathon_Schwags>;
  /** update multiples rows of table: "user_hackathon_schwags" */
  update_user_hackathon_schwags_many?: Maybe<Array<Maybe<User_Hackathon_Schwags_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_staking_razorpay_payment_status" */
  update_user_hackathon_staking_razorpay_payment_status?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status_Mutation_Response>;
  /** update single row of the table: "user_hackathon_staking_razorpay_payment_status" */
  update_user_hackathon_staking_razorpay_payment_status_by_pk?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status>;
  /** update multiples rows of table: "user_hackathon_staking_razorpay_payment_status" */
  update_user_hackathon_staking_razorpay_payment_status_many?: Maybe<Array<Maybe<User_Hackathon_Staking_Razorpay_Payment_Status_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_staking_status" */
  update_user_hackathon_staking_status?: Maybe<User_Hackathon_Staking_Status_Mutation_Response>;
  /** update single row of the table: "user_hackathon_staking_status" */
  update_user_hackathon_staking_status_by_pk?: Maybe<User_Hackathon_Staking_Status>;
  /** update multiples rows of table: "user_hackathon_staking_status" */
  update_user_hackathon_staking_status_many?: Maybe<Array<Maybe<User_Hackathon_Staking_Status_Mutation_Response>>>;
  /** update data of the table: "user_hackathon_stakings" */
  update_user_hackathon_stakings?: Maybe<User_Hackathon_Stakings_Mutation_Response>;
  /** update single row of the table: "user_hackathon_stakings" */
  update_user_hackathon_stakings_by_pk?: Maybe<User_Hackathon_Stakings>;
  /** update multiples rows of table: "user_hackathon_stakings" */
  update_user_hackathon_stakings_many?: Maybe<Array<Maybe<User_Hackathon_Stakings_Mutation_Response>>>;
  /** update data of the table: "user_hackathons" */
  update_user_hackathons?: Maybe<User_Hackathons_Mutation_Response>;
  /** update single row of the table: "user_hackathons" */
  update_user_hackathons_by_pk?: Maybe<User_Hackathons>;
  /** update multiples rows of table: "user_hackathons" */
  update_user_hackathons_many?: Maybe<Array<Maybe<User_Hackathons_Mutation_Response>>>;
  /** update data of the table: "user_idea_stats" */
  update_user_idea_stats?: Maybe<User_Idea_Stats_Mutation_Response>;
  /** update single row of the table: "user_idea_stats" */
  update_user_idea_stats_by_pk?: Maybe<User_Idea_Stats>;
  /** update multiples rows of table: "user_idea_stats" */
  update_user_idea_stats_many?: Maybe<Array<Maybe<User_Idea_Stats_Mutation_Response>>>;
  /** update data of the table: "user_kyc_status" */
  update_user_kyc_status?: Maybe<User_Kyc_Status_Mutation_Response>;
  /** update single row of the table: "user_kyc_status" */
  update_user_kyc_status_by_pk?: Maybe<User_Kyc_Status>;
  /** update multiples rows of table: "user_kyc_status" */
  update_user_kyc_status_many?: Maybe<Array<Maybe<User_Kyc_Status_Mutation_Response>>>;
  /** update data of the table: "user_permissions" */
  update_user_permissions?: Maybe<User_Permissions_Mutation_Response>;
  /** update single row of the table: "user_permissions" */
  update_user_permissions_by_pk?: Maybe<User_Permissions>;
  /** update multiples rows of table: "user_permissions" */
  update_user_permissions_many?: Maybe<Array<Maybe<User_Permissions_Mutation_Response>>>;
  /** update data of the table: "user_profile_rss_feed_platforms" */
  update_user_profile_rss_feed_platforms?: Maybe<User_Profile_Rss_Feed_Platforms_Mutation_Response>;
  /** update single row of the table: "user_profile_rss_feed_platforms" */
  update_user_profile_rss_feed_platforms_by_pk?: Maybe<User_Profile_Rss_Feed_Platforms>;
  /** update multiples rows of table: "user_profile_rss_feed_platforms" */
  update_user_profile_rss_feed_platforms_many?: Maybe<Array<Maybe<User_Profile_Rss_Feed_Platforms_Mutation_Response>>>;
  /** update data of the table: "user_profile_rss_feeds" */
  update_user_profile_rss_feeds?: Maybe<User_Profile_Rss_Feeds_Mutation_Response>;
  /** update single row of the table: "user_profile_rss_feeds" */
  update_user_profile_rss_feeds_by_pk?: Maybe<User_Profile_Rss_Feeds>;
  /** update multiples rows of table: "user_profile_rss_feeds" */
  update_user_profile_rss_feeds_many?: Maybe<Array<Maybe<User_Profile_Rss_Feeds_Mutation_Response>>>;
  /** update data of the table: "user_profiles" */
  update_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** update single row of the table: "user_profiles" */
  update_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** update multiples rows of table: "user_profiles" */
  update_user_profiles_many?: Maybe<Array<Maybe<User_Profiles_Mutation_Response>>>;
  /** update data of the table: "user_project_meta" */
  update_user_project_meta?: Maybe<User_Project_Meta_Mutation_Response>;
  /** update single row of the table: "user_project_meta" */
  update_user_project_meta_by_pk?: Maybe<User_Project_Meta>;
  /** update multiples rows of table: "user_project_meta" */
  update_user_project_meta_many?: Maybe<Array<Maybe<User_Project_Meta_Mutation_Response>>>;
  /** update data of the table: "user_projects" */
  update_user_projects?: Maybe<User_Projects_Mutation_Response>;
  /** update single row of the table: "user_projects" */
  update_user_projects_by_pk?: Maybe<User_Projects>;
  /** update multiples rows of table: "user_projects" */
  update_user_projects_many?: Maybe<Array<Maybe<User_Projects_Mutation_Response>>>;
  /** update data of the table: "user_public_profile_layout" */
  update_user_public_profile_layout?: Maybe<User_Public_Profile_Layout_Mutation_Response>;
  /** update single row of the table: "user_public_profile_layout" */
  update_user_public_profile_layout_by_pk?: Maybe<User_Public_Profile_Layout>;
  /** update multiples rows of table: "user_public_profile_layout" */
  update_user_public_profile_layout_many?: Maybe<Array<Maybe<User_Public_Profile_Layout_Mutation_Response>>>;
  /** update data of the table: "user_public_profile_projects" */
  update_user_public_profile_projects?: Maybe<User_Public_Profile_Projects_Mutation_Response>;
  /** update single row of the table: "user_public_profile_projects" */
  update_user_public_profile_projects_by_pk?: Maybe<User_Public_Profile_Projects>;
  /** update multiples rows of table: "user_public_profile_projects" */
  update_user_public_profile_projects_many?: Maybe<Array<Maybe<User_Public_Profile_Projects_Mutation_Response>>>;
  /** update data of the table: "user_roles" */
  update_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** update single row of the table: "user_roles" */
  update_user_roles_by_pk?: Maybe<User_Roles>;
  /** update multiples rows of table: "user_roles" */
  update_user_roles_many?: Maybe<Array<Maybe<User_Roles_Mutation_Response>>>;
  /** update data of the table: "user_saved_searches" */
  update_user_saved_searches?: Maybe<User_Saved_Searches_Mutation_Response>;
  /** update single row of the table: "user_saved_searches" */
  update_user_saved_searches_by_pk?: Maybe<User_Saved_Searches>;
  /** update multiples rows of table: "user_saved_searches" */
  update_user_saved_searches_many?: Maybe<Array<Maybe<User_Saved_Searches_Mutation_Response>>>;
  /** update data of the table: "user_skills" */
  update_user_skills?: Maybe<User_Skills_Mutation_Response>;
  /** update single row of the table: "user_skills" */
  update_user_skills_by_pk?: Maybe<User_Skills>;
  /** update multiples rows of table: "user_skills" */
  update_user_skills_many?: Maybe<Array<Maybe<User_Skills_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "winners" */
  update_winners?: Maybe<Winners_Mutation_Response>;
  /** update single row of the table: "winners" */
  update_winners_by_pk?: Maybe<Winners>;
  /** update multiples rows of table: "winners" */
  update_winners_many?: Maybe<Array<Maybe<Winners_Mutation_Response>>>;
  /** execute VOLATILE function "upvote_comment" which returns "user_comments" */
  upvote_comment: Array<User_Comments>;
  /** execute VOLATILE function "want_idea" which returns "user_idea_stats" */
  want_idea: Array<User_Idea_Stats>;
};


/** mutation root */
export type Mutation_RootAddSchwagProductArgs = {
  company_uuid?: InputMaybe<Scalars['String']>;
  product_details: Schwag_Shop_Products_Insert_Input;
};


/** mutation root */
export type Mutation_RootAdd_Comment_To_ProjectArgs = {
  args: Add_Comment_To_Project_Args;
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootAdd_Hackathon_EditionArgs = {
  args: Add_Hackathon_Edition_Args;
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootAdd_Hackathon_ReminderArgs = {
  args: Add_Hackathon_Reminder_Args;
  distinct_on?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Reminders_Order_By>>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootBuilderAmaArgs = {
  message: Scalars['String'];
  uuid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCheerProjectArgs = {
  chain?: InputMaybe<CheerProjectChain>;
  message?: InputMaybe<Scalars['String']>;
  project_uuid: Scalars['String'];
  stickers: Array<CheerProjectSticker>;
};


/** mutation root */
export type Mutation_RootClaimHackathonCredentialArgs = {
  user_hackathon_credential_uuid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ArticlesArgs = {
  where: Articles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Articles_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CollegesArgs = {
  where: Colleges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Colleges_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CommentsArgs = {
  where: Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Comments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyArgs = {
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DiscoverArgs = {
  where: Discover_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discover_By_PkArgs = {
  uuid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Discover_EventsArgs = {
  where: Discover_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discover_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Education_FieldsArgs = {
  where: Education_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Education_Fields_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_EducationsArgs = {
  where: Educations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Educations_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Experience_TypeArgs = {
  where: Experience_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Experience_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ExperiencesArgs = {
  where: Experiences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Experiences_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Feature_Flag_TypesArgs = {
  where: Feature_Flag_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_Flag_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Feature_FlagsArgs = {
  where: Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_Flags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Bounties_StatusArgs = {
  where: Hackathon_Bounties_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Bounties_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_BrandsArgs = {
  where: Hackathon_Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Brands_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_ChecklistsArgs = {
  where: Hackathon_Checklists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Checklists_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Credential_Eligible_EntitiesArgs = {
  where: Hackathon_Credential_Eligible_Entities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Credential_Eligible_Entities_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Credential_TypeArgs = {
  where: Hackathon_Credential_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Credential_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_CredentialsArgs = {
  where: Hackathon_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Credentials_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Credentials_ChainArgs = {
  where: Hackathon_Credentials_Chain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Credentials_Chain_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Email_TemplatesArgs = {
  where: Hackathon_Email_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Email_Templates_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Event_GroupsArgs = {
  where: Hackathon_Event_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Event_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Event_SpeakersArgs = {
  where: Hackathon_Event_Speakers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Event_Speakers_By_PkArgs = {
  hackathon_event_id: Scalars['Int'];
  judge_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Event_SponsorsArgs = {
  where: Hackathon_Event_Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Event_Sponsors_By_PkArgs = {
  event_id: Scalars['Int'];
  sponsor_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Event_TypeArgs = {
  where: Hackathon_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Event_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_EventsArgs = {
  where: Hackathon_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_FaqArgs = {
  where: Hackathon_Faq_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Faq_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Faq_TypeArgs = {
  where: Hackathon_Faq_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Faq_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_HashtagsArgs = {
  where: Hackathon_Hashtags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Hashtags_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  hashtag_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_HostsArgs = {
  where: Hackathon_Hosts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Hosts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Note_TypeArgs = {
  where: Hackathon_Note_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Note_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_NotesArgs = {
  where: Hackathon_Notes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Notes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_SchwagsArgs = {
  where: Hackathon_Schwags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Schwags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Scope_ExtrasArgs = {
  where: Hackathon_Scope_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Scope_Extras_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_ScopesArgs = {
  where: Hackathon_Scopes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Scopes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_SettingsArgs = {
  where: Hackathon_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Settings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Staking_CurrencyArgs = {
  where: Hackathon_Staking_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Staking_Currency_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Staking_TypeArgs = {
  where: Hackathon_Staking_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Staking_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_StakingsArgs = {
  where: Hackathon_Stakings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Stakings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_ThemesArgs = {
  where: Hackathon_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Themes_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  theme_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_TracksArgs = {
  where: Hackathon_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Tracks_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_TypeArgs = {
  where: Hackathon_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathon_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_HackathonsArgs = {
  where: Hackathons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hackathons_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_HashtagsArgs = {
  where: Hashtags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hashtags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Idea_StatsArgs = {
  where: Idea_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Idea_Stats_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_IdeasArgs = {
  where: Ideas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ideas_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_JudgesArgs = {
  where: Judges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Judges_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Judging_RoomsArgs = {
  where: Judging_Rooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Judging_Rooms_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_TypesArgs = {
  where: Notification_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationsArgs = {
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notifications_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_OauthArgs = {
  where: Oauth_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Oauth_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Oauth_ProvidersArgs = {
  where: Oauth_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Oauth_Providers_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_PermissionsArgs = {
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Prize_SponsorsArgs = {
  where: Prize_Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prize_Sponsors_By_PkArgs = {
  prize_id: Scalars['Int'];
  sponsor_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Prize_TracksArgs = {
  where: Prize_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prize_Tracks_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PrizesArgs = {
  where: Prizes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prizes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ProfilesArgs = {
  where: Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profiles_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_CommitsArgs = {
  where: Project_Commits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Commits_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Contribution_StickersArgs = {
  where: Project_Contribution_Stickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Contribution_Stickers_By_PkArgs = {
  project_contribution_id: Scalars['Int'];
  sticker_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Contribution_Tx_Network_TypeArgs = {
  where: Project_Contribution_Tx_Network_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Contribution_Tx_Network_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Project_ContributionsArgs = {
  where: Project_Contributions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Contributions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Contributions_TypeArgs = {
  where: Project_Contributions_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Contributions_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Project_HashtagsArgs = {
  where: Project_Hashtags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Hashtags_By_PkArgs = {
  hashtag_id: Scalars['Int'];
  project_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_JudgesArgs = {
  where: Project_Judges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Judges_By_PkArgs = {
  judge_id: Scalars['Int'];
  project_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Judging_Submission_TypeArgs = {
  where: Project_Judging_Submission_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Judging_Submission_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Project_JudgmentsArgs = {
  where: Project_Judgments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Judgments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Report_TypeArgs = {
  where: Project_Report_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Report_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Project_ReportsArgs = {
  where: Project_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Reports_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_TracksArgs = {
  where: Project_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Tracks_By_PkArgs = {
  project_id: Scalars['Int'];
  track_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectsArgs = {
  where: Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Projects_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Projects_FundingArgs = {
  where: Projects_Funding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Projects_Funding_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_VotingArgs = {
  where: Quadratic_Voting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_ChainArgs = {
  where: Quadratic_Voting_Chain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_Chain_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_CurrencyArgs = {
  where: Quadratic_Voting_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_Currency_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_ProjectsArgs = {
  where: Quadratic_Voting_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_Projects_By_PkArgs = {
  project_id: Scalars['Int'];
  quadratic_voting_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_Request_AccessArgs = {
  where: Quadratic_Voting_Request_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_Request_Access_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_Request_Access_StatusArgs = {
  where: Quadratic_Voting_Request_Access_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quadratic_Voting_Request_Access_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Room_JudgesArgs = {
  where: Room_Judges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Room_Judges_By_PkArgs = {
  judge_id: Scalars['Int'];
  room_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Schwag_TracksArgs = {
  where: Schwag_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Schwag_Tracks_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Schwags_Allowed_Org_Winner_CountArgs = {
  where: Schwags_Allowed_Org_Winner_Count_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_CountriesArgs = {
  where: Shop_Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Countries_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_Coupon_Discount_TypeArgs = {
  where: Shop_Coupon_Discount_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Coupon_Discount_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_Coupon_TypeArgs = {
  where: Shop_Coupon_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Coupon_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_CouponsArgs = {
  where: Shop_Coupons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Coupons_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_HsnArgs = {
  where: Shop_Hsn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Hsn_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_Hsn_MappingsArgs = {
  where: Shop_Hsn_Mappings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Hsn_Mappings_By_PkArgs = {
  country_id: Scalars['Int'];
  hsn_id: Scalars['Int'];
  state_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_Inventory_SkusArgs = {
  where: Shop_Inventory_Skus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Inventory_Skus_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_Order_Payment_StatusArgs = {
  where: Shop_Order_Payment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Order_Payment_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_Order_ProductsArgs = {
  where: Shop_Order_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Order_Products_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_OrdersArgs = {
  where: Shop_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Orders_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_Product_TypeArgs = {
  where: Shop_Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Product_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_ProductsArgs = {
  where: Shop_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Products_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_Shipping_AddressesArgs = {
  where: Shop_Shipping_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_Shipping_Addresses_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shop_StatesArgs = {
  where: Shop_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shop_States_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SkillsArgs = {
  where: Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skills_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Speaker_Slot_StatusArgs = {
  where: Speaker_Slot_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Speaker_Slot_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Sponsor_JudgmentsArgs = {
  where: Sponsor_Judgments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sponsor_Judgments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Sponsor_TiersArgs = {
  where: Sponsor_Tiers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sponsor_Tiers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SponsorsArgs = {
  where: Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sponsors_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_StickersArgs = {
  where: Stickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stickers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Sumsub_ApplicantsArgs = {
  where: Sumsub_Applicants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sumsub_Applicants_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Sumsub_Applicants_Review_StatusArgs = {
  where: Sumsub_Applicants_Review_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sumsub_Applicants_Review_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Synaps_Kyc_Session_StatusArgs = {
  where: Synaps_Kyc_Session_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Synaps_Kyc_Session_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Synaps_Kyc_SessionsArgs = {
  where: Synaps_Kyc_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Synaps_Kyc_Sessions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TeamsArgs = {
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ThemesArgs = {
  where: Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Themes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Twitter_CardsArgs = {
  where: Twitter_Cards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Twitter_Cards_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Api_TokensArgs = {
  where: User_Api_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Api_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_CommentsArgs = {
  where: User_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Comments_By_PkArgs = {
  comment_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_ExtrasArgs = {
  where: User_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Extras_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Feature_FlagsArgs = {
  where: User_Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Feature_Flags_By_PkArgs = {
  feature_flag_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_BountiesArgs = {
  where: User_Hackathon_Bounties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Bounties_Bounty_TypeArgs = {
  where: User_Hackathon_Bounties_Bounty_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Bounties_Bounty_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Bounties_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Bounties_CurrencyArgs = {
  where: User_Hackathon_Bounties_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Bounties_Currency_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Bounties_StatusArgs = {
  where: User_Hackathon_Bounties_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Bounties_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Bounties_TypeArgs = {
  where: User_Hackathon_Bounties_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Bounties_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_ChecklistsArgs = {
  where: User_Hackathon_Checklists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Checklists_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_CredentialsArgs = {
  where: User_Hackathon_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Credentials_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Credentials_StatusArgs = {
  where: User_Hackathon_Credentials_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Credentials_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_ExtrasArgs = {
  where: User_Hackathon_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Extras_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_FeedbacksArgs = {
  where: User_Hackathon_Feedbacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Feedbacks_By_PkArgs = {
  feedback_question_id: Scalars['Int'];
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_RemindersArgs = {
  where: User_Hackathon_Reminders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Reminders_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_SchwagsArgs = {
  where: User_Hackathon_Schwags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Schwags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Staking_Razorpay_Payment_StatusArgs = {
  where: User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Staking_Razorpay_Payment_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Staking_StatusArgs = {
  where: User_Hackathon_Staking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Staking_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_StakingsArgs = {
  where: User_Hackathon_Stakings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathon_Stakings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_HackathonsArgs = {
  where: User_Hackathons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Hackathons_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Idea_StatsArgs = {
  where: User_Idea_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Idea_Stats_By_PkArgs = {
  idea_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Kyc_StatusArgs = {
  where: User_Kyc_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Kyc_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_PermissionsArgs = {
  where: User_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Permissions_By_PkArgs = {
  permission_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Profile_Rss_Feed_PlatformsArgs = {
  where: User_Profile_Rss_Feed_Platforms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profile_Rss_Feed_Platforms_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Profile_Rss_FeedsArgs = {
  where: User_Profile_Rss_Feeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profile_Rss_Feeds_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_ProfilesArgs = {
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profiles_By_PkArgs = {
  profile_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Project_MetaArgs = {
  where: User_Project_Meta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Project_Meta_By_PkArgs = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_ProjectsArgs = {
  where: User_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Projects_By_PkArgs = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Public_Profile_LayoutArgs = {
  where: User_Public_Profile_Layout_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Public_Profile_Layout_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Public_Profile_ProjectsArgs = {
  where: User_Public_Profile_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Public_Profile_Projects_By_PkArgs = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_RolesArgs = {
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Roles_By_PkArgs = {
  role_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Saved_SearchesArgs = {
  where: User_Saved_Searches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Saved_Searches_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_SkillsArgs = {
  where: User_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Skills_By_PkArgs = {
  skill_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_WinnersArgs = {
  where: Winners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Winners_By_PkArgs = {
  prize_id: Scalars['Int'];
  project_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ArticlesArgs = {
  objects: Array<Articles_Insert_Input>;
  on_conflict?: InputMaybe<Articles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Articles_OneArgs = {
  object: Articles_Insert_Input;
  on_conflict?: InputMaybe<Articles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CollegesArgs = {
  objects: Array<Colleges_Insert_Input>;
  on_conflict?: InputMaybe<Colleges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Colleges_OneArgs = {
  object: Colleges_Insert_Input;
  on_conflict?: InputMaybe<Colleges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommentsArgs = {
  objects: Array<Comments_Insert_Input>;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comments_OneArgs = {
  object: Comments_Insert_Input;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyArgs = {
  objects: Array<Company_Insert_Input>;
  on_conflict?: InputMaybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_OneArgs = {
  object: Company_Insert_Input;
  on_conflict?: InputMaybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DiscoverArgs = {
  objects: Array<Discover_Insert_Input>;
  on_conflict?: InputMaybe<Discover_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discover_EventsArgs = {
  objects: Array<Discover_Events_Insert_Input>;
  on_conflict?: InputMaybe<Discover_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discover_Events_OneArgs = {
  object: Discover_Events_Insert_Input;
  on_conflict?: InputMaybe<Discover_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discover_OneArgs = {
  object: Discover_Insert_Input;
  on_conflict?: InputMaybe<Discover_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_FieldsArgs = {
  objects: Array<Education_Fields_Insert_Input>;
  on_conflict?: InputMaybe<Education_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_Fields_OneArgs = {
  object: Education_Fields_Insert_Input;
  on_conflict?: InputMaybe<Education_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EducationsArgs = {
  objects: Array<Educations_Insert_Input>;
  on_conflict?: InputMaybe<Educations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Educations_OneArgs = {
  object: Educations_Insert_Input;
  on_conflict?: InputMaybe<Educations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Experience_TypeArgs = {
  objects: Array<Experience_Type_Insert_Input>;
  on_conflict?: InputMaybe<Experience_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Experience_Type_OneArgs = {
  object: Experience_Type_Insert_Input;
  on_conflict?: InputMaybe<Experience_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExperiencesArgs = {
  objects: Array<Experiences_Insert_Input>;
  on_conflict?: InputMaybe<Experiences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Experiences_OneArgs = {
  object: Experiences_Insert_Input;
  on_conflict?: InputMaybe<Experiences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Flag_TypesArgs = {
  objects: Array<Feature_Flag_Types_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Flag_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Flag_Types_OneArgs = {
  object: Feature_Flag_Types_Insert_Input;
  on_conflict?: InputMaybe<Feature_Flag_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_FlagsArgs = {
  objects: Array<Feature_Flags_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Flags_OneArgs = {
  object: Feature_Flags_Insert_Input;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Bounties_StatusArgs = {
  objects: Array<Hackathon_Bounties_Status_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Bounties_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Bounties_Status_OneArgs = {
  object: Hackathon_Bounties_Status_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Bounties_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_BrandsArgs = {
  objects: Array<Hackathon_Brands_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Brands_OneArgs = {
  object: Hackathon_Brands_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_ChecklistsArgs = {
  objects: Array<Hackathon_Checklists_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Checklists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Checklists_OneArgs = {
  object: Hackathon_Checklists_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Checklists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Credential_Eligible_EntitiesArgs = {
  objects: Array<Hackathon_Credential_Eligible_Entities_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Credential_Eligible_Entities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Credential_Eligible_Entities_OneArgs = {
  object: Hackathon_Credential_Eligible_Entities_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Credential_Eligible_Entities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Credential_TypeArgs = {
  objects: Array<Hackathon_Credential_Type_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Credential_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Credential_Type_OneArgs = {
  object: Hackathon_Credential_Type_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Credential_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_CredentialsArgs = {
  objects: Array<Hackathon_Credentials_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Credentials_ChainArgs = {
  objects: Array<Hackathon_Credentials_Chain_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Credentials_Chain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Credentials_Chain_OneArgs = {
  object: Hackathon_Credentials_Chain_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Credentials_Chain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Credentials_OneArgs = {
  object: Hackathon_Credentials_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Email_TemplatesArgs = {
  objects: Array<Hackathon_Email_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Email_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Email_Templates_OneArgs = {
  object: Hackathon_Email_Templates_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Email_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Event_GroupsArgs = {
  objects: Array<Hackathon_Event_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Event_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Event_Groups_OneArgs = {
  object: Hackathon_Event_Groups_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Event_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Event_SpeakersArgs = {
  objects: Array<Hackathon_Event_Speakers_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Event_Speakers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Event_Speakers_OneArgs = {
  object: Hackathon_Event_Speakers_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Event_Speakers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Event_SponsorsArgs = {
  objects: Array<Hackathon_Event_Sponsors_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Event_Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Event_Sponsors_OneArgs = {
  object: Hackathon_Event_Sponsors_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Event_Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Event_TypeArgs = {
  objects: Array<Hackathon_Event_Type_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Event_Type_OneArgs = {
  object: Hackathon_Event_Type_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_EventsArgs = {
  objects: Array<Hackathon_Events_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Events_OneArgs = {
  object: Hackathon_Events_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_FaqArgs = {
  objects: Array<Hackathon_Faq_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Faq_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Faq_OneArgs = {
  object: Hackathon_Faq_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Faq_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Faq_TypeArgs = {
  objects: Array<Hackathon_Faq_Type_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Faq_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Faq_Type_OneArgs = {
  object: Hackathon_Faq_Type_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Faq_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_HashtagsArgs = {
  objects: Array<Hackathon_Hashtags_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Hashtags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Hashtags_OneArgs = {
  object: Hackathon_Hashtags_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Hashtags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_HostsArgs = {
  objects: Array<Hackathon_Hosts_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Hosts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Hosts_OneArgs = {
  object: Hackathon_Hosts_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Hosts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Note_TypeArgs = {
  objects: Array<Hackathon_Note_Type_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Note_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Note_Type_OneArgs = {
  object: Hackathon_Note_Type_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Note_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_NotesArgs = {
  objects: Array<Hackathon_Notes_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Notes_OneArgs = {
  object: Hackathon_Notes_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_SchwagsArgs = {
  objects: Array<Hackathon_Schwags_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Schwags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Schwags_OneArgs = {
  object: Hackathon_Schwags_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Schwags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Scope_ExtrasArgs = {
  objects: Array<Hackathon_Scope_Extras_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Scope_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Scope_Extras_OneArgs = {
  object: Hackathon_Scope_Extras_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Scope_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_ScopesArgs = {
  objects: Array<Hackathon_Scopes_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Scopes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Scopes_OneArgs = {
  object: Hackathon_Scopes_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Scopes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_SettingsArgs = {
  objects: Array<Hackathon_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Settings_OneArgs = {
  object: Hackathon_Settings_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Staking_CurrencyArgs = {
  objects: Array<Hackathon_Staking_Currency_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Staking_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Staking_Currency_OneArgs = {
  object: Hackathon_Staking_Currency_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Staking_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Staking_TypeArgs = {
  objects: Array<Hackathon_Staking_Type_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Staking_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Staking_Type_OneArgs = {
  object: Hackathon_Staking_Type_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Staking_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_StakingsArgs = {
  objects: Array<Hackathon_Stakings_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Stakings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Stakings_OneArgs = {
  object: Hackathon_Stakings_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Stakings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_ThemesArgs = {
  objects: Array<Hackathon_Themes_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Themes_OneArgs = {
  object: Hackathon_Themes_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_TracksArgs = {
  objects: Array<Hackathon_Tracks_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Tracks_OneArgs = {
  object: Hackathon_Tracks_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_TypeArgs = {
  objects: Array<Hackathon_Type_Insert_Input>;
  on_conflict?: InputMaybe<Hackathon_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathon_Type_OneArgs = {
  object: Hackathon_Type_Insert_Input;
  on_conflict?: InputMaybe<Hackathon_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_HackathonsArgs = {
  objects: Array<Hackathons_Insert_Input>;
  on_conflict?: InputMaybe<Hackathons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hackathons_OneArgs = {
  object: Hackathons_Insert_Input;
  on_conflict?: InputMaybe<Hackathons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_HashtagsArgs = {
  objects: Array<Hashtags_Insert_Input>;
  on_conflict?: InputMaybe<Hashtags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hashtags_OneArgs = {
  object: Hashtags_Insert_Input;
  on_conflict?: InputMaybe<Hashtags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Idea_StatsArgs = {
  objects: Array<Idea_Stats_Insert_Input>;
  on_conflict?: InputMaybe<Idea_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Idea_Stats_OneArgs = {
  object: Idea_Stats_Insert_Input;
  on_conflict?: InputMaybe<Idea_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IdeasArgs = {
  objects: Array<Ideas_Insert_Input>;
  on_conflict?: InputMaybe<Ideas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ideas_OneArgs = {
  object: Ideas_Insert_Input;
  on_conflict?: InputMaybe<Ideas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JudgesArgs = {
  objects: Array<Judges_Insert_Input>;
  on_conflict?: InputMaybe<Judges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Judges_OneArgs = {
  object: Judges_Insert_Input;
  on_conflict?: InputMaybe<Judges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Judging_RoomsArgs = {
  objects: Array<Judging_Rooms_Insert_Input>;
  on_conflict?: InputMaybe<Judging_Rooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Judging_Rooms_OneArgs = {
  object: Judging_Rooms_Insert_Input;
  on_conflict?: InputMaybe<Judging_Rooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_TypesArgs = {
  objects: Array<Notification_Types_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Types_OneArgs = {
  object: Notification_Types_Insert_Input;
  on_conflict?: InputMaybe<Notification_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationsArgs = {
  objects: Array<Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notifications_OneArgs = {
  object: Notifications_Insert_Input;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OauthArgs = {
  objects: Array<Oauth_Insert_Input>;
  on_conflict?: InputMaybe<Oauth_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Oauth_OneArgs = {
  object: Oauth_Insert_Input;
  on_conflict?: InputMaybe<Oauth_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Oauth_ProvidersArgs = {
  objects: Array<Oauth_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Oauth_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Oauth_Providers_OneArgs = {
  object: Oauth_Providers_Insert_Input;
  on_conflict?: InputMaybe<Oauth_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermissionsArgs = {
  objects: Array<Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissions_OneArgs = {
  object: Permissions_Insert_Input;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prize_SponsorsArgs = {
  objects: Array<Prize_Sponsors_Insert_Input>;
  on_conflict?: InputMaybe<Prize_Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prize_Sponsors_OneArgs = {
  object: Prize_Sponsors_Insert_Input;
  on_conflict?: InputMaybe<Prize_Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prize_TracksArgs = {
  objects: Array<Prize_Tracks_Insert_Input>;
  on_conflict?: InputMaybe<Prize_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prize_Tracks_OneArgs = {
  object: Prize_Tracks_Insert_Input;
  on_conflict?: InputMaybe<Prize_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PrizesArgs = {
  objects: Array<Prizes_Insert_Input>;
  on_conflict?: InputMaybe<Prizes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prizes_OneArgs = {
  object: Prizes_Insert_Input;
  on_conflict?: InputMaybe<Prizes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProfilesArgs = {
  objects: Array<Profiles_Insert_Input>;
  on_conflict?: InputMaybe<Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profiles_OneArgs = {
  object: Profiles_Insert_Input;
  on_conflict?: InputMaybe<Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_CommitsArgs = {
  objects: Array<Project_Commits_Insert_Input>;
  on_conflict?: InputMaybe<Project_Commits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Commits_OneArgs = {
  object: Project_Commits_Insert_Input;
  on_conflict?: InputMaybe<Project_Commits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Contribution_StickersArgs = {
  objects: Array<Project_Contribution_Stickers_Insert_Input>;
  on_conflict?: InputMaybe<Project_Contribution_Stickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Contribution_Stickers_OneArgs = {
  object: Project_Contribution_Stickers_Insert_Input;
  on_conflict?: InputMaybe<Project_Contribution_Stickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Contribution_Tx_Network_TypeArgs = {
  objects: Array<Project_Contribution_Tx_Network_Type_Insert_Input>;
  on_conflict?: InputMaybe<Project_Contribution_Tx_Network_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Contribution_Tx_Network_Type_OneArgs = {
  object: Project_Contribution_Tx_Network_Type_Insert_Input;
  on_conflict?: InputMaybe<Project_Contribution_Tx_Network_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_ContributionsArgs = {
  objects: Array<Project_Contributions_Insert_Input>;
  on_conflict?: InputMaybe<Project_Contributions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Contributions_OneArgs = {
  object: Project_Contributions_Insert_Input;
  on_conflict?: InputMaybe<Project_Contributions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Contributions_TypeArgs = {
  objects: Array<Project_Contributions_Type_Insert_Input>;
  on_conflict?: InputMaybe<Project_Contributions_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Contributions_Type_OneArgs = {
  object: Project_Contributions_Type_Insert_Input;
  on_conflict?: InputMaybe<Project_Contributions_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_HashtagsArgs = {
  objects: Array<Project_Hashtags_Insert_Input>;
  on_conflict?: InputMaybe<Project_Hashtags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Hashtags_OneArgs = {
  object: Project_Hashtags_Insert_Input;
  on_conflict?: InputMaybe<Project_Hashtags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_JudgesArgs = {
  objects: Array<Project_Judges_Insert_Input>;
  on_conflict?: InputMaybe<Project_Judges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Judges_OneArgs = {
  object: Project_Judges_Insert_Input;
  on_conflict?: InputMaybe<Project_Judges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Judging_Submission_TypeArgs = {
  objects: Array<Project_Judging_Submission_Type_Insert_Input>;
  on_conflict?: InputMaybe<Project_Judging_Submission_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Judging_Submission_Type_OneArgs = {
  object: Project_Judging_Submission_Type_Insert_Input;
  on_conflict?: InputMaybe<Project_Judging_Submission_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_JudgmentsArgs = {
  objects: Array<Project_Judgments_Insert_Input>;
  on_conflict?: InputMaybe<Project_Judgments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Judgments_OneArgs = {
  object: Project_Judgments_Insert_Input;
  on_conflict?: InputMaybe<Project_Judgments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Report_TypeArgs = {
  objects: Array<Project_Report_Type_Insert_Input>;
  on_conflict?: InputMaybe<Project_Report_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Report_Type_OneArgs = {
  object: Project_Report_Type_Insert_Input;
  on_conflict?: InputMaybe<Project_Report_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_ReportsArgs = {
  objects: Array<Project_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Project_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Reports_OneArgs = {
  object: Project_Reports_Insert_Input;
  on_conflict?: InputMaybe<Project_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_TracksArgs = {
  objects: Array<Project_Tracks_Insert_Input>;
  on_conflict?: InputMaybe<Project_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Tracks_OneArgs = {
  object: Project_Tracks_Insert_Input;
  on_conflict?: InputMaybe<Project_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectsArgs = {
  objects: Array<Projects_Insert_Input>;
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_FundingArgs = {
  objects: Array<Projects_Funding_Insert_Input>;
  on_conflict?: InputMaybe<Projects_Funding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_Funding_OneArgs = {
  object: Projects_Funding_Insert_Input;
  on_conflict?: InputMaybe<Projects_Funding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_OneArgs = {
  object: Projects_Insert_Input;
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_VotingArgs = {
  objects: Array<Quadratic_Voting_Insert_Input>;
  on_conflict?: InputMaybe<Quadratic_Voting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_ChainArgs = {
  objects: Array<Quadratic_Voting_Chain_Insert_Input>;
  on_conflict?: InputMaybe<Quadratic_Voting_Chain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_Chain_OneArgs = {
  object: Quadratic_Voting_Chain_Insert_Input;
  on_conflict?: InputMaybe<Quadratic_Voting_Chain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_CurrencyArgs = {
  objects: Array<Quadratic_Voting_Currency_Insert_Input>;
  on_conflict?: InputMaybe<Quadratic_Voting_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_Currency_OneArgs = {
  object: Quadratic_Voting_Currency_Insert_Input;
  on_conflict?: InputMaybe<Quadratic_Voting_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_OneArgs = {
  object: Quadratic_Voting_Insert_Input;
  on_conflict?: InputMaybe<Quadratic_Voting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_ProjectsArgs = {
  objects: Array<Quadratic_Voting_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Quadratic_Voting_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_Projects_OneArgs = {
  object: Quadratic_Voting_Projects_Insert_Input;
  on_conflict?: InputMaybe<Quadratic_Voting_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_Request_AccessArgs = {
  objects: Array<Quadratic_Voting_Request_Access_Insert_Input>;
  on_conflict?: InputMaybe<Quadratic_Voting_Request_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_Request_Access_OneArgs = {
  object: Quadratic_Voting_Request_Access_Insert_Input;
  on_conflict?: InputMaybe<Quadratic_Voting_Request_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_Request_Access_StatusArgs = {
  objects: Array<Quadratic_Voting_Request_Access_Status_Insert_Input>;
  on_conflict?: InputMaybe<Quadratic_Voting_Request_Access_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quadratic_Voting_Request_Access_Status_OneArgs = {
  object: Quadratic_Voting_Request_Access_Status_Insert_Input;
  on_conflict?: InputMaybe<Quadratic_Voting_Request_Access_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Room_JudgesArgs = {
  objects: Array<Room_Judges_Insert_Input>;
  on_conflict?: InputMaybe<Room_Judges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Room_Judges_OneArgs = {
  object: Room_Judges_Insert_Input;
  on_conflict?: InputMaybe<Room_Judges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Schwag_TracksArgs = {
  objects: Array<Schwag_Tracks_Insert_Input>;
  on_conflict?: InputMaybe<Schwag_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Schwag_Tracks_OneArgs = {
  object: Schwag_Tracks_Insert_Input;
  on_conflict?: InputMaybe<Schwag_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Schwags_Allowed_Org_Winner_CountArgs = {
  objects: Array<Schwags_Allowed_Org_Winner_Count_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Schwags_Allowed_Org_Winner_Count_OneArgs = {
  object: Schwags_Allowed_Org_Winner_Count_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Shop_CountriesArgs = {
  objects: Array<Shop_Countries_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Countries_OneArgs = {
  object: Shop_Countries_Insert_Input;
  on_conflict?: InputMaybe<Shop_Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Coupon_Discount_TypeArgs = {
  objects: Array<Shop_Coupon_Discount_Type_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Coupon_Discount_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Coupon_Discount_Type_OneArgs = {
  object: Shop_Coupon_Discount_Type_Insert_Input;
  on_conflict?: InputMaybe<Shop_Coupon_Discount_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Coupon_TypeArgs = {
  objects: Array<Shop_Coupon_Type_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Coupon_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Coupon_Type_OneArgs = {
  object: Shop_Coupon_Type_Insert_Input;
  on_conflict?: InputMaybe<Shop_Coupon_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_CouponsArgs = {
  objects: Array<Shop_Coupons_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Coupons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Coupons_OneArgs = {
  object: Shop_Coupons_Insert_Input;
  on_conflict?: InputMaybe<Shop_Coupons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_HsnArgs = {
  objects: Array<Shop_Hsn_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Hsn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Hsn_MappingsArgs = {
  objects: Array<Shop_Hsn_Mappings_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Hsn_Mappings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Hsn_Mappings_OneArgs = {
  object: Shop_Hsn_Mappings_Insert_Input;
  on_conflict?: InputMaybe<Shop_Hsn_Mappings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Hsn_OneArgs = {
  object: Shop_Hsn_Insert_Input;
  on_conflict?: InputMaybe<Shop_Hsn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Inventory_SkusArgs = {
  objects: Array<Shop_Inventory_Skus_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Inventory_Skus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Inventory_Skus_OneArgs = {
  object: Shop_Inventory_Skus_Insert_Input;
  on_conflict?: InputMaybe<Shop_Inventory_Skus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Order_Payment_StatusArgs = {
  objects: Array<Shop_Order_Payment_Status_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Order_Payment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Order_Payment_Status_OneArgs = {
  object: Shop_Order_Payment_Status_Insert_Input;
  on_conflict?: InputMaybe<Shop_Order_Payment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Order_ProductsArgs = {
  objects: Array<Shop_Order_Products_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Order_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Order_Products_OneArgs = {
  object: Shop_Order_Products_Insert_Input;
  on_conflict?: InputMaybe<Shop_Order_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_OrdersArgs = {
  objects: Array<Shop_Orders_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Orders_OneArgs = {
  object: Shop_Orders_Insert_Input;
  on_conflict?: InputMaybe<Shop_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Product_TypeArgs = {
  objects: Array<Shop_Product_Type_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Product_Type_OneArgs = {
  object: Shop_Product_Type_Insert_Input;
  on_conflict?: InputMaybe<Shop_Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_ProductsArgs = {
  objects: Array<Shop_Products_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Products_OneArgs = {
  object: Shop_Products_Insert_Input;
  on_conflict?: InputMaybe<Shop_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Shipping_AddressesArgs = {
  objects: Array<Shop_Shipping_Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Shop_Shipping_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_Shipping_Addresses_OneArgs = {
  object: Shop_Shipping_Addresses_Insert_Input;
  on_conflict?: InputMaybe<Shop_Shipping_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_StatesArgs = {
  objects: Array<Shop_States_Insert_Input>;
  on_conflict?: InputMaybe<Shop_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shop_States_OneArgs = {
  object: Shop_States_Insert_Input;
  on_conflict?: InputMaybe<Shop_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SkillsArgs = {
  objects: Array<Skills_Insert_Input>;
  on_conflict?: InputMaybe<Skills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Skills_OneArgs = {
  object: Skills_Insert_Input;
  on_conflict?: InputMaybe<Skills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Speaker_Slot_StatusArgs = {
  objects: Array<Speaker_Slot_Status_Insert_Input>;
  on_conflict?: InputMaybe<Speaker_Slot_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Speaker_Slot_Status_OneArgs = {
  object: Speaker_Slot_Status_Insert_Input;
  on_conflict?: InputMaybe<Speaker_Slot_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsor_JudgmentsArgs = {
  objects: Array<Sponsor_Judgments_Insert_Input>;
  on_conflict?: InputMaybe<Sponsor_Judgments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsor_Judgments_OneArgs = {
  object: Sponsor_Judgments_Insert_Input;
  on_conflict?: InputMaybe<Sponsor_Judgments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsor_TiersArgs = {
  objects: Array<Sponsor_Tiers_Insert_Input>;
  on_conflict?: InputMaybe<Sponsor_Tiers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsor_Tiers_OneArgs = {
  object: Sponsor_Tiers_Insert_Input;
  on_conflict?: InputMaybe<Sponsor_Tiers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SponsorsArgs = {
  objects: Array<Sponsors_Insert_Input>;
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsors_OneArgs = {
  object: Sponsors_Insert_Input;
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StickersArgs = {
  objects: Array<Stickers_Insert_Input>;
  on_conflict?: InputMaybe<Stickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stickers_OneArgs = {
  object: Stickers_Insert_Input;
  on_conflict?: InputMaybe<Stickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sumsub_ApplicantsArgs = {
  objects: Array<Sumsub_Applicants_Insert_Input>;
  on_conflict?: InputMaybe<Sumsub_Applicants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sumsub_Applicants_OneArgs = {
  object: Sumsub_Applicants_Insert_Input;
  on_conflict?: InputMaybe<Sumsub_Applicants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sumsub_Applicants_Review_StatusArgs = {
  objects: Array<Sumsub_Applicants_Review_Status_Insert_Input>;
  on_conflict?: InputMaybe<Sumsub_Applicants_Review_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sumsub_Applicants_Review_Status_OneArgs = {
  object: Sumsub_Applicants_Review_Status_Insert_Input;
  on_conflict?: InputMaybe<Sumsub_Applicants_Review_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Synaps_Kyc_Session_StatusArgs = {
  objects: Array<Synaps_Kyc_Session_Status_Insert_Input>;
  on_conflict?: InputMaybe<Synaps_Kyc_Session_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Synaps_Kyc_Session_Status_OneArgs = {
  object: Synaps_Kyc_Session_Status_Insert_Input;
  on_conflict?: InputMaybe<Synaps_Kyc_Session_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Synaps_Kyc_SessionsArgs = {
  objects: Array<Synaps_Kyc_Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Synaps_Kyc_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Synaps_Kyc_Sessions_OneArgs = {
  object: Synaps_Kyc_Sessions_Insert_Input;
  on_conflict?: InputMaybe<Synaps_Kyc_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeamsArgs = {
  objects: Array<Teams_Insert_Input>;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_OneArgs = {
  object: Teams_Insert_Input;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ThemesArgs = {
  objects: Array<Themes_Insert_Input>;
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Themes_OneArgs = {
  object: Themes_Insert_Input;
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Twitter_CardsArgs = {
  objects: Array<Twitter_Cards_Insert_Input>;
  on_conflict?: InputMaybe<Twitter_Cards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Twitter_Cards_OneArgs = {
  object: Twitter_Cards_Insert_Input;
  on_conflict?: InputMaybe<Twitter_Cards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Api_TokensArgs = {
  objects: Array<User_Api_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<User_Api_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Api_Tokens_OneArgs = {
  object: User_Api_Tokens_Insert_Input;
  on_conflict?: InputMaybe<User_Api_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_CommentsArgs = {
  objects: Array<User_Comments_Insert_Input>;
  on_conflict?: InputMaybe<User_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Comments_OneArgs = {
  object: User_Comments_Insert_Input;
  on_conflict?: InputMaybe<User_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ExtrasArgs = {
  objects: Array<User_Extras_Insert_Input>;
  on_conflict?: InputMaybe<User_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Extras_OneArgs = {
  object: User_Extras_Insert_Input;
  on_conflict?: InputMaybe<User_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Feature_FlagsArgs = {
  objects: Array<User_Feature_Flags_Insert_Input>;
  on_conflict?: InputMaybe<User_Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Feature_Flags_OneArgs = {
  object: User_Feature_Flags_Insert_Input;
  on_conflict?: InputMaybe<User_Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_BountiesArgs = {
  objects: Array<User_Hackathon_Bounties_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Bounties_Bounty_TypeArgs = {
  objects: Array<User_Hackathon_Bounties_Bounty_Type_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Bounties_Bounty_Type_OneArgs = {
  object: User_Hackathon_Bounties_Bounty_Type_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Bounties_CurrencyArgs = {
  objects: Array<User_Hackathon_Bounties_Currency_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Bounties_Currency_OneArgs = {
  object: User_Hackathon_Bounties_Currency_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Bounties_OneArgs = {
  object: User_Hackathon_Bounties_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Bounties_StatusArgs = {
  objects: Array<User_Hackathon_Bounties_Status_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Bounties_Status_OneArgs = {
  object: User_Hackathon_Bounties_Status_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Bounties_TypeArgs = {
  objects: Array<User_Hackathon_Bounties_Type_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Bounties_Type_OneArgs = {
  object: User_Hackathon_Bounties_Type_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Bounties_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_ChecklistsArgs = {
  objects: Array<User_Hackathon_Checklists_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Checklists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Checklists_OneArgs = {
  object: User_Hackathon_Checklists_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Checklists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_CredentialsArgs = {
  objects: Array<User_Hackathon_Credentials_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Credentials_OneArgs = {
  object: User_Hackathon_Credentials_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Credentials_StatusArgs = {
  objects: Array<User_Hackathon_Credentials_Status_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Credentials_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Credentials_Status_OneArgs = {
  object: User_Hackathon_Credentials_Status_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Credentials_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_ExtrasArgs = {
  objects: Array<User_Hackathon_Extras_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Extras_OneArgs = {
  object: User_Hackathon_Extras_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_FeedbacksArgs = {
  objects: Array<User_Hackathon_Feedbacks_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Feedbacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Feedbacks_OneArgs = {
  object: User_Hackathon_Feedbacks_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Feedbacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_RemindersArgs = {
  objects: Array<User_Hackathon_Reminders_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Reminders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Reminders_OneArgs = {
  object: User_Hackathon_Reminders_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Reminders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_SchwagsArgs = {
  objects: Array<User_Hackathon_Schwags_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Schwags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Schwags_OneArgs = {
  object: User_Hackathon_Schwags_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Schwags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Staking_Razorpay_Payment_StatusArgs = {
  objects: Array<User_Hackathon_Staking_Razorpay_Payment_Status_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Staking_Razorpay_Payment_Status_OneArgs = {
  object: User_Hackathon_Staking_Razorpay_Payment_Status_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Staking_StatusArgs = {
  objects: Array<User_Hackathon_Staking_Status_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Staking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Staking_Status_OneArgs = {
  object: User_Hackathon_Staking_Status_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Staking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_StakingsArgs = {
  objects: Array<User_Hackathon_Stakings_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathon_Stakings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathon_Stakings_OneArgs = {
  object: User_Hackathon_Stakings_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathon_Stakings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_HackathonsArgs = {
  objects: Array<User_Hackathons_Insert_Input>;
  on_conflict?: InputMaybe<User_Hackathons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Hackathons_OneArgs = {
  object: User_Hackathons_Insert_Input;
  on_conflict?: InputMaybe<User_Hackathons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Idea_StatsArgs = {
  objects: Array<User_Idea_Stats_Insert_Input>;
  on_conflict?: InputMaybe<User_Idea_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Idea_Stats_OneArgs = {
  object: User_Idea_Stats_Insert_Input;
  on_conflict?: InputMaybe<User_Idea_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Kyc_StatusArgs = {
  objects: Array<User_Kyc_Status_Insert_Input>;
  on_conflict?: InputMaybe<User_Kyc_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Kyc_Status_OneArgs = {
  object: User_Kyc_Status_Insert_Input;
  on_conflict?: InputMaybe<User_Kyc_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PermissionsArgs = {
  objects: Array<User_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<User_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Permissions_OneArgs = {
  object: User_Permissions_Insert_Input;
  on_conflict?: InputMaybe<User_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profile_Rss_Feed_PlatformsArgs = {
  objects: Array<User_Profile_Rss_Feed_Platforms_Insert_Input>;
  on_conflict?: InputMaybe<User_Profile_Rss_Feed_Platforms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profile_Rss_Feed_Platforms_OneArgs = {
  object: User_Profile_Rss_Feed_Platforms_Insert_Input;
  on_conflict?: InputMaybe<User_Profile_Rss_Feed_Platforms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profile_Rss_FeedsArgs = {
  objects: Array<User_Profile_Rss_Feeds_Insert_Input>;
  on_conflict?: InputMaybe<User_Profile_Rss_Feeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profile_Rss_Feeds_OneArgs = {
  object: User_Profile_Rss_Feeds_Insert_Input;
  on_conflict?: InputMaybe<User_Profile_Rss_Feeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ProfilesArgs = {
  objects: Array<User_Profiles_Insert_Input>;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profiles_OneArgs = {
  object: User_Profiles_Insert_Input;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Project_MetaArgs = {
  objects: Array<User_Project_Meta_Insert_Input>;
  on_conflict?: InputMaybe<User_Project_Meta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Project_Meta_OneArgs = {
  object: User_Project_Meta_Insert_Input;
  on_conflict?: InputMaybe<User_Project_Meta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ProjectsArgs = {
  objects: Array<User_Projects_Insert_Input>;
  on_conflict?: InputMaybe<User_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Projects_OneArgs = {
  object: User_Projects_Insert_Input;
  on_conflict?: InputMaybe<User_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Public_Profile_LayoutArgs = {
  objects: Array<User_Public_Profile_Layout_Insert_Input>;
  on_conflict?: InputMaybe<User_Public_Profile_Layout_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Public_Profile_Layout_OneArgs = {
  object: User_Public_Profile_Layout_Insert_Input;
  on_conflict?: InputMaybe<User_Public_Profile_Layout_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Public_Profile_ProjectsArgs = {
  objects: Array<User_Public_Profile_Projects_Insert_Input>;
  on_conflict?: InputMaybe<User_Public_Profile_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Public_Profile_Projects_OneArgs = {
  object: User_Public_Profile_Projects_Insert_Input;
  on_conflict?: InputMaybe<User_Public_Profile_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RolesArgs = {
  objects: Array<User_Roles_Insert_Input>;
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Roles_OneArgs = {
  object: User_Roles_Insert_Input;
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Saved_SearchesArgs = {
  objects: Array<User_Saved_Searches_Insert_Input>;
  on_conflict?: InputMaybe<User_Saved_Searches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Saved_Searches_OneArgs = {
  object: User_Saved_Searches_Insert_Input;
  on_conflict?: InputMaybe<User_Saved_Searches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_SkillsArgs = {
  objects: Array<User_Skills_Insert_Input>;
  on_conflict?: InputMaybe<User_Skills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Skills_OneArgs = {
  object: User_Skills_Insert_Input;
  on_conflict?: InputMaybe<User_Skills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WinnersArgs = {
  objects: Array<Winners_Insert_Input>;
  on_conflict?: InputMaybe<Winners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Winners_OneArgs = {
  object: Winners_Insert_Input;
  on_conflict?: InputMaybe<Winners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLike_ProjectArgs = {
  args: Like_Project_Args;
  distinct_on?: InputMaybe<Array<User_Project_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Project_Meta_Order_By>>;
  where?: InputMaybe<User_Project_Meta_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootNominateBuilderArgs = {
  reason: Scalars['String'];
  uuid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootQuadraticVotingArgs = {
  anonAadhaarPCD?: InputMaybe<Scalars['String']>;
  hackathon_uuid: Scalars['String'];
  projects: Array<QuadraticVotingProject>;
};


/** mutation root */
export type Mutation_RootRefresh_Hackathon_Participants_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRefresh_Hackathon_Participants_Details_SingleArgs = {
  args: Refresh_Hackathon_Participants_Details_Single_Args;
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRemove_Hackathon_EditionArgs = {
  args: Remove_Hackathon_Edition_Args;
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRemove_Hackathon_ReminderArgs = {
  args: Remove_Hackathon_Reminder_Args;
  distinct_on?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Reminders_Order_By>>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootReportCommentArgs = {
  description: Scalars['String'];
  project_uuid?: InputMaybe<Scalars['String']>;
  report_type: Scalars['String'];
  reported_by_email?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootReportProjectArgs = {
  description: Scalars['String'];
  hackathon_uuid?: InputMaybe<Scalars['String']>;
  link_to_original?: InputMaybe<Scalars['String']>;
  report_type: ReportType;
  reported_by_email?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRsvpStakingArgs = {
  hackathon_staking_uuid: Scalars['String'];
  tx_hash?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootShop_PlaceOrderArgs = {
  coupon_code?: InputMaybe<Scalars['String']>;
  products: Array<Shop_PlaceOrderInputProducts>;
  shipping_address_uuid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSiwe_ConnectEthereumWalletArgs = {
  message: SiweMessageInput;
  signature: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSubmitSchwagFulfilmentFormArgs = {
  hackathon_uuid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSubmitSchwagShippingAddressArgs = {
  shippingAddress: ShippingAddress;
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ArticlesArgs = {
  _inc?: InputMaybe<Articles_Inc_Input>;
  _set?: InputMaybe<Articles_Set_Input>;
  where: Articles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Articles_By_PkArgs = {
  _inc?: InputMaybe<Articles_Inc_Input>;
  _set?: InputMaybe<Articles_Set_Input>;
  pk_columns: Articles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Articles_ManyArgs = {
  updates: Array<Articles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CollegesArgs = {
  _inc?: InputMaybe<Colleges_Inc_Input>;
  _set?: InputMaybe<Colleges_Set_Input>;
  where: Colleges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Colleges_By_PkArgs = {
  _inc?: InputMaybe<Colleges_Inc_Input>;
  _set?: InputMaybe<Colleges_Set_Input>;
  pk_columns: Colleges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Colleges_ManyArgs = {
  updates: Array<Colleges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommentsArgs = {
  _inc?: InputMaybe<Comments_Inc_Input>;
  _set?: InputMaybe<Comments_Set_Input>;
  where: Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comments_By_PkArgs = {
  _inc?: InputMaybe<Comments_Inc_Input>;
  _set?: InputMaybe<Comments_Set_Input>;
  pk_columns: Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Comments_ManyArgs = {
  updates: Array<Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyArgs = {
  _inc?: InputMaybe<Company_Inc_Input>;
  _set?: InputMaybe<Company_Set_Input>;
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_By_PkArgs = {
  _inc?: InputMaybe<Company_Inc_Input>;
  _set?: InputMaybe<Company_Set_Input>;
  pk_columns: Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_ManyArgs = {
  updates: Array<Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DiscoverArgs = {
  _append?: InputMaybe<Discover_Append_Input>;
  _delete_at_path?: InputMaybe<Discover_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Discover_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Discover_Delete_Key_Input>;
  _prepend?: InputMaybe<Discover_Prepend_Input>;
  _set?: InputMaybe<Discover_Set_Input>;
  where: Discover_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discover_By_PkArgs = {
  _append?: InputMaybe<Discover_Append_Input>;
  _delete_at_path?: InputMaybe<Discover_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Discover_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Discover_Delete_Key_Input>;
  _prepend?: InputMaybe<Discover_Prepend_Input>;
  _set?: InputMaybe<Discover_Set_Input>;
  pk_columns: Discover_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discover_EventsArgs = {
  _inc?: InputMaybe<Discover_Events_Inc_Input>;
  _set?: InputMaybe<Discover_Events_Set_Input>;
  where: Discover_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discover_Events_By_PkArgs = {
  _inc?: InputMaybe<Discover_Events_Inc_Input>;
  _set?: InputMaybe<Discover_Events_Set_Input>;
  pk_columns: Discover_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discover_Events_ManyArgs = {
  updates: Array<Discover_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Discover_ManyArgs = {
  updates: Array<Discover_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Education_FieldsArgs = {
  _inc?: InputMaybe<Education_Fields_Inc_Input>;
  _set?: InputMaybe<Education_Fields_Set_Input>;
  where: Education_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Fields_By_PkArgs = {
  _inc?: InputMaybe<Education_Fields_Inc_Input>;
  _set?: InputMaybe<Education_Fields_Set_Input>;
  pk_columns: Education_Fields_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Fields_ManyArgs = {
  updates: Array<Education_Fields_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EducationsArgs = {
  _inc?: InputMaybe<Educations_Inc_Input>;
  _set?: InputMaybe<Educations_Set_Input>;
  where: Educations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Educations_By_PkArgs = {
  _inc?: InputMaybe<Educations_Inc_Input>;
  _set?: InputMaybe<Educations_Set_Input>;
  pk_columns: Educations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Educations_ManyArgs = {
  updates: Array<Educations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Experience_TypeArgs = {
  _set?: InputMaybe<Experience_Type_Set_Input>;
  where: Experience_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Experience_Type_By_PkArgs = {
  _set?: InputMaybe<Experience_Type_Set_Input>;
  pk_columns: Experience_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Experience_Type_ManyArgs = {
  updates: Array<Experience_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExperiencesArgs = {
  _inc?: InputMaybe<Experiences_Inc_Input>;
  _set?: InputMaybe<Experiences_Set_Input>;
  where: Experiences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Experiences_By_PkArgs = {
  _inc?: InputMaybe<Experiences_Inc_Input>;
  _set?: InputMaybe<Experiences_Set_Input>;
  pk_columns: Experiences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Experiences_ManyArgs = {
  updates: Array<Experiences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flag_TypesArgs = {
  _set?: InputMaybe<Feature_Flag_Types_Set_Input>;
  where: Feature_Flag_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flag_Types_By_PkArgs = {
  _set?: InputMaybe<Feature_Flag_Types_Set_Input>;
  pk_columns: Feature_Flag_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flag_Types_ManyArgs = {
  updates: Array<Feature_Flag_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_FlagsArgs = {
  _inc?: InputMaybe<Feature_Flags_Inc_Input>;
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  where: Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flags_By_PkArgs = {
  _inc?: InputMaybe<Feature_Flags_Inc_Input>;
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  pk_columns: Feature_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flags_ManyArgs = {
  updates: Array<Feature_Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Bounties_StatusArgs = {
  _set?: InputMaybe<Hackathon_Bounties_Status_Set_Input>;
  where: Hackathon_Bounties_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Bounties_Status_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Bounties_Status_Set_Input>;
  pk_columns: Hackathon_Bounties_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Bounties_Status_ManyArgs = {
  updates: Array<Hackathon_Bounties_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_BrandsArgs = {
  _inc?: InputMaybe<Hackathon_Brands_Inc_Input>;
  _set?: InputMaybe<Hackathon_Brands_Set_Input>;
  where: Hackathon_Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Brands_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Brands_Inc_Input>;
  _set?: InputMaybe<Hackathon_Brands_Set_Input>;
  pk_columns: Hackathon_Brands_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Brands_ManyArgs = {
  updates: Array<Hackathon_Brands_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_ChecklistsArgs = {
  _inc?: InputMaybe<Hackathon_Checklists_Inc_Input>;
  _set?: InputMaybe<Hackathon_Checklists_Set_Input>;
  where: Hackathon_Checklists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Checklists_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Checklists_Inc_Input>;
  _set?: InputMaybe<Hackathon_Checklists_Set_Input>;
  pk_columns: Hackathon_Checklists_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Checklists_ManyArgs = {
  updates: Array<Hackathon_Checklists_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credential_Eligible_EntitiesArgs = {
  _set?: InputMaybe<Hackathon_Credential_Eligible_Entities_Set_Input>;
  where: Hackathon_Credential_Eligible_Entities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credential_Eligible_Entities_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Credential_Eligible_Entities_Set_Input>;
  pk_columns: Hackathon_Credential_Eligible_Entities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credential_Eligible_Entities_ManyArgs = {
  updates: Array<Hackathon_Credential_Eligible_Entities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credential_TypeArgs = {
  _set?: InputMaybe<Hackathon_Credential_Type_Set_Input>;
  where: Hackathon_Credential_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credential_Type_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Credential_Type_Set_Input>;
  pk_columns: Hackathon_Credential_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credential_Type_ManyArgs = {
  updates: Array<Hackathon_Credential_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_CredentialsArgs = {
  _inc?: InputMaybe<Hackathon_Credentials_Inc_Input>;
  _set?: InputMaybe<Hackathon_Credentials_Set_Input>;
  where: Hackathon_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credentials_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Credentials_Inc_Input>;
  _set?: InputMaybe<Hackathon_Credentials_Set_Input>;
  pk_columns: Hackathon_Credentials_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credentials_ChainArgs = {
  _set?: InputMaybe<Hackathon_Credentials_Chain_Set_Input>;
  where: Hackathon_Credentials_Chain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credentials_Chain_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Credentials_Chain_Set_Input>;
  pk_columns: Hackathon_Credentials_Chain_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credentials_Chain_ManyArgs = {
  updates: Array<Hackathon_Credentials_Chain_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Credentials_ManyArgs = {
  updates: Array<Hackathon_Credentials_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Email_TemplatesArgs = {
  _inc?: InputMaybe<Hackathon_Email_Templates_Inc_Input>;
  _set?: InputMaybe<Hackathon_Email_Templates_Set_Input>;
  where: Hackathon_Email_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Email_Templates_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Email_Templates_Inc_Input>;
  _set?: InputMaybe<Hackathon_Email_Templates_Set_Input>;
  pk_columns: Hackathon_Email_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Email_Templates_ManyArgs = {
  updates: Array<Hackathon_Email_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_GroupsArgs = {
  _inc?: InputMaybe<Hackathon_Event_Groups_Inc_Input>;
  _set?: InputMaybe<Hackathon_Event_Groups_Set_Input>;
  where: Hackathon_Event_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_Groups_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Event_Groups_Inc_Input>;
  _set?: InputMaybe<Hackathon_Event_Groups_Set_Input>;
  pk_columns: Hackathon_Event_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_Groups_ManyArgs = {
  updates: Array<Hackathon_Event_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_SpeakersArgs = {
  _inc?: InputMaybe<Hackathon_Event_Speakers_Inc_Input>;
  _set?: InputMaybe<Hackathon_Event_Speakers_Set_Input>;
  where: Hackathon_Event_Speakers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_Speakers_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Event_Speakers_Inc_Input>;
  _set?: InputMaybe<Hackathon_Event_Speakers_Set_Input>;
  pk_columns: Hackathon_Event_Speakers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_Speakers_ManyArgs = {
  updates: Array<Hackathon_Event_Speakers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_SponsorsArgs = {
  _inc?: InputMaybe<Hackathon_Event_Sponsors_Inc_Input>;
  _set?: InputMaybe<Hackathon_Event_Sponsors_Set_Input>;
  where: Hackathon_Event_Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_Sponsors_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Event_Sponsors_Inc_Input>;
  _set?: InputMaybe<Hackathon_Event_Sponsors_Set_Input>;
  pk_columns: Hackathon_Event_Sponsors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_Sponsors_ManyArgs = {
  updates: Array<Hackathon_Event_Sponsors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_TypeArgs = {
  _set?: InputMaybe<Hackathon_Event_Type_Set_Input>;
  where: Hackathon_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_Type_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Event_Type_Set_Input>;
  pk_columns: Hackathon_Event_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Event_Type_ManyArgs = {
  updates: Array<Hackathon_Event_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_EventsArgs = {
  _inc?: InputMaybe<Hackathon_Events_Inc_Input>;
  _set?: InputMaybe<Hackathon_Events_Set_Input>;
  where: Hackathon_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Events_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Events_Inc_Input>;
  _set?: InputMaybe<Hackathon_Events_Set_Input>;
  pk_columns: Hackathon_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Events_ManyArgs = {
  updates: Array<Hackathon_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_FaqArgs = {
  _inc?: InputMaybe<Hackathon_Faq_Inc_Input>;
  _set?: InputMaybe<Hackathon_Faq_Set_Input>;
  where: Hackathon_Faq_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Faq_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Faq_Inc_Input>;
  _set?: InputMaybe<Hackathon_Faq_Set_Input>;
  pk_columns: Hackathon_Faq_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Faq_ManyArgs = {
  updates: Array<Hackathon_Faq_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Faq_TypeArgs = {
  _set?: InputMaybe<Hackathon_Faq_Type_Set_Input>;
  where: Hackathon_Faq_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Faq_Type_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Faq_Type_Set_Input>;
  pk_columns: Hackathon_Faq_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Faq_Type_ManyArgs = {
  updates: Array<Hackathon_Faq_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_HashtagsArgs = {
  _inc?: InputMaybe<Hackathon_Hashtags_Inc_Input>;
  _set?: InputMaybe<Hackathon_Hashtags_Set_Input>;
  where: Hackathon_Hashtags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Hashtags_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Hashtags_Inc_Input>;
  _set?: InputMaybe<Hackathon_Hashtags_Set_Input>;
  pk_columns: Hackathon_Hashtags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Hashtags_ManyArgs = {
  updates: Array<Hackathon_Hashtags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_HostsArgs = {
  _inc?: InputMaybe<Hackathon_Hosts_Inc_Input>;
  _set?: InputMaybe<Hackathon_Hosts_Set_Input>;
  where: Hackathon_Hosts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Hosts_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Hosts_Inc_Input>;
  _set?: InputMaybe<Hackathon_Hosts_Set_Input>;
  pk_columns: Hackathon_Hosts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Hosts_ManyArgs = {
  updates: Array<Hackathon_Hosts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Note_TypeArgs = {
  _set?: InputMaybe<Hackathon_Note_Type_Set_Input>;
  where: Hackathon_Note_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Note_Type_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Note_Type_Set_Input>;
  pk_columns: Hackathon_Note_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Note_Type_ManyArgs = {
  updates: Array<Hackathon_Note_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_NotesArgs = {
  _inc?: InputMaybe<Hackathon_Notes_Inc_Input>;
  _set?: InputMaybe<Hackathon_Notes_Set_Input>;
  where: Hackathon_Notes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Notes_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Notes_Inc_Input>;
  _set?: InputMaybe<Hackathon_Notes_Set_Input>;
  pk_columns: Hackathon_Notes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Notes_ManyArgs = {
  updates: Array<Hackathon_Notes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_SchwagsArgs = {
  _append?: InputMaybe<Hackathon_Schwags_Append_Input>;
  _delete_at_path?: InputMaybe<Hackathon_Schwags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hackathon_Schwags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hackathon_Schwags_Delete_Key_Input>;
  _inc?: InputMaybe<Hackathon_Schwags_Inc_Input>;
  _prepend?: InputMaybe<Hackathon_Schwags_Prepend_Input>;
  _set?: InputMaybe<Hackathon_Schwags_Set_Input>;
  where: Hackathon_Schwags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Schwags_By_PkArgs = {
  _append?: InputMaybe<Hackathon_Schwags_Append_Input>;
  _delete_at_path?: InputMaybe<Hackathon_Schwags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hackathon_Schwags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hackathon_Schwags_Delete_Key_Input>;
  _inc?: InputMaybe<Hackathon_Schwags_Inc_Input>;
  _prepend?: InputMaybe<Hackathon_Schwags_Prepend_Input>;
  _set?: InputMaybe<Hackathon_Schwags_Set_Input>;
  pk_columns: Hackathon_Schwags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Schwags_ManyArgs = {
  updates: Array<Hackathon_Schwags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Scope_ExtrasArgs = {
  _inc?: InputMaybe<Hackathon_Scope_Extras_Inc_Input>;
  _set?: InputMaybe<Hackathon_Scope_Extras_Set_Input>;
  where: Hackathon_Scope_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Scope_Extras_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Scope_Extras_Inc_Input>;
  _set?: InputMaybe<Hackathon_Scope_Extras_Set_Input>;
  pk_columns: Hackathon_Scope_Extras_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Scope_Extras_ManyArgs = {
  updates: Array<Hackathon_Scope_Extras_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_ScopesArgs = {
  _inc?: InputMaybe<Hackathon_Scopes_Inc_Input>;
  _set?: InputMaybe<Hackathon_Scopes_Set_Input>;
  where: Hackathon_Scopes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Scopes_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Scopes_Inc_Input>;
  _set?: InputMaybe<Hackathon_Scopes_Set_Input>;
  pk_columns: Hackathon_Scopes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Scopes_ManyArgs = {
  updates: Array<Hackathon_Scopes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_SettingsArgs = {
  _append?: InputMaybe<Hackathon_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Hackathon_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hackathon_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hackathon_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Hackathon_Settings_Inc_Input>;
  _prepend?: InputMaybe<Hackathon_Settings_Prepend_Input>;
  _set?: InputMaybe<Hackathon_Settings_Set_Input>;
  where: Hackathon_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Settings_By_PkArgs = {
  _append?: InputMaybe<Hackathon_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Hackathon_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hackathon_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hackathon_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Hackathon_Settings_Inc_Input>;
  _prepend?: InputMaybe<Hackathon_Settings_Prepend_Input>;
  _set?: InputMaybe<Hackathon_Settings_Set_Input>;
  pk_columns: Hackathon_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Settings_ManyArgs = {
  updates: Array<Hackathon_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Staking_CurrencyArgs = {
  _set?: InputMaybe<Hackathon_Staking_Currency_Set_Input>;
  where: Hackathon_Staking_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Staking_Currency_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Staking_Currency_Set_Input>;
  pk_columns: Hackathon_Staking_Currency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Staking_Currency_ManyArgs = {
  updates: Array<Hackathon_Staking_Currency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Staking_TypeArgs = {
  _set?: InputMaybe<Hackathon_Staking_Type_Set_Input>;
  where: Hackathon_Staking_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Staking_Type_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Staking_Type_Set_Input>;
  pk_columns: Hackathon_Staking_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Staking_Type_ManyArgs = {
  updates: Array<Hackathon_Staking_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_StakingsArgs = {
  _inc?: InputMaybe<Hackathon_Stakings_Inc_Input>;
  _set?: InputMaybe<Hackathon_Stakings_Set_Input>;
  where: Hackathon_Stakings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Stakings_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Stakings_Inc_Input>;
  _set?: InputMaybe<Hackathon_Stakings_Set_Input>;
  pk_columns: Hackathon_Stakings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Stakings_ManyArgs = {
  updates: Array<Hackathon_Stakings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_ThemesArgs = {
  _inc?: InputMaybe<Hackathon_Themes_Inc_Input>;
  _set?: InputMaybe<Hackathon_Themes_Set_Input>;
  where: Hackathon_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Themes_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Themes_Inc_Input>;
  _set?: InputMaybe<Hackathon_Themes_Set_Input>;
  pk_columns: Hackathon_Themes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Themes_ManyArgs = {
  updates: Array<Hackathon_Themes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_TracksArgs = {
  _inc?: InputMaybe<Hackathon_Tracks_Inc_Input>;
  _set?: InputMaybe<Hackathon_Tracks_Set_Input>;
  where: Hackathon_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Tracks_By_PkArgs = {
  _inc?: InputMaybe<Hackathon_Tracks_Inc_Input>;
  _set?: InputMaybe<Hackathon_Tracks_Set_Input>;
  pk_columns: Hackathon_Tracks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Tracks_ManyArgs = {
  updates: Array<Hackathon_Tracks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_TypeArgs = {
  _set?: InputMaybe<Hackathon_Type_Set_Input>;
  where: Hackathon_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Type_By_PkArgs = {
  _set?: InputMaybe<Hackathon_Type_Set_Input>;
  pk_columns: Hackathon_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathon_Type_ManyArgs = {
  updates: Array<Hackathon_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_HackathonsArgs = {
  _append?: InputMaybe<Hackathons_Append_Input>;
  _delete_at_path?: InputMaybe<Hackathons_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hackathons_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hackathons_Delete_Key_Input>;
  _inc?: InputMaybe<Hackathons_Inc_Input>;
  _prepend?: InputMaybe<Hackathons_Prepend_Input>;
  _set?: InputMaybe<Hackathons_Set_Input>;
  where: Hackathons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathons_By_PkArgs = {
  _append?: InputMaybe<Hackathons_Append_Input>;
  _delete_at_path?: InputMaybe<Hackathons_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hackathons_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hackathons_Delete_Key_Input>;
  _inc?: InputMaybe<Hackathons_Inc_Input>;
  _prepend?: InputMaybe<Hackathons_Prepend_Input>;
  _set?: InputMaybe<Hackathons_Set_Input>;
  pk_columns: Hackathons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hackathons_ManyArgs = {
  updates: Array<Hackathons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_HashtagsArgs = {
  _inc?: InputMaybe<Hashtags_Inc_Input>;
  _set?: InputMaybe<Hashtags_Set_Input>;
  where: Hashtags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hashtags_By_PkArgs = {
  _inc?: InputMaybe<Hashtags_Inc_Input>;
  _set?: InputMaybe<Hashtags_Set_Input>;
  pk_columns: Hashtags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hashtags_ManyArgs = {
  updates: Array<Hashtags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Idea_StatsArgs = {
  _inc?: InputMaybe<Idea_Stats_Inc_Input>;
  _set?: InputMaybe<Idea_Stats_Set_Input>;
  where: Idea_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Idea_Stats_By_PkArgs = {
  _inc?: InputMaybe<Idea_Stats_Inc_Input>;
  _set?: InputMaybe<Idea_Stats_Set_Input>;
  pk_columns: Idea_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Idea_Stats_ManyArgs = {
  updates: Array<Idea_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IdeasArgs = {
  _inc?: InputMaybe<Ideas_Inc_Input>;
  _set?: InputMaybe<Ideas_Set_Input>;
  where: Ideas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ideas_By_PkArgs = {
  _inc?: InputMaybe<Ideas_Inc_Input>;
  _set?: InputMaybe<Ideas_Set_Input>;
  pk_columns: Ideas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ideas_ManyArgs = {
  updates: Array<Ideas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_JudgesArgs = {
  _inc?: InputMaybe<Judges_Inc_Input>;
  _set?: InputMaybe<Judges_Set_Input>;
  where: Judges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Judges_By_PkArgs = {
  _inc?: InputMaybe<Judges_Inc_Input>;
  _set?: InputMaybe<Judges_Set_Input>;
  pk_columns: Judges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Judges_ManyArgs = {
  updates: Array<Judges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Judging_RoomsArgs = {
  _inc?: InputMaybe<Judging_Rooms_Inc_Input>;
  _set?: InputMaybe<Judging_Rooms_Set_Input>;
  where: Judging_Rooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Judging_Rooms_By_PkArgs = {
  _inc?: InputMaybe<Judging_Rooms_Inc_Input>;
  _set?: InputMaybe<Judging_Rooms_Set_Input>;
  pk_columns: Judging_Rooms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Judging_Rooms_ManyArgs = {
  updates: Array<Judging_Rooms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_TypesArgs = {
  _set?: InputMaybe<Notification_Types_Set_Input>;
  where: Notification_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Types_By_PkArgs = {
  _set?: InputMaybe<Notification_Types_Set_Input>;
  pk_columns: Notification_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Types_ManyArgs = {
  updates: Array<Notification_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationsArgs = {
  _append?: InputMaybe<Notifications_Append_Input>;
  _delete_at_path?: InputMaybe<Notifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notifications_Delete_Key_Input>;
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _prepend?: InputMaybe<Notifications_Prepend_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_By_PkArgs = {
  _append?: InputMaybe<Notifications_Append_Input>;
  _delete_at_path?: InputMaybe<Notifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notifications_Delete_Key_Input>;
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _prepend?: InputMaybe<Notifications_Prepend_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  pk_columns: Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_ManyArgs = {
  updates: Array<Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OauthArgs = {
  _append?: InputMaybe<Oauth_Append_Input>;
  _delete_at_path?: InputMaybe<Oauth_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Oauth_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Oauth_Delete_Key_Input>;
  _inc?: InputMaybe<Oauth_Inc_Input>;
  _prepend?: InputMaybe<Oauth_Prepend_Input>;
  _set?: InputMaybe<Oauth_Set_Input>;
  where: Oauth_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Oauth_By_PkArgs = {
  _append?: InputMaybe<Oauth_Append_Input>;
  _delete_at_path?: InputMaybe<Oauth_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Oauth_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Oauth_Delete_Key_Input>;
  _inc?: InputMaybe<Oauth_Inc_Input>;
  _prepend?: InputMaybe<Oauth_Prepend_Input>;
  _set?: InputMaybe<Oauth_Set_Input>;
  pk_columns: Oauth_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Oauth_ManyArgs = {
  updates: Array<Oauth_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Oauth_ProvidersArgs = {
  _set?: InputMaybe<Oauth_Providers_Set_Input>;
  where: Oauth_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Oauth_Providers_By_PkArgs = {
  _set?: InputMaybe<Oauth_Providers_Set_Input>;
  pk_columns: Oauth_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Oauth_Providers_ManyArgs = {
  updates: Array<Oauth_Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionsArgs = {
  _inc?: InputMaybe<Permissions_Inc_Input>;
  _set?: InputMaybe<Permissions_Set_Input>;
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Permissions_Inc_Input>;
  _set?: InputMaybe<Permissions_Set_Input>;
  pk_columns: Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_ManyArgs = {
  updates: Array<Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prize_SponsorsArgs = {
  _inc?: InputMaybe<Prize_Sponsors_Inc_Input>;
  _set?: InputMaybe<Prize_Sponsors_Set_Input>;
  where: Prize_Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prize_Sponsors_By_PkArgs = {
  _inc?: InputMaybe<Prize_Sponsors_Inc_Input>;
  _set?: InputMaybe<Prize_Sponsors_Set_Input>;
  pk_columns: Prize_Sponsors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prize_Sponsors_ManyArgs = {
  updates: Array<Prize_Sponsors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prize_TracksArgs = {
  _inc?: InputMaybe<Prize_Tracks_Inc_Input>;
  _set?: InputMaybe<Prize_Tracks_Set_Input>;
  where: Prize_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prize_Tracks_By_PkArgs = {
  _inc?: InputMaybe<Prize_Tracks_Inc_Input>;
  _set?: InputMaybe<Prize_Tracks_Set_Input>;
  pk_columns: Prize_Tracks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prize_Tracks_ManyArgs = {
  updates: Array<Prize_Tracks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PrizesArgs = {
  _inc?: InputMaybe<Prizes_Inc_Input>;
  _set?: InputMaybe<Prizes_Set_Input>;
  where: Prizes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prizes_By_PkArgs = {
  _inc?: InputMaybe<Prizes_Inc_Input>;
  _set?: InputMaybe<Prizes_Set_Input>;
  pk_columns: Prizes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prizes_ManyArgs = {
  updates: Array<Prizes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProfilesArgs = {
  _inc?: InputMaybe<Profiles_Inc_Input>;
  _set?: InputMaybe<Profiles_Set_Input>;
  where: Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profiles_By_PkArgs = {
  _inc?: InputMaybe<Profiles_Inc_Input>;
  _set?: InputMaybe<Profiles_Set_Input>;
  pk_columns: Profiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Profiles_ManyArgs = {
  updates: Array<Profiles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_CommitsArgs = {
  _append?: InputMaybe<Project_Commits_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Commits_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Commits_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Commits_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Commits_Inc_Input>;
  _prepend?: InputMaybe<Project_Commits_Prepend_Input>;
  _set?: InputMaybe<Project_Commits_Set_Input>;
  where: Project_Commits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Commits_By_PkArgs = {
  _append?: InputMaybe<Project_Commits_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Commits_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Commits_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Commits_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Commits_Inc_Input>;
  _prepend?: InputMaybe<Project_Commits_Prepend_Input>;
  _set?: InputMaybe<Project_Commits_Set_Input>;
  pk_columns: Project_Commits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Commits_ManyArgs = {
  updates: Array<Project_Commits_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contribution_StickersArgs = {
  _append?: InputMaybe<Project_Contribution_Stickers_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Contribution_Stickers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Contribution_Stickers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Contribution_Stickers_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Contribution_Stickers_Inc_Input>;
  _prepend?: InputMaybe<Project_Contribution_Stickers_Prepend_Input>;
  _set?: InputMaybe<Project_Contribution_Stickers_Set_Input>;
  where: Project_Contribution_Stickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contribution_Stickers_By_PkArgs = {
  _append?: InputMaybe<Project_Contribution_Stickers_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Contribution_Stickers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Contribution_Stickers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Contribution_Stickers_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Contribution_Stickers_Inc_Input>;
  _prepend?: InputMaybe<Project_Contribution_Stickers_Prepend_Input>;
  _set?: InputMaybe<Project_Contribution_Stickers_Set_Input>;
  pk_columns: Project_Contribution_Stickers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contribution_Stickers_ManyArgs = {
  updates: Array<Project_Contribution_Stickers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contribution_Tx_Network_TypeArgs = {
  _set?: InputMaybe<Project_Contribution_Tx_Network_Type_Set_Input>;
  where: Project_Contribution_Tx_Network_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contribution_Tx_Network_Type_By_PkArgs = {
  _set?: InputMaybe<Project_Contribution_Tx_Network_Type_Set_Input>;
  pk_columns: Project_Contribution_Tx_Network_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contribution_Tx_Network_Type_ManyArgs = {
  updates: Array<Project_Contribution_Tx_Network_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ContributionsArgs = {
  _append?: InputMaybe<Project_Contributions_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Contributions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Contributions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Contributions_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Contributions_Inc_Input>;
  _prepend?: InputMaybe<Project_Contributions_Prepend_Input>;
  _set?: InputMaybe<Project_Contributions_Set_Input>;
  where: Project_Contributions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contributions_By_PkArgs = {
  _append?: InputMaybe<Project_Contributions_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Contributions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Contributions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Contributions_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Contributions_Inc_Input>;
  _prepend?: InputMaybe<Project_Contributions_Prepend_Input>;
  _set?: InputMaybe<Project_Contributions_Set_Input>;
  pk_columns: Project_Contributions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contributions_ManyArgs = {
  updates: Array<Project_Contributions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contributions_TypeArgs = {
  _set?: InputMaybe<Project_Contributions_Type_Set_Input>;
  where: Project_Contributions_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contributions_Type_By_PkArgs = {
  _set?: InputMaybe<Project_Contributions_Type_Set_Input>;
  pk_columns: Project_Contributions_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contributions_Type_ManyArgs = {
  updates: Array<Project_Contributions_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_HashtagsArgs = {
  _inc?: InputMaybe<Project_Hashtags_Inc_Input>;
  _set?: InputMaybe<Project_Hashtags_Set_Input>;
  where: Project_Hashtags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Hashtags_By_PkArgs = {
  _inc?: InputMaybe<Project_Hashtags_Inc_Input>;
  _set?: InputMaybe<Project_Hashtags_Set_Input>;
  pk_columns: Project_Hashtags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Hashtags_ManyArgs = {
  updates: Array<Project_Hashtags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_JudgesArgs = {
  _inc?: InputMaybe<Project_Judges_Inc_Input>;
  _set?: InputMaybe<Project_Judges_Set_Input>;
  where: Project_Judges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Judges_By_PkArgs = {
  _inc?: InputMaybe<Project_Judges_Inc_Input>;
  _set?: InputMaybe<Project_Judges_Set_Input>;
  pk_columns: Project_Judges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Judges_ManyArgs = {
  updates: Array<Project_Judges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Judging_Submission_TypeArgs = {
  _set?: InputMaybe<Project_Judging_Submission_Type_Set_Input>;
  where: Project_Judging_Submission_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Judging_Submission_Type_By_PkArgs = {
  _set?: InputMaybe<Project_Judging_Submission_Type_Set_Input>;
  pk_columns: Project_Judging_Submission_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Judging_Submission_Type_ManyArgs = {
  updates: Array<Project_Judging_Submission_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_JudgmentsArgs = {
  _append?: InputMaybe<Project_Judgments_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Judgments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Judgments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Judgments_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Judgments_Inc_Input>;
  _prepend?: InputMaybe<Project_Judgments_Prepend_Input>;
  _set?: InputMaybe<Project_Judgments_Set_Input>;
  where: Project_Judgments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Judgments_By_PkArgs = {
  _append?: InputMaybe<Project_Judgments_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Judgments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Judgments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Judgments_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Judgments_Inc_Input>;
  _prepend?: InputMaybe<Project_Judgments_Prepend_Input>;
  _set?: InputMaybe<Project_Judgments_Set_Input>;
  pk_columns: Project_Judgments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Judgments_ManyArgs = {
  updates: Array<Project_Judgments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Report_TypeArgs = {
  _set?: InputMaybe<Project_Report_Type_Set_Input>;
  where: Project_Report_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Report_Type_By_PkArgs = {
  _set?: InputMaybe<Project_Report_Type_Set_Input>;
  pk_columns: Project_Report_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Report_Type_ManyArgs = {
  updates: Array<Project_Report_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ReportsArgs = {
  _inc?: InputMaybe<Project_Reports_Inc_Input>;
  _set?: InputMaybe<Project_Reports_Set_Input>;
  where: Project_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Reports_By_PkArgs = {
  _inc?: InputMaybe<Project_Reports_Inc_Input>;
  _set?: InputMaybe<Project_Reports_Set_Input>;
  pk_columns: Project_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Reports_ManyArgs = {
  updates: Array<Project_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_TracksArgs = {
  _inc?: InputMaybe<Project_Tracks_Inc_Input>;
  _set?: InputMaybe<Project_Tracks_Set_Input>;
  where: Project_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Tracks_By_PkArgs = {
  _inc?: InputMaybe<Project_Tracks_Inc_Input>;
  _set?: InputMaybe<Project_Tracks_Set_Input>;
  pk_columns: Project_Tracks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Tracks_ManyArgs = {
  updates: Array<Project_Tracks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectsArgs = {
  _append?: InputMaybe<Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Projects_Delete_Key_Input>;
  _inc?: InputMaybe<Projects_Inc_Input>;
  _prepend?: InputMaybe<Projects_Prepend_Input>;
  _set?: InputMaybe<Projects_Set_Input>;
  where: Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_By_PkArgs = {
  _append?: InputMaybe<Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Projects_Delete_Key_Input>;
  _inc?: InputMaybe<Projects_Inc_Input>;
  _prepend?: InputMaybe<Projects_Prepend_Input>;
  _set?: InputMaybe<Projects_Set_Input>;
  pk_columns: Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_FundingArgs = {
  _inc?: InputMaybe<Projects_Funding_Inc_Input>;
  _set?: InputMaybe<Projects_Funding_Set_Input>;
  where: Projects_Funding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_Funding_By_PkArgs = {
  _inc?: InputMaybe<Projects_Funding_Inc_Input>;
  _set?: InputMaybe<Projects_Funding_Set_Input>;
  pk_columns: Projects_Funding_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_Funding_ManyArgs = {
  updates: Array<Projects_Funding_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_ManyArgs = {
  updates: Array<Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_VotingArgs = {
  _append?: InputMaybe<Quadratic_Voting_Append_Input>;
  _delete_at_path?: InputMaybe<Quadratic_Voting_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quadratic_Voting_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quadratic_Voting_Delete_Key_Input>;
  _inc?: InputMaybe<Quadratic_Voting_Inc_Input>;
  _prepend?: InputMaybe<Quadratic_Voting_Prepend_Input>;
  _set?: InputMaybe<Quadratic_Voting_Set_Input>;
  where: Quadratic_Voting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_By_PkArgs = {
  _append?: InputMaybe<Quadratic_Voting_Append_Input>;
  _delete_at_path?: InputMaybe<Quadratic_Voting_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quadratic_Voting_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quadratic_Voting_Delete_Key_Input>;
  _inc?: InputMaybe<Quadratic_Voting_Inc_Input>;
  _prepend?: InputMaybe<Quadratic_Voting_Prepend_Input>;
  _set?: InputMaybe<Quadratic_Voting_Set_Input>;
  pk_columns: Quadratic_Voting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_ChainArgs = {
  _set?: InputMaybe<Quadratic_Voting_Chain_Set_Input>;
  where: Quadratic_Voting_Chain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Chain_By_PkArgs = {
  _set?: InputMaybe<Quadratic_Voting_Chain_Set_Input>;
  pk_columns: Quadratic_Voting_Chain_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Chain_ManyArgs = {
  updates: Array<Quadratic_Voting_Chain_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_CurrencyArgs = {
  _set?: InputMaybe<Quadratic_Voting_Currency_Set_Input>;
  where: Quadratic_Voting_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Currency_By_PkArgs = {
  _set?: InputMaybe<Quadratic_Voting_Currency_Set_Input>;
  pk_columns: Quadratic_Voting_Currency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Currency_ManyArgs = {
  updates: Array<Quadratic_Voting_Currency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_ManyArgs = {
  updates: Array<Quadratic_Voting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_ProjectsArgs = {
  _inc?: InputMaybe<Quadratic_Voting_Projects_Inc_Input>;
  _set?: InputMaybe<Quadratic_Voting_Projects_Set_Input>;
  where: Quadratic_Voting_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Projects_By_PkArgs = {
  _inc?: InputMaybe<Quadratic_Voting_Projects_Inc_Input>;
  _set?: InputMaybe<Quadratic_Voting_Projects_Set_Input>;
  pk_columns: Quadratic_Voting_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Projects_ManyArgs = {
  updates: Array<Quadratic_Voting_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Request_AccessArgs = {
  _inc?: InputMaybe<Quadratic_Voting_Request_Access_Inc_Input>;
  _set?: InputMaybe<Quadratic_Voting_Request_Access_Set_Input>;
  where: Quadratic_Voting_Request_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Request_Access_By_PkArgs = {
  _inc?: InputMaybe<Quadratic_Voting_Request_Access_Inc_Input>;
  _set?: InputMaybe<Quadratic_Voting_Request_Access_Set_Input>;
  pk_columns: Quadratic_Voting_Request_Access_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Request_Access_ManyArgs = {
  updates: Array<Quadratic_Voting_Request_Access_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Request_Access_StatusArgs = {
  _set?: InputMaybe<Quadratic_Voting_Request_Access_Status_Set_Input>;
  where: Quadratic_Voting_Request_Access_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Request_Access_Status_By_PkArgs = {
  _set?: InputMaybe<Quadratic_Voting_Request_Access_Status_Set_Input>;
  pk_columns: Quadratic_Voting_Request_Access_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quadratic_Voting_Request_Access_Status_ManyArgs = {
  updates: Array<Quadratic_Voting_Request_Access_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _inc?: InputMaybe<Roles_Inc_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _inc?: InputMaybe<Roles_Inc_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgs = {
  updates: Array<Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Room_JudgesArgs = {
  _inc?: InputMaybe<Room_Judges_Inc_Input>;
  _set?: InputMaybe<Room_Judges_Set_Input>;
  where: Room_Judges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Room_Judges_By_PkArgs = {
  _inc?: InputMaybe<Room_Judges_Inc_Input>;
  _set?: InputMaybe<Room_Judges_Set_Input>;
  pk_columns: Room_Judges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Room_Judges_ManyArgs = {
  updates: Array<Room_Judges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Schwag_TracksArgs = {
  _inc?: InputMaybe<Schwag_Tracks_Inc_Input>;
  _set?: InputMaybe<Schwag_Tracks_Set_Input>;
  where: Schwag_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Schwag_Tracks_By_PkArgs = {
  _inc?: InputMaybe<Schwag_Tracks_Inc_Input>;
  _set?: InputMaybe<Schwag_Tracks_Set_Input>;
  pk_columns: Schwag_Tracks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Schwag_Tracks_ManyArgs = {
  updates: Array<Schwag_Tracks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Schwags_Allowed_Org_Winner_CountArgs = {
  _inc?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Inc_Input>;
  _set?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Set_Input>;
  where: Schwags_Allowed_Org_Winner_Count_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Schwags_Allowed_Org_Winner_Count_ManyArgs = {
  updates: Array<Schwags_Allowed_Org_Winner_Count_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_CountriesArgs = {
  _inc?: InputMaybe<Shop_Countries_Inc_Input>;
  _set?: InputMaybe<Shop_Countries_Set_Input>;
  where: Shop_Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Countries_By_PkArgs = {
  _inc?: InputMaybe<Shop_Countries_Inc_Input>;
  _set?: InputMaybe<Shop_Countries_Set_Input>;
  pk_columns: Shop_Countries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Countries_ManyArgs = {
  updates: Array<Shop_Countries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Coupon_Discount_TypeArgs = {
  _set?: InputMaybe<Shop_Coupon_Discount_Type_Set_Input>;
  where: Shop_Coupon_Discount_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Coupon_Discount_Type_By_PkArgs = {
  _set?: InputMaybe<Shop_Coupon_Discount_Type_Set_Input>;
  pk_columns: Shop_Coupon_Discount_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Coupon_Discount_Type_ManyArgs = {
  updates: Array<Shop_Coupon_Discount_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Coupon_TypeArgs = {
  _set?: InputMaybe<Shop_Coupon_Type_Set_Input>;
  where: Shop_Coupon_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Coupon_Type_By_PkArgs = {
  _set?: InputMaybe<Shop_Coupon_Type_Set_Input>;
  pk_columns: Shop_Coupon_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Coupon_Type_ManyArgs = {
  updates: Array<Shop_Coupon_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_CouponsArgs = {
  _inc?: InputMaybe<Shop_Coupons_Inc_Input>;
  _set?: InputMaybe<Shop_Coupons_Set_Input>;
  where: Shop_Coupons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Coupons_By_PkArgs = {
  _inc?: InputMaybe<Shop_Coupons_Inc_Input>;
  _set?: InputMaybe<Shop_Coupons_Set_Input>;
  pk_columns: Shop_Coupons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Coupons_ManyArgs = {
  updates: Array<Shop_Coupons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_HsnArgs = {
  _inc?: InputMaybe<Shop_Hsn_Inc_Input>;
  _set?: InputMaybe<Shop_Hsn_Set_Input>;
  where: Shop_Hsn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Hsn_By_PkArgs = {
  _inc?: InputMaybe<Shop_Hsn_Inc_Input>;
  _set?: InputMaybe<Shop_Hsn_Set_Input>;
  pk_columns: Shop_Hsn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Hsn_ManyArgs = {
  updates: Array<Shop_Hsn_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Hsn_MappingsArgs = {
  _inc?: InputMaybe<Shop_Hsn_Mappings_Inc_Input>;
  _set?: InputMaybe<Shop_Hsn_Mappings_Set_Input>;
  where: Shop_Hsn_Mappings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Hsn_Mappings_By_PkArgs = {
  _inc?: InputMaybe<Shop_Hsn_Mappings_Inc_Input>;
  _set?: InputMaybe<Shop_Hsn_Mappings_Set_Input>;
  pk_columns: Shop_Hsn_Mappings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Hsn_Mappings_ManyArgs = {
  updates: Array<Shop_Hsn_Mappings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Inventory_SkusArgs = {
  _inc?: InputMaybe<Shop_Inventory_Skus_Inc_Input>;
  _set?: InputMaybe<Shop_Inventory_Skus_Set_Input>;
  where: Shop_Inventory_Skus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Inventory_Skus_By_PkArgs = {
  _inc?: InputMaybe<Shop_Inventory_Skus_Inc_Input>;
  _set?: InputMaybe<Shop_Inventory_Skus_Set_Input>;
  pk_columns: Shop_Inventory_Skus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Inventory_Skus_ManyArgs = {
  updates: Array<Shop_Inventory_Skus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Order_Payment_StatusArgs = {
  _set?: InputMaybe<Shop_Order_Payment_Status_Set_Input>;
  where: Shop_Order_Payment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Order_Payment_Status_By_PkArgs = {
  _set?: InputMaybe<Shop_Order_Payment_Status_Set_Input>;
  pk_columns: Shop_Order_Payment_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Order_Payment_Status_ManyArgs = {
  updates: Array<Shop_Order_Payment_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Order_ProductsArgs = {
  _append?: InputMaybe<Shop_Order_Products_Append_Input>;
  _delete_at_path?: InputMaybe<Shop_Order_Products_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shop_Order_Products_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shop_Order_Products_Delete_Key_Input>;
  _inc?: InputMaybe<Shop_Order_Products_Inc_Input>;
  _prepend?: InputMaybe<Shop_Order_Products_Prepend_Input>;
  _set?: InputMaybe<Shop_Order_Products_Set_Input>;
  where: Shop_Order_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Order_Products_By_PkArgs = {
  _append?: InputMaybe<Shop_Order_Products_Append_Input>;
  _delete_at_path?: InputMaybe<Shop_Order_Products_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shop_Order_Products_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shop_Order_Products_Delete_Key_Input>;
  _inc?: InputMaybe<Shop_Order_Products_Inc_Input>;
  _prepend?: InputMaybe<Shop_Order_Products_Prepend_Input>;
  _set?: InputMaybe<Shop_Order_Products_Set_Input>;
  pk_columns: Shop_Order_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Order_Products_ManyArgs = {
  updates: Array<Shop_Order_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_OrdersArgs = {
  _append?: InputMaybe<Shop_Orders_Append_Input>;
  _delete_at_path?: InputMaybe<Shop_Orders_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shop_Orders_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shop_Orders_Delete_Key_Input>;
  _inc?: InputMaybe<Shop_Orders_Inc_Input>;
  _prepend?: InputMaybe<Shop_Orders_Prepend_Input>;
  _set?: InputMaybe<Shop_Orders_Set_Input>;
  where: Shop_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Orders_By_PkArgs = {
  _append?: InputMaybe<Shop_Orders_Append_Input>;
  _delete_at_path?: InputMaybe<Shop_Orders_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shop_Orders_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shop_Orders_Delete_Key_Input>;
  _inc?: InputMaybe<Shop_Orders_Inc_Input>;
  _prepend?: InputMaybe<Shop_Orders_Prepend_Input>;
  _set?: InputMaybe<Shop_Orders_Set_Input>;
  pk_columns: Shop_Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Orders_ManyArgs = {
  updates: Array<Shop_Orders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Product_TypeArgs = {
  _set?: InputMaybe<Shop_Product_Type_Set_Input>;
  where: Shop_Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Product_Type_By_PkArgs = {
  _set?: InputMaybe<Shop_Product_Type_Set_Input>;
  pk_columns: Shop_Product_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Product_Type_ManyArgs = {
  updates: Array<Shop_Product_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_ProductsArgs = {
  _inc?: InputMaybe<Shop_Products_Inc_Input>;
  _set?: InputMaybe<Shop_Products_Set_Input>;
  where: Shop_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Products_By_PkArgs = {
  _inc?: InputMaybe<Shop_Products_Inc_Input>;
  _set?: InputMaybe<Shop_Products_Set_Input>;
  pk_columns: Shop_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Products_ManyArgs = {
  updates: Array<Shop_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Shipping_AddressesArgs = {
  _inc?: InputMaybe<Shop_Shipping_Addresses_Inc_Input>;
  _set?: InputMaybe<Shop_Shipping_Addresses_Set_Input>;
  where: Shop_Shipping_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Shipping_Addresses_By_PkArgs = {
  _inc?: InputMaybe<Shop_Shipping_Addresses_Inc_Input>;
  _set?: InputMaybe<Shop_Shipping_Addresses_Set_Input>;
  pk_columns: Shop_Shipping_Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_Shipping_Addresses_ManyArgs = {
  updates: Array<Shop_Shipping_Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_StatesArgs = {
  _inc?: InputMaybe<Shop_States_Inc_Input>;
  _set?: InputMaybe<Shop_States_Set_Input>;
  where: Shop_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_States_By_PkArgs = {
  _inc?: InputMaybe<Shop_States_Inc_Input>;
  _set?: InputMaybe<Shop_States_Set_Input>;
  pk_columns: Shop_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shop_States_ManyArgs = {
  updates: Array<Shop_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SkillsArgs = {
  _inc?: InputMaybe<Skills_Inc_Input>;
  _set?: InputMaybe<Skills_Set_Input>;
  where: Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skills_By_PkArgs = {
  _inc?: InputMaybe<Skills_Inc_Input>;
  _set?: InputMaybe<Skills_Set_Input>;
  pk_columns: Skills_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Skills_ManyArgs = {
  updates: Array<Skills_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Speaker_Slot_StatusArgs = {
  _set?: InputMaybe<Speaker_Slot_Status_Set_Input>;
  where: Speaker_Slot_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Speaker_Slot_Status_By_PkArgs = {
  _set?: InputMaybe<Speaker_Slot_Status_Set_Input>;
  pk_columns: Speaker_Slot_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Speaker_Slot_Status_ManyArgs = {
  updates: Array<Speaker_Slot_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsor_JudgmentsArgs = {
  _inc?: InputMaybe<Sponsor_Judgments_Inc_Input>;
  _set?: InputMaybe<Sponsor_Judgments_Set_Input>;
  where: Sponsor_Judgments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsor_Judgments_By_PkArgs = {
  _inc?: InputMaybe<Sponsor_Judgments_Inc_Input>;
  _set?: InputMaybe<Sponsor_Judgments_Set_Input>;
  pk_columns: Sponsor_Judgments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsor_Judgments_ManyArgs = {
  updates: Array<Sponsor_Judgments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsor_TiersArgs = {
  _inc?: InputMaybe<Sponsor_Tiers_Inc_Input>;
  _set?: InputMaybe<Sponsor_Tiers_Set_Input>;
  where: Sponsor_Tiers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsor_Tiers_By_PkArgs = {
  _inc?: InputMaybe<Sponsor_Tiers_Inc_Input>;
  _set?: InputMaybe<Sponsor_Tiers_Set_Input>;
  pk_columns: Sponsor_Tiers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsor_Tiers_ManyArgs = {
  updates: Array<Sponsor_Tiers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SponsorsArgs = {
  _inc?: InputMaybe<Sponsors_Inc_Input>;
  _set?: InputMaybe<Sponsors_Set_Input>;
  where: Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsors_By_PkArgs = {
  _inc?: InputMaybe<Sponsors_Inc_Input>;
  _set?: InputMaybe<Sponsors_Set_Input>;
  pk_columns: Sponsors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsors_ManyArgs = {
  updates: Array<Sponsors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StickersArgs = {
  _inc?: InputMaybe<Stickers_Inc_Input>;
  _set?: InputMaybe<Stickers_Set_Input>;
  where: Stickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stickers_By_PkArgs = {
  _inc?: InputMaybe<Stickers_Inc_Input>;
  _set?: InputMaybe<Stickers_Set_Input>;
  pk_columns: Stickers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stickers_ManyArgs = {
  updates: Array<Stickers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sumsub_ApplicantsArgs = {
  _append?: InputMaybe<Sumsub_Applicants_Append_Input>;
  _delete_at_path?: InputMaybe<Sumsub_Applicants_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sumsub_Applicants_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sumsub_Applicants_Delete_Key_Input>;
  _inc?: InputMaybe<Sumsub_Applicants_Inc_Input>;
  _prepend?: InputMaybe<Sumsub_Applicants_Prepend_Input>;
  _set?: InputMaybe<Sumsub_Applicants_Set_Input>;
  where: Sumsub_Applicants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sumsub_Applicants_By_PkArgs = {
  _append?: InputMaybe<Sumsub_Applicants_Append_Input>;
  _delete_at_path?: InputMaybe<Sumsub_Applicants_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sumsub_Applicants_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sumsub_Applicants_Delete_Key_Input>;
  _inc?: InputMaybe<Sumsub_Applicants_Inc_Input>;
  _prepend?: InputMaybe<Sumsub_Applicants_Prepend_Input>;
  _set?: InputMaybe<Sumsub_Applicants_Set_Input>;
  pk_columns: Sumsub_Applicants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sumsub_Applicants_ManyArgs = {
  updates: Array<Sumsub_Applicants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sumsub_Applicants_Review_StatusArgs = {
  _set?: InputMaybe<Sumsub_Applicants_Review_Status_Set_Input>;
  where: Sumsub_Applicants_Review_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sumsub_Applicants_Review_Status_By_PkArgs = {
  _set?: InputMaybe<Sumsub_Applicants_Review_Status_Set_Input>;
  pk_columns: Sumsub_Applicants_Review_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sumsub_Applicants_Review_Status_ManyArgs = {
  updates: Array<Sumsub_Applicants_Review_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Synaps_Kyc_Session_StatusArgs = {
  _set?: InputMaybe<Synaps_Kyc_Session_Status_Set_Input>;
  where: Synaps_Kyc_Session_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Synaps_Kyc_Session_Status_By_PkArgs = {
  _set?: InputMaybe<Synaps_Kyc_Session_Status_Set_Input>;
  pk_columns: Synaps_Kyc_Session_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Synaps_Kyc_Session_Status_ManyArgs = {
  updates: Array<Synaps_Kyc_Session_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Synaps_Kyc_SessionsArgs = {
  _append?: InputMaybe<Synaps_Kyc_Sessions_Append_Input>;
  _delete_at_path?: InputMaybe<Synaps_Kyc_Sessions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Synaps_Kyc_Sessions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Synaps_Kyc_Sessions_Delete_Key_Input>;
  _inc?: InputMaybe<Synaps_Kyc_Sessions_Inc_Input>;
  _prepend?: InputMaybe<Synaps_Kyc_Sessions_Prepend_Input>;
  _set?: InputMaybe<Synaps_Kyc_Sessions_Set_Input>;
  where: Synaps_Kyc_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Synaps_Kyc_Sessions_By_PkArgs = {
  _append?: InputMaybe<Synaps_Kyc_Sessions_Append_Input>;
  _delete_at_path?: InputMaybe<Synaps_Kyc_Sessions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Synaps_Kyc_Sessions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Synaps_Kyc_Sessions_Delete_Key_Input>;
  _inc?: InputMaybe<Synaps_Kyc_Sessions_Inc_Input>;
  _prepend?: InputMaybe<Synaps_Kyc_Sessions_Prepend_Input>;
  _set?: InputMaybe<Synaps_Kyc_Sessions_Set_Input>;
  pk_columns: Synaps_Kyc_Sessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Synaps_Kyc_Sessions_ManyArgs = {
  updates: Array<Synaps_Kyc_Sessions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeamsArgs = {
  _inc?: InputMaybe<Teams_Inc_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_By_PkArgs = {
  _inc?: InputMaybe<Teams_Inc_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  pk_columns: Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_ManyArgs = {
  updates: Array<Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ThemesArgs = {
  _inc?: InputMaybe<Themes_Inc_Input>;
  _set?: InputMaybe<Themes_Set_Input>;
  where: Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Themes_By_PkArgs = {
  _inc?: InputMaybe<Themes_Inc_Input>;
  _set?: InputMaybe<Themes_Set_Input>;
  pk_columns: Themes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Themes_ManyArgs = {
  updates: Array<Themes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Twitter_CardsArgs = {
  _inc?: InputMaybe<Twitter_Cards_Inc_Input>;
  _set?: InputMaybe<Twitter_Cards_Set_Input>;
  where: Twitter_Cards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Twitter_Cards_By_PkArgs = {
  _inc?: InputMaybe<Twitter_Cards_Inc_Input>;
  _set?: InputMaybe<Twitter_Cards_Set_Input>;
  pk_columns: Twitter_Cards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Twitter_Cards_ManyArgs = {
  updates: Array<Twitter_Cards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Api_TokensArgs = {
  _inc?: InputMaybe<User_Api_Tokens_Inc_Input>;
  _set?: InputMaybe<User_Api_Tokens_Set_Input>;
  where: User_Api_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Api_Tokens_By_PkArgs = {
  _inc?: InputMaybe<User_Api_Tokens_Inc_Input>;
  _set?: InputMaybe<User_Api_Tokens_Set_Input>;
  pk_columns: User_Api_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Api_Tokens_ManyArgs = {
  updates: Array<User_Api_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_CommentsArgs = {
  _inc?: InputMaybe<User_Comments_Inc_Input>;
  _set?: InputMaybe<User_Comments_Set_Input>;
  where: User_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Comments_By_PkArgs = {
  _inc?: InputMaybe<User_Comments_Inc_Input>;
  _set?: InputMaybe<User_Comments_Set_Input>;
  pk_columns: User_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Comments_ManyArgs = {
  updates: Array<User_Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ExtrasArgs = {
  _append?: InputMaybe<User_Extras_Append_Input>;
  _delete_at_path?: InputMaybe<User_Extras_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Extras_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Extras_Delete_Key_Input>;
  _inc?: InputMaybe<User_Extras_Inc_Input>;
  _prepend?: InputMaybe<User_Extras_Prepend_Input>;
  _set?: InputMaybe<User_Extras_Set_Input>;
  where: User_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Extras_By_PkArgs = {
  _append?: InputMaybe<User_Extras_Append_Input>;
  _delete_at_path?: InputMaybe<User_Extras_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Extras_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Extras_Delete_Key_Input>;
  _inc?: InputMaybe<User_Extras_Inc_Input>;
  _prepend?: InputMaybe<User_Extras_Prepend_Input>;
  _set?: InputMaybe<User_Extras_Set_Input>;
  pk_columns: User_Extras_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Extras_ManyArgs = {
  updates: Array<User_Extras_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feature_FlagsArgs = {
  _inc?: InputMaybe<User_Feature_Flags_Inc_Input>;
  _set?: InputMaybe<User_Feature_Flags_Set_Input>;
  where: User_Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feature_Flags_By_PkArgs = {
  _inc?: InputMaybe<User_Feature_Flags_Inc_Input>;
  _set?: InputMaybe<User_Feature_Flags_Set_Input>;
  pk_columns: User_Feature_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feature_Flags_ManyArgs = {
  updates: Array<User_Feature_Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_BountiesArgs = {
  _append?: InputMaybe<User_Hackathon_Bounties_Append_Input>;
  _delete_at_path?: InputMaybe<User_Hackathon_Bounties_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Hackathon_Bounties_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Hackathon_Bounties_Delete_Key_Input>;
  _inc?: InputMaybe<User_Hackathon_Bounties_Inc_Input>;
  _prepend?: InputMaybe<User_Hackathon_Bounties_Prepend_Input>;
  _set?: InputMaybe<User_Hackathon_Bounties_Set_Input>;
  where: User_Hackathon_Bounties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_Bounty_TypeArgs = {
  _set?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Set_Input>;
  where: User_Hackathon_Bounties_Bounty_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_Bounty_Type_By_PkArgs = {
  _set?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Set_Input>;
  pk_columns: User_Hackathon_Bounties_Bounty_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_Bounty_Type_ManyArgs = {
  updates: Array<User_Hackathon_Bounties_Bounty_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_By_PkArgs = {
  _append?: InputMaybe<User_Hackathon_Bounties_Append_Input>;
  _delete_at_path?: InputMaybe<User_Hackathon_Bounties_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Hackathon_Bounties_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Hackathon_Bounties_Delete_Key_Input>;
  _inc?: InputMaybe<User_Hackathon_Bounties_Inc_Input>;
  _prepend?: InputMaybe<User_Hackathon_Bounties_Prepend_Input>;
  _set?: InputMaybe<User_Hackathon_Bounties_Set_Input>;
  pk_columns: User_Hackathon_Bounties_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_CurrencyArgs = {
  _set?: InputMaybe<User_Hackathon_Bounties_Currency_Set_Input>;
  where: User_Hackathon_Bounties_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_Currency_By_PkArgs = {
  _set?: InputMaybe<User_Hackathon_Bounties_Currency_Set_Input>;
  pk_columns: User_Hackathon_Bounties_Currency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_Currency_ManyArgs = {
  updates: Array<User_Hackathon_Bounties_Currency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_ManyArgs = {
  updates: Array<User_Hackathon_Bounties_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_StatusArgs = {
  _set?: InputMaybe<User_Hackathon_Bounties_Status_Set_Input>;
  where: User_Hackathon_Bounties_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_Status_By_PkArgs = {
  _set?: InputMaybe<User_Hackathon_Bounties_Status_Set_Input>;
  pk_columns: User_Hackathon_Bounties_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_Status_ManyArgs = {
  updates: Array<User_Hackathon_Bounties_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_TypeArgs = {
  _set?: InputMaybe<User_Hackathon_Bounties_Type_Set_Input>;
  where: User_Hackathon_Bounties_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_Type_By_PkArgs = {
  _set?: InputMaybe<User_Hackathon_Bounties_Type_Set_Input>;
  pk_columns: User_Hackathon_Bounties_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Bounties_Type_ManyArgs = {
  updates: Array<User_Hackathon_Bounties_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_ChecklistsArgs = {
  _inc?: InputMaybe<User_Hackathon_Checklists_Inc_Input>;
  _set?: InputMaybe<User_Hackathon_Checklists_Set_Input>;
  where: User_Hackathon_Checklists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Checklists_By_PkArgs = {
  _inc?: InputMaybe<User_Hackathon_Checklists_Inc_Input>;
  _set?: InputMaybe<User_Hackathon_Checklists_Set_Input>;
  pk_columns: User_Hackathon_Checklists_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Checklists_ManyArgs = {
  updates: Array<User_Hackathon_Checklists_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_CredentialsArgs = {
  _append?: InputMaybe<User_Hackathon_Credentials_Append_Input>;
  _delete_at_path?: InputMaybe<User_Hackathon_Credentials_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Hackathon_Credentials_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Hackathon_Credentials_Delete_Key_Input>;
  _inc?: InputMaybe<User_Hackathon_Credentials_Inc_Input>;
  _prepend?: InputMaybe<User_Hackathon_Credentials_Prepend_Input>;
  _set?: InputMaybe<User_Hackathon_Credentials_Set_Input>;
  where: User_Hackathon_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Credentials_By_PkArgs = {
  _append?: InputMaybe<User_Hackathon_Credentials_Append_Input>;
  _delete_at_path?: InputMaybe<User_Hackathon_Credentials_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Hackathon_Credentials_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Hackathon_Credentials_Delete_Key_Input>;
  _inc?: InputMaybe<User_Hackathon_Credentials_Inc_Input>;
  _prepend?: InputMaybe<User_Hackathon_Credentials_Prepend_Input>;
  _set?: InputMaybe<User_Hackathon_Credentials_Set_Input>;
  pk_columns: User_Hackathon_Credentials_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Credentials_ManyArgs = {
  updates: Array<User_Hackathon_Credentials_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Credentials_StatusArgs = {
  _set?: InputMaybe<User_Hackathon_Credentials_Status_Set_Input>;
  where: User_Hackathon_Credentials_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Credentials_Status_By_PkArgs = {
  _set?: InputMaybe<User_Hackathon_Credentials_Status_Set_Input>;
  pk_columns: User_Hackathon_Credentials_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Credentials_Status_ManyArgs = {
  updates: Array<User_Hackathon_Credentials_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_ExtrasArgs = {
  _inc?: InputMaybe<User_Hackathon_Extras_Inc_Input>;
  _set?: InputMaybe<User_Hackathon_Extras_Set_Input>;
  where: User_Hackathon_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Extras_By_PkArgs = {
  _inc?: InputMaybe<User_Hackathon_Extras_Inc_Input>;
  _set?: InputMaybe<User_Hackathon_Extras_Set_Input>;
  pk_columns: User_Hackathon_Extras_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Extras_ManyArgs = {
  updates: Array<User_Hackathon_Extras_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_FeedbacksArgs = {
  _inc?: InputMaybe<User_Hackathon_Feedbacks_Inc_Input>;
  _set?: InputMaybe<User_Hackathon_Feedbacks_Set_Input>;
  where: User_Hackathon_Feedbacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Feedbacks_By_PkArgs = {
  _inc?: InputMaybe<User_Hackathon_Feedbacks_Inc_Input>;
  _set?: InputMaybe<User_Hackathon_Feedbacks_Set_Input>;
  pk_columns: User_Hackathon_Feedbacks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Feedbacks_ManyArgs = {
  updates: Array<User_Hackathon_Feedbacks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_RemindersArgs = {
  _inc?: InputMaybe<User_Hackathon_Reminders_Inc_Input>;
  _set?: InputMaybe<User_Hackathon_Reminders_Set_Input>;
  where: User_Hackathon_Reminders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Reminders_By_PkArgs = {
  _inc?: InputMaybe<User_Hackathon_Reminders_Inc_Input>;
  _set?: InputMaybe<User_Hackathon_Reminders_Set_Input>;
  pk_columns: User_Hackathon_Reminders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Reminders_ManyArgs = {
  updates: Array<User_Hackathon_Reminders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_SchwagsArgs = {
  _append?: InputMaybe<User_Hackathon_Schwags_Append_Input>;
  _delete_at_path?: InputMaybe<User_Hackathon_Schwags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Hackathon_Schwags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Hackathon_Schwags_Delete_Key_Input>;
  _inc?: InputMaybe<User_Hackathon_Schwags_Inc_Input>;
  _prepend?: InputMaybe<User_Hackathon_Schwags_Prepend_Input>;
  _set?: InputMaybe<User_Hackathon_Schwags_Set_Input>;
  where: User_Hackathon_Schwags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Schwags_By_PkArgs = {
  _append?: InputMaybe<User_Hackathon_Schwags_Append_Input>;
  _delete_at_path?: InputMaybe<User_Hackathon_Schwags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Hackathon_Schwags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Hackathon_Schwags_Delete_Key_Input>;
  _inc?: InputMaybe<User_Hackathon_Schwags_Inc_Input>;
  _prepend?: InputMaybe<User_Hackathon_Schwags_Prepend_Input>;
  _set?: InputMaybe<User_Hackathon_Schwags_Set_Input>;
  pk_columns: User_Hackathon_Schwags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Schwags_ManyArgs = {
  updates: Array<User_Hackathon_Schwags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Staking_Razorpay_Payment_StatusArgs = {
  _set?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Set_Input>;
  where: User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Staking_Razorpay_Payment_Status_By_PkArgs = {
  _set?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Set_Input>;
  pk_columns: User_Hackathon_Staking_Razorpay_Payment_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Staking_Razorpay_Payment_Status_ManyArgs = {
  updates: Array<User_Hackathon_Staking_Razorpay_Payment_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Staking_StatusArgs = {
  _set?: InputMaybe<User_Hackathon_Staking_Status_Set_Input>;
  where: User_Hackathon_Staking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Staking_Status_By_PkArgs = {
  _set?: InputMaybe<User_Hackathon_Staking_Status_Set_Input>;
  pk_columns: User_Hackathon_Staking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Staking_Status_ManyArgs = {
  updates: Array<User_Hackathon_Staking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_StakingsArgs = {
  _append?: InputMaybe<User_Hackathon_Stakings_Append_Input>;
  _delete_at_path?: InputMaybe<User_Hackathon_Stakings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Hackathon_Stakings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Hackathon_Stakings_Delete_Key_Input>;
  _inc?: InputMaybe<User_Hackathon_Stakings_Inc_Input>;
  _prepend?: InputMaybe<User_Hackathon_Stakings_Prepend_Input>;
  _set?: InputMaybe<User_Hackathon_Stakings_Set_Input>;
  where: User_Hackathon_Stakings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Stakings_By_PkArgs = {
  _append?: InputMaybe<User_Hackathon_Stakings_Append_Input>;
  _delete_at_path?: InputMaybe<User_Hackathon_Stakings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Hackathon_Stakings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Hackathon_Stakings_Delete_Key_Input>;
  _inc?: InputMaybe<User_Hackathon_Stakings_Inc_Input>;
  _prepend?: InputMaybe<User_Hackathon_Stakings_Prepend_Input>;
  _set?: InputMaybe<User_Hackathon_Stakings_Set_Input>;
  pk_columns: User_Hackathon_Stakings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathon_Stakings_ManyArgs = {
  updates: Array<User_Hackathon_Stakings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_HackathonsArgs = {
  _inc?: InputMaybe<User_Hackathons_Inc_Input>;
  _set?: InputMaybe<User_Hackathons_Set_Input>;
  where: User_Hackathons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathons_By_PkArgs = {
  _inc?: InputMaybe<User_Hackathons_Inc_Input>;
  _set?: InputMaybe<User_Hackathons_Set_Input>;
  pk_columns: User_Hackathons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Hackathons_ManyArgs = {
  updates: Array<User_Hackathons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Idea_StatsArgs = {
  _inc?: InputMaybe<User_Idea_Stats_Inc_Input>;
  _set?: InputMaybe<User_Idea_Stats_Set_Input>;
  where: User_Idea_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Idea_Stats_By_PkArgs = {
  _inc?: InputMaybe<User_Idea_Stats_Inc_Input>;
  _set?: InputMaybe<User_Idea_Stats_Set_Input>;
  pk_columns: User_Idea_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Idea_Stats_ManyArgs = {
  updates: Array<User_Idea_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Kyc_StatusArgs = {
  _set?: InputMaybe<User_Kyc_Status_Set_Input>;
  where: User_Kyc_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Kyc_Status_By_PkArgs = {
  _set?: InputMaybe<User_Kyc_Status_Set_Input>;
  pk_columns: User_Kyc_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Kyc_Status_ManyArgs = {
  updates: Array<User_Kyc_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_PermissionsArgs = {
  _inc?: InputMaybe<User_Permissions_Inc_Input>;
  _set?: InputMaybe<User_Permissions_Set_Input>;
  where: User_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permissions_By_PkArgs = {
  _inc?: InputMaybe<User_Permissions_Inc_Input>;
  _set?: InputMaybe<User_Permissions_Set_Input>;
  pk_columns: User_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permissions_ManyArgs = {
  updates: Array<User_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_Rss_Feed_PlatformsArgs = {
  _set?: InputMaybe<User_Profile_Rss_Feed_Platforms_Set_Input>;
  where: User_Profile_Rss_Feed_Platforms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_Rss_Feed_Platforms_By_PkArgs = {
  _set?: InputMaybe<User_Profile_Rss_Feed_Platforms_Set_Input>;
  pk_columns: User_Profile_Rss_Feed_Platforms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_Rss_Feed_Platforms_ManyArgs = {
  updates: Array<User_Profile_Rss_Feed_Platforms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_Rss_FeedsArgs = {
  _inc?: InputMaybe<User_Profile_Rss_Feeds_Inc_Input>;
  _set?: InputMaybe<User_Profile_Rss_Feeds_Set_Input>;
  where: User_Profile_Rss_Feeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_Rss_Feeds_By_PkArgs = {
  _inc?: InputMaybe<User_Profile_Rss_Feeds_Inc_Input>;
  _set?: InputMaybe<User_Profile_Rss_Feeds_Set_Input>;
  pk_columns: User_Profile_Rss_Feeds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_Rss_Feeds_ManyArgs = {
  updates: Array<User_Profile_Rss_Feeds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProfilesArgs = {
  _inc?: InputMaybe<User_Profiles_Inc_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profiles_By_PkArgs = {
  _inc?: InputMaybe<User_Profiles_Inc_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  pk_columns: User_Profiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profiles_ManyArgs = {
  updates: Array<User_Profiles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Project_MetaArgs = {
  _inc?: InputMaybe<User_Project_Meta_Inc_Input>;
  _set?: InputMaybe<User_Project_Meta_Set_Input>;
  where: User_Project_Meta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Project_Meta_By_PkArgs = {
  _inc?: InputMaybe<User_Project_Meta_Inc_Input>;
  _set?: InputMaybe<User_Project_Meta_Set_Input>;
  pk_columns: User_Project_Meta_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Project_Meta_ManyArgs = {
  updates: Array<User_Project_Meta_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProjectsArgs = {
  _inc?: InputMaybe<User_Projects_Inc_Input>;
  _set?: InputMaybe<User_Projects_Set_Input>;
  where: User_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Projects_By_PkArgs = {
  _inc?: InputMaybe<User_Projects_Inc_Input>;
  _set?: InputMaybe<User_Projects_Set_Input>;
  pk_columns: User_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Projects_ManyArgs = {
  updates: Array<User_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Public_Profile_LayoutArgs = {
  _append?: InputMaybe<User_Public_Profile_Layout_Append_Input>;
  _delete_at_path?: InputMaybe<User_Public_Profile_Layout_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Public_Profile_Layout_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Public_Profile_Layout_Delete_Key_Input>;
  _inc?: InputMaybe<User_Public_Profile_Layout_Inc_Input>;
  _prepend?: InputMaybe<User_Public_Profile_Layout_Prepend_Input>;
  _set?: InputMaybe<User_Public_Profile_Layout_Set_Input>;
  where: User_Public_Profile_Layout_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Public_Profile_Layout_By_PkArgs = {
  _append?: InputMaybe<User_Public_Profile_Layout_Append_Input>;
  _delete_at_path?: InputMaybe<User_Public_Profile_Layout_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Public_Profile_Layout_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Public_Profile_Layout_Delete_Key_Input>;
  _inc?: InputMaybe<User_Public_Profile_Layout_Inc_Input>;
  _prepend?: InputMaybe<User_Public_Profile_Layout_Prepend_Input>;
  _set?: InputMaybe<User_Public_Profile_Layout_Set_Input>;
  pk_columns: User_Public_Profile_Layout_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Public_Profile_Layout_ManyArgs = {
  updates: Array<User_Public_Profile_Layout_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Public_Profile_ProjectsArgs = {
  _inc?: InputMaybe<User_Public_Profile_Projects_Inc_Input>;
  _set?: InputMaybe<User_Public_Profile_Projects_Set_Input>;
  where: User_Public_Profile_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Public_Profile_Projects_By_PkArgs = {
  _inc?: InputMaybe<User_Public_Profile_Projects_Inc_Input>;
  _set?: InputMaybe<User_Public_Profile_Projects_Set_Input>;
  pk_columns: User_Public_Profile_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Public_Profile_Projects_ManyArgs = {
  updates: Array<User_Public_Profile_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_RolesArgs = {
  _inc?: InputMaybe<User_Roles_Inc_Input>;
  _set?: InputMaybe<User_Roles_Set_Input>;
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_By_PkArgs = {
  _inc?: InputMaybe<User_Roles_Inc_Input>;
  _set?: InputMaybe<User_Roles_Set_Input>;
  pk_columns: User_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_ManyArgs = {
  updates: Array<User_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Saved_SearchesArgs = {
  _inc?: InputMaybe<User_Saved_Searches_Inc_Input>;
  _set?: InputMaybe<User_Saved_Searches_Set_Input>;
  where: User_Saved_Searches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Saved_Searches_By_PkArgs = {
  _inc?: InputMaybe<User_Saved_Searches_Inc_Input>;
  _set?: InputMaybe<User_Saved_Searches_Set_Input>;
  pk_columns: User_Saved_Searches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Saved_Searches_ManyArgs = {
  updates: Array<User_Saved_Searches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_SkillsArgs = {
  _inc?: InputMaybe<User_Skills_Inc_Input>;
  _set?: InputMaybe<User_Skills_Set_Input>;
  where: User_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Skills_By_PkArgs = {
  _inc?: InputMaybe<User_Skills_Inc_Input>;
  _set?: InputMaybe<User_Skills_Set_Input>;
  pk_columns: User_Skills_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Skills_ManyArgs = {
  updates: Array<User_Skills_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WinnersArgs = {
  _inc?: InputMaybe<Winners_Inc_Input>;
  _set?: InputMaybe<Winners_Set_Input>;
  where: Winners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Winners_By_PkArgs = {
  _inc?: InputMaybe<Winners_Inc_Input>;
  _set?: InputMaybe<Winners_Set_Input>;
  pk_columns: Winners_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Winners_ManyArgs = {
  updates: Array<Winners_Updates>;
};


/** mutation root */
export type Mutation_RootUpvote_CommentArgs = {
  args: Upvote_Comment_Args;
  distinct_on?: InputMaybe<Array<User_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Comments_Order_By>>;
  where?: InputMaybe<User_Comments_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootWant_IdeaArgs = {
  args: Want_Idea_Args;
  distinct_on?: InputMaybe<Array<User_Idea_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Idea_Stats_Order_By>>;
  where?: InputMaybe<User_Idea_Stats_Bool_Exp>;
};

/** This table is used as an enum table to store the types of notifications */
export type Notification_Types = {
  __typename?: 'notification_types';
  value: Scalars['String'];
};

/** aggregated selection of "notification_types" */
export type Notification_Types_Aggregate = {
  __typename?: 'notification_types_aggregate';
  aggregate?: Maybe<Notification_Types_Aggregate_Fields>;
  nodes: Array<Notification_Types>;
};

/** aggregate fields of "notification_types" */
export type Notification_Types_Aggregate_Fields = {
  __typename?: 'notification_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Types_Max_Fields>;
  min?: Maybe<Notification_Types_Min_Fields>;
};


/** aggregate fields of "notification_types" */
export type Notification_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_types". All fields are combined with a logical 'AND'. */
export type Notification_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Types_Bool_Exp>>;
  _not?: InputMaybe<Notification_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Types_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_types" */
export enum Notification_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  NotificationTypesPkey = 'notification_types_pkey'
}

export enum Notification_Types_Enum {
  BetaAnnouncements = 'BETA_ANNOUNCEMENTS',
  CommunityWide = 'COMMUNITY_WIDE',
  User = 'USER'
}

/** Boolean expression to compare columns of type "notification_types_enum". All fields are combined with logical 'AND'. */
export type Notification_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Notification_Types_Enum>;
  _in?: InputMaybe<Array<Notification_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Notification_Types_Enum>;
  _nin?: InputMaybe<Array<Notification_Types_Enum>>;
};

/** input type for inserting data into table "notification_types" */
export type Notification_Types_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_Types_Max_Fields = {
  __typename?: 'notification_types_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_Types_Min_Fields = {
  __typename?: 'notification_types_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_types" */
export type Notification_Types_Mutation_Response = {
  __typename?: 'notification_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Types>;
};

/** on_conflict condition type for table "notification_types" */
export type Notification_Types_On_Conflict = {
  constraint: Notification_Types_Constraint;
  update_columns?: Array<Notification_Types_Update_Column>;
  where?: InputMaybe<Notification_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_types". */
export type Notification_Types_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_types */
export type Notification_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "notification_types" */
export enum Notification_Types_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notification_types" */
export type Notification_Types_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_types" */
export type Notification_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Types_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_types" */
export enum Notification_Types_Update_Column {
  /** column name */
  Value = 'value'
}

export type Notification_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Types_Bool_Exp;
};

/** This table is used to store the notifications */
export type Notifications = {
  __typename?: 'notifications';
  batched: Scalars['Boolean'];
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  hidden: Scalars['Boolean'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  notification_metadata_type?: Maybe<Scalars['String']>;
  type: Notification_Types_Enum;
  unique_metadata_identifier?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};


/** This table is used to store the notifications */
export type NotificationsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

/** aggregate fields of "notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  avg?: Maybe<Notifications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
  stddev?: Maybe<Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Notifications_Sum_Fields>;
  var_pop?: Maybe<Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Notifications_Var_Samp_Fields>;
  variance?: Maybe<Notifications_Variance_Fields>;
};


/** aggregate fields of "notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Notifications_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Notifications_Avg_Fields = {
  __typename?: 'notifications_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  batched?: InputMaybe<Boolean_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  notification_metadata_type?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Notification_Types_Enum_Comparison_Exp>;
  unique_metadata_identifier?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notifications" */
export enum Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationsPkey = 'notifications_pkey',
  /** unique or primary key constraint on columns "uuid" */
  NotificationsUuidKey = 'notifications_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Notifications_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Notifications_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Notifications_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notifications" */
export type Notifications_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notifications" */
export type Notifications_Insert_Input = {
  batched?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  notification_metadata_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Notification_Types_Enum>;
  unique_metadata_identifier?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  notification_metadata_type?: Maybe<Scalars['String']>;
  unique_metadata_identifier?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  notification_metadata_type?: Maybe<Scalars['String']>;
  unique_metadata_identifier?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notifications" */
export type Notifications_Mutation_Response = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** on_conflict condition type for table "notifications" */
export type Notifications_On_Conflict = {
  constraint: Notifications_Constraint;
  update_columns?: Array<Notifications_Update_Column>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  batched?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  notification_metadata_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unique_metadata_identifier?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notifications */
export type Notifications_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Notifications_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  Batched = 'batched',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NotificationMetadataType = 'notification_metadata_type',
  /** column name */
  Type = 'type',
  /** column name */
  UniqueMetadataIdentifier = 'unique_metadata_identifier',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "notifications" */
export type Notifications_Set_Input = {
  batched?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  notification_metadata_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Notification_Types_Enum>;
  unique_metadata_identifier?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Notifications_Stddev_Fields = {
  __typename?: 'notifications_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Notifications_Stddev_Pop_Fields = {
  __typename?: 'notifications_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Notifications_Stddev_Samp_Fields = {
  __typename?: 'notifications_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  batched?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  notification_metadata_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Notification_Types_Enum>;
  unique_metadata_identifier?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Notifications_Sum_Fields = {
  __typename?: 'notifications_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "notifications" */
export enum Notifications_Update_Column {
  /** column name */
  Batched = 'batched',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NotificationMetadataType = 'notification_metadata_type',
  /** column name */
  Type = 'type',
  /** column name */
  UniqueMetadataIdentifier = 'unique_metadata_identifier',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Notifications_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Notifications_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Notifications_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Notifications_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Notifications_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notifications_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Notifications_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notifications_Var_Pop_Fields = {
  __typename?: 'notifications_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Notifications_Var_Samp_Fields = {
  __typename?: 'notifications_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Notifications_Variance_Fields = {
  __typename?: 'notifications_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "oauth" */
export type Oauth = {
  __typename?: 'oauth';
  access_token?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_primary?: Maybe<Scalars['Boolean']>;
  provider_name: Oauth_Providers_Enum;
  refresh_token?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['Int']>;
  user_info?: Maybe<Scalars['jsonb']>;
  user_info_id?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};


/** columns and relationships of "oauth" */
export type OauthUser_InfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "oauth" */
export type Oauth_Aggregate = {
  __typename?: 'oauth_aggregate';
  aggregate?: Maybe<Oauth_Aggregate_Fields>;
  nodes: Array<Oauth>;
};

export type Oauth_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Oauth_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Oauth_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Oauth_Aggregate_Bool_Exp_Count>;
};

export type Oauth_Aggregate_Bool_Exp_Bool_And = {
  arguments: Oauth_Select_Column_Oauth_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Oauth_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Oauth_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Oauth_Select_Column_Oauth_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Oauth_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Oauth_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Oauth_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Oauth_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "oauth" */
export type Oauth_Aggregate_Fields = {
  __typename?: 'oauth_aggregate_fields';
  avg?: Maybe<Oauth_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Oauth_Max_Fields>;
  min?: Maybe<Oauth_Min_Fields>;
  stddev?: Maybe<Oauth_Stddev_Fields>;
  stddev_pop?: Maybe<Oauth_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Oauth_Stddev_Samp_Fields>;
  sum?: Maybe<Oauth_Sum_Fields>;
  var_pop?: Maybe<Oauth_Var_Pop_Fields>;
  var_samp?: Maybe<Oauth_Var_Samp_Fields>;
  variance?: Maybe<Oauth_Variance_Fields>;
};


/** aggregate fields of "oauth" */
export type Oauth_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Oauth_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "oauth" */
export type Oauth_Aggregate_Order_By = {
  avg?: InputMaybe<Oauth_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Oauth_Max_Order_By>;
  min?: InputMaybe<Oauth_Min_Order_By>;
  stddev?: InputMaybe<Oauth_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Oauth_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Oauth_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Oauth_Sum_Order_By>;
  var_pop?: InputMaybe<Oauth_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Oauth_Var_Samp_Order_By>;
  variance?: InputMaybe<Oauth_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Oauth_Append_Input = {
  user_info?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "oauth" */
export type Oauth_Arr_Rel_Insert_Input = {
  data: Array<Oauth_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Oauth_On_Conflict>;
};

/** aggregate avg on columns */
export type Oauth_Avg_Fields = {
  __typename?: 'oauth_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "oauth" */
export type Oauth_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "oauth". All fields are combined with a logical 'AND'. */
export type Oauth_Bool_Exp = {
  _and?: InputMaybe<Array<Oauth_Bool_Exp>>;
  _not?: InputMaybe<Oauth_Bool_Exp>;
  _or?: InputMaybe<Array<Oauth_Bool_Exp>>;
  access_token?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  provider_name?: InputMaybe<Oauth_Providers_Enum_Comparison_Exp>;
  refresh_token?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  user_info?: InputMaybe<Jsonb_Comparison_Exp>;
  user_info_id?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "oauth" */
export enum Oauth_Constraint {
  /** unique or primary key constraint on columns "id" */
  OauthPkey = 'oauth_pkey',
  /** unique or primary key constraint on columns "user_info_id", "provider_name" */
  OauthProviderNameUserInfoIdKey = 'oauth_provider_name_user_info_id_key',
  /** unique or primary key constraint on columns "uuid" */
  OauthUuidKey = 'oauth_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Oauth_Delete_At_Path_Input = {
  user_info?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Oauth_Delete_Elem_Input = {
  user_info?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Oauth_Delete_Key_Input = {
  user_info?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "oauth" */
export type Oauth_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "oauth" */
export type Oauth_Insert_Input = {
  access_token?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  provider_name?: InputMaybe<Oauth_Providers_Enum>;
  refresh_token?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  user_info?: InputMaybe<Scalars['jsonb']>;
  user_info_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Oauth_Max_Fields = {
  __typename?: 'oauth_max_fields';
  access_token?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  user_info_id?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "oauth" */
export type Oauth_Max_Order_By = {
  access_token?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_info_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Oauth_Min_Fields = {
  __typename?: 'oauth_min_fields';
  access_token?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  user_info_id?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "oauth" */
export type Oauth_Min_Order_By = {
  access_token?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_info_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "oauth" */
export type Oauth_Mutation_Response = {
  __typename?: 'oauth_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Oauth>;
};

/** on_conflict condition type for table "oauth" */
export type Oauth_On_Conflict = {
  constraint: Oauth_Constraint;
  update_columns?: Array<Oauth_Update_Column>;
  where?: InputMaybe<Oauth_Bool_Exp>;
};

/** Ordering options when selecting data from "oauth". */
export type Oauth_Order_By = {
  access_token?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  provider_name?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_info?: InputMaybe<Order_By>;
  user_info_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: oauth */
export type Oauth_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Oauth_Prepend_Input = {
  user_info?: InputMaybe<Scalars['jsonb']>;
};

/** This table is used as an enum table to store the supported oauth providers on the platform */
export type Oauth_Providers = {
  __typename?: 'oauth_providers';
  value: Scalars['String'];
};

/** aggregated selection of "oauth_providers" */
export type Oauth_Providers_Aggregate = {
  __typename?: 'oauth_providers_aggregate';
  aggregate?: Maybe<Oauth_Providers_Aggregate_Fields>;
  nodes: Array<Oauth_Providers>;
};

/** aggregate fields of "oauth_providers" */
export type Oauth_Providers_Aggregate_Fields = {
  __typename?: 'oauth_providers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Oauth_Providers_Max_Fields>;
  min?: Maybe<Oauth_Providers_Min_Fields>;
};


/** aggregate fields of "oauth_providers" */
export type Oauth_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Oauth_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "oauth_providers". All fields are combined with a logical 'AND'. */
export type Oauth_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Oauth_Providers_Bool_Exp>>;
  _not?: InputMaybe<Oauth_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Oauth_Providers_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "oauth_providers" */
export enum Oauth_Providers_Constraint {
  /** unique or primary key constraint on columns "value" */
  OauthProvidersPkey = 'oauth_providers_pkey'
}

export enum Oauth_Providers_Enum {
  Discord = 'discord',
  Ethereum = 'ethereum',
  Github = 'github',
  Google = 'google',
  Linkedin = 'linkedin'
}

/** Boolean expression to compare columns of type "oauth_providers_enum". All fields are combined with logical 'AND'. */
export type Oauth_Providers_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Oauth_Providers_Enum>;
  _in?: InputMaybe<Array<Oauth_Providers_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Oauth_Providers_Enum>;
  _nin?: InputMaybe<Array<Oauth_Providers_Enum>>;
};

/** input type for inserting data into table "oauth_providers" */
export type Oauth_Providers_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Oauth_Providers_Max_Fields = {
  __typename?: 'oauth_providers_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Oauth_Providers_Min_Fields = {
  __typename?: 'oauth_providers_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "oauth_providers" */
export type Oauth_Providers_Mutation_Response = {
  __typename?: 'oauth_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Oauth_Providers>;
};

/** on_conflict condition type for table "oauth_providers" */
export type Oauth_Providers_On_Conflict = {
  constraint: Oauth_Providers_Constraint;
  update_columns?: Array<Oauth_Providers_Update_Column>;
  where?: InputMaybe<Oauth_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "oauth_providers". */
export type Oauth_Providers_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: oauth_providers */
export type Oauth_Providers_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "oauth_providers" */
export enum Oauth_Providers_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "oauth_providers" */
export type Oauth_Providers_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "oauth_providers" */
export type Oauth_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Oauth_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Oauth_Providers_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "oauth_providers" */
export enum Oauth_Providers_Update_Column {
  /** column name */
  Value = 'value'
}

export type Oauth_Providers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Oauth_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Oauth_Providers_Bool_Exp;
};

/** select columns of table "oauth" */
export enum Oauth_Select_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  ProviderName = 'provider_name',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  Scope = 'scope',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserInfo = 'user_info',
  /** column name */
  UserInfoId = 'user_info_id',
  /** column name */
  Uuid = 'uuid'
}

/** select "oauth_aggregate_bool_exp_bool_and_arguments_columns" columns of table "oauth" */
export enum Oauth_Select_Column_Oauth_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** select "oauth_aggregate_bool_exp_bool_or_arguments_columns" columns of table "oauth" */
export enum Oauth_Select_Column_Oauth_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** input type for updating data in table "oauth" */
export type Oauth_Set_Input = {
  access_token?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  provider_name?: InputMaybe<Oauth_Providers_Enum>;
  refresh_token?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  user_info?: InputMaybe<Scalars['jsonb']>;
  user_info_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Oauth_Stddev_Fields = {
  __typename?: 'oauth_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "oauth" */
export type Oauth_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Oauth_Stddev_Pop_Fields = {
  __typename?: 'oauth_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "oauth" */
export type Oauth_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Oauth_Stddev_Samp_Fields = {
  __typename?: 'oauth_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "oauth" */
export type Oauth_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "oauth" */
export type Oauth_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Oauth_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Oauth_Stream_Cursor_Value_Input = {
  access_token?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  provider_name?: InputMaybe<Oauth_Providers_Enum>;
  refresh_token?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  user_info?: InputMaybe<Scalars['jsonb']>;
  user_info_id?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Oauth_Sum_Fields = {
  __typename?: 'oauth_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "oauth" */
export type Oauth_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "oauth" */
export enum Oauth_Update_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  ProviderName = 'provider_name',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  Scope = 'scope',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserInfo = 'user_info',
  /** column name */
  UserInfoId = 'user_info_id',
  /** column name */
  Uuid = 'uuid'
}

export type Oauth_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Oauth_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Oauth_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Oauth_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Oauth_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Oauth_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Oauth_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Oauth_Set_Input>;
  /** filter the rows which have to be updated */
  where: Oauth_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Oauth_Var_Pop_Fields = {
  __typename?: 'oauth_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "oauth" */
export type Oauth_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Oauth_Var_Samp_Fields = {
  __typename?: 'oauth_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "oauth" */
export type Oauth_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Oauth_Variance_Fields = {
  __typename?: 'oauth_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "oauth" */
export type Oauth_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Boolean expression to compare columns of type "pc_status_enum". All fields are combined with logical 'AND'. */
export type Pc_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['pc_status_enum']>;
  _gt?: InputMaybe<Scalars['pc_status_enum']>;
  _gte?: InputMaybe<Scalars['pc_status_enum']>;
  _in?: InputMaybe<Array<Scalars['pc_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['pc_status_enum']>;
  _lte?: InputMaybe<Scalars['pc_status_enum']>;
  _neq?: InputMaybe<Scalars['pc_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['pc_status_enum']>>;
};

/** This table is used to store the permissions for organiser admin dashboard */
export type Permissions = {
  __typename?: 'permissions';
  actions?: Maybe<Scalars['_text']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  permission: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "permissions" */
export type Permissions_Aggregate = {
  __typename?: 'permissions_aggregate';
  aggregate?: Maybe<Permissions_Aggregate_Fields>;
  nodes: Array<Permissions>;
};

/** aggregate fields of "permissions" */
export type Permissions_Aggregate_Fields = {
  __typename?: 'permissions_aggregate_fields';
  avg?: Maybe<Permissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Permissions_Max_Fields>;
  min?: Maybe<Permissions_Min_Fields>;
  stddev?: Maybe<Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Permissions_Sum_Fields>;
  var_pop?: Maybe<Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Permissions_Var_Samp_Fields>;
  variance?: Maybe<Permissions_Variance_Fields>;
};


/** aggregate fields of "permissions" */
export type Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Permissions_Avg_Fields = {
  __typename?: 'permissions_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "permissions". All fields are combined with a logical 'AND'. */
export type Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Permissions_Bool_Exp>>;
  _not?: InputMaybe<Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Permissions_Bool_Exp>>;
  actions?: InputMaybe<_Text_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  permission?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "permissions" */
export enum Permissions_Constraint {
  /** unique or primary key constraint on columns "permission" */
  PermissionsPermissionKey = 'permissions_permission_key',
  /** unique or primary key constraint on columns "id" */
  PermissionsPkey = 'permissions_pkey',
  /** unique or primary key constraint on columns "uuid" */
  PermissionsUuidKey = 'permissions_uuid_key'
}

/** input type for incrementing numeric columns in table "permissions" */
export type Permissions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "permissions" */
export type Permissions_Insert_Input = {
  actions?: InputMaybe<Scalars['_text']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  permission?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Permissions_Max_Fields = {
  __typename?: 'permissions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  permission?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Permissions_Min_Fields = {
  __typename?: 'permissions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  permission?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "permissions" */
export type Permissions_Mutation_Response = {
  __typename?: 'permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Permissions>;
};

/** input type for inserting object relation for remote table "permissions" */
export type Permissions_Obj_Rel_Insert_Input = {
  data: Permissions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};

/** on_conflict condition type for table "permissions" */
export type Permissions_On_Conflict = {
  constraint: Permissions_Constraint;
  update_columns?: Array<Permissions_Update_Column>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "permissions". */
export type Permissions_Order_By = {
  actions?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: permissions */
export type Permissions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "permissions" */
export enum Permissions_Select_Column {
  /** column name */
  Actions = 'actions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Permission = 'permission',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "permissions" */
export type Permissions_Set_Input = {
  actions?: InputMaybe<Scalars['_text']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  permission?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Permissions_Stddev_Fields = {
  __typename?: 'permissions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Permissions_Stddev_Pop_Fields = {
  __typename?: 'permissions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Permissions_Stddev_Samp_Fields = {
  __typename?: 'permissions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "permissions" */
export type Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permissions_Stream_Cursor_Value_Input = {
  actions?: InputMaybe<Scalars['_text']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  permission?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Permissions_Sum_Fields = {
  __typename?: 'permissions_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "permissions" */
export enum Permissions_Update_Column {
  /** column name */
  Actions = 'actions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Permission = 'permission',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Permissions_Var_Pop_Fields = {
  __typename?: 'permissions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Permissions_Var_Samp_Fields = {
  __typename?: 'permissions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Permissions_Variance_Fields = {
  __typename?: 'permissions_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "prize_sponsors" */
export type Prize_Sponsors = {
  __typename?: 'prize_sponsors';
  created_at: Scalars['timestamptz'];
  prize_id: Scalars['Int'];
  /** An object relationship */
  sponsor?: Maybe<Sponsors>;
  sponsor_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "prize_sponsors" */
export type Prize_Sponsors_Aggregate = {
  __typename?: 'prize_sponsors_aggregate';
  aggregate?: Maybe<Prize_Sponsors_Aggregate_Fields>;
  nodes: Array<Prize_Sponsors>;
};

export type Prize_Sponsors_Aggregate_Bool_Exp = {
  count?: InputMaybe<Prize_Sponsors_Aggregate_Bool_Exp_Count>;
};

export type Prize_Sponsors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Prize_Sponsors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Prize_Sponsors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "prize_sponsors" */
export type Prize_Sponsors_Aggregate_Fields = {
  __typename?: 'prize_sponsors_aggregate_fields';
  avg?: Maybe<Prize_Sponsors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Prize_Sponsors_Max_Fields>;
  min?: Maybe<Prize_Sponsors_Min_Fields>;
  stddev?: Maybe<Prize_Sponsors_Stddev_Fields>;
  stddev_pop?: Maybe<Prize_Sponsors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prize_Sponsors_Stddev_Samp_Fields>;
  sum?: Maybe<Prize_Sponsors_Sum_Fields>;
  var_pop?: Maybe<Prize_Sponsors_Var_Pop_Fields>;
  var_samp?: Maybe<Prize_Sponsors_Var_Samp_Fields>;
  variance?: Maybe<Prize_Sponsors_Variance_Fields>;
};


/** aggregate fields of "prize_sponsors" */
export type Prize_Sponsors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prize_Sponsors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "prize_sponsors" */
export type Prize_Sponsors_Aggregate_Order_By = {
  avg?: InputMaybe<Prize_Sponsors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Prize_Sponsors_Max_Order_By>;
  min?: InputMaybe<Prize_Sponsors_Min_Order_By>;
  stddev?: InputMaybe<Prize_Sponsors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Prize_Sponsors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Prize_Sponsors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Prize_Sponsors_Sum_Order_By>;
  var_pop?: InputMaybe<Prize_Sponsors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Prize_Sponsors_Var_Samp_Order_By>;
  variance?: InputMaybe<Prize_Sponsors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "prize_sponsors" */
export type Prize_Sponsors_Arr_Rel_Insert_Input = {
  data: Array<Prize_Sponsors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Prize_Sponsors_On_Conflict>;
};

/** aggregate avg on columns */
export type Prize_Sponsors_Avg_Fields = {
  __typename?: 'prize_sponsors_avg_fields';
  prize_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Avg_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "prize_sponsors". All fields are combined with a logical 'AND'. */
export type Prize_Sponsors_Bool_Exp = {
  _and?: InputMaybe<Array<Prize_Sponsors_Bool_Exp>>;
  _not?: InputMaybe<Prize_Sponsors_Bool_Exp>;
  _or?: InputMaybe<Array<Prize_Sponsors_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  prize_id?: InputMaybe<Int_Comparison_Exp>;
  sponsor?: InputMaybe<Sponsors_Bool_Exp>;
  sponsor_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "prize_sponsors" */
export enum Prize_Sponsors_Constraint {
  /** unique or primary key constraint on columns "prize_id", "sponsor_id" */
  PrizeSponsorsPkey = 'prize_sponsors_pkey',
  /** unique or primary key constraint on columns "uuid" */
  PrizeSponsorsUuidKey = 'prize_sponsors_uuid_key'
}

/** input type for incrementing numeric columns in table "prize_sponsors" */
export type Prize_Sponsors_Inc_Input = {
  prize_id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "prize_sponsors" */
export type Prize_Sponsors_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  sponsor?: InputMaybe<Sponsors_Obj_Rel_Insert_Input>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Prize_Sponsors_Max_Fields = {
  __typename?: 'prize_sponsors_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  prize_id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Prize_Sponsors_Min_Fields = {
  __typename?: 'prize_sponsors_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  prize_id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "prize_sponsors" */
export type Prize_Sponsors_Mutation_Response = {
  __typename?: 'prize_sponsors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Prize_Sponsors>;
};

/** on_conflict condition type for table "prize_sponsors" */
export type Prize_Sponsors_On_Conflict = {
  constraint: Prize_Sponsors_Constraint;
  update_columns?: Array<Prize_Sponsors_Update_Column>;
  where?: InputMaybe<Prize_Sponsors_Bool_Exp>;
};

/** Ordering options when selecting data from "prize_sponsors". */
export type Prize_Sponsors_Order_By = {
  created_at?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  sponsor?: InputMaybe<Sponsors_Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prize_sponsors */
export type Prize_Sponsors_Pk_Columns_Input = {
  prize_id: Scalars['Int'];
  sponsor_id: Scalars['Int'];
};

/** select columns of table "prize_sponsors" */
export enum Prize_Sponsors_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "prize_sponsors" */
export type Prize_Sponsors_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Prize_Sponsors_Stddev_Fields = {
  __typename?: 'prize_sponsors_stddev_fields';
  prize_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Stddev_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Prize_Sponsors_Stddev_Pop_Fields = {
  __typename?: 'prize_sponsors_stddev_pop_fields';
  prize_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Stddev_Pop_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Prize_Sponsors_Stddev_Samp_Fields = {
  __typename?: 'prize_sponsors_stddev_samp_fields';
  prize_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Stddev_Samp_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "prize_sponsors" */
export type Prize_Sponsors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prize_Sponsors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prize_Sponsors_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Prize_Sponsors_Sum_Fields = {
  __typename?: 'prize_sponsors_sum_fields';
  prize_id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Sum_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** update columns of table "prize_sponsors" */
export enum Prize_Sponsors_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Prize_Sponsors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prize_Sponsors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prize_Sponsors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prize_Sponsors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prize_Sponsors_Var_Pop_Fields = {
  __typename?: 'prize_sponsors_var_pop_fields';
  prize_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Var_Pop_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Prize_Sponsors_Var_Samp_Fields = {
  __typename?: 'prize_sponsors_var_samp_fields';
  prize_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Var_Samp_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Prize_Sponsors_Variance_Fields = {
  __typename?: 'prize_sponsors_variance_fields';
  prize_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "prize_sponsors" */
export type Prize_Sponsors_Variance_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "prize_tracks" */
export type Prize_Tracks = {
  __typename?: 'prize_tracks';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  hackathon: Hackathons;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  no_winners_reasons?: Maybe<Scalars['_text']>;
  /** An array relationship */
  prizes: Array<Prizes>;
  /** An aggregate relationship */
  prizes_aggregate: Prizes_Aggregate;
  /** An array relationship */
  project_tracks: Array<Project_Tracks>;
  /** An aggregate relationship */
  project_tracks_aggregate: Project_Tracks_Aggregate;
  /** An object relationship */
  sponsor?: Maybe<Sponsors>;
  sponsor_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  sponsor_judgments: Array<Sponsor_Judgments>;
  /** An aggregate relationship */
  sponsor_judgments_aggregate: Sponsor_Judgments_Aggregate;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};


/** columns and relationships of "prize_tracks" */
export type Prize_TracksPrizesArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


/** columns and relationships of "prize_tracks" */
export type Prize_TracksPrizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


/** columns and relationships of "prize_tracks" */
export type Prize_TracksProject_TracksArgs = {
  distinct_on?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Tracks_Order_By>>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};


/** columns and relationships of "prize_tracks" */
export type Prize_TracksProject_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Tracks_Order_By>>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};


/** columns and relationships of "prize_tracks" */
export type Prize_TracksSponsor_JudgmentsArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


/** columns and relationships of "prize_tracks" */
export type Prize_TracksSponsor_Judgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};

/** aggregated selection of "prize_tracks" */
export type Prize_Tracks_Aggregate = {
  __typename?: 'prize_tracks_aggregate';
  aggregate?: Maybe<Prize_Tracks_Aggregate_Fields>;
  nodes: Array<Prize_Tracks>;
};

export type Prize_Tracks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Prize_Tracks_Aggregate_Bool_Exp_Count>;
};

export type Prize_Tracks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Prize_Tracks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "prize_tracks" */
export type Prize_Tracks_Aggregate_Fields = {
  __typename?: 'prize_tracks_aggregate_fields';
  avg?: Maybe<Prize_Tracks_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Prize_Tracks_Max_Fields>;
  min?: Maybe<Prize_Tracks_Min_Fields>;
  stddev?: Maybe<Prize_Tracks_Stddev_Fields>;
  stddev_pop?: Maybe<Prize_Tracks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prize_Tracks_Stddev_Samp_Fields>;
  sum?: Maybe<Prize_Tracks_Sum_Fields>;
  var_pop?: Maybe<Prize_Tracks_Var_Pop_Fields>;
  var_samp?: Maybe<Prize_Tracks_Var_Samp_Fields>;
  variance?: Maybe<Prize_Tracks_Variance_Fields>;
};


/** aggregate fields of "prize_tracks" */
export type Prize_Tracks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "prize_tracks" */
export type Prize_Tracks_Aggregate_Order_By = {
  avg?: InputMaybe<Prize_Tracks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Prize_Tracks_Max_Order_By>;
  min?: InputMaybe<Prize_Tracks_Min_Order_By>;
  stddev?: InputMaybe<Prize_Tracks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Prize_Tracks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Prize_Tracks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Prize_Tracks_Sum_Order_By>;
  var_pop?: InputMaybe<Prize_Tracks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Prize_Tracks_Var_Samp_Order_By>;
  variance?: InputMaybe<Prize_Tracks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "prize_tracks" */
export type Prize_Tracks_Arr_Rel_Insert_Input = {
  data: Array<Prize_Tracks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Prize_Tracks_On_Conflict>;
};

/** aggregate avg on columns */
export type Prize_Tracks_Avg_Fields = {
  __typename?: 'prize_tracks_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "prize_tracks" */
export type Prize_Tracks_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "prize_tracks". All fields are combined with a logical 'AND'. */
export type Prize_Tracks_Bool_Exp = {
  _and?: InputMaybe<Array<Prize_Tracks_Bool_Exp>>;
  _not?: InputMaybe<Prize_Tracks_Bool_Exp>;
  _or?: InputMaybe<Array<Prize_Tracks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  no_winners_reasons?: InputMaybe<_Text_Comparison_Exp>;
  prizes?: InputMaybe<Prizes_Bool_Exp>;
  prizes_aggregate?: InputMaybe<Prizes_Aggregate_Bool_Exp>;
  project_tracks?: InputMaybe<Project_Tracks_Bool_Exp>;
  project_tracks_aggregate?: InputMaybe<Project_Tracks_Aggregate_Bool_Exp>;
  sponsor?: InputMaybe<Sponsors_Bool_Exp>;
  sponsor_id?: InputMaybe<Int_Comparison_Exp>;
  sponsor_judgments?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
  sponsor_judgments_aggregate?: InputMaybe<Sponsor_Judgments_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "prize_tracks" */
export enum Prize_Tracks_Constraint {
  /** unique or primary key constraint on columns "id" */
  PrizeTracksPkey = 'prize_tracks_pkey',
  /** unique or primary key constraint on columns "uuid" */
  PrizeTracksUuidKey = 'prize_tracks_uuid_key'
}

/** input type for incrementing numeric columns in table "prize_tracks" */
export type Prize_Tracks_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "prize_tracks" */
export type Prize_Tracks_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  no_winners_reasons?: InputMaybe<Scalars['_text']>;
  prizes?: InputMaybe<Prizes_Arr_Rel_Insert_Input>;
  project_tracks?: InputMaybe<Project_Tracks_Arr_Rel_Insert_Input>;
  sponsor?: InputMaybe<Sponsors_Obj_Rel_Insert_Input>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  sponsor_judgments?: InputMaybe<Sponsor_Judgments_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Prize_Tracks_Max_Fields = {
  __typename?: 'prize_tracks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "prize_tracks" */
export type Prize_Tracks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Prize_Tracks_Min_Fields = {
  __typename?: 'prize_tracks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "prize_tracks" */
export type Prize_Tracks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "prize_tracks" */
export type Prize_Tracks_Mutation_Response = {
  __typename?: 'prize_tracks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Prize_Tracks>;
};

/** input type for inserting object relation for remote table "prize_tracks" */
export type Prize_Tracks_Obj_Rel_Insert_Input = {
  data: Prize_Tracks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Prize_Tracks_On_Conflict>;
};

/** on_conflict condition type for table "prize_tracks" */
export type Prize_Tracks_On_Conflict = {
  constraint: Prize_Tracks_Constraint;
  update_columns?: Array<Prize_Tracks_Update_Column>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};

/** Ordering options when selecting data from "prize_tracks". */
export type Prize_Tracks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  no_winners_reasons?: InputMaybe<Order_By>;
  prizes_aggregate?: InputMaybe<Prizes_Aggregate_Order_By>;
  project_tracks_aggregate?: InputMaybe<Project_Tracks_Aggregate_Order_By>;
  sponsor?: InputMaybe<Sponsors_Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  sponsor_judgments_aggregate?: InputMaybe<Sponsor_Judgments_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prize_tracks */
export type Prize_Tracks_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "prize_tracks" */
export enum Prize_Tracks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NoWinnersReasons = 'no_winners_reasons',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "prize_tracks" */
export type Prize_Tracks_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  no_winners_reasons?: InputMaybe<Scalars['_text']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Prize_Tracks_Stddev_Fields = {
  __typename?: 'prize_tracks_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "prize_tracks" */
export type Prize_Tracks_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Prize_Tracks_Stddev_Pop_Fields = {
  __typename?: 'prize_tracks_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "prize_tracks" */
export type Prize_Tracks_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Prize_Tracks_Stddev_Samp_Fields = {
  __typename?: 'prize_tracks_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "prize_tracks" */
export type Prize_Tracks_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "prize_tracks" */
export type Prize_Tracks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prize_Tracks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prize_Tracks_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  no_winners_reasons?: InputMaybe<Scalars['_text']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Prize_Tracks_Sum_Fields = {
  __typename?: 'prize_tracks_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "prize_tracks" */
export type Prize_Tracks_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** update columns of table "prize_tracks" */
export enum Prize_Tracks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NoWinnersReasons = 'no_winners_reasons',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Prize_Tracks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prize_Tracks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prize_Tracks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prize_Tracks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prize_Tracks_Var_Pop_Fields = {
  __typename?: 'prize_tracks_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "prize_tracks" */
export type Prize_Tracks_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Prize_Tracks_Var_Samp_Fields = {
  __typename?: 'prize_tracks_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "prize_tracks" */
export type Prize_Tracks_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Prize_Tracks_Variance_Fields = {
  __typename?: 'prize_tracks_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "prize_tracks" */
export type Prize_Tracks_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "prizes" */
export type Prizes = {
  __typename?: 'prizes';
  amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  currency?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  /** An object relationship */
  hackathon: Hackathons;
  hackathon_id: Scalars['Int'];
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  is_partner_prize: Scalars['Boolean'];
  is_sponsor_prize?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  /** An object relationship */
  parent_prize?: Maybe<Prizes>;
  parent_prize_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  prize_track?: Maybe<Prize_Tracks>;
  quantity?: Maybe<Scalars['Int']>;
  /** An array relationship */
  schwag_tracks: Array<Schwag_Tracks>;
  /** An aggregate relationship */
  schwag_tracks_aggregate: Schwag_Tracks_Aggregate;
  /** An array relationship */
  sponsor_judgments: Array<Sponsor_Judgments>;
  /** An aggregate relationship */
  sponsor_judgments_aggregate: Sponsor_Judgments_Aggregate;
  /** An array relationship */
  sponsors: Array<Prize_Sponsors>;
  /** An aggregate relationship */
  sponsors_aggregate: Prize_Sponsors_Aggregate;
  /** An array relationship */
  sub_prizes: Array<Prizes>;
  /** An aggregate relationship */
  sub_prizes_aggregate: Prizes_Aggregate;
  tagline?: Maybe<Scalars['String']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
  /** An array relationship */
  winners: Array<Winners>;
  /** An aggregate relationship */
  winners_aggregate: Winners_Aggregate;
};


/** columns and relationships of "prizes" */
export type PrizesSchwag_TracksArgs = {
  distinct_on?: InputMaybe<Array<Schwag_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwag_Tracks_Order_By>>;
  where?: InputMaybe<Schwag_Tracks_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesSchwag_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schwag_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwag_Tracks_Order_By>>;
  where?: InputMaybe<Schwag_Tracks_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesSponsor_JudgmentsArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesSponsor_Judgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Prize_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Sponsors_Order_By>>;
  where?: InputMaybe<Prize_Sponsors_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Sponsors_Order_By>>;
  where?: InputMaybe<Prize_Sponsors_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesSub_PrizesArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesSub_Prizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesWinnersArgs = {
  distinct_on?: InputMaybe<Array<Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Winners_Order_By>>;
  where?: InputMaybe<Winners_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesWinners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Winners_Order_By>>;
  where?: InputMaybe<Winners_Bool_Exp>;
};

/** aggregated selection of "prizes" */
export type Prizes_Aggregate = {
  __typename?: 'prizes_aggregate';
  aggregate?: Maybe<Prizes_Aggregate_Fields>;
  nodes: Array<Prizes>;
};

export type Prizes_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Prizes_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Prizes_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Prizes_Aggregate_Bool_Exp_Count>;
};

export type Prizes_Aggregate_Bool_Exp_Bool_And = {
  arguments: Prizes_Select_Column_Prizes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Prizes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Prizes_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Prizes_Select_Column_Prizes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Prizes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Prizes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Prizes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Prizes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "prizes" */
export type Prizes_Aggregate_Fields = {
  __typename?: 'prizes_aggregate_fields';
  avg?: Maybe<Prizes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Prizes_Max_Fields>;
  min?: Maybe<Prizes_Min_Fields>;
  stddev?: Maybe<Prizes_Stddev_Fields>;
  stddev_pop?: Maybe<Prizes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prizes_Stddev_Samp_Fields>;
  sum?: Maybe<Prizes_Sum_Fields>;
  var_pop?: Maybe<Prizes_Var_Pop_Fields>;
  var_samp?: Maybe<Prizes_Var_Samp_Fields>;
  variance?: Maybe<Prizes_Variance_Fields>;
};


/** aggregate fields of "prizes" */
export type Prizes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prizes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "prizes" */
export type Prizes_Aggregate_Order_By = {
  avg?: InputMaybe<Prizes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Prizes_Max_Order_By>;
  min?: InputMaybe<Prizes_Min_Order_By>;
  stddev?: InputMaybe<Prizes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Prizes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Prizes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Prizes_Sum_Order_By>;
  var_pop?: InputMaybe<Prizes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Prizes_Var_Samp_Order_By>;
  variance?: InputMaybe<Prizes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "prizes" */
export type Prizes_Arr_Rel_Insert_Input = {
  data: Array<Prizes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Prizes_On_Conflict>;
};

/** aggregate avg on columns */
export type Prizes_Avg_Fields = {
  __typename?: 'prizes_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_prize_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "prizes" */
export type Prizes_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "prizes". All fields are combined with a logical 'AND'. */
export type Prizes_Bool_Exp = {
  _and?: InputMaybe<Array<Prizes_Bool_Exp>>;
  _not?: InputMaybe<Prizes_Bool_Exp>;
  _or?: InputMaybe<Array<Prizes_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_partner_prize?: InputMaybe<Boolean_Comparison_Exp>;
  is_sponsor_prize?: InputMaybe<Boolean_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  parent_prize?: InputMaybe<Prizes_Bool_Exp>;
  parent_prize_id?: InputMaybe<Int_Comparison_Exp>;
  prize_track?: InputMaybe<Prize_Tracks_Bool_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  schwag_tracks?: InputMaybe<Schwag_Tracks_Bool_Exp>;
  schwag_tracks_aggregate?: InputMaybe<Schwag_Tracks_Aggregate_Bool_Exp>;
  sponsor_judgments?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
  sponsor_judgments_aggregate?: InputMaybe<Sponsor_Judgments_Aggregate_Bool_Exp>;
  sponsors?: InputMaybe<Prize_Sponsors_Bool_Exp>;
  sponsors_aggregate?: InputMaybe<Prize_Sponsors_Aggregate_Bool_Exp>;
  sub_prizes?: InputMaybe<Prizes_Bool_Exp>;
  sub_prizes_aggregate?: InputMaybe<Prizes_Aggregate_Bool_Exp>;
  tagline?: InputMaybe<String_Comparison_Exp>;
  track_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  winners?: InputMaybe<Winners_Bool_Exp>;
  winners_aggregate?: InputMaybe<Winners_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "prizes" */
export enum Prizes_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPrizes = 'pk_prizes',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidPrizes = 'unique_uuid_prizes'
}

/** input type for incrementing numeric columns in table "prizes" */
export type Prizes_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_prize_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  track_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "prizes" */
export type Prizes_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_partner_prize?: InputMaybe<Scalars['Boolean']>;
  is_sponsor_prize?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_prize?: InputMaybe<Prizes_Obj_Rel_Insert_Input>;
  parent_prize_id?: InputMaybe<Scalars['Int']>;
  prize_track?: InputMaybe<Prize_Tracks_Obj_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['Int']>;
  schwag_tracks?: InputMaybe<Schwag_Tracks_Arr_Rel_Insert_Input>;
  sponsor_judgments?: InputMaybe<Sponsor_Judgments_Arr_Rel_Insert_Input>;
  sponsors?: InputMaybe<Prize_Sponsors_Arr_Rel_Insert_Input>;
  sub_prizes?: InputMaybe<Prizes_Arr_Rel_Insert_Input>;
  tagline?: InputMaybe<Scalars['String']>;
  track_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  winners?: InputMaybe<Winners_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Prizes_Max_Fields = {
  __typename?: 'prizes_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent_prize_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  tagline?: Maybe<Scalars['String']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "prizes" */
export type Prizes_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Prizes_Min_Fields = {
  __typename?: 'prizes_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent_prize_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  tagline?: Maybe<Scalars['String']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "prizes" */
export type Prizes_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "prizes" */
export type Prizes_Mutation_Response = {
  __typename?: 'prizes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Prizes>;
};

/** input type for inserting object relation for remote table "prizes" */
export type Prizes_Obj_Rel_Insert_Input = {
  data: Prizes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Prizes_On_Conflict>;
};

/** on_conflict condition type for table "prizes" */
export type Prizes_On_Conflict = {
  constraint: Prizes_Constraint;
  update_columns?: Array<Prizes_Update_Column>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};

/** Ordering options when selecting data from "prizes". */
export type Prizes_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_partner_prize?: InputMaybe<Order_By>;
  is_sponsor_prize?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize?: InputMaybe<Prizes_Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  prize_track?: InputMaybe<Prize_Tracks_Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_tracks_aggregate?: InputMaybe<Schwag_Tracks_Aggregate_Order_By>;
  sponsor_judgments_aggregate?: InputMaybe<Sponsor_Judgments_Aggregate_Order_By>;
  sponsors_aggregate?: InputMaybe<Prize_Sponsors_Aggregate_Order_By>;
  sub_prizes_aggregate?: InputMaybe<Prizes_Aggregate_Order_By>;
  tagline?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  winners_aggregate?: InputMaybe<Winners_Aggregate_Order_By>;
};

/** primary key columns input for table: prizes */
export type Prizes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "prizes" */
export enum Prizes_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Desc = 'desc',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IsPartnerPrize = 'is_partner_prize',
  /** column name */
  IsSponsorPrize = 'is_sponsor_prize',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParentPrizeId = 'parent_prize_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  TrackId = 'track_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** select "prizes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "prizes" */
export enum Prizes_Select_Column_Prizes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsPartnerPrize = 'is_partner_prize',
  /** column name */
  IsSponsorPrize = 'is_sponsor_prize'
}

/** select "prizes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "prizes" */
export enum Prizes_Select_Column_Prizes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsPartnerPrize = 'is_partner_prize',
  /** column name */
  IsSponsorPrize = 'is_sponsor_prize'
}

/** input type for updating data in table "prizes" */
export type Prizes_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_partner_prize?: InputMaybe<Scalars['Boolean']>;
  is_sponsor_prize?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_prize_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  tagline?: InputMaybe<Scalars['String']>;
  track_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Prizes_Stddev_Fields = {
  __typename?: 'prizes_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_prize_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "prizes" */
export type Prizes_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Prizes_Stddev_Pop_Fields = {
  __typename?: 'prizes_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_prize_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "prizes" */
export type Prizes_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Prizes_Stddev_Samp_Fields = {
  __typename?: 'prizes_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_prize_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "prizes" */
export type Prizes_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "prizes" */
export type Prizes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prizes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prizes_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_partner_prize?: InputMaybe<Scalars['Boolean']>;
  is_sponsor_prize?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_prize_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  tagline?: InputMaybe<Scalars['String']>;
  track_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Prizes_Sum_Fields = {
  __typename?: 'prizes_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  parent_prize_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  track_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "prizes" */
export type Prizes_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** update columns of table "prizes" */
export enum Prizes_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Desc = 'desc',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IsPartnerPrize = 'is_partner_prize',
  /** column name */
  IsSponsorPrize = 'is_sponsor_prize',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParentPrizeId = 'parent_prize_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  TrackId = 'track_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Prizes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prizes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prizes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prizes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prizes_Var_Pop_Fields = {
  __typename?: 'prizes_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_prize_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "prizes" */
export type Prizes_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Prizes_Var_Samp_Fields = {
  __typename?: 'prizes_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_prize_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "prizes" */
export type Prizes_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Prizes_Variance_Fields = {
  __typename?: 'prizes_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_prize_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "prizes" */
export type Prizes_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_prize_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "profiles" */
export type Profiles = {
  __typename?: 'profiles';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['citext'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "profiles" */
export type Profiles_Aggregate = {
  __typename?: 'profiles_aggregate';
  aggregate?: Maybe<Profiles_Aggregate_Fields>;
  nodes: Array<Profiles>;
};

/** aggregate fields of "profiles" */
export type Profiles_Aggregate_Fields = {
  __typename?: 'profiles_aggregate_fields';
  avg?: Maybe<Profiles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Profiles_Max_Fields>;
  min?: Maybe<Profiles_Min_Fields>;
  stddev?: Maybe<Profiles_Stddev_Fields>;
  stddev_pop?: Maybe<Profiles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Profiles_Stddev_Samp_Fields>;
  sum?: Maybe<Profiles_Sum_Fields>;
  var_pop?: Maybe<Profiles_Var_Pop_Fields>;
  var_samp?: Maybe<Profiles_Var_Samp_Fields>;
  variance?: Maybe<Profiles_Variance_Fields>;
};


/** aggregate fields of "profiles" */
export type Profiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Profiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Profiles_Avg_Fields = {
  __typename?: 'profiles_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "profiles". All fields are combined with a logical 'AND'. */
export type Profiles_Bool_Exp = {
  _and?: InputMaybe<Array<Profiles_Bool_Exp>>;
  _not?: InputMaybe<Profiles_Bool_Exp>;
  _or?: InputMaybe<Array<Profiles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<Citext_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "profiles" */
export enum Profiles_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProfiles = 'pk_profiles',
  /** unique or primary key constraint on columns "name" */
  UniqueNameProfiles = 'unique_name_profiles',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidProfiles = 'unique_uuid_profiles'
}

/** input type for incrementing numeric columns in table "profiles" */
export type Profiles_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "profiles" */
export type Profiles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Profiles_Max_Fields = {
  __typename?: 'profiles_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['citext']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Profiles_Min_Fields = {
  __typename?: 'profiles_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['citext']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "profiles" */
export type Profiles_Mutation_Response = {
  __typename?: 'profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profiles>;
};

/** input type for inserting object relation for remote table "profiles" */
export type Profiles_Obj_Rel_Insert_Input = {
  data: Profiles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Profiles_On_Conflict>;
};

/** on_conflict condition type for table "profiles" */
export type Profiles_On_Conflict = {
  constraint: Profiles_Constraint;
  update_columns?: Array<Profiles_Update_Column>;
  where?: InputMaybe<Profiles_Bool_Exp>;
};

/** Ordering options when selecting data from "profiles". */
export type Profiles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: profiles */
export type Profiles_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "profiles" */
export enum Profiles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "profiles" */
export type Profiles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Profiles_Stddev_Fields = {
  __typename?: 'profiles_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Profiles_Stddev_Pop_Fields = {
  __typename?: 'profiles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Profiles_Stddev_Samp_Fields = {
  __typename?: 'profiles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "profiles" */
export type Profiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profiles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Profiles_Sum_Fields = {
  __typename?: 'profiles_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "profiles" */
export enum Profiles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Profiles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Profiles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Profiles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Profiles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Profiles_Var_Pop_Fields = {
  __typename?: 'profiles_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Profiles_Var_Samp_Fields = {
  __typename?: 'profiles_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Profiles_Variance_Fields = {
  __typename?: 'profiles_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "project_commits" */
export type Project_Commits = {
  __typename?: 'project_commits';
  commit: Scalars['String'];
  created_at: Scalars['timestamptz'];
  desc?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  project_id: Scalars['Int'];
  /** This column is used to store the state of the project at the time of the commit */
  project_state?: Maybe<Scalars['jsonb']>;
  /** This column is used to denote whether or not the project_state is available */
  state_available?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
  v2_submission_flow?: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "project_commits" */
export type Project_CommitsProject_StateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "project_commits" */
export type Project_Commits_Aggregate = {
  __typename?: 'project_commits_aggregate';
  aggregate?: Maybe<Project_Commits_Aggregate_Fields>;
  nodes: Array<Project_Commits>;
};

export type Project_Commits_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Commits_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Commits_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Commits_Aggregate_Bool_Exp_Count>;
};

export type Project_Commits_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Commits_Select_Column_Project_Commits_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Commits_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Commits_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Commits_Select_Column_Project_Commits_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Commits_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Commits_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Commits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Commits_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_commits" */
export type Project_Commits_Aggregate_Fields = {
  __typename?: 'project_commits_aggregate_fields';
  avg?: Maybe<Project_Commits_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Commits_Max_Fields>;
  min?: Maybe<Project_Commits_Min_Fields>;
  stddev?: Maybe<Project_Commits_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Commits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Commits_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Commits_Sum_Fields>;
  var_pop?: Maybe<Project_Commits_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Commits_Var_Samp_Fields>;
  variance?: Maybe<Project_Commits_Variance_Fields>;
};


/** aggregate fields of "project_commits" */
export type Project_Commits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Commits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_commits" */
export type Project_Commits_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Commits_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Commits_Max_Order_By>;
  min?: InputMaybe<Project_Commits_Min_Order_By>;
  stddev?: InputMaybe<Project_Commits_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Commits_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Commits_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Commits_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Commits_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Commits_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Commits_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Commits_Append_Input = {
  /** This column is used to store the state of the project at the time of the commit */
  project_state?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "project_commits" */
export type Project_Commits_Arr_Rel_Insert_Input = {
  data: Array<Project_Commits_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Commits_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Commits_Avg_Fields = {
  __typename?: 'project_commits_avg_fields';
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_commits" */
export type Project_Commits_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_commits". All fields are combined with a logical 'AND'. */
export type Project_Commits_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Commits_Bool_Exp>>;
  _not?: InputMaybe<Project_Commits_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Commits_Bool_Exp>>;
  commit?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  project_state?: InputMaybe<Jsonb_Comparison_Exp>;
  state_available?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  v2_submission_flow?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_commits" */
export enum Project_Commits_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProjectCommits = 'pk_project_commits',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidProjectCommits = 'unique_uuid_project_commits'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Commits_Delete_At_Path_Input = {
  /** This column is used to store the state of the project at the time of the commit */
  project_state?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Commits_Delete_Elem_Input = {
  /** This column is used to store the state of the project at the time of the commit */
  project_state?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Commits_Delete_Key_Input = {
  /** This column is used to store the state of the project at the time of the commit */
  project_state?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "project_commits" */
export type Project_Commits_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_commits" */
export type Project_Commits_Insert_Input = {
  commit?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  /** This column is used to store the state of the project at the time of the commit */
  project_state?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  v2_submission_flow?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Project_Commits_Max_Fields = {
  __typename?: 'project_commits_max_fields';
  commit?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_commits" */
export type Project_Commits_Max_Order_By = {
  commit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Commits_Min_Fields = {
  __typename?: 'project_commits_min_fields';
  commit?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_commits" */
export type Project_Commits_Min_Order_By = {
  commit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_commits" */
export type Project_Commits_Mutation_Response = {
  __typename?: 'project_commits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Commits>;
};

/** on_conflict condition type for table "project_commits" */
export type Project_Commits_On_Conflict = {
  constraint: Project_Commits_Constraint;
  update_columns?: Array<Project_Commits_Update_Column>;
  where?: InputMaybe<Project_Commits_Bool_Exp>;
};

/** Ordering options when selecting data from "project_commits". */
export type Project_Commits_Order_By = {
  commit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_state?: InputMaybe<Order_By>;
  state_available?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  v2_submission_flow?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_commits */
export type Project_Commits_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Commits_Prepend_Input = {
  /** This column is used to store the state of the project at the time of the commit */
  project_state?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "project_commits" */
export enum Project_Commits_Select_Column {
  /** column name */
  Commit = 'commit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectState = 'project_state',
  /** column name */
  StateAvailable = 'state_available',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  V2SubmissionFlow = 'v2_submission_flow'
}

/** select "project_commits_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_commits" */
export enum Project_Commits_Select_Column_Project_Commits_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  StateAvailable = 'state_available',
  /** column name */
  V2SubmissionFlow = 'v2_submission_flow'
}

/** select "project_commits_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_commits" */
export enum Project_Commits_Select_Column_Project_Commits_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  StateAvailable = 'state_available',
  /** column name */
  V2SubmissionFlow = 'v2_submission_flow'
}

/** input type for updating data in table "project_commits" */
export type Project_Commits_Set_Input = {
  commit?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  /** This column is used to store the state of the project at the time of the commit */
  project_state?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  v2_submission_flow?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Project_Commits_Stddev_Fields = {
  __typename?: 'project_commits_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_commits" */
export type Project_Commits_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Commits_Stddev_Pop_Fields = {
  __typename?: 'project_commits_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_commits" */
export type Project_Commits_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Commits_Stddev_Samp_Fields = {
  __typename?: 'project_commits_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_commits" */
export type Project_Commits_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_commits" */
export type Project_Commits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Commits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Commits_Stream_Cursor_Value_Input = {
  commit?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  /** This column is used to store the state of the project at the time of the commit */
  project_state?: InputMaybe<Scalars['jsonb']>;
  /** This column is used to denote whether or not the project_state is available */
  state_available?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  v2_submission_flow?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Project_Commits_Sum_Fields = {
  __typename?: 'project_commits_sum_fields';
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_commits" */
export type Project_Commits_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** update columns of table "project_commits" */
export enum Project_Commits_Update_Column {
  /** column name */
  Commit = 'commit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectState = 'project_state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  V2SubmissionFlow = 'v2_submission_flow'
}

export type Project_Commits_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Commits_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Commits_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Commits_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Commits_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Commits_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Commits_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Commits_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Commits_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Commits_Var_Pop_Fields = {
  __typename?: 'project_commits_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_commits" */
export type Project_Commits_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Commits_Var_Samp_Fields = {
  __typename?: 'project_commits_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_commits" */
export type Project_Commits_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Commits_Variance_Fields = {
  __typename?: 'project_commits_variance_fields';
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_commits" */
export type Project_Commits_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_contribution_stickers" */
export type Project_Contribution_Stickers = {
  __typename?: 'project_contribution_stickers';
  created_at: Scalars['timestamptz'];
  project_contribution_id: Scalars['Int'];
  quantity: Scalars['Int'];
  /** An object relationship */
  sticker?: Maybe<Stickers>;
  sticker_details: Scalars['jsonb'];
  sticker_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};


/** columns and relationships of "project_contribution_stickers" */
export type Project_Contribution_StickersSticker_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "project_contribution_stickers" */
export type Project_Contribution_Stickers_Aggregate = {
  __typename?: 'project_contribution_stickers_aggregate';
  aggregate?: Maybe<Project_Contribution_Stickers_Aggregate_Fields>;
  nodes: Array<Project_Contribution_Stickers>;
};

export type Project_Contribution_Stickers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Contribution_Stickers_Aggregate_Bool_Exp_Count>;
};

export type Project_Contribution_Stickers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Contribution_Stickers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_contribution_stickers" */
export type Project_Contribution_Stickers_Aggregate_Fields = {
  __typename?: 'project_contribution_stickers_aggregate_fields';
  avg?: Maybe<Project_Contribution_Stickers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Contribution_Stickers_Max_Fields>;
  min?: Maybe<Project_Contribution_Stickers_Min_Fields>;
  stddev?: Maybe<Project_Contribution_Stickers_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Contribution_Stickers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Contribution_Stickers_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Contribution_Stickers_Sum_Fields>;
  var_pop?: Maybe<Project_Contribution_Stickers_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Contribution_Stickers_Var_Samp_Fields>;
  variance?: Maybe<Project_Contribution_Stickers_Variance_Fields>;
};


/** aggregate fields of "project_contribution_stickers" */
export type Project_Contribution_Stickers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Contribution_Stickers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Contribution_Stickers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Contribution_Stickers_Max_Order_By>;
  min?: InputMaybe<Project_Contribution_Stickers_Min_Order_By>;
  stddev?: InputMaybe<Project_Contribution_Stickers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Contribution_Stickers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Contribution_Stickers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Contribution_Stickers_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Contribution_Stickers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Contribution_Stickers_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Contribution_Stickers_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Contribution_Stickers_Append_Input = {
  sticker_details?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Arr_Rel_Insert_Input = {
  data: Array<Project_Contribution_Stickers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Contribution_Stickers_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Contribution_Stickers_Avg_Fields = {
  __typename?: 'project_contribution_stickers_avg_fields';
  project_contribution_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sticker_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Avg_Order_By = {
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_contribution_stickers". All fields are combined with a logical 'AND'. */
export type Project_Contribution_Stickers_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Contribution_Stickers_Bool_Exp>>;
  _not?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Contribution_Stickers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  project_contribution_id?: InputMaybe<Int_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  sticker?: InputMaybe<Stickers_Bool_Exp>;
  sticker_details?: InputMaybe<Jsonb_Comparison_Exp>;
  sticker_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_contribution_stickers" */
export enum Project_Contribution_Stickers_Constraint {
  /** unique or primary key constraint on columns "project_contribution_id", "sticker_id" */
  ProjectContributionStickersPkey = 'project_contribution_stickers_pkey',
  /** unique or primary key constraint on columns "uuid" */
  ProjectContributionStickersUuidKey = 'project_contribution_stickers_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Contribution_Stickers_Delete_At_Path_Input = {
  sticker_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Contribution_Stickers_Delete_Elem_Input = {
  sticker_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Contribution_Stickers_Delete_Key_Input = {
  sticker_details?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Inc_Input = {
  project_contribution_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sticker_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_contribution_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sticker?: InputMaybe<Stickers_Obj_Rel_Insert_Input>;
  sticker_details?: InputMaybe<Scalars['jsonb']>;
  sticker_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Contribution_Stickers_Max_Fields = {
  __typename?: 'project_contribution_stickers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_contribution_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  sticker_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Contribution_Stickers_Min_Fields = {
  __typename?: 'project_contribution_stickers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_contribution_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  sticker_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Mutation_Response = {
  __typename?: 'project_contribution_stickers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Contribution_Stickers>;
};

/** on_conflict condition type for table "project_contribution_stickers" */
export type Project_Contribution_Stickers_On_Conflict = {
  constraint: Project_Contribution_Stickers_Constraint;
  update_columns?: Array<Project_Contribution_Stickers_Update_Column>;
  where?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
};

/** Ordering options when selecting data from "project_contribution_stickers". */
export type Project_Contribution_Stickers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker?: InputMaybe<Stickers_Order_By>;
  sticker_details?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_contribution_stickers */
export type Project_Contribution_Stickers_Pk_Columns_Input = {
  project_contribution_id: Scalars['Int'];
  sticker_id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Contribution_Stickers_Prepend_Input = {
  sticker_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "project_contribution_stickers" */
export enum Project_Contribution_Stickers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectContributionId = 'project_contribution_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  StickerDetails = 'sticker_details',
  /** column name */
  StickerId = 'sticker_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_contribution_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sticker_details?: InputMaybe<Scalars['jsonb']>;
  sticker_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Contribution_Stickers_Stddev_Fields = {
  __typename?: 'project_contribution_stickers_stddev_fields';
  project_contribution_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sticker_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Stddev_Order_By = {
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Contribution_Stickers_Stddev_Pop_Fields = {
  __typename?: 'project_contribution_stickers_stddev_pop_fields';
  project_contribution_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sticker_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Stddev_Pop_Order_By = {
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Contribution_Stickers_Stddev_Samp_Fields = {
  __typename?: 'project_contribution_stickers_stddev_samp_fields';
  project_contribution_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sticker_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Stddev_Samp_Order_By = {
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Contribution_Stickers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Contribution_Stickers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_contribution_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sticker_details?: InputMaybe<Scalars['jsonb']>;
  sticker_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Contribution_Stickers_Sum_Fields = {
  __typename?: 'project_contribution_stickers_sum_fields';
  project_contribution_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  sticker_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Sum_Order_By = {
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
};

/** update columns of table "project_contribution_stickers" */
export enum Project_Contribution_Stickers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectContributionId = 'project_contribution_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  StickerDetails = 'sticker_details',
  /** column name */
  StickerId = 'sticker_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Project_Contribution_Stickers_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Contribution_Stickers_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Contribution_Stickers_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Contribution_Stickers_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Contribution_Stickers_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Contribution_Stickers_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Contribution_Stickers_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Contribution_Stickers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Contribution_Stickers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Contribution_Stickers_Var_Pop_Fields = {
  __typename?: 'project_contribution_stickers_var_pop_fields';
  project_contribution_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sticker_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Var_Pop_Order_By = {
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Contribution_Stickers_Var_Samp_Fields = {
  __typename?: 'project_contribution_stickers_var_samp_fields';
  project_contribution_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sticker_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Var_Samp_Order_By = {
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Contribution_Stickers_Variance_Fields = {
  __typename?: 'project_contribution_stickers_variance_fields';
  project_contribution_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sticker_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_contribution_stickers" */
export type Project_Contribution_Stickers_Variance_Order_By = {
  project_contribution_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sticker_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_contribution_tx_network_type" */
export type Project_Contribution_Tx_Network_Type = {
  __typename?: 'project_contribution_tx_network_type';
  value: Scalars['String'];
};

/** aggregated selection of "project_contribution_tx_network_type" */
export type Project_Contribution_Tx_Network_Type_Aggregate = {
  __typename?: 'project_contribution_tx_network_type_aggregate';
  aggregate?: Maybe<Project_Contribution_Tx_Network_Type_Aggregate_Fields>;
  nodes: Array<Project_Contribution_Tx_Network_Type>;
};

/** aggregate fields of "project_contribution_tx_network_type" */
export type Project_Contribution_Tx_Network_Type_Aggregate_Fields = {
  __typename?: 'project_contribution_tx_network_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Contribution_Tx_Network_Type_Max_Fields>;
  min?: Maybe<Project_Contribution_Tx_Network_Type_Min_Fields>;
};


/** aggregate fields of "project_contribution_tx_network_type" */
export type Project_Contribution_Tx_Network_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "project_contribution_tx_network_type". All fields are combined with a logical 'AND'. */
export type Project_Contribution_Tx_Network_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Bool_Exp>>;
  _not?: InputMaybe<Project_Contribution_Tx_Network_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_contribution_tx_network_type" */
export enum Project_Contribution_Tx_Network_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProjectContributionTxNetworkTypePkey = 'project_contribution_tx_network_type_pkey'
}

export enum Project_Contribution_Tx_Network_Type_Enum {
  Arbitrum = 'arbitrum',
  Base = 'base',
  Mainnet = 'mainnet',
  Optimism = 'optimism',
  Sepolia = 'sepolia'
}

/** Boolean expression to compare columns of type "project_contribution_tx_network_type_enum". All fields are combined with logical 'AND'. */
export type Project_Contribution_Tx_Network_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Contribution_Tx_Network_Type_Enum>;
  _in?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Project_Contribution_Tx_Network_Type_Enum>;
  _nin?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Enum>>;
};

/** input type for inserting data into table "project_contribution_tx_network_type" */
export type Project_Contribution_Tx_Network_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Contribution_Tx_Network_Type_Max_Fields = {
  __typename?: 'project_contribution_tx_network_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Project_Contribution_Tx_Network_Type_Min_Fields = {
  __typename?: 'project_contribution_tx_network_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "project_contribution_tx_network_type" */
export type Project_Contribution_Tx_Network_Type_Mutation_Response = {
  __typename?: 'project_contribution_tx_network_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Contribution_Tx_Network_Type>;
};

/** on_conflict condition type for table "project_contribution_tx_network_type" */
export type Project_Contribution_Tx_Network_Type_On_Conflict = {
  constraint: Project_Contribution_Tx_Network_Type_Constraint;
  update_columns?: Array<Project_Contribution_Tx_Network_Type_Update_Column>;
  where?: InputMaybe<Project_Contribution_Tx_Network_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "project_contribution_tx_network_type". */
export type Project_Contribution_Tx_Network_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_contribution_tx_network_type */
export type Project_Contribution_Tx_Network_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "project_contribution_tx_network_type" */
export enum Project_Contribution_Tx_Network_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "project_contribution_tx_network_type" */
export type Project_Contribution_Tx_Network_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "project_contribution_tx_network_type" */
export type Project_Contribution_Tx_Network_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Contribution_Tx_Network_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Contribution_Tx_Network_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "project_contribution_tx_network_type" */
export enum Project_Contribution_Tx_Network_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Project_Contribution_Tx_Network_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Contribution_Tx_Network_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Contribution_Tx_Network_Type_Bool_Exp;
};

/** columns and relationships of "project_contributions" */
export type Project_Contributions = {
  __typename?: 'project_contributions';
  amount?: Maybe<Scalars['Int']>;
  amount_eth?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  eas_details?: Maybe<Scalars['jsonb']>;
  eas_uuid?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  /** An object relationship */
  project?: Maybe<Projects>;
  project_funding_id?: Maybe<Scalars['Int']>;
  project_id: Scalars['Int'];
  razorpay_meta?: Maybe<Scalars['jsonb']>;
  razorpay_order_id?: Maybe<Scalars['citext']>;
  razorpay_payment_id?: Maybe<Scalars['citext']>;
  status?: Maybe<Scalars['pc_status_enum']>;
  /** An array relationship */
  stickers: Array<Project_Contribution_Stickers>;
  /** An aggregate relationship */
  stickers_aggregate: Project_Contribution_Stickers_Aggregate;
  tx_hash?: Maybe<Scalars['String']>;
  tx_meta?: Maybe<Scalars['jsonb']>;
  tx_network?: Maybe<Project_Contribution_Tx_Network_Type_Enum>;
  type?: Maybe<Project_Contributions_Type_Enum>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};


/** columns and relationships of "project_contributions" */
export type Project_ContributionsEas_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "project_contributions" */
export type Project_ContributionsRazorpay_MetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "project_contributions" */
export type Project_ContributionsStickersArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Stickers_Order_By>>;
  where?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
};


/** columns and relationships of "project_contributions" */
export type Project_ContributionsStickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Stickers_Order_By>>;
  where?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
};


/** columns and relationships of "project_contributions" */
export type Project_ContributionsTx_MetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "project_contributions" */
export type Project_Contributions_Aggregate = {
  __typename?: 'project_contributions_aggregate';
  aggregate?: Maybe<Project_Contributions_Aggregate_Fields>;
  nodes: Array<Project_Contributions>;
};

export type Project_Contributions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Contributions_Aggregate_Bool_Exp_Count>;
};

export type Project_Contributions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Contributions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Contributions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_contributions" */
export type Project_Contributions_Aggregate_Fields = {
  __typename?: 'project_contributions_aggregate_fields';
  avg?: Maybe<Project_Contributions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Contributions_Max_Fields>;
  min?: Maybe<Project_Contributions_Min_Fields>;
  stddev?: Maybe<Project_Contributions_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Contributions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Contributions_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Contributions_Sum_Fields>;
  var_pop?: Maybe<Project_Contributions_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Contributions_Var_Samp_Fields>;
  variance?: Maybe<Project_Contributions_Variance_Fields>;
};


/** aggregate fields of "project_contributions" */
export type Project_Contributions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Contributions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_contributions" */
export type Project_Contributions_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Contributions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Contributions_Max_Order_By>;
  min?: InputMaybe<Project_Contributions_Min_Order_By>;
  stddev?: InputMaybe<Project_Contributions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Contributions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Contributions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Contributions_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Contributions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Contributions_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Contributions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Contributions_Append_Input = {
  eas_details?: InputMaybe<Scalars['jsonb']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "project_contributions" */
export type Project_Contributions_Arr_Rel_Insert_Input = {
  data: Array<Project_Contributions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Contributions_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Contributions_Avg_Fields = {
  __typename?: 'project_contributions_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_funding_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_contributions" */
export type Project_Contributions_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_contributions". All fields are combined with a logical 'AND'. */
export type Project_Contributions_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Contributions_Bool_Exp>>;
  _not?: InputMaybe<Project_Contributions_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Contributions_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  amount_eth?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eas_details?: InputMaybe<Jsonb_Comparison_Exp>;
  eas_uuid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_funding_id?: InputMaybe<Int_Comparison_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  razorpay_meta?: InputMaybe<Jsonb_Comparison_Exp>;
  razorpay_order_id?: InputMaybe<Citext_Comparison_Exp>;
  razorpay_payment_id?: InputMaybe<Citext_Comparison_Exp>;
  status?: InputMaybe<Pc_Status_Enum_Comparison_Exp>;
  stickers?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
  stickers_aggregate?: InputMaybe<Project_Contribution_Stickers_Aggregate_Bool_Exp>;
  tx_hash?: InputMaybe<String_Comparison_Exp>;
  tx_meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tx_network?: InputMaybe<Project_Contribution_Tx_Network_Type_Enum_Comparison_Exp>;
  type?: InputMaybe<Project_Contributions_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_contributions" */
export enum Project_Contributions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProjectContributions = 'pk_project_contributions',
  /** unique or primary key constraint on columns "razorpay_order_id" */
  UniqueRazorpayOrderIdProjectContributions = 'unique_razorpay_order_id_project_contributions',
  /** unique or primary key constraint on columns "razorpay_payment_id" */
  UniqueRazorpayPaymentIdProjectContributions = 'unique_razorpay_payment_id_project_contributions',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidProjectContributions = 'unique_uuid_project_contributions'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Contributions_Delete_At_Path_Input = {
  eas_details?: InputMaybe<Array<Scalars['String']>>;
  razorpay_meta?: InputMaybe<Array<Scalars['String']>>;
  tx_meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Contributions_Delete_Elem_Input = {
  eas_details?: InputMaybe<Scalars['Int']>;
  razorpay_meta?: InputMaybe<Scalars['Int']>;
  tx_meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Contributions_Delete_Key_Input = {
  eas_details?: InputMaybe<Scalars['String']>;
  razorpay_meta?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "project_contributions" */
export type Project_Contributions_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  amount_eth?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  project_funding_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_contributions" */
export type Project_Contributions_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  amount_eth?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eas_details?: InputMaybe<Scalars['jsonb']>;
  eas_uuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_funding_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  razorpay_order_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_id?: InputMaybe<Scalars['citext']>;
  status?: InputMaybe<Scalars['pc_status_enum']>;
  stickers?: InputMaybe<Project_Contribution_Stickers_Arr_Rel_Insert_Input>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Project_Contribution_Tx_Network_Type_Enum>;
  type?: InputMaybe<Project_Contributions_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Contributions_Max_Fields = {
  __typename?: 'project_contributions_max_fields';
  amount?: Maybe<Scalars['Int']>;
  amount_eth?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  eas_uuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  project_funding_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  razorpay_order_id?: Maybe<Scalars['citext']>;
  razorpay_payment_id?: Maybe<Scalars['citext']>;
  status?: Maybe<Scalars['pc_status_enum']>;
  tx_hash?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_contributions" */
export type Project_Contributions_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  eas_uuid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  razorpay_order_id?: InputMaybe<Order_By>;
  razorpay_payment_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Contributions_Min_Fields = {
  __typename?: 'project_contributions_min_fields';
  amount?: Maybe<Scalars['Int']>;
  amount_eth?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  eas_uuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  project_funding_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  razorpay_order_id?: Maybe<Scalars['citext']>;
  razorpay_payment_id?: Maybe<Scalars['citext']>;
  status?: Maybe<Scalars['pc_status_enum']>;
  tx_hash?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_contributions" */
export type Project_Contributions_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  eas_uuid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  razorpay_order_id?: InputMaybe<Order_By>;
  razorpay_payment_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_contributions" */
export type Project_Contributions_Mutation_Response = {
  __typename?: 'project_contributions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Contributions>;
};

/** input type for inserting object relation for remote table "project_contributions" */
export type Project_Contributions_Obj_Rel_Insert_Input = {
  data: Project_Contributions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Contributions_On_Conflict>;
};

/** on_conflict condition type for table "project_contributions" */
export type Project_Contributions_On_Conflict = {
  constraint: Project_Contributions_Constraint;
  update_columns?: Array<Project_Contributions_Update_Column>;
  where?: InputMaybe<Project_Contributions_Bool_Exp>;
};

/** Ordering options when selecting data from "project_contributions". */
export type Project_Contributions_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  eas_details?: InputMaybe<Order_By>;
  eas_uuid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  razorpay_meta?: InputMaybe<Order_By>;
  razorpay_order_id?: InputMaybe<Order_By>;
  razorpay_payment_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stickers_aggregate?: InputMaybe<Project_Contribution_Stickers_Aggregate_Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  tx_meta?: InputMaybe<Order_By>;
  tx_network?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_contributions */
export type Project_Contributions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Contributions_Prepend_Input = {
  eas_details?: InputMaybe<Scalars['jsonb']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "project_contributions" */
export enum Project_Contributions_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountEth = 'amount_eth',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EasDetails = 'eas_details',
  /** column name */
  EasUuid = 'eas_uuid',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  ProjectFundingId = 'project_funding_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RazorpayMeta = 'razorpay_meta',
  /** column name */
  RazorpayOrderId = 'razorpay_order_id',
  /** column name */
  RazorpayPaymentId = 'razorpay_payment_id',
  /** column name */
  Status = 'status',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "project_contributions" */
export type Project_Contributions_Set_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  amount_eth?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eas_details?: InputMaybe<Scalars['jsonb']>;
  eas_uuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  project_funding_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  razorpay_order_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_id?: InputMaybe<Scalars['citext']>;
  status?: InputMaybe<Scalars['pc_status_enum']>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Project_Contribution_Tx_Network_Type_Enum>;
  type?: InputMaybe<Project_Contributions_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Contributions_Stddev_Fields = {
  __typename?: 'project_contributions_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_funding_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_contributions" */
export type Project_Contributions_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Contributions_Stddev_Pop_Fields = {
  __typename?: 'project_contributions_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_funding_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_contributions" */
export type Project_Contributions_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Contributions_Stddev_Samp_Fields = {
  __typename?: 'project_contributions_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_funding_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_contributions" */
export type Project_Contributions_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_contributions" */
export type Project_Contributions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Contributions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Contributions_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  amount_eth?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eas_details?: InputMaybe<Scalars['jsonb']>;
  eas_uuid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  project_funding_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  razorpay_order_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_id?: InputMaybe<Scalars['citext']>;
  status?: InputMaybe<Scalars['pc_status_enum']>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Project_Contribution_Tx_Network_Type_Enum>;
  type?: InputMaybe<Project_Contributions_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Contributions_Sum_Fields = {
  __typename?: 'project_contributions_sum_fields';
  amount?: Maybe<Scalars['Int']>;
  amount_eth?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  project_funding_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_contributions" */
export type Project_Contributions_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_contributions_type" */
export type Project_Contributions_Type = {
  __typename?: 'project_contributions_type';
  value: Scalars['String'];
};

/** aggregated selection of "project_contributions_type" */
export type Project_Contributions_Type_Aggregate = {
  __typename?: 'project_contributions_type_aggregate';
  aggregate?: Maybe<Project_Contributions_Type_Aggregate_Fields>;
  nodes: Array<Project_Contributions_Type>;
};

/** aggregate fields of "project_contributions_type" */
export type Project_Contributions_Type_Aggregate_Fields = {
  __typename?: 'project_contributions_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Contributions_Type_Max_Fields>;
  min?: Maybe<Project_Contributions_Type_Min_Fields>;
};


/** aggregate fields of "project_contributions_type" */
export type Project_Contributions_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Contributions_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "project_contributions_type". All fields are combined with a logical 'AND'. */
export type Project_Contributions_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Contributions_Type_Bool_Exp>>;
  _not?: InputMaybe<Project_Contributions_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Contributions_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_contributions_type" */
export enum Project_Contributions_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProjectContributionsTypePkey = 'project_contributions_type_pkey'
}

export enum Project_Contributions_Type_Enum {
  Crypto = 'CRYPTO',
  Fiat = 'FIAT'
}

/** Boolean expression to compare columns of type "project_contributions_type_enum". All fields are combined with logical 'AND'. */
export type Project_Contributions_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Contributions_Type_Enum>;
  _in?: InputMaybe<Array<Project_Contributions_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Project_Contributions_Type_Enum>;
  _nin?: InputMaybe<Array<Project_Contributions_Type_Enum>>;
};

/** input type for inserting data into table "project_contributions_type" */
export type Project_Contributions_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Contributions_Type_Max_Fields = {
  __typename?: 'project_contributions_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Project_Contributions_Type_Min_Fields = {
  __typename?: 'project_contributions_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "project_contributions_type" */
export type Project_Contributions_Type_Mutation_Response = {
  __typename?: 'project_contributions_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Contributions_Type>;
};

/** on_conflict condition type for table "project_contributions_type" */
export type Project_Contributions_Type_On_Conflict = {
  constraint: Project_Contributions_Type_Constraint;
  update_columns?: Array<Project_Contributions_Type_Update_Column>;
  where?: InputMaybe<Project_Contributions_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "project_contributions_type". */
export type Project_Contributions_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_contributions_type */
export type Project_Contributions_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "project_contributions_type" */
export enum Project_Contributions_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "project_contributions_type" */
export type Project_Contributions_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "project_contributions_type" */
export type Project_Contributions_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Contributions_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Contributions_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "project_contributions_type" */
export enum Project_Contributions_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Project_Contributions_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Contributions_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Contributions_Type_Bool_Exp;
};

/** update columns of table "project_contributions" */
export enum Project_Contributions_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountEth = 'amount_eth',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EasDetails = 'eas_details',
  /** column name */
  EasUuid = 'eas_uuid',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  ProjectFundingId = 'project_funding_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RazorpayMeta = 'razorpay_meta',
  /** column name */
  RazorpayOrderId = 'razorpay_order_id',
  /** column name */
  RazorpayPaymentId = 'razorpay_payment_id',
  /** column name */
  Status = 'status',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Project_Contributions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Contributions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Contributions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Contributions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Contributions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Contributions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Contributions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Contributions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Contributions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Contributions_Var_Pop_Fields = {
  __typename?: 'project_contributions_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_funding_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_contributions" */
export type Project_Contributions_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Contributions_Var_Samp_Fields = {
  __typename?: 'project_contributions_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_funding_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_contributions" */
export type Project_Contributions_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Contributions_Variance_Fields = {
  __typename?: 'project_contributions_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_funding_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_contributions" */
export type Project_Contributions_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_funding_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_hashtags" */
export type Project_Hashtags = {
  __typename?: 'project_hashtags';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  hashtag?: Maybe<Hashtags>;
  hashtag_id: Scalars['Int'];
  project_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "project_hashtags" */
export type Project_Hashtags_Aggregate = {
  __typename?: 'project_hashtags_aggregate';
  aggregate?: Maybe<Project_Hashtags_Aggregate_Fields>;
  nodes: Array<Project_Hashtags>;
};

export type Project_Hashtags_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Hashtags_Aggregate_Bool_Exp_Count>;
};

export type Project_Hashtags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Hashtags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Hashtags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_hashtags" */
export type Project_Hashtags_Aggregate_Fields = {
  __typename?: 'project_hashtags_aggregate_fields';
  avg?: Maybe<Project_Hashtags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Hashtags_Max_Fields>;
  min?: Maybe<Project_Hashtags_Min_Fields>;
  stddev?: Maybe<Project_Hashtags_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Hashtags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Hashtags_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Hashtags_Sum_Fields>;
  var_pop?: Maybe<Project_Hashtags_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Hashtags_Var_Samp_Fields>;
  variance?: Maybe<Project_Hashtags_Variance_Fields>;
};


/** aggregate fields of "project_hashtags" */
export type Project_Hashtags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Hashtags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_hashtags" */
export type Project_Hashtags_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Hashtags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Hashtags_Max_Order_By>;
  min?: InputMaybe<Project_Hashtags_Min_Order_By>;
  stddev?: InputMaybe<Project_Hashtags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Hashtags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Hashtags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Hashtags_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Hashtags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Hashtags_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Hashtags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_hashtags" */
export type Project_Hashtags_Arr_Rel_Insert_Input = {
  data: Array<Project_Hashtags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Hashtags_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Hashtags_Avg_Fields = {
  __typename?: 'project_hashtags_avg_fields';
  hashtag_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_hashtags" */
export type Project_Hashtags_Avg_Order_By = {
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_hashtags". All fields are combined with a logical 'AND'. */
export type Project_Hashtags_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Hashtags_Bool_Exp>>;
  _not?: InputMaybe<Project_Hashtags_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Hashtags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hashtag?: InputMaybe<Hashtags_Bool_Exp>;
  hashtag_id?: InputMaybe<Int_Comparison_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_hashtags" */
export enum Project_Hashtags_Constraint {
  /** unique or primary key constraint on columns "hashtag_id", "project_id" */
  PkProjectHashtags = 'pk_project_hashtags',
  /** unique or primary key constraint on columns "hashtag_id", "project_id" */
  UniqueProjectIdHashtagIdProjectHashtags = 'unique_project_id_hashtag_id_project_hashtags'
}

/** input type for incrementing numeric columns in table "project_hashtags" */
export type Project_Hashtags_Inc_Input = {
  hashtag_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_hashtags" */
export type Project_Hashtags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hashtag?: InputMaybe<Hashtags_Obj_Rel_Insert_Input>;
  hashtag_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Project_Hashtags_Max_Fields = {
  __typename?: 'project_hashtags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hashtag_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "project_hashtags" */
export type Project_Hashtags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Hashtags_Min_Fields = {
  __typename?: 'project_hashtags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hashtag_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "project_hashtags" */
export type Project_Hashtags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_hashtags" */
export type Project_Hashtags_Mutation_Response = {
  __typename?: 'project_hashtags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Hashtags>;
};

/** on_conflict condition type for table "project_hashtags" */
export type Project_Hashtags_On_Conflict = {
  constraint: Project_Hashtags_Constraint;
  update_columns?: Array<Project_Hashtags_Update_Column>;
  where?: InputMaybe<Project_Hashtags_Bool_Exp>;
};

/** Ordering options when selecting data from "project_hashtags". */
export type Project_Hashtags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hashtag?: InputMaybe<Hashtags_Order_By>;
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_hashtags */
export type Project_Hashtags_Pk_Columns_Input = {
  hashtag_id: Scalars['Int'];
  project_id: Scalars['Int'];
};

/** select columns of table "project_hashtags" */
export enum Project_Hashtags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HashtagId = 'hashtag_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_hashtags" */
export type Project_Hashtags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hashtag_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Project_Hashtags_Stddev_Fields = {
  __typename?: 'project_hashtags_stddev_fields';
  hashtag_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_hashtags" */
export type Project_Hashtags_Stddev_Order_By = {
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Hashtags_Stddev_Pop_Fields = {
  __typename?: 'project_hashtags_stddev_pop_fields';
  hashtag_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_hashtags" */
export type Project_Hashtags_Stddev_Pop_Order_By = {
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Hashtags_Stddev_Samp_Fields = {
  __typename?: 'project_hashtags_stddev_samp_fields';
  hashtag_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_hashtags" */
export type Project_Hashtags_Stddev_Samp_Order_By = {
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_hashtags" */
export type Project_Hashtags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Hashtags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Hashtags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hashtag_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Project_Hashtags_Sum_Fields = {
  __typename?: 'project_hashtags_sum_fields';
  hashtag_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_hashtags" */
export type Project_Hashtags_Sum_Order_By = {
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** update columns of table "project_hashtags" */
export enum Project_Hashtags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HashtagId = 'hashtag_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Hashtags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Hashtags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Hashtags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Hashtags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Hashtags_Var_Pop_Fields = {
  __typename?: 'project_hashtags_var_pop_fields';
  hashtag_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_hashtags" */
export type Project_Hashtags_Var_Pop_Order_By = {
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Hashtags_Var_Samp_Fields = {
  __typename?: 'project_hashtags_var_samp_fields';
  hashtag_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_hashtags" */
export type Project_Hashtags_Var_Samp_Order_By = {
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Hashtags_Variance_Fields = {
  __typename?: 'project_hashtags_variance_fields';
  hashtag_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_hashtags" */
export type Project_Hashtags_Variance_Order_By = {
  hashtag_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_judges" */
export type Project_Judges = {
  __typename?: 'project_judges';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  judge?: Maybe<Judges>;
  judge_id: Scalars['Int'];
  project_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "project_judges" */
export type Project_Judges_Aggregate = {
  __typename?: 'project_judges_aggregate';
  aggregate?: Maybe<Project_Judges_Aggregate_Fields>;
  nodes: Array<Project_Judges>;
};

/** aggregate fields of "project_judges" */
export type Project_Judges_Aggregate_Fields = {
  __typename?: 'project_judges_aggregate_fields';
  avg?: Maybe<Project_Judges_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Judges_Max_Fields>;
  min?: Maybe<Project_Judges_Min_Fields>;
  stddev?: Maybe<Project_Judges_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Judges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Judges_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Judges_Sum_Fields>;
  var_pop?: Maybe<Project_Judges_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Judges_Var_Samp_Fields>;
  variance?: Maybe<Project_Judges_Variance_Fields>;
};


/** aggregate fields of "project_judges" */
export type Project_Judges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Judges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Project_Judges_Avg_Fields = {
  __typename?: 'project_judges_avg_fields';
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "project_judges". All fields are combined with a logical 'AND'. */
export type Project_Judges_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Judges_Bool_Exp>>;
  _not?: InputMaybe<Project_Judges_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Judges_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  judge?: InputMaybe<Judges_Bool_Exp>;
  judge_id?: InputMaybe<Int_Comparison_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_judges" */
export enum Project_Judges_Constraint {
  /** unique or primary key constraint on columns "judge_id", "project_id" */
  ProjectJudgesPkey = 'project_judges_pkey',
  /** unique or primary key constraint on columns "uuid" */
  ProjectJudgesUuidKey = 'project_judges_uuid_key'
}

/** input type for incrementing numeric columns in table "project_judges" */
export type Project_Judges_Inc_Input = {
  judge_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_judges" */
export type Project_Judges_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  judge?: InputMaybe<Judges_Obj_Rel_Insert_Input>;
  judge_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Judges_Max_Fields = {
  __typename?: 'project_judges_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  judge_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Project_Judges_Min_Fields = {
  __typename?: 'project_judges_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  judge_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "project_judges" */
export type Project_Judges_Mutation_Response = {
  __typename?: 'project_judges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Judges>;
};

/** on_conflict condition type for table "project_judges" */
export type Project_Judges_On_Conflict = {
  constraint: Project_Judges_Constraint;
  update_columns?: Array<Project_Judges_Update_Column>;
  where?: InputMaybe<Project_Judges_Bool_Exp>;
};

/** Ordering options when selecting data from "project_judges". */
export type Project_Judges_Order_By = {
  created_at?: InputMaybe<Order_By>;
  judge?: InputMaybe<Judges_Order_By>;
  judge_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_judges */
export type Project_Judges_Pk_Columns_Input = {
  judge_id: Scalars['Int'];
  project_id: Scalars['Int'];
};

/** select columns of table "project_judges" */
export enum Project_Judges_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "project_judges" */
export type Project_Judges_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Judges_Stddev_Fields = {
  __typename?: 'project_judges_stddev_fields';
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Project_Judges_Stddev_Pop_Fields = {
  __typename?: 'project_judges_stddev_pop_fields';
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Project_Judges_Stddev_Samp_Fields = {
  __typename?: 'project_judges_stddev_samp_fields';
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "project_judges" */
export type Project_Judges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Judges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Judges_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Judges_Sum_Fields = {
  __typename?: 'project_judges_sum_fields';
  judge_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "project_judges" */
export enum Project_Judges_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Project_Judges_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Judges_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Judges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Judges_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Judges_Var_Pop_Fields = {
  __typename?: 'project_judges_var_pop_fields';
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Project_Judges_Var_Samp_Fields = {
  __typename?: 'project_judges_var_samp_fields';
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Project_Judges_Variance_Fields = {
  __typename?: 'project_judges_variance_fields';
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** This table is used as an enum table to store the types for the variants of projects judging submission */
export type Project_Judging_Submission_Type = {
  __typename?: 'project_judging_submission_type';
  value: Scalars['String'];
};

/** aggregated selection of "project_judging_submission_type" */
export type Project_Judging_Submission_Type_Aggregate = {
  __typename?: 'project_judging_submission_type_aggregate';
  aggregate?: Maybe<Project_Judging_Submission_Type_Aggregate_Fields>;
  nodes: Array<Project_Judging_Submission_Type>;
};

/** aggregate fields of "project_judging_submission_type" */
export type Project_Judging_Submission_Type_Aggregate_Fields = {
  __typename?: 'project_judging_submission_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Judging_Submission_Type_Max_Fields>;
  min?: Maybe<Project_Judging_Submission_Type_Min_Fields>;
};


/** aggregate fields of "project_judging_submission_type" */
export type Project_Judging_Submission_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Judging_Submission_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "project_judging_submission_type". All fields are combined with a logical 'AND'. */
export type Project_Judging_Submission_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Judging_Submission_Type_Bool_Exp>>;
  _not?: InputMaybe<Project_Judging_Submission_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Judging_Submission_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_judging_submission_type" */
export enum Project_Judging_Submission_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProjectJudgingSubmissionTypePkey = 'project_judging_submission_type_pkey'
}

export enum Project_Judging_Submission_Type_Enum {
  SponsorAndMainJudging = 'SPONSOR_AND_MAIN_JUDGING',
  SponsorJudging = 'SPONSOR_JUDGING'
}

/** Boolean expression to compare columns of type "project_judging_submission_type_enum". All fields are combined with logical 'AND'. */
export type Project_Judging_Submission_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Judging_Submission_Type_Enum>;
  _in?: InputMaybe<Array<Project_Judging_Submission_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Project_Judging_Submission_Type_Enum>;
  _nin?: InputMaybe<Array<Project_Judging_Submission_Type_Enum>>;
};

/** input type for inserting data into table "project_judging_submission_type" */
export type Project_Judging_Submission_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Judging_Submission_Type_Max_Fields = {
  __typename?: 'project_judging_submission_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Project_Judging_Submission_Type_Min_Fields = {
  __typename?: 'project_judging_submission_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "project_judging_submission_type" */
export type Project_Judging_Submission_Type_Mutation_Response = {
  __typename?: 'project_judging_submission_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Judging_Submission_Type>;
};

/** on_conflict condition type for table "project_judging_submission_type" */
export type Project_Judging_Submission_Type_On_Conflict = {
  constraint: Project_Judging_Submission_Type_Constraint;
  update_columns?: Array<Project_Judging_Submission_Type_Update_Column>;
  where?: InputMaybe<Project_Judging_Submission_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "project_judging_submission_type". */
export type Project_Judging_Submission_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_judging_submission_type */
export type Project_Judging_Submission_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "project_judging_submission_type" */
export enum Project_Judging_Submission_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "project_judging_submission_type" */
export type Project_Judging_Submission_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "project_judging_submission_type" */
export type Project_Judging_Submission_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Judging_Submission_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Judging_Submission_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "project_judging_submission_type" */
export enum Project_Judging_Submission_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Project_Judging_Submission_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Judging_Submission_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Judging_Submission_Type_Bool_Exp;
};

/** columns and relationships of "project_judgments" */
export type Project_Judgments = {
  __typename?: 'project_judgments';
  _score?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  flagged: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  judge?: Maybe<Judges>;
  judge_id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  project?: Maybe<Projects>;
  project_id: Scalars['Int'];
  /** An object relationship */
  room?: Maybe<Judging_Rooms>;
  room_id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};


/** columns and relationships of "project_judgments" */
export type Project_JudgmentsScoreArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "project_judgments" */
export type Project_Judgments_Aggregate = {
  __typename?: 'project_judgments_aggregate';
  aggregate?: Maybe<Project_Judgments_Aggregate_Fields>;
  nodes: Array<Project_Judgments>;
};

export type Project_Judgments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Judgments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Judgments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Judgments_Aggregate_Bool_Exp_Count>;
};

export type Project_Judgments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Judgments_Select_Column_Project_Judgments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Judgments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Judgments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Judgments_Select_Column_Project_Judgments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Judgments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Judgments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Judgments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_judgments" */
export type Project_Judgments_Aggregate_Fields = {
  __typename?: 'project_judgments_aggregate_fields';
  avg?: Maybe<Project_Judgments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Judgments_Max_Fields>;
  min?: Maybe<Project_Judgments_Min_Fields>;
  stddev?: Maybe<Project_Judgments_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Judgments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Judgments_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Judgments_Sum_Fields>;
  var_pop?: Maybe<Project_Judgments_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Judgments_Var_Samp_Fields>;
  variance?: Maybe<Project_Judgments_Variance_Fields>;
};


/** aggregate fields of "project_judgments" */
export type Project_Judgments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_judgments" */
export type Project_Judgments_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Judgments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Judgments_Max_Order_By>;
  min?: InputMaybe<Project_Judgments_Min_Order_By>;
  stddev?: InputMaybe<Project_Judgments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Judgments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Judgments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Judgments_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Judgments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Judgments_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Judgments_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Judgments_Append_Input = {
  score?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "project_judgments" */
export type Project_Judgments_Arr_Rel_Insert_Input = {
  data: Array<Project_Judgments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Judgments_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Judgments_Avg_Fields = {
  __typename?: 'project_judgments_avg_fields';
  _score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_judgments" */
export type Project_Judgments_Avg_Order_By = {
  _score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_judgments". All fields are combined with a logical 'AND'. */
export type Project_Judgments_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Judgments_Bool_Exp>>;
  _not?: InputMaybe<Project_Judgments_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Judgments_Bool_Exp>>;
  _score?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  flagged?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  judge?: InputMaybe<Judges_Bool_Exp>;
  judge_id?: InputMaybe<Int_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  room?: InputMaybe<Judging_Rooms_Bool_Exp>;
  room_id?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Jsonb_Comparison_Exp>;
  tags?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_judgments" */
export enum Project_Judgments_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectJudgmentsPkey = 'project_judgments_pkey',
  /** unique or primary key constraint on columns "judge_id", "project_id", "room_id" */
  ProjectJudgmentsProjectIdRoomIdJudgeIdKey = 'project_judgments_project_id_room_id_judge_id_key',
  /** unique or primary key constraint on columns "uuid" */
  ProjectJudgmentsUuidKey = 'project_judgments_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Judgments_Delete_At_Path_Input = {
  score?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Judgments_Delete_Elem_Input = {
  score?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Judgments_Delete_Key_Input = {
  score?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "project_judgments" */
export type Project_Judgments_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  room_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_judgments" */
export type Project_Judgments_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  judge?: InputMaybe<Judges_Obj_Rel_Insert_Input>;
  judge_id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  room?: InputMaybe<Judging_Rooms_Obj_Rel_Insert_Input>;
  room_id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Judgments_Max_Fields = {
  __typename?: 'project_judgments_max_fields';
  _score?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  judge_id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['Int']>;
  room_id?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_judgments" */
export type Project_Judgments_Max_Order_By = {
  _score?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Judgments_Min_Fields = {
  __typename?: 'project_judgments_min_fields';
  _score?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  judge_id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['Int']>;
  room_id?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_judgments" */
export type Project_Judgments_Min_Order_By = {
  _score?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_judgments" */
export type Project_Judgments_Mutation_Response = {
  __typename?: 'project_judgments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Judgments>;
};

/** on_conflict condition type for table "project_judgments" */
export type Project_Judgments_On_Conflict = {
  constraint: Project_Judgments_Constraint;
  update_columns?: Array<Project_Judgments_Update_Column>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};

/** Ordering options when selecting data from "project_judgments". */
export type Project_Judgments_Order_By = {
  _score?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  flagged?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge?: InputMaybe<Judges_Order_By>;
  judge_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  room?: InputMaybe<Judging_Rooms_Order_By>;
  room_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_judgments */
export type Project_Judgments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Judgments_Prepend_Input = {
  score?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "project_judgments" */
export enum Project_Judgments_Select_Column {
  /** column name */
  _Score = '_score',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Flagged = 'flagged',
  /** column name */
  Id = 'id',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RoomId = 'room_id',
  /** column name */
  Score = 'score',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** select "project_judgments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_judgments" */
export enum Project_Judgments_Select_Column_Project_Judgments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Flagged = 'flagged'
}

/** select "project_judgments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_judgments" */
export enum Project_Judgments_Select_Column_Project_Judgments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Flagged = 'flagged'
}

/** input type for updating data in table "project_judgments" */
export type Project_Judgments_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['Int']>;
  room_id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Judgments_Stddev_Fields = {
  __typename?: 'project_judgments_stddev_fields';
  _score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_judgments" */
export type Project_Judgments_Stddev_Order_By = {
  _score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Judgments_Stddev_Pop_Fields = {
  __typename?: 'project_judgments_stddev_pop_fields';
  _score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_judgments" */
export type Project_Judgments_Stddev_Pop_Order_By = {
  _score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Judgments_Stddev_Samp_Fields = {
  __typename?: 'project_judgments_stddev_samp_fields';
  _score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_judgments" */
export type Project_Judgments_Stddev_Samp_Order_By = {
  _score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_judgments" */
export type Project_Judgments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Judgments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Judgments_Stream_Cursor_Value_Input = {
  _score?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['Int']>;
  room_id?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Judgments_Sum_Fields = {
  __typename?: 'project_judgments_sum_fields';
  _score?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  judge_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  room_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_judgments" */
export type Project_Judgments_Sum_Order_By = {
  _score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** update columns of table "project_judgments" */
export enum Project_Judgments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Flagged = 'flagged',
  /** column name */
  Id = 'id',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RoomId = 'room_id',
  /** column name */
  Score = 'score',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Project_Judgments_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Judgments_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Judgments_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Judgments_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Judgments_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Judgments_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Judgments_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Judgments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Judgments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Judgments_Var_Pop_Fields = {
  __typename?: 'project_judgments_var_pop_fields';
  _score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_judgments" */
export type Project_Judgments_Var_Pop_Order_By = {
  _score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Judgments_Var_Samp_Fields = {
  __typename?: 'project_judgments_var_samp_fields';
  _score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_judgments" */
export type Project_Judgments_Var_Samp_Order_By = {
  _score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Judgments_Variance_Fields = {
  __typename?: 'project_judgments_variance_fields';
  _score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_judgments" */
export type Project_Judgments_Variance_Order_By = {
  _score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** This table is used as an enum table to store the types of a project report */
export type Project_Report_Type = {
  __typename?: 'project_report_type';
  value: Scalars['String'];
};

/** aggregated selection of "project_report_type" */
export type Project_Report_Type_Aggregate = {
  __typename?: 'project_report_type_aggregate';
  aggregate?: Maybe<Project_Report_Type_Aggregate_Fields>;
  nodes: Array<Project_Report_Type>;
};

/** aggregate fields of "project_report_type" */
export type Project_Report_Type_Aggregate_Fields = {
  __typename?: 'project_report_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Report_Type_Max_Fields>;
  min?: Maybe<Project_Report_Type_Min_Fields>;
};


/** aggregate fields of "project_report_type" */
export type Project_Report_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Report_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "project_report_type". All fields are combined with a logical 'AND'. */
export type Project_Report_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Report_Type_Bool_Exp>>;
  _not?: InputMaybe<Project_Report_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Report_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_report_type" */
export enum Project_Report_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProjectReportTypePkey = 'project_report_type_pkey'
}

export enum Project_Report_Type_Enum {
  Harmful = 'HARMFUL',
  Plagiarism = 'PLAGIARISM',
  Recycling = 'RECYCLING',
  Spam = 'SPAM'
}

/** Boolean expression to compare columns of type "project_report_type_enum". All fields are combined with logical 'AND'. */
export type Project_Report_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Report_Type_Enum>;
  _in?: InputMaybe<Array<Project_Report_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Project_Report_Type_Enum>;
  _nin?: InputMaybe<Array<Project_Report_Type_Enum>>;
};

/** input type for inserting data into table "project_report_type" */
export type Project_Report_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Report_Type_Max_Fields = {
  __typename?: 'project_report_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Project_Report_Type_Min_Fields = {
  __typename?: 'project_report_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "project_report_type" */
export type Project_Report_Type_Mutation_Response = {
  __typename?: 'project_report_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Report_Type>;
};

/** on_conflict condition type for table "project_report_type" */
export type Project_Report_Type_On_Conflict = {
  constraint: Project_Report_Type_Constraint;
  update_columns?: Array<Project_Report_Type_Update_Column>;
  where?: InputMaybe<Project_Report_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "project_report_type". */
export type Project_Report_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_report_type */
export type Project_Report_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "project_report_type" */
export enum Project_Report_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "project_report_type" */
export type Project_Report_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "project_report_type" */
export type Project_Report_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Report_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Report_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "project_report_type" */
export enum Project_Report_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Project_Report_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Report_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Report_Type_Bool_Exp;
};

/** This table is used to store project reports */
export type Project_Reports = {
  __typename?: 'project_reports';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  link_to_original?: Maybe<Scalars['String']>;
  /** An object relationship */
  project: Projects;
  project_id: Scalars['Int'];
  reporter_email?: Maybe<Scalars['String']>;
  /** An object relationship */
  reporting_user?: Maybe<Users>;
  type: Project_Report_Type_Enum;
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};

/** aggregated selection of "project_reports" */
export type Project_Reports_Aggregate = {
  __typename?: 'project_reports_aggregate';
  aggregate?: Maybe<Project_Reports_Aggregate_Fields>;
  nodes: Array<Project_Reports>;
};

export type Project_Reports_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Reports_Aggregate_Bool_Exp_Count>;
};

export type Project_Reports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Reports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_reports" */
export type Project_Reports_Aggregate_Fields = {
  __typename?: 'project_reports_aggregate_fields';
  avg?: Maybe<Project_Reports_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Reports_Max_Fields>;
  min?: Maybe<Project_Reports_Min_Fields>;
  stddev?: Maybe<Project_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Reports_Sum_Fields>;
  var_pop?: Maybe<Project_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Reports_Var_Samp_Fields>;
  variance?: Maybe<Project_Reports_Variance_Fields>;
};


/** aggregate fields of "project_reports" */
export type Project_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_reports" */
export type Project_Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Reports_Max_Order_By>;
  min?: InputMaybe<Project_Reports_Min_Order_By>;
  stddev?: InputMaybe<Project_Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Reports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_reports" */
export type Project_Reports_Arr_Rel_Insert_Input = {
  data: Array<Project_Reports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Reports_Avg_Fields = {
  __typename?: 'project_reports_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_reports" */
export type Project_Reports_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_reports". All fields are combined with a logical 'AND'. */
export type Project_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Reports_Bool_Exp>>;
  _not?: InputMaybe<Project_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Reports_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  link_to_original?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  reporter_email?: InputMaybe<String_Comparison_Exp>;
  reporting_user?: InputMaybe<Users_Bool_Exp>;
  type?: InputMaybe<Project_Report_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_reports" */
export enum Project_Reports_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectReportsPkey = 'project_reports_pkey',
  /** unique or primary key constraint on columns "uuid" */
  ProjectReportsUuidKey = 'project_reports_uuid_key'
}

/** input type for incrementing numeric columns in table "project_reports" */
export type Project_Reports_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_reports" */
export type Project_Reports_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  link_to_original?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  reporter_email?: InputMaybe<Scalars['String']>;
  reporting_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Project_Report_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Reports_Max_Fields = {
  __typename?: 'project_reports_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  link_to_original?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['Int']>;
  reporter_email?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_reports" */
export type Project_Reports_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link_to_original?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reporter_email?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Reports_Min_Fields = {
  __typename?: 'project_reports_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  link_to_original?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['Int']>;
  reporter_email?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_reports" */
export type Project_Reports_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link_to_original?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reporter_email?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_reports" */
export type Project_Reports_Mutation_Response = {
  __typename?: 'project_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Reports>;
};

/** input type for inserting object relation for remote table "project_reports" */
export type Project_Reports_Obj_Rel_Insert_Input = {
  data: Project_Reports_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Reports_On_Conflict>;
};

/** on_conflict condition type for table "project_reports" */
export type Project_Reports_On_Conflict = {
  constraint: Project_Reports_Constraint;
  update_columns?: Array<Project_Reports_Update_Column>;
  where?: InputMaybe<Project_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "project_reports". */
export type Project_Reports_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link_to_original?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  reporter_email?: InputMaybe<Order_By>;
  reporting_user?: InputMaybe<Users_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_reports */
export type Project_Reports_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "project_reports" */
export enum Project_Reports_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  LinkToOriginal = 'link_to_original',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ReporterEmail = 'reporter_email',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "project_reports" */
export type Project_Reports_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  link_to_original?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['Int']>;
  reporter_email?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Project_Report_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Reports_Stddev_Fields = {
  __typename?: 'project_reports_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_reports" */
export type Project_Reports_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Reports_Stddev_Pop_Fields = {
  __typename?: 'project_reports_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_reports" */
export type Project_Reports_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Reports_Stddev_Samp_Fields = {
  __typename?: 'project_reports_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_reports" */
export type Project_Reports_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_reports" */
export type Project_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Reports_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  link_to_original?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['Int']>;
  reporter_email?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Project_Report_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Reports_Sum_Fields = {
  __typename?: 'project_reports_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_reports" */
export type Project_Reports_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "project_reports" */
export enum Project_Reports_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  LinkToOriginal = 'link_to_original',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ReporterEmail = 'reporter_email',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Project_Reports_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Reports_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Reports_Var_Pop_Fields = {
  __typename?: 'project_reports_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_reports" */
export type Project_Reports_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Reports_Var_Samp_Fields = {
  __typename?: 'project_reports_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_reports" */
export type Project_Reports_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Reports_Variance_Fields = {
  __typename?: 'project_reports_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_reports" */
export type Project_Reports_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_tracks" */
export type Project_Tracks = {
  __typename?: 'project_tracks';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  prize_track: Prize_Tracks;
  /** An object relationship */
  project: Projects;
  project_id: Scalars['Int'];
  track_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "project_tracks" */
export type Project_Tracks_Aggregate = {
  __typename?: 'project_tracks_aggregate';
  aggregate?: Maybe<Project_Tracks_Aggregate_Fields>;
  nodes: Array<Project_Tracks>;
};

export type Project_Tracks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Tracks_Aggregate_Bool_Exp_Count>;
};

export type Project_Tracks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Tracks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_tracks" */
export type Project_Tracks_Aggregate_Fields = {
  __typename?: 'project_tracks_aggregate_fields';
  avg?: Maybe<Project_Tracks_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Tracks_Max_Fields>;
  min?: Maybe<Project_Tracks_Min_Fields>;
  stddev?: Maybe<Project_Tracks_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Tracks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Tracks_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Tracks_Sum_Fields>;
  var_pop?: Maybe<Project_Tracks_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Tracks_Var_Samp_Fields>;
  variance?: Maybe<Project_Tracks_Variance_Fields>;
};


/** aggregate fields of "project_tracks" */
export type Project_Tracks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_tracks" */
export type Project_Tracks_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Tracks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Tracks_Max_Order_By>;
  min?: InputMaybe<Project_Tracks_Min_Order_By>;
  stddev?: InputMaybe<Project_Tracks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Tracks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Tracks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Tracks_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Tracks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Tracks_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Tracks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_tracks" */
export type Project_Tracks_Arr_Rel_Insert_Input = {
  data: Array<Project_Tracks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Tracks_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Tracks_Avg_Fields = {
  __typename?: 'project_tracks_avg_fields';
  project_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_tracks" */
export type Project_Tracks_Avg_Order_By = {
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_tracks". All fields are combined with a logical 'AND'. */
export type Project_Tracks_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Tracks_Bool_Exp>>;
  _not?: InputMaybe<Project_Tracks_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Tracks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  prize_track?: InputMaybe<Prize_Tracks_Bool_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  track_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_tracks" */
export enum Project_Tracks_Constraint {
  /** unique or primary key constraint on columns "project_id", "track_id" */
  ProjectTracksPkey = 'project_tracks_pkey',
  /** unique or primary key constraint on columns "uuid" */
  ProjectTracksUuidKey = 'project_tracks_uuid_key'
}

/** input type for incrementing numeric columns in table "project_tracks" */
export type Project_Tracks_Inc_Input = {
  project_id?: InputMaybe<Scalars['Int']>;
  track_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_tracks" */
export type Project_Tracks_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  prize_track?: InputMaybe<Prize_Tracks_Obj_Rel_Insert_Input>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  track_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Tracks_Max_Fields = {
  __typename?: 'project_tracks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['Int']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_tracks" */
export type Project_Tracks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Tracks_Min_Fields = {
  __typename?: 'project_tracks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['Int']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_tracks" */
export type Project_Tracks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_tracks" */
export type Project_Tracks_Mutation_Response = {
  __typename?: 'project_tracks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Tracks>;
};

/** on_conflict condition type for table "project_tracks" */
export type Project_Tracks_On_Conflict = {
  constraint: Project_Tracks_Constraint;
  update_columns?: Array<Project_Tracks_Update_Column>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};

/** Ordering options when selecting data from "project_tracks". */
export type Project_Tracks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  prize_track?: InputMaybe<Prize_Tracks_Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_tracks */
export type Project_Tracks_Pk_Columns_Input = {
  project_id: Scalars['Int'];
  track_id: Scalars['Int'];
};

/** select columns of table "project_tracks" */
export enum Project_Tracks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TrackId = 'track_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "project_tracks" */
export type Project_Tracks_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['Int']>;
  track_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Tracks_Stddev_Fields = {
  __typename?: 'project_tracks_stddev_fields';
  project_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_tracks" */
export type Project_Tracks_Stddev_Order_By = {
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Tracks_Stddev_Pop_Fields = {
  __typename?: 'project_tracks_stddev_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_tracks" */
export type Project_Tracks_Stddev_Pop_Order_By = {
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Tracks_Stddev_Samp_Fields = {
  __typename?: 'project_tracks_stddev_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_tracks" */
export type Project_Tracks_Stddev_Samp_Order_By = {
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_tracks" */
export type Project_Tracks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Tracks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Tracks_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['Int']>;
  track_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Tracks_Sum_Fields = {
  __typename?: 'project_tracks_sum_fields';
  project_id?: Maybe<Scalars['Int']>;
  track_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_tracks" */
export type Project_Tracks_Sum_Order_By = {
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** update columns of table "project_tracks" */
export enum Project_Tracks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TrackId = 'track_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Project_Tracks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Tracks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Tracks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Tracks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Tracks_Var_Pop_Fields = {
  __typename?: 'project_tracks_var_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_tracks" */
export type Project_Tracks_Var_Pop_Order_By = {
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Tracks_Var_Samp_Fields = {
  __typename?: 'project_tracks_var_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_tracks" */
export type Project_Tracks_Var_Samp_Order_By = {
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Tracks_Variance_Fields = {
  __typename?: 'project_tracks_variance_fields';
  project_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_tracks" */
export type Project_Tracks_Variance_Order_By = {
  project_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "projects" */
export type Projects = {
  __typename?: 'projects';
  /** This function is used for adding the assets prefix to the cover_img field */
  _cover_img?: Maybe<Scalars['String']>;
  /** This function is used for adding the assets prefix to the favicon field */
  _favicon?: Maybe<Scalars['String']>;
  apply_for_network_school_fellowship_prize?: Maybe<Scalars['Boolean']>;
  architecture_diagram?: Maybe<Scalars['String']>;
  banned: Scalars['Boolean'];
  /** The builders of the project */
  builders?: Maybe<Array<Users>>;
  by_student_team?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** An array relationship */
  commits: Array<Project_Commits>;
  /** An aggregate relationship */
  commits_aggregate: Project_Commits_Aggregate;
  community_expo_location?: Maybe<Scalars['String']>;
  community_expo_opt_in?: Maybe<Scalars['Boolean']>;
  community_expo_opt_in_time?: Maybe<Scalars['timestamptz']>;
  cover_img?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  demo_url?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['jsonb']>;
  discover: Scalars['Boolean'];
  eligible_for_prizing?: Maybe<Scalars['Boolean']>;
  emoji?: Maybe<Scalars['String']>;
  experience_id?: Maybe<Scalars['Int']>;
  /** This field stores the favicon image location for the project */
  favicon?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  flagged: Scalars['Boolean'];
  flagging_admin_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  funding?: Maybe<Projects_Funding>;
  /** The hackathons that the project is a part of */
  hackathons?: Maybe<Array<Hackathons>>;
  /** An array relationship */
  hashtags: Array<Project_Hashtags>;
  /** An aggregate relationship */
  hashtags_aggregate: Project_Hashtags_Aggregate;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  idea_id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "get_is_project_accepting_funding" */
  is_project_accepting_funding?: Maybe<Scalars['String']>;
  judging_submission_type?: Maybe<Project_Judging_Submission_Type_Enum>;
  likes?: Maybe<Scalars['Int']>;
  links?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  pictures?: Maybe<Scalars['String']>;
  platforms?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  project_reports: Array<Project_Reports>;
  /** An aggregate relationship */
  project_reports_aggregate: Project_Reports_Aggregate;
  /** An array relationship */
  project_tracks: Array<Project_Tracks>;
  /** An aggregate relationship */
  project_tracks_aggregate: Project_Tracks_Aggregate;
  published_at?: Maybe<Scalars['timestamptz']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['numeric']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['numeric']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  quadratic_votings: Array<Quadratic_Voting_Projects>;
  /** An aggregate relationship */
  quadratic_votings_aggregate: Quadratic_Voting_Projects_Aggregate;
  /** An object relationship */
  report?: Maybe<Project_Reports>;
  report_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['citext']>;
  source_code_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  sponsor_judgments: Array<Sponsor_Judgments>;
  /** An aggregate relationship */
  sponsor_judgments_aggregate: Sponsor_Judgments_Aggregate;
  status?: Maybe<Scalars['projects_status_enum']>;
  sync_updated_at: Scalars['timestamptz'];
  tagline?: Maybe<Scalars['String']>;
  /** The teams that the project is a part of */
  teams?: Maybe<Array<Teams>>;
  tech_details?: Maybe<Scalars['jsonb']>;
  ua_views: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_hackathons: Array<User_Hackathons>;
  /** An aggregate relationship */
  user_hackathons_aggregate: User_Hackathons_Aggregate;
  /** An array relationship */
  user_projects: Array<User_Projects>;
  /** An aggregate relationship */
  user_projects_aggregate: User_Projects_Aggregate;
  uuid: Scalars['String'];
  video_url?: Maybe<Scalars['String']>;
  views?: Maybe<Scalars['Int']>;
  /** An array relationship */
  winning_prizes: Array<Winners>;
  /** An aggregate relationship */
  winning_prizes_aggregate: Winners_Aggregate;
};


/** columns and relationships of "projects" */
export type ProjectsBuildersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsCommitsArgs = {
  distinct_on?: InputMaybe<Array<Project_Commits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Commits_Order_By>>;
  where?: InputMaybe<Project_Commits_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsCommits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Commits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Commits_Order_By>>;
  where?: InputMaybe<Project_Commits_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsDescriptionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "projects" */
export type ProjectsHackathonsArgs = {
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsHashtagsArgs = {
  distinct_on?: InputMaybe<Array<Project_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Hashtags_Order_By>>;
  where?: InputMaybe<Project_Hashtags_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsHashtags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Hashtags_Order_By>>;
  where?: InputMaybe<Project_Hashtags_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsPlatformsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Project_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reports_Order_By>>;
  where?: InputMaybe<Project_Reports_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reports_Order_By>>;
  where?: InputMaybe<Project_Reports_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_TracksArgs = {
  distinct_on?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Tracks_Order_By>>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Tracks_Order_By>>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsQuadratic_VotingsArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Projects_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsQuadratic_Votings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Projects_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsSponsor_JudgmentsArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsSponsor_Judgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsTech_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "projects" */
export type ProjectsUser_HackathonsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsUser_Hackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsUser_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<User_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Projects_Order_By>>;
  where?: InputMaybe<User_Projects_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsUser_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Projects_Order_By>>;
  where?: InputMaybe<User_Projects_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsWinning_PrizesArgs = {
  distinct_on?: InputMaybe<Array<Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Winners_Order_By>>;
  where?: InputMaybe<Winners_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsWinning_Prizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Winners_Order_By>>;
  where?: InputMaybe<Winners_Bool_Exp>;
};

/** aggregated selection of "projects" */
export type Projects_Aggregate = {
  __typename?: 'projects_aggregate';
  aggregate?: Maybe<Projects_Aggregate_Fields>;
  nodes: Array<Projects>;
};

/** aggregate fields of "projects" */
export type Projects_Aggregate_Fields = {
  __typename?: 'projects_aggregate_fields';
  avg?: Maybe<Projects_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Projects_Max_Fields>;
  min?: Maybe<Projects_Min_Fields>;
  stddev?: Maybe<Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Projects_Sum_Fields>;
  var_pop?: Maybe<Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Projects_Var_Samp_Fields>;
  variance?: Maybe<Projects_Variance_Fields>;
};


/** aggregate fields of "projects" */
export type Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "projects" */
export type Projects_Aggregate_Order_By = {
  avg?: InputMaybe<Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Projects_Max_Order_By>;
  min?: InputMaybe<Projects_Min_Order_By>;
  stddev?: InputMaybe<Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Projects_Sum_Order_By>;
  var_pop?: InputMaybe<Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<Projects_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Projects_Append_Input = {
  description?: InputMaybe<Scalars['jsonb']>;
  platforms?: InputMaybe<Scalars['jsonb']>;
  tech_details?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Projects_Avg_Fields = {
  __typename?: 'projects_avg_fields';
  experience_id?: Maybe<Scalars['Float']>;
  flagging_admin_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  likes?: Maybe<Scalars['Float']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['Float']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['Float']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  ua_views?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "projects" */
export type Projects_Avg_Order_By = {
  experience_id?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "projects". All fields are combined with a logical 'AND'. */
export type Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Bool_Exp>>;
  _cover_img?: InputMaybe<String_Comparison_Exp>;
  _favicon?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Bool_Exp>>;
  apply_for_network_school_fellowship_prize?: InputMaybe<Boolean_Comparison_Exp>;
  architecture_diagram?: InputMaybe<String_Comparison_Exp>;
  banned?: InputMaybe<Boolean_Comparison_Exp>;
  builders?: InputMaybe<Users_Bool_Exp>;
  by_student_team?: InputMaybe<Boolean_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Bool_Exp>;
  commits?: InputMaybe<Project_Commits_Bool_Exp>;
  commits_aggregate?: InputMaybe<Project_Commits_Aggregate_Bool_Exp>;
  community_expo_location?: InputMaybe<String_Comparison_Exp>;
  community_expo_opt_in?: InputMaybe<Boolean_Comparison_Exp>;
  community_expo_opt_in_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  cover_img?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  demo_url?: InputMaybe<String_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<Jsonb_Comparison_Exp>;
  discover?: InputMaybe<Boolean_Comparison_Exp>;
  eligible_for_prizing?: InputMaybe<Boolean_Comparison_Exp>;
  emoji?: InputMaybe<String_Comparison_Exp>;
  experience_id?: InputMaybe<Int_Comparison_Exp>;
  favicon?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<String_Comparison_Exp>;
  flagged?: InputMaybe<Boolean_Comparison_Exp>;
  flagging_admin_id?: InputMaybe<Int_Comparison_Exp>;
  funding?: InputMaybe<Projects_Funding_Bool_Exp>;
  hackathons?: InputMaybe<Hackathons_Bool_Exp>;
  hashtags?: InputMaybe<Project_Hashtags_Bool_Exp>;
  hashtags_aggregate?: InputMaybe<Project_Hashtags_Aggregate_Bool_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  idea_id?: InputMaybe<Int_Comparison_Exp>;
  is_project_accepting_funding?: InputMaybe<String_Comparison_Exp>;
  judging_submission_type?: InputMaybe<Project_Judging_Submission_Type_Enum_Comparison_Exp>;
  likes?: InputMaybe<Int_Comparison_Exp>;
  links?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  pictures?: InputMaybe<String_Comparison_Exp>;
  platforms?: InputMaybe<Jsonb_Comparison_Exp>;
  project_reports?: InputMaybe<Project_Reports_Bool_Exp>;
  project_reports_aggregate?: InputMaybe<Project_Reports_Aggregate_Bool_Exp>;
  project_tracks?: InputMaybe<Project_Tracks_Bool_Exp>;
  project_tracks_aggregate?: InputMaybe<Project_Tracks_Aggregate_Bool_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  quadratic_voting_prize_pool_distribution?: InputMaybe<Numeric_Comparison_Exp>;
  quadratic_voting_quadratic_votes?: InputMaybe<Numeric_Comparison_Exp>;
  quadratic_voting_votes?: InputMaybe<Numeric_Comparison_Exp>;
  quadratic_votings?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
  quadratic_votings_aggregate?: InputMaybe<Quadratic_Voting_Projects_Aggregate_Bool_Exp>;
  report?: InputMaybe<Project_Reports_Bool_Exp>;
  report_id?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<Citext_Comparison_Exp>;
  source_code_url?: InputMaybe<String_Comparison_Exp>;
  sponsor_judgments?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
  sponsor_judgments_aggregate?: InputMaybe<Sponsor_Judgments_Aggregate_Bool_Exp>;
  status?: InputMaybe<Projects_Status_Enum_Comparison_Exp>;
  sync_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  tagline?: InputMaybe<String_Comparison_Exp>;
  teams?: InputMaybe<Teams_Bool_Exp>;
  tech_details?: InputMaybe<Jsonb_Comparison_Exp>;
  ua_views?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_hackathons?: InputMaybe<User_Hackathons_Bool_Exp>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Bool_Exp>;
  user_projects?: InputMaybe<User_Projects_Bool_Exp>;
  user_projects_aggregate?: InputMaybe<User_Projects_Aggregate_Bool_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  video_url?: InputMaybe<String_Comparison_Exp>;
  views?: InputMaybe<Int_Comparison_Exp>;
  winning_prizes?: InputMaybe<Winners_Bool_Exp>;
  winning_prizes_aggregate?: InputMaybe<Winners_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "projects" */
export enum Projects_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProjects = 'pk_projects',
  /** unique or primary key constraint on columns "slug" */
  UniqueSlugProjects = 'unique_slug_projects',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidProjects = 'unique_uuid_projects'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Projects_Delete_At_Path_Input = {
  description?: InputMaybe<Array<Scalars['String']>>;
  platforms?: InputMaybe<Array<Scalars['String']>>;
  tech_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Projects_Delete_Elem_Input = {
  description?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Scalars['Int']>;
  tech_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Projects_Delete_Key_Input = {
  description?: InputMaybe<Scalars['String']>;
  platforms?: InputMaybe<Scalars['String']>;
  tech_details?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "projects_funding" */
export type Projects_Funding = {
  __typename?: 'projects_funding';
  accepting_funding?: Maybe<Scalars['Boolean']>;
  amount_eth: Scalars['numeric'];
  contribution_count?: Maybe<Scalars['Int']>;
  /** An array relationship */
  contributions: Array<Project_Contributions>;
  /** An aggregate relationship */
  contributions_aggregate: Project_Contributions_Aggregate;
  created_at: Scalars['timestamptz'];
  devfolio_matched_amount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  project_id: Scalars['Int'];
  public_contribution_amount?: Maybe<Scalars['Int']>;
  root_quadratic_amount?: Maybe<Scalars['numeric']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "projects_funding" */
export type Projects_FundingContributionsArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Order_By>>;
  where?: InputMaybe<Project_Contributions_Bool_Exp>;
};


/** columns and relationships of "projects_funding" */
export type Projects_FundingContributions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Order_By>>;
  where?: InputMaybe<Project_Contributions_Bool_Exp>;
};

/** aggregated selection of "projects_funding" */
export type Projects_Funding_Aggregate = {
  __typename?: 'projects_funding_aggregate';
  aggregate?: Maybe<Projects_Funding_Aggregate_Fields>;
  nodes: Array<Projects_Funding>;
};

/** aggregate fields of "projects_funding" */
export type Projects_Funding_Aggregate_Fields = {
  __typename?: 'projects_funding_aggregate_fields';
  avg?: Maybe<Projects_Funding_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Projects_Funding_Max_Fields>;
  min?: Maybe<Projects_Funding_Min_Fields>;
  stddev?: Maybe<Projects_Funding_Stddev_Fields>;
  stddev_pop?: Maybe<Projects_Funding_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Projects_Funding_Stddev_Samp_Fields>;
  sum?: Maybe<Projects_Funding_Sum_Fields>;
  var_pop?: Maybe<Projects_Funding_Var_Pop_Fields>;
  var_samp?: Maybe<Projects_Funding_Var_Samp_Fields>;
  variance?: Maybe<Projects_Funding_Variance_Fields>;
};


/** aggregate fields of "projects_funding" */
export type Projects_Funding_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Funding_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Projects_Funding_Avg_Fields = {
  __typename?: 'projects_funding_avg_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  contribution_count?: Maybe<Scalars['Float']>;
  devfolio_matched_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  public_contribution_amount?: Maybe<Scalars['Float']>;
  root_quadratic_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "projects_funding". All fields are combined with a logical 'AND'. */
export type Projects_Funding_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Funding_Bool_Exp>>;
  _not?: InputMaybe<Projects_Funding_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Funding_Bool_Exp>>;
  accepting_funding?: InputMaybe<Boolean_Comparison_Exp>;
  amount_eth?: InputMaybe<Numeric_Comparison_Exp>;
  contribution_count?: InputMaybe<Int_Comparison_Exp>;
  contributions?: InputMaybe<Project_Contributions_Bool_Exp>;
  contributions_aggregate?: InputMaybe<Project_Contributions_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  devfolio_matched_amount?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  public_contribution_amount?: InputMaybe<Int_Comparison_Exp>;
  root_quadratic_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "projects_funding" */
export enum Projects_Funding_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProjectsFunding = 'pk_projects_funding',
  /** unique or primary key constraint on columns "project_id" */
  UniqueProjectIdProjectsFunding = 'unique_project_id_projects_funding'
}

/** input type for incrementing numeric columns in table "projects_funding" */
export type Projects_Funding_Inc_Input = {
  amount_eth?: InputMaybe<Scalars['numeric']>;
  contribution_count?: InputMaybe<Scalars['Int']>;
  devfolio_matched_amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  public_contribution_amount?: InputMaybe<Scalars['Int']>;
  root_quadratic_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "projects_funding" */
export type Projects_Funding_Insert_Input = {
  accepting_funding?: InputMaybe<Scalars['Boolean']>;
  amount_eth?: InputMaybe<Scalars['numeric']>;
  contribution_count?: InputMaybe<Scalars['Int']>;
  contributions?: InputMaybe<Project_Contributions_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devfolio_matched_amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  public_contribution_amount?: InputMaybe<Scalars['Int']>;
  root_quadratic_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Projects_Funding_Max_Fields = {
  __typename?: 'projects_funding_max_fields';
  amount_eth?: Maybe<Scalars['numeric']>;
  contribution_count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  devfolio_matched_amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  public_contribution_amount?: Maybe<Scalars['Int']>;
  root_quadratic_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Projects_Funding_Min_Fields = {
  __typename?: 'projects_funding_min_fields';
  amount_eth?: Maybe<Scalars['numeric']>;
  contribution_count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  devfolio_matched_amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  public_contribution_amount?: Maybe<Scalars['Int']>;
  root_quadratic_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "projects_funding" */
export type Projects_Funding_Mutation_Response = {
  __typename?: 'projects_funding_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Projects_Funding>;
};

/** input type for inserting object relation for remote table "projects_funding" */
export type Projects_Funding_Obj_Rel_Insert_Input = {
  data: Projects_Funding_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_Funding_On_Conflict>;
};

/** on_conflict condition type for table "projects_funding" */
export type Projects_Funding_On_Conflict = {
  constraint: Projects_Funding_Constraint;
  update_columns?: Array<Projects_Funding_Update_Column>;
  where?: InputMaybe<Projects_Funding_Bool_Exp>;
};

/** Ordering options when selecting data from "projects_funding". */
export type Projects_Funding_Order_By = {
  accepting_funding?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  contribution_count?: InputMaybe<Order_By>;
  contributions_aggregate?: InputMaybe<Project_Contributions_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  devfolio_matched_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  public_contribution_amount?: InputMaybe<Order_By>;
  root_quadratic_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: projects_funding */
export type Projects_Funding_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "projects_funding" */
export enum Projects_Funding_Select_Column {
  /** column name */
  AcceptingFunding = 'accepting_funding',
  /** column name */
  AmountEth = 'amount_eth',
  /** column name */
  ContributionCount = 'contribution_count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevfolioMatchedAmount = 'devfolio_matched_amount',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  PublicContributionAmount = 'public_contribution_amount',
  /** column name */
  RootQuadraticAmount = 'root_quadratic_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "projects_funding" */
export type Projects_Funding_Set_Input = {
  accepting_funding?: InputMaybe<Scalars['Boolean']>;
  amount_eth?: InputMaybe<Scalars['numeric']>;
  contribution_count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devfolio_matched_amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  public_contribution_amount?: InputMaybe<Scalars['Int']>;
  root_quadratic_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Projects_Funding_Stddev_Fields = {
  __typename?: 'projects_funding_stddev_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  contribution_count?: Maybe<Scalars['Float']>;
  devfolio_matched_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  public_contribution_amount?: Maybe<Scalars['Float']>;
  root_quadratic_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Projects_Funding_Stddev_Pop_Fields = {
  __typename?: 'projects_funding_stddev_pop_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  contribution_count?: Maybe<Scalars['Float']>;
  devfolio_matched_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  public_contribution_amount?: Maybe<Scalars['Float']>;
  root_quadratic_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Projects_Funding_Stddev_Samp_Fields = {
  __typename?: 'projects_funding_stddev_samp_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  contribution_count?: Maybe<Scalars['Float']>;
  devfolio_matched_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  public_contribution_amount?: Maybe<Scalars['Float']>;
  root_quadratic_amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "projects_funding" */
export type Projects_Funding_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projects_Funding_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projects_Funding_Stream_Cursor_Value_Input = {
  accepting_funding?: InputMaybe<Scalars['Boolean']>;
  amount_eth?: InputMaybe<Scalars['numeric']>;
  contribution_count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devfolio_matched_amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  public_contribution_amount?: InputMaybe<Scalars['Int']>;
  root_quadratic_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Projects_Funding_Sum_Fields = {
  __typename?: 'projects_funding_sum_fields';
  amount_eth?: Maybe<Scalars['numeric']>;
  contribution_count?: Maybe<Scalars['Int']>;
  devfolio_matched_amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  public_contribution_amount?: Maybe<Scalars['Int']>;
  root_quadratic_amount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "projects_funding" */
export enum Projects_Funding_Update_Column {
  /** column name */
  AcceptingFunding = 'accepting_funding',
  /** column name */
  AmountEth = 'amount_eth',
  /** column name */
  ContributionCount = 'contribution_count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevfolioMatchedAmount = 'devfolio_matched_amount',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  PublicContributionAmount = 'public_contribution_amount',
  /** column name */
  RootQuadraticAmount = 'root_quadratic_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Projects_Funding_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Projects_Funding_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Projects_Funding_Set_Input>;
  /** filter the rows which have to be updated */
  where: Projects_Funding_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Projects_Funding_Var_Pop_Fields = {
  __typename?: 'projects_funding_var_pop_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  contribution_count?: Maybe<Scalars['Float']>;
  devfolio_matched_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  public_contribution_amount?: Maybe<Scalars['Float']>;
  root_quadratic_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Projects_Funding_Var_Samp_Fields = {
  __typename?: 'projects_funding_var_samp_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  contribution_count?: Maybe<Scalars['Float']>;
  devfolio_matched_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  public_contribution_amount?: Maybe<Scalars['Float']>;
  root_quadratic_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Projects_Funding_Variance_Fields = {
  __typename?: 'projects_funding_variance_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  contribution_count?: Maybe<Scalars['Float']>;
  devfolio_matched_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  public_contribution_amount?: Maybe<Scalars['Float']>;
  root_quadratic_amount?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "projects" */
export type Projects_Inc_Input = {
  experience_id?: InputMaybe<Scalars['Int']>;
  flagging_admin_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  likes?: InputMaybe<Scalars['Int']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Scalars['numeric']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Scalars['numeric']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Scalars['numeric']>;
  report_id?: InputMaybe<Scalars['Int']>;
  ua_views?: InputMaybe<Scalars['Int']>;
  views?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "projects" */
export type Projects_Insert_Input = {
  apply_for_network_school_fellowship_prize?: InputMaybe<Scalars['Boolean']>;
  architecture_diagram?: InputMaybe<Scalars['String']>;
  banned?: InputMaybe<Scalars['Boolean']>;
  by_student_team?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  commits?: InputMaybe<Project_Commits_Arr_Rel_Insert_Input>;
  community_expo_location?: InputMaybe<Scalars['String']>;
  community_expo_opt_in?: InputMaybe<Scalars['Boolean']>;
  community_expo_opt_in_time?: InputMaybe<Scalars['timestamptz']>;
  cover_img?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  demo_url?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  eligible_for_prizing?: InputMaybe<Scalars['Boolean']>;
  emoji?: InputMaybe<Scalars['String']>;
  experience_id?: InputMaybe<Scalars['Int']>;
  /** This field stores the favicon image location for the project */
  favicon?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['String']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  flagging_admin_id?: InputMaybe<Scalars['Int']>;
  funding?: InputMaybe<Projects_Funding_Obj_Rel_Insert_Input>;
  hashtags?: InputMaybe<Project_Hashtags_Arr_Rel_Insert_Input>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  judging_submission_type?: InputMaybe<Project_Judging_Submission_Type_Enum>;
  likes?: InputMaybe<Scalars['Int']>;
  links?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pictures?: InputMaybe<Scalars['String']>;
  platforms?: InputMaybe<Scalars['jsonb']>;
  project_reports?: InputMaybe<Project_Reports_Arr_Rel_Insert_Input>;
  project_tracks?: InputMaybe<Project_Tracks_Arr_Rel_Insert_Input>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Scalars['numeric']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Scalars['numeric']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Scalars['numeric']>;
  quadratic_votings?: InputMaybe<Quadratic_Voting_Projects_Arr_Rel_Insert_Input>;
  report?: InputMaybe<Project_Reports_Obj_Rel_Insert_Input>;
  report_id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['citext']>;
  source_code_url?: InputMaybe<Scalars['String']>;
  sponsor_judgments?: InputMaybe<Sponsor_Judgments_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['projects_status_enum']>;
  sync_updated_at?: InputMaybe<Scalars['timestamptz']>;
  tagline?: InputMaybe<Scalars['String']>;
  tech_details?: InputMaybe<Scalars['jsonb']>;
  ua_views?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_hackathons?: InputMaybe<User_Hackathons_Arr_Rel_Insert_Input>;
  user_projects?: InputMaybe<User_Projects_Arr_Rel_Insert_Input>;
  uuid?: InputMaybe<Scalars['String']>;
  video_url?: InputMaybe<Scalars['String']>;
  views?: InputMaybe<Scalars['Int']>;
  winning_prizes?: InputMaybe<Winners_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Projects_Max_Fields = {
  __typename?: 'projects_max_fields';
  architecture_diagram?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  community_expo_location?: Maybe<Scalars['String']>;
  community_expo_opt_in_time?: Maybe<Scalars['timestamptz']>;
  cover_img?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  demo_url?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  emoji?: Maybe<Scalars['String']>;
  experience_id?: Maybe<Scalars['Int']>;
  /** This field stores the favicon image location for the project */
  favicon?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  flagging_admin_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  idea_id?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  links?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pictures?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['numeric']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['numeric']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['numeric']>;
  report_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['citext']>;
  source_code_url?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['projects_status_enum']>;
  sync_updated_at?: Maybe<Scalars['timestamptz']>;
  tagline?: Maybe<Scalars['String']>;
  ua_views?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
  views?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "projects" */
export type Projects_Max_Order_By = {
  architecture_diagram?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  community_expo_location?: InputMaybe<Order_By>;
  community_expo_opt_in_time?: InputMaybe<Order_By>;
  cover_img?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  demo_url?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  emoji?: InputMaybe<Order_By>;
  experience_id?: InputMaybe<Order_By>;
  /** This field stores the favicon image location for the project */
  favicon?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  links?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pictures?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  source_code_url?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sync_updated_at?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Projects_Min_Fields = {
  __typename?: 'projects_min_fields';
  architecture_diagram?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  community_expo_location?: Maybe<Scalars['String']>;
  community_expo_opt_in_time?: Maybe<Scalars['timestamptz']>;
  cover_img?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  demo_url?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  emoji?: Maybe<Scalars['String']>;
  experience_id?: Maybe<Scalars['Int']>;
  /** This field stores the favicon image location for the project */
  favicon?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  flagging_admin_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  idea_id?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  links?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pictures?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['numeric']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['numeric']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['numeric']>;
  report_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['citext']>;
  source_code_url?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['projects_status_enum']>;
  sync_updated_at?: Maybe<Scalars['timestamptz']>;
  tagline?: Maybe<Scalars['String']>;
  ua_views?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
  views?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "projects" */
export type Projects_Min_Order_By = {
  architecture_diagram?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  community_expo_location?: InputMaybe<Order_By>;
  community_expo_opt_in_time?: InputMaybe<Order_By>;
  cover_img?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  demo_url?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  emoji?: InputMaybe<Order_By>;
  experience_id?: InputMaybe<Order_By>;
  /** This field stores the favicon image location for the project */
  favicon?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  links?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pictures?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  source_code_url?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sync_updated_at?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "projects" */
export type Projects_Mutation_Response = {
  __typename?: 'projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Projects>;
};

/** input type for inserting object relation for remote table "projects" */
export type Projects_Obj_Rel_Insert_Input = {
  data: Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};

/** on_conflict condition type for table "projects" */
export type Projects_On_Conflict = {
  constraint: Projects_Constraint;
  update_columns?: Array<Projects_Update_Column>;
  where?: InputMaybe<Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "projects". */
export type Projects_Order_By = {
  _cover_img?: InputMaybe<Order_By>;
  _favicon?: InputMaybe<Order_By>;
  apply_for_network_school_fellowship_prize?: InputMaybe<Order_By>;
  architecture_diagram?: InputMaybe<Order_By>;
  banned?: InputMaybe<Order_By>;
  builders_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  by_student_team?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  commits_aggregate?: InputMaybe<Project_Commits_Aggregate_Order_By>;
  community_expo_location?: InputMaybe<Order_By>;
  community_expo_opt_in?: InputMaybe<Order_By>;
  community_expo_opt_in_time?: InputMaybe<Order_By>;
  cover_img?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  demo_url?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discover?: InputMaybe<Order_By>;
  eligible_for_prizing?: InputMaybe<Order_By>;
  emoji?: InputMaybe<Order_By>;
  experience_id?: InputMaybe<Order_By>;
  favicon?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  flagged?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  funding?: InputMaybe<Projects_Funding_Order_By>;
  hackathons_aggregate?: InputMaybe<Hackathons_Aggregate_Order_By>;
  hashtags_aggregate?: InputMaybe<Project_Hashtags_Aggregate_Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  is_project_accepting_funding?: InputMaybe<Order_By>;
  judging_submission_type?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  links?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pictures?: InputMaybe<Order_By>;
  platforms?: InputMaybe<Order_By>;
  project_reports_aggregate?: InputMaybe<Project_Reports_Aggregate_Order_By>;
  project_tracks_aggregate?: InputMaybe<Project_Tracks_Aggregate_Order_By>;
  published_at?: InputMaybe<Order_By>;
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  quadratic_voting_votes?: InputMaybe<Order_By>;
  quadratic_votings_aggregate?: InputMaybe<Quadratic_Voting_Projects_Aggregate_Order_By>;
  report?: InputMaybe<Project_Reports_Order_By>;
  report_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  source_code_url?: InputMaybe<Order_By>;
  sponsor_judgments_aggregate?: InputMaybe<Sponsor_Judgments_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  sync_updated_at?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  tech_details?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Order_By>;
  user_projects_aggregate?: InputMaybe<User_Projects_Aggregate_Order_By>;
  uuid?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
  winning_prizes_aggregate?: InputMaybe<Winners_Aggregate_Order_By>;
};

/** primary key columns input for table: projects */
export type Projects_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Projects_Prepend_Input = {
  description?: InputMaybe<Scalars['jsonb']>;
  platforms?: InputMaybe<Scalars['jsonb']>;
  tech_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "projects" */
export enum Projects_Select_Column {
  /** column name */
  ApplyForNetworkSchoolFellowshipPrize = 'apply_for_network_school_fellowship_prize',
  /** column name */
  ArchitectureDiagram = 'architecture_diagram',
  /** column name */
  Banned = 'banned',
  /** column name */
  ByStudentTeam = 'by_student_team',
  /** column name */
  Category = 'category',
  /** column name */
  CommunityExpoLocation = 'community_expo_location',
  /** column name */
  CommunityExpoOptIn = 'community_expo_opt_in',
  /** column name */
  CommunityExpoOptInTime = 'community_expo_opt_in_time',
  /** column name */
  CoverImg = 'cover_img',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DemoUrl = 'demo_url',
  /** column name */
  Desc = 'desc',
  /** column name */
  Description = 'description',
  /** column name */
  Discover = 'discover',
  /** column name */
  EligibleForPrizing = 'eligible_for_prizing',
  /** column name */
  Emoji = 'emoji',
  /** column name */
  ExperienceId = 'experience_id',
  /** column name */
  Favicon = 'favicon',
  /** column name */
  File = 'file',
  /** column name */
  Flagged = 'flagged',
  /** column name */
  FlaggingAdminId = 'flagging_admin_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IdeaId = 'idea_id',
  /** column name */
  JudgingSubmissionType = 'judging_submission_type',
  /** column name */
  Likes = 'likes',
  /** column name */
  Links = 'links',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  Pictures = 'pictures',
  /** column name */
  Platforms = 'platforms',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  QuadraticVotingPrizePoolDistribution = 'quadratic_voting_prize_pool_distribution',
  /** column name */
  QuadraticVotingQuadraticVotes = 'quadratic_voting_quadratic_votes',
  /** column name */
  QuadraticVotingVotes = 'quadratic_voting_votes',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  SourceCodeUrl = 'source_code_url',
  /** column name */
  Status = 'status',
  /** column name */
  SyncUpdatedAt = 'sync_updated_at',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  TechDetails = 'tech_details',
  /** column name */
  UaViews = 'ua_views',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  Views = 'views'
}

/** input type for updating data in table "projects" */
export type Projects_Set_Input = {
  apply_for_network_school_fellowship_prize?: InputMaybe<Scalars['Boolean']>;
  architecture_diagram?: InputMaybe<Scalars['String']>;
  banned?: InputMaybe<Scalars['Boolean']>;
  by_student_team?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Scalars['String']>;
  community_expo_location?: InputMaybe<Scalars['String']>;
  community_expo_opt_in?: InputMaybe<Scalars['Boolean']>;
  community_expo_opt_in_time?: InputMaybe<Scalars['timestamptz']>;
  cover_img?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  demo_url?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  eligible_for_prizing?: InputMaybe<Scalars['Boolean']>;
  emoji?: InputMaybe<Scalars['String']>;
  experience_id?: InputMaybe<Scalars['Int']>;
  /** This field stores the favicon image location for the project */
  favicon?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['String']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  flagging_admin_id?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  judging_submission_type?: InputMaybe<Project_Judging_Submission_Type_Enum>;
  likes?: InputMaybe<Scalars['Int']>;
  links?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pictures?: InputMaybe<Scalars['String']>;
  platforms?: InputMaybe<Scalars['jsonb']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Scalars['numeric']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Scalars['numeric']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Scalars['numeric']>;
  report_id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['citext']>;
  source_code_url?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['projects_status_enum']>;
  sync_updated_at?: InputMaybe<Scalars['timestamptz']>;
  tagline?: InputMaybe<Scalars['String']>;
  tech_details?: InputMaybe<Scalars['jsonb']>;
  ua_views?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  video_url?: InputMaybe<Scalars['String']>;
  views?: InputMaybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "projects_status_enum". All fields are combined with logical 'AND'. */
export type Projects_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['projects_status_enum']>;
  _gt?: InputMaybe<Scalars['projects_status_enum']>;
  _gte?: InputMaybe<Scalars['projects_status_enum']>;
  _in?: InputMaybe<Array<Scalars['projects_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['projects_status_enum']>;
  _lte?: InputMaybe<Scalars['projects_status_enum']>;
  _neq?: InputMaybe<Scalars['projects_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['projects_status_enum']>>;
};

/** aggregate stddev on columns */
export type Projects_Stddev_Fields = {
  __typename?: 'projects_stddev_fields';
  experience_id?: Maybe<Scalars['Float']>;
  flagging_admin_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  likes?: Maybe<Scalars['Float']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['Float']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['Float']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  ua_views?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "projects" */
export type Projects_Stddev_Order_By = {
  experience_id?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Projects_Stddev_Pop_Fields = {
  __typename?: 'projects_stddev_pop_fields';
  experience_id?: Maybe<Scalars['Float']>;
  flagging_admin_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  likes?: Maybe<Scalars['Float']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['Float']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['Float']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  ua_views?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "projects" */
export type Projects_Stddev_Pop_Order_By = {
  experience_id?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Projects_Stddev_Samp_Fields = {
  __typename?: 'projects_stddev_samp_fields';
  experience_id?: Maybe<Scalars['Float']>;
  flagging_admin_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  likes?: Maybe<Scalars['Float']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['Float']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['Float']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  ua_views?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "projects" */
export type Projects_Stddev_Samp_Order_By = {
  experience_id?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projects" */
export type Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projects_Stream_Cursor_Value_Input = {
  apply_for_network_school_fellowship_prize?: InputMaybe<Scalars['Boolean']>;
  architecture_diagram?: InputMaybe<Scalars['String']>;
  banned?: InputMaybe<Scalars['Boolean']>;
  by_student_team?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Scalars['String']>;
  community_expo_location?: InputMaybe<Scalars['String']>;
  community_expo_opt_in?: InputMaybe<Scalars['Boolean']>;
  community_expo_opt_in_time?: InputMaybe<Scalars['timestamptz']>;
  cover_img?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  demo_url?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  eligible_for_prizing?: InputMaybe<Scalars['Boolean']>;
  emoji?: InputMaybe<Scalars['String']>;
  experience_id?: InputMaybe<Scalars['Int']>;
  /** This field stores the favicon image location for the project */
  favicon?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['String']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  flagging_admin_id?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  judging_submission_type?: InputMaybe<Project_Judging_Submission_Type_Enum>;
  likes?: InputMaybe<Scalars['Int']>;
  links?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pictures?: InputMaybe<Scalars['String']>;
  platforms?: InputMaybe<Scalars['jsonb']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Scalars['numeric']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Scalars['numeric']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Scalars['numeric']>;
  report_id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['citext']>;
  source_code_url?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['projects_status_enum']>;
  sync_updated_at?: InputMaybe<Scalars['timestamptz']>;
  tagline?: InputMaybe<Scalars['String']>;
  tech_details?: InputMaybe<Scalars['jsonb']>;
  ua_views?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  video_url?: InputMaybe<Scalars['String']>;
  views?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Projects_Sum_Fields = {
  __typename?: 'projects_sum_fields';
  experience_id?: Maybe<Scalars['Int']>;
  flagging_admin_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  idea_id?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['numeric']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['numeric']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['numeric']>;
  report_id?: Maybe<Scalars['Int']>;
  ua_views?: Maybe<Scalars['Int']>;
  views?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "projects" */
export type Projects_Sum_Order_By = {
  experience_id?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** update columns of table "projects" */
export enum Projects_Update_Column {
  /** column name */
  ApplyForNetworkSchoolFellowshipPrize = 'apply_for_network_school_fellowship_prize',
  /** column name */
  ArchitectureDiagram = 'architecture_diagram',
  /** column name */
  Banned = 'banned',
  /** column name */
  ByStudentTeam = 'by_student_team',
  /** column name */
  Category = 'category',
  /** column name */
  CommunityExpoLocation = 'community_expo_location',
  /** column name */
  CommunityExpoOptIn = 'community_expo_opt_in',
  /** column name */
  CommunityExpoOptInTime = 'community_expo_opt_in_time',
  /** column name */
  CoverImg = 'cover_img',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DemoUrl = 'demo_url',
  /** column name */
  Desc = 'desc',
  /** column name */
  Description = 'description',
  /** column name */
  Discover = 'discover',
  /** column name */
  EligibleForPrizing = 'eligible_for_prizing',
  /** column name */
  Emoji = 'emoji',
  /** column name */
  ExperienceId = 'experience_id',
  /** column name */
  Favicon = 'favicon',
  /** column name */
  File = 'file',
  /** column name */
  Flagged = 'flagged',
  /** column name */
  FlaggingAdminId = 'flagging_admin_id',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IdeaId = 'idea_id',
  /** column name */
  JudgingSubmissionType = 'judging_submission_type',
  /** column name */
  Likes = 'likes',
  /** column name */
  Links = 'links',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  Pictures = 'pictures',
  /** column name */
  Platforms = 'platforms',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  QuadraticVotingPrizePoolDistribution = 'quadratic_voting_prize_pool_distribution',
  /** column name */
  QuadraticVotingQuadraticVotes = 'quadratic_voting_quadratic_votes',
  /** column name */
  QuadraticVotingVotes = 'quadratic_voting_votes',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  SourceCodeUrl = 'source_code_url',
  /** column name */
  Status = 'status',
  /** column name */
  SyncUpdatedAt = 'sync_updated_at',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  TechDetails = 'tech_details',
  /** column name */
  UaViews = 'ua_views',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  Views = 'views'
}

export type Projects_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Projects_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Projects_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Projects_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Projects_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Projects_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Projects_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Projects_Var_Pop_Fields = {
  __typename?: 'projects_var_pop_fields';
  experience_id?: Maybe<Scalars['Float']>;
  flagging_admin_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  likes?: Maybe<Scalars['Float']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['Float']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['Float']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  ua_views?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "projects" */
export type Projects_Var_Pop_Order_By = {
  experience_id?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Projects_Var_Samp_Fields = {
  __typename?: 'projects_var_samp_fields';
  experience_id?: Maybe<Scalars['Float']>;
  flagging_admin_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  likes?: Maybe<Scalars['Float']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['Float']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['Float']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  ua_views?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "projects" */
export type Projects_Var_Samp_Order_By = {
  experience_id?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Projects_Variance_Fields = {
  __typename?: 'projects_variance_fields';
  experience_id?: Maybe<Scalars['Float']>;
  flagging_admin_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  idea_id?: Maybe<Scalars['Float']>;
  likes?: Maybe<Scalars['Float']>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: Maybe<Scalars['Float']>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: Maybe<Scalars['Float']>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  ua_views?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "projects" */
export type Projects_Variance_Order_By = {
  experience_id?: InputMaybe<Order_By>;
  flagging_admin_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idea_id?: InputMaybe<Order_By>;
  likes?: InputMaybe<Order_By>;
  /** The distribution ratio derived from the quadratic voting */
  quadratic_voting_prize_pool_distribution?: InputMaybe<Order_By>;
  /** The quadratic votes that the project received */
  quadratic_voting_quadratic_votes?: InputMaybe<Order_By>;
  /** The linear sum of all the votes that the project received */
  quadratic_voting_votes?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  ua_views?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** columns and relationships of "quadratic_voting" */
export type Quadratic_Voting = {
  __typename?: 'quadratic_voting';
  created_at: Scalars['timestamptz'];
  /** The raw JSONB value of the attestation */
  eas_details?: Maybe<Scalars['jsonb']>;
  /** The uuid of the EAS Attestation */
  eas_uuid?: Maybe<Scalars['String']>;
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An array relationship */
  projects: Array<Quadratic_Voting_Projects>;
  /** An aggregate relationship */
  projects_aggregate: Quadratic_Voting_Projects_Aggregate;
  /** The hash of the transaction in which this attestation is done */
  tx_hash?: Maybe<Scalars['String']>;
  /** The raw metadata of the transaction */
  tx_meta?: Maybe<Scalars['jsonb']>;
  /** The network of the transaction */
  tx_network?: Maybe<Quadratic_Voting_Chain_Enum>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};


/** columns and relationships of "quadratic_voting" */
export type Quadratic_VotingEas_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "quadratic_voting" */
export type Quadratic_VotingProjectsArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Projects_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};


/** columns and relationships of "quadratic_voting" */
export type Quadratic_VotingProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Projects_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};


/** columns and relationships of "quadratic_voting" */
export type Quadratic_VotingTx_MetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "quadratic_voting" */
export type Quadratic_Voting_Aggregate = {
  __typename?: 'quadratic_voting_aggregate';
  aggregate?: Maybe<Quadratic_Voting_Aggregate_Fields>;
  nodes: Array<Quadratic_Voting>;
};

/** aggregate fields of "quadratic_voting" */
export type Quadratic_Voting_Aggregate_Fields = {
  __typename?: 'quadratic_voting_aggregate_fields';
  avg?: Maybe<Quadratic_Voting_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quadratic_Voting_Max_Fields>;
  min?: Maybe<Quadratic_Voting_Min_Fields>;
  stddev?: Maybe<Quadratic_Voting_Stddev_Fields>;
  stddev_pop?: Maybe<Quadratic_Voting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quadratic_Voting_Stddev_Samp_Fields>;
  sum?: Maybe<Quadratic_Voting_Sum_Fields>;
  var_pop?: Maybe<Quadratic_Voting_Var_Pop_Fields>;
  var_samp?: Maybe<Quadratic_Voting_Var_Samp_Fields>;
  variance?: Maybe<Quadratic_Voting_Variance_Fields>;
};


/** aggregate fields of "quadratic_voting" */
export type Quadratic_Voting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quadratic_Voting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quadratic_Voting_Append_Input = {
  /** The raw JSONB value of the attestation */
  eas_details?: InputMaybe<Scalars['jsonb']>;
  /** The raw metadata of the transaction */
  tx_meta?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Quadratic_Voting_Avg_Fields = {
  __typename?: 'quadratic_voting_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "quadratic_voting". All fields are combined with a logical 'AND'. */
export type Quadratic_Voting_Bool_Exp = {
  _and?: InputMaybe<Array<Quadratic_Voting_Bool_Exp>>;
  _not?: InputMaybe<Quadratic_Voting_Bool_Exp>;
  _or?: InputMaybe<Array<Quadratic_Voting_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eas_details?: InputMaybe<Jsonb_Comparison_Exp>;
  eas_uuid?: InputMaybe<String_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  projects?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
  projects_aggregate?: InputMaybe<Quadratic_Voting_Projects_Aggregate_Bool_Exp>;
  tx_hash?: InputMaybe<String_Comparison_Exp>;
  tx_meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tx_network?: InputMaybe<Quadratic_Voting_Chain_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "quadratic_voting_chain" */
export type Quadratic_Voting_Chain = {
  __typename?: 'quadratic_voting_chain';
  value: Scalars['String'];
};

/** aggregated selection of "quadratic_voting_chain" */
export type Quadratic_Voting_Chain_Aggregate = {
  __typename?: 'quadratic_voting_chain_aggregate';
  aggregate?: Maybe<Quadratic_Voting_Chain_Aggregate_Fields>;
  nodes: Array<Quadratic_Voting_Chain>;
};

/** aggregate fields of "quadratic_voting_chain" */
export type Quadratic_Voting_Chain_Aggregate_Fields = {
  __typename?: 'quadratic_voting_chain_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Quadratic_Voting_Chain_Max_Fields>;
  min?: Maybe<Quadratic_Voting_Chain_Min_Fields>;
};


/** aggregate fields of "quadratic_voting_chain" */
export type Quadratic_Voting_Chain_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quadratic_Voting_Chain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "quadratic_voting_chain". All fields are combined with a logical 'AND'. */
export type Quadratic_Voting_Chain_Bool_Exp = {
  _and?: InputMaybe<Array<Quadratic_Voting_Chain_Bool_Exp>>;
  _not?: InputMaybe<Quadratic_Voting_Chain_Bool_Exp>;
  _or?: InputMaybe<Array<Quadratic_Voting_Chain_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quadratic_voting_chain" */
export enum Quadratic_Voting_Chain_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuadraticVotingChainPkey = 'quadratic_voting_chain_pkey'
}

export enum Quadratic_Voting_Chain_Enum {
  Arbitrum = 'ARBITRUM',
  Base = 'BASE',
  Mainnet = 'MAINNET',
  Optimism = 'OPTIMISM',
  Sepolia = 'SEPOLIA'
}

/** Boolean expression to compare columns of type "quadratic_voting_chain_enum". All fields are combined with logical 'AND'. */
export type Quadratic_Voting_Chain_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quadratic_Voting_Chain_Enum>;
  _in?: InputMaybe<Array<Quadratic_Voting_Chain_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Quadratic_Voting_Chain_Enum>;
  _nin?: InputMaybe<Array<Quadratic_Voting_Chain_Enum>>;
};

/** input type for inserting data into table "quadratic_voting_chain" */
export type Quadratic_Voting_Chain_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Quadratic_Voting_Chain_Max_Fields = {
  __typename?: 'quadratic_voting_chain_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Quadratic_Voting_Chain_Min_Fields = {
  __typename?: 'quadratic_voting_chain_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quadratic_voting_chain" */
export type Quadratic_Voting_Chain_Mutation_Response = {
  __typename?: 'quadratic_voting_chain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quadratic_Voting_Chain>;
};

/** on_conflict condition type for table "quadratic_voting_chain" */
export type Quadratic_Voting_Chain_On_Conflict = {
  constraint: Quadratic_Voting_Chain_Constraint;
  update_columns?: Array<Quadratic_Voting_Chain_Update_Column>;
  where?: InputMaybe<Quadratic_Voting_Chain_Bool_Exp>;
};

/** Ordering options when selecting data from "quadratic_voting_chain". */
export type Quadratic_Voting_Chain_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quadratic_voting_chain */
export type Quadratic_Voting_Chain_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "quadratic_voting_chain" */
export enum Quadratic_Voting_Chain_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quadratic_voting_chain" */
export type Quadratic_Voting_Chain_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "quadratic_voting_chain" */
export type Quadratic_Voting_Chain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quadratic_Voting_Chain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quadratic_Voting_Chain_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "quadratic_voting_chain" */
export enum Quadratic_Voting_Chain_Update_Column {
  /** column name */
  Value = 'value'
}

export type Quadratic_Voting_Chain_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quadratic_Voting_Chain_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quadratic_Voting_Chain_Bool_Exp;
};

/** unique or primary key constraints on table "quadratic_voting" */
export enum Quadratic_Voting_Constraint {
  /** unique or primary key constraint on columns "user_id", "hackathon_id" */
  QuadraticVotingHackathonIdUserIdKey = 'quadratic_voting_hackathon_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  QuadraticVotingPkey = 'quadratic_voting_pkey',
  /** unique or primary key constraint on columns "uuid" */
  QuadraticVotingUuidKey = 'quadratic_voting_uuid_key'
}

/** columns and relationships of "quadratic_voting_currency" */
export type Quadratic_Voting_Currency = {
  __typename?: 'quadratic_voting_currency';
  value: Scalars['String'];
};

/** aggregated selection of "quadratic_voting_currency" */
export type Quadratic_Voting_Currency_Aggregate = {
  __typename?: 'quadratic_voting_currency_aggregate';
  aggregate?: Maybe<Quadratic_Voting_Currency_Aggregate_Fields>;
  nodes: Array<Quadratic_Voting_Currency>;
};

/** aggregate fields of "quadratic_voting_currency" */
export type Quadratic_Voting_Currency_Aggregate_Fields = {
  __typename?: 'quadratic_voting_currency_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Quadratic_Voting_Currency_Max_Fields>;
  min?: Maybe<Quadratic_Voting_Currency_Min_Fields>;
};


/** aggregate fields of "quadratic_voting_currency" */
export type Quadratic_Voting_Currency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quadratic_Voting_Currency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "quadratic_voting_currency". All fields are combined with a logical 'AND'. */
export type Quadratic_Voting_Currency_Bool_Exp = {
  _and?: InputMaybe<Array<Quadratic_Voting_Currency_Bool_Exp>>;
  _not?: InputMaybe<Quadratic_Voting_Currency_Bool_Exp>;
  _or?: InputMaybe<Array<Quadratic_Voting_Currency_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quadratic_voting_currency" */
export enum Quadratic_Voting_Currency_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuadraticVotingCurrencyPkey = 'quadratic_voting_currency_pkey'
}

export enum Quadratic_Voting_Currency_Enum {
  Eth = 'ETH',
  Spork = 'SPORK',
  Usd = 'USD'
}

/** Boolean expression to compare columns of type "quadratic_voting_currency_enum". All fields are combined with logical 'AND'. */
export type Quadratic_Voting_Currency_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quadratic_Voting_Currency_Enum>;
  _in?: InputMaybe<Array<Quadratic_Voting_Currency_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Quadratic_Voting_Currency_Enum>;
  _nin?: InputMaybe<Array<Quadratic_Voting_Currency_Enum>>;
};

/** input type for inserting data into table "quadratic_voting_currency" */
export type Quadratic_Voting_Currency_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Quadratic_Voting_Currency_Max_Fields = {
  __typename?: 'quadratic_voting_currency_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Quadratic_Voting_Currency_Min_Fields = {
  __typename?: 'quadratic_voting_currency_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quadratic_voting_currency" */
export type Quadratic_Voting_Currency_Mutation_Response = {
  __typename?: 'quadratic_voting_currency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quadratic_Voting_Currency>;
};

/** on_conflict condition type for table "quadratic_voting_currency" */
export type Quadratic_Voting_Currency_On_Conflict = {
  constraint: Quadratic_Voting_Currency_Constraint;
  update_columns?: Array<Quadratic_Voting_Currency_Update_Column>;
  where?: InputMaybe<Quadratic_Voting_Currency_Bool_Exp>;
};

/** Ordering options when selecting data from "quadratic_voting_currency". */
export type Quadratic_Voting_Currency_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quadratic_voting_currency */
export type Quadratic_Voting_Currency_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "quadratic_voting_currency" */
export enum Quadratic_Voting_Currency_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quadratic_voting_currency" */
export type Quadratic_Voting_Currency_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "quadratic_voting_currency" */
export type Quadratic_Voting_Currency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quadratic_Voting_Currency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quadratic_Voting_Currency_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "quadratic_voting_currency" */
export enum Quadratic_Voting_Currency_Update_Column {
  /** column name */
  Value = 'value'
}

export type Quadratic_Voting_Currency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quadratic_Voting_Currency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quadratic_Voting_Currency_Bool_Exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quadratic_Voting_Delete_At_Path_Input = {
  /** The raw JSONB value of the attestation */
  eas_details?: InputMaybe<Array<Scalars['String']>>;
  /** The raw metadata of the transaction */
  tx_meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quadratic_Voting_Delete_Elem_Input = {
  /** The raw JSONB value of the attestation */
  eas_details?: InputMaybe<Scalars['Int']>;
  /** The raw metadata of the transaction */
  tx_meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quadratic_Voting_Delete_Key_Input = {
  /** The raw JSONB value of the attestation */
  eas_details?: InputMaybe<Scalars['String']>;
  /** The raw metadata of the transaction */
  tx_meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "quadratic_voting" */
export type Quadratic_Voting_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "quadratic_voting" */
export type Quadratic_Voting_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** The raw JSONB value of the attestation */
  eas_details?: InputMaybe<Scalars['jsonb']>;
  /** The uuid of the EAS Attestation */
  eas_uuid?: InputMaybe<Scalars['String']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  projects?: InputMaybe<Quadratic_Voting_Projects_Arr_Rel_Insert_Input>;
  /** The hash of the transaction in which this attestation is done */
  tx_hash?: InputMaybe<Scalars['String']>;
  /** The raw metadata of the transaction */
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  /** The network of the transaction */
  tx_network?: InputMaybe<Quadratic_Voting_Chain_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Quadratic_Voting_Max_Fields = {
  __typename?: 'quadratic_voting_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The uuid of the EAS Attestation */
  eas_uuid?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** The hash of the transaction in which this attestation is done */
  tx_hash?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Quadratic_Voting_Min_Fields = {
  __typename?: 'quadratic_voting_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The uuid of the EAS Attestation */
  eas_uuid?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** The hash of the transaction in which this attestation is done */
  tx_hash?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quadratic_voting" */
export type Quadratic_Voting_Mutation_Response = {
  __typename?: 'quadratic_voting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quadratic_Voting>;
};

/** input type for inserting object relation for remote table "quadratic_voting" */
export type Quadratic_Voting_Obj_Rel_Insert_Input = {
  data: Quadratic_Voting_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quadratic_Voting_On_Conflict>;
};

/** on_conflict condition type for table "quadratic_voting" */
export type Quadratic_Voting_On_Conflict = {
  constraint: Quadratic_Voting_Constraint;
  update_columns?: Array<Quadratic_Voting_Update_Column>;
  where?: InputMaybe<Quadratic_Voting_Bool_Exp>;
};

/** Ordering options when selecting data from "quadratic_voting". */
export type Quadratic_Voting_Order_By = {
  created_at?: InputMaybe<Order_By>;
  eas_details?: InputMaybe<Order_By>;
  eas_uuid?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Quadratic_Voting_Projects_Aggregate_Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  tx_meta?: InputMaybe<Order_By>;
  tx_network?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quadratic_voting */
export type Quadratic_Voting_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quadratic_Voting_Prepend_Input = {
  /** The raw JSONB value of the attestation */
  eas_details?: InputMaybe<Scalars['jsonb']>;
  /** The raw metadata of the transaction */
  tx_meta?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "quadratic_voting_projects" */
export type Quadratic_Voting_Projects = {
  __typename?: 'quadratic_voting_projects';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  project?: Maybe<Projects>;
  project_id: Scalars['Int'];
  /** An object relationship */
  quadratic_voting?: Maybe<Quadratic_Voting>;
  quadratic_voting_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
  votes: Scalars['Int'];
};

/** aggregated selection of "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Aggregate = {
  __typename?: 'quadratic_voting_projects_aggregate';
  aggregate?: Maybe<Quadratic_Voting_Projects_Aggregate_Fields>;
  nodes: Array<Quadratic_Voting_Projects>;
};

export type Quadratic_Voting_Projects_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quadratic_Voting_Projects_Aggregate_Bool_Exp_Count>;
};

export type Quadratic_Voting_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Aggregate_Fields = {
  __typename?: 'quadratic_voting_projects_aggregate_fields';
  avg?: Maybe<Quadratic_Voting_Projects_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quadratic_Voting_Projects_Max_Fields>;
  min?: Maybe<Quadratic_Voting_Projects_Min_Fields>;
  stddev?: Maybe<Quadratic_Voting_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Quadratic_Voting_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quadratic_Voting_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Quadratic_Voting_Projects_Sum_Fields>;
  var_pop?: Maybe<Quadratic_Voting_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Quadratic_Voting_Projects_Var_Samp_Fields>;
  variance?: Maybe<Quadratic_Voting_Projects_Variance_Fields>;
};


/** aggregate fields of "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Aggregate_Order_By = {
  avg?: InputMaybe<Quadratic_Voting_Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quadratic_Voting_Projects_Max_Order_By>;
  min?: InputMaybe<Quadratic_Voting_Projects_Min_Order_By>;
  stddev?: InputMaybe<Quadratic_Voting_Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quadratic_Voting_Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quadratic_Voting_Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quadratic_Voting_Projects_Sum_Order_By>;
  var_pop?: InputMaybe<Quadratic_Voting_Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quadratic_Voting_Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<Quadratic_Voting_Projects_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Arr_Rel_Insert_Input = {
  data: Array<Quadratic_Voting_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quadratic_Voting_Projects_On_Conflict>;
};

/** aggregate avg on columns */
export type Quadratic_Voting_Projects_Avg_Fields = {
  __typename?: 'quadratic_voting_projects_avg_fields';
  project_id?: Maybe<Scalars['Float']>;
  quadratic_voting_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  votes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Avg_Order_By = {
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quadratic_voting_projects". All fields are combined with a logical 'AND'. */
export type Quadratic_Voting_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Quadratic_Voting_Projects_Bool_Exp>>;
  _not?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Quadratic_Voting_Projects_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  quadratic_voting?: InputMaybe<Quadratic_Voting_Bool_Exp>;
  quadratic_voting_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  votes?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "quadratic_voting_projects" */
export enum Quadratic_Voting_Projects_Constraint {
  /** unique or primary key constraint on columns "project_id", "user_id", "quadratic_voting_id" */
  QuadraticVotingProjectsPkey = 'quadratic_voting_projects_pkey',
  /** unique or primary key constraint on columns "project_id", "user_id" */
  QuadraticVotingProjectsUserIdProjectIdKey = 'quadratic_voting_projects_user_id_project_id_key',
  /** unique or primary key constraint on columns "uuid" */
  QuadraticVotingProjectsUuidKey = 'quadratic_voting_projects_uuid_key'
}

/** input type for incrementing numeric columns in table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Inc_Input = {
  project_id?: InputMaybe<Scalars['Int']>;
  quadratic_voting_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  votes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  quadratic_voting?: InputMaybe<Quadratic_Voting_Obj_Rel_Insert_Input>;
  quadratic_voting_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  votes?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Quadratic_Voting_Projects_Max_Fields = {
  __typename?: 'quadratic_voting_projects_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['Int']>;
  quadratic_voting_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  votes?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quadratic_Voting_Projects_Min_Fields = {
  __typename?: 'quadratic_voting_projects_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['Int']>;
  quadratic_voting_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  votes?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Mutation_Response = {
  __typename?: 'quadratic_voting_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quadratic_Voting_Projects>;
};

/** on_conflict condition type for table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_On_Conflict = {
  constraint: Quadratic_Voting_Projects_Constraint;
  update_columns?: Array<Quadratic_Voting_Projects_Update_Column>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "quadratic_voting_projects". */
export type Quadratic_Voting_Projects_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  quadratic_voting?: InputMaybe<Quadratic_Voting_Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quadratic_voting_projects */
export type Quadratic_Voting_Projects_Pk_Columns_Input = {
  project_id: Scalars['Int'];
  quadratic_voting_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "quadratic_voting_projects" */
export enum Quadratic_Voting_Projects_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  QuadraticVotingId = 'quadratic_voting_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Votes = 'votes'
}

/** input type for updating data in table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_id?: InputMaybe<Scalars['Int']>;
  quadratic_voting_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  votes?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Quadratic_Voting_Projects_Stddev_Fields = {
  __typename?: 'quadratic_voting_projects_stddev_fields';
  project_id?: Maybe<Scalars['Float']>;
  quadratic_voting_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  votes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Stddev_Order_By = {
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quadratic_Voting_Projects_Stddev_Pop_Fields = {
  __typename?: 'quadratic_voting_projects_stddev_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  quadratic_voting_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  votes?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Stddev_Pop_Order_By = {
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quadratic_Voting_Projects_Stddev_Samp_Fields = {
  __typename?: 'quadratic_voting_projects_stddev_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  quadratic_voting_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  votes?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Stddev_Samp_Order_By = {
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quadratic_Voting_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quadratic_Voting_Projects_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_id?: InputMaybe<Scalars['Int']>;
  quadratic_voting_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  votes?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Quadratic_Voting_Projects_Sum_Fields = {
  __typename?: 'quadratic_voting_projects_sum_fields';
  project_id?: Maybe<Scalars['Int']>;
  quadratic_voting_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  votes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Sum_Order_By = {
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** update columns of table "quadratic_voting_projects" */
export enum Quadratic_Voting_Projects_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  QuadraticVotingId = 'quadratic_voting_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Votes = 'votes'
}

export type Quadratic_Voting_Projects_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quadratic_Voting_Projects_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quadratic_Voting_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quadratic_Voting_Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quadratic_Voting_Projects_Var_Pop_Fields = {
  __typename?: 'quadratic_voting_projects_var_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  quadratic_voting_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  votes?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Var_Pop_Order_By = {
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quadratic_Voting_Projects_Var_Samp_Fields = {
  __typename?: 'quadratic_voting_projects_var_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  quadratic_voting_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  votes?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Var_Samp_Order_By = {
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quadratic_Voting_Projects_Variance_Fields = {
  __typename?: 'quadratic_voting_projects_variance_fields';
  project_id?: Maybe<Scalars['Float']>;
  quadratic_voting_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  votes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quadratic_voting_projects" */
export type Quadratic_Voting_Projects_Variance_Order_By = {
  project_id?: InputMaybe<Order_By>;
  quadratic_voting_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  votes?: InputMaybe<Order_By>;
};

/** columns and relationships of "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access = {
  __typename?: 'quadratic_voting_request_access';
  created_at: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  status: Quadratic_Voting_Request_Access_Status_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};

/** aggregated selection of "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access_Aggregate = {
  __typename?: 'quadratic_voting_request_access_aggregate';
  aggregate?: Maybe<Quadratic_Voting_Request_Access_Aggregate_Fields>;
  nodes: Array<Quadratic_Voting_Request_Access>;
};

/** aggregate fields of "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access_Aggregate_Fields = {
  __typename?: 'quadratic_voting_request_access_aggregate_fields';
  avg?: Maybe<Quadratic_Voting_Request_Access_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quadratic_Voting_Request_Access_Max_Fields>;
  min?: Maybe<Quadratic_Voting_Request_Access_Min_Fields>;
  stddev?: Maybe<Quadratic_Voting_Request_Access_Stddev_Fields>;
  stddev_pop?: Maybe<Quadratic_Voting_Request_Access_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quadratic_Voting_Request_Access_Stddev_Samp_Fields>;
  sum?: Maybe<Quadratic_Voting_Request_Access_Sum_Fields>;
  var_pop?: Maybe<Quadratic_Voting_Request_Access_Var_Pop_Fields>;
  var_samp?: Maybe<Quadratic_Voting_Request_Access_Var_Samp_Fields>;
  variance?: Maybe<Quadratic_Voting_Request_Access_Variance_Fields>;
};


/** aggregate fields of "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quadratic_Voting_Request_Access_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Quadratic_Voting_Request_Access_Avg_Fields = {
  __typename?: 'quadratic_voting_request_access_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "quadratic_voting_request_access". All fields are combined with a logical 'AND'. */
export type Quadratic_Voting_Request_Access_Bool_Exp = {
  _and?: InputMaybe<Array<Quadratic_Voting_Request_Access_Bool_Exp>>;
  _not?: InputMaybe<Quadratic_Voting_Request_Access_Bool_Exp>;
  _or?: InputMaybe<Array<Quadratic_Voting_Request_Access_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Quadratic_Voting_Request_Access_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quadratic_voting_request_access" */
export enum Quadratic_Voting_Request_Access_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuadraticVotingRequestAccessPkey = 'quadratic_voting_request_access_pkey',
  /** unique or primary key constraint on columns "user_id", "hackathon_id" */
  QuadraticVotingRequestAccessUserIdHackathonIdKey = 'quadratic_voting_request_access_user_id_hackathon_id_key',
  /** unique or primary key constraint on columns "uuid" */
  QuadraticVotingRequestAccessUuidKey = 'quadratic_voting_request_access_uuid_key'
}

/** input type for incrementing numeric columns in table "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Quadratic_Voting_Request_Access_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Quadratic_Voting_Request_Access_Max_Fields = {
  __typename?: 'quadratic_voting_request_access_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Quadratic_Voting_Request_Access_Min_Fields = {
  __typename?: 'quadratic_voting_request_access_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access_Mutation_Response = {
  __typename?: 'quadratic_voting_request_access_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quadratic_Voting_Request_Access>;
};

/** on_conflict condition type for table "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access_On_Conflict = {
  constraint: Quadratic_Voting_Request_Access_Constraint;
  update_columns?: Array<Quadratic_Voting_Request_Access_Update_Column>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Bool_Exp>;
};

/** Ordering options when selecting data from "quadratic_voting_request_access". */
export type Quadratic_Voting_Request_Access_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quadratic_voting_request_access */
export type Quadratic_Voting_Request_Access_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "quadratic_voting_request_access" */
export enum Quadratic_Voting_Request_Access_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Quadratic_Voting_Request_Access_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "quadratic_voting_request_access_status" */
export type Quadratic_Voting_Request_Access_Status = {
  __typename?: 'quadratic_voting_request_access_status';
  value: Scalars['String'];
};

/** aggregated selection of "quadratic_voting_request_access_status" */
export type Quadratic_Voting_Request_Access_Status_Aggregate = {
  __typename?: 'quadratic_voting_request_access_status_aggregate';
  aggregate?: Maybe<Quadratic_Voting_Request_Access_Status_Aggregate_Fields>;
  nodes: Array<Quadratic_Voting_Request_Access_Status>;
};

/** aggregate fields of "quadratic_voting_request_access_status" */
export type Quadratic_Voting_Request_Access_Status_Aggregate_Fields = {
  __typename?: 'quadratic_voting_request_access_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Quadratic_Voting_Request_Access_Status_Max_Fields>;
  min?: Maybe<Quadratic_Voting_Request_Access_Status_Min_Fields>;
};


/** aggregate fields of "quadratic_voting_request_access_status" */
export type Quadratic_Voting_Request_Access_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "quadratic_voting_request_access_status". All fields are combined with a logical 'AND'. */
export type Quadratic_Voting_Request_Access_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Bool_Exp>>;
  _not?: InputMaybe<Quadratic_Voting_Request_Access_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quadratic_voting_request_access_status" */
export enum Quadratic_Voting_Request_Access_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuadraticVotingRequestAccessStatusPkey = 'quadratic_voting_request_access_status_pkey'
}

export enum Quadratic_Voting_Request_Access_Status_Enum {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Boolean expression to compare columns of type "quadratic_voting_request_access_status_enum". All fields are combined with logical 'AND'. */
export type Quadratic_Voting_Request_Access_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quadratic_Voting_Request_Access_Status_Enum>;
  _in?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Quadratic_Voting_Request_Access_Status_Enum>;
  _nin?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Enum>>;
};

/** input type for inserting data into table "quadratic_voting_request_access_status" */
export type Quadratic_Voting_Request_Access_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Quadratic_Voting_Request_Access_Status_Max_Fields = {
  __typename?: 'quadratic_voting_request_access_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Quadratic_Voting_Request_Access_Status_Min_Fields = {
  __typename?: 'quadratic_voting_request_access_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quadratic_voting_request_access_status" */
export type Quadratic_Voting_Request_Access_Status_Mutation_Response = {
  __typename?: 'quadratic_voting_request_access_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quadratic_Voting_Request_Access_Status>;
};

/** on_conflict condition type for table "quadratic_voting_request_access_status" */
export type Quadratic_Voting_Request_Access_Status_On_Conflict = {
  constraint: Quadratic_Voting_Request_Access_Status_Constraint;
  update_columns?: Array<Quadratic_Voting_Request_Access_Status_Update_Column>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "quadratic_voting_request_access_status". */
export type Quadratic_Voting_Request_Access_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quadratic_voting_request_access_status */
export type Quadratic_Voting_Request_Access_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "quadratic_voting_request_access_status" */
export enum Quadratic_Voting_Request_Access_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quadratic_voting_request_access_status" */
export type Quadratic_Voting_Request_Access_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "quadratic_voting_request_access_status" */
export type Quadratic_Voting_Request_Access_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quadratic_Voting_Request_Access_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quadratic_Voting_Request_Access_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "quadratic_voting_request_access_status" */
export enum Quadratic_Voting_Request_Access_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Quadratic_Voting_Request_Access_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quadratic_Voting_Request_Access_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quadratic_Voting_Request_Access_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Quadratic_Voting_Request_Access_Stddev_Fields = {
  __typename?: 'quadratic_voting_request_access_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Quadratic_Voting_Request_Access_Stddev_Pop_Fields = {
  __typename?: 'quadratic_voting_request_access_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Quadratic_Voting_Request_Access_Stddev_Samp_Fields = {
  __typename?: 'quadratic_voting_request_access_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "quadratic_voting_request_access" */
export type Quadratic_Voting_Request_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quadratic_Voting_Request_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quadratic_Voting_Request_Access_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Quadratic_Voting_Request_Access_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Quadratic_Voting_Request_Access_Sum_Fields = {
  __typename?: 'quadratic_voting_request_access_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "quadratic_voting_request_access" */
export enum Quadratic_Voting_Request_Access_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Quadratic_Voting_Request_Access_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quadratic_Voting_Request_Access_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quadratic_Voting_Request_Access_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quadratic_Voting_Request_Access_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quadratic_Voting_Request_Access_Var_Pop_Fields = {
  __typename?: 'quadratic_voting_request_access_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Quadratic_Voting_Request_Access_Var_Samp_Fields = {
  __typename?: 'quadratic_voting_request_access_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Quadratic_Voting_Request_Access_Variance_Fields = {
  __typename?: 'quadratic_voting_request_access_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "quadratic_voting" */
export enum Quadratic_Voting_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EasDetails = 'eas_details',
  /** column name */
  EasUuid = 'eas_uuid',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "quadratic_voting" */
export type Quadratic_Voting_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** The raw JSONB value of the attestation */
  eas_details?: InputMaybe<Scalars['jsonb']>;
  /** The uuid of the EAS Attestation */
  eas_uuid?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The hash of the transaction in which this attestation is done */
  tx_hash?: InputMaybe<Scalars['String']>;
  /** The raw metadata of the transaction */
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  /** The network of the transaction */
  tx_network?: InputMaybe<Quadratic_Voting_Chain_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Quadratic_Voting_Stddev_Fields = {
  __typename?: 'quadratic_voting_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Quadratic_Voting_Stddev_Pop_Fields = {
  __typename?: 'quadratic_voting_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Quadratic_Voting_Stddev_Samp_Fields = {
  __typename?: 'quadratic_voting_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "quadratic_voting" */
export type Quadratic_Voting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quadratic_Voting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quadratic_Voting_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** The raw JSONB value of the attestation */
  eas_details?: InputMaybe<Scalars['jsonb']>;
  /** The uuid of the EAS Attestation */
  eas_uuid?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The hash of the transaction in which this attestation is done */
  tx_hash?: InputMaybe<Scalars['String']>;
  /** The raw metadata of the transaction */
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  /** The network of the transaction */
  tx_network?: InputMaybe<Quadratic_Voting_Chain_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Quadratic_Voting_Sum_Fields = {
  __typename?: 'quadratic_voting_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "quadratic_voting" */
export enum Quadratic_Voting_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EasDetails = 'eas_details',
  /** column name */
  EasUuid = 'eas_uuid',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Quadratic_Voting_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quadratic_Voting_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quadratic_Voting_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quadratic_Voting_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quadratic_Voting_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quadratic_Voting_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quadratic_Voting_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quadratic_Voting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quadratic_Voting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quadratic_Voting_Var_Pop_Fields = {
  __typename?: 'quadratic_voting_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Quadratic_Voting_Var_Samp_Fields = {
  __typename?: 'quadratic_voting_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Quadratic_Voting_Variance_Fields = {
  __typename?: 'quadratic_voting_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table: "articles" */
  articles: Array<Articles>;
  /** fetch aggregated fields from the table: "articles" */
  articles_aggregate: Articles_Aggregate;
  /** fetch data from the table: "articles" using primary key columns */
  articles_by_pk?: Maybe<Articles>;
  /** fetch data from the table: "colleges" */
  colleges: Array<Colleges>;
  /** fetch aggregated fields from the table: "colleges" */
  colleges_aggregate: Colleges_Aggregate;
  /** fetch data from the table: "colleges" using primary key columns */
  colleges_by_pk?: Maybe<Colleges>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comments_by_pk?: Maybe<Comments>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "discover" */
  discover: Array<Discover>;
  /** fetch aggregated fields from the table: "discover" */
  discover_aggregate: Discover_Aggregate;
  /** fetch data from the table: "discover" using primary key columns */
  discover_by_pk?: Maybe<Discover>;
  /** fetch data from the table: "discover_events" */
  discover_events: Array<Discover_Events>;
  /** fetch aggregated fields from the table: "discover_events" */
  discover_events_aggregate: Discover_Events_Aggregate;
  /** fetch data from the table: "discover_events" using primary key columns */
  discover_events_by_pk?: Maybe<Discover_Events>;
  /** fetch data from the table: "education_fields" */
  education_fields: Array<Education_Fields>;
  /** fetch aggregated fields from the table: "education_fields" */
  education_fields_aggregate: Education_Fields_Aggregate;
  /** fetch data from the table: "education_fields" using primary key columns */
  education_fields_by_pk?: Maybe<Education_Fields>;
  /** An array relationship */
  educations: Array<Educations>;
  /** An aggregate relationship */
  educations_aggregate: Educations_Aggregate;
  /** fetch data from the table: "educations" using primary key columns */
  educations_by_pk?: Maybe<Educations>;
  /** fetch data from the table: "experience_type" */
  experience_type: Array<Experience_Type>;
  /** fetch aggregated fields from the table: "experience_type" */
  experience_type_aggregate: Experience_Type_Aggregate;
  /** fetch data from the table: "experience_type" using primary key columns */
  experience_type_by_pk?: Maybe<Experience_Type>;
  /** An array relationship */
  experiences: Array<Experiences>;
  /** An aggregate relationship */
  experiences_aggregate: Experiences_Aggregate;
  /** fetch data from the table: "experiences" using primary key columns */
  experiences_by_pk?: Maybe<Experiences>;
  /** fetch data from the table: "feature_flag_types" */
  feature_flag_types: Array<Feature_Flag_Types>;
  /** fetch aggregated fields from the table: "feature_flag_types" */
  feature_flag_types_aggregate: Feature_Flag_Types_Aggregate;
  /** fetch data from the table: "feature_flag_types" using primary key columns */
  feature_flag_types_by_pk?: Maybe<Feature_Flag_Types>;
  /** fetch data from the table: "feature_flags" */
  feature_flags: Array<Feature_Flags>;
  /** fetch aggregated fields from the table: "feature_flags" */
  feature_flags_aggregate: Feature_Flags_Aggregate;
  /** fetch data from the table: "feature_flags" using primary key columns */
  feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** fetch data from the table: "hackathon_bounties_status" */
  hackathon_bounties_status: Array<Hackathon_Bounties_Status>;
  /** fetch aggregated fields from the table: "hackathon_bounties_status" */
  hackathon_bounties_status_aggregate: Hackathon_Bounties_Status_Aggregate;
  /** fetch data from the table: "hackathon_bounties_status" using primary key columns */
  hackathon_bounties_status_by_pk?: Maybe<Hackathon_Bounties_Status>;
  /** fetch data from the table: "hackathon_brands" */
  hackathon_brands: Array<Hackathon_Brands>;
  /** fetch aggregated fields from the table: "hackathon_brands" */
  hackathon_brands_aggregate: Hackathon_Brands_Aggregate;
  /** fetch data from the table: "hackathon_brands" using primary key columns */
  hackathon_brands_by_pk?: Maybe<Hackathon_Brands>;
  /** fetch data from the table: "hackathon_checklists" */
  hackathon_checklists: Array<Hackathon_Checklists>;
  /** fetch aggregated fields from the table: "hackathon_checklists" */
  hackathon_checklists_aggregate: Hackathon_Checklists_Aggregate;
  /** fetch data from the table: "hackathon_checklists" using primary key columns */
  hackathon_checklists_by_pk?: Maybe<Hackathon_Checklists>;
  /** fetch data from the table: "hackathon_credential_eligible_entities" */
  hackathon_credential_eligible_entities: Array<Hackathon_Credential_Eligible_Entities>;
  /** fetch aggregated fields from the table: "hackathon_credential_eligible_entities" */
  hackathon_credential_eligible_entities_aggregate: Hackathon_Credential_Eligible_Entities_Aggregate;
  /** fetch data from the table: "hackathon_credential_eligible_entities" using primary key columns */
  hackathon_credential_eligible_entities_by_pk?: Maybe<Hackathon_Credential_Eligible_Entities>;
  /** fetch data from the table: "hackathon_credential_type" */
  hackathon_credential_type: Array<Hackathon_Credential_Type>;
  /** fetch aggregated fields from the table: "hackathon_credential_type" */
  hackathon_credential_type_aggregate: Hackathon_Credential_Type_Aggregate;
  /** fetch data from the table: "hackathon_credential_type" using primary key columns */
  hackathon_credential_type_by_pk?: Maybe<Hackathon_Credential_Type>;
  /** fetch data from the table: "hackathon_credentials" */
  hackathon_credentials: Array<Hackathon_Credentials>;
  /** fetch aggregated fields from the table: "hackathon_credentials" */
  hackathon_credentials_aggregate: Hackathon_Credentials_Aggregate;
  /** fetch data from the table: "hackathon_credentials" using primary key columns */
  hackathon_credentials_by_pk?: Maybe<Hackathon_Credentials>;
  /** fetch data from the table: "hackathon_credentials_chain" */
  hackathon_credentials_chain: Array<Hackathon_Credentials_Chain>;
  /** fetch aggregated fields from the table: "hackathon_credentials_chain" */
  hackathon_credentials_chain_aggregate: Hackathon_Credentials_Chain_Aggregate;
  /** fetch data from the table: "hackathon_credentials_chain" using primary key columns */
  hackathon_credentials_chain_by_pk?: Maybe<Hackathon_Credentials_Chain>;
  /** fetch data from the table: "hackathon_email_templates" */
  hackathon_email_templates: Array<Hackathon_Email_Templates>;
  /** fetch aggregated fields from the table: "hackathon_email_templates" */
  hackathon_email_templates_aggregate: Hackathon_Email_Templates_Aggregate;
  /** fetch data from the table: "hackathon_email_templates" using primary key columns */
  hackathon_email_templates_by_pk?: Maybe<Hackathon_Email_Templates>;
  /** An array relationship */
  hackathon_event_groups: Array<Hackathon_Event_Groups>;
  /** An aggregate relationship */
  hackathon_event_groups_aggregate: Hackathon_Event_Groups_Aggregate;
  /** fetch data from the table: "hackathon_event_groups" using primary key columns */
  hackathon_event_groups_by_pk?: Maybe<Hackathon_Event_Groups>;
  /** fetch data from the table: "hackathon_event_speakers" */
  hackathon_event_speakers: Array<Hackathon_Event_Speakers>;
  /** fetch aggregated fields from the table: "hackathon_event_speakers" */
  hackathon_event_speakers_aggregate: Hackathon_Event_Speakers_Aggregate;
  /** fetch data from the table: "hackathon_event_speakers" using primary key columns */
  hackathon_event_speakers_by_pk?: Maybe<Hackathon_Event_Speakers>;
  /** fetch data from the table: "hackathon_event_sponsors" */
  hackathon_event_sponsors: Array<Hackathon_Event_Sponsors>;
  /** fetch aggregated fields from the table: "hackathon_event_sponsors" */
  hackathon_event_sponsors_aggregate: Hackathon_Event_Sponsors_Aggregate;
  /** fetch data from the table: "hackathon_event_sponsors" using primary key columns */
  hackathon_event_sponsors_by_pk?: Maybe<Hackathon_Event_Sponsors>;
  /** fetch data from the table: "hackathon_event_type" */
  hackathon_event_type: Array<Hackathon_Event_Type>;
  /** fetch aggregated fields from the table: "hackathon_event_type" */
  hackathon_event_type_aggregate: Hackathon_Event_Type_Aggregate;
  /** fetch data from the table: "hackathon_event_type" using primary key columns */
  hackathon_event_type_by_pk?: Maybe<Hackathon_Event_Type>;
  /** An array relationship */
  hackathon_events: Array<Hackathon_Events>;
  /** An aggregate relationship */
  hackathon_events_aggregate: Hackathon_Events_Aggregate;
  /** fetch data from the table: "hackathon_events" using primary key columns */
  hackathon_events_by_pk?: Maybe<Hackathon_Events>;
  /** fetch data from the table: "hackathon_faq" */
  hackathon_faq: Array<Hackathon_Faq>;
  /** fetch aggregated fields from the table: "hackathon_faq" */
  hackathon_faq_aggregate: Hackathon_Faq_Aggregate;
  /** fetch data from the table: "hackathon_faq" using primary key columns */
  hackathon_faq_by_pk?: Maybe<Hackathon_Faq>;
  /** fetch data from the table: "hackathon_faq_type" */
  hackathon_faq_type: Array<Hackathon_Faq_Type>;
  /** fetch aggregated fields from the table: "hackathon_faq_type" */
  hackathon_faq_type_aggregate: Hackathon_Faq_Type_Aggregate;
  /** fetch data from the table: "hackathon_faq_type" using primary key columns */
  hackathon_faq_type_by_pk?: Maybe<Hackathon_Faq_Type>;
  /** fetch data from the table: "hackathon_hashtags" */
  hackathon_hashtags: Array<Hackathon_Hashtags>;
  /** fetch aggregated fields from the table: "hackathon_hashtags" */
  hackathon_hashtags_aggregate: Hackathon_Hashtags_Aggregate;
  /** fetch data from the table: "hackathon_hashtags" using primary key columns */
  hackathon_hashtags_by_pk?: Maybe<Hackathon_Hashtags>;
  /** fetch data from the table: "hackathon_hosts" */
  hackathon_hosts: Array<Hackathon_Hosts>;
  /** fetch aggregated fields from the table: "hackathon_hosts" */
  hackathon_hosts_aggregate: Hackathon_Hosts_Aggregate;
  /** fetch data from the table: "hackathon_hosts" using primary key columns */
  hackathon_hosts_by_pk?: Maybe<Hackathon_Hosts>;
  /** fetch data from the table: "hackathon_note_type" */
  hackathon_note_type: Array<Hackathon_Note_Type>;
  /** fetch aggregated fields from the table: "hackathon_note_type" */
  hackathon_note_type_aggregate: Hackathon_Note_Type_Aggregate;
  /** fetch data from the table: "hackathon_note_type" using primary key columns */
  hackathon_note_type_by_pk?: Maybe<Hackathon_Note_Type>;
  /** An array relationship */
  hackathon_notes: Array<Hackathon_Notes>;
  /** An aggregate relationship */
  hackathon_notes_aggregate: Hackathon_Notes_Aggregate;
  /** fetch data from the table: "hackathon_notes" using primary key columns */
  hackathon_notes_by_pk?: Maybe<Hackathon_Notes>;
  /** fetch data from the table: "hackathon_schwags" */
  hackathon_schwags: Array<Hackathon_Schwags>;
  /** fetch aggregated fields from the table: "hackathon_schwags" */
  hackathon_schwags_aggregate: Hackathon_Schwags_Aggregate;
  /** fetch data from the table: "hackathon_schwags" using primary key columns */
  hackathon_schwags_by_pk?: Maybe<Hackathon_Schwags>;
  /** fetch data from the table: "hackathon_scope_extras" */
  hackathon_scope_extras: Array<Hackathon_Scope_Extras>;
  /** fetch aggregated fields from the table: "hackathon_scope_extras" */
  hackathon_scope_extras_aggregate: Hackathon_Scope_Extras_Aggregate;
  /** fetch data from the table: "hackathon_scope_extras" using primary key columns */
  hackathon_scope_extras_by_pk?: Maybe<Hackathon_Scope_Extras>;
  /** fetch data from the table: "hackathon_scopes" */
  hackathon_scopes: Array<Hackathon_Scopes>;
  /** fetch aggregated fields from the table: "hackathon_scopes" */
  hackathon_scopes_aggregate: Hackathon_Scopes_Aggregate;
  /** fetch data from the table: "hackathon_scopes" using primary key columns */
  hackathon_scopes_by_pk?: Maybe<Hackathon_Scopes>;
  /** fetch data from the table: "hackathon_settings" */
  hackathon_settings: Array<Hackathon_Settings>;
  /** fetch aggregated fields from the table: "hackathon_settings" */
  hackathon_settings_aggregate: Hackathon_Settings_Aggregate;
  /** fetch data from the table: "hackathon_settings" using primary key columns */
  hackathon_settings_by_pk?: Maybe<Hackathon_Settings>;
  /** fetch data from the table: "hackathon_staking_currency" */
  hackathon_staking_currency: Array<Hackathon_Staking_Currency>;
  /** fetch aggregated fields from the table: "hackathon_staking_currency" */
  hackathon_staking_currency_aggregate: Hackathon_Staking_Currency_Aggregate;
  /** fetch data from the table: "hackathon_staking_currency" using primary key columns */
  hackathon_staking_currency_by_pk?: Maybe<Hackathon_Staking_Currency>;
  /** fetch data from the table: "hackathon_staking_type" */
  hackathon_staking_type: Array<Hackathon_Staking_Type>;
  /** fetch aggregated fields from the table: "hackathon_staking_type" */
  hackathon_staking_type_aggregate: Hackathon_Staking_Type_Aggregate;
  /** fetch data from the table: "hackathon_staking_type" using primary key columns */
  hackathon_staking_type_by_pk?: Maybe<Hackathon_Staking_Type>;
  /** fetch data from the table: "hackathon_stakings" */
  hackathon_stakings: Array<Hackathon_Stakings>;
  /** fetch aggregated fields from the table: "hackathon_stakings" */
  hackathon_stakings_aggregate: Hackathon_Stakings_Aggregate;
  /** fetch data from the table: "hackathon_stakings" using primary key columns */
  hackathon_stakings_by_pk?: Maybe<Hackathon_Stakings>;
  /** fetch data from the table: "hackathon_themes" */
  hackathon_themes: Array<Hackathon_Themes>;
  /** fetch aggregated fields from the table: "hackathon_themes" */
  hackathon_themes_aggregate: Hackathon_Themes_Aggregate;
  /** fetch data from the table: "hackathon_themes" using primary key columns */
  hackathon_themes_by_pk?: Maybe<Hackathon_Themes>;
  /** fetch data from the table: "hackathon_tracks" */
  hackathon_tracks: Array<Hackathon_Tracks>;
  /** fetch aggregated fields from the table: "hackathon_tracks" */
  hackathon_tracks_aggregate: Hackathon_Tracks_Aggregate;
  /** fetch data from the table: "hackathon_tracks" using primary key columns */
  hackathon_tracks_by_pk?: Maybe<Hackathon_Tracks>;
  /** fetch data from the table: "hackathon_type" */
  hackathon_type: Array<Hackathon_Type>;
  /** fetch aggregated fields from the table: "hackathon_type" */
  hackathon_type_aggregate: Hackathon_Type_Aggregate;
  /** fetch data from the table: "hackathon_type" using primary key columns */
  hackathon_type_by_pk?: Maybe<Hackathon_Type>;
  /** An array relationship */
  hackathons: Array<Hackathons>;
  /** An aggregate relationship */
  hackathons_aggregate: Hackathons_Aggregate;
  /** fetch data from the table: "hackathons" using primary key columns */
  hackathons_by_pk?: Maybe<Hackathons>;
  /** fetch data from the table: "hashtags" */
  hashtags: Array<Hashtags>;
  /** fetch aggregated fields from the table: "hashtags" */
  hashtags_aggregate: Hashtags_Aggregate;
  /** fetch data from the table: "hashtags" using primary key columns */
  hashtags_by_pk?: Maybe<Hashtags>;
  /** fetch data from the table: "idea_stats" */
  idea_stats: Array<Idea_Stats>;
  /** fetch aggregated fields from the table: "idea_stats" */
  idea_stats_aggregate: Idea_Stats_Aggregate;
  /** fetch data from the table: "idea_stats" using primary key columns */
  idea_stats_by_pk?: Maybe<Idea_Stats>;
  /** fetch data from the table: "ideas" */
  ideas: Array<Ideas>;
  /** fetch aggregated fields from the table: "ideas" */
  ideas_aggregate: Ideas_Aggregate;
  /** fetch data from the table: "ideas" using primary key columns */
  ideas_by_pk?: Maybe<Ideas>;
  /** An array relationship */
  judges: Array<Judges>;
  /** An aggregate relationship */
  judges_aggregate: Judges_Aggregate;
  /** fetch data from the table: "judges" using primary key columns */
  judges_by_pk?: Maybe<Judges>;
  /** fetch data from the table: "judging_rooms" */
  judging_rooms: Array<Judging_Rooms>;
  /** fetch aggregated fields from the table: "judging_rooms" */
  judging_rooms_aggregate: Judging_Rooms_Aggregate;
  /** fetch data from the table: "judging_rooms" using primary key columns */
  judging_rooms_by_pk?: Maybe<Judging_Rooms>;
  /** execute function "me" which returns "users" */
  me?: Maybe<Users>;
  /** execute function "me" and query aggregates on result of table type "users" */
  me_aggregate: Users_Aggregate;
  /** fetch data from the table: "notification_types" */
  notification_types: Array<Notification_Types>;
  /** fetch aggregated fields from the table: "notification_types" */
  notification_types_aggregate: Notification_Types_Aggregate;
  /** fetch data from the table: "notification_types" using primary key columns */
  notification_types_by_pk?: Maybe<Notification_Types>;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table: "oauth" */
  oauth: Array<Oauth>;
  /** fetch aggregated fields from the table: "oauth" */
  oauth_aggregate: Oauth_Aggregate;
  /** fetch data from the table: "oauth" using primary key columns */
  oauth_by_pk?: Maybe<Oauth>;
  /** fetch data from the table: "oauth_providers" */
  oauth_providers: Array<Oauth_Providers>;
  /** fetch aggregated fields from the table: "oauth_providers" */
  oauth_providers_aggregate: Oauth_Providers_Aggregate;
  /** fetch data from the table: "oauth_providers" using primary key columns */
  oauth_providers_by_pk?: Maybe<Oauth_Providers>;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** fetch data from the table: "prize_sponsors" */
  prize_sponsors: Array<Prize_Sponsors>;
  /** fetch aggregated fields from the table: "prize_sponsors" */
  prize_sponsors_aggregate: Prize_Sponsors_Aggregate;
  /** fetch data from the table: "prize_sponsors" using primary key columns */
  prize_sponsors_by_pk?: Maybe<Prize_Sponsors>;
  /** An array relationship */
  prize_tracks: Array<Prize_Tracks>;
  /** An aggregate relationship */
  prize_tracks_aggregate: Prize_Tracks_Aggregate;
  /** fetch data from the table: "prize_tracks" using primary key columns */
  prize_tracks_by_pk?: Maybe<Prize_Tracks>;
  /** An array relationship */
  prizes: Array<Prizes>;
  /** An aggregate relationship */
  prizes_aggregate: Prizes_Aggregate;
  /** fetch data from the table: "prizes" using primary key columns */
  prizes_by_pk?: Maybe<Prizes>;
  /** fetch data from the table: "profiles" */
  profiles: Array<Profiles>;
  /** fetch aggregated fields from the table: "profiles" */
  profiles_aggregate: Profiles_Aggregate;
  /** fetch data from the table: "profiles" using primary key columns */
  profiles_by_pk?: Maybe<Profiles>;
  /** fetch data from the table: "project_commits" */
  project_commits: Array<Project_Commits>;
  /** fetch aggregated fields from the table: "project_commits" */
  project_commits_aggregate: Project_Commits_Aggregate;
  /** fetch data from the table: "project_commits" using primary key columns */
  project_commits_by_pk?: Maybe<Project_Commits>;
  /** fetch data from the table: "project_contribution_stickers" */
  project_contribution_stickers: Array<Project_Contribution_Stickers>;
  /** fetch aggregated fields from the table: "project_contribution_stickers" */
  project_contribution_stickers_aggregate: Project_Contribution_Stickers_Aggregate;
  /** fetch data from the table: "project_contribution_stickers" using primary key columns */
  project_contribution_stickers_by_pk?: Maybe<Project_Contribution_Stickers>;
  /** fetch data from the table: "project_contribution_tx_network_type" */
  project_contribution_tx_network_type: Array<Project_Contribution_Tx_Network_Type>;
  /** fetch aggregated fields from the table: "project_contribution_tx_network_type" */
  project_contribution_tx_network_type_aggregate: Project_Contribution_Tx_Network_Type_Aggregate;
  /** fetch data from the table: "project_contribution_tx_network_type" using primary key columns */
  project_contribution_tx_network_type_by_pk?: Maybe<Project_Contribution_Tx_Network_Type>;
  /** fetch data from the table: "project_contributions" */
  project_contributions: Array<Project_Contributions>;
  /** fetch aggregated fields from the table: "project_contributions" */
  project_contributions_aggregate: Project_Contributions_Aggregate;
  /** fetch data from the table: "project_contributions" using primary key columns */
  project_contributions_by_pk?: Maybe<Project_Contributions>;
  /** fetch data from the table: "project_contributions_type" */
  project_contributions_type: Array<Project_Contributions_Type>;
  /** fetch aggregated fields from the table: "project_contributions_type" */
  project_contributions_type_aggregate: Project_Contributions_Type_Aggregate;
  /** fetch data from the table: "project_contributions_type" using primary key columns */
  project_contributions_type_by_pk?: Maybe<Project_Contributions_Type>;
  /** fetch data from the table: "project_hashtags" */
  project_hashtags: Array<Project_Hashtags>;
  /** fetch aggregated fields from the table: "project_hashtags" */
  project_hashtags_aggregate: Project_Hashtags_Aggregate;
  /** fetch data from the table: "project_hashtags" using primary key columns */
  project_hashtags_by_pk?: Maybe<Project_Hashtags>;
  /** fetch data from the table: "project_judges" */
  project_judges: Array<Project_Judges>;
  /** fetch aggregated fields from the table: "project_judges" */
  project_judges_aggregate: Project_Judges_Aggregate;
  /** fetch data from the table: "project_judges" using primary key columns */
  project_judges_by_pk?: Maybe<Project_Judges>;
  /** fetch data from the table: "project_judging_submission_type" */
  project_judging_submission_type: Array<Project_Judging_Submission_Type>;
  /** fetch aggregated fields from the table: "project_judging_submission_type" */
  project_judging_submission_type_aggregate: Project_Judging_Submission_Type_Aggregate;
  /** fetch data from the table: "project_judging_submission_type" using primary key columns */
  project_judging_submission_type_by_pk?: Maybe<Project_Judging_Submission_Type>;
  /** An array relationship */
  project_judgments: Array<Project_Judgments>;
  /** An aggregate relationship */
  project_judgments_aggregate: Project_Judgments_Aggregate;
  /** fetch data from the table: "project_judgments" using primary key columns */
  project_judgments_by_pk?: Maybe<Project_Judgments>;
  /** fetch data from the table: "project_report_type" */
  project_report_type: Array<Project_Report_Type>;
  /** fetch aggregated fields from the table: "project_report_type" */
  project_report_type_aggregate: Project_Report_Type_Aggregate;
  /** fetch data from the table: "project_report_type" using primary key columns */
  project_report_type_by_pk?: Maybe<Project_Report_Type>;
  /** An array relationship */
  project_reports: Array<Project_Reports>;
  /** An aggregate relationship */
  project_reports_aggregate: Project_Reports_Aggregate;
  /** fetch data from the table: "project_reports" using primary key columns */
  project_reports_by_pk?: Maybe<Project_Reports>;
  /** An array relationship */
  project_tracks: Array<Project_Tracks>;
  /** An aggregate relationship */
  project_tracks_aggregate: Project_Tracks_Aggregate;
  /** fetch data from the table: "project_tracks" using primary key columns */
  project_tracks_by_pk?: Maybe<Project_Tracks>;
  /** fetch data from the table: "projects" */
  projects: Array<Projects>;
  /** fetch aggregated fields from the table: "projects" */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** fetch data from the table: "projects_funding" */
  projects_funding: Array<Projects_Funding>;
  /** fetch aggregated fields from the table: "projects_funding" */
  projects_funding_aggregate: Projects_Funding_Aggregate;
  /** fetch data from the table: "projects_funding" using primary key columns */
  projects_funding_by_pk?: Maybe<Projects_Funding>;
  /** fetch data from the table: "quadratic_voting" */
  quadratic_voting: Array<Quadratic_Voting>;
  /** fetch aggregated fields from the table: "quadratic_voting" */
  quadratic_voting_aggregate: Quadratic_Voting_Aggregate;
  /** fetch data from the table: "quadratic_voting" using primary key columns */
  quadratic_voting_by_pk?: Maybe<Quadratic_Voting>;
  /** fetch data from the table: "quadratic_voting_chain" */
  quadratic_voting_chain: Array<Quadratic_Voting_Chain>;
  /** fetch aggregated fields from the table: "quadratic_voting_chain" */
  quadratic_voting_chain_aggregate: Quadratic_Voting_Chain_Aggregate;
  /** fetch data from the table: "quadratic_voting_chain" using primary key columns */
  quadratic_voting_chain_by_pk?: Maybe<Quadratic_Voting_Chain>;
  /** fetch data from the table: "quadratic_voting_currency" */
  quadratic_voting_currency: Array<Quadratic_Voting_Currency>;
  /** fetch aggregated fields from the table: "quadratic_voting_currency" */
  quadratic_voting_currency_aggregate: Quadratic_Voting_Currency_Aggregate;
  /** fetch data from the table: "quadratic_voting_currency" using primary key columns */
  quadratic_voting_currency_by_pk?: Maybe<Quadratic_Voting_Currency>;
  /** fetch data from the table: "quadratic_voting_projects" */
  quadratic_voting_projects: Array<Quadratic_Voting_Projects>;
  /** fetch aggregated fields from the table: "quadratic_voting_projects" */
  quadratic_voting_projects_aggregate: Quadratic_Voting_Projects_Aggregate;
  /** fetch data from the table: "quadratic_voting_projects" using primary key columns */
  quadratic_voting_projects_by_pk?: Maybe<Quadratic_Voting_Projects>;
  /** fetch data from the table: "quadratic_voting_request_access" */
  quadratic_voting_request_access: Array<Quadratic_Voting_Request_Access>;
  /** fetch aggregated fields from the table: "quadratic_voting_request_access" */
  quadratic_voting_request_access_aggregate: Quadratic_Voting_Request_Access_Aggregate;
  /** fetch data from the table: "quadratic_voting_request_access" using primary key columns */
  quadratic_voting_request_access_by_pk?: Maybe<Quadratic_Voting_Request_Access>;
  /** fetch data from the table: "quadratic_voting_request_access_status" */
  quadratic_voting_request_access_status: Array<Quadratic_Voting_Request_Access_Status>;
  /** fetch aggregated fields from the table: "quadratic_voting_request_access_status" */
  quadratic_voting_request_access_status_aggregate: Quadratic_Voting_Request_Access_Status_Aggregate;
  /** fetch data from the table: "quadratic_voting_request_access_status" using primary key columns */
  quadratic_voting_request_access_status_by_pk?: Maybe<Quadratic_Voting_Request_Access_Status>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "room_judges" */
  room_judges: Array<Room_Judges>;
  /** fetch aggregated fields from the table: "room_judges" */
  room_judges_aggregate: Room_Judges_Aggregate;
  /** fetch data from the table: "room_judges" using primary key columns */
  room_judges_by_pk?: Maybe<Room_Judges>;
  /** An array relationship */
  schwag_tracks: Array<Schwag_Tracks>;
  /** An aggregate relationship */
  schwag_tracks_aggregate: Schwag_Tracks_Aggregate;
  /** fetch data from the table: "schwag_tracks" using primary key columns */
  schwag_tracks_by_pk?: Maybe<Schwag_Tracks>;
  /** fetch data from the table: "schwags.allowed_org_winner_count" */
  schwags_allowed_org_winner_count: Array<Schwags_Allowed_Org_Winner_Count>;
  /** fetch aggregated fields from the table: "schwags.allowed_org_winner_count" */
  schwags_allowed_org_winner_count_aggregate: Schwags_Allowed_Org_Winner_Count_Aggregate;
  /** execute function "schwags.get_allowed_org_winner_count" which returns "schwags.allowed_org_winner_count" */
  schwags_get_allowed_org_winner_count: Array<Schwags_Allowed_Org_Winner_Count>;
  /** execute function "schwags.get_allowed_org_winner_count" and query aggregates on result of table type "schwags.allowed_org_winner_count" */
  schwags_get_allowed_org_winner_count_aggregate: Schwags_Allowed_Org_Winner_Count_Aggregate;
  /** fetch data from the table: "shop.countries" */
  shop_countries: Array<Shop_Countries>;
  /** fetch aggregated fields from the table: "shop.countries" */
  shop_countries_aggregate: Shop_Countries_Aggregate;
  /** fetch data from the table: "shop.countries" using primary key columns */
  shop_countries_by_pk?: Maybe<Shop_Countries>;
  /** fetch data from the table: "shop.coupon_discount_type" */
  shop_coupon_discount_type: Array<Shop_Coupon_Discount_Type>;
  /** fetch aggregated fields from the table: "shop.coupon_discount_type" */
  shop_coupon_discount_type_aggregate: Shop_Coupon_Discount_Type_Aggregate;
  /** fetch data from the table: "shop.coupon_discount_type" using primary key columns */
  shop_coupon_discount_type_by_pk?: Maybe<Shop_Coupon_Discount_Type>;
  /** fetch data from the table: "shop.coupon_type" */
  shop_coupon_type: Array<Shop_Coupon_Type>;
  /** fetch aggregated fields from the table: "shop.coupon_type" */
  shop_coupon_type_aggregate: Shop_Coupon_Type_Aggregate;
  /** fetch data from the table: "shop.coupon_type" using primary key columns */
  shop_coupon_type_by_pk?: Maybe<Shop_Coupon_Type>;
  /** fetch data from the table: "shop.coupons" */
  shop_coupons: Array<Shop_Coupons>;
  /** fetch aggregated fields from the table: "shop.coupons" */
  shop_coupons_aggregate: Shop_Coupons_Aggregate;
  /** fetch data from the table: "shop.coupons" using primary key columns */
  shop_coupons_by_pk?: Maybe<Shop_Coupons>;
  /** execute function "shop.get_coupon" which returns "shop.coupons" */
  shop_get_coupon?: Maybe<Shop_Coupons>;
  /** execute function "shop.get_coupon" and query aggregates on result of table type "shop.coupons" */
  shop_get_coupon_aggregate: Shop_Coupons_Aggregate;
  /** fetch data from the table: "shop.hsn" */
  shop_hsn: Array<Shop_Hsn>;
  /** fetch aggregated fields from the table: "shop.hsn" */
  shop_hsn_aggregate: Shop_Hsn_Aggregate;
  /** fetch data from the table: "shop.hsn" using primary key columns */
  shop_hsn_by_pk?: Maybe<Shop_Hsn>;
  /** fetch data from the table: "shop.hsn_mappings" */
  shop_hsn_mappings: Array<Shop_Hsn_Mappings>;
  /** fetch aggregated fields from the table: "shop.hsn_mappings" */
  shop_hsn_mappings_aggregate: Shop_Hsn_Mappings_Aggregate;
  /** fetch data from the table: "shop.hsn_mappings" using primary key columns */
  shop_hsn_mappings_by_pk?: Maybe<Shop_Hsn_Mappings>;
  /** fetch data from the table: "shop.inventory_skus" */
  shop_inventory_skus: Array<Shop_Inventory_Skus>;
  /** fetch aggregated fields from the table: "shop.inventory_skus" */
  shop_inventory_skus_aggregate: Shop_Inventory_Skus_Aggregate;
  /** fetch data from the table: "shop.inventory_skus" using primary key columns */
  shop_inventory_skus_by_pk?: Maybe<Shop_Inventory_Skus>;
  /** fetch data from the table: "shop.order_payment_status" */
  shop_order_payment_status: Array<Shop_Order_Payment_Status>;
  /** fetch aggregated fields from the table: "shop.order_payment_status" */
  shop_order_payment_status_aggregate: Shop_Order_Payment_Status_Aggregate;
  /** fetch data from the table: "shop.order_payment_status" using primary key columns */
  shop_order_payment_status_by_pk?: Maybe<Shop_Order_Payment_Status>;
  /** fetch data from the table: "shop.order_products" */
  shop_order_products: Array<Shop_Order_Products>;
  /** fetch aggregated fields from the table: "shop.order_products" */
  shop_order_products_aggregate: Shop_Order_Products_Aggregate;
  /** fetch data from the table: "shop.order_products" using primary key columns */
  shop_order_products_by_pk?: Maybe<Shop_Order_Products>;
  /** fetch data from the table: "shop.orders" */
  shop_orders: Array<Shop_Orders>;
  /** fetch aggregated fields from the table: "shop.orders" */
  shop_orders_aggregate: Shop_Orders_Aggregate;
  /** fetch data from the table: "shop.orders" using primary key columns */
  shop_orders_by_pk?: Maybe<Shop_Orders>;
  /** fetch data from the table: "shop.product_type" */
  shop_product_type: Array<Shop_Product_Type>;
  /** fetch aggregated fields from the table: "shop.product_type" */
  shop_product_type_aggregate: Shop_Product_Type_Aggregate;
  /** fetch data from the table: "shop.product_type" using primary key columns */
  shop_product_type_by_pk?: Maybe<Shop_Product_Type>;
  /** fetch data from the table: "shop.products" */
  shop_products: Array<Shop_Products>;
  /** fetch aggregated fields from the table: "shop.products" */
  shop_products_aggregate: Shop_Products_Aggregate;
  /** fetch data from the table: "shop.products" using primary key columns */
  shop_products_by_pk?: Maybe<Shop_Products>;
  /** fetch data from the table: "shop.shipping_addresses" */
  shop_shipping_addresses: Array<Shop_Shipping_Addresses>;
  /** fetch aggregated fields from the table: "shop.shipping_addresses" */
  shop_shipping_addresses_aggregate: Shop_Shipping_Addresses_Aggregate;
  /** fetch data from the table: "shop.shipping_addresses" using primary key columns */
  shop_shipping_addresses_by_pk?: Maybe<Shop_Shipping_Addresses>;
  /** fetch data from the table: "shop.states" */
  shop_states: Array<Shop_States>;
  /** fetch aggregated fields from the table: "shop.states" */
  shop_states_aggregate: Shop_States_Aggregate;
  /** fetch data from the table: "shop.states" using primary key columns */
  shop_states_by_pk?: Maybe<Shop_States>;
  /** fetch data from the table: "skills" */
  skills: Array<Skills>;
  /** fetch aggregated fields from the table: "skills" */
  skills_aggregate: Skills_Aggregate;
  /** fetch data from the table: "skills" using primary key columns */
  skills_by_pk?: Maybe<Skills>;
  /** fetch data from the table: "speaker_slot_status" */
  speaker_slot_status: Array<Speaker_Slot_Status>;
  /** fetch aggregated fields from the table: "speaker_slot_status" */
  speaker_slot_status_aggregate: Speaker_Slot_Status_Aggregate;
  /** fetch data from the table: "speaker_slot_status" using primary key columns */
  speaker_slot_status_by_pk?: Maybe<Speaker_Slot_Status>;
  /** An array relationship */
  sponsor_judgments: Array<Sponsor_Judgments>;
  /** An aggregate relationship */
  sponsor_judgments_aggregate: Sponsor_Judgments_Aggregate;
  /** fetch data from the table: "sponsor_judgments" using primary key columns */
  sponsor_judgments_by_pk?: Maybe<Sponsor_Judgments>;
  /** An array relationship */
  sponsor_tiers: Array<Sponsor_Tiers>;
  /** An aggregate relationship */
  sponsor_tiers_aggregate: Sponsor_Tiers_Aggregate;
  /** fetch data from the table: "sponsor_tiers" using primary key columns */
  sponsor_tiers_by_pk?: Maybe<Sponsor_Tiers>;
  /** An array relationship */
  sponsors: Array<Sponsors>;
  /** An aggregate relationship */
  sponsors_aggregate: Sponsors_Aggregate;
  /** fetch data from the table: "sponsors" using primary key columns */
  sponsors_by_pk?: Maybe<Sponsors>;
  /** fetch data from the table: "stickers" */
  stickers: Array<Stickers>;
  /** fetch aggregated fields from the table: "stickers" */
  stickers_aggregate: Stickers_Aggregate;
  /** fetch data from the table: "stickers" using primary key columns */
  stickers_by_pk?: Maybe<Stickers>;
  /** An array relationship */
  sumsub_applicants: Array<Sumsub_Applicants>;
  /** An aggregate relationship */
  sumsub_applicants_aggregate: Sumsub_Applicants_Aggregate;
  /** fetch data from the table: "sumsub_applicants" using primary key columns */
  sumsub_applicants_by_pk?: Maybe<Sumsub_Applicants>;
  /** fetch data from the table: "sumsub_applicants_review_status" */
  sumsub_applicants_review_status: Array<Sumsub_Applicants_Review_Status>;
  /** fetch aggregated fields from the table: "sumsub_applicants_review_status" */
  sumsub_applicants_review_status_aggregate: Sumsub_Applicants_Review_Status_Aggregate;
  /** fetch data from the table: "sumsub_applicants_review_status" using primary key columns */
  sumsub_applicants_review_status_by_pk?: Maybe<Sumsub_Applicants_Review_Status>;
  /** fetch data from the table: "synaps_kyc_session_status" */
  synaps_kyc_session_status: Array<Synaps_Kyc_Session_Status>;
  /** fetch aggregated fields from the table: "synaps_kyc_session_status" */
  synaps_kyc_session_status_aggregate: Synaps_Kyc_Session_Status_Aggregate;
  /** fetch data from the table: "synaps_kyc_session_status" using primary key columns */
  synaps_kyc_session_status_by_pk?: Maybe<Synaps_Kyc_Session_Status>;
  /** An array relationship */
  synaps_kyc_sessions: Array<Synaps_Kyc_Sessions>;
  /** An aggregate relationship */
  synaps_kyc_sessions_aggregate: Synaps_Kyc_Sessions_Aggregate;
  /** fetch data from the table: "synaps_kyc_sessions" using primary key columns */
  synaps_kyc_sessions_by_pk?: Maybe<Synaps_Kyc_Sessions>;
  /** fetch data from the table: "teams" */
  teams: Array<Teams>;
  /** fetch aggregated fields from the table: "teams" */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table: "themes" */
  themes: Array<Themes>;
  /** fetch aggregated fields from the table: "themes" */
  themes_aggregate: Themes_Aggregate;
  /** fetch data from the table: "themes" using primary key columns */
  themes_by_pk?: Maybe<Themes>;
  /** fetch data from the table: "twitter_cards" */
  twitter_cards: Array<Twitter_Cards>;
  /** fetch aggregated fields from the table: "twitter_cards" */
  twitter_cards_aggregate: Twitter_Cards_Aggregate;
  /** fetch data from the table: "twitter_cards" using primary key columns */
  twitter_cards_by_pk?: Maybe<Twitter_Cards>;
  /** fetch data from the table: "user_api_tokens" */
  user_api_tokens: Array<User_Api_Tokens>;
  /** fetch aggregated fields from the table: "user_api_tokens" */
  user_api_tokens_aggregate: User_Api_Tokens_Aggregate;
  /** fetch data from the table: "user_api_tokens" using primary key columns */
  user_api_tokens_by_pk?: Maybe<User_Api_Tokens>;
  /** fetch data from the table: "user_comments" */
  user_comments: Array<User_Comments>;
  /** fetch aggregated fields from the table: "user_comments" */
  user_comments_aggregate: User_Comments_Aggregate;
  /** fetch data from the table: "user_comments" using primary key columns */
  user_comments_by_pk?: Maybe<User_Comments>;
  /** fetch data from the table: "user_extras" */
  user_extras: Array<User_Extras>;
  /** fetch aggregated fields from the table: "user_extras" */
  user_extras_aggregate: User_Extras_Aggregate;
  /** fetch data from the table: "user_extras" using primary key columns */
  user_extras_by_pk?: Maybe<User_Extras>;
  /** fetch data from the table: "user_feature_flags" */
  user_feature_flags: Array<User_Feature_Flags>;
  /** fetch aggregated fields from the table: "user_feature_flags" */
  user_feature_flags_aggregate: User_Feature_Flags_Aggregate;
  /** fetch data from the table: "user_feature_flags" using primary key columns */
  user_feature_flags_by_pk?: Maybe<User_Feature_Flags>;
  /** An array relationship */
  user_hackathon_bounties: Array<User_Hackathon_Bounties>;
  /** An aggregate relationship */
  user_hackathon_bounties_aggregate: User_Hackathon_Bounties_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_bounty_type" */
  user_hackathon_bounties_bounty_type: Array<User_Hackathon_Bounties_Bounty_Type>;
  /** fetch aggregated fields from the table: "user_hackathon_bounties_bounty_type" */
  user_hackathon_bounties_bounty_type_aggregate: User_Hackathon_Bounties_Bounty_Type_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_bounty_type" using primary key columns */
  user_hackathon_bounties_bounty_type_by_pk?: Maybe<User_Hackathon_Bounties_Bounty_Type>;
  /** fetch data from the table: "user_hackathon_bounties" using primary key columns */
  user_hackathon_bounties_by_pk?: Maybe<User_Hackathon_Bounties>;
  /** fetch data from the table: "user_hackathon_bounties_currency" */
  user_hackathon_bounties_currency: Array<User_Hackathon_Bounties_Currency>;
  /** fetch aggregated fields from the table: "user_hackathon_bounties_currency" */
  user_hackathon_bounties_currency_aggregate: User_Hackathon_Bounties_Currency_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_currency" using primary key columns */
  user_hackathon_bounties_currency_by_pk?: Maybe<User_Hackathon_Bounties_Currency>;
  /** fetch data from the table: "user_hackathon_bounties_status" */
  user_hackathon_bounties_status: Array<User_Hackathon_Bounties_Status>;
  /** fetch aggregated fields from the table: "user_hackathon_bounties_status" */
  user_hackathon_bounties_status_aggregate: User_Hackathon_Bounties_Status_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_status" using primary key columns */
  user_hackathon_bounties_status_by_pk?: Maybe<User_Hackathon_Bounties_Status>;
  /** fetch data from the table: "user_hackathon_bounties_type" */
  user_hackathon_bounties_type: Array<User_Hackathon_Bounties_Type>;
  /** fetch aggregated fields from the table: "user_hackathon_bounties_type" */
  user_hackathon_bounties_type_aggregate: User_Hackathon_Bounties_Type_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_type" using primary key columns */
  user_hackathon_bounties_type_by_pk?: Maybe<User_Hackathon_Bounties_Type>;
  /** An array relationship */
  user_hackathon_checklists: Array<User_Hackathon_Checklists>;
  /** An aggregate relationship */
  user_hackathon_checklists_aggregate: User_Hackathon_Checklists_Aggregate;
  /** fetch data from the table: "user_hackathon_checklists" using primary key columns */
  user_hackathon_checklists_by_pk?: Maybe<User_Hackathon_Checklists>;
  /** An array relationship */
  user_hackathon_credentials: Array<User_Hackathon_Credentials>;
  /** An aggregate relationship */
  user_hackathon_credentials_aggregate: User_Hackathon_Credentials_Aggregate;
  /** fetch data from the table: "user_hackathon_credentials" using primary key columns */
  user_hackathon_credentials_by_pk?: Maybe<User_Hackathon_Credentials>;
  /** fetch data from the table: "user_hackathon_credentials_status" */
  user_hackathon_credentials_status: Array<User_Hackathon_Credentials_Status>;
  /** fetch aggregated fields from the table: "user_hackathon_credentials_status" */
  user_hackathon_credentials_status_aggregate: User_Hackathon_Credentials_Status_Aggregate;
  /** fetch data from the table: "user_hackathon_credentials_status" using primary key columns */
  user_hackathon_credentials_status_by_pk?: Maybe<User_Hackathon_Credentials_Status>;
  /** fetch data from the table: "user_hackathon_extras" */
  user_hackathon_extras: Array<User_Hackathon_Extras>;
  /** fetch aggregated fields from the table: "user_hackathon_extras" */
  user_hackathon_extras_aggregate: User_Hackathon_Extras_Aggregate;
  /** fetch data from the table: "user_hackathon_extras" using primary key columns */
  user_hackathon_extras_by_pk?: Maybe<User_Hackathon_Extras>;
  /** fetch data from the table: "user_hackathon_feedbacks" */
  user_hackathon_feedbacks: Array<User_Hackathon_Feedbacks>;
  /** fetch aggregated fields from the table: "user_hackathon_feedbacks" */
  user_hackathon_feedbacks_aggregate: User_Hackathon_Feedbacks_Aggregate;
  /** fetch data from the table: "user_hackathon_feedbacks" using primary key columns */
  user_hackathon_feedbacks_by_pk?: Maybe<User_Hackathon_Feedbacks>;
  /** An array relationship */
  user_hackathon_reminders: Array<User_Hackathon_Reminders>;
  /** An aggregate relationship */
  user_hackathon_reminders_aggregate: User_Hackathon_Reminders_Aggregate;
  /** fetch data from the table: "user_hackathon_reminders" using primary key columns */
  user_hackathon_reminders_by_pk?: Maybe<User_Hackathon_Reminders>;
  /** fetch data from the table: "user_hackathon_schwags" */
  user_hackathon_schwags: Array<User_Hackathon_Schwags>;
  /** fetch aggregated fields from the table: "user_hackathon_schwags" */
  user_hackathon_schwags_aggregate: User_Hackathon_Schwags_Aggregate;
  /** fetch data from the table: "user_hackathon_schwags" using primary key columns */
  user_hackathon_schwags_by_pk?: Maybe<User_Hackathon_Schwags>;
  /** fetch data from the table: "user_hackathon_staking_razorpay_payment_status" */
  user_hackathon_staking_razorpay_payment_status: Array<User_Hackathon_Staking_Razorpay_Payment_Status>;
  /** fetch aggregated fields from the table: "user_hackathon_staking_razorpay_payment_status" */
  user_hackathon_staking_razorpay_payment_status_aggregate: User_Hackathon_Staking_Razorpay_Payment_Status_Aggregate;
  /** fetch data from the table: "user_hackathon_staking_razorpay_payment_status" using primary key columns */
  user_hackathon_staking_razorpay_payment_status_by_pk?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status>;
  /** fetch data from the table: "user_hackathon_staking_status" */
  user_hackathon_staking_status: Array<User_Hackathon_Staking_Status>;
  /** fetch aggregated fields from the table: "user_hackathon_staking_status" */
  user_hackathon_staking_status_aggregate: User_Hackathon_Staking_Status_Aggregate;
  /** fetch data from the table: "user_hackathon_staking_status" using primary key columns */
  user_hackathon_staking_status_by_pk?: Maybe<User_Hackathon_Staking_Status>;
  /** fetch data from the table: "user_hackathon_stakings" */
  user_hackathon_stakings: Array<User_Hackathon_Stakings>;
  /** fetch aggregated fields from the table: "user_hackathon_stakings" */
  user_hackathon_stakings_aggregate: User_Hackathon_Stakings_Aggregate;
  /** fetch data from the table: "user_hackathon_stakings" using primary key columns */
  user_hackathon_stakings_by_pk?: Maybe<User_Hackathon_Stakings>;
  /** An array relationship */
  user_hackathons: Array<User_Hackathons>;
  /** An aggregate relationship */
  user_hackathons_aggregate: User_Hackathons_Aggregate;
  /** fetch data from the table: "user_hackathons" using primary key columns */
  user_hackathons_by_pk?: Maybe<User_Hackathons>;
  /** fetch data from the table: "user_idea_stats" */
  user_idea_stats: Array<User_Idea_Stats>;
  /** fetch aggregated fields from the table: "user_idea_stats" */
  user_idea_stats_aggregate: User_Idea_Stats_Aggregate;
  /** fetch data from the table: "user_idea_stats" using primary key columns */
  user_idea_stats_by_pk?: Maybe<User_Idea_Stats>;
  /** fetch data from the table: "user_kyc_status" */
  user_kyc_status: Array<User_Kyc_Status>;
  /** fetch aggregated fields from the table: "user_kyc_status" */
  user_kyc_status_aggregate: User_Kyc_Status_Aggregate;
  /** fetch data from the table: "user_kyc_status" using primary key columns */
  user_kyc_status_by_pk?: Maybe<User_Kyc_Status>;
  /** fetch data from the table: "user_permissions" */
  user_permissions: Array<User_Permissions>;
  /** fetch aggregated fields from the table: "user_permissions" */
  user_permissions_aggregate: User_Permissions_Aggregate;
  /** fetch data from the table: "user_permissions" using primary key columns */
  user_permissions_by_pk?: Maybe<User_Permissions>;
  /** fetch data from the table: "user_profile_rss_feed_platforms" */
  user_profile_rss_feed_platforms: Array<User_Profile_Rss_Feed_Platforms>;
  /** fetch aggregated fields from the table: "user_profile_rss_feed_platforms" */
  user_profile_rss_feed_platforms_aggregate: User_Profile_Rss_Feed_Platforms_Aggregate;
  /** fetch data from the table: "user_profile_rss_feed_platforms" using primary key columns */
  user_profile_rss_feed_platforms_by_pk?: Maybe<User_Profile_Rss_Feed_Platforms>;
  /** fetch data from the table: "user_profile_rss_feeds" */
  user_profile_rss_feeds: Array<User_Profile_Rss_Feeds>;
  /** fetch aggregated fields from the table: "user_profile_rss_feeds" */
  user_profile_rss_feeds_aggregate: User_Profile_Rss_Feeds_Aggregate;
  /** fetch data from the table: "user_profile_rss_feeds" using primary key columns */
  user_profile_rss_feeds_by_pk?: Maybe<User_Profile_Rss_Feeds>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table: "user_project_meta" */
  user_project_meta: Array<User_Project_Meta>;
  /** fetch aggregated fields from the table: "user_project_meta" */
  user_project_meta_aggregate: User_Project_Meta_Aggregate;
  /** fetch data from the table: "user_project_meta" using primary key columns */
  user_project_meta_by_pk?: Maybe<User_Project_Meta>;
  /** An array relationship */
  user_projects: Array<User_Projects>;
  /** An aggregate relationship */
  user_projects_aggregate: User_Projects_Aggregate;
  /** fetch data from the table: "user_projects" using primary key columns */
  user_projects_by_pk?: Maybe<User_Projects>;
  /** fetch data from the table: "user_public_profile_layout" */
  user_public_profile_layout: Array<User_Public_Profile_Layout>;
  /** fetch aggregated fields from the table: "user_public_profile_layout" */
  user_public_profile_layout_aggregate: User_Public_Profile_Layout_Aggregate;
  /** fetch data from the table: "user_public_profile_layout" using primary key columns */
  user_public_profile_layout_by_pk?: Maybe<User_Public_Profile_Layout>;
  /** fetch data from the table: "user_public_profile_projects" */
  user_public_profile_projects: Array<User_Public_Profile_Projects>;
  /** fetch aggregated fields from the table: "user_public_profile_projects" */
  user_public_profile_projects_aggregate: User_Public_Profile_Projects_Aggregate;
  /** fetch data from the table: "user_public_profile_projects" using primary key columns */
  user_public_profile_projects_by_pk?: Maybe<User_Public_Profile_Projects>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** fetch data from the table: "user_saved_searches" */
  user_saved_searches: Array<User_Saved_Searches>;
  /** fetch aggregated fields from the table: "user_saved_searches" */
  user_saved_searches_aggregate: User_Saved_Searches_Aggregate;
  /** fetch data from the table: "user_saved_searches" using primary key columns */
  user_saved_searches_by_pk?: Maybe<User_Saved_Searches>;
  /** fetch data from the table: "user_skills" */
  user_skills: Array<User_Skills>;
  /** fetch aggregated fields from the table: "user_skills" */
  user_skills_aggregate: User_Skills_Aggregate;
  /** fetch data from the table: "user_skills" using primary key columns */
  user_skills_by_pk?: Maybe<User_Skills>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  winners: Array<Winners>;
  /** An aggregate relationship */
  winners_aggregate: Winners_Aggregate;
  /** fetch data from the table: "winners" using primary key columns */
  winners_by_pk?: Maybe<Winners>;
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootArticlesArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Articles_Order_By>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Query_RootArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Articles_Order_By>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Query_RootArticles_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCollegesArgs = {
  distinct_on?: InputMaybe<Array<Colleges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Colleges_Order_By>>;
  where?: InputMaybe<Colleges_Bool_Exp>;
};


export type Query_RootColleges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Colleges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Colleges_Order_By>>;
  where?: InputMaybe<Colleges_Bool_Exp>;
};


export type Query_RootColleges_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Query_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Query_RootComments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompanyArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Query_RootCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Query_RootCompany_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDiscoverArgs = {
  distinct_on?: InputMaybe<Array<Discover_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discover_Order_By>>;
  where?: InputMaybe<Discover_Bool_Exp>;
};


export type Query_RootDiscover_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discover_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discover_Order_By>>;
  where?: InputMaybe<Discover_Bool_Exp>;
};


export type Query_RootDiscover_By_PkArgs = {
  uuid: Scalars['String'];
};


export type Query_RootDiscover_EventsArgs = {
  distinct_on?: InputMaybe<Array<Discover_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discover_Events_Order_By>>;
  where?: InputMaybe<Discover_Events_Bool_Exp>;
};


export type Query_RootDiscover_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discover_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discover_Events_Order_By>>;
  where?: InputMaybe<Discover_Events_Bool_Exp>;
};


export type Query_RootDiscover_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEducation_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Education_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Fields_Order_By>>;
  where?: InputMaybe<Education_Fields_Bool_Exp>;
};


export type Query_RootEducation_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Fields_Order_By>>;
  where?: InputMaybe<Education_Fields_Bool_Exp>;
};


export type Query_RootEducation_Fields_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEducationsArgs = {
  distinct_on?: InputMaybe<Array<Educations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educations_Order_By>>;
  where?: InputMaybe<Educations_Bool_Exp>;
};


export type Query_RootEducations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educations_Order_By>>;
  where?: InputMaybe<Educations_Bool_Exp>;
};


export type Query_RootEducations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootExperience_TypeArgs = {
  distinct_on?: InputMaybe<Array<Experience_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experience_Type_Order_By>>;
  where?: InputMaybe<Experience_Type_Bool_Exp>;
};


export type Query_RootExperience_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Experience_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experience_Type_Order_By>>;
  where?: InputMaybe<Experience_Type_Bool_Exp>;
};


export type Query_RootExperience_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootExperiencesArgs = {
  distinct_on?: InputMaybe<Array<Experiences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experiences_Order_By>>;
  where?: InputMaybe<Experiences_Bool_Exp>;
};


export type Query_RootExperiences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Experiences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experiences_Order_By>>;
  where?: InputMaybe<Experiences_Bool_Exp>;
};


export type Query_RootExperiences_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFeature_Flag_TypesArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flag_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flag_Types_Order_By>>;
  where?: InputMaybe<Feature_Flag_Types_Bool_Exp>;
};


export type Query_RootFeature_Flag_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flag_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flag_Types_Order_By>>;
  where?: InputMaybe<Feature_Flag_Types_Bool_Exp>;
};


export type Query_RootFeature_Flag_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootFeature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Query_RootFeature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Query_RootFeature_Flags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_Bounties_StatusArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Bounties_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Bounties_Status_Order_By>>;
  where?: InputMaybe<Hackathon_Bounties_Status_Bool_Exp>;
};


export type Query_RootHackathon_Bounties_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Bounties_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Bounties_Status_Order_By>>;
  where?: InputMaybe<Hackathon_Bounties_Status_Bool_Exp>;
};


export type Query_RootHackathon_Bounties_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootHackathon_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Brands_Order_By>>;
  where?: InputMaybe<Hackathon_Brands_Bool_Exp>;
};


export type Query_RootHackathon_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Brands_Order_By>>;
  where?: InputMaybe<Hackathon_Brands_Bool_Exp>;
};


export type Query_RootHackathon_Brands_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_ChecklistsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
};


export type Query_RootHackathon_Checklists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
};


export type Query_RootHackathon_Checklists_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_Credential_Eligible_EntitiesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Order_By>>;
  where?: InputMaybe<Hackathon_Credential_Eligible_Entities_Bool_Exp>;
};


export type Query_RootHackathon_Credential_Eligible_Entities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Order_By>>;
  where?: InputMaybe<Hackathon_Credential_Eligible_Entities_Bool_Exp>;
};


export type Query_RootHackathon_Credential_Eligible_Entities_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootHackathon_Credential_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credential_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credential_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Credential_Type_Bool_Exp>;
};


export type Query_RootHackathon_Credential_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credential_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credential_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Credential_Type_Bool_Exp>;
};


export type Query_RootHackathon_Credential_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootHackathon_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<Hackathon_Credentials_Bool_Exp>;
};


export type Query_RootHackathon_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<Hackathon_Credentials_Bool_Exp>;
};


export type Query_RootHackathon_Credentials_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_Credentials_ChainArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credentials_Chain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credentials_Chain_Order_By>>;
  where?: InputMaybe<Hackathon_Credentials_Chain_Bool_Exp>;
};


export type Query_RootHackathon_Credentials_Chain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credentials_Chain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credentials_Chain_Order_By>>;
  where?: InputMaybe<Hackathon_Credentials_Chain_Bool_Exp>;
};


export type Query_RootHackathon_Credentials_Chain_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootHackathon_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Email_Templates_Order_By>>;
  where?: InputMaybe<Hackathon_Email_Templates_Bool_Exp>;
};


export type Query_RootHackathon_Email_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Email_Templates_Order_By>>;
  where?: InputMaybe<Hackathon_Email_Templates_Bool_Exp>;
};


export type Query_RootHackathon_Email_Templates_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_Event_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Groups_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
};


export type Query_RootHackathon_Event_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Groups_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
};


export type Query_RootHackathon_Event_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_Event_SpeakersArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Speakers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Speakers_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
};


export type Query_RootHackathon_Event_Speakers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Speakers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Speakers_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
};


export type Query_RootHackathon_Event_Speakers_By_PkArgs = {
  hackathon_event_id: Scalars['Int'];
  judge_id: Scalars['Int'];
};


export type Query_RootHackathon_Event_SponsorsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Sponsors_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
};


export type Query_RootHackathon_Event_Sponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Sponsors_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
};


export type Query_RootHackathon_Event_Sponsors_By_PkArgs = {
  event_id: Scalars['Int'];
  sponsor_id: Scalars['Int'];
};


export type Query_RootHackathon_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Type_Bool_Exp>;
};


export type Query_RootHackathon_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Type_Bool_Exp>;
};


export type Query_RootHackathon_Event_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootHackathon_EventsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Events_Order_By>>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};


export type Query_RootHackathon_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Events_Order_By>>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};


export type Query_RootHackathon_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_FaqArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Bool_Exp>;
};


export type Query_RootHackathon_Faq_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Bool_Exp>;
};


export type Query_RootHackathon_Faq_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_Faq_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Type_Bool_Exp>;
};


export type Query_RootHackathon_Faq_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Type_Bool_Exp>;
};


export type Query_RootHackathon_Faq_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootHackathon_HashtagsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Hashtags_Order_By>>;
  where?: InputMaybe<Hackathon_Hashtags_Bool_Exp>;
};


export type Query_RootHackathon_Hashtags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Hashtags_Order_By>>;
  where?: InputMaybe<Hackathon_Hashtags_Bool_Exp>;
};


export type Query_RootHackathon_Hashtags_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  hashtag_id: Scalars['Int'];
};


export type Query_RootHackathon_HostsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Hosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Hosts_Order_By>>;
  where?: InputMaybe<Hackathon_Hosts_Bool_Exp>;
};


export type Query_RootHackathon_Hosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Hosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Hosts_Order_By>>;
  where?: InputMaybe<Hackathon_Hosts_Bool_Exp>;
};


export type Query_RootHackathon_Hosts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_Note_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Note_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Note_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Note_Type_Bool_Exp>;
};


export type Query_RootHackathon_Note_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Note_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Note_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Note_Type_Bool_Exp>;
};


export type Query_RootHackathon_Note_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootHackathon_NotesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Notes_Order_By>>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};


export type Query_RootHackathon_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Notes_Order_By>>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};


export type Query_RootHackathon_Notes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_SchwagsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<Hackathon_Schwags_Bool_Exp>;
};


export type Query_RootHackathon_Schwags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<Hackathon_Schwags_Bool_Exp>;
};


export type Query_RootHackathon_Schwags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_Scope_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scope_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scope_Extras_Order_By>>;
  where?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
};


export type Query_RootHackathon_Scope_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scope_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scope_Extras_Order_By>>;
  where?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
};


export type Query_RootHackathon_Scope_Extras_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scopes_Order_By>>;
  where?: InputMaybe<Hackathon_Scopes_Bool_Exp>;
};


export type Query_RootHackathon_Scopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scopes_Order_By>>;
  where?: InputMaybe<Hackathon_Scopes_Bool_Exp>;
};


export type Query_RootHackathon_Scopes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Settings_Order_By>>;
  where?: InputMaybe<Hackathon_Settings_Bool_Exp>;
};


export type Query_RootHackathon_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Settings_Order_By>>;
  where?: InputMaybe<Hackathon_Settings_Bool_Exp>;
};


export type Query_RootHackathon_Settings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_Staking_CurrencyArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Staking_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Staking_Currency_Order_By>>;
  where?: InputMaybe<Hackathon_Staking_Currency_Bool_Exp>;
};


export type Query_RootHackathon_Staking_Currency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Staking_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Staking_Currency_Order_By>>;
  where?: InputMaybe<Hackathon_Staking_Currency_Bool_Exp>;
};


export type Query_RootHackathon_Staking_Currency_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootHackathon_Staking_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Staking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Staking_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Staking_Type_Bool_Exp>;
};


export type Query_RootHackathon_Staking_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Staking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Staking_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Staking_Type_Bool_Exp>;
};


export type Query_RootHackathon_Staking_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootHackathon_StakingsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
};


export type Query_RootHackathon_Stakings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
};


export type Query_RootHackathon_Stakings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Themes_Order_By>>;
  where?: InputMaybe<Hackathon_Themes_Bool_Exp>;
};


export type Query_RootHackathon_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Themes_Order_By>>;
  where?: InputMaybe<Hackathon_Themes_Bool_Exp>;
};


export type Query_RootHackathon_Themes_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  theme_id: Scalars['Int'];
};


export type Query_RootHackathon_TracksArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Tracks_Order_By>>;
  where?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
};


export type Query_RootHackathon_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Tracks_Order_By>>;
  where?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
};


export type Query_RootHackathon_Tracks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHackathon_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Type_Bool_Exp>;
};


export type Query_RootHackathon_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Type_Bool_Exp>;
};


export type Query_RootHackathon_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootHackathonsArgs = {
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


export type Query_RootHackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


export type Query_RootHackathons_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHashtagsArgs = {
  distinct_on?: InputMaybe<Array<Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hashtags_Order_By>>;
  where?: InputMaybe<Hashtags_Bool_Exp>;
};


export type Query_RootHashtags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hashtags_Order_By>>;
  where?: InputMaybe<Hashtags_Bool_Exp>;
};


export type Query_RootHashtags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootIdea_StatsArgs = {
  distinct_on?: InputMaybe<Array<Idea_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Idea_Stats_Order_By>>;
  where?: InputMaybe<Idea_Stats_Bool_Exp>;
};


export type Query_RootIdea_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Idea_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Idea_Stats_Order_By>>;
  where?: InputMaybe<Idea_Stats_Bool_Exp>;
};


export type Query_RootIdea_Stats_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootIdeasArgs = {
  distinct_on?: InputMaybe<Array<Ideas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ideas_Order_By>>;
  where?: InputMaybe<Ideas_Bool_Exp>;
};


export type Query_RootIdeas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ideas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ideas_Order_By>>;
  where?: InputMaybe<Ideas_Bool_Exp>;
};


export type Query_RootIdeas_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootJudgesArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


export type Query_RootJudges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


export type Query_RootJudges_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootJudging_RoomsArgs = {
  distinct_on?: InputMaybe<Array<Judging_Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judging_Rooms_Order_By>>;
  where?: InputMaybe<Judging_Rooms_Bool_Exp>;
};


export type Query_RootJudging_Rooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Judging_Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judging_Rooms_Order_By>>;
  where?: InputMaybe<Judging_Rooms_Bool_Exp>;
};


export type Query_RootJudging_Rooms_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMeArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootMe_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootNotification_TypesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Types_Order_By>>;
  where?: InputMaybe<Notification_Types_Bool_Exp>;
};


export type Query_RootNotification_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Types_Order_By>>;
  where?: InputMaybe<Notification_Types_Bool_Exp>;
};


export type Query_RootNotification_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOauthArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Order_By>>;
  where?: InputMaybe<Oauth_Bool_Exp>;
};


export type Query_RootOauth_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Order_By>>;
  where?: InputMaybe<Oauth_Bool_Exp>;
};


export type Query_RootOauth_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOauth_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Providers_Order_By>>;
  where?: InputMaybe<Oauth_Providers_Bool_Exp>;
};


export type Query_RootOauth_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Providers_Order_By>>;
  where?: InputMaybe<Oauth_Providers_Bool_Exp>;
};


export type Query_RootOauth_Providers_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPrize_SponsorsArgs = {
  distinct_on?: InputMaybe<Array<Prize_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Sponsors_Order_By>>;
  where?: InputMaybe<Prize_Sponsors_Bool_Exp>;
};


export type Query_RootPrize_Sponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Sponsors_Order_By>>;
  where?: InputMaybe<Prize_Sponsors_Bool_Exp>;
};


export type Query_RootPrize_Sponsors_By_PkArgs = {
  prize_id: Scalars['Int'];
  sponsor_id: Scalars['Int'];
};


export type Query_RootPrize_TracksArgs = {
  distinct_on?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Tracks_Order_By>>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};


export type Query_RootPrize_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Tracks_Order_By>>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};


export type Query_RootPrize_Tracks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPrizesArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Query_RootPrizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Query_RootPrizes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProfilesArgs = {
  distinct_on?: InputMaybe<Array<Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profiles_Order_By>>;
  where?: InputMaybe<Profiles_Bool_Exp>;
};


export type Query_RootProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profiles_Order_By>>;
  where?: InputMaybe<Profiles_Bool_Exp>;
};


export type Query_RootProfiles_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_CommitsArgs = {
  distinct_on?: InputMaybe<Array<Project_Commits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Commits_Order_By>>;
  where?: InputMaybe<Project_Commits_Bool_Exp>;
};


export type Query_RootProject_Commits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Commits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Commits_Order_By>>;
  where?: InputMaybe<Project_Commits_Bool_Exp>;
};


export type Query_RootProject_Commits_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_Contribution_StickersArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Stickers_Order_By>>;
  where?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
};


export type Query_RootProject_Contribution_Stickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Stickers_Order_By>>;
  where?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
};


export type Query_RootProject_Contribution_Stickers_By_PkArgs = {
  project_contribution_id: Scalars['Int'];
  sticker_id: Scalars['Int'];
};


export type Query_RootProject_Contribution_Tx_Network_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Order_By>>;
  where?: InputMaybe<Project_Contribution_Tx_Network_Type_Bool_Exp>;
};


export type Query_RootProject_Contribution_Tx_Network_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Order_By>>;
  where?: InputMaybe<Project_Contribution_Tx_Network_Type_Bool_Exp>;
};


export type Query_RootProject_Contribution_Tx_Network_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootProject_ContributionsArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Order_By>>;
  where?: InputMaybe<Project_Contributions_Bool_Exp>;
};


export type Query_RootProject_Contributions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Order_By>>;
  where?: InputMaybe<Project_Contributions_Bool_Exp>;
};


export type Query_RootProject_Contributions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_Contributions_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Type_Order_By>>;
  where?: InputMaybe<Project_Contributions_Type_Bool_Exp>;
};


export type Query_RootProject_Contributions_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Type_Order_By>>;
  where?: InputMaybe<Project_Contributions_Type_Bool_Exp>;
};


export type Query_RootProject_Contributions_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootProject_HashtagsArgs = {
  distinct_on?: InputMaybe<Array<Project_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Hashtags_Order_By>>;
  where?: InputMaybe<Project_Hashtags_Bool_Exp>;
};


export type Query_RootProject_Hashtags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Hashtags_Order_By>>;
  where?: InputMaybe<Project_Hashtags_Bool_Exp>;
};


export type Query_RootProject_Hashtags_By_PkArgs = {
  hashtag_id: Scalars['Int'];
  project_id: Scalars['Int'];
};


export type Query_RootProject_JudgesArgs = {
  distinct_on?: InputMaybe<Array<Project_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judges_Order_By>>;
  where?: InputMaybe<Project_Judges_Bool_Exp>;
};


export type Query_RootProject_Judges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judges_Order_By>>;
  where?: InputMaybe<Project_Judges_Bool_Exp>;
};


export type Query_RootProject_Judges_By_PkArgs = {
  judge_id: Scalars['Int'];
  project_id: Scalars['Int'];
};


export type Query_RootProject_Judging_Submission_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Judging_Submission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judging_Submission_Type_Order_By>>;
  where?: InputMaybe<Project_Judging_Submission_Type_Bool_Exp>;
};


export type Query_RootProject_Judging_Submission_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Judging_Submission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judging_Submission_Type_Order_By>>;
  where?: InputMaybe<Project_Judging_Submission_Type_Bool_Exp>;
};


export type Query_RootProject_Judging_Submission_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootProject_JudgmentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judgments_Order_By>>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};


export type Query_RootProject_Judgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judgments_Order_By>>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};


export type Query_RootProject_Judgments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_Report_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Report_Type_Order_By>>;
  where?: InputMaybe<Project_Report_Type_Bool_Exp>;
};


export type Query_RootProject_Report_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Report_Type_Order_By>>;
  where?: InputMaybe<Project_Report_Type_Bool_Exp>;
};


export type Query_RootProject_Report_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootProject_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Project_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reports_Order_By>>;
  where?: InputMaybe<Project_Reports_Bool_Exp>;
};


export type Query_RootProject_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reports_Order_By>>;
  where?: InputMaybe<Project_Reports_Bool_Exp>;
};


export type Query_RootProject_Reports_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_TracksArgs = {
  distinct_on?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Tracks_Order_By>>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};


export type Query_RootProject_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Tracks_Order_By>>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};


export type Query_RootProject_Tracks_By_PkArgs = {
  project_id: Scalars['Int'];
  track_id: Scalars['Int'];
};


export type Query_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Query_RootProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Query_RootProjects_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProjects_FundingArgs = {
  distinct_on?: InputMaybe<Array<Projects_Funding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Funding_Order_By>>;
  where?: InputMaybe<Projects_Funding_Bool_Exp>;
};


export type Query_RootProjects_Funding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Funding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Funding_Order_By>>;
  where?: InputMaybe<Projects_Funding_Bool_Exp>;
};


export type Query_RootProjects_Funding_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuadratic_VotingArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuadratic_Voting_ChainArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Chain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Chain_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Chain_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Chain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Chain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Chain_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Chain_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Chain_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootQuadratic_Voting_CurrencyArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Currency_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Currency_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Currency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Currency_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Currency_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Currency_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootQuadratic_Voting_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Projects_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Projects_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Projects_By_PkArgs = {
  project_id: Scalars['Int'];
  quadratic_voting_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootQuadratic_Voting_Request_AccessArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Request_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Request_Access_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Request_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Request_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Request_Access_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Request_Access_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuadratic_Voting_Request_Access_StatusArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Status_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Request_Access_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Status_Bool_Exp>;
};


export type Query_RootQuadratic_Voting_Request_Access_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRoom_JudgesArgs = {
  distinct_on?: InputMaybe<Array<Room_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Judges_Order_By>>;
  where?: InputMaybe<Room_Judges_Bool_Exp>;
};


export type Query_RootRoom_Judges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Judges_Order_By>>;
  where?: InputMaybe<Room_Judges_Bool_Exp>;
};


export type Query_RootRoom_Judges_By_PkArgs = {
  judge_id: Scalars['Int'];
  room_id: Scalars['Int'];
};


export type Query_RootSchwag_TracksArgs = {
  distinct_on?: InputMaybe<Array<Schwag_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwag_Tracks_Order_By>>;
  where?: InputMaybe<Schwag_Tracks_Bool_Exp>;
};


export type Query_RootSchwag_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schwag_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwag_Tracks_Order_By>>;
  where?: InputMaybe<Schwag_Tracks_Bool_Exp>;
};


export type Query_RootSchwag_Tracks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSchwags_Allowed_Org_Winner_CountArgs = {
  distinct_on?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Order_By>>;
  where?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
};


export type Query_RootSchwags_Allowed_Org_Winner_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Order_By>>;
  where?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
};


export type Query_RootSchwags_Get_Allowed_Org_Winner_CountArgs = {
  args: Schwags_Get_Allowed_Org_Winner_Count_Args;
  distinct_on?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Order_By>>;
  where?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
};


export type Query_RootSchwags_Get_Allowed_Org_Winner_Count_AggregateArgs = {
  args: Schwags_Get_Allowed_Org_Winner_Count_Args;
  distinct_on?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Order_By>>;
  where?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
};


export type Query_RootShop_CountriesArgs = {
  distinct_on?: InputMaybe<Array<Shop_Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Countries_Order_By>>;
  where?: InputMaybe<Shop_Countries_Bool_Exp>;
};


export type Query_RootShop_Countries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Countries_Order_By>>;
  where?: InputMaybe<Shop_Countries_Bool_Exp>;
};


export type Query_RootShop_Countries_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShop_Coupon_Discount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupon_Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupon_Discount_Type_Order_By>>;
  where?: InputMaybe<Shop_Coupon_Discount_Type_Bool_Exp>;
};


export type Query_RootShop_Coupon_Discount_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupon_Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupon_Discount_Type_Order_By>>;
  where?: InputMaybe<Shop_Coupon_Discount_Type_Bool_Exp>;
};


export type Query_RootShop_Coupon_Discount_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootShop_Coupon_TypeArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupon_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupon_Type_Order_By>>;
  where?: InputMaybe<Shop_Coupon_Type_Bool_Exp>;
};


export type Query_RootShop_Coupon_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupon_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupon_Type_Order_By>>;
  where?: InputMaybe<Shop_Coupon_Type_Bool_Exp>;
};


export type Query_RootShop_Coupon_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootShop_CouponsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupons_Order_By>>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};


export type Query_RootShop_Coupons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupons_Order_By>>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};


export type Query_RootShop_Coupons_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShop_Get_CouponArgs = {
  args: Shop_Get_Coupon_Args;
  distinct_on?: InputMaybe<Array<Shop_Coupons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupons_Order_By>>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};


export type Query_RootShop_Get_Coupon_AggregateArgs = {
  args: Shop_Get_Coupon_Args;
  distinct_on?: InputMaybe<Array<Shop_Coupons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupons_Order_By>>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};


export type Query_RootShop_HsnArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Bool_Exp>;
};


export type Query_RootShop_Hsn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Bool_Exp>;
};


export type Query_RootShop_Hsn_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShop_Hsn_MappingsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Mappings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Mappings_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
};


export type Query_RootShop_Hsn_Mappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Mappings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Mappings_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
};


export type Query_RootShop_Hsn_Mappings_By_PkArgs = {
  country_id: Scalars['Int'];
  hsn_id: Scalars['Int'];
  state_id: Scalars['Int'];
};


export type Query_RootShop_Inventory_SkusArgs = {
  distinct_on?: InputMaybe<Array<Shop_Inventory_Skus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Inventory_Skus_Order_By>>;
  where?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
};


export type Query_RootShop_Inventory_Skus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Inventory_Skus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Inventory_Skus_Order_By>>;
  where?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
};


export type Query_RootShop_Inventory_Skus_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShop_Order_Payment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Payment_Status_Order_By>>;
  where?: InputMaybe<Shop_Order_Payment_Status_Bool_Exp>;
};


export type Query_RootShop_Order_Payment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Payment_Status_Order_By>>;
  where?: InputMaybe<Shop_Order_Payment_Status_Bool_Exp>;
};


export type Query_RootShop_Order_Payment_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootShop_Order_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Products_Order_By>>;
  where?: InputMaybe<Shop_Order_Products_Bool_Exp>;
};


export type Query_RootShop_Order_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Products_Order_By>>;
  where?: InputMaybe<Shop_Order_Products_Bool_Exp>;
};


export type Query_RootShop_Order_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShop_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Shop_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Orders_Order_By>>;
  where?: InputMaybe<Shop_Orders_Bool_Exp>;
};


export type Query_RootShop_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Orders_Order_By>>;
  where?: InputMaybe<Shop_Orders_Bool_Exp>;
};


export type Query_RootShop_Orders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShop_Product_TypeArgs = {
  distinct_on?: InputMaybe<Array<Shop_Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Product_Type_Order_By>>;
  where?: InputMaybe<Shop_Product_Type_Bool_Exp>;
};


export type Query_RootShop_Product_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Product_Type_Order_By>>;
  where?: InputMaybe<Shop_Product_Type_Bool_Exp>;
};


export type Query_RootShop_Product_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootShop_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Products_Order_By>>;
  where?: InputMaybe<Shop_Products_Bool_Exp>;
};


export type Query_RootShop_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Products_Order_By>>;
  where?: InputMaybe<Shop_Products_Bool_Exp>;
};


export type Query_RootShop_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShop_Shipping_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Shop_Shipping_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Shipping_Addresses_Order_By>>;
  where?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
};


export type Query_RootShop_Shipping_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Shipping_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Shipping_Addresses_Order_By>>;
  where?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
};


export type Query_RootShop_Shipping_Addresses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShop_StatesArgs = {
  distinct_on?: InputMaybe<Array<Shop_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_States_Order_By>>;
  where?: InputMaybe<Shop_States_Bool_Exp>;
};


export type Query_RootShop_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_States_Order_By>>;
  where?: InputMaybe<Shop_States_Bool_Exp>;
};


export type Query_RootShop_States_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSkillsArgs = {
  distinct_on?: InputMaybe<Array<Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Skills_Order_By>>;
  where?: InputMaybe<Skills_Bool_Exp>;
};


export type Query_RootSkills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Skills_Order_By>>;
  where?: InputMaybe<Skills_Bool_Exp>;
};


export type Query_RootSkills_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSpeaker_Slot_StatusArgs = {
  distinct_on?: InputMaybe<Array<Speaker_Slot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Speaker_Slot_Status_Order_By>>;
  where?: InputMaybe<Speaker_Slot_Status_Bool_Exp>;
};


export type Query_RootSpeaker_Slot_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speaker_Slot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Speaker_Slot_Status_Order_By>>;
  where?: InputMaybe<Speaker_Slot_Status_Bool_Exp>;
};


export type Query_RootSpeaker_Slot_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootSponsor_JudgmentsArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


export type Query_RootSponsor_Judgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


export type Query_RootSponsor_Judgments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSponsor_TiersArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Tiers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Tiers_Order_By>>;
  where?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
};


export type Query_RootSponsor_Tiers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Tiers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Tiers_Order_By>>;
  where?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
};


export type Query_RootSponsor_Tiers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Query_RootSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Query_RootSponsors_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStickersArgs = {
  distinct_on?: InputMaybe<Array<Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stickers_Order_By>>;
  where?: InputMaybe<Stickers_Bool_Exp>;
};


export type Query_RootStickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stickers_Order_By>>;
  where?: InputMaybe<Stickers_Bool_Exp>;
};


export type Query_RootStickers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSumsub_ApplicantsArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
};


export type Query_RootSumsub_Applicants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
};


export type Query_RootSumsub_Applicants_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSumsub_Applicants_Review_StatusArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Review_Status_Bool_Exp>;
};


export type Query_RootSumsub_Applicants_Review_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Review_Status_Bool_Exp>;
};


export type Query_RootSumsub_Applicants_Review_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootSynaps_Kyc_Session_StatusArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Session_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Session_Status_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Session_Status_Bool_Exp>;
};


export type Query_RootSynaps_Kyc_Session_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Session_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Session_Status_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Session_Status_Bool_Exp>;
};


export type Query_RootSynaps_Kyc_Session_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootSynaps_Kyc_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Sessions_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
};


export type Query_RootSynaps_Kyc_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Sessions_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
};


export type Query_RootSynaps_Kyc_Sessions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootThemesArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Query_RootThemes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Query_RootThemes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTwitter_CardsArgs = {
  distinct_on?: InputMaybe<Array<Twitter_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Twitter_Cards_Order_By>>;
  where?: InputMaybe<Twitter_Cards_Bool_Exp>;
};


export type Query_RootTwitter_Cards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Twitter_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Twitter_Cards_Order_By>>;
  where?: InputMaybe<Twitter_Cards_Bool_Exp>;
};


export type Query_RootTwitter_Cards_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Api_TokensArgs = {
  distinct_on?: InputMaybe<Array<User_Api_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Api_Tokens_Order_By>>;
  where?: InputMaybe<User_Api_Tokens_Bool_Exp>;
};


export type Query_RootUser_Api_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Api_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Api_Tokens_Order_By>>;
  where?: InputMaybe<User_Api_Tokens_Bool_Exp>;
};


export type Query_RootUser_Api_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_CommentsArgs = {
  distinct_on?: InputMaybe<Array<User_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Comments_Order_By>>;
  where?: InputMaybe<User_Comments_Bool_Exp>;
};


export type Query_RootUser_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Comments_Order_By>>;
  where?: InputMaybe<User_Comments_Bool_Exp>;
};


export type Query_RootUser_Comments_By_PkArgs = {
  comment_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<User_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Extras_Order_By>>;
  where?: InputMaybe<User_Extras_Bool_Exp>;
};


export type Query_RootUser_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Extras_Order_By>>;
  where?: InputMaybe<User_Extras_Bool_Exp>;
};


export type Query_RootUser_Extras_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Feature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<User_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Feature_Flags_Order_By>>;
  where?: InputMaybe<User_Feature_Flags_Bool_Exp>;
};


export type Query_RootUser_Feature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Feature_Flags_Order_By>>;
  where?: InputMaybe<User_Feature_Flags_Bool_Exp>;
};


export type Query_RootUser_Feature_Flags_By_PkArgs = {
  feature_flag_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_Hackathon_BountiesArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_Bounty_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_Bounty_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_Bounty_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_Hackathon_Bounties_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Hackathon_Bounties_CurrencyArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Currency_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_Currency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Currency_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_Currency_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_Hackathon_Bounties_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Status_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Status_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_Hackathon_Bounties_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Type_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Type_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Type_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Type_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Bounties_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_Hackathon_ChecklistsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Checklists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Checklists_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Hackathon_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Credentials_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Hackathon_Credentials_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Status_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Credentials_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Status_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Credentials_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_Hackathon_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Extras_Order_By>>;
  where?: InputMaybe<User_Hackathon_Extras_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Extras_Order_By>>;
  where?: InputMaybe<User_Hackathon_Extras_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Extras_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Hackathon_FeedbacksArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Feedbacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Feedbacks_By_PkArgs = {
  feedback_question_id: Scalars['Int'];
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_Hackathon_RemindersArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Reminders_Order_By>>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Reminders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Reminders_Order_By>>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Reminders_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_Hackathon_SchwagsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Schwags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Schwags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Hackathon_Staking_Razorpay_Payment_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Staking_Razorpay_Payment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Staking_Razorpay_Payment_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_Hackathon_Staking_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Staking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Staking_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Staking_Status_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Staking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Staking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Staking_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Staking_Status_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Staking_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_Hackathon_StakingsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<User_Hackathon_Stakings_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Stakings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<User_Hackathon_Stakings_Bool_Exp>;
};


export type Query_RootUser_Hackathon_Stakings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_HackathonsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


export type Query_RootUser_Hackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


export type Query_RootUser_Hackathons_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_Idea_StatsArgs = {
  distinct_on?: InputMaybe<Array<User_Idea_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Idea_Stats_Order_By>>;
  where?: InputMaybe<User_Idea_Stats_Bool_Exp>;
};


export type Query_RootUser_Idea_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Idea_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Idea_Stats_Order_By>>;
  where?: InputMaybe<User_Idea_Stats_Bool_Exp>;
};


export type Query_RootUser_Idea_Stats_By_PkArgs = {
  idea_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_Kyc_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Kyc_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Kyc_Status_Order_By>>;
  where?: InputMaybe<User_Kyc_Status_Bool_Exp>;
};


export type Query_RootUser_Kyc_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Kyc_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Kyc_Status_Order_By>>;
  where?: InputMaybe<User_Kyc_Status_Bool_Exp>;
};


export type Query_RootUser_Kyc_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Query_RootUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Query_RootUser_Permissions_By_PkArgs = {
  permission_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_Profile_Rss_Feed_PlatformsArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feed_Platforms_Bool_Exp>;
};


export type Query_RootUser_Profile_Rss_Feed_Platforms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feed_Platforms_Bool_Exp>;
};


export type Query_RootUser_Profile_Rss_Feed_Platforms_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_Profile_Rss_FeedsArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feeds_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
};


export type Query_RootUser_Profile_Rss_Feeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feeds_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
};


export type Query_RootUser_Profile_Rss_Feeds_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootUser_Profiles_By_PkArgs = {
  profile_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_Project_MetaArgs = {
  distinct_on?: InputMaybe<Array<User_Project_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Project_Meta_Order_By>>;
  where?: InputMaybe<User_Project_Meta_Bool_Exp>;
};


export type Query_RootUser_Project_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Project_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Project_Meta_Order_By>>;
  where?: InputMaybe<User_Project_Meta_Bool_Exp>;
};


export type Query_RootUser_Project_Meta_By_PkArgs = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<User_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Projects_Order_By>>;
  where?: InputMaybe<User_Projects_Bool_Exp>;
};


export type Query_RootUser_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Projects_Order_By>>;
  where?: InputMaybe<User_Projects_Bool_Exp>;
};


export type Query_RootUser_Projects_By_PkArgs = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_Public_Profile_LayoutArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Layout_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
};


export type Query_RootUser_Public_Profile_Layout_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Layout_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
};


export type Query_RootUser_Public_Profile_Layout_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Public_Profile_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Projects_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
};


export type Query_RootUser_Public_Profile_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Projects_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
};


export type Query_RootUser_Public_Profile_Projects_By_PkArgs = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Query_RootUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Query_RootUser_Roles_By_PkArgs = {
  role_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUser_Saved_SearchesArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Saved_Searches_Order_By>>;
  where?: InputMaybe<User_Saved_Searches_Bool_Exp>;
};


export type Query_RootUser_Saved_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Saved_Searches_Order_By>>;
  where?: InputMaybe<User_Saved_Searches_Bool_Exp>;
};


export type Query_RootUser_Saved_Searches_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_SkillsArgs = {
  distinct_on?: InputMaybe<Array<User_Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Skills_Order_By>>;
  where?: InputMaybe<User_Skills_Bool_Exp>;
};


export type Query_RootUser_Skills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Skills_Order_By>>;
  where?: InputMaybe<User_Skills_Bool_Exp>;
};


export type Query_RootUser_Skills_By_PkArgs = {
  skill_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWinnersArgs = {
  distinct_on?: InputMaybe<Array<Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Winners_Order_By>>;
  where?: InputMaybe<Winners_Bool_Exp>;
};


export type Query_RootWinners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Winners_Order_By>>;
  where?: InputMaybe<Winners_Bool_Exp>;
};


export type Query_RootWinners_By_PkArgs = {
  prize_id: Scalars['Int'];
  project_id: Scalars['Int'];
};

export type Refresh_Hackathon_Participants_Details_Single_Args = {
  hackathon_uuid?: InputMaybe<Scalars['String']>;
};

export type Remove_Hackathon_Edition_Args = {
  brand_uuid?: InputMaybe<Scalars['String']>;
  hackathon_uuid?: InputMaybe<Scalars['String']>;
};

export type Remove_Hackathon_Reminder_Args = {
  hackathon_uuid?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  created_at: Scalars['timestamptz'];
  desc?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['citext'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  avg?: Maybe<Roles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
  stddev?: Maybe<Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Roles_Sum_Fields>;
  var_pop?: Maybe<Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Roles_Var_Samp_Fields>;
  variance?: Maybe<Roles_Variance_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Roles_Avg_Fields = {
  __typename?: 'roles_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<Citext_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkRoles = 'pk_roles',
  /** unique or primary key constraint on columns "name" */
  UniqueNameRoles = 'unique_name_roles',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidRoles = 'unique_uuid_roles'
}

/** input type for incrementing numeric columns in table "roles" */
export type Roles_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['citext']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['citext']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Roles_Stddev_Fields = {
  __typename?: 'roles_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Roles_Stddev_Pop_Fields = {
  __typename?: 'roles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Roles_Stddev_Samp_Fields = {
  __typename?: 'roles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['citext']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Roles_Sum_Fields = {
  __typename?: 'roles_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Roles_Var_Pop_Fields = {
  __typename?: 'roles_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Roles_Var_Samp_Fields = {
  __typename?: 'roles_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Roles_Variance_Fields = {
  __typename?: 'roles_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "room_judges" */
export type Room_Judges = {
  __typename?: 'room_judges';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  judge?: Maybe<Judges>;
  judge_id: Scalars['Int'];
  /** An object relationship */
  room?: Maybe<Judging_Rooms>;
  room_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "room_judges" */
export type Room_Judges_Aggregate = {
  __typename?: 'room_judges_aggregate';
  aggregate?: Maybe<Room_Judges_Aggregate_Fields>;
  nodes: Array<Room_Judges>;
};

export type Room_Judges_Aggregate_Bool_Exp = {
  count?: InputMaybe<Room_Judges_Aggregate_Bool_Exp_Count>;
};

export type Room_Judges_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Room_Judges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Room_Judges_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "room_judges" */
export type Room_Judges_Aggregate_Fields = {
  __typename?: 'room_judges_aggregate_fields';
  avg?: Maybe<Room_Judges_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Room_Judges_Max_Fields>;
  min?: Maybe<Room_Judges_Min_Fields>;
  stddev?: Maybe<Room_Judges_Stddev_Fields>;
  stddev_pop?: Maybe<Room_Judges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Room_Judges_Stddev_Samp_Fields>;
  sum?: Maybe<Room_Judges_Sum_Fields>;
  var_pop?: Maybe<Room_Judges_Var_Pop_Fields>;
  var_samp?: Maybe<Room_Judges_Var_Samp_Fields>;
  variance?: Maybe<Room_Judges_Variance_Fields>;
};


/** aggregate fields of "room_judges" */
export type Room_Judges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Room_Judges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "room_judges" */
export type Room_Judges_Aggregate_Order_By = {
  avg?: InputMaybe<Room_Judges_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Room_Judges_Max_Order_By>;
  min?: InputMaybe<Room_Judges_Min_Order_By>;
  stddev?: InputMaybe<Room_Judges_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Room_Judges_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Room_Judges_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Room_Judges_Sum_Order_By>;
  var_pop?: InputMaybe<Room_Judges_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Room_Judges_Var_Samp_Order_By>;
  variance?: InputMaybe<Room_Judges_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "room_judges" */
export type Room_Judges_Arr_Rel_Insert_Input = {
  data: Array<Room_Judges_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Room_Judges_On_Conflict>;
};

/** aggregate avg on columns */
export type Room_Judges_Avg_Fields = {
  __typename?: 'room_judges_avg_fields';
  judge_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "room_judges" */
export type Room_Judges_Avg_Order_By = {
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "room_judges". All fields are combined with a logical 'AND'. */
export type Room_Judges_Bool_Exp = {
  _and?: InputMaybe<Array<Room_Judges_Bool_Exp>>;
  _not?: InputMaybe<Room_Judges_Bool_Exp>;
  _or?: InputMaybe<Array<Room_Judges_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  judge?: InputMaybe<Judges_Bool_Exp>;
  judge_id?: InputMaybe<Int_Comparison_Exp>;
  room?: InputMaybe<Judging_Rooms_Bool_Exp>;
  room_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "room_judges" */
export enum Room_Judges_Constraint {
  /** unique or primary key constraint on columns "judge_id", "room_id" */
  RoomJudgesPkey = 'room_judges_pkey',
  /** unique or primary key constraint on columns "judge_id", "room_id" */
  RoomJudgesRoomIdJudgeIdKey = 'room_judges_room_id_judge_id_key',
  /** unique or primary key constraint on columns "uuid" */
  RoomJudgesUuidKey = 'room_judges_uuid_key'
}

/** input type for incrementing numeric columns in table "room_judges" */
export type Room_Judges_Inc_Input = {
  judge_id?: InputMaybe<Scalars['Int']>;
  room_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "room_judges" */
export type Room_Judges_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  judge?: InputMaybe<Judges_Obj_Rel_Insert_Input>;
  judge_id?: InputMaybe<Scalars['Int']>;
  room?: InputMaybe<Judging_Rooms_Obj_Rel_Insert_Input>;
  room_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Room_Judges_Max_Fields = {
  __typename?: 'room_judges_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  judge_id?: Maybe<Scalars['Int']>;
  room_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "room_judges" */
export type Room_Judges_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Room_Judges_Min_Fields = {
  __typename?: 'room_judges_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  judge_id?: Maybe<Scalars['Int']>;
  room_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "room_judges" */
export type Room_Judges_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "room_judges" */
export type Room_Judges_Mutation_Response = {
  __typename?: 'room_judges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Room_Judges>;
};

/** on_conflict condition type for table "room_judges" */
export type Room_Judges_On_Conflict = {
  constraint: Room_Judges_Constraint;
  update_columns?: Array<Room_Judges_Update_Column>;
  where?: InputMaybe<Room_Judges_Bool_Exp>;
};

/** Ordering options when selecting data from "room_judges". */
export type Room_Judges_Order_By = {
  created_at?: InputMaybe<Order_By>;
  judge?: InputMaybe<Judges_Order_By>;
  judge_id?: InputMaybe<Order_By>;
  room?: InputMaybe<Judging_Rooms_Order_By>;
  room_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: room_judges */
export type Room_Judges_Pk_Columns_Input = {
  judge_id: Scalars['Int'];
  room_id: Scalars['Int'];
};

/** select columns of table "room_judges" */
export enum Room_Judges_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  RoomId = 'room_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "room_judges" */
export type Room_Judges_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  room_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Room_Judges_Stddev_Fields = {
  __typename?: 'room_judges_stddev_fields';
  judge_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "room_judges" */
export type Room_Judges_Stddev_Order_By = {
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Room_Judges_Stddev_Pop_Fields = {
  __typename?: 'room_judges_stddev_pop_fields';
  judge_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "room_judges" */
export type Room_Judges_Stddev_Pop_Order_By = {
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Room_Judges_Stddev_Samp_Fields = {
  __typename?: 'room_judges_stddev_samp_fields';
  judge_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "room_judges" */
export type Room_Judges_Stddev_Samp_Order_By = {
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "room_judges" */
export type Room_Judges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Room_Judges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Room_Judges_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  room_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Room_Judges_Sum_Fields = {
  __typename?: 'room_judges_sum_fields';
  judge_id?: Maybe<Scalars['Int']>;
  room_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "room_judges" */
export type Room_Judges_Sum_Order_By = {
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** update columns of table "room_judges" */
export enum Room_Judges_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  RoomId = 'room_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Room_Judges_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Room_Judges_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Room_Judges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Room_Judges_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Room_Judges_Var_Pop_Fields = {
  __typename?: 'room_judges_var_pop_fields';
  judge_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "room_judges" */
export type Room_Judges_Var_Pop_Order_By = {
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Room_Judges_Var_Samp_Fields = {
  __typename?: 'room_judges_var_samp_fields';
  judge_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "room_judges" */
export type Room_Judges_Var_Samp_Order_By = {
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Room_Judges_Variance_Fields = {
  __typename?: 'room_judges_variance_fields';
  judge_id?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "room_judges" */
export type Room_Judges_Variance_Order_By = {
  judge_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

export type Schwag_Shop_Countries_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Schwag_Shop_States_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

export type Schwag_Shop_Countries_Obj_Rel_Insert_Input = {
  data: Schwag_Shop_Countries_Insert_Input;
};

export type Schwag_Shop_Hsn_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mappings?: InputMaybe<Schwag_Shop_Hsn_Mappings_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

export type Schwag_Shop_Hsn_Mappings_Arr_Rel_Insert_Input = {
  data: Array<Schwag_Shop_Hsn_Mappings_Insert_Input>;
};

export type Schwag_Shop_Hsn_Mappings_Insert_Input = {
  /** This value is in percentage */
  cgst?: InputMaybe<Scalars['numeric']>;
  country?: InputMaybe<Schwag_Shop_Countries_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hsn_id?: InputMaybe<Scalars['Int']>;
  /** This value is in percentage */
  igst?: InputMaybe<Scalars['numeric']>;
  /** This value is in percentage */
  sgst?: InputMaybe<Scalars['numeric']>;
  state?: InputMaybe<Schwag_Shop_States_Obj_Rel_Insert_Input>;
  state_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

export type Schwag_Shop_Hsn_Obj_Rel_Insert_Input = {
  data: Schwag_Shop_Hsn_Insert_Input;
};

export type Schwag_Shop_Inventory_Skus_Arr_Rel_Insert_Input = {
  data: Array<Schwag_Shop_Inventory_Skus_Insert_Input>;
};

export type Schwag_Shop_Inventory_Skus_Insert_Input = {
  available_quantity?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export enum Schwag_Shop_Product_Type_Enum {
  Diary = 'DIARY',
  TShirt = 'T_SHIRT'
}

export type Schwag_Shop_Products_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eligible_entities?: InputMaybe<Scalars['_text']>;
  hsn?: InputMaybe<Schwag_Shop_Hsn_Obj_Rel_Insert_Input>;
  hsn_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Scalars['_text']>;
  is_available?: InputMaybe<Scalars['Boolean']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /** This value is in paisa */
  price?: InputMaybe<Scalars['Int']>;
  skus?: InputMaybe<Schwag_Shop_Inventory_Skus_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Schwag_Shop_Product_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type Schwag_Shop_States_Arr_Rel_Insert_Input = {
  data: Array<Schwag_Shop_States_Insert_Input>;
};

export type Schwag_Shop_States_Insert_Input = {
  country_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

export type Schwag_Shop_States_Obj_Rel_Insert_Input = {
  data: Schwag_Shop_States_Insert_Input;
};

/** columns and relationships of "schwag_tracks" */
export type Schwag_Tracks = {
  __typename?: 'schwag_tracks';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  prize_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  product?: Maybe<Shop_Products>;
  product_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "schwag_tracks" */
export type Schwag_Tracks_Aggregate = {
  __typename?: 'schwag_tracks_aggregate';
  aggregate?: Maybe<Schwag_Tracks_Aggregate_Fields>;
  nodes: Array<Schwag_Tracks>;
};

export type Schwag_Tracks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Schwag_Tracks_Aggregate_Bool_Exp_Count>;
};

export type Schwag_Tracks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Schwag_Tracks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Schwag_Tracks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "schwag_tracks" */
export type Schwag_Tracks_Aggregate_Fields = {
  __typename?: 'schwag_tracks_aggregate_fields';
  avg?: Maybe<Schwag_Tracks_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Schwag_Tracks_Max_Fields>;
  min?: Maybe<Schwag_Tracks_Min_Fields>;
  stddev?: Maybe<Schwag_Tracks_Stddev_Fields>;
  stddev_pop?: Maybe<Schwag_Tracks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Schwag_Tracks_Stddev_Samp_Fields>;
  sum?: Maybe<Schwag_Tracks_Sum_Fields>;
  var_pop?: Maybe<Schwag_Tracks_Var_Pop_Fields>;
  var_samp?: Maybe<Schwag_Tracks_Var_Samp_Fields>;
  variance?: Maybe<Schwag_Tracks_Variance_Fields>;
};


/** aggregate fields of "schwag_tracks" */
export type Schwag_Tracks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Schwag_Tracks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "schwag_tracks" */
export type Schwag_Tracks_Aggregate_Order_By = {
  avg?: InputMaybe<Schwag_Tracks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Schwag_Tracks_Max_Order_By>;
  min?: InputMaybe<Schwag_Tracks_Min_Order_By>;
  stddev?: InputMaybe<Schwag_Tracks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Schwag_Tracks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Schwag_Tracks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Schwag_Tracks_Sum_Order_By>;
  var_pop?: InputMaybe<Schwag_Tracks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Schwag_Tracks_Var_Samp_Order_By>;
  variance?: InputMaybe<Schwag_Tracks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "schwag_tracks" */
export type Schwag_Tracks_Arr_Rel_Insert_Input = {
  data: Array<Schwag_Tracks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Schwag_Tracks_On_Conflict>;
};

/** aggregate avg on columns */
export type Schwag_Tracks_Avg_Fields = {
  __typename?: 'schwag_tracks_avg_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "schwag_tracks". All fields are combined with a logical 'AND'. */
export type Schwag_Tracks_Bool_Exp = {
  _and?: InputMaybe<Array<Schwag_Tracks_Bool_Exp>>;
  _not?: InputMaybe<Schwag_Tracks_Bool_Exp>;
  _or?: InputMaybe<Array<Schwag_Tracks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  prize_id?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Shop_Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "schwag_tracks" */
export enum Schwag_Tracks_Constraint {
  /** unique or primary key constraint on columns "id" */
  SchwagTracksPkey = 'schwag_tracks_pkey',
  /** unique or primary key constraint on columns "prize_id", "product_id" */
  SchwagTracksPrizeIdProductIdKey = 'schwag_tracks_prize_id_product_id_key',
  /** unique or primary key constraint on columns "uuid" */
  SchwagTracksUuidKey = 'schwag_tracks_uuid_key'
}

/** input type for incrementing numeric columns in table "schwag_tracks" */
export type Schwag_Tracks_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "schwag_tracks" */
export type Schwag_Tracks_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Shop_Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Schwag_Tracks_Max_Fields = {
  __typename?: 'schwag_tracks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  prize_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Schwag_Tracks_Min_Fields = {
  __typename?: 'schwag_tracks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  prize_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "schwag_tracks" */
export type Schwag_Tracks_Mutation_Response = {
  __typename?: 'schwag_tracks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Schwag_Tracks>;
};

/** on_conflict condition type for table "schwag_tracks" */
export type Schwag_Tracks_On_Conflict = {
  constraint: Schwag_Tracks_Constraint;
  update_columns?: Array<Schwag_Tracks_Update_Column>;
  where?: InputMaybe<Schwag_Tracks_Bool_Exp>;
};

/** Ordering options when selecting data from "schwag_tracks". */
export type Schwag_Tracks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Shop_Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: schwag_tracks */
export type Schwag_Tracks_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "schwag_tracks" */
export enum Schwag_Tracks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "schwag_tracks" */
export type Schwag_Tracks_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Schwag_Tracks_Stddev_Fields = {
  __typename?: 'schwag_tracks_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Schwag_Tracks_Stddev_Pop_Fields = {
  __typename?: 'schwag_tracks_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Schwag_Tracks_Stddev_Samp_Fields = {
  __typename?: 'schwag_tracks_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "schwag_tracks" */
export type Schwag_Tracks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Schwag_Tracks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Schwag_Tracks_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Schwag_Tracks_Sum_Fields = {
  __typename?: 'schwag_tracks_sum_fields';
  id?: Maybe<Scalars['Int']>;
  prize_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** update columns of table "schwag_tracks" */
export enum Schwag_Tracks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Schwag_Tracks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Schwag_Tracks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Schwag_Tracks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Schwag_Tracks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Schwag_Tracks_Var_Pop_Fields = {
  __typename?: 'schwag_tracks_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Schwag_Tracks_Var_Samp_Fields = {
  __typename?: 'schwag_tracks_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Schwag_Tracks_Variance_Fields = {
  __typename?: 'schwag_tracks_variance_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "schwag_tracks" */
export type Schwag_Tracks_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** This table is used by Hasura to return the allowed schwags for organizers and winners */
export type Schwags_Allowed_Org_Winner_Count = {
  __typename?: 'schwags_allowed_org_winner_count';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Int']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "schwags.allowed_org_winner_count" */
export type Schwags_Allowed_Org_Winner_Count_Aggregate = {
  __typename?: 'schwags_allowed_org_winner_count_aggregate';
  aggregate?: Maybe<Schwags_Allowed_Org_Winner_Count_Aggregate_Fields>;
  nodes: Array<Schwags_Allowed_Org_Winner_Count>;
};

/** aggregate fields of "schwags.allowed_org_winner_count" */
export type Schwags_Allowed_Org_Winner_Count_Aggregate_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_aggregate_fields';
  avg?: Maybe<Schwags_Allowed_Org_Winner_Count_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Schwags_Allowed_Org_Winner_Count_Max_Fields>;
  min?: Maybe<Schwags_Allowed_Org_Winner_Count_Min_Fields>;
  stddev?: Maybe<Schwags_Allowed_Org_Winner_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Schwags_Allowed_Org_Winner_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Schwags_Allowed_Org_Winner_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Schwags_Allowed_Org_Winner_Count_Sum_Fields>;
  var_pop?: Maybe<Schwags_Allowed_Org_Winner_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Schwags_Allowed_Org_Winner_Count_Var_Samp_Fields>;
  variance?: Maybe<Schwags_Allowed_Org_Winner_Count_Variance_Fields>;
};


/** aggregate fields of "schwags.allowed_org_winner_count" */
export type Schwags_Allowed_Org_Winner_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Schwags_Allowed_Org_Winner_Count_Avg_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_avg_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Float']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "schwags.allowed_org_winner_count". All fields are combined with a logical 'AND'. */
export type Schwags_Allowed_Org_Winner_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Bool_Exp>>;
  _not?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Bool_Exp>>;
  organizers?: InputMaybe<Int_Comparison_Exp>;
  winners?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "schwags.allowed_org_winner_count" */
export type Schwags_Allowed_Org_Winner_Count_Inc_Input = {
  /** This field stores the allowed organzier count for schwag */
  organizers?: InputMaybe<Scalars['Int']>;
  /** This field returns the allowed winners count */
  winners?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "schwags.allowed_org_winner_count" */
export type Schwags_Allowed_Org_Winner_Count_Insert_Input = {
  /** This field stores the allowed organzier count for schwag */
  organizers?: InputMaybe<Scalars['Int']>;
  /** This field returns the allowed winners count */
  winners?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Schwags_Allowed_Org_Winner_Count_Max_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_max_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Int']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Schwags_Allowed_Org_Winner_Count_Min_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_min_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Int']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "schwags.allowed_org_winner_count" */
export type Schwags_Allowed_Org_Winner_Count_Mutation_Response = {
  __typename?: 'schwags_allowed_org_winner_count_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Schwags_Allowed_Org_Winner_Count>;
};

/** Ordering options when selecting data from "schwags.allowed_org_winner_count". */
export type Schwags_Allowed_Org_Winner_Count_Order_By = {
  organizers?: InputMaybe<Order_By>;
  winners?: InputMaybe<Order_By>;
};

/** select columns of table "schwags.allowed_org_winner_count" */
export enum Schwags_Allowed_Org_Winner_Count_Select_Column {
  /** column name */
  Organizers = 'organizers',
  /** column name */
  Winners = 'winners'
}

/** input type for updating data in table "schwags.allowed_org_winner_count" */
export type Schwags_Allowed_Org_Winner_Count_Set_Input = {
  /** This field stores the allowed organzier count for schwag */
  organizers?: InputMaybe<Scalars['Int']>;
  /** This field returns the allowed winners count */
  winners?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Schwags_Allowed_Org_Winner_Count_Stddev_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_stddev_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Float']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Schwags_Allowed_Org_Winner_Count_Stddev_Pop_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_stddev_pop_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Float']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Schwags_Allowed_Org_Winner_Count_Stddev_Samp_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_stddev_samp_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Float']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "schwags_allowed_org_winner_count" */
export type Schwags_Allowed_Org_Winner_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Schwags_Allowed_Org_Winner_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Schwags_Allowed_Org_Winner_Count_Stream_Cursor_Value_Input = {
  /** This field stores the allowed organzier count for schwag */
  organizers?: InputMaybe<Scalars['Int']>;
  /** This field returns the allowed winners count */
  winners?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Schwags_Allowed_Org_Winner_Count_Sum_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_sum_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Int']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Int']>;
};

export type Schwags_Allowed_Org_Winner_Count_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Set_Input>;
  /** filter the rows which have to be updated */
  where: Schwags_Allowed_Org_Winner_Count_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Schwags_Allowed_Org_Winner_Count_Var_Pop_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_var_pop_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Float']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Schwags_Allowed_Org_Winner_Count_Var_Samp_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_var_samp_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Float']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Schwags_Allowed_Org_Winner_Count_Variance_Fields = {
  __typename?: 'schwags_allowed_org_winner_count_variance_fields';
  /** This field stores the allowed organzier count for schwag */
  organizers?: Maybe<Scalars['Float']>;
  /** This field returns the allowed winners count */
  winners?: Maybe<Scalars['Float']>;
};

export type Schwags_Get_Allowed_Org_Winner_Count_Args = {
  hackathon_uuid?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "shop.countries" */
export type Shop_Countries = {
  __typename?: 'shop_countries';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  iso_code: Scalars['String'];
  name: Scalars['String'];
  /** An array relationship */
  states: Array<Shop_States>;
  /** An aggregate relationship */
  states_aggregate: Shop_States_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "shop.countries" */
export type Shop_CountriesStatesArgs = {
  distinct_on?: InputMaybe<Array<Shop_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_States_Order_By>>;
  where?: InputMaybe<Shop_States_Bool_Exp>;
};


/** columns and relationships of "shop.countries" */
export type Shop_CountriesStates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_States_Order_By>>;
  where?: InputMaybe<Shop_States_Bool_Exp>;
};

/** aggregated selection of "shop.countries" */
export type Shop_Countries_Aggregate = {
  __typename?: 'shop_countries_aggregate';
  aggregate?: Maybe<Shop_Countries_Aggregate_Fields>;
  nodes: Array<Shop_Countries>;
};

/** aggregate fields of "shop.countries" */
export type Shop_Countries_Aggregate_Fields = {
  __typename?: 'shop_countries_aggregate_fields';
  avg?: Maybe<Shop_Countries_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Countries_Max_Fields>;
  min?: Maybe<Shop_Countries_Min_Fields>;
  stddev?: Maybe<Shop_Countries_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Countries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Countries_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Countries_Sum_Fields>;
  var_pop?: Maybe<Shop_Countries_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Countries_Var_Samp_Fields>;
  variance?: Maybe<Shop_Countries_Variance_Fields>;
};


/** aggregate fields of "shop.countries" */
export type Shop_Countries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Countries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Shop_Countries_Avg_Fields = {
  __typename?: 'shop_countries_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shop.countries". All fields are combined with a logical 'AND'. */
export type Shop_Countries_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Countries_Bool_Exp>>;
  _not?: InputMaybe<Shop_Countries_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Countries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  iso_code?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  states?: InputMaybe<Shop_States_Bool_Exp>;
  states_aggregate?: InputMaybe<Shop_States_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.countries" */
export enum Shop_Countries_Constraint {
  /** unique or primary key constraint on columns "iso_code" */
  CountriesIsoCodeKey = 'countries_iso_code_key',
  /** unique or primary key constraint on columns "name" */
  CountriesNameKey = 'countries_name_key',
  /** unique or primary key constraint on columns "id" */
  CountriesPkey = 'countries_pkey'
}

/** input type for incrementing numeric columns in table "shop.countries" */
export type Shop_Countries_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.countries" */
export type Shop_Countries_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Shop_States_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Shop_Countries_Max_Fields = {
  __typename?: 'shop_countries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  iso_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Shop_Countries_Min_Fields = {
  __typename?: 'shop_countries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  iso_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shop.countries" */
export type Shop_Countries_Mutation_Response = {
  __typename?: 'shop_countries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Countries>;
};

/** input type for inserting object relation for remote table "shop.countries" */
export type Shop_Countries_Obj_Rel_Insert_Input = {
  data: Shop_Countries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Countries_On_Conflict>;
};

/** on_conflict condition type for table "shop.countries" */
export type Shop_Countries_On_Conflict = {
  constraint: Shop_Countries_Constraint;
  update_columns?: Array<Shop_Countries_Update_Column>;
  where?: InputMaybe<Shop_Countries_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.countries". */
export type Shop_Countries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  iso_code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  states_aggregate?: InputMaybe<Shop_States_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.countries */
export type Shop_Countries_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "shop.countries" */
export enum Shop_Countries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "shop.countries" */
export type Shop_Countries_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Shop_Countries_Stddev_Fields = {
  __typename?: 'shop_countries_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Shop_Countries_Stddev_Pop_Fields = {
  __typename?: 'shop_countries_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Shop_Countries_Stddev_Samp_Fields = {
  __typename?: 'shop_countries_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "shop_countries" */
export type Shop_Countries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Countries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Countries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Shop_Countries_Sum_Fields = {
  __typename?: 'shop_countries_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "shop.countries" */
export enum Shop_Countries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Shop_Countries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Countries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Countries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Countries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Countries_Var_Pop_Fields = {
  __typename?: 'shop_countries_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Shop_Countries_Var_Samp_Fields = {
  __typename?: 'shop_countries_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Shop_Countries_Variance_Fields = {
  __typename?: 'shop_countries_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** This table is used as an enum table to store the discount types for a coupon */
export type Shop_Coupon_Discount_Type = {
  __typename?: 'shop_coupon_discount_type';
  value: Scalars['String'];
};

/** aggregated selection of "shop.coupon_discount_type" */
export type Shop_Coupon_Discount_Type_Aggregate = {
  __typename?: 'shop_coupon_discount_type_aggregate';
  aggregate?: Maybe<Shop_Coupon_Discount_Type_Aggregate_Fields>;
  nodes: Array<Shop_Coupon_Discount_Type>;
};

/** aggregate fields of "shop.coupon_discount_type" */
export type Shop_Coupon_Discount_Type_Aggregate_Fields = {
  __typename?: 'shop_coupon_discount_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Shop_Coupon_Discount_Type_Max_Fields>;
  min?: Maybe<Shop_Coupon_Discount_Type_Min_Fields>;
};


/** aggregate fields of "shop.coupon_discount_type" */
export type Shop_Coupon_Discount_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Coupon_Discount_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shop.coupon_discount_type". All fields are combined with a logical 'AND'. */
export type Shop_Coupon_Discount_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Coupon_Discount_Type_Bool_Exp>>;
  _not?: InputMaybe<Shop_Coupon_Discount_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Coupon_Discount_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.coupon_discount_type" */
export enum Shop_Coupon_Discount_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  CouponDiscountTypePkey = 'coupon_discount_type_pkey'
}

export enum Shop_Coupon_Discount_Type_Enum {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

/** Boolean expression to compare columns of type "shop_coupon_discount_type_enum". All fields are combined with logical 'AND'. */
export type Shop_Coupon_Discount_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Shop_Coupon_Discount_Type_Enum>;
  _in?: InputMaybe<Array<Shop_Coupon_Discount_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Shop_Coupon_Discount_Type_Enum>;
  _nin?: InputMaybe<Array<Shop_Coupon_Discount_Type_Enum>>;
};

/** input type for inserting data into table "shop.coupon_discount_type" */
export type Shop_Coupon_Discount_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shop_Coupon_Discount_Type_Max_Fields = {
  __typename?: 'shop_coupon_discount_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Shop_Coupon_Discount_Type_Min_Fields = {
  __typename?: 'shop_coupon_discount_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shop.coupon_discount_type" */
export type Shop_Coupon_Discount_Type_Mutation_Response = {
  __typename?: 'shop_coupon_discount_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Coupon_Discount_Type>;
};

/** on_conflict condition type for table "shop.coupon_discount_type" */
export type Shop_Coupon_Discount_Type_On_Conflict = {
  constraint: Shop_Coupon_Discount_Type_Constraint;
  update_columns?: Array<Shop_Coupon_Discount_Type_Update_Column>;
  where?: InputMaybe<Shop_Coupon_Discount_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.coupon_discount_type". */
export type Shop_Coupon_Discount_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.coupon_discount_type */
export type Shop_Coupon_Discount_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "shop.coupon_discount_type" */
export enum Shop_Coupon_Discount_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "shop.coupon_discount_type" */
export type Shop_Coupon_Discount_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "shop_coupon_discount_type" */
export type Shop_Coupon_Discount_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Coupon_Discount_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Coupon_Discount_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "shop.coupon_discount_type" */
export enum Shop_Coupon_Discount_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Shop_Coupon_Discount_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Coupon_Discount_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Coupon_Discount_Type_Bool_Exp;
};

/** This table is used as an enum table to store the types of coupons */
export type Shop_Coupon_Type = {
  __typename?: 'shop_coupon_type';
  value: Scalars['String'];
};

/** aggregated selection of "shop.coupon_type" */
export type Shop_Coupon_Type_Aggregate = {
  __typename?: 'shop_coupon_type_aggregate';
  aggregate?: Maybe<Shop_Coupon_Type_Aggregate_Fields>;
  nodes: Array<Shop_Coupon_Type>;
};

/** aggregate fields of "shop.coupon_type" */
export type Shop_Coupon_Type_Aggregate_Fields = {
  __typename?: 'shop_coupon_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Shop_Coupon_Type_Max_Fields>;
  min?: Maybe<Shop_Coupon_Type_Min_Fields>;
};


/** aggregate fields of "shop.coupon_type" */
export type Shop_Coupon_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Coupon_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shop.coupon_type". All fields are combined with a logical 'AND'. */
export type Shop_Coupon_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Coupon_Type_Bool_Exp>>;
  _not?: InputMaybe<Shop_Coupon_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Coupon_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.coupon_type" */
export enum Shop_Coupon_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  CouponTypePkey = 'coupon_type_pkey'
}

export enum Shop_Coupon_Type_Enum {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

/** Boolean expression to compare columns of type "shop_coupon_type_enum". All fields are combined with logical 'AND'. */
export type Shop_Coupon_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Shop_Coupon_Type_Enum>;
  _in?: InputMaybe<Array<Shop_Coupon_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Shop_Coupon_Type_Enum>;
  _nin?: InputMaybe<Array<Shop_Coupon_Type_Enum>>;
};

/** input type for inserting data into table "shop.coupon_type" */
export type Shop_Coupon_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shop_Coupon_Type_Max_Fields = {
  __typename?: 'shop_coupon_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Shop_Coupon_Type_Min_Fields = {
  __typename?: 'shop_coupon_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shop.coupon_type" */
export type Shop_Coupon_Type_Mutation_Response = {
  __typename?: 'shop_coupon_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Coupon_Type>;
};

/** on_conflict condition type for table "shop.coupon_type" */
export type Shop_Coupon_Type_On_Conflict = {
  constraint: Shop_Coupon_Type_Constraint;
  update_columns?: Array<Shop_Coupon_Type_Update_Column>;
  where?: InputMaybe<Shop_Coupon_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.coupon_type". */
export type Shop_Coupon_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.coupon_type */
export type Shop_Coupon_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "shop.coupon_type" */
export enum Shop_Coupon_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "shop.coupon_type" */
export type Shop_Coupon_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "shop_coupon_type" */
export type Shop_Coupon_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Coupon_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Coupon_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "shop.coupon_type" */
export enum Shop_Coupon_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Shop_Coupon_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Coupon_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Coupon_Type_Bool_Exp;
};

/** This table is used to store the coupons for the shop */
export type Shop_Coupons = {
  __typename?: 'shop_coupons';
  code: Scalars['String'];
  created_at: Scalars['timestamptz'];
  discount_type: Shop_Coupon_Discount_Type_Enum;
  discount_value: Scalars['Int'];
  expires_on?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** If the coupon is a one time coupon, and it is used, this field is marked as false */
  is_valid: Scalars['Boolean'];
  name: Scalars['String'];
  type: Shop_Coupon_Type_Enum;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "shop.coupons" */
export type Shop_Coupons_Aggregate = {
  __typename?: 'shop_coupons_aggregate';
  aggregate?: Maybe<Shop_Coupons_Aggregate_Fields>;
  nodes: Array<Shop_Coupons>;
};

/** aggregate fields of "shop.coupons" */
export type Shop_Coupons_Aggregate_Fields = {
  __typename?: 'shop_coupons_aggregate_fields';
  avg?: Maybe<Shop_Coupons_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Coupons_Max_Fields>;
  min?: Maybe<Shop_Coupons_Min_Fields>;
  stddev?: Maybe<Shop_Coupons_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Coupons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Coupons_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Coupons_Sum_Fields>;
  var_pop?: Maybe<Shop_Coupons_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Coupons_Var_Samp_Fields>;
  variance?: Maybe<Shop_Coupons_Variance_Fields>;
};


/** aggregate fields of "shop.coupons" */
export type Shop_Coupons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Coupons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Shop_Coupons_Avg_Fields = {
  __typename?: 'shop_coupons_avg_fields';
  discount_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shop.coupons". All fields are combined with a logical 'AND'. */
export type Shop_Coupons_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Coupons_Bool_Exp>>;
  _not?: InputMaybe<Shop_Coupons_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Coupons_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discount_type?: InputMaybe<Shop_Coupon_Discount_Type_Enum_Comparison_Exp>;
  discount_value?: InputMaybe<Int_Comparison_Exp>;
  expires_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_valid?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Shop_Coupon_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.coupons" */
export enum Shop_Coupons_Constraint {
  /** unique or primary key constraint on columns "code" */
  CouponsCodeKey = 'coupons_code_key',
  /** unique or primary key constraint on columns "id" */
  CouponsPkey = 'coupons_pkey'
}

/** input type for incrementing numeric columns in table "shop.coupons" */
export type Shop_Coupons_Inc_Input = {
  discount_value?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.coupons" */
export type Shop_Coupons_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_type?: InputMaybe<Shop_Coupon_Discount_Type_Enum>;
  discount_value?: InputMaybe<Scalars['Int']>;
  expires_on?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  /** If the coupon is a one time coupon, and it is used, this field is marked as false */
  is_valid?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Shop_Coupon_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Shop_Coupons_Max_Fields = {
  __typename?: 'shop_coupons_max_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_value?: Maybe<Scalars['Int']>;
  expires_on?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Shop_Coupons_Min_Fields = {
  __typename?: 'shop_coupons_min_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_value?: Maybe<Scalars['Int']>;
  expires_on?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shop.coupons" */
export type Shop_Coupons_Mutation_Response = {
  __typename?: 'shop_coupons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Coupons>;
};

/** input type for inserting object relation for remote table "shop.coupons" */
export type Shop_Coupons_Obj_Rel_Insert_Input = {
  data: Shop_Coupons_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Coupons_On_Conflict>;
};

/** on_conflict condition type for table "shop.coupons" */
export type Shop_Coupons_On_Conflict = {
  constraint: Shop_Coupons_Constraint;
  update_columns?: Array<Shop_Coupons_Update_Column>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.coupons". */
export type Shop_Coupons_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  discount_value?: InputMaybe<Order_By>;
  expires_on?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_valid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.coupons */
export type Shop_Coupons_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "shop.coupons" */
export enum Shop_Coupons_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  DiscountValue = 'discount_value',
  /** column name */
  ExpiresOn = 'expires_on',
  /** column name */
  Id = 'id',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "shop.coupons" */
export type Shop_Coupons_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_type?: InputMaybe<Shop_Coupon_Discount_Type_Enum>;
  discount_value?: InputMaybe<Scalars['Int']>;
  expires_on?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  /** If the coupon is a one time coupon, and it is used, this field is marked as false */
  is_valid?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Shop_Coupon_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Shop_Coupons_Stddev_Fields = {
  __typename?: 'shop_coupons_stddev_fields';
  discount_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Shop_Coupons_Stddev_Pop_Fields = {
  __typename?: 'shop_coupons_stddev_pop_fields';
  discount_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Shop_Coupons_Stddev_Samp_Fields = {
  __typename?: 'shop_coupons_stddev_samp_fields';
  discount_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "shop_coupons" */
export type Shop_Coupons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Coupons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Coupons_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_type?: InputMaybe<Shop_Coupon_Discount_Type_Enum>;
  discount_value?: InputMaybe<Scalars['Int']>;
  expires_on?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  /** If the coupon is a one time coupon, and it is used, this field is marked as false */
  is_valid?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Shop_Coupon_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Shop_Coupons_Sum_Fields = {
  __typename?: 'shop_coupons_sum_fields';
  discount_value?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "shop.coupons" */
export enum Shop_Coupons_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  DiscountValue = 'discount_value',
  /** column name */
  ExpiresOn = 'expires_on',
  /** column name */
  Id = 'id',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Shop_Coupons_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Coupons_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Coupons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Coupons_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Coupons_Var_Pop_Fields = {
  __typename?: 'shop_coupons_var_pop_fields';
  discount_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Shop_Coupons_Var_Samp_Fields = {
  __typename?: 'shop_coupons_var_samp_fields';
  discount_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Shop_Coupons_Variance_Fields = {
  __typename?: 'shop_coupons_variance_fields';
  discount_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Shop_Get_Coupon_Args = {
  coupon_code?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "shop.hsn" */
export type Shop_Hsn = {
  __typename?: 'shop_hsn';
  code: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['Int'];
  /** An array relationship */
  mappings: Array<Shop_Hsn_Mappings>;
  /** An aggregate relationship */
  mappings_aggregate: Shop_Hsn_Mappings_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "shop.hsn" */
export type Shop_HsnMappingsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Mappings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Mappings_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
};


/** columns and relationships of "shop.hsn" */
export type Shop_HsnMappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Mappings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Mappings_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
};

/** aggregated selection of "shop.hsn" */
export type Shop_Hsn_Aggregate = {
  __typename?: 'shop_hsn_aggregate';
  aggregate?: Maybe<Shop_Hsn_Aggregate_Fields>;
  nodes: Array<Shop_Hsn>;
};

/** aggregate fields of "shop.hsn" */
export type Shop_Hsn_Aggregate_Fields = {
  __typename?: 'shop_hsn_aggregate_fields';
  avg?: Maybe<Shop_Hsn_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Hsn_Max_Fields>;
  min?: Maybe<Shop_Hsn_Min_Fields>;
  stddev?: Maybe<Shop_Hsn_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Hsn_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Hsn_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Hsn_Sum_Fields>;
  var_pop?: Maybe<Shop_Hsn_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Hsn_Var_Samp_Fields>;
  variance?: Maybe<Shop_Hsn_Variance_Fields>;
};


/** aggregate fields of "shop.hsn" */
export type Shop_Hsn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Hsn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Shop_Hsn_Avg_Fields = {
  __typename?: 'shop_hsn_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shop.hsn". All fields are combined with a logical 'AND'. */
export type Shop_Hsn_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Hsn_Bool_Exp>>;
  _not?: InputMaybe<Shop_Hsn_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Hsn_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mappings?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
  mappings_aggregate?: InputMaybe<Shop_Hsn_Mappings_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.hsn" */
export enum Shop_Hsn_Constraint {
  /** unique or primary key constraint on columns "code" */
  HsnCodeKey = 'hsn_code_key',
  /** unique or primary key constraint on columns "id" */
  HsnPkey = 'hsn_pkey'
}

/** input type for incrementing numeric columns in table "shop.hsn" */
export type Shop_Hsn_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.hsn" */
export type Shop_Hsn_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mappings?: InputMaybe<Shop_Hsn_Mappings_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** This table is used to store the mapping between the hsn code and the gst taxes */
export type Shop_Hsn_Mappings = {
  __typename?: 'shop_hsn_mappings';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  country: Shop_Countries;
  country_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  hsn_id: Scalars['Int'];
  /** This value is in percentage */
  igst?: Maybe<Scalars['numeric']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  state: Shop_States;
  state_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Aggregate = {
  __typename?: 'shop_hsn_mappings_aggregate';
  aggregate?: Maybe<Shop_Hsn_Mappings_Aggregate_Fields>;
  nodes: Array<Shop_Hsn_Mappings>;
};

export type Shop_Hsn_Mappings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Shop_Hsn_Mappings_Aggregate_Bool_Exp_Count>;
};

export type Shop_Hsn_Mappings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Shop_Hsn_Mappings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Aggregate_Fields = {
  __typename?: 'shop_hsn_mappings_aggregate_fields';
  avg?: Maybe<Shop_Hsn_Mappings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Hsn_Mappings_Max_Fields>;
  min?: Maybe<Shop_Hsn_Mappings_Min_Fields>;
  stddev?: Maybe<Shop_Hsn_Mappings_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Hsn_Mappings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Hsn_Mappings_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Hsn_Mappings_Sum_Fields>;
  var_pop?: Maybe<Shop_Hsn_Mappings_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Hsn_Mappings_Var_Samp_Fields>;
  variance?: Maybe<Shop_Hsn_Mappings_Variance_Fields>;
};


/** aggregate fields of "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Hsn_Mappings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Aggregate_Order_By = {
  avg?: InputMaybe<Shop_Hsn_Mappings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shop_Hsn_Mappings_Max_Order_By>;
  min?: InputMaybe<Shop_Hsn_Mappings_Min_Order_By>;
  stddev?: InputMaybe<Shop_Hsn_Mappings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Shop_Hsn_Mappings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Shop_Hsn_Mappings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Shop_Hsn_Mappings_Sum_Order_By>;
  var_pop?: InputMaybe<Shop_Hsn_Mappings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Shop_Hsn_Mappings_Var_Samp_Order_By>;
  variance?: InputMaybe<Shop_Hsn_Mappings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Arr_Rel_Insert_Input = {
  data: Array<Shop_Hsn_Mappings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Hsn_Mappings_On_Conflict>;
};

/** aggregate avg on columns */
export type Shop_Hsn_Mappings_Avg_Fields = {
  __typename?: 'shop_hsn_mappings_avg_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['Float']>;
  country_id?: Maybe<Scalars['Float']>;
  hsn_id?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Avg_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shop.hsn_mappings". All fields are combined with a logical 'AND'. */
export type Shop_Hsn_Mappings_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Hsn_Mappings_Bool_Exp>>;
  _not?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Hsn_Mappings_Bool_Exp>>;
  cgst?: InputMaybe<Numeric_Comparison_Exp>;
  country?: InputMaybe<Shop_Countries_Bool_Exp>;
  country_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hsn_id?: InputMaybe<Int_Comparison_Exp>;
  igst?: InputMaybe<Numeric_Comparison_Exp>;
  sgst?: InputMaybe<Numeric_Comparison_Exp>;
  state?: InputMaybe<Shop_States_Bool_Exp>;
  state_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.hsn_mappings" */
export enum Shop_Hsn_Mappings_Constraint {
  /** unique or primary key constraint on columns "hsn_id", "country_id", "state_id" */
  HsnMappingsPkey = 'hsn_mappings_pkey'
}

/** input type for incrementing numeric columns in table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Inc_Input = {
  /** This value is in percentage */
  cgst?: InputMaybe<Scalars['numeric']>;
  country_id?: InputMaybe<Scalars['Int']>;
  hsn_id?: InputMaybe<Scalars['Int']>;
  /** This value is in percentage */
  igst?: InputMaybe<Scalars['numeric']>;
  /** This value is in percentage */
  sgst?: InputMaybe<Scalars['numeric']>;
  state_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Insert_Input = {
  /** This value is in percentage */
  cgst?: InputMaybe<Scalars['numeric']>;
  country?: InputMaybe<Shop_Countries_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hsn_id?: InputMaybe<Scalars['Int']>;
  /** This value is in percentage */
  igst?: InputMaybe<Scalars['numeric']>;
  /** This value is in percentage */
  sgst?: InputMaybe<Scalars['numeric']>;
  state?: InputMaybe<Shop_States_Obj_Rel_Insert_Input>;
  state_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Shop_Hsn_Mappings_Max_Fields = {
  __typename?: 'shop_hsn_mappings_max_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['numeric']>;
  country_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hsn_id?: Maybe<Scalars['Int']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['numeric']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['numeric']>;
  state_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Max_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shop_Hsn_Mappings_Min_Fields = {
  __typename?: 'shop_hsn_mappings_min_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['numeric']>;
  country_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hsn_id?: Maybe<Scalars['Int']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['numeric']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['numeric']>;
  state_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Min_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Mutation_Response = {
  __typename?: 'shop_hsn_mappings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Hsn_Mappings>;
};

/** on_conflict condition type for table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_On_Conflict = {
  constraint: Shop_Hsn_Mappings_Constraint;
  update_columns?: Array<Shop_Hsn_Mappings_Update_Column>;
  where?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.hsn_mappings". */
export type Shop_Hsn_Mappings_Order_By = {
  cgst?: InputMaybe<Order_By>;
  country?: InputMaybe<Shop_Countries_Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  igst?: InputMaybe<Order_By>;
  sgst?: InputMaybe<Order_By>;
  state?: InputMaybe<Shop_States_Order_By>;
  state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.hsn_mappings */
export type Shop_Hsn_Mappings_Pk_Columns_Input = {
  country_id: Scalars['Int'];
  hsn_id: Scalars['Int'];
  state_id: Scalars['Int'];
};

/** select columns of table "shop.hsn_mappings" */
export enum Shop_Hsn_Mappings_Select_Column {
  /** column name */
  Cgst = 'cgst',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HsnId = 'hsn_id',
  /** column name */
  Igst = 'igst',
  /** column name */
  Sgst = 'sgst',
  /** column name */
  StateId = 'state_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Set_Input = {
  /** This value is in percentage */
  cgst?: InputMaybe<Scalars['numeric']>;
  country_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hsn_id?: InputMaybe<Scalars['Int']>;
  /** This value is in percentage */
  igst?: InputMaybe<Scalars['numeric']>;
  /** This value is in percentage */
  sgst?: InputMaybe<Scalars['numeric']>;
  state_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Shop_Hsn_Mappings_Stddev_Fields = {
  __typename?: 'shop_hsn_mappings_stddev_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['Float']>;
  country_id?: Maybe<Scalars['Float']>;
  hsn_id?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Stddev_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shop_Hsn_Mappings_Stddev_Pop_Fields = {
  __typename?: 'shop_hsn_mappings_stddev_pop_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['Float']>;
  country_id?: Maybe<Scalars['Float']>;
  hsn_id?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Stddev_Pop_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shop_Hsn_Mappings_Stddev_Samp_Fields = {
  __typename?: 'shop_hsn_mappings_stddev_samp_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['Float']>;
  country_id?: Maybe<Scalars['Float']>;
  hsn_id?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Stddev_Samp_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shop_hsn_mappings" */
export type Shop_Hsn_Mappings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Hsn_Mappings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Hsn_Mappings_Stream_Cursor_Value_Input = {
  /** This value is in percentage */
  cgst?: InputMaybe<Scalars['numeric']>;
  country_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hsn_id?: InputMaybe<Scalars['Int']>;
  /** This value is in percentage */
  igst?: InputMaybe<Scalars['numeric']>;
  /** This value is in percentage */
  sgst?: InputMaybe<Scalars['numeric']>;
  state_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Shop_Hsn_Mappings_Sum_Fields = {
  __typename?: 'shop_hsn_mappings_sum_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['numeric']>;
  country_id?: Maybe<Scalars['Int']>;
  hsn_id?: Maybe<Scalars['Int']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['numeric']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['numeric']>;
  state_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Sum_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** update columns of table "shop.hsn_mappings" */
export enum Shop_Hsn_Mappings_Update_Column {
  /** column name */
  Cgst = 'cgst',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HsnId = 'hsn_id',
  /** column name */
  Igst = 'igst',
  /** column name */
  Sgst = 'sgst',
  /** column name */
  StateId = 'state_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Shop_Hsn_Mappings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Hsn_Mappings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Hsn_Mappings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Hsn_Mappings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Hsn_Mappings_Var_Pop_Fields = {
  __typename?: 'shop_hsn_mappings_var_pop_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['Float']>;
  country_id?: Maybe<Scalars['Float']>;
  hsn_id?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Var_Pop_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shop_Hsn_Mappings_Var_Samp_Fields = {
  __typename?: 'shop_hsn_mappings_var_samp_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['Float']>;
  country_id?: Maybe<Scalars['Float']>;
  hsn_id?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Var_Samp_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shop_Hsn_Mappings_Variance_Fields = {
  __typename?: 'shop_hsn_mappings_variance_fields';
  /** This value is in percentage */
  cgst?: Maybe<Scalars['Float']>;
  country_id?: Maybe<Scalars['Float']>;
  hsn_id?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  igst?: Maybe<Scalars['Float']>;
  /** This value is in percentage */
  sgst?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shop.hsn_mappings" */
export type Shop_Hsn_Mappings_Variance_Order_By = {
  /** This value is in percentage */
  cgst?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  /** This value is in percentage */
  igst?: InputMaybe<Order_By>;
  /** This value is in percentage */
  sgst?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Shop_Hsn_Max_Fields = {
  __typename?: 'shop_hsn_max_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Shop_Hsn_Min_Fields = {
  __typename?: 'shop_hsn_min_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shop.hsn" */
export type Shop_Hsn_Mutation_Response = {
  __typename?: 'shop_hsn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Hsn>;
};

/** input type for inserting object relation for remote table "shop.hsn" */
export type Shop_Hsn_Obj_Rel_Insert_Input = {
  data: Shop_Hsn_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Hsn_On_Conflict>;
};

/** on_conflict condition type for table "shop.hsn" */
export type Shop_Hsn_On_Conflict = {
  constraint: Shop_Hsn_Constraint;
  update_columns?: Array<Shop_Hsn_Update_Column>;
  where?: InputMaybe<Shop_Hsn_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.hsn". */
export type Shop_Hsn_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mappings_aggregate?: InputMaybe<Shop_Hsn_Mappings_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.hsn */
export type Shop_Hsn_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "shop.hsn" */
export enum Shop_Hsn_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "shop.hsn" */
export type Shop_Hsn_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Shop_Hsn_Stddev_Fields = {
  __typename?: 'shop_hsn_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Shop_Hsn_Stddev_Pop_Fields = {
  __typename?: 'shop_hsn_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Shop_Hsn_Stddev_Samp_Fields = {
  __typename?: 'shop_hsn_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "shop_hsn" */
export type Shop_Hsn_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Hsn_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Hsn_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Shop_Hsn_Sum_Fields = {
  __typename?: 'shop_hsn_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "shop.hsn" */
export enum Shop_Hsn_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Shop_Hsn_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Hsn_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Hsn_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Hsn_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Hsn_Var_Pop_Fields = {
  __typename?: 'shop_hsn_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Shop_Hsn_Var_Samp_Fields = {
  __typename?: 'shop_hsn_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Shop_Hsn_Variance_Fields = {
  __typename?: 'shop_hsn_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "shop.inventory_skus" */
export type Shop_Inventory_Skus = {
  __typename?: 'shop_inventory_skus';
  available_quantity: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_available: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  product_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "shop.inventory_skus" */
export type Shop_Inventory_Skus_Aggregate = {
  __typename?: 'shop_inventory_skus_aggregate';
  aggregate?: Maybe<Shop_Inventory_Skus_Aggregate_Fields>;
  nodes: Array<Shop_Inventory_Skus>;
};

export type Shop_Inventory_Skus_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Shop_Inventory_Skus_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Shop_Inventory_Skus_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Shop_Inventory_Skus_Aggregate_Bool_Exp_Count>;
};

export type Shop_Inventory_Skus_Aggregate_Bool_Exp_Bool_And = {
  arguments: Shop_Inventory_Skus_Select_Column_Shop_Inventory_Skus_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shop_Inventory_Skus_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Shop_Inventory_Skus_Select_Column_Shop_Inventory_Skus_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shop_Inventory_Skus_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Shop_Inventory_Skus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shop.inventory_skus" */
export type Shop_Inventory_Skus_Aggregate_Fields = {
  __typename?: 'shop_inventory_skus_aggregate_fields';
  avg?: Maybe<Shop_Inventory_Skus_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Inventory_Skus_Max_Fields>;
  min?: Maybe<Shop_Inventory_Skus_Min_Fields>;
  stddev?: Maybe<Shop_Inventory_Skus_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Inventory_Skus_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Inventory_Skus_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Inventory_Skus_Sum_Fields>;
  var_pop?: Maybe<Shop_Inventory_Skus_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Inventory_Skus_Var_Samp_Fields>;
  variance?: Maybe<Shop_Inventory_Skus_Variance_Fields>;
};


/** aggregate fields of "shop.inventory_skus" */
export type Shop_Inventory_Skus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Inventory_Skus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Aggregate_Order_By = {
  avg?: InputMaybe<Shop_Inventory_Skus_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shop_Inventory_Skus_Max_Order_By>;
  min?: InputMaybe<Shop_Inventory_Skus_Min_Order_By>;
  stddev?: InputMaybe<Shop_Inventory_Skus_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Shop_Inventory_Skus_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Shop_Inventory_Skus_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Shop_Inventory_Skus_Sum_Order_By>;
  var_pop?: InputMaybe<Shop_Inventory_Skus_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Shop_Inventory_Skus_Var_Samp_Order_By>;
  variance?: InputMaybe<Shop_Inventory_Skus_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Arr_Rel_Insert_Input = {
  data: Array<Shop_Inventory_Skus_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Inventory_Skus_On_Conflict>;
};

/** aggregate avg on columns */
export type Shop_Inventory_Skus_Avg_Fields = {
  __typename?: 'shop_inventory_skus_avg_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Avg_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shop.inventory_skus". All fields are combined with a logical 'AND'. */
export type Shop_Inventory_Skus_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Inventory_Skus_Bool_Exp>>;
  _not?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Inventory_Skus_Bool_Exp>>;
  available_quantity?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_available?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.inventory_skus" */
export enum Shop_Inventory_Skus_Constraint {
  /** unique or primary key constraint on columns "id" */
  InventorySkusPkey = 'inventory_skus_pkey',
  /** unique or primary key constraint on columns "name", "product_id" */
  InventorySkusProductIdNameKey = 'inventory_skus_product_id_name_key'
}

/** input type for incrementing numeric columns in table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Inc_Input = {
  available_quantity?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Insert_Input = {
  available_quantity?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shop_Inventory_Skus_Max_Fields = {
  __typename?: 'shop_inventory_skus_max_fields';
  available_quantity?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Max_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shop_Inventory_Skus_Min_Fields = {
  __typename?: 'shop_inventory_skus_min_fields';
  available_quantity?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Min_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Mutation_Response = {
  __typename?: 'shop_inventory_skus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Inventory_Skus>;
};

/** on_conflict condition type for table "shop.inventory_skus" */
export type Shop_Inventory_Skus_On_Conflict = {
  constraint: Shop_Inventory_Skus_Constraint;
  update_columns?: Array<Shop_Inventory_Skus_Update_Column>;
  where?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.inventory_skus". */
export type Shop_Inventory_Skus_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_available?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.inventory_skus */
export type Shop_Inventory_Skus_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "shop.inventory_skus" */
export enum Shop_Inventory_Skus_Select_Column {
  /** column name */
  AvailableQuantity = 'available_quantity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAvailable = 'is_available',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** select "shop_inventory_skus_aggregate_bool_exp_bool_and_arguments_columns" columns of table "shop.inventory_skus" */
export enum Shop_Inventory_Skus_Select_Column_Shop_Inventory_Skus_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAvailable = 'is_available'
}

/** select "shop_inventory_skus_aggregate_bool_exp_bool_or_arguments_columns" columns of table "shop.inventory_skus" */
export enum Shop_Inventory_Skus_Select_Column_Shop_Inventory_Skus_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAvailable = 'is_available'
}

/** input type for updating data in table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Set_Input = {
  available_quantity?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Shop_Inventory_Skus_Stddev_Fields = {
  __typename?: 'shop_inventory_skus_stddev_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Stddev_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shop_Inventory_Skus_Stddev_Pop_Fields = {
  __typename?: 'shop_inventory_skus_stddev_pop_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Stddev_Pop_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shop_Inventory_Skus_Stddev_Samp_Fields = {
  __typename?: 'shop_inventory_skus_stddev_samp_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Stddev_Samp_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shop_inventory_skus" */
export type Shop_Inventory_Skus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Inventory_Skus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Inventory_Skus_Stream_Cursor_Value_Input = {
  available_quantity?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_available?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Shop_Inventory_Skus_Sum_Fields = {
  __typename?: 'shop_inventory_skus_sum_fields';
  available_quantity?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Sum_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** update columns of table "shop.inventory_skus" */
export enum Shop_Inventory_Skus_Update_Column {
  /** column name */
  AvailableQuantity = 'available_quantity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Shop_Inventory_Skus_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Inventory_Skus_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Inventory_Skus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Inventory_Skus_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Inventory_Skus_Var_Pop_Fields = {
  __typename?: 'shop_inventory_skus_var_pop_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Var_Pop_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shop_Inventory_Skus_Var_Samp_Fields = {
  __typename?: 'shop_inventory_skus_var_samp_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Var_Samp_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shop_Inventory_Skus_Variance_Fields = {
  __typename?: 'shop_inventory_skus_variance_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shop.inventory_skus" */
export type Shop_Inventory_Skus_Variance_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** This table is used as an enum table to store the order payment status */
export type Shop_Order_Payment_Status = {
  __typename?: 'shop_order_payment_status';
  value: Scalars['String'];
};

/** aggregated selection of "shop.order_payment_status" */
export type Shop_Order_Payment_Status_Aggregate = {
  __typename?: 'shop_order_payment_status_aggregate';
  aggregate?: Maybe<Shop_Order_Payment_Status_Aggregate_Fields>;
  nodes: Array<Shop_Order_Payment_Status>;
};

/** aggregate fields of "shop.order_payment_status" */
export type Shop_Order_Payment_Status_Aggregate_Fields = {
  __typename?: 'shop_order_payment_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Shop_Order_Payment_Status_Max_Fields>;
  min?: Maybe<Shop_Order_Payment_Status_Min_Fields>;
};


/** aggregate fields of "shop.order_payment_status" */
export type Shop_Order_Payment_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Order_Payment_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shop.order_payment_status". All fields are combined with a logical 'AND'. */
export type Shop_Order_Payment_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Order_Payment_Status_Bool_Exp>>;
  _not?: InputMaybe<Shop_Order_Payment_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Order_Payment_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.order_payment_status" */
export enum Shop_Order_Payment_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  OrderPaymentStatusPkey = 'order_payment_status_pkey'
}

export enum Shop_Order_Payment_Status_Enum {
  Authorized = 'authorized',
  Captured = 'captured',
  Created = 'created',
  Failed = 'failed',
  Refunded = 'refunded'
}

/** Boolean expression to compare columns of type "shop_order_payment_status_enum". All fields are combined with logical 'AND'. */
export type Shop_Order_Payment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Shop_Order_Payment_Status_Enum>;
  _in?: InputMaybe<Array<Shop_Order_Payment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Shop_Order_Payment_Status_Enum>;
  _nin?: InputMaybe<Array<Shop_Order_Payment_Status_Enum>>;
};

/** input type for inserting data into table "shop.order_payment_status" */
export type Shop_Order_Payment_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shop_Order_Payment_Status_Max_Fields = {
  __typename?: 'shop_order_payment_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Shop_Order_Payment_Status_Min_Fields = {
  __typename?: 'shop_order_payment_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shop.order_payment_status" */
export type Shop_Order_Payment_Status_Mutation_Response = {
  __typename?: 'shop_order_payment_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Order_Payment_Status>;
};

/** on_conflict condition type for table "shop.order_payment_status" */
export type Shop_Order_Payment_Status_On_Conflict = {
  constraint: Shop_Order_Payment_Status_Constraint;
  update_columns?: Array<Shop_Order_Payment_Status_Update_Column>;
  where?: InputMaybe<Shop_Order_Payment_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.order_payment_status". */
export type Shop_Order_Payment_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.order_payment_status */
export type Shop_Order_Payment_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "shop.order_payment_status" */
export enum Shop_Order_Payment_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "shop.order_payment_status" */
export type Shop_Order_Payment_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "shop_order_payment_status" */
export type Shop_Order_Payment_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Order_Payment_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Order_Payment_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "shop.order_payment_status" */
export enum Shop_Order_Payment_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Shop_Order_Payment_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Order_Payment_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Order_Payment_Status_Bool_Exp;
};

/** This table is used to store the products for an order */
export type Shop_Order_Products = {
  __typename?: 'shop_order_products';
  created_at: Scalars['timestamptz'];
  hsn_details: Scalars['jsonb'];
  hsn_mapping_details: Scalars['jsonb'];
  id: Scalars['Int'];
  is_schwag: Scalars['Boolean'];
  /** An object relationship */
  order?: Maybe<Shop_Orders>;
  order_id: Scalars['Int'];
  /** Stores a snapshot of the product details */
  product_details: Scalars['jsonb'];
  product_id: Scalars['Int'];
  quantity: Scalars['Int'];
  schwag_track_id?: Maybe<Scalars['Int']>;
  sku_details: Scalars['jsonb'];
  sku_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};


/** This table is used to store the products for an order */
export type Shop_Order_ProductsHsn_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the products for an order */
export type Shop_Order_ProductsHsn_Mapping_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the products for an order */
export type Shop_Order_ProductsProduct_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the products for an order */
export type Shop_Order_ProductsSku_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "shop.order_products" */
export type Shop_Order_Products_Aggregate = {
  __typename?: 'shop_order_products_aggregate';
  aggregate?: Maybe<Shop_Order_Products_Aggregate_Fields>;
  nodes: Array<Shop_Order_Products>;
};

export type Shop_Order_Products_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Shop_Order_Products_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Shop_Order_Products_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Shop_Order_Products_Aggregate_Bool_Exp_Count>;
};

export type Shop_Order_Products_Aggregate_Bool_Exp_Bool_And = {
  arguments: Shop_Order_Products_Select_Column_Shop_Order_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Shop_Order_Products_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shop_Order_Products_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Shop_Order_Products_Select_Column_Shop_Order_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Shop_Order_Products_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shop_Order_Products_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Shop_Order_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Shop_Order_Products_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shop.order_products" */
export type Shop_Order_Products_Aggregate_Fields = {
  __typename?: 'shop_order_products_aggregate_fields';
  avg?: Maybe<Shop_Order_Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Order_Products_Max_Fields>;
  min?: Maybe<Shop_Order_Products_Min_Fields>;
  stddev?: Maybe<Shop_Order_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Order_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Order_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Order_Products_Sum_Fields>;
  var_pop?: Maybe<Shop_Order_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Order_Products_Var_Samp_Fields>;
  variance?: Maybe<Shop_Order_Products_Variance_Fields>;
};


/** aggregate fields of "shop.order_products" */
export type Shop_Order_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Order_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shop.order_products" */
export type Shop_Order_Products_Aggregate_Order_By = {
  avg?: InputMaybe<Shop_Order_Products_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shop_Order_Products_Max_Order_By>;
  min?: InputMaybe<Shop_Order_Products_Min_Order_By>;
  stddev?: InputMaybe<Shop_Order_Products_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Shop_Order_Products_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Shop_Order_Products_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Shop_Order_Products_Sum_Order_By>;
  var_pop?: InputMaybe<Shop_Order_Products_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Shop_Order_Products_Var_Samp_Order_By>;
  variance?: InputMaybe<Shop_Order_Products_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Shop_Order_Products_Append_Input = {
  hsn_details?: InputMaybe<Scalars['jsonb']>;
  hsn_mapping_details?: InputMaybe<Scalars['jsonb']>;
  /** Stores a snapshot of the product details */
  product_details?: InputMaybe<Scalars['jsonb']>;
  sku_details?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "shop.order_products" */
export type Shop_Order_Products_Arr_Rel_Insert_Input = {
  data: Array<Shop_Order_Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Order_Products_On_Conflict>;
};

/** aggregate avg on columns */
export type Shop_Order_Products_Avg_Fields = {
  __typename?: 'shop_order_products_avg_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shop.order_products" */
export type Shop_Order_Products_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shop.order_products". All fields are combined with a logical 'AND'. */
export type Shop_Order_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Order_Products_Bool_Exp>>;
  _not?: InputMaybe<Shop_Order_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Order_Products_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hsn_details?: InputMaybe<Jsonb_Comparison_Exp>;
  hsn_mapping_details?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_schwag?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Shop_Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  product_details?: InputMaybe<Jsonb_Comparison_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  schwag_track_id?: InputMaybe<Int_Comparison_Exp>;
  sku_details?: InputMaybe<Jsonb_Comparison_Exp>;
  sku_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.order_products" */
export enum Shop_Order_Products_Constraint {
  /** unique or primary key constraint on columns "product_id", "order_id" */
  OrderProductsOrderIdProductIdKey = 'order_products_order_id_product_id_key',
  /** unique or primary key constraint on columns "id" */
  OrderProductsPkey = 'order_products_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Shop_Order_Products_Delete_At_Path_Input = {
  hsn_details?: InputMaybe<Array<Scalars['String']>>;
  hsn_mapping_details?: InputMaybe<Array<Scalars['String']>>;
  /** Stores a snapshot of the product details */
  product_details?: InputMaybe<Array<Scalars['String']>>;
  sku_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Shop_Order_Products_Delete_Elem_Input = {
  hsn_details?: InputMaybe<Scalars['Int']>;
  hsn_mapping_details?: InputMaybe<Scalars['Int']>;
  /** Stores a snapshot of the product details */
  product_details?: InputMaybe<Scalars['Int']>;
  sku_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Shop_Order_Products_Delete_Key_Input = {
  hsn_details?: InputMaybe<Scalars['String']>;
  hsn_mapping_details?: InputMaybe<Scalars['String']>;
  /** Stores a snapshot of the product details */
  product_details?: InputMaybe<Scalars['String']>;
  sku_details?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "shop.order_products" */
export type Shop_Order_Products_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  schwag_track_id?: InputMaybe<Scalars['Int']>;
  sku_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.order_products" */
export type Shop_Order_Products_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hsn_details?: InputMaybe<Scalars['jsonb']>;
  hsn_mapping_details?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Shop_Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  /** Stores a snapshot of the product details */
  product_details?: InputMaybe<Scalars['jsonb']>;
  product_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  schwag_track_id?: InputMaybe<Scalars['Int']>;
  sku_details?: InputMaybe<Scalars['jsonb']>;
  sku_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Shop_Order_Products_Max_Fields = {
  __typename?: 'shop_order_products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  schwag_track_id?: Maybe<Scalars['Int']>;
  sku_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shop.order_products" */
export type Shop_Order_Products_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shop_Order_Products_Min_Fields = {
  __typename?: 'shop_order_products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  schwag_track_id?: Maybe<Scalars['Int']>;
  sku_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shop.order_products" */
export type Shop_Order_Products_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shop.order_products" */
export type Shop_Order_Products_Mutation_Response = {
  __typename?: 'shop_order_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Order_Products>;
};

/** on_conflict condition type for table "shop.order_products" */
export type Shop_Order_Products_On_Conflict = {
  constraint: Shop_Order_Products_Constraint;
  update_columns?: Array<Shop_Order_Products_Update_Column>;
  where?: InputMaybe<Shop_Order_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.order_products". */
export type Shop_Order_Products_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hsn_details?: InputMaybe<Order_By>;
  hsn_mapping_details?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_schwag?: InputMaybe<Order_By>;
  order?: InputMaybe<Shop_Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_details?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_details?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.order_products */
export type Shop_Order_Products_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Shop_Order_Products_Prepend_Input = {
  hsn_details?: InputMaybe<Scalars['jsonb']>;
  hsn_mapping_details?: InputMaybe<Scalars['jsonb']>;
  /** Stores a snapshot of the product details */
  product_details?: InputMaybe<Scalars['jsonb']>;
  sku_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shop.order_products" */
export enum Shop_Order_Products_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HsnDetails = 'hsn_details',
  /** column name */
  HsnMappingDetails = 'hsn_mapping_details',
  /** column name */
  Id = 'id',
  /** column name */
  IsSchwag = 'is_schwag',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  ProductDetails = 'product_details',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  SchwagTrackId = 'schwag_track_id',
  /** column name */
  SkuDetails = 'sku_details',
  /** column name */
  SkuId = 'sku_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "shop_order_products_aggregate_bool_exp_bool_and_arguments_columns" columns of table "shop.order_products" */
export enum Shop_Order_Products_Select_Column_Shop_Order_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsSchwag = 'is_schwag'
}

/** select "shop_order_products_aggregate_bool_exp_bool_or_arguments_columns" columns of table "shop.order_products" */
export enum Shop_Order_Products_Select_Column_Shop_Order_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsSchwag = 'is_schwag'
}

/** input type for updating data in table "shop.order_products" */
export type Shop_Order_Products_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hsn_details?: InputMaybe<Scalars['jsonb']>;
  hsn_mapping_details?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  order_id?: InputMaybe<Scalars['Int']>;
  /** Stores a snapshot of the product details */
  product_details?: InputMaybe<Scalars['jsonb']>;
  product_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  schwag_track_id?: InputMaybe<Scalars['Int']>;
  sku_details?: InputMaybe<Scalars['jsonb']>;
  sku_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Shop_Order_Products_Stddev_Fields = {
  __typename?: 'shop_order_products_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shop.order_products" */
export type Shop_Order_Products_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shop_Order_Products_Stddev_Pop_Fields = {
  __typename?: 'shop_order_products_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shop.order_products" */
export type Shop_Order_Products_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shop_Order_Products_Stddev_Samp_Fields = {
  __typename?: 'shop_order_products_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shop.order_products" */
export type Shop_Order_Products_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shop_order_products" */
export type Shop_Order_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Order_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Order_Products_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hsn_details?: InputMaybe<Scalars['jsonb']>;
  hsn_mapping_details?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  order_id?: InputMaybe<Scalars['Int']>;
  /** Stores a snapshot of the product details */
  product_details?: InputMaybe<Scalars['jsonb']>;
  product_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  schwag_track_id?: InputMaybe<Scalars['Int']>;
  sku_details?: InputMaybe<Scalars['jsonb']>;
  sku_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Shop_Order_Products_Sum_Fields = {
  __typename?: 'shop_order_products_sum_fields';
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  schwag_track_id?: Maybe<Scalars['Int']>;
  sku_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shop.order_products" */
export type Shop_Order_Products_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** update columns of table "shop.order_products" */
export enum Shop_Order_Products_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HsnDetails = 'hsn_details',
  /** column name */
  HsnMappingDetails = 'hsn_mapping_details',
  /** column name */
  Id = 'id',
  /** column name */
  IsSchwag = 'is_schwag',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  ProductDetails = 'product_details',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  SchwagTrackId = 'schwag_track_id',
  /** column name */
  SkuDetails = 'sku_details',
  /** column name */
  SkuId = 'sku_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Shop_Order_Products_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Shop_Order_Products_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Shop_Order_Products_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Shop_Order_Products_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Shop_Order_Products_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Order_Products_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Shop_Order_Products_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Order_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Order_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Order_Products_Var_Pop_Fields = {
  __typename?: 'shop_order_products_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shop.order_products" */
export type Shop_Order_Products_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shop_Order_Products_Var_Samp_Fields = {
  __typename?: 'shop_order_products_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shop.order_products" */
export type Shop_Order_Products_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shop_Order_Products_Variance_Fields = {
  __typename?: 'shop_order_products_variance_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shop.order_products" */
export type Shop_Order_Products_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
};

/** This table is used to store the orders */
export type Shop_Orders = {
  __typename?: 'shop_orders';
  /** This function is used to prefix the ASSETS_URL */
  _invoice?: Maybe<Scalars['String']>;
  amount: Scalars['Int'];
  clickpost_status?: Maybe<Scalars['jsonb']>;
  country_details: Scalars['jsonb'];
  /** An object relationship */
  coupon?: Maybe<Shop_Coupons>;
  /** Stores a snapshot of the coupon details */
  coupon_details?: Maybe<Scalars['jsonb']>;
  coupon_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** The s3 path/uri for the invoice generated for the order */
  invoice?: Maybe<Scalars['String']>;
  /** The integer field used to indicate the sequential invoice number */
  invoice_number?: Maybe<Scalars['String']>;
  is_schwag: Scalars['Boolean'];
  /** The label for the order generated by clickpost, attached physcially on the shipment */
  label?: Maybe<Scalars['String']>;
  order_id: Scalars['String'];
  order_payment_status?: Maybe<Shop_Order_Payment_Status_Enum>;
  pickup_address_details?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  products: Array<Shop_Order_Products>;
  /** An aggregate relationship */
  products_aggregate: Shop_Order_Products_Aggregate;
  razorpay_meta?: Maybe<Scalars['jsonb']>;
  razorpay_order_id?: Maybe<Scalars['citext']>;
  razorpay_payment_id?: Maybe<Scalars['citext']>;
  /** The boolean field that indicates the order is ready to be shipped */
  ready_for_shipment: Scalars['Boolean'];
  schwag_track_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  shipping_address?: Maybe<Shop_Shipping_Addresses>;
  /** Stores a snapshot of the user shipping address */
  shipping_address_details: Scalars['jsonb'];
  shipping_address_id: Scalars['Int'];
  state_details: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
  /** The AWB for the order generated by clickpost */
  waybill?: Maybe<Scalars['String']>;
};


/** This table is used to store the orders */
export type Shop_OrdersClickpost_StatusArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the orders */
export type Shop_OrdersCountry_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the orders */
export type Shop_OrdersCoupon_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the orders */
export type Shop_OrdersPickup_Address_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the orders */
export type Shop_OrdersProductsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Products_Order_By>>;
  where?: InputMaybe<Shop_Order_Products_Bool_Exp>;
};


/** This table is used to store the orders */
export type Shop_OrdersProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Products_Order_By>>;
  where?: InputMaybe<Shop_Order_Products_Bool_Exp>;
};


/** This table is used to store the orders */
export type Shop_OrdersRazorpay_MetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the orders */
export type Shop_OrdersShipping_Address_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the orders */
export type Shop_OrdersState_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "shop.orders" */
export type Shop_Orders_Aggregate = {
  __typename?: 'shop_orders_aggregate';
  aggregate?: Maybe<Shop_Orders_Aggregate_Fields>;
  nodes: Array<Shop_Orders>;
};

/** aggregate fields of "shop.orders" */
export type Shop_Orders_Aggregate_Fields = {
  __typename?: 'shop_orders_aggregate_fields';
  avg?: Maybe<Shop_Orders_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Orders_Max_Fields>;
  min?: Maybe<Shop_Orders_Min_Fields>;
  stddev?: Maybe<Shop_Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Orders_Sum_Fields>;
  var_pop?: Maybe<Shop_Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Orders_Var_Samp_Fields>;
  variance?: Maybe<Shop_Orders_Variance_Fields>;
};


/** aggregate fields of "shop.orders" */
export type Shop_Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Shop_Orders_Append_Input = {
  clickpost_status?: InputMaybe<Scalars['jsonb']>;
  country_details?: InputMaybe<Scalars['jsonb']>;
  /** Stores a snapshot of the coupon details */
  coupon_details?: InputMaybe<Scalars['jsonb']>;
  pickup_address_details?: InputMaybe<Scalars['jsonb']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  /** Stores a snapshot of the user shipping address */
  shipping_address_details?: InputMaybe<Scalars['jsonb']>;
  state_details?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Shop_Orders_Avg_Fields = {
  __typename?: 'shop_orders_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  coupon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  shipping_address_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shop.orders". All fields are combined with a logical 'AND'. */
export type Shop_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Orders_Bool_Exp>>;
  _invoice?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Shop_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Orders_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  clickpost_status?: InputMaybe<Jsonb_Comparison_Exp>;
  country_details?: InputMaybe<Jsonb_Comparison_Exp>;
  coupon?: InputMaybe<Shop_Coupons_Bool_Exp>;
  coupon_details?: InputMaybe<Jsonb_Comparison_Exp>;
  coupon_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoice?: InputMaybe<String_Comparison_Exp>;
  invoice_number?: InputMaybe<String_Comparison_Exp>;
  is_schwag?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  order_id?: InputMaybe<String_Comparison_Exp>;
  order_payment_status?: InputMaybe<Shop_Order_Payment_Status_Enum_Comparison_Exp>;
  pickup_address_details?: InputMaybe<Jsonb_Comparison_Exp>;
  products?: InputMaybe<Shop_Order_Products_Bool_Exp>;
  products_aggregate?: InputMaybe<Shop_Order_Products_Aggregate_Bool_Exp>;
  razorpay_meta?: InputMaybe<Jsonb_Comparison_Exp>;
  razorpay_order_id?: InputMaybe<Citext_Comparison_Exp>;
  razorpay_payment_id?: InputMaybe<Citext_Comparison_Exp>;
  ready_for_shipment?: InputMaybe<Boolean_Comparison_Exp>;
  schwag_track_id?: InputMaybe<Int_Comparison_Exp>;
  shipping_address?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
  shipping_address_details?: InputMaybe<Jsonb_Comparison_Exp>;
  shipping_address_id?: InputMaybe<Int_Comparison_Exp>;
  state_details?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  waybill?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.orders" */
export enum Shop_Orders_Constraint {
  /** unique or primary key constraint on columns "order_id" */
  OrdersOrderIdKey = 'orders_order_id_key',
  /** unique or primary key constraint on columns "id" */
  OrdersPkey = 'orders_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Shop_Orders_Delete_At_Path_Input = {
  clickpost_status?: InputMaybe<Array<Scalars['String']>>;
  country_details?: InputMaybe<Array<Scalars['String']>>;
  /** Stores a snapshot of the coupon details */
  coupon_details?: InputMaybe<Array<Scalars['String']>>;
  pickup_address_details?: InputMaybe<Array<Scalars['String']>>;
  razorpay_meta?: InputMaybe<Array<Scalars['String']>>;
  /** Stores a snapshot of the user shipping address */
  shipping_address_details?: InputMaybe<Array<Scalars['String']>>;
  state_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Shop_Orders_Delete_Elem_Input = {
  clickpost_status?: InputMaybe<Scalars['Int']>;
  country_details?: InputMaybe<Scalars['Int']>;
  /** Stores a snapshot of the coupon details */
  coupon_details?: InputMaybe<Scalars['Int']>;
  pickup_address_details?: InputMaybe<Scalars['Int']>;
  razorpay_meta?: InputMaybe<Scalars['Int']>;
  /** Stores a snapshot of the user shipping address */
  shipping_address_details?: InputMaybe<Scalars['Int']>;
  state_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Shop_Orders_Delete_Key_Input = {
  clickpost_status?: InputMaybe<Scalars['String']>;
  country_details?: InputMaybe<Scalars['String']>;
  /** Stores a snapshot of the coupon details */
  coupon_details?: InputMaybe<Scalars['String']>;
  pickup_address_details?: InputMaybe<Scalars['String']>;
  razorpay_meta?: InputMaybe<Scalars['String']>;
  /** Stores a snapshot of the user shipping address */
  shipping_address_details?: InputMaybe<Scalars['String']>;
  state_details?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "shop.orders" */
export type Shop_Orders_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  coupon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  schwag_track_id?: InputMaybe<Scalars['Int']>;
  shipping_address_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.orders" */
export type Shop_Orders_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  clickpost_status?: InputMaybe<Scalars['jsonb']>;
  country_details?: InputMaybe<Scalars['jsonb']>;
  coupon?: InputMaybe<Shop_Coupons_Obj_Rel_Insert_Input>;
  /** Stores a snapshot of the coupon details */
  coupon_details?: InputMaybe<Scalars['jsonb']>;
  coupon_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The s3 path/uri for the invoice generated for the order */
  invoice?: InputMaybe<Scalars['String']>;
  /** The integer field used to indicate the sequential invoice number */
  invoice_number?: InputMaybe<Scalars['String']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  /** The label for the order generated by clickpost, attached physcially on the shipment */
  label?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['String']>;
  order_payment_status?: InputMaybe<Shop_Order_Payment_Status_Enum>;
  pickup_address_details?: InputMaybe<Scalars['jsonb']>;
  products?: InputMaybe<Shop_Order_Products_Arr_Rel_Insert_Input>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  razorpay_order_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_id?: InputMaybe<Scalars['citext']>;
  /** The boolean field that indicates the order is ready to be shipped */
  ready_for_shipment?: InputMaybe<Scalars['Boolean']>;
  schwag_track_id?: InputMaybe<Scalars['Int']>;
  shipping_address?: InputMaybe<Shop_Shipping_Addresses_Obj_Rel_Insert_Input>;
  /** Stores a snapshot of the user shipping address */
  shipping_address_details?: InputMaybe<Scalars['jsonb']>;
  shipping_address_id?: InputMaybe<Scalars['Int']>;
  state_details?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  /** The AWB for the order generated by clickpost */
  waybill?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shop_Orders_Max_Fields = {
  __typename?: 'shop_orders_max_fields';
  amount?: Maybe<Scalars['Int']>;
  coupon_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  /** The s3 path/uri for the invoice generated for the order */
  invoice?: Maybe<Scalars['String']>;
  /** The integer field used to indicate the sequential invoice number */
  invoice_number?: Maybe<Scalars['String']>;
  /** The label for the order generated by clickpost, attached physcially on the shipment */
  label?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  razorpay_order_id?: Maybe<Scalars['citext']>;
  razorpay_payment_id?: Maybe<Scalars['citext']>;
  schwag_track_id?: Maybe<Scalars['Int']>;
  shipping_address_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  /** The AWB for the order generated by clickpost */
  waybill?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Shop_Orders_Min_Fields = {
  __typename?: 'shop_orders_min_fields';
  amount?: Maybe<Scalars['Int']>;
  coupon_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  /** The s3 path/uri for the invoice generated for the order */
  invoice?: Maybe<Scalars['String']>;
  /** The integer field used to indicate the sequential invoice number */
  invoice_number?: Maybe<Scalars['String']>;
  /** The label for the order generated by clickpost, attached physcially on the shipment */
  label?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  razorpay_order_id?: Maybe<Scalars['citext']>;
  razorpay_payment_id?: Maybe<Scalars['citext']>;
  schwag_track_id?: Maybe<Scalars['Int']>;
  shipping_address_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  /** The AWB for the order generated by clickpost */
  waybill?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shop.orders" */
export type Shop_Orders_Mutation_Response = {
  __typename?: 'shop_orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Orders>;
};

/** input type for inserting object relation for remote table "shop.orders" */
export type Shop_Orders_Obj_Rel_Insert_Input = {
  data: Shop_Orders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Orders_On_Conflict>;
};

/** on_conflict condition type for table "shop.orders" */
export type Shop_Orders_On_Conflict = {
  constraint: Shop_Orders_Constraint;
  update_columns?: Array<Shop_Orders_Update_Column>;
  where?: InputMaybe<Shop_Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.orders". */
export type Shop_Orders_Order_By = {
  _invoice?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  clickpost_status?: InputMaybe<Order_By>;
  country_details?: InputMaybe<Order_By>;
  coupon?: InputMaybe<Shop_Coupons_Order_By>;
  coupon_details?: InputMaybe<Order_By>;
  coupon_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  is_schwag?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  order_payment_status?: InputMaybe<Order_By>;
  pickup_address_details?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Shop_Order_Products_Aggregate_Order_By>;
  razorpay_meta?: InputMaybe<Order_By>;
  razorpay_order_id?: InputMaybe<Order_By>;
  razorpay_payment_id?: InputMaybe<Order_By>;
  ready_for_shipment?: InputMaybe<Order_By>;
  schwag_track_id?: InputMaybe<Order_By>;
  shipping_address?: InputMaybe<Shop_Shipping_Addresses_Order_By>;
  shipping_address_details?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  state_details?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  waybill?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.orders */
export type Shop_Orders_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Shop_Orders_Prepend_Input = {
  clickpost_status?: InputMaybe<Scalars['jsonb']>;
  country_details?: InputMaybe<Scalars['jsonb']>;
  /** Stores a snapshot of the coupon details */
  coupon_details?: InputMaybe<Scalars['jsonb']>;
  pickup_address_details?: InputMaybe<Scalars['jsonb']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  /** Stores a snapshot of the user shipping address */
  shipping_address_details?: InputMaybe<Scalars['jsonb']>;
  state_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shop.orders" */
export enum Shop_Orders_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ClickpostStatus = 'clickpost_status',
  /** column name */
  CountryDetails = 'country_details',
  /** column name */
  CouponDetails = 'coupon_details',
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  IsSchwag = 'is_schwag',
  /** column name */
  Label = 'label',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OrderPaymentStatus = 'order_payment_status',
  /** column name */
  PickupAddressDetails = 'pickup_address_details',
  /** column name */
  RazorpayMeta = 'razorpay_meta',
  /** column name */
  RazorpayOrderId = 'razorpay_order_id',
  /** column name */
  RazorpayPaymentId = 'razorpay_payment_id',
  /** column name */
  ReadyForShipment = 'ready_for_shipment',
  /** column name */
  SchwagTrackId = 'schwag_track_id',
  /** column name */
  ShippingAddressDetails = 'shipping_address_details',
  /** column name */
  ShippingAddressId = 'shipping_address_id',
  /** column name */
  StateDetails = 'state_details',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Waybill = 'waybill'
}

/** input type for updating data in table "shop.orders" */
export type Shop_Orders_Set_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  clickpost_status?: InputMaybe<Scalars['jsonb']>;
  country_details?: InputMaybe<Scalars['jsonb']>;
  /** Stores a snapshot of the coupon details */
  coupon_details?: InputMaybe<Scalars['jsonb']>;
  coupon_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The s3 path/uri for the invoice generated for the order */
  invoice?: InputMaybe<Scalars['String']>;
  /** The integer field used to indicate the sequential invoice number */
  invoice_number?: InputMaybe<Scalars['String']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  /** The label for the order generated by clickpost, attached physcially on the shipment */
  label?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['String']>;
  order_payment_status?: InputMaybe<Shop_Order_Payment_Status_Enum>;
  pickup_address_details?: InputMaybe<Scalars['jsonb']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  razorpay_order_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_id?: InputMaybe<Scalars['citext']>;
  /** The boolean field that indicates the order is ready to be shipped */
  ready_for_shipment?: InputMaybe<Scalars['Boolean']>;
  schwag_track_id?: InputMaybe<Scalars['Int']>;
  /** Stores a snapshot of the user shipping address */
  shipping_address_details?: InputMaybe<Scalars['jsonb']>;
  shipping_address_id?: InputMaybe<Scalars['Int']>;
  state_details?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  /** The AWB for the order generated by clickpost */
  waybill?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Shop_Orders_Stddev_Fields = {
  __typename?: 'shop_orders_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  coupon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  shipping_address_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Shop_Orders_Stddev_Pop_Fields = {
  __typename?: 'shop_orders_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  coupon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  shipping_address_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Shop_Orders_Stddev_Samp_Fields = {
  __typename?: 'shop_orders_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  coupon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  shipping_address_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "shop_orders" */
export type Shop_Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Orders_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  clickpost_status?: InputMaybe<Scalars['jsonb']>;
  country_details?: InputMaybe<Scalars['jsonb']>;
  /** Stores a snapshot of the coupon details */
  coupon_details?: InputMaybe<Scalars['jsonb']>;
  coupon_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The s3 path/uri for the invoice generated for the order */
  invoice?: InputMaybe<Scalars['String']>;
  /** The integer field used to indicate the sequential invoice number */
  invoice_number?: InputMaybe<Scalars['String']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  /** The label for the order generated by clickpost, attached physcially on the shipment */
  label?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['String']>;
  order_payment_status?: InputMaybe<Shop_Order_Payment_Status_Enum>;
  pickup_address_details?: InputMaybe<Scalars['jsonb']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  razorpay_order_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_id?: InputMaybe<Scalars['citext']>;
  /** The boolean field that indicates the order is ready to be shipped */
  ready_for_shipment?: InputMaybe<Scalars['Boolean']>;
  schwag_track_id?: InputMaybe<Scalars['Int']>;
  /** Stores a snapshot of the user shipping address */
  shipping_address_details?: InputMaybe<Scalars['jsonb']>;
  shipping_address_id?: InputMaybe<Scalars['Int']>;
  state_details?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  /** The AWB for the order generated by clickpost */
  waybill?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Shop_Orders_Sum_Fields = {
  __typename?: 'shop_orders_sum_fields';
  amount?: Maybe<Scalars['Int']>;
  coupon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  schwag_track_id?: Maybe<Scalars['Int']>;
  shipping_address_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "shop.orders" */
export enum Shop_Orders_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ClickpostStatus = 'clickpost_status',
  /** column name */
  CountryDetails = 'country_details',
  /** column name */
  CouponDetails = 'coupon_details',
  /** column name */
  CouponId = 'coupon_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  IsSchwag = 'is_schwag',
  /** column name */
  Label = 'label',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OrderPaymentStatus = 'order_payment_status',
  /** column name */
  PickupAddressDetails = 'pickup_address_details',
  /** column name */
  RazorpayMeta = 'razorpay_meta',
  /** column name */
  RazorpayOrderId = 'razorpay_order_id',
  /** column name */
  RazorpayPaymentId = 'razorpay_payment_id',
  /** column name */
  ReadyForShipment = 'ready_for_shipment',
  /** column name */
  SchwagTrackId = 'schwag_track_id',
  /** column name */
  ShippingAddressDetails = 'shipping_address_details',
  /** column name */
  ShippingAddressId = 'shipping_address_id',
  /** column name */
  StateDetails = 'state_details',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Waybill = 'waybill'
}

export type Shop_Orders_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Shop_Orders_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Shop_Orders_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Shop_Orders_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Shop_Orders_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Orders_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Shop_Orders_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Orders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Orders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Orders_Var_Pop_Fields = {
  __typename?: 'shop_orders_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  coupon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  shipping_address_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Shop_Orders_Var_Samp_Fields = {
  __typename?: 'shop_orders_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  coupon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  shipping_address_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Shop_Orders_Variance_Fields = {
  __typename?: 'shop_orders_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  coupon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  schwag_track_id?: Maybe<Scalars['Float']>;
  shipping_address_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

export type Shop_PlaceOrderInputProducts = {
  product_uuid: Scalars['String'];
  quantity: Scalars['Int'];
  sku_uuid: Scalars['String'];
};

export type Shop_PlaceOrderOutput = {
  __typename?: 'shop_placeOrderOutput';
  order_id: Scalars['String'];
  razorpay_order_id: Scalars['String'];
};

/** This table is used as an enum table to store the types of products */
export type Shop_Product_Type = {
  __typename?: 'shop_product_type';
  value: Scalars['String'];
};

/** aggregated selection of "shop.product_type" */
export type Shop_Product_Type_Aggregate = {
  __typename?: 'shop_product_type_aggregate';
  aggregate?: Maybe<Shop_Product_Type_Aggregate_Fields>;
  nodes: Array<Shop_Product_Type>;
};

/** aggregate fields of "shop.product_type" */
export type Shop_Product_Type_Aggregate_Fields = {
  __typename?: 'shop_product_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Shop_Product_Type_Max_Fields>;
  min?: Maybe<Shop_Product_Type_Min_Fields>;
};


/** aggregate fields of "shop.product_type" */
export type Shop_Product_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Product_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shop.product_type". All fields are combined with a logical 'AND'. */
export type Shop_Product_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Product_Type_Bool_Exp>>;
  _not?: InputMaybe<Shop_Product_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Product_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.product_type" */
export enum Shop_Product_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProductTypePkey = 'product_type_pkey'
}

export enum Shop_Product_Type_Enum {
  TShirt = 'T_SHIRT'
}

/** Boolean expression to compare columns of type "shop_product_type_enum". All fields are combined with logical 'AND'. */
export type Shop_Product_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Shop_Product_Type_Enum>;
  _in?: InputMaybe<Array<Shop_Product_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Shop_Product_Type_Enum>;
  _nin?: InputMaybe<Array<Shop_Product_Type_Enum>>;
};

/** input type for inserting data into table "shop.product_type" */
export type Shop_Product_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shop_Product_Type_Max_Fields = {
  __typename?: 'shop_product_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Shop_Product_Type_Min_Fields = {
  __typename?: 'shop_product_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shop.product_type" */
export type Shop_Product_Type_Mutation_Response = {
  __typename?: 'shop_product_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Product_Type>;
};

/** on_conflict condition type for table "shop.product_type" */
export type Shop_Product_Type_On_Conflict = {
  constraint: Shop_Product_Type_Constraint;
  update_columns?: Array<Shop_Product_Type_Update_Column>;
  where?: InputMaybe<Shop_Product_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.product_type". */
export type Shop_Product_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.product_type */
export type Shop_Product_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "shop.product_type" */
export enum Shop_Product_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "shop.product_type" */
export type Shop_Product_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "shop_product_type" */
export type Shop_Product_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Product_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Product_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "shop.product_type" */
export enum Shop_Product_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Shop_Product_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Product_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Product_Type_Bool_Exp;
};

/** This table is used to store the products for the shop */
export type Shop_Products = {
  __typename?: 'shop_products';
  created_at: Scalars['timestamptz'];
  eligible_entities?: Maybe<Scalars['_text']>;
  /** An object relationship */
  hsn?: Maybe<Shop_Hsn>;
  hsn_id: Scalars['Int'];
  id: Scalars['Int'];
  images: Scalars['_text'];
  is_available: Scalars['Boolean'];
  is_schwag: Scalars['Boolean'];
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity: Scalars['Int'];
  name: Scalars['String'];
  /** This value is in paisa */
  price: Scalars['Int'];
  /** An array relationship */
  skus: Array<Shop_Inventory_Skus>;
  /** An aggregate relationship */
  skus_aggregate: Shop_Inventory_Skus_Aggregate;
  type: Shop_Product_Type_Enum;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};


/** This table is used to store the products for the shop */
export type Shop_ProductsSkusArgs = {
  distinct_on?: InputMaybe<Array<Shop_Inventory_Skus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Inventory_Skus_Order_By>>;
  where?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
};


/** This table is used to store the products for the shop */
export type Shop_ProductsSkus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Inventory_Skus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Inventory_Skus_Order_By>>;
  where?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
};

/** aggregated selection of "shop.products" */
export type Shop_Products_Aggregate = {
  __typename?: 'shop_products_aggregate';
  aggregate?: Maybe<Shop_Products_Aggregate_Fields>;
  nodes: Array<Shop_Products>;
};

/** aggregate fields of "shop.products" */
export type Shop_Products_Aggregate_Fields = {
  __typename?: 'shop_products_aggregate_fields';
  avg?: Maybe<Shop_Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Products_Max_Fields>;
  min?: Maybe<Shop_Products_Min_Fields>;
  stddev?: Maybe<Shop_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Products_Sum_Fields>;
  var_pop?: Maybe<Shop_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Products_Var_Samp_Fields>;
  variance?: Maybe<Shop_Products_Variance_Fields>;
};


/** aggregate fields of "shop.products" */
export type Shop_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Shop_Products_Avg_Fields = {
  __typename?: 'shop_products_avg_fields';
  hsn_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Float']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shop.products". All fields are combined with a logical 'AND'. */
export type Shop_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Products_Bool_Exp>>;
  _not?: InputMaybe<Shop_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Products_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eligible_entities?: InputMaybe<_Text_Comparison_Exp>;
  hsn?: InputMaybe<Shop_Hsn_Bool_Exp>;
  hsn_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<_Text_Comparison_Exp>;
  is_available?: InputMaybe<Boolean_Comparison_Exp>;
  is_schwag?: InputMaybe<Boolean_Comparison_Exp>;
  maximum_allowed_quantity?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  skus?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
  skus_aggregate?: InputMaybe<Shop_Inventory_Skus_Aggregate_Bool_Exp>;
  type?: InputMaybe<Shop_Product_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.products" */
export enum Shop_Products_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProductsNameKey = 'products_name_key',
  /** unique or primary key constraint on columns "id" */
  ProductsPkey = 'products_pkey',
  /** unique or primary key constraint on columns "uuid" */
  ProductsUuidKey = 'products_uuid_key'
}

/** input type for incrementing numeric columns in table "shop.products" */
export type Shop_Products_Inc_Input = {
  hsn_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: InputMaybe<Scalars['Int']>;
  /** This value is in paisa */
  price?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.products" */
export type Shop_Products_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eligible_entities?: InputMaybe<Scalars['_text']>;
  hsn?: InputMaybe<Shop_Hsn_Obj_Rel_Insert_Input>;
  hsn_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Scalars['_text']>;
  is_available?: InputMaybe<Scalars['Boolean']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /** This value is in paisa */
  price?: InputMaybe<Scalars['Int']>;
  skus?: InputMaybe<Shop_Inventory_Skus_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Shop_Product_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shop_Products_Max_Fields = {
  __typename?: 'shop_products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hsn_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Shop_Products_Min_Fields = {
  __typename?: 'shop_products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hsn_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shop.products" */
export type Shop_Products_Mutation_Response = {
  __typename?: 'shop_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Products>;
};

/** input type for inserting object relation for remote table "shop.products" */
export type Shop_Products_Obj_Rel_Insert_Input = {
  data: Shop_Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Products_On_Conflict>;
};

/** on_conflict condition type for table "shop.products" */
export type Shop_Products_On_Conflict = {
  constraint: Shop_Products_Constraint;
  update_columns?: Array<Shop_Products_Update_Column>;
  where?: InputMaybe<Shop_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.products". */
export type Shop_Products_Order_By = {
  created_at?: InputMaybe<Order_By>;
  eligible_entities?: InputMaybe<Order_By>;
  hsn?: InputMaybe<Shop_Hsn_Order_By>;
  hsn_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  is_available?: InputMaybe<Order_By>;
  is_schwag?: InputMaybe<Order_By>;
  maximum_allowed_quantity?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  skus_aggregate?: InputMaybe<Shop_Inventory_Skus_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.products */
export type Shop_Products_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "shop.products" */
export enum Shop_Products_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EligibleEntities = 'eligible_entities',
  /** column name */
  HsnId = 'hsn_id',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  IsAvailable = 'is_available',
  /** column name */
  IsSchwag = 'is_schwag',
  /** column name */
  MaximumAllowedQuantity = 'maximum_allowed_quantity',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "shop.products" */
export type Shop_Products_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eligible_entities?: InputMaybe<Scalars['_text']>;
  hsn_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Scalars['_text']>;
  is_available?: InputMaybe<Scalars['Boolean']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /** This value is in paisa */
  price?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Shop_Product_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Shop_Products_Stddev_Fields = {
  __typename?: 'shop_products_stddev_fields';
  hsn_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Float']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Shop_Products_Stddev_Pop_Fields = {
  __typename?: 'shop_products_stddev_pop_fields';
  hsn_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Float']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Shop_Products_Stddev_Samp_Fields = {
  __typename?: 'shop_products_stddev_samp_fields';
  hsn_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Float']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "shop_products" */
export type Shop_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Products_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eligible_entities?: InputMaybe<Scalars['_text']>;
  hsn_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Scalars['_text']>;
  is_available?: InputMaybe<Scalars['Boolean']>;
  is_schwag?: InputMaybe<Scalars['Boolean']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /** This value is in paisa */
  price?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Shop_Product_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Shop_Products_Sum_Fields = {
  __typename?: 'shop_products_sum_fields';
  hsn_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Int']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Int']>;
};

/** update columns of table "shop.products" */
export enum Shop_Products_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EligibleEntities = 'eligible_entities',
  /** column name */
  HsnId = 'hsn_id',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  IsAvailable = 'is_available',
  /** column name */
  IsSchwag = 'is_schwag',
  /** column name */
  MaximumAllowedQuantity = 'maximum_allowed_quantity',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Shop_Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Products_Var_Pop_Fields = {
  __typename?: 'shop_products_var_pop_fields';
  hsn_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Float']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Shop_Products_Var_Samp_Fields = {
  __typename?: 'shop_products_var_samp_fields';
  hsn_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Float']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Shop_Products_Variance_Fields = {
  __typename?: 'shop_products_variance_fields';
  hsn_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** The integer field used to indicate the maximum quantity that can be bought at once */
  maximum_allowed_quantity?: Maybe<Scalars['Float']>;
  /** This value is in paisa */
  price?: Maybe<Scalars['Float']>;
};

/** This table is used to store the shipping addresses for users */
export type Shop_Shipping_Addresses = {
  __typename?: 'shop_shipping_addresses';
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  full_name: Scalars['String'];
  id: Scalars['Int'];
  phone_number: Scalars['String'];
  pincode: Scalars['String'];
  state: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};

/** aggregated selection of "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Aggregate = {
  __typename?: 'shop_shipping_addresses_aggregate';
  aggregate?: Maybe<Shop_Shipping_Addresses_Aggregate_Fields>;
  nodes: Array<Shop_Shipping_Addresses>;
};

export type Shop_Shipping_Addresses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Shop_Shipping_Addresses_Aggregate_Bool_Exp_Count>;
};

export type Shop_Shipping_Addresses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Shop_Shipping_Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Aggregate_Fields = {
  __typename?: 'shop_shipping_addresses_aggregate_fields';
  avg?: Maybe<Shop_Shipping_Addresses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_Shipping_Addresses_Max_Fields>;
  min?: Maybe<Shop_Shipping_Addresses_Min_Fields>;
  stddev?: Maybe<Shop_Shipping_Addresses_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_Shipping_Addresses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_Shipping_Addresses_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_Shipping_Addresses_Sum_Fields>;
  var_pop?: Maybe<Shop_Shipping_Addresses_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_Shipping_Addresses_Var_Samp_Fields>;
  variance?: Maybe<Shop_Shipping_Addresses_Variance_Fields>;
};


/** aggregate fields of "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_Shipping_Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Aggregate_Order_By = {
  avg?: InputMaybe<Shop_Shipping_Addresses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shop_Shipping_Addresses_Max_Order_By>;
  min?: InputMaybe<Shop_Shipping_Addresses_Min_Order_By>;
  stddev?: InputMaybe<Shop_Shipping_Addresses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Shop_Shipping_Addresses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Shop_Shipping_Addresses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Shop_Shipping_Addresses_Sum_Order_By>;
  var_pop?: InputMaybe<Shop_Shipping_Addresses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Shop_Shipping_Addresses_Var_Samp_Order_By>;
  variance?: InputMaybe<Shop_Shipping_Addresses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Arr_Rel_Insert_Input = {
  data: Array<Shop_Shipping_Addresses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Shipping_Addresses_On_Conflict>;
};

/** aggregate avg on columns */
export type Shop_Shipping_Addresses_Avg_Fields = {
  __typename?: 'shop_shipping_addresses_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shop.shipping_addresses". All fields are combined with a logical 'AND'. */
export type Shop_Shipping_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_Shipping_Addresses_Bool_Exp>>;
  _not?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_Shipping_Addresses_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  pincode?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.shipping_addresses" */
export enum Shop_Shipping_Addresses_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShippingAddressesPkey = 'shipping_addresses_pkey',
  /** unique or primary key constraint on columns "uuid" */
  ShippingAddressesUuidKey = 'shipping_addresses_uuid_key'
}

/** input type for incrementing numeric columns in table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  phone_number?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shop_Shipping_Addresses_Max_Fields = {
  __typename?: 'shop_shipping_addresses_max_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shop_Shipping_Addresses_Min_Fields = {
  __typename?: 'shop_shipping_addresses_min_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Mutation_Response = {
  __typename?: 'shop_shipping_addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_Shipping_Addresses>;
};

/** input type for inserting object relation for remote table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Obj_Rel_Insert_Input = {
  data: Shop_Shipping_Addresses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_Shipping_Addresses_On_Conflict>;
};

/** on_conflict condition type for table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_On_Conflict = {
  constraint: Shop_Shipping_Addresses_Constraint;
  update_columns?: Array<Shop_Shipping_Addresses_Update_Column>;
  where?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.shipping_addresses". */
export type Shop_Shipping_Addresses_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.shipping_addresses */
export type Shop_Shipping_Addresses_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "shop.shipping_addresses" */
export enum Shop_Shipping_Addresses_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  phone_number?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Shop_Shipping_Addresses_Stddev_Fields = {
  __typename?: 'shop_shipping_addresses_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shop_Shipping_Addresses_Stddev_Pop_Fields = {
  __typename?: 'shop_shipping_addresses_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shop_Shipping_Addresses_Stddev_Samp_Fields = {
  __typename?: 'shop_shipping_addresses_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shop_shipping_addresses" */
export type Shop_Shipping_Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_Shipping_Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_Shipping_Addresses_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  phone_number?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Shop_Shipping_Addresses_Sum_Fields = {
  __typename?: 'shop_shipping_addresses_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "shop.shipping_addresses" */
export enum Shop_Shipping_Addresses_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Shop_Shipping_Addresses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_Shipping_Addresses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_Shipping_Addresses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_Shipping_Addresses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_Shipping_Addresses_Var_Pop_Fields = {
  __typename?: 'shop_shipping_addresses_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shop_Shipping_Addresses_Var_Samp_Fields = {
  __typename?: 'shop_shipping_addresses_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shop_Shipping_Addresses_Variance_Fields = {
  __typename?: 'shop_shipping_addresses_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shop.shipping_addresses" */
export type Shop_Shipping_Addresses_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "shop.states" */
export type Shop_States = {
  __typename?: 'shop_states';
  country_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  iso_code: Scalars['String'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "shop.states" */
export type Shop_States_Aggregate = {
  __typename?: 'shop_states_aggregate';
  aggregate?: Maybe<Shop_States_Aggregate_Fields>;
  nodes: Array<Shop_States>;
};

export type Shop_States_Aggregate_Bool_Exp = {
  count?: InputMaybe<Shop_States_Aggregate_Bool_Exp_Count>;
};

export type Shop_States_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Shop_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Shop_States_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shop.states" */
export type Shop_States_Aggregate_Fields = {
  __typename?: 'shop_states_aggregate_fields';
  avg?: Maybe<Shop_States_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shop_States_Max_Fields>;
  min?: Maybe<Shop_States_Min_Fields>;
  stddev?: Maybe<Shop_States_Stddev_Fields>;
  stddev_pop?: Maybe<Shop_States_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shop_States_Stddev_Samp_Fields>;
  sum?: Maybe<Shop_States_Sum_Fields>;
  var_pop?: Maybe<Shop_States_Var_Pop_Fields>;
  var_samp?: Maybe<Shop_States_Var_Samp_Fields>;
  variance?: Maybe<Shop_States_Variance_Fields>;
};


/** aggregate fields of "shop.states" */
export type Shop_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shop_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shop.states" */
export type Shop_States_Aggregate_Order_By = {
  avg?: InputMaybe<Shop_States_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shop_States_Max_Order_By>;
  min?: InputMaybe<Shop_States_Min_Order_By>;
  stddev?: InputMaybe<Shop_States_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Shop_States_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Shop_States_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Shop_States_Sum_Order_By>;
  var_pop?: InputMaybe<Shop_States_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Shop_States_Var_Samp_Order_By>;
  variance?: InputMaybe<Shop_States_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shop.states" */
export type Shop_States_Arr_Rel_Insert_Input = {
  data: Array<Shop_States_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_States_On_Conflict>;
};

/** aggregate avg on columns */
export type Shop_States_Avg_Fields = {
  __typename?: 'shop_states_avg_fields';
  country_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shop.states" */
export type Shop_States_Avg_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shop.states". All fields are combined with a logical 'AND'. */
export type Shop_States_Bool_Exp = {
  _and?: InputMaybe<Array<Shop_States_Bool_Exp>>;
  _not?: InputMaybe<Shop_States_Bool_Exp>;
  _or?: InputMaybe<Array<Shop_States_Bool_Exp>>;
  country_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  iso_code?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shop.states" */
export enum Shop_States_Constraint {
  /** unique or primary key constraint on columns "iso_code", "country_id" */
  StatesIsoCodeCountryIdKey = 'states_iso_code_country_id_key',
  /** unique or primary key constraint on columns "name" */
  StatesNameKey = 'states_name_key',
  /** unique or primary key constraint on columns "id" */
  StatesPkey = 'states_pkey'
}

/** input type for incrementing numeric columns in table "shop.states" */
export type Shop_States_Inc_Input = {
  country_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shop.states" */
export type Shop_States_Insert_Input = {
  country_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Shop_States_Max_Fields = {
  __typename?: 'shop_states_max_fields';
  country_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  iso_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shop.states" */
export type Shop_States_Max_Order_By = {
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  iso_code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shop_States_Min_Fields = {
  __typename?: 'shop_states_min_fields';
  country_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  iso_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shop.states" */
export type Shop_States_Min_Order_By = {
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  iso_code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shop.states" */
export type Shop_States_Mutation_Response = {
  __typename?: 'shop_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shop_States>;
};

/** input type for inserting object relation for remote table "shop.states" */
export type Shop_States_Obj_Rel_Insert_Input = {
  data: Shop_States_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shop_States_On_Conflict>;
};

/** on_conflict condition type for table "shop.states" */
export type Shop_States_On_Conflict = {
  constraint: Shop_States_Constraint;
  update_columns?: Array<Shop_States_Update_Column>;
  where?: InputMaybe<Shop_States_Bool_Exp>;
};

/** Ordering options when selecting data from "shop.states". */
export type Shop_States_Order_By = {
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  iso_code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shop.states */
export type Shop_States_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "shop.states" */
export enum Shop_States_Select_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "shop.states" */
export type Shop_States_Set_Input = {
  country_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Shop_States_Stddev_Fields = {
  __typename?: 'shop_states_stddev_fields';
  country_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shop.states" */
export type Shop_States_Stddev_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shop_States_Stddev_Pop_Fields = {
  __typename?: 'shop_states_stddev_pop_fields';
  country_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shop.states" */
export type Shop_States_Stddev_Pop_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shop_States_Stddev_Samp_Fields = {
  __typename?: 'shop_states_stddev_samp_fields';
  country_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shop.states" */
export type Shop_States_Stddev_Samp_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shop_states" */
export type Shop_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shop_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shop_States_Stream_Cursor_Value_Input = {
  country_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  iso_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Shop_States_Sum_Fields = {
  __typename?: 'shop_states_sum_fields';
  country_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shop.states" */
export type Shop_States_Sum_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "shop.states" */
export enum Shop_States_Update_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Shop_States_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shop_States_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shop_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shop_States_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shop_States_Var_Pop_Fields = {
  __typename?: 'shop_states_var_pop_fields';
  country_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shop.states" */
export type Shop_States_Var_Pop_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shop_States_Var_Samp_Fields = {
  __typename?: 'shop_states_var_samp_fields';
  country_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shop.states" */
export type Shop_States_Var_Samp_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shop_States_Variance_Fields = {
  __typename?: 'shop_states_variance_fields';
  country_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shop.states" */
export type Shop_States_Variance_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "skills" */
export type Skills = {
  __typename?: 'skills';
  /** computed field containing a prefixed logo field */
  _logo?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['citext'];
  status?: Maybe<Scalars['skills_status_enum']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "skills" */
export type Skills_Aggregate = {
  __typename?: 'skills_aggregate';
  aggregate?: Maybe<Skills_Aggregate_Fields>;
  nodes: Array<Skills>;
};

/** aggregate fields of "skills" */
export type Skills_Aggregate_Fields = {
  __typename?: 'skills_aggregate_fields';
  avg?: Maybe<Skills_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skills_Max_Fields>;
  min?: Maybe<Skills_Min_Fields>;
  stddev?: Maybe<Skills_Stddev_Fields>;
  stddev_pop?: Maybe<Skills_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skills_Stddev_Samp_Fields>;
  sum?: Maybe<Skills_Sum_Fields>;
  var_pop?: Maybe<Skills_Var_Pop_Fields>;
  var_samp?: Maybe<Skills_Var_Samp_Fields>;
  variance?: Maybe<Skills_Variance_Fields>;
};


/** aggregate fields of "skills" */
export type Skills_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Skills_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skills_Avg_Fields = {
  __typename?: 'skills_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skills". All fields are combined with a logical 'AND'. */
export type Skills_Bool_Exp = {
  _and?: InputMaybe<Array<Skills_Bool_Exp>>;
  _logo?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Skills_Bool_Exp>;
  _or?: InputMaybe<Array<Skills_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<Citext_Comparison_Exp>;
  status?: InputMaybe<Skills_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "skills" */
export enum Skills_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkSkills = 'pk_skills',
  /** unique or primary key constraint on columns "name" */
  UniqueNameSkills = 'unique_name_skills',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidSkills = 'unique_uuid_skills'
}

/** input type for incrementing numeric columns in table "skills" */
export type Skills_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "skills" */
export type Skills_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['citext']>;
  status?: InputMaybe<Scalars['skills_status_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skills_Max_Fields = {
  __typename?: 'skills_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['citext']>;
  status?: Maybe<Scalars['skills_status_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skills_Min_Fields = {
  __typename?: 'skills_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['citext']>;
  status?: Maybe<Scalars['skills_status_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skills" */
export type Skills_Mutation_Response = {
  __typename?: 'skills_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skills>;
};

/** input type for inserting object relation for remote table "skills" */
export type Skills_Obj_Rel_Insert_Input = {
  data: Skills_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Skills_On_Conflict>;
};

/** on_conflict condition type for table "skills" */
export type Skills_On_Conflict = {
  constraint: Skills_Constraint;
  update_columns?: Array<Skills_Update_Column>;
  where?: InputMaybe<Skills_Bool_Exp>;
};

/** Ordering options when selecting data from "skills". */
export type Skills_Order_By = {
  _logo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: skills */
export type Skills_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "skills" */
export enum Skills_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "skills" */
export type Skills_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['citext']>;
  status?: InputMaybe<Scalars['skills_status_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "skills_status_enum". All fields are combined with logical 'AND'. */
export type Skills_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['skills_status_enum']>;
  _gt?: InputMaybe<Scalars['skills_status_enum']>;
  _gte?: InputMaybe<Scalars['skills_status_enum']>;
  _in?: InputMaybe<Array<Scalars['skills_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['skills_status_enum']>;
  _lte?: InputMaybe<Scalars['skills_status_enum']>;
  _neq?: InputMaybe<Scalars['skills_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['skills_status_enum']>>;
};

/** aggregate stddev on columns */
export type Skills_Stddev_Fields = {
  __typename?: 'skills_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skills_Stddev_Pop_Fields = {
  __typename?: 'skills_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skills_Stddev_Samp_Fields = {
  __typename?: 'skills_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skills" */
export type Skills_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skills_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skills_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['citext']>;
  status?: InputMaybe<Scalars['skills_status_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skills_Sum_Fields = {
  __typename?: 'skills_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "skills" */
export enum Skills_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Skills_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Skills_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Skills_Set_Input>;
  /** filter the rows which have to be updated */
  where: Skills_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skills_Var_Pop_Fields = {
  __typename?: 'skills_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skills_Var_Samp_Fields = {
  __typename?: 'skills_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skills_Variance_Fields = {
  __typename?: 'skills_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** This table is used as an enum table to store the status for speaker slots */
export type Speaker_Slot_Status = {
  __typename?: 'speaker_slot_status';
  value: Scalars['String'];
};

/** aggregated selection of "speaker_slot_status" */
export type Speaker_Slot_Status_Aggregate = {
  __typename?: 'speaker_slot_status_aggregate';
  aggregate?: Maybe<Speaker_Slot_Status_Aggregate_Fields>;
  nodes: Array<Speaker_Slot_Status>;
};

/** aggregate fields of "speaker_slot_status" */
export type Speaker_Slot_Status_Aggregate_Fields = {
  __typename?: 'speaker_slot_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Speaker_Slot_Status_Max_Fields>;
  min?: Maybe<Speaker_Slot_Status_Min_Fields>;
};


/** aggregate fields of "speaker_slot_status" */
export type Speaker_Slot_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Speaker_Slot_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "speaker_slot_status". All fields are combined with a logical 'AND'. */
export type Speaker_Slot_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Speaker_Slot_Status_Bool_Exp>>;
  _not?: InputMaybe<Speaker_Slot_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Speaker_Slot_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "speaker_slot_status" */
export enum Speaker_Slot_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  SpeakerSlotStatusPkey = 'speaker_slot_status_pkey'
}

export enum Speaker_Slot_Status_Enum {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Boolean expression to compare columns of type "speaker_slot_status_enum". All fields are combined with logical 'AND'. */
export type Speaker_Slot_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Speaker_Slot_Status_Enum>;
  _in?: InputMaybe<Array<Speaker_Slot_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Speaker_Slot_Status_Enum>;
  _nin?: InputMaybe<Array<Speaker_Slot_Status_Enum>>;
};

/** input type for inserting data into table "speaker_slot_status" */
export type Speaker_Slot_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Speaker_Slot_Status_Max_Fields = {
  __typename?: 'speaker_slot_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Speaker_Slot_Status_Min_Fields = {
  __typename?: 'speaker_slot_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "speaker_slot_status" */
export type Speaker_Slot_Status_Mutation_Response = {
  __typename?: 'speaker_slot_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Speaker_Slot_Status>;
};

/** on_conflict condition type for table "speaker_slot_status" */
export type Speaker_Slot_Status_On_Conflict = {
  constraint: Speaker_Slot_Status_Constraint;
  update_columns?: Array<Speaker_Slot_Status_Update_Column>;
  where?: InputMaybe<Speaker_Slot_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "speaker_slot_status". */
export type Speaker_Slot_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: speaker_slot_status */
export type Speaker_Slot_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "speaker_slot_status" */
export enum Speaker_Slot_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "speaker_slot_status" */
export type Speaker_Slot_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "speaker_slot_status" */
export type Speaker_Slot_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Speaker_Slot_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Speaker_Slot_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "speaker_slot_status" */
export enum Speaker_Slot_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Speaker_Slot_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Speaker_Slot_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Speaker_Slot_Status_Bool_Exp;
};

/** columns and relationships of "sponsor_judgments" */
export type Sponsor_Judgments = {
  __typename?: 'sponsor_judgments';
  created_at: Scalars['timestamptz'];
  favorite: Scalars['Boolean'];
  flagged: Scalars['Boolean'];
  id: Scalars['Int'];
  /** An object relationship */
  judge?: Maybe<Judges>;
  judge_id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  prize?: Maybe<Prizes>;
  prize_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  prize_track?: Maybe<Prize_Tracks>;
  /** An object relationship */
  project?: Maybe<Projects>;
  project_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  sponsor?: Maybe<Sponsors>;
  sponsor_id?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['String']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
  viewed: Scalars['Boolean'];
};

/** aggregated selection of "sponsor_judgments" */
export type Sponsor_Judgments_Aggregate = {
  __typename?: 'sponsor_judgments_aggregate';
  aggregate?: Maybe<Sponsor_Judgments_Aggregate_Fields>;
  nodes: Array<Sponsor_Judgments>;
};

export type Sponsor_Judgments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Sponsor_Judgments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Sponsor_Judgments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Sponsor_Judgments_Aggregate_Bool_Exp_Count>;
};

export type Sponsor_Judgments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Sponsor_Judgments_Select_Column_Sponsor_Judgments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sponsor_Judgments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Sponsor_Judgments_Select_Column_Sponsor_Judgments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sponsor_Judgments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sponsor_judgments" */
export type Sponsor_Judgments_Aggregate_Fields = {
  __typename?: 'sponsor_judgments_aggregate_fields';
  avg?: Maybe<Sponsor_Judgments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sponsor_Judgments_Max_Fields>;
  min?: Maybe<Sponsor_Judgments_Min_Fields>;
  stddev?: Maybe<Sponsor_Judgments_Stddev_Fields>;
  stddev_pop?: Maybe<Sponsor_Judgments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sponsor_Judgments_Stddev_Samp_Fields>;
  sum?: Maybe<Sponsor_Judgments_Sum_Fields>;
  var_pop?: Maybe<Sponsor_Judgments_Var_Pop_Fields>;
  var_samp?: Maybe<Sponsor_Judgments_Var_Samp_Fields>;
  variance?: Maybe<Sponsor_Judgments_Variance_Fields>;
};


/** aggregate fields of "sponsor_judgments" */
export type Sponsor_Judgments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sponsor_judgments" */
export type Sponsor_Judgments_Aggregate_Order_By = {
  avg?: InputMaybe<Sponsor_Judgments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sponsor_Judgments_Max_Order_By>;
  min?: InputMaybe<Sponsor_Judgments_Min_Order_By>;
  stddev?: InputMaybe<Sponsor_Judgments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sponsor_Judgments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sponsor_Judgments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sponsor_Judgments_Sum_Order_By>;
  var_pop?: InputMaybe<Sponsor_Judgments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sponsor_Judgments_Var_Samp_Order_By>;
  variance?: InputMaybe<Sponsor_Judgments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sponsor_judgments" */
export type Sponsor_Judgments_Arr_Rel_Insert_Input = {
  data: Array<Sponsor_Judgments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sponsor_Judgments_On_Conflict>;
};

/** aggregate avg on columns */
export type Sponsor_Judgments_Avg_Fields = {
  __typename?: 'sponsor_judgments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sponsor_judgments". All fields are combined with a logical 'AND'. */
export type Sponsor_Judgments_Bool_Exp = {
  _and?: InputMaybe<Array<Sponsor_Judgments_Bool_Exp>>;
  _not?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
  _or?: InputMaybe<Array<Sponsor_Judgments_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  favorite?: InputMaybe<Boolean_Comparison_Exp>;
  flagged?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  judge?: InputMaybe<Judges_Bool_Exp>;
  judge_id?: InputMaybe<Int_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  prize?: InputMaybe<Prizes_Bool_Exp>;
  prize_id?: InputMaybe<Int_Comparison_Exp>;
  prize_track?: InputMaybe<Prize_Tracks_Bool_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  sponsor?: InputMaybe<Sponsors_Bool_Exp>;
  sponsor_id?: InputMaybe<Int_Comparison_Exp>;
  tags?: InputMaybe<String_Comparison_Exp>;
  track_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  viewed?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "sponsor_judgments" */
export enum Sponsor_Judgments_Constraint {
  /** unique or primary key constraint on columns "id" */
  SponsorJudgmentsPkey = 'sponsor_judgments_pkey',
  /** unique or primary key constraint on columns "project_id", "track_id", "prize_id" */
  SponsorJudgmentsUniqueProjectIdTrackIdPrizeIdKey = 'sponsor_judgments_unique_project_id_track_id_prize_id_key',
  /** unique or primary key constraint on columns "uuid" */
  SponsorJudgmentsUuidKey = 'sponsor_judgments_uuid_key'
}

/** input type for incrementing numeric columns in table "sponsor_judgments" */
export type Sponsor_Judgments_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  track_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sponsor_judgments" */
export type Sponsor_Judgments_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  judge?: InputMaybe<Judges_Obj_Rel_Insert_Input>;
  judge_id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  prize?: InputMaybe<Prizes_Obj_Rel_Insert_Input>;
  prize_id?: InputMaybe<Scalars['Int']>;
  prize_track?: InputMaybe<Prize_Tracks_Obj_Rel_Insert_Input>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  sponsor?: InputMaybe<Sponsors_Obj_Rel_Insert_Input>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['String']>;
  track_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Sponsor_Judgments_Max_Fields = {
  __typename?: 'sponsor_judgments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  judge_id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  prize_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['String']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sponsor_Judgments_Min_Fields = {
  __typename?: 'sponsor_judgments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  judge_id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  prize_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['String']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sponsor_judgments" */
export type Sponsor_Judgments_Mutation_Response = {
  __typename?: 'sponsor_judgments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sponsor_Judgments>;
};

/** on_conflict condition type for table "sponsor_judgments" */
export type Sponsor_Judgments_On_Conflict = {
  constraint: Sponsor_Judgments_Constraint;
  update_columns?: Array<Sponsor_Judgments_Update_Column>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};

/** Ordering options when selecting data from "sponsor_judgments". */
export type Sponsor_Judgments_Order_By = {
  created_at?: InputMaybe<Order_By>;
  favorite?: InputMaybe<Order_By>;
  flagged?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judge?: InputMaybe<Judges_Order_By>;
  judge_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  prize?: InputMaybe<Prizes_Order_By>;
  prize_id?: InputMaybe<Order_By>;
  prize_track?: InputMaybe<Prize_Tracks_Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor?: InputMaybe<Sponsors_Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  viewed?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sponsor_judgments */
export type Sponsor_Judgments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sponsor_judgments" */
export enum Sponsor_Judgments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Favorite = 'favorite',
  /** column name */
  Flagged = 'flagged',
  /** column name */
  Id = 'id',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  Tags = 'tags',
  /** column name */
  TrackId = 'track_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Viewed = 'viewed'
}

/** select "sponsor_judgments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sponsor_judgments" */
export enum Sponsor_Judgments_Select_Column_Sponsor_Judgments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Favorite = 'favorite',
  /** column name */
  Flagged = 'flagged',
  /** column name */
  Viewed = 'viewed'
}

/** select "sponsor_judgments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sponsor_judgments" */
export enum Sponsor_Judgments_Select_Column_Sponsor_Judgments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Favorite = 'favorite',
  /** column name */
  Flagged = 'flagged',
  /** column name */
  Viewed = 'viewed'
}

/** input type for updating data in table "sponsor_judgments" */
export type Sponsor_Judgments_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['String']>;
  track_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Sponsor_Judgments_Stddev_Fields = {
  __typename?: 'sponsor_judgments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sponsor_Judgments_Stddev_Pop_Fields = {
  __typename?: 'sponsor_judgments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sponsor_Judgments_Stddev_Samp_Fields = {
  __typename?: 'sponsor_judgments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sponsor_judgments" */
export type Sponsor_Judgments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sponsor_Judgments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sponsor_Judgments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  judge_id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  sponsor_id?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['String']>;
  track_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Sponsor_Judgments_Sum_Fields = {
  __typename?: 'sponsor_judgments_sum_fields';
  id?: Maybe<Scalars['Int']>;
  judge_id?: Maybe<Scalars['Int']>;
  prize_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  sponsor_id?: Maybe<Scalars['Int']>;
  track_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** update columns of table "sponsor_judgments" */
export enum Sponsor_Judgments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Favorite = 'favorite',
  /** column name */
  Flagged = 'flagged',
  /** column name */
  Id = 'id',
  /** column name */
  JudgeId = 'judge_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SponsorId = 'sponsor_id',
  /** column name */
  Tags = 'tags',
  /** column name */
  TrackId = 'track_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Viewed = 'viewed'
}

export type Sponsor_Judgments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sponsor_Judgments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sponsor_Judgments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sponsor_Judgments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sponsor_Judgments_Var_Pop_Fields = {
  __typename?: 'sponsor_judgments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sponsor_Judgments_Var_Samp_Fields = {
  __typename?: 'sponsor_judgments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sponsor_Judgments_Variance_Fields = {
  __typename?: 'sponsor_judgments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  judge_id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  sponsor_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sponsor_judgments" */
export type Sponsor_Judgments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  judge_id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  sponsor_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "sponsor_tiers" */
export type Sponsor_Tiers = {
  __typename?: 'sponsor_tiers';
  about?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  hackathon: Hackathons;
  hackathon_id: Scalars['Int'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  name_empty: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  /** An array relationship */
  sponsors: Array<Sponsors>;
  /** An aggregate relationship */
  sponsors_aggregate: Sponsors_Aggregate;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "sponsor_tiers" */
export type Sponsor_TiersSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


/** columns and relationships of "sponsor_tiers" */
export type Sponsor_TiersSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};

/** aggregated selection of "sponsor_tiers" */
export type Sponsor_Tiers_Aggregate = {
  __typename?: 'sponsor_tiers_aggregate';
  aggregate?: Maybe<Sponsor_Tiers_Aggregate_Fields>;
  nodes: Array<Sponsor_Tiers>;
};

export type Sponsor_Tiers_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Sponsor_Tiers_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Sponsor_Tiers_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Sponsor_Tiers_Aggregate_Bool_Exp_Count>;
};

export type Sponsor_Tiers_Aggregate_Bool_Exp_Bool_And = {
  arguments: Sponsor_Tiers_Select_Column_Sponsor_Tiers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sponsor_Tiers_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Sponsor_Tiers_Select_Column_Sponsor_Tiers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sponsor_Tiers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sponsor_Tiers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sponsor_tiers" */
export type Sponsor_Tiers_Aggregate_Fields = {
  __typename?: 'sponsor_tiers_aggregate_fields';
  avg?: Maybe<Sponsor_Tiers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sponsor_Tiers_Max_Fields>;
  min?: Maybe<Sponsor_Tiers_Min_Fields>;
  stddev?: Maybe<Sponsor_Tiers_Stddev_Fields>;
  stddev_pop?: Maybe<Sponsor_Tiers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sponsor_Tiers_Stddev_Samp_Fields>;
  sum?: Maybe<Sponsor_Tiers_Sum_Fields>;
  var_pop?: Maybe<Sponsor_Tiers_Var_Pop_Fields>;
  var_samp?: Maybe<Sponsor_Tiers_Var_Samp_Fields>;
  variance?: Maybe<Sponsor_Tiers_Variance_Fields>;
};


/** aggregate fields of "sponsor_tiers" */
export type Sponsor_Tiers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sponsor_Tiers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sponsor_tiers" */
export type Sponsor_Tiers_Aggregate_Order_By = {
  avg?: InputMaybe<Sponsor_Tiers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sponsor_Tiers_Max_Order_By>;
  min?: InputMaybe<Sponsor_Tiers_Min_Order_By>;
  stddev?: InputMaybe<Sponsor_Tiers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sponsor_Tiers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sponsor_Tiers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sponsor_Tiers_Sum_Order_By>;
  var_pop?: InputMaybe<Sponsor_Tiers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sponsor_Tiers_Var_Samp_Order_By>;
  variance?: InputMaybe<Sponsor_Tiers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sponsor_tiers" */
export type Sponsor_Tiers_Arr_Rel_Insert_Input = {
  data: Array<Sponsor_Tiers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sponsor_Tiers_On_Conflict>;
};

/** aggregate avg on columns */
export type Sponsor_Tiers_Avg_Fields = {
  __typename?: 'sponsor_tiers_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sponsor_tiers". All fields are combined with a logical 'AND'. */
export type Sponsor_Tiers_Bool_Exp = {
  _and?: InputMaybe<Array<Sponsor_Tiers_Bool_Exp>>;
  _not?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
  _or?: InputMaybe<Array<Sponsor_Tiers_Bool_Exp>>;
  about?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  height?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_empty?: InputMaybe<Boolean_Comparison_Exp>;
  position?: InputMaybe<Int_Comparison_Exp>;
  sponsors?: InputMaybe<Sponsors_Bool_Exp>;
  sponsors_aggregate?: InputMaybe<Sponsors_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  width?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "sponsor_tiers" */
export enum Sponsor_Tiers_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkSponsorTiers = 'pk_sponsor_tiers',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidSponsorTiers = 'unique_uuid_sponsor_tiers'
}

/** input type for incrementing numeric columns in table "sponsor_tiers" */
export type Sponsor_Tiers_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sponsor_tiers" */
export type Sponsor_Tiers_Insert_Input = {
  about?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_empty?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
  sponsors?: InputMaybe<Sponsors_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Sponsor_Tiers_Max_Fields = {
  __typename?: 'sponsor_tiers_max_fields';
  about?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Max_Order_By = {
  about?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sponsor_Tiers_Min_Fields = {
  __typename?: 'sponsor_tiers_min_fields';
  about?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Min_Order_By = {
  about?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sponsor_tiers" */
export type Sponsor_Tiers_Mutation_Response = {
  __typename?: 'sponsor_tiers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sponsor_Tiers>;
};

/** input type for inserting object relation for remote table "sponsor_tiers" */
export type Sponsor_Tiers_Obj_Rel_Insert_Input = {
  data: Sponsor_Tiers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sponsor_Tiers_On_Conflict>;
};

/** on_conflict condition type for table "sponsor_tiers" */
export type Sponsor_Tiers_On_Conflict = {
  constraint: Sponsor_Tiers_Constraint;
  update_columns?: Array<Sponsor_Tiers_Update_Column>;
  where?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
};

/** Ordering options when selecting data from "sponsor_tiers". */
export type Sponsor_Tiers_Order_By = {
  about?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_empty?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  sponsors_aggregate?: InputMaybe<Sponsors_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sponsor_tiers */
export type Sponsor_Tiers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sponsor_tiers" */
export enum Sponsor_Tiers_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Height = 'height',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEmpty = 'name_empty',
  /** column name */
  Position = 'position',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Width = 'width'
}

/** select "sponsor_tiers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sponsor_tiers" */
export enum Sponsor_Tiers_Select_Column_Sponsor_Tiers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  NameEmpty = 'name_empty'
}

/** select "sponsor_tiers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sponsor_tiers" */
export enum Sponsor_Tiers_Select_Column_Sponsor_Tiers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  NameEmpty = 'name_empty'
}

/** input type for updating data in table "sponsor_tiers" */
export type Sponsor_Tiers_Set_Input = {
  about?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_empty?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Sponsor_Tiers_Stddev_Fields = {
  __typename?: 'sponsor_tiers_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sponsor_Tiers_Stddev_Pop_Fields = {
  __typename?: 'sponsor_tiers_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sponsor_Tiers_Stddev_Samp_Fields = {
  __typename?: 'sponsor_tiers_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sponsor_tiers" */
export type Sponsor_Tiers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sponsor_Tiers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sponsor_Tiers_Stream_Cursor_Value_Input = {
  about?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_empty?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Sponsor_Tiers_Sum_Fields = {
  __typename?: 'sponsor_tiers_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** update columns of table "sponsor_tiers" */
export enum Sponsor_Tiers_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Height = 'height',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEmpty = 'name_empty',
  /** column name */
  Position = 'position',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Width = 'width'
}

export type Sponsor_Tiers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sponsor_Tiers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sponsor_Tiers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sponsor_Tiers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sponsor_Tiers_Var_Pop_Fields = {
  __typename?: 'sponsor_tiers_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sponsor_Tiers_Var_Samp_Fields = {
  __typename?: 'sponsor_tiers_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sponsor_Tiers_Variance_Fields = {
  __typename?: 'sponsor_tiers_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sponsor_tiers" */
export type Sponsor_Tiers_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** columns and relationships of "sponsors" */
export type Sponsors = {
  __typename?: 'sponsors';
  /** A computed field, executes function "sponsors_logo" */
  _logo?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An array relationship */
  judges: Array<Judges>;
  /** An aggregate relationship */
  judges_aggregate: Judges_Aggregate;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  /** An array relationship */
  prize_tracks: Array<Prize_Tracks>;
  /** An aggregate relationship */
  prize_tracks_aggregate: Prize_Tracks_Aggregate;
  speaker_slot?: Maybe<Scalars['timestamptz']>;
  speaker_slot_status?: Maybe<Speaker_Slot_Status_Enum>;
  /** An array relationship */
  sponsor_judgments: Array<Sponsor_Judgments>;
  /** An aggregate relationship */
  sponsor_judgments_aggregate: Sponsor_Judgments_Aggregate;
  /** An object relationship */
  sponsor_tier: Sponsor_Tiers;
  sponsor_tier_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
  winners_confirmed: Scalars['Boolean'];
};


/** columns and relationships of "sponsors" */
export type SponsorsJudgesArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


/** columns and relationships of "sponsors" */
export type SponsorsJudges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


/** columns and relationships of "sponsors" */
export type SponsorsPrize_TracksArgs = {
  distinct_on?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Tracks_Order_By>>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};


/** columns and relationships of "sponsors" */
export type SponsorsPrize_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Tracks_Order_By>>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};


/** columns and relationships of "sponsors" */
export type SponsorsSponsor_JudgmentsArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


/** columns and relationships of "sponsors" */
export type SponsorsSponsor_Judgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};

/** aggregated selection of "sponsors" */
export type Sponsors_Aggregate = {
  __typename?: 'sponsors_aggregate';
  aggregate?: Maybe<Sponsors_Aggregate_Fields>;
  nodes: Array<Sponsors>;
};

export type Sponsors_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Sponsors_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Sponsors_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Sponsors_Aggregate_Bool_Exp_Count>;
};

export type Sponsors_Aggregate_Bool_Exp_Bool_And = {
  arguments: Sponsors_Select_Column_Sponsors_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsors_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sponsors_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Sponsors_Select_Column_Sponsors_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsors_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sponsors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sponsors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sponsors" */
export type Sponsors_Aggregate_Fields = {
  __typename?: 'sponsors_aggregate_fields';
  avg?: Maybe<Sponsors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sponsors_Max_Fields>;
  min?: Maybe<Sponsors_Min_Fields>;
  stddev?: Maybe<Sponsors_Stddev_Fields>;
  stddev_pop?: Maybe<Sponsors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sponsors_Stddev_Samp_Fields>;
  sum?: Maybe<Sponsors_Sum_Fields>;
  var_pop?: Maybe<Sponsors_Var_Pop_Fields>;
  var_samp?: Maybe<Sponsors_Var_Samp_Fields>;
  variance?: Maybe<Sponsors_Variance_Fields>;
};


/** aggregate fields of "sponsors" */
export type Sponsors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sponsors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sponsors" */
export type Sponsors_Aggregate_Order_By = {
  avg?: InputMaybe<Sponsors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sponsors_Max_Order_By>;
  min?: InputMaybe<Sponsors_Min_Order_By>;
  stddev?: InputMaybe<Sponsors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sponsors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sponsors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sponsors_Sum_Order_By>;
  var_pop?: InputMaybe<Sponsors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sponsors_Var_Samp_Order_By>;
  variance?: InputMaybe<Sponsors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sponsors" */
export type Sponsors_Arr_Rel_Insert_Input = {
  data: Array<Sponsors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};

/** aggregate avg on columns */
export type Sponsors_Avg_Fields = {
  __typename?: 'sponsors_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  sponsor_tier_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sponsors" */
export type Sponsors_Avg_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sponsors". All fields are combined with a logical 'AND'. */
export type Sponsors_Bool_Exp = {
  _and?: InputMaybe<Array<Sponsors_Bool_Exp>>;
  _logo?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Sponsors_Bool_Exp>;
  _or?: InputMaybe<Array<Sponsors_Bool_Exp>>;
  about?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  judges?: InputMaybe<Judges_Bool_Exp>;
  judges_aggregate?: InputMaybe<Judges_Aggregate_Bool_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  position?: InputMaybe<Int_Comparison_Exp>;
  prize_tracks?: InputMaybe<Prize_Tracks_Bool_Exp>;
  prize_tracks_aggregate?: InputMaybe<Prize_Tracks_Aggregate_Bool_Exp>;
  speaker_slot?: InputMaybe<Timestamptz_Comparison_Exp>;
  speaker_slot_status?: InputMaybe<Speaker_Slot_Status_Enum_Comparison_Exp>;
  sponsor_judgments?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
  sponsor_judgments_aggregate?: InputMaybe<Sponsor_Judgments_Aggregate_Bool_Exp>;
  sponsor_tier?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
  sponsor_tier_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  winners_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "sponsors" */
export enum Sponsors_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkSponsors = 'pk_sponsors',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidSponsors = 'unique_uuid_sponsors'
}

/** input type for incrementing numeric columns in table "sponsors" */
export type Sponsors_Inc_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  sponsor_tier_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sponsors" */
export type Sponsors_Insert_Input = {
  about?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  judges?: InputMaybe<Judges_Arr_Rel_Insert_Input>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  prize_tracks?: InputMaybe<Prize_Tracks_Arr_Rel_Insert_Input>;
  speaker_slot?: InputMaybe<Scalars['timestamptz']>;
  speaker_slot_status?: InputMaybe<Speaker_Slot_Status_Enum>;
  sponsor_judgments?: InputMaybe<Sponsor_Judgments_Arr_Rel_Insert_Input>;
  sponsor_tier?: InputMaybe<Sponsor_Tiers_Obj_Rel_Insert_Input>;
  sponsor_tier_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  winners_confirmed?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Sponsors_Max_Fields = {
  __typename?: 'sponsors_max_fields';
  about?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  speaker_slot?: Maybe<Scalars['timestamptz']>;
  sponsor_tier_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "sponsors" */
export type Sponsors_Max_Order_By = {
  about?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  speaker_slot?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sponsors_Min_Fields = {
  __typename?: 'sponsors_min_fields';
  about?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  speaker_slot?: Maybe<Scalars['timestamptz']>;
  sponsor_tier_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "sponsors" */
export type Sponsors_Min_Order_By = {
  about?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  speaker_slot?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sponsors" */
export type Sponsors_Mutation_Response = {
  __typename?: 'sponsors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sponsors>;
};

/** input type for inserting object relation for remote table "sponsors" */
export type Sponsors_Obj_Rel_Insert_Input = {
  data: Sponsors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};

/** on_conflict condition type for table "sponsors" */
export type Sponsors_On_Conflict = {
  constraint: Sponsors_Constraint;
  update_columns?: Array<Sponsors_Update_Column>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};

/** Ordering options when selecting data from "sponsors". */
export type Sponsors_Order_By = {
  _logo?: InputMaybe<Order_By>;
  about?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  judges_aggregate?: InputMaybe<Judges_Aggregate_Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  prize_tracks_aggregate?: InputMaybe<Prize_Tracks_Aggregate_Order_By>;
  speaker_slot?: InputMaybe<Order_By>;
  speaker_slot_status?: InputMaybe<Order_By>;
  sponsor_judgments_aggregate?: InputMaybe<Sponsor_Judgments_Aggregate_Order_By>;
  sponsor_tier?: InputMaybe<Sponsor_Tiers_Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  winners_confirmed?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sponsors */
export type Sponsors_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sponsors" */
export enum Sponsors_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position',
  /** column name */
  SpeakerSlot = 'speaker_slot',
  /** column name */
  SpeakerSlotStatus = 'speaker_slot_status',
  /** column name */
  SponsorTierId = 'sponsor_tier_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  WinnersConfirmed = 'winners_confirmed'
}

/** select "sponsors_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sponsors" */
export enum Sponsors_Select_Column_Sponsors_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  WinnersConfirmed = 'winners_confirmed'
}

/** select "sponsors_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sponsors" */
export enum Sponsors_Select_Column_Sponsors_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  WinnersConfirmed = 'winners_confirmed'
}

/** input type for updating data in table "sponsors" */
export type Sponsors_Set_Input = {
  about?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  speaker_slot?: InputMaybe<Scalars['timestamptz']>;
  speaker_slot_status?: InputMaybe<Speaker_Slot_Status_Enum>;
  sponsor_tier_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  winners_confirmed?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Sponsors_Stddev_Fields = {
  __typename?: 'sponsors_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  sponsor_tier_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sponsors" */
export type Sponsors_Stddev_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sponsors_Stddev_Pop_Fields = {
  __typename?: 'sponsors_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  sponsor_tier_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sponsors" */
export type Sponsors_Stddev_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sponsors_Stddev_Samp_Fields = {
  __typename?: 'sponsors_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  sponsor_tier_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sponsors" */
export type Sponsors_Stddev_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sponsors" */
export type Sponsors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sponsors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sponsors_Stream_Cursor_Value_Input = {
  about?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  speaker_slot?: InputMaybe<Scalars['timestamptz']>;
  speaker_slot_status?: InputMaybe<Speaker_Slot_Status_Enum>;
  sponsor_tier_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  winners_confirmed?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Sponsors_Sum_Fields = {
  __typename?: 'sponsors_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  sponsor_tier_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "sponsors" */
export type Sponsors_Sum_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
};

/** update columns of table "sponsors" */
export enum Sponsors_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position',
  /** column name */
  SpeakerSlot = 'speaker_slot',
  /** column name */
  SpeakerSlotStatus = 'speaker_slot_status',
  /** column name */
  SponsorTierId = 'sponsor_tier_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  WinnersConfirmed = 'winners_confirmed'
}

export type Sponsors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sponsors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sponsors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sponsors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sponsors_Var_Pop_Fields = {
  __typename?: 'sponsors_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  sponsor_tier_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sponsors" */
export type Sponsors_Var_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sponsors_Var_Samp_Fields = {
  __typename?: 'sponsors_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  sponsor_tier_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sponsors" */
export type Sponsors_Var_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sponsors_Variance_Fields = {
  __typename?: 'sponsors_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  sponsor_tier_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sponsors" */
export type Sponsors_Variance_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  sponsor_tier_id?: InputMaybe<Order_By>;
};

/** This table is used to store stickers for project contributions/cheer */
export type Stickers = {
  __typename?: 'stickers';
  /** A computed field, executes function "stickers_image" */
  _image?: Maybe<Scalars['String']>;
  amount_eth: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['Int'];
  image: Scalars['String'];
  is_available: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "stickers" */
export type Stickers_Aggregate = {
  __typename?: 'stickers_aggregate';
  aggregate?: Maybe<Stickers_Aggregate_Fields>;
  nodes: Array<Stickers>;
};

/** aggregate fields of "stickers" */
export type Stickers_Aggregate_Fields = {
  __typename?: 'stickers_aggregate_fields';
  avg?: Maybe<Stickers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stickers_Max_Fields>;
  min?: Maybe<Stickers_Min_Fields>;
  stddev?: Maybe<Stickers_Stddev_Fields>;
  stddev_pop?: Maybe<Stickers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stickers_Stddev_Samp_Fields>;
  sum?: Maybe<Stickers_Sum_Fields>;
  var_pop?: Maybe<Stickers_Var_Pop_Fields>;
  var_samp?: Maybe<Stickers_Var_Samp_Fields>;
  variance?: Maybe<Stickers_Variance_Fields>;
};


/** aggregate fields of "stickers" */
export type Stickers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stickers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Stickers_Avg_Fields = {
  __typename?: 'stickers_avg_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stickers". All fields are combined with a logical 'AND'. */
export type Stickers_Bool_Exp = {
  _and?: InputMaybe<Array<Stickers_Bool_Exp>>;
  _image?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Stickers_Bool_Exp>;
  _or?: InputMaybe<Array<Stickers_Bool_Exp>>;
  amount_eth?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  is_available?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "stickers" */
export enum Stickers_Constraint {
  /** unique or primary key constraint on columns "id" */
  StickersPkey = 'stickers_pkey',
  /** unique or primary key constraint on columns "uuid" */
  StickersUuidKey = 'stickers_uuid_key'
}

/** input type for incrementing numeric columns in table "stickers" */
export type Stickers_Inc_Input = {
  amount_eth?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stickers" */
export type Stickers_Insert_Input = {
  amount_eth?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_available?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Stickers_Max_Fields = {
  __typename?: 'stickers_max_fields';
  amount_eth?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Stickers_Min_Fields = {
  __typename?: 'stickers_min_fields';
  amount_eth?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "stickers" */
export type Stickers_Mutation_Response = {
  __typename?: 'stickers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stickers>;
};

/** input type for inserting object relation for remote table "stickers" */
export type Stickers_Obj_Rel_Insert_Input = {
  data: Stickers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Stickers_On_Conflict>;
};

/** on_conflict condition type for table "stickers" */
export type Stickers_On_Conflict = {
  constraint: Stickers_Constraint;
  update_columns?: Array<Stickers_Update_Column>;
  where?: InputMaybe<Stickers_Bool_Exp>;
};

/** Ordering options when selecting data from "stickers". */
export type Stickers_Order_By = {
  _image?: InputMaybe<Order_By>;
  amount_eth?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  is_available?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stickers */
export type Stickers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "stickers" */
export enum Stickers_Select_Column {
  /** column name */
  AmountEth = 'amount_eth',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsAvailable = 'is_available',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "stickers" */
export type Stickers_Set_Input = {
  amount_eth?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_available?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Stickers_Stddev_Fields = {
  __typename?: 'stickers_stddev_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Stickers_Stddev_Pop_Fields = {
  __typename?: 'stickers_stddev_pop_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Stickers_Stddev_Samp_Fields = {
  __typename?: 'stickers_stddev_samp_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stickers" */
export type Stickers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stickers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stickers_Stream_Cursor_Value_Input = {
  amount_eth?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_available?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Stickers_Sum_Fields = {
  __typename?: 'stickers_sum_fields';
  amount_eth?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "stickers" */
export enum Stickers_Update_Column {
  /** column name */
  AmountEth = 'amount_eth',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsAvailable = 'is_available',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Stickers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stickers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stickers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stickers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stickers_Var_Pop_Fields = {
  __typename?: 'stickers_var_pop_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Stickers_Var_Samp_Fields = {
  __typename?: 'stickers_var_samp_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Stickers_Variance_Fields = {
  __typename?: 'stickers_variance_fields';
  amount_eth?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<Address>;
  /** fetch data from the table: "articles" */
  articles: Array<Articles>;
  /** fetch aggregated fields from the table: "articles" */
  articles_aggregate: Articles_Aggregate;
  /** fetch data from the table: "articles" using primary key columns */
  articles_by_pk?: Maybe<Articles>;
  /** fetch data from the table in a streaming manner: "articles" */
  articles_stream: Array<Articles>;
  /** fetch data from the table: "colleges" */
  colleges: Array<Colleges>;
  /** fetch aggregated fields from the table: "colleges" */
  colleges_aggregate: Colleges_Aggregate;
  /** fetch data from the table: "colleges" using primary key columns */
  colleges_by_pk?: Maybe<Colleges>;
  /** fetch data from the table in a streaming manner: "colleges" */
  colleges_stream: Array<Colleges>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comments_by_pk?: Maybe<Comments>;
  /** fetch data from the table in a streaming manner: "comments" */
  comments_stream: Array<Comments>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table in a streaming manner: "company" */
  company_stream: Array<Company>;
  /** fetch data from the table: "discover" */
  discover: Array<Discover>;
  /** fetch aggregated fields from the table: "discover" */
  discover_aggregate: Discover_Aggregate;
  /** fetch data from the table: "discover" using primary key columns */
  discover_by_pk?: Maybe<Discover>;
  /** fetch data from the table: "discover_events" */
  discover_events: Array<Discover_Events>;
  /** fetch aggregated fields from the table: "discover_events" */
  discover_events_aggregate: Discover_Events_Aggregate;
  /** fetch data from the table: "discover_events" using primary key columns */
  discover_events_by_pk?: Maybe<Discover_Events>;
  /** fetch data from the table in a streaming manner: "discover_events" */
  discover_events_stream: Array<Discover_Events>;
  /** fetch data from the table in a streaming manner: "discover" */
  discover_stream: Array<Discover>;
  /** fetch data from the table: "education_fields" */
  education_fields: Array<Education_Fields>;
  /** fetch aggregated fields from the table: "education_fields" */
  education_fields_aggregate: Education_Fields_Aggregate;
  /** fetch data from the table: "education_fields" using primary key columns */
  education_fields_by_pk?: Maybe<Education_Fields>;
  /** fetch data from the table in a streaming manner: "education_fields" */
  education_fields_stream: Array<Education_Fields>;
  /** An array relationship */
  educations: Array<Educations>;
  /** An aggregate relationship */
  educations_aggregate: Educations_Aggregate;
  /** fetch data from the table: "educations" using primary key columns */
  educations_by_pk?: Maybe<Educations>;
  /** fetch data from the table in a streaming manner: "educations" */
  educations_stream: Array<Educations>;
  /** fetch data from the table: "experience_type" */
  experience_type: Array<Experience_Type>;
  /** fetch aggregated fields from the table: "experience_type" */
  experience_type_aggregate: Experience_Type_Aggregate;
  /** fetch data from the table: "experience_type" using primary key columns */
  experience_type_by_pk?: Maybe<Experience_Type>;
  /** fetch data from the table in a streaming manner: "experience_type" */
  experience_type_stream: Array<Experience_Type>;
  /** An array relationship */
  experiences: Array<Experiences>;
  /** An aggregate relationship */
  experiences_aggregate: Experiences_Aggregate;
  /** fetch data from the table: "experiences" using primary key columns */
  experiences_by_pk?: Maybe<Experiences>;
  /** fetch data from the table in a streaming manner: "experiences" */
  experiences_stream: Array<Experiences>;
  /** fetch data from the table: "feature_flag_types" */
  feature_flag_types: Array<Feature_Flag_Types>;
  /** fetch aggregated fields from the table: "feature_flag_types" */
  feature_flag_types_aggregate: Feature_Flag_Types_Aggregate;
  /** fetch data from the table: "feature_flag_types" using primary key columns */
  feature_flag_types_by_pk?: Maybe<Feature_Flag_Types>;
  /** fetch data from the table in a streaming manner: "feature_flag_types" */
  feature_flag_types_stream: Array<Feature_Flag_Types>;
  /** fetch data from the table: "feature_flags" */
  feature_flags: Array<Feature_Flags>;
  /** fetch aggregated fields from the table: "feature_flags" */
  feature_flags_aggregate: Feature_Flags_Aggregate;
  /** fetch data from the table: "feature_flags" using primary key columns */
  feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** fetch data from the table in a streaming manner: "feature_flags" */
  feature_flags_stream: Array<Feature_Flags>;
  /** fetch data from the table: "hackathon_bounties_status" */
  hackathon_bounties_status: Array<Hackathon_Bounties_Status>;
  /** fetch aggregated fields from the table: "hackathon_bounties_status" */
  hackathon_bounties_status_aggregate: Hackathon_Bounties_Status_Aggregate;
  /** fetch data from the table: "hackathon_bounties_status" using primary key columns */
  hackathon_bounties_status_by_pk?: Maybe<Hackathon_Bounties_Status>;
  /** fetch data from the table in a streaming manner: "hackathon_bounties_status" */
  hackathon_bounties_status_stream: Array<Hackathon_Bounties_Status>;
  /** fetch data from the table: "hackathon_brands" */
  hackathon_brands: Array<Hackathon_Brands>;
  /** fetch aggregated fields from the table: "hackathon_brands" */
  hackathon_brands_aggregate: Hackathon_Brands_Aggregate;
  /** fetch data from the table: "hackathon_brands" using primary key columns */
  hackathon_brands_by_pk?: Maybe<Hackathon_Brands>;
  /** fetch data from the table in a streaming manner: "hackathon_brands" */
  hackathon_brands_stream: Array<Hackathon_Brands>;
  /** fetch data from the table: "hackathon_checklists" */
  hackathon_checklists: Array<Hackathon_Checklists>;
  /** fetch aggregated fields from the table: "hackathon_checklists" */
  hackathon_checklists_aggregate: Hackathon_Checklists_Aggregate;
  /** fetch data from the table: "hackathon_checklists" using primary key columns */
  hackathon_checklists_by_pk?: Maybe<Hackathon_Checklists>;
  /** fetch data from the table in a streaming manner: "hackathon_checklists" */
  hackathon_checklists_stream: Array<Hackathon_Checklists>;
  /** fetch data from the table: "hackathon_credential_eligible_entities" */
  hackathon_credential_eligible_entities: Array<Hackathon_Credential_Eligible_Entities>;
  /** fetch aggregated fields from the table: "hackathon_credential_eligible_entities" */
  hackathon_credential_eligible_entities_aggregate: Hackathon_Credential_Eligible_Entities_Aggregate;
  /** fetch data from the table: "hackathon_credential_eligible_entities" using primary key columns */
  hackathon_credential_eligible_entities_by_pk?: Maybe<Hackathon_Credential_Eligible_Entities>;
  /** fetch data from the table in a streaming manner: "hackathon_credential_eligible_entities" */
  hackathon_credential_eligible_entities_stream: Array<Hackathon_Credential_Eligible_Entities>;
  /** fetch data from the table: "hackathon_credential_type" */
  hackathon_credential_type: Array<Hackathon_Credential_Type>;
  /** fetch aggregated fields from the table: "hackathon_credential_type" */
  hackathon_credential_type_aggregate: Hackathon_Credential_Type_Aggregate;
  /** fetch data from the table: "hackathon_credential_type" using primary key columns */
  hackathon_credential_type_by_pk?: Maybe<Hackathon_Credential_Type>;
  /** fetch data from the table in a streaming manner: "hackathon_credential_type" */
  hackathon_credential_type_stream: Array<Hackathon_Credential_Type>;
  /** fetch data from the table: "hackathon_credentials" */
  hackathon_credentials: Array<Hackathon_Credentials>;
  /** fetch aggregated fields from the table: "hackathon_credentials" */
  hackathon_credentials_aggregate: Hackathon_Credentials_Aggregate;
  /** fetch data from the table: "hackathon_credentials" using primary key columns */
  hackathon_credentials_by_pk?: Maybe<Hackathon_Credentials>;
  /** fetch data from the table: "hackathon_credentials_chain" */
  hackathon_credentials_chain: Array<Hackathon_Credentials_Chain>;
  /** fetch aggregated fields from the table: "hackathon_credentials_chain" */
  hackathon_credentials_chain_aggregate: Hackathon_Credentials_Chain_Aggregate;
  /** fetch data from the table: "hackathon_credentials_chain" using primary key columns */
  hackathon_credentials_chain_by_pk?: Maybe<Hackathon_Credentials_Chain>;
  /** fetch data from the table in a streaming manner: "hackathon_credentials_chain" */
  hackathon_credentials_chain_stream: Array<Hackathon_Credentials_Chain>;
  /** fetch data from the table in a streaming manner: "hackathon_credentials" */
  hackathon_credentials_stream: Array<Hackathon_Credentials>;
  /** fetch data from the table: "hackathon_email_templates" */
  hackathon_email_templates: Array<Hackathon_Email_Templates>;
  /** fetch aggregated fields from the table: "hackathon_email_templates" */
  hackathon_email_templates_aggregate: Hackathon_Email_Templates_Aggregate;
  /** fetch data from the table: "hackathon_email_templates" using primary key columns */
  hackathon_email_templates_by_pk?: Maybe<Hackathon_Email_Templates>;
  /** fetch data from the table in a streaming manner: "hackathon_email_templates" */
  hackathon_email_templates_stream: Array<Hackathon_Email_Templates>;
  /** An array relationship */
  hackathon_event_groups: Array<Hackathon_Event_Groups>;
  /** An aggregate relationship */
  hackathon_event_groups_aggregate: Hackathon_Event_Groups_Aggregate;
  /** fetch data from the table: "hackathon_event_groups" using primary key columns */
  hackathon_event_groups_by_pk?: Maybe<Hackathon_Event_Groups>;
  /** fetch data from the table in a streaming manner: "hackathon_event_groups" */
  hackathon_event_groups_stream: Array<Hackathon_Event_Groups>;
  /** fetch data from the table: "hackathon_event_speakers" */
  hackathon_event_speakers: Array<Hackathon_Event_Speakers>;
  /** fetch aggregated fields from the table: "hackathon_event_speakers" */
  hackathon_event_speakers_aggregate: Hackathon_Event_Speakers_Aggregate;
  /** fetch data from the table: "hackathon_event_speakers" using primary key columns */
  hackathon_event_speakers_by_pk?: Maybe<Hackathon_Event_Speakers>;
  /** fetch data from the table in a streaming manner: "hackathon_event_speakers" */
  hackathon_event_speakers_stream: Array<Hackathon_Event_Speakers>;
  /** fetch data from the table: "hackathon_event_sponsors" */
  hackathon_event_sponsors: Array<Hackathon_Event_Sponsors>;
  /** fetch aggregated fields from the table: "hackathon_event_sponsors" */
  hackathon_event_sponsors_aggregate: Hackathon_Event_Sponsors_Aggregate;
  /** fetch data from the table: "hackathon_event_sponsors" using primary key columns */
  hackathon_event_sponsors_by_pk?: Maybe<Hackathon_Event_Sponsors>;
  /** fetch data from the table in a streaming manner: "hackathon_event_sponsors" */
  hackathon_event_sponsors_stream: Array<Hackathon_Event_Sponsors>;
  /** fetch data from the table: "hackathon_event_type" */
  hackathon_event_type: Array<Hackathon_Event_Type>;
  /** fetch aggregated fields from the table: "hackathon_event_type" */
  hackathon_event_type_aggregate: Hackathon_Event_Type_Aggregate;
  /** fetch data from the table: "hackathon_event_type" using primary key columns */
  hackathon_event_type_by_pk?: Maybe<Hackathon_Event_Type>;
  /** fetch data from the table in a streaming manner: "hackathon_event_type" */
  hackathon_event_type_stream: Array<Hackathon_Event_Type>;
  /** An array relationship */
  hackathon_events: Array<Hackathon_Events>;
  /** An aggregate relationship */
  hackathon_events_aggregate: Hackathon_Events_Aggregate;
  /** fetch data from the table: "hackathon_events" using primary key columns */
  hackathon_events_by_pk?: Maybe<Hackathon_Events>;
  /** fetch data from the table in a streaming manner: "hackathon_events" */
  hackathon_events_stream: Array<Hackathon_Events>;
  /** fetch data from the table: "hackathon_faq" */
  hackathon_faq: Array<Hackathon_Faq>;
  /** fetch aggregated fields from the table: "hackathon_faq" */
  hackathon_faq_aggregate: Hackathon_Faq_Aggregate;
  /** fetch data from the table: "hackathon_faq" using primary key columns */
  hackathon_faq_by_pk?: Maybe<Hackathon_Faq>;
  /** fetch data from the table in a streaming manner: "hackathon_faq" */
  hackathon_faq_stream: Array<Hackathon_Faq>;
  /** fetch data from the table: "hackathon_faq_type" */
  hackathon_faq_type: Array<Hackathon_Faq_Type>;
  /** fetch aggregated fields from the table: "hackathon_faq_type" */
  hackathon_faq_type_aggregate: Hackathon_Faq_Type_Aggregate;
  /** fetch data from the table: "hackathon_faq_type" using primary key columns */
  hackathon_faq_type_by_pk?: Maybe<Hackathon_Faq_Type>;
  /** fetch data from the table in a streaming manner: "hackathon_faq_type" */
  hackathon_faq_type_stream: Array<Hackathon_Faq_Type>;
  /** fetch data from the table: "hackathon_hashtags" */
  hackathon_hashtags: Array<Hackathon_Hashtags>;
  /** fetch aggregated fields from the table: "hackathon_hashtags" */
  hackathon_hashtags_aggregate: Hackathon_Hashtags_Aggregate;
  /** fetch data from the table: "hackathon_hashtags" using primary key columns */
  hackathon_hashtags_by_pk?: Maybe<Hackathon_Hashtags>;
  /** fetch data from the table in a streaming manner: "hackathon_hashtags" */
  hackathon_hashtags_stream: Array<Hackathon_Hashtags>;
  /** fetch data from the table: "hackathon_hosts" */
  hackathon_hosts: Array<Hackathon_Hosts>;
  /** fetch aggregated fields from the table: "hackathon_hosts" */
  hackathon_hosts_aggregate: Hackathon_Hosts_Aggregate;
  /** fetch data from the table: "hackathon_hosts" using primary key columns */
  hackathon_hosts_by_pk?: Maybe<Hackathon_Hosts>;
  /** fetch data from the table in a streaming manner: "hackathon_hosts" */
  hackathon_hosts_stream: Array<Hackathon_Hosts>;
  /** fetch data from the table: "hackathon_note_type" */
  hackathon_note_type: Array<Hackathon_Note_Type>;
  /** fetch aggregated fields from the table: "hackathon_note_type" */
  hackathon_note_type_aggregate: Hackathon_Note_Type_Aggregate;
  /** fetch data from the table: "hackathon_note_type" using primary key columns */
  hackathon_note_type_by_pk?: Maybe<Hackathon_Note_Type>;
  /** fetch data from the table in a streaming manner: "hackathon_note_type" */
  hackathon_note_type_stream: Array<Hackathon_Note_Type>;
  /** An array relationship */
  hackathon_notes: Array<Hackathon_Notes>;
  /** An aggregate relationship */
  hackathon_notes_aggregate: Hackathon_Notes_Aggregate;
  /** fetch data from the table: "hackathon_notes" using primary key columns */
  hackathon_notes_by_pk?: Maybe<Hackathon_Notes>;
  /** fetch data from the table in a streaming manner: "hackathon_notes" */
  hackathon_notes_stream: Array<Hackathon_Notes>;
  /** fetch data from the table: "hackathon_schwags" */
  hackathon_schwags: Array<Hackathon_Schwags>;
  /** fetch aggregated fields from the table: "hackathon_schwags" */
  hackathon_schwags_aggregate: Hackathon_Schwags_Aggregate;
  /** fetch data from the table: "hackathon_schwags" using primary key columns */
  hackathon_schwags_by_pk?: Maybe<Hackathon_Schwags>;
  /** fetch data from the table in a streaming manner: "hackathon_schwags" */
  hackathon_schwags_stream: Array<Hackathon_Schwags>;
  /** fetch data from the table: "hackathon_scope_extras" */
  hackathon_scope_extras: Array<Hackathon_Scope_Extras>;
  /** fetch aggregated fields from the table: "hackathon_scope_extras" */
  hackathon_scope_extras_aggregate: Hackathon_Scope_Extras_Aggregate;
  /** fetch data from the table: "hackathon_scope_extras" using primary key columns */
  hackathon_scope_extras_by_pk?: Maybe<Hackathon_Scope_Extras>;
  /** fetch data from the table in a streaming manner: "hackathon_scope_extras" */
  hackathon_scope_extras_stream: Array<Hackathon_Scope_Extras>;
  /** fetch data from the table: "hackathon_scopes" */
  hackathon_scopes: Array<Hackathon_Scopes>;
  /** fetch aggregated fields from the table: "hackathon_scopes" */
  hackathon_scopes_aggregate: Hackathon_Scopes_Aggregate;
  /** fetch data from the table: "hackathon_scopes" using primary key columns */
  hackathon_scopes_by_pk?: Maybe<Hackathon_Scopes>;
  /** fetch data from the table in a streaming manner: "hackathon_scopes" */
  hackathon_scopes_stream: Array<Hackathon_Scopes>;
  /** fetch data from the table: "hackathon_settings" */
  hackathon_settings: Array<Hackathon_Settings>;
  /** fetch aggregated fields from the table: "hackathon_settings" */
  hackathon_settings_aggregate: Hackathon_Settings_Aggregate;
  /** fetch data from the table: "hackathon_settings" using primary key columns */
  hackathon_settings_by_pk?: Maybe<Hackathon_Settings>;
  /** fetch data from the table in a streaming manner: "hackathon_settings" */
  hackathon_settings_stream: Array<Hackathon_Settings>;
  /** fetch data from the table: "hackathon_staking_currency" */
  hackathon_staking_currency: Array<Hackathon_Staking_Currency>;
  /** fetch aggregated fields from the table: "hackathon_staking_currency" */
  hackathon_staking_currency_aggregate: Hackathon_Staking_Currency_Aggregate;
  /** fetch data from the table: "hackathon_staking_currency" using primary key columns */
  hackathon_staking_currency_by_pk?: Maybe<Hackathon_Staking_Currency>;
  /** fetch data from the table in a streaming manner: "hackathon_staking_currency" */
  hackathon_staking_currency_stream: Array<Hackathon_Staking_Currency>;
  /** fetch data from the table: "hackathon_staking_type" */
  hackathon_staking_type: Array<Hackathon_Staking_Type>;
  /** fetch aggregated fields from the table: "hackathon_staking_type" */
  hackathon_staking_type_aggregate: Hackathon_Staking_Type_Aggregate;
  /** fetch data from the table: "hackathon_staking_type" using primary key columns */
  hackathon_staking_type_by_pk?: Maybe<Hackathon_Staking_Type>;
  /** fetch data from the table in a streaming manner: "hackathon_staking_type" */
  hackathon_staking_type_stream: Array<Hackathon_Staking_Type>;
  /** fetch data from the table: "hackathon_stakings" */
  hackathon_stakings: Array<Hackathon_Stakings>;
  /** fetch aggregated fields from the table: "hackathon_stakings" */
  hackathon_stakings_aggregate: Hackathon_Stakings_Aggregate;
  /** fetch data from the table: "hackathon_stakings" using primary key columns */
  hackathon_stakings_by_pk?: Maybe<Hackathon_Stakings>;
  /** fetch data from the table in a streaming manner: "hackathon_stakings" */
  hackathon_stakings_stream: Array<Hackathon_Stakings>;
  /** fetch data from the table: "hackathon_themes" */
  hackathon_themes: Array<Hackathon_Themes>;
  /** fetch aggregated fields from the table: "hackathon_themes" */
  hackathon_themes_aggregate: Hackathon_Themes_Aggregate;
  /** fetch data from the table: "hackathon_themes" using primary key columns */
  hackathon_themes_by_pk?: Maybe<Hackathon_Themes>;
  /** fetch data from the table in a streaming manner: "hackathon_themes" */
  hackathon_themes_stream: Array<Hackathon_Themes>;
  /** fetch data from the table: "hackathon_tracks" */
  hackathon_tracks: Array<Hackathon_Tracks>;
  /** fetch aggregated fields from the table: "hackathon_tracks" */
  hackathon_tracks_aggregate: Hackathon_Tracks_Aggregate;
  /** fetch data from the table: "hackathon_tracks" using primary key columns */
  hackathon_tracks_by_pk?: Maybe<Hackathon_Tracks>;
  /** fetch data from the table in a streaming manner: "hackathon_tracks" */
  hackathon_tracks_stream: Array<Hackathon_Tracks>;
  /** fetch data from the table: "hackathon_type" */
  hackathon_type: Array<Hackathon_Type>;
  /** fetch aggregated fields from the table: "hackathon_type" */
  hackathon_type_aggregate: Hackathon_Type_Aggregate;
  /** fetch data from the table: "hackathon_type" using primary key columns */
  hackathon_type_by_pk?: Maybe<Hackathon_Type>;
  /** fetch data from the table in a streaming manner: "hackathon_type" */
  hackathon_type_stream: Array<Hackathon_Type>;
  /** An array relationship */
  hackathons: Array<Hackathons>;
  /** An aggregate relationship */
  hackathons_aggregate: Hackathons_Aggregate;
  /** fetch data from the table: "hackathons" using primary key columns */
  hackathons_by_pk?: Maybe<Hackathons>;
  /** fetch data from the table in a streaming manner: "hackathons" */
  hackathons_stream: Array<Hackathons>;
  /** fetch data from the table: "hashtags" */
  hashtags: Array<Hashtags>;
  /** fetch aggregated fields from the table: "hashtags" */
  hashtags_aggregate: Hashtags_Aggregate;
  /** fetch data from the table: "hashtags" using primary key columns */
  hashtags_by_pk?: Maybe<Hashtags>;
  /** fetch data from the table in a streaming manner: "hashtags" */
  hashtags_stream: Array<Hashtags>;
  /** fetch data from the table: "idea_stats" */
  idea_stats: Array<Idea_Stats>;
  /** fetch aggregated fields from the table: "idea_stats" */
  idea_stats_aggregate: Idea_Stats_Aggregate;
  /** fetch data from the table: "idea_stats" using primary key columns */
  idea_stats_by_pk?: Maybe<Idea_Stats>;
  /** fetch data from the table in a streaming manner: "idea_stats" */
  idea_stats_stream: Array<Idea_Stats>;
  /** fetch data from the table: "ideas" */
  ideas: Array<Ideas>;
  /** fetch aggregated fields from the table: "ideas" */
  ideas_aggregate: Ideas_Aggregate;
  /** fetch data from the table: "ideas" using primary key columns */
  ideas_by_pk?: Maybe<Ideas>;
  /** fetch data from the table in a streaming manner: "ideas" */
  ideas_stream: Array<Ideas>;
  /** An array relationship */
  judges: Array<Judges>;
  /** An aggregate relationship */
  judges_aggregate: Judges_Aggregate;
  /** fetch data from the table: "judges" using primary key columns */
  judges_by_pk?: Maybe<Judges>;
  /** fetch data from the table in a streaming manner: "judges" */
  judges_stream: Array<Judges>;
  /** fetch data from the table: "judging_rooms" */
  judging_rooms: Array<Judging_Rooms>;
  /** fetch aggregated fields from the table: "judging_rooms" */
  judging_rooms_aggregate: Judging_Rooms_Aggregate;
  /** fetch data from the table: "judging_rooms" using primary key columns */
  judging_rooms_by_pk?: Maybe<Judging_Rooms>;
  /** fetch data from the table in a streaming manner: "judging_rooms" */
  judging_rooms_stream: Array<Judging_Rooms>;
  /** execute function "me" which returns "users" */
  me?: Maybe<Users>;
  /** execute function "me" and query aggregates on result of table type "users" */
  me_aggregate: Users_Aggregate;
  /** fetch data from the table: "notification_types" */
  notification_types: Array<Notification_Types>;
  /** fetch aggregated fields from the table: "notification_types" */
  notification_types_aggregate: Notification_Types_Aggregate;
  /** fetch data from the table: "notification_types" using primary key columns */
  notification_types_by_pk?: Maybe<Notification_Types>;
  /** fetch data from the table in a streaming manner: "notification_types" */
  notification_types_stream: Array<Notification_Types>;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "oauth" */
  oauth: Array<Oauth>;
  /** fetch aggregated fields from the table: "oauth" */
  oauth_aggregate: Oauth_Aggregate;
  /** fetch data from the table: "oauth" using primary key columns */
  oauth_by_pk?: Maybe<Oauth>;
  /** fetch data from the table: "oauth_providers" */
  oauth_providers: Array<Oauth_Providers>;
  /** fetch aggregated fields from the table: "oauth_providers" */
  oauth_providers_aggregate: Oauth_Providers_Aggregate;
  /** fetch data from the table: "oauth_providers" using primary key columns */
  oauth_providers_by_pk?: Maybe<Oauth_Providers>;
  /** fetch data from the table in a streaming manner: "oauth_providers" */
  oauth_providers_stream: Array<Oauth_Providers>;
  /** fetch data from the table in a streaming manner: "oauth" */
  oauth_stream: Array<Oauth>;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** fetch data from the table in a streaming manner: "permissions" */
  permissions_stream: Array<Permissions>;
  /** fetch data from the table: "prize_sponsors" */
  prize_sponsors: Array<Prize_Sponsors>;
  /** fetch aggregated fields from the table: "prize_sponsors" */
  prize_sponsors_aggregate: Prize_Sponsors_Aggregate;
  /** fetch data from the table: "prize_sponsors" using primary key columns */
  prize_sponsors_by_pk?: Maybe<Prize_Sponsors>;
  /** fetch data from the table in a streaming manner: "prize_sponsors" */
  prize_sponsors_stream: Array<Prize_Sponsors>;
  /** An array relationship */
  prize_tracks: Array<Prize_Tracks>;
  /** An aggregate relationship */
  prize_tracks_aggregate: Prize_Tracks_Aggregate;
  /** fetch data from the table: "prize_tracks" using primary key columns */
  prize_tracks_by_pk?: Maybe<Prize_Tracks>;
  /** fetch data from the table in a streaming manner: "prize_tracks" */
  prize_tracks_stream: Array<Prize_Tracks>;
  /** An array relationship */
  prizes: Array<Prizes>;
  /** An aggregate relationship */
  prizes_aggregate: Prizes_Aggregate;
  /** fetch data from the table: "prizes" using primary key columns */
  prizes_by_pk?: Maybe<Prizes>;
  /** fetch data from the table in a streaming manner: "prizes" */
  prizes_stream: Array<Prizes>;
  /** fetch data from the table: "profiles" */
  profiles: Array<Profiles>;
  /** fetch aggregated fields from the table: "profiles" */
  profiles_aggregate: Profiles_Aggregate;
  /** fetch data from the table: "profiles" using primary key columns */
  profiles_by_pk?: Maybe<Profiles>;
  /** fetch data from the table in a streaming manner: "profiles" */
  profiles_stream: Array<Profiles>;
  /** fetch data from the table: "project_commits" */
  project_commits: Array<Project_Commits>;
  /** fetch aggregated fields from the table: "project_commits" */
  project_commits_aggregate: Project_Commits_Aggregate;
  /** fetch data from the table: "project_commits" using primary key columns */
  project_commits_by_pk?: Maybe<Project_Commits>;
  /** fetch data from the table in a streaming manner: "project_commits" */
  project_commits_stream: Array<Project_Commits>;
  /** fetch data from the table: "project_contribution_stickers" */
  project_contribution_stickers: Array<Project_Contribution_Stickers>;
  /** fetch aggregated fields from the table: "project_contribution_stickers" */
  project_contribution_stickers_aggregate: Project_Contribution_Stickers_Aggregate;
  /** fetch data from the table: "project_contribution_stickers" using primary key columns */
  project_contribution_stickers_by_pk?: Maybe<Project_Contribution_Stickers>;
  /** fetch data from the table in a streaming manner: "project_contribution_stickers" */
  project_contribution_stickers_stream: Array<Project_Contribution_Stickers>;
  /** fetch data from the table: "project_contribution_tx_network_type" */
  project_contribution_tx_network_type: Array<Project_Contribution_Tx_Network_Type>;
  /** fetch aggregated fields from the table: "project_contribution_tx_network_type" */
  project_contribution_tx_network_type_aggregate: Project_Contribution_Tx_Network_Type_Aggregate;
  /** fetch data from the table: "project_contribution_tx_network_type" using primary key columns */
  project_contribution_tx_network_type_by_pk?: Maybe<Project_Contribution_Tx_Network_Type>;
  /** fetch data from the table in a streaming manner: "project_contribution_tx_network_type" */
  project_contribution_tx_network_type_stream: Array<Project_Contribution_Tx_Network_Type>;
  /** fetch data from the table: "project_contributions" */
  project_contributions: Array<Project_Contributions>;
  /** fetch aggregated fields from the table: "project_contributions" */
  project_contributions_aggregate: Project_Contributions_Aggregate;
  /** fetch data from the table: "project_contributions" using primary key columns */
  project_contributions_by_pk?: Maybe<Project_Contributions>;
  /** fetch data from the table in a streaming manner: "project_contributions" */
  project_contributions_stream: Array<Project_Contributions>;
  /** fetch data from the table: "project_contributions_type" */
  project_contributions_type: Array<Project_Contributions_Type>;
  /** fetch aggregated fields from the table: "project_contributions_type" */
  project_contributions_type_aggregate: Project_Contributions_Type_Aggregate;
  /** fetch data from the table: "project_contributions_type" using primary key columns */
  project_contributions_type_by_pk?: Maybe<Project_Contributions_Type>;
  /** fetch data from the table in a streaming manner: "project_contributions_type" */
  project_contributions_type_stream: Array<Project_Contributions_Type>;
  /** fetch data from the table: "project_hashtags" */
  project_hashtags: Array<Project_Hashtags>;
  /** fetch aggregated fields from the table: "project_hashtags" */
  project_hashtags_aggregate: Project_Hashtags_Aggregate;
  /** fetch data from the table: "project_hashtags" using primary key columns */
  project_hashtags_by_pk?: Maybe<Project_Hashtags>;
  /** fetch data from the table in a streaming manner: "project_hashtags" */
  project_hashtags_stream: Array<Project_Hashtags>;
  /** fetch data from the table: "project_judges" */
  project_judges: Array<Project_Judges>;
  /** fetch aggregated fields from the table: "project_judges" */
  project_judges_aggregate: Project_Judges_Aggregate;
  /** fetch data from the table: "project_judges" using primary key columns */
  project_judges_by_pk?: Maybe<Project_Judges>;
  /** fetch data from the table in a streaming manner: "project_judges" */
  project_judges_stream: Array<Project_Judges>;
  /** fetch data from the table: "project_judging_submission_type" */
  project_judging_submission_type: Array<Project_Judging_Submission_Type>;
  /** fetch aggregated fields from the table: "project_judging_submission_type" */
  project_judging_submission_type_aggregate: Project_Judging_Submission_Type_Aggregate;
  /** fetch data from the table: "project_judging_submission_type" using primary key columns */
  project_judging_submission_type_by_pk?: Maybe<Project_Judging_Submission_Type>;
  /** fetch data from the table in a streaming manner: "project_judging_submission_type" */
  project_judging_submission_type_stream: Array<Project_Judging_Submission_Type>;
  /** An array relationship */
  project_judgments: Array<Project_Judgments>;
  /** An aggregate relationship */
  project_judgments_aggregate: Project_Judgments_Aggregate;
  /** fetch data from the table: "project_judgments" using primary key columns */
  project_judgments_by_pk?: Maybe<Project_Judgments>;
  /** fetch data from the table in a streaming manner: "project_judgments" */
  project_judgments_stream: Array<Project_Judgments>;
  /** fetch data from the table: "project_report_type" */
  project_report_type: Array<Project_Report_Type>;
  /** fetch aggregated fields from the table: "project_report_type" */
  project_report_type_aggregate: Project_Report_Type_Aggregate;
  /** fetch data from the table: "project_report_type" using primary key columns */
  project_report_type_by_pk?: Maybe<Project_Report_Type>;
  /** fetch data from the table in a streaming manner: "project_report_type" */
  project_report_type_stream: Array<Project_Report_Type>;
  /** An array relationship */
  project_reports: Array<Project_Reports>;
  /** An aggregate relationship */
  project_reports_aggregate: Project_Reports_Aggregate;
  /** fetch data from the table: "project_reports" using primary key columns */
  project_reports_by_pk?: Maybe<Project_Reports>;
  /** fetch data from the table in a streaming manner: "project_reports" */
  project_reports_stream: Array<Project_Reports>;
  /** An array relationship */
  project_tracks: Array<Project_Tracks>;
  /** An aggregate relationship */
  project_tracks_aggregate: Project_Tracks_Aggregate;
  /** fetch data from the table: "project_tracks" using primary key columns */
  project_tracks_by_pk?: Maybe<Project_Tracks>;
  /** fetch data from the table in a streaming manner: "project_tracks" */
  project_tracks_stream: Array<Project_Tracks>;
  /** fetch data from the table: "projects" */
  projects: Array<Projects>;
  /** fetch aggregated fields from the table: "projects" */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** fetch data from the table: "projects_funding" */
  projects_funding: Array<Projects_Funding>;
  /** fetch aggregated fields from the table: "projects_funding" */
  projects_funding_aggregate: Projects_Funding_Aggregate;
  /** fetch data from the table: "projects_funding" using primary key columns */
  projects_funding_by_pk?: Maybe<Projects_Funding>;
  /** fetch data from the table in a streaming manner: "projects_funding" */
  projects_funding_stream: Array<Projects_Funding>;
  /** fetch data from the table in a streaming manner: "projects" */
  projects_stream: Array<Projects>;
  /** fetch data from the table: "quadratic_voting" */
  quadratic_voting: Array<Quadratic_Voting>;
  /** fetch aggregated fields from the table: "quadratic_voting" */
  quadratic_voting_aggregate: Quadratic_Voting_Aggregate;
  /** fetch data from the table: "quadratic_voting" using primary key columns */
  quadratic_voting_by_pk?: Maybe<Quadratic_Voting>;
  /** fetch data from the table: "quadratic_voting_chain" */
  quadratic_voting_chain: Array<Quadratic_Voting_Chain>;
  /** fetch aggregated fields from the table: "quadratic_voting_chain" */
  quadratic_voting_chain_aggregate: Quadratic_Voting_Chain_Aggregate;
  /** fetch data from the table: "quadratic_voting_chain" using primary key columns */
  quadratic_voting_chain_by_pk?: Maybe<Quadratic_Voting_Chain>;
  /** fetch data from the table in a streaming manner: "quadratic_voting_chain" */
  quadratic_voting_chain_stream: Array<Quadratic_Voting_Chain>;
  /** fetch data from the table: "quadratic_voting_currency" */
  quadratic_voting_currency: Array<Quadratic_Voting_Currency>;
  /** fetch aggregated fields from the table: "quadratic_voting_currency" */
  quadratic_voting_currency_aggregate: Quadratic_Voting_Currency_Aggregate;
  /** fetch data from the table: "quadratic_voting_currency" using primary key columns */
  quadratic_voting_currency_by_pk?: Maybe<Quadratic_Voting_Currency>;
  /** fetch data from the table in a streaming manner: "quadratic_voting_currency" */
  quadratic_voting_currency_stream: Array<Quadratic_Voting_Currency>;
  /** fetch data from the table: "quadratic_voting_projects" */
  quadratic_voting_projects: Array<Quadratic_Voting_Projects>;
  /** fetch aggregated fields from the table: "quadratic_voting_projects" */
  quadratic_voting_projects_aggregate: Quadratic_Voting_Projects_Aggregate;
  /** fetch data from the table: "quadratic_voting_projects" using primary key columns */
  quadratic_voting_projects_by_pk?: Maybe<Quadratic_Voting_Projects>;
  /** fetch data from the table in a streaming manner: "quadratic_voting_projects" */
  quadratic_voting_projects_stream: Array<Quadratic_Voting_Projects>;
  /** fetch data from the table: "quadratic_voting_request_access" */
  quadratic_voting_request_access: Array<Quadratic_Voting_Request_Access>;
  /** fetch aggregated fields from the table: "quadratic_voting_request_access" */
  quadratic_voting_request_access_aggregate: Quadratic_Voting_Request_Access_Aggregate;
  /** fetch data from the table: "quadratic_voting_request_access" using primary key columns */
  quadratic_voting_request_access_by_pk?: Maybe<Quadratic_Voting_Request_Access>;
  /** fetch data from the table: "quadratic_voting_request_access_status" */
  quadratic_voting_request_access_status: Array<Quadratic_Voting_Request_Access_Status>;
  /** fetch aggregated fields from the table: "quadratic_voting_request_access_status" */
  quadratic_voting_request_access_status_aggregate: Quadratic_Voting_Request_Access_Status_Aggregate;
  /** fetch data from the table: "quadratic_voting_request_access_status" using primary key columns */
  quadratic_voting_request_access_status_by_pk?: Maybe<Quadratic_Voting_Request_Access_Status>;
  /** fetch data from the table in a streaming manner: "quadratic_voting_request_access_status" */
  quadratic_voting_request_access_status_stream: Array<Quadratic_Voting_Request_Access_Status>;
  /** fetch data from the table in a streaming manner: "quadratic_voting_request_access" */
  quadratic_voting_request_access_stream: Array<Quadratic_Voting_Request_Access>;
  /** fetch data from the table in a streaming manner: "quadratic_voting" */
  quadratic_voting_stream: Array<Quadratic_Voting>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  roles_stream: Array<Roles>;
  /** fetch data from the table: "room_judges" */
  room_judges: Array<Room_Judges>;
  /** fetch aggregated fields from the table: "room_judges" */
  room_judges_aggregate: Room_Judges_Aggregate;
  /** fetch data from the table: "room_judges" using primary key columns */
  room_judges_by_pk?: Maybe<Room_Judges>;
  /** fetch data from the table in a streaming manner: "room_judges" */
  room_judges_stream: Array<Room_Judges>;
  /** An array relationship */
  schwag_tracks: Array<Schwag_Tracks>;
  /** An aggregate relationship */
  schwag_tracks_aggregate: Schwag_Tracks_Aggregate;
  /** fetch data from the table: "schwag_tracks" using primary key columns */
  schwag_tracks_by_pk?: Maybe<Schwag_Tracks>;
  /** fetch data from the table in a streaming manner: "schwag_tracks" */
  schwag_tracks_stream: Array<Schwag_Tracks>;
  /** fetch data from the table: "schwags.allowed_org_winner_count" */
  schwags_allowed_org_winner_count: Array<Schwags_Allowed_Org_Winner_Count>;
  /** fetch aggregated fields from the table: "schwags.allowed_org_winner_count" */
  schwags_allowed_org_winner_count_aggregate: Schwags_Allowed_Org_Winner_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "schwags.allowed_org_winner_count" */
  schwags_allowed_org_winner_count_stream: Array<Schwags_Allowed_Org_Winner_Count>;
  /** execute function "schwags.get_allowed_org_winner_count" which returns "schwags.allowed_org_winner_count" */
  schwags_get_allowed_org_winner_count: Array<Schwags_Allowed_Org_Winner_Count>;
  /** execute function "schwags.get_allowed_org_winner_count" and query aggregates on result of table type "schwags.allowed_org_winner_count" */
  schwags_get_allowed_org_winner_count_aggregate: Schwags_Allowed_Org_Winner_Count_Aggregate;
  /** fetch data from the table: "shop.countries" */
  shop_countries: Array<Shop_Countries>;
  /** fetch aggregated fields from the table: "shop.countries" */
  shop_countries_aggregate: Shop_Countries_Aggregate;
  /** fetch data from the table: "shop.countries" using primary key columns */
  shop_countries_by_pk?: Maybe<Shop_Countries>;
  /** fetch data from the table in a streaming manner: "shop.countries" */
  shop_countries_stream: Array<Shop_Countries>;
  /** fetch data from the table: "shop.coupon_discount_type" */
  shop_coupon_discount_type: Array<Shop_Coupon_Discount_Type>;
  /** fetch aggregated fields from the table: "shop.coupon_discount_type" */
  shop_coupon_discount_type_aggregate: Shop_Coupon_Discount_Type_Aggregate;
  /** fetch data from the table: "shop.coupon_discount_type" using primary key columns */
  shop_coupon_discount_type_by_pk?: Maybe<Shop_Coupon_Discount_Type>;
  /** fetch data from the table in a streaming manner: "shop.coupon_discount_type" */
  shop_coupon_discount_type_stream: Array<Shop_Coupon_Discount_Type>;
  /** fetch data from the table: "shop.coupon_type" */
  shop_coupon_type: Array<Shop_Coupon_Type>;
  /** fetch aggregated fields from the table: "shop.coupon_type" */
  shop_coupon_type_aggregate: Shop_Coupon_Type_Aggregate;
  /** fetch data from the table: "shop.coupon_type" using primary key columns */
  shop_coupon_type_by_pk?: Maybe<Shop_Coupon_Type>;
  /** fetch data from the table in a streaming manner: "shop.coupon_type" */
  shop_coupon_type_stream: Array<Shop_Coupon_Type>;
  /** fetch data from the table: "shop.coupons" */
  shop_coupons: Array<Shop_Coupons>;
  /** fetch aggregated fields from the table: "shop.coupons" */
  shop_coupons_aggregate: Shop_Coupons_Aggregate;
  /** fetch data from the table: "shop.coupons" using primary key columns */
  shop_coupons_by_pk?: Maybe<Shop_Coupons>;
  /** fetch data from the table in a streaming manner: "shop.coupons" */
  shop_coupons_stream: Array<Shop_Coupons>;
  /** execute function "shop.get_coupon" which returns "shop.coupons" */
  shop_get_coupon?: Maybe<Shop_Coupons>;
  /** execute function "shop.get_coupon" and query aggregates on result of table type "shop.coupons" */
  shop_get_coupon_aggregate: Shop_Coupons_Aggregate;
  /** fetch data from the table: "shop.hsn" */
  shop_hsn: Array<Shop_Hsn>;
  /** fetch aggregated fields from the table: "shop.hsn" */
  shop_hsn_aggregate: Shop_Hsn_Aggregate;
  /** fetch data from the table: "shop.hsn" using primary key columns */
  shop_hsn_by_pk?: Maybe<Shop_Hsn>;
  /** fetch data from the table: "shop.hsn_mappings" */
  shop_hsn_mappings: Array<Shop_Hsn_Mappings>;
  /** fetch aggregated fields from the table: "shop.hsn_mappings" */
  shop_hsn_mappings_aggregate: Shop_Hsn_Mappings_Aggregate;
  /** fetch data from the table: "shop.hsn_mappings" using primary key columns */
  shop_hsn_mappings_by_pk?: Maybe<Shop_Hsn_Mappings>;
  /** fetch data from the table in a streaming manner: "shop.hsn_mappings" */
  shop_hsn_mappings_stream: Array<Shop_Hsn_Mappings>;
  /** fetch data from the table in a streaming manner: "shop.hsn" */
  shop_hsn_stream: Array<Shop_Hsn>;
  /** fetch data from the table: "shop.inventory_skus" */
  shop_inventory_skus: Array<Shop_Inventory_Skus>;
  /** fetch aggregated fields from the table: "shop.inventory_skus" */
  shop_inventory_skus_aggregate: Shop_Inventory_Skus_Aggregate;
  /** fetch data from the table: "shop.inventory_skus" using primary key columns */
  shop_inventory_skus_by_pk?: Maybe<Shop_Inventory_Skus>;
  /** fetch data from the table in a streaming manner: "shop.inventory_skus" */
  shop_inventory_skus_stream: Array<Shop_Inventory_Skus>;
  /** fetch data from the table: "shop.order_payment_status" */
  shop_order_payment_status: Array<Shop_Order_Payment_Status>;
  /** fetch aggregated fields from the table: "shop.order_payment_status" */
  shop_order_payment_status_aggregate: Shop_Order_Payment_Status_Aggregate;
  /** fetch data from the table: "shop.order_payment_status" using primary key columns */
  shop_order_payment_status_by_pk?: Maybe<Shop_Order_Payment_Status>;
  /** fetch data from the table in a streaming manner: "shop.order_payment_status" */
  shop_order_payment_status_stream: Array<Shop_Order_Payment_Status>;
  /** fetch data from the table: "shop.order_products" */
  shop_order_products: Array<Shop_Order_Products>;
  /** fetch aggregated fields from the table: "shop.order_products" */
  shop_order_products_aggregate: Shop_Order_Products_Aggregate;
  /** fetch data from the table: "shop.order_products" using primary key columns */
  shop_order_products_by_pk?: Maybe<Shop_Order_Products>;
  /** fetch data from the table in a streaming manner: "shop.order_products" */
  shop_order_products_stream: Array<Shop_Order_Products>;
  /** fetch data from the table: "shop.orders" */
  shop_orders: Array<Shop_Orders>;
  /** fetch aggregated fields from the table: "shop.orders" */
  shop_orders_aggregate: Shop_Orders_Aggregate;
  /** fetch data from the table: "shop.orders" using primary key columns */
  shop_orders_by_pk?: Maybe<Shop_Orders>;
  /** fetch data from the table in a streaming manner: "shop.orders" */
  shop_orders_stream: Array<Shop_Orders>;
  /** fetch data from the table: "shop.product_type" */
  shop_product_type: Array<Shop_Product_Type>;
  /** fetch aggregated fields from the table: "shop.product_type" */
  shop_product_type_aggregate: Shop_Product_Type_Aggregate;
  /** fetch data from the table: "shop.product_type" using primary key columns */
  shop_product_type_by_pk?: Maybe<Shop_Product_Type>;
  /** fetch data from the table in a streaming manner: "shop.product_type" */
  shop_product_type_stream: Array<Shop_Product_Type>;
  /** fetch data from the table: "shop.products" */
  shop_products: Array<Shop_Products>;
  /** fetch aggregated fields from the table: "shop.products" */
  shop_products_aggregate: Shop_Products_Aggregate;
  /** fetch data from the table: "shop.products" using primary key columns */
  shop_products_by_pk?: Maybe<Shop_Products>;
  /** fetch data from the table in a streaming manner: "shop.products" */
  shop_products_stream: Array<Shop_Products>;
  /** fetch data from the table: "shop.shipping_addresses" */
  shop_shipping_addresses: Array<Shop_Shipping_Addresses>;
  /** fetch aggregated fields from the table: "shop.shipping_addresses" */
  shop_shipping_addresses_aggregate: Shop_Shipping_Addresses_Aggregate;
  /** fetch data from the table: "shop.shipping_addresses" using primary key columns */
  shop_shipping_addresses_by_pk?: Maybe<Shop_Shipping_Addresses>;
  /** fetch data from the table in a streaming manner: "shop.shipping_addresses" */
  shop_shipping_addresses_stream: Array<Shop_Shipping_Addresses>;
  /** fetch data from the table: "shop.states" */
  shop_states: Array<Shop_States>;
  /** fetch aggregated fields from the table: "shop.states" */
  shop_states_aggregate: Shop_States_Aggregate;
  /** fetch data from the table: "shop.states" using primary key columns */
  shop_states_by_pk?: Maybe<Shop_States>;
  /** fetch data from the table in a streaming manner: "shop.states" */
  shop_states_stream: Array<Shop_States>;
  /** fetch data from the table: "skills" */
  skills: Array<Skills>;
  /** fetch aggregated fields from the table: "skills" */
  skills_aggregate: Skills_Aggregate;
  /** fetch data from the table: "skills" using primary key columns */
  skills_by_pk?: Maybe<Skills>;
  /** fetch data from the table in a streaming manner: "skills" */
  skills_stream: Array<Skills>;
  /** fetch data from the table: "speaker_slot_status" */
  speaker_slot_status: Array<Speaker_Slot_Status>;
  /** fetch aggregated fields from the table: "speaker_slot_status" */
  speaker_slot_status_aggregate: Speaker_Slot_Status_Aggregate;
  /** fetch data from the table: "speaker_slot_status" using primary key columns */
  speaker_slot_status_by_pk?: Maybe<Speaker_Slot_Status>;
  /** fetch data from the table in a streaming manner: "speaker_slot_status" */
  speaker_slot_status_stream: Array<Speaker_Slot_Status>;
  /** An array relationship */
  sponsor_judgments: Array<Sponsor_Judgments>;
  /** An aggregate relationship */
  sponsor_judgments_aggregate: Sponsor_Judgments_Aggregate;
  /** fetch data from the table: "sponsor_judgments" using primary key columns */
  sponsor_judgments_by_pk?: Maybe<Sponsor_Judgments>;
  /** fetch data from the table in a streaming manner: "sponsor_judgments" */
  sponsor_judgments_stream: Array<Sponsor_Judgments>;
  /** An array relationship */
  sponsor_tiers: Array<Sponsor_Tiers>;
  /** An aggregate relationship */
  sponsor_tiers_aggregate: Sponsor_Tiers_Aggregate;
  /** fetch data from the table: "sponsor_tiers" using primary key columns */
  sponsor_tiers_by_pk?: Maybe<Sponsor_Tiers>;
  /** fetch data from the table in a streaming manner: "sponsor_tiers" */
  sponsor_tiers_stream: Array<Sponsor_Tiers>;
  /** An array relationship */
  sponsors: Array<Sponsors>;
  /** An aggregate relationship */
  sponsors_aggregate: Sponsors_Aggregate;
  /** fetch data from the table: "sponsors" using primary key columns */
  sponsors_by_pk?: Maybe<Sponsors>;
  /** fetch data from the table in a streaming manner: "sponsors" */
  sponsors_stream: Array<Sponsors>;
  /** fetch data from the table: "stickers" */
  stickers: Array<Stickers>;
  /** fetch aggregated fields from the table: "stickers" */
  stickers_aggregate: Stickers_Aggregate;
  /** fetch data from the table: "stickers" using primary key columns */
  stickers_by_pk?: Maybe<Stickers>;
  /** fetch data from the table in a streaming manner: "stickers" */
  stickers_stream: Array<Stickers>;
  /** An array relationship */
  sumsub_applicants: Array<Sumsub_Applicants>;
  /** An aggregate relationship */
  sumsub_applicants_aggregate: Sumsub_Applicants_Aggregate;
  /** fetch data from the table: "sumsub_applicants" using primary key columns */
  sumsub_applicants_by_pk?: Maybe<Sumsub_Applicants>;
  /** fetch data from the table: "sumsub_applicants_review_status" */
  sumsub_applicants_review_status: Array<Sumsub_Applicants_Review_Status>;
  /** fetch aggregated fields from the table: "sumsub_applicants_review_status" */
  sumsub_applicants_review_status_aggregate: Sumsub_Applicants_Review_Status_Aggregate;
  /** fetch data from the table: "sumsub_applicants_review_status" using primary key columns */
  sumsub_applicants_review_status_by_pk?: Maybe<Sumsub_Applicants_Review_Status>;
  /** fetch data from the table in a streaming manner: "sumsub_applicants_review_status" */
  sumsub_applicants_review_status_stream: Array<Sumsub_Applicants_Review_Status>;
  /** fetch data from the table in a streaming manner: "sumsub_applicants" */
  sumsub_applicants_stream: Array<Sumsub_Applicants>;
  /** fetch data from the table: "synaps_kyc_session_status" */
  synaps_kyc_session_status: Array<Synaps_Kyc_Session_Status>;
  /** fetch aggregated fields from the table: "synaps_kyc_session_status" */
  synaps_kyc_session_status_aggregate: Synaps_Kyc_Session_Status_Aggregate;
  /** fetch data from the table: "synaps_kyc_session_status" using primary key columns */
  synaps_kyc_session_status_by_pk?: Maybe<Synaps_Kyc_Session_Status>;
  /** fetch data from the table in a streaming manner: "synaps_kyc_session_status" */
  synaps_kyc_session_status_stream: Array<Synaps_Kyc_Session_Status>;
  /** An array relationship */
  synaps_kyc_sessions: Array<Synaps_Kyc_Sessions>;
  /** An aggregate relationship */
  synaps_kyc_sessions_aggregate: Synaps_Kyc_Sessions_Aggregate;
  /** fetch data from the table: "synaps_kyc_sessions" using primary key columns */
  synaps_kyc_sessions_by_pk?: Maybe<Synaps_Kyc_Sessions>;
  /** fetch data from the table in a streaming manner: "synaps_kyc_sessions" */
  synaps_kyc_sessions_stream: Array<Synaps_Kyc_Sessions>;
  /** fetch data from the table: "teams" */
  teams: Array<Teams>;
  /** fetch aggregated fields from the table: "teams" */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table in a streaming manner: "teams" */
  teams_stream: Array<Teams>;
  /** fetch data from the table: "themes" */
  themes: Array<Themes>;
  /** fetch aggregated fields from the table: "themes" */
  themes_aggregate: Themes_Aggregate;
  /** fetch data from the table: "themes" using primary key columns */
  themes_by_pk?: Maybe<Themes>;
  /** fetch data from the table in a streaming manner: "themes" */
  themes_stream: Array<Themes>;
  /** fetch data from the table: "twitter_cards" */
  twitter_cards: Array<Twitter_Cards>;
  /** fetch aggregated fields from the table: "twitter_cards" */
  twitter_cards_aggregate: Twitter_Cards_Aggregate;
  /** fetch data from the table: "twitter_cards" using primary key columns */
  twitter_cards_by_pk?: Maybe<Twitter_Cards>;
  /** fetch data from the table in a streaming manner: "twitter_cards" */
  twitter_cards_stream: Array<Twitter_Cards>;
  /** fetch data from the table: "user_api_tokens" */
  user_api_tokens: Array<User_Api_Tokens>;
  /** fetch aggregated fields from the table: "user_api_tokens" */
  user_api_tokens_aggregate: User_Api_Tokens_Aggregate;
  /** fetch data from the table: "user_api_tokens" using primary key columns */
  user_api_tokens_by_pk?: Maybe<User_Api_Tokens>;
  /** fetch data from the table in a streaming manner: "user_api_tokens" */
  user_api_tokens_stream: Array<User_Api_Tokens>;
  /** fetch data from the table: "user_comments" */
  user_comments: Array<User_Comments>;
  /** fetch aggregated fields from the table: "user_comments" */
  user_comments_aggregate: User_Comments_Aggregate;
  /** fetch data from the table: "user_comments" using primary key columns */
  user_comments_by_pk?: Maybe<User_Comments>;
  /** fetch data from the table in a streaming manner: "user_comments" */
  user_comments_stream: Array<User_Comments>;
  /** fetch data from the table: "user_extras" */
  user_extras: Array<User_Extras>;
  /** fetch aggregated fields from the table: "user_extras" */
  user_extras_aggregate: User_Extras_Aggregate;
  /** fetch data from the table: "user_extras" using primary key columns */
  user_extras_by_pk?: Maybe<User_Extras>;
  /** fetch data from the table in a streaming manner: "user_extras" */
  user_extras_stream: Array<User_Extras>;
  /** fetch data from the table: "user_feature_flags" */
  user_feature_flags: Array<User_Feature_Flags>;
  /** fetch aggregated fields from the table: "user_feature_flags" */
  user_feature_flags_aggregate: User_Feature_Flags_Aggregate;
  /** fetch data from the table: "user_feature_flags" using primary key columns */
  user_feature_flags_by_pk?: Maybe<User_Feature_Flags>;
  /** fetch data from the table in a streaming manner: "user_feature_flags" */
  user_feature_flags_stream: Array<User_Feature_Flags>;
  /** An array relationship */
  user_hackathon_bounties: Array<User_Hackathon_Bounties>;
  /** An aggregate relationship */
  user_hackathon_bounties_aggregate: User_Hackathon_Bounties_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_bounty_type" */
  user_hackathon_bounties_bounty_type: Array<User_Hackathon_Bounties_Bounty_Type>;
  /** fetch aggregated fields from the table: "user_hackathon_bounties_bounty_type" */
  user_hackathon_bounties_bounty_type_aggregate: User_Hackathon_Bounties_Bounty_Type_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_bounty_type" using primary key columns */
  user_hackathon_bounties_bounty_type_by_pk?: Maybe<User_Hackathon_Bounties_Bounty_Type>;
  /** fetch data from the table in a streaming manner: "user_hackathon_bounties_bounty_type" */
  user_hackathon_bounties_bounty_type_stream: Array<User_Hackathon_Bounties_Bounty_Type>;
  /** fetch data from the table: "user_hackathon_bounties" using primary key columns */
  user_hackathon_bounties_by_pk?: Maybe<User_Hackathon_Bounties>;
  /** fetch data from the table: "user_hackathon_bounties_currency" */
  user_hackathon_bounties_currency: Array<User_Hackathon_Bounties_Currency>;
  /** fetch aggregated fields from the table: "user_hackathon_bounties_currency" */
  user_hackathon_bounties_currency_aggregate: User_Hackathon_Bounties_Currency_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_currency" using primary key columns */
  user_hackathon_bounties_currency_by_pk?: Maybe<User_Hackathon_Bounties_Currency>;
  /** fetch data from the table in a streaming manner: "user_hackathon_bounties_currency" */
  user_hackathon_bounties_currency_stream: Array<User_Hackathon_Bounties_Currency>;
  /** fetch data from the table: "user_hackathon_bounties_status" */
  user_hackathon_bounties_status: Array<User_Hackathon_Bounties_Status>;
  /** fetch aggregated fields from the table: "user_hackathon_bounties_status" */
  user_hackathon_bounties_status_aggregate: User_Hackathon_Bounties_Status_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_status" using primary key columns */
  user_hackathon_bounties_status_by_pk?: Maybe<User_Hackathon_Bounties_Status>;
  /** fetch data from the table in a streaming manner: "user_hackathon_bounties_status" */
  user_hackathon_bounties_status_stream: Array<User_Hackathon_Bounties_Status>;
  /** fetch data from the table in a streaming manner: "user_hackathon_bounties" */
  user_hackathon_bounties_stream: Array<User_Hackathon_Bounties>;
  /** fetch data from the table: "user_hackathon_bounties_type" */
  user_hackathon_bounties_type: Array<User_Hackathon_Bounties_Type>;
  /** fetch aggregated fields from the table: "user_hackathon_bounties_type" */
  user_hackathon_bounties_type_aggregate: User_Hackathon_Bounties_Type_Aggregate;
  /** fetch data from the table: "user_hackathon_bounties_type" using primary key columns */
  user_hackathon_bounties_type_by_pk?: Maybe<User_Hackathon_Bounties_Type>;
  /** fetch data from the table in a streaming manner: "user_hackathon_bounties_type" */
  user_hackathon_bounties_type_stream: Array<User_Hackathon_Bounties_Type>;
  /** An array relationship */
  user_hackathon_checklists: Array<User_Hackathon_Checklists>;
  /** An aggregate relationship */
  user_hackathon_checklists_aggregate: User_Hackathon_Checklists_Aggregate;
  /** fetch data from the table: "user_hackathon_checklists" using primary key columns */
  user_hackathon_checklists_by_pk?: Maybe<User_Hackathon_Checklists>;
  /** fetch data from the table in a streaming manner: "user_hackathon_checklists" */
  user_hackathon_checklists_stream: Array<User_Hackathon_Checklists>;
  /** An array relationship */
  user_hackathon_credentials: Array<User_Hackathon_Credentials>;
  /** An aggregate relationship */
  user_hackathon_credentials_aggregate: User_Hackathon_Credentials_Aggregate;
  /** fetch data from the table: "user_hackathon_credentials" using primary key columns */
  user_hackathon_credentials_by_pk?: Maybe<User_Hackathon_Credentials>;
  /** fetch data from the table: "user_hackathon_credentials_status" */
  user_hackathon_credentials_status: Array<User_Hackathon_Credentials_Status>;
  /** fetch aggregated fields from the table: "user_hackathon_credentials_status" */
  user_hackathon_credentials_status_aggregate: User_Hackathon_Credentials_Status_Aggregate;
  /** fetch data from the table: "user_hackathon_credentials_status" using primary key columns */
  user_hackathon_credentials_status_by_pk?: Maybe<User_Hackathon_Credentials_Status>;
  /** fetch data from the table in a streaming manner: "user_hackathon_credentials_status" */
  user_hackathon_credentials_status_stream: Array<User_Hackathon_Credentials_Status>;
  /** fetch data from the table in a streaming manner: "user_hackathon_credentials" */
  user_hackathon_credentials_stream: Array<User_Hackathon_Credentials>;
  /** fetch data from the table: "user_hackathon_extras" */
  user_hackathon_extras: Array<User_Hackathon_Extras>;
  /** fetch aggregated fields from the table: "user_hackathon_extras" */
  user_hackathon_extras_aggregate: User_Hackathon_Extras_Aggregate;
  /** fetch data from the table: "user_hackathon_extras" using primary key columns */
  user_hackathon_extras_by_pk?: Maybe<User_Hackathon_Extras>;
  /** fetch data from the table in a streaming manner: "user_hackathon_extras" */
  user_hackathon_extras_stream: Array<User_Hackathon_Extras>;
  /** fetch data from the table: "user_hackathon_feedbacks" */
  user_hackathon_feedbacks: Array<User_Hackathon_Feedbacks>;
  /** fetch aggregated fields from the table: "user_hackathon_feedbacks" */
  user_hackathon_feedbacks_aggregate: User_Hackathon_Feedbacks_Aggregate;
  /** fetch data from the table: "user_hackathon_feedbacks" using primary key columns */
  user_hackathon_feedbacks_by_pk?: Maybe<User_Hackathon_Feedbacks>;
  /** fetch data from the table in a streaming manner: "user_hackathon_feedbacks" */
  user_hackathon_feedbacks_stream: Array<User_Hackathon_Feedbacks>;
  /** An array relationship */
  user_hackathon_reminders: Array<User_Hackathon_Reminders>;
  /** An aggregate relationship */
  user_hackathon_reminders_aggregate: User_Hackathon_Reminders_Aggregate;
  /** fetch data from the table: "user_hackathon_reminders" using primary key columns */
  user_hackathon_reminders_by_pk?: Maybe<User_Hackathon_Reminders>;
  /** fetch data from the table in a streaming manner: "user_hackathon_reminders" */
  user_hackathon_reminders_stream: Array<User_Hackathon_Reminders>;
  /** fetch data from the table: "user_hackathon_schwags" */
  user_hackathon_schwags: Array<User_Hackathon_Schwags>;
  /** fetch aggregated fields from the table: "user_hackathon_schwags" */
  user_hackathon_schwags_aggregate: User_Hackathon_Schwags_Aggregate;
  /** fetch data from the table: "user_hackathon_schwags" using primary key columns */
  user_hackathon_schwags_by_pk?: Maybe<User_Hackathon_Schwags>;
  /** fetch data from the table in a streaming manner: "user_hackathon_schwags" */
  user_hackathon_schwags_stream: Array<User_Hackathon_Schwags>;
  /** fetch data from the table: "user_hackathon_staking_razorpay_payment_status" */
  user_hackathon_staking_razorpay_payment_status: Array<User_Hackathon_Staking_Razorpay_Payment_Status>;
  /** fetch aggregated fields from the table: "user_hackathon_staking_razorpay_payment_status" */
  user_hackathon_staking_razorpay_payment_status_aggregate: User_Hackathon_Staking_Razorpay_Payment_Status_Aggregate;
  /** fetch data from the table: "user_hackathon_staking_razorpay_payment_status" using primary key columns */
  user_hackathon_staking_razorpay_payment_status_by_pk?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status>;
  /** fetch data from the table in a streaming manner: "user_hackathon_staking_razorpay_payment_status" */
  user_hackathon_staking_razorpay_payment_status_stream: Array<User_Hackathon_Staking_Razorpay_Payment_Status>;
  /** fetch data from the table: "user_hackathon_staking_status" */
  user_hackathon_staking_status: Array<User_Hackathon_Staking_Status>;
  /** fetch aggregated fields from the table: "user_hackathon_staking_status" */
  user_hackathon_staking_status_aggregate: User_Hackathon_Staking_Status_Aggregate;
  /** fetch data from the table: "user_hackathon_staking_status" using primary key columns */
  user_hackathon_staking_status_by_pk?: Maybe<User_Hackathon_Staking_Status>;
  /** fetch data from the table in a streaming manner: "user_hackathon_staking_status" */
  user_hackathon_staking_status_stream: Array<User_Hackathon_Staking_Status>;
  /** fetch data from the table: "user_hackathon_stakings" */
  user_hackathon_stakings: Array<User_Hackathon_Stakings>;
  /** fetch aggregated fields from the table: "user_hackathon_stakings" */
  user_hackathon_stakings_aggregate: User_Hackathon_Stakings_Aggregate;
  /** fetch data from the table: "user_hackathon_stakings" using primary key columns */
  user_hackathon_stakings_by_pk?: Maybe<User_Hackathon_Stakings>;
  /** fetch data from the table in a streaming manner: "user_hackathon_stakings" */
  user_hackathon_stakings_stream: Array<User_Hackathon_Stakings>;
  /** An array relationship */
  user_hackathons: Array<User_Hackathons>;
  /** An aggregate relationship */
  user_hackathons_aggregate: User_Hackathons_Aggregate;
  /** fetch data from the table: "user_hackathons" using primary key columns */
  user_hackathons_by_pk?: Maybe<User_Hackathons>;
  /** fetch data from the table in a streaming manner: "user_hackathons" */
  user_hackathons_stream: Array<User_Hackathons>;
  /** fetch data from the table: "user_idea_stats" */
  user_idea_stats: Array<User_Idea_Stats>;
  /** fetch aggregated fields from the table: "user_idea_stats" */
  user_idea_stats_aggregate: User_Idea_Stats_Aggregate;
  /** fetch data from the table: "user_idea_stats" using primary key columns */
  user_idea_stats_by_pk?: Maybe<User_Idea_Stats>;
  /** fetch data from the table in a streaming manner: "user_idea_stats" */
  user_idea_stats_stream: Array<User_Idea_Stats>;
  /** fetch data from the table: "user_kyc_status" */
  user_kyc_status: Array<User_Kyc_Status>;
  /** fetch aggregated fields from the table: "user_kyc_status" */
  user_kyc_status_aggregate: User_Kyc_Status_Aggregate;
  /** fetch data from the table: "user_kyc_status" using primary key columns */
  user_kyc_status_by_pk?: Maybe<User_Kyc_Status>;
  /** fetch data from the table in a streaming manner: "user_kyc_status" */
  user_kyc_status_stream: Array<User_Kyc_Status>;
  /** fetch data from the table: "user_permissions" */
  user_permissions: Array<User_Permissions>;
  /** fetch aggregated fields from the table: "user_permissions" */
  user_permissions_aggregate: User_Permissions_Aggregate;
  /** fetch data from the table: "user_permissions" using primary key columns */
  user_permissions_by_pk?: Maybe<User_Permissions>;
  /** fetch data from the table in a streaming manner: "user_permissions" */
  user_permissions_stream: Array<User_Permissions>;
  /** fetch data from the table: "user_profile_rss_feed_platforms" */
  user_profile_rss_feed_platforms: Array<User_Profile_Rss_Feed_Platforms>;
  /** fetch aggregated fields from the table: "user_profile_rss_feed_platforms" */
  user_profile_rss_feed_platforms_aggregate: User_Profile_Rss_Feed_Platforms_Aggregate;
  /** fetch data from the table: "user_profile_rss_feed_platforms" using primary key columns */
  user_profile_rss_feed_platforms_by_pk?: Maybe<User_Profile_Rss_Feed_Platforms>;
  /** fetch data from the table in a streaming manner: "user_profile_rss_feed_platforms" */
  user_profile_rss_feed_platforms_stream: Array<User_Profile_Rss_Feed_Platforms>;
  /** fetch data from the table: "user_profile_rss_feeds" */
  user_profile_rss_feeds: Array<User_Profile_Rss_Feeds>;
  /** fetch aggregated fields from the table: "user_profile_rss_feeds" */
  user_profile_rss_feeds_aggregate: User_Profile_Rss_Feeds_Aggregate;
  /** fetch data from the table: "user_profile_rss_feeds" using primary key columns */
  user_profile_rss_feeds_by_pk?: Maybe<User_Profile_Rss_Feeds>;
  /** fetch data from the table in a streaming manner: "user_profile_rss_feeds" */
  user_profile_rss_feeds_stream: Array<User_Profile_Rss_Feeds>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table in a streaming manner: "user_profiles" */
  user_profiles_stream: Array<User_Profiles>;
  /** fetch data from the table: "user_project_meta" */
  user_project_meta: Array<User_Project_Meta>;
  /** fetch aggregated fields from the table: "user_project_meta" */
  user_project_meta_aggregate: User_Project_Meta_Aggregate;
  /** fetch data from the table: "user_project_meta" using primary key columns */
  user_project_meta_by_pk?: Maybe<User_Project_Meta>;
  /** fetch data from the table in a streaming manner: "user_project_meta" */
  user_project_meta_stream: Array<User_Project_Meta>;
  /** An array relationship */
  user_projects: Array<User_Projects>;
  /** An aggregate relationship */
  user_projects_aggregate: User_Projects_Aggregate;
  /** fetch data from the table: "user_projects" using primary key columns */
  user_projects_by_pk?: Maybe<User_Projects>;
  /** fetch data from the table in a streaming manner: "user_projects" */
  user_projects_stream: Array<User_Projects>;
  /** fetch data from the table: "user_public_profile_layout" */
  user_public_profile_layout: Array<User_Public_Profile_Layout>;
  /** fetch aggregated fields from the table: "user_public_profile_layout" */
  user_public_profile_layout_aggregate: User_Public_Profile_Layout_Aggregate;
  /** fetch data from the table: "user_public_profile_layout" using primary key columns */
  user_public_profile_layout_by_pk?: Maybe<User_Public_Profile_Layout>;
  /** fetch data from the table in a streaming manner: "user_public_profile_layout" */
  user_public_profile_layout_stream: Array<User_Public_Profile_Layout>;
  /** fetch data from the table: "user_public_profile_projects" */
  user_public_profile_projects: Array<User_Public_Profile_Projects>;
  /** fetch aggregated fields from the table: "user_public_profile_projects" */
  user_public_profile_projects_aggregate: User_Public_Profile_Projects_Aggregate;
  /** fetch data from the table: "user_public_profile_projects" using primary key columns */
  user_public_profile_projects_by_pk?: Maybe<User_Public_Profile_Projects>;
  /** fetch data from the table in a streaming manner: "user_public_profile_projects" */
  user_public_profile_projects_stream: Array<User_Public_Profile_Projects>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** fetch data from the table in a streaming manner: "user_roles" */
  user_roles_stream: Array<User_Roles>;
  /** fetch data from the table: "user_saved_searches" */
  user_saved_searches: Array<User_Saved_Searches>;
  /** fetch aggregated fields from the table: "user_saved_searches" */
  user_saved_searches_aggregate: User_Saved_Searches_Aggregate;
  /** fetch data from the table: "user_saved_searches" using primary key columns */
  user_saved_searches_by_pk?: Maybe<User_Saved_Searches>;
  /** fetch data from the table in a streaming manner: "user_saved_searches" */
  user_saved_searches_stream: Array<User_Saved_Searches>;
  /** fetch data from the table: "user_skills" */
  user_skills: Array<User_Skills>;
  /** fetch aggregated fields from the table: "user_skills" */
  user_skills_aggregate: User_Skills_Aggregate;
  /** fetch data from the table: "user_skills" using primary key columns */
  user_skills_by_pk?: Maybe<User_Skills>;
  /** fetch data from the table in a streaming manner: "user_skills" */
  user_skills_stream: Array<User_Skills>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** An array relationship */
  winners: Array<Winners>;
  /** An aggregate relationship */
  winners_aggregate: Winners_Aggregate;
  /** fetch data from the table: "winners" using primary key columns */
  winners_by_pk?: Maybe<Winners>;
  /** fetch data from the table in a streaming manner: "winners" */
  winners_stream: Array<Winners>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootArticlesArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Articles_Order_By>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Subscription_RootArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Articles_Order_By>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Subscription_RootArticles_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootArticles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Articles_Stream_Cursor_Input>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Subscription_RootCollegesArgs = {
  distinct_on?: InputMaybe<Array<Colleges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Colleges_Order_By>>;
  where?: InputMaybe<Colleges_Bool_Exp>;
};


export type Subscription_RootColleges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Colleges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Colleges_Order_By>>;
  where?: InputMaybe<Colleges_Bool_Exp>;
};


export type Subscription_RootColleges_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootColleges_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Colleges_Stream_Cursor_Input>>;
  where?: InputMaybe<Colleges_Bool_Exp>;
};


export type Subscription_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootComments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootComments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootCompanyArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompany_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Subscription_RootDiscoverArgs = {
  distinct_on?: InputMaybe<Array<Discover_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discover_Order_By>>;
  where?: InputMaybe<Discover_Bool_Exp>;
};


export type Subscription_RootDiscover_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discover_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discover_Order_By>>;
  where?: InputMaybe<Discover_Bool_Exp>;
};


export type Subscription_RootDiscover_By_PkArgs = {
  uuid: Scalars['String'];
};


export type Subscription_RootDiscover_EventsArgs = {
  distinct_on?: InputMaybe<Array<Discover_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discover_Events_Order_By>>;
  where?: InputMaybe<Discover_Events_Bool_Exp>;
};


export type Subscription_RootDiscover_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discover_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discover_Events_Order_By>>;
  where?: InputMaybe<Discover_Events_Bool_Exp>;
};


export type Subscription_RootDiscover_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDiscover_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Discover_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Discover_Events_Bool_Exp>;
};


export type Subscription_RootDiscover_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Discover_Stream_Cursor_Input>>;
  where?: InputMaybe<Discover_Bool_Exp>;
};


export type Subscription_RootEducation_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Education_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Fields_Order_By>>;
  where?: InputMaybe<Education_Fields_Bool_Exp>;
};


export type Subscription_RootEducation_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Fields_Order_By>>;
  where?: InputMaybe<Education_Fields_Bool_Exp>;
};


export type Subscription_RootEducation_Fields_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEducation_Fields_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Education_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Education_Fields_Bool_Exp>;
};


export type Subscription_RootEducationsArgs = {
  distinct_on?: InputMaybe<Array<Educations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educations_Order_By>>;
  where?: InputMaybe<Educations_Bool_Exp>;
};


export type Subscription_RootEducations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educations_Order_By>>;
  where?: InputMaybe<Educations_Bool_Exp>;
};


export type Subscription_RootEducations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEducations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Educations_Stream_Cursor_Input>>;
  where?: InputMaybe<Educations_Bool_Exp>;
};


export type Subscription_RootExperience_TypeArgs = {
  distinct_on?: InputMaybe<Array<Experience_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experience_Type_Order_By>>;
  where?: InputMaybe<Experience_Type_Bool_Exp>;
};


export type Subscription_RootExperience_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Experience_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experience_Type_Order_By>>;
  where?: InputMaybe<Experience_Type_Bool_Exp>;
};


export type Subscription_RootExperience_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootExperience_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Experience_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Experience_Type_Bool_Exp>;
};


export type Subscription_RootExperiencesArgs = {
  distinct_on?: InputMaybe<Array<Experiences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experiences_Order_By>>;
  where?: InputMaybe<Experiences_Bool_Exp>;
};


export type Subscription_RootExperiences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Experiences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experiences_Order_By>>;
  where?: InputMaybe<Experiences_Bool_Exp>;
};


export type Subscription_RootExperiences_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootExperiences_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Experiences_Stream_Cursor_Input>>;
  where?: InputMaybe<Experiences_Bool_Exp>;
};


export type Subscription_RootFeature_Flag_TypesArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flag_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flag_Types_Order_By>>;
  where?: InputMaybe<Feature_Flag_Types_Bool_Exp>;
};


export type Subscription_RootFeature_Flag_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flag_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flag_Types_Order_By>>;
  where?: InputMaybe<Feature_Flag_Types_Bool_Exp>;
};


export type Subscription_RootFeature_Flag_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFeature_Flag_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feature_Flag_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Flag_Types_Bool_Exp>;
};


export type Subscription_RootFeature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFeature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFeature_Flags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFeature_Flags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feature_Flags_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootHackathon_Bounties_StatusArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Bounties_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Bounties_Status_Order_By>>;
  where?: InputMaybe<Hackathon_Bounties_Status_Bool_Exp>;
};


export type Subscription_RootHackathon_Bounties_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Bounties_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Bounties_Status_Order_By>>;
  where?: InputMaybe<Hackathon_Bounties_Status_Bool_Exp>;
};


export type Subscription_RootHackathon_Bounties_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootHackathon_Bounties_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Bounties_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Bounties_Status_Bool_Exp>;
};


export type Subscription_RootHackathon_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Brands_Order_By>>;
  where?: InputMaybe<Hackathon_Brands_Bool_Exp>;
};


export type Subscription_RootHackathon_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Brands_Order_By>>;
  where?: InputMaybe<Hackathon_Brands_Bool_Exp>;
};


export type Subscription_RootHackathon_Brands_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Brands_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Brands_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Brands_Bool_Exp>;
};


export type Subscription_RootHackathon_ChecklistsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
};


export type Subscription_RootHackathon_Checklists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
};


export type Subscription_RootHackathon_Checklists_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Checklists_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Checklists_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Checklists_Bool_Exp>;
};


export type Subscription_RootHackathon_Credential_Eligible_EntitiesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Order_By>>;
  where?: InputMaybe<Hackathon_Credential_Eligible_Entities_Bool_Exp>;
};


export type Subscription_RootHackathon_Credential_Eligible_Entities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credential_Eligible_Entities_Order_By>>;
  where?: InputMaybe<Hackathon_Credential_Eligible_Entities_Bool_Exp>;
};


export type Subscription_RootHackathon_Credential_Eligible_Entities_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootHackathon_Credential_Eligible_Entities_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Credential_Eligible_Entities_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Credential_Eligible_Entities_Bool_Exp>;
};


export type Subscription_RootHackathon_Credential_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credential_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credential_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Credential_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Credential_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credential_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credential_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Credential_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Credential_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootHackathon_Credential_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Credential_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Credential_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<Hackathon_Credentials_Bool_Exp>;
};


export type Subscription_RootHackathon_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<Hackathon_Credentials_Bool_Exp>;
};


export type Subscription_RootHackathon_Credentials_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Credentials_ChainArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credentials_Chain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credentials_Chain_Order_By>>;
  where?: InputMaybe<Hackathon_Credentials_Chain_Bool_Exp>;
};


export type Subscription_RootHackathon_Credentials_Chain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Credentials_Chain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Credentials_Chain_Order_By>>;
  where?: InputMaybe<Hackathon_Credentials_Chain_Bool_Exp>;
};


export type Subscription_RootHackathon_Credentials_Chain_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootHackathon_Credentials_Chain_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Credentials_Chain_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Credentials_Chain_Bool_Exp>;
};


export type Subscription_RootHackathon_Credentials_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Credentials_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Credentials_Bool_Exp>;
};


export type Subscription_RootHackathon_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Email_Templates_Order_By>>;
  where?: InputMaybe<Hackathon_Email_Templates_Bool_Exp>;
};


export type Subscription_RootHackathon_Email_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Email_Templates_Order_By>>;
  where?: InputMaybe<Hackathon_Email_Templates_Bool_Exp>;
};


export type Subscription_RootHackathon_Email_Templates_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Email_Templates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Email_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Email_Templates_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Groups_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Groups_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Event_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Event_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Event_Groups_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_SpeakersArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Speakers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Speakers_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_Speakers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Speakers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Speakers_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_Speakers_By_PkArgs = {
  hackathon_event_id: Scalars['Int'];
  judge_id: Scalars['Int'];
};


export type Subscription_RootHackathon_Event_Speakers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Event_Speakers_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Event_Speakers_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_SponsorsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Sponsors_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_Sponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Sponsors_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_Sponsors_By_PkArgs = {
  event_id: Scalars['Int'];
  sponsor_id: Scalars['Int'];
};


export type Subscription_RootHackathon_Event_Sponsors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Event_Sponsors_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Event_Sponsors_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Event_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Event_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Event_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootHackathon_Event_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Event_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Event_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_EventsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Events_Order_By>>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};


export type Subscription_RootHackathon_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Events_Order_By>>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};


export type Subscription_RootHackathon_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Events_Bool_Exp>;
};


export type Subscription_RootHackathon_FaqArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Bool_Exp>;
};


export type Subscription_RootHackathon_Faq_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Bool_Exp>;
};


export type Subscription_RootHackathon_Faq_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Faq_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Faq_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Faq_Bool_Exp>;
};


export type Subscription_RootHackathon_Faq_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Faq_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Faq_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Faq_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Faq_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Faq_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootHackathon_Faq_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Faq_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Faq_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_HashtagsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Hashtags_Order_By>>;
  where?: InputMaybe<Hackathon_Hashtags_Bool_Exp>;
};


export type Subscription_RootHackathon_Hashtags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Hashtags_Order_By>>;
  where?: InputMaybe<Hackathon_Hashtags_Bool_Exp>;
};


export type Subscription_RootHackathon_Hashtags_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  hashtag_id: Scalars['Int'];
};


export type Subscription_RootHackathon_Hashtags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Hashtags_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Hashtags_Bool_Exp>;
};


export type Subscription_RootHackathon_HostsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Hosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Hosts_Order_By>>;
  where?: InputMaybe<Hackathon_Hosts_Bool_Exp>;
};


export type Subscription_RootHackathon_Hosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Hosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Hosts_Order_By>>;
  where?: InputMaybe<Hackathon_Hosts_Bool_Exp>;
};


export type Subscription_RootHackathon_Hosts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Hosts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Hosts_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Hosts_Bool_Exp>;
};


export type Subscription_RootHackathon_Note_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Note_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Note_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Note_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Note_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Note_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Note_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Note_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Note_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootHackathon_Note_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Note_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Note_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_NotesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Notes_Order_By>>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};


export type Subscription_RootHackathon_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Notes_Order_By>>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};


export type Subscription_RootHackathon_Notes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Notes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Notes_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};


export type Subscription_RootHackathon_SchwagsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<Hackathon_Schwags_Bool_Exp>;
};


export type Subscription_RootHackathon_Schwags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<Hackathon_Schwags_Bool_Exp>;
};


export type Subscription_RootHackathon_Schwags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Schwags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Schwags_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Schwags_Bool_Exp>;
};


export type Subscription_RootHackathon_Scope_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scope_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scope_Extras_Order_By>>;
  where?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
};


export type Subscription_RootHackathon_Scope_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scope_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scope_Extras_Order_By>>;
  where?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
};


export type Subscription_RootHackathon_Scope_Extras_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Scope_Extras_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Scope_Extras_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Scope_Extras_Bool_Exp>;
};


export type Subscription_RootHackathon_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scopes_Order_By>>;
  where?: InputMaybe<Hackathon_Scopes_Bool_Exp>;
};


export type Subscription_RootHackathon_Scopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Scopes_Order_By>>;
  where?: InputMaybe<Hackathon_Scopes_Bool_Exp>;
};


export type Subscription_RootHackathon_Scopes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Scopes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Scopes_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Scopes_Bool_Exp>;
};


export type Subscription_RootHackathon_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Settings_Order_By>>;
  where?: InputMaybe<Hackathon_Settings_Bool_Exp>;
};


export type Subscription_RootHackathon_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Settings_Order_By>>;
  where?: InputMaybe<Hackathon_Settings_Bool_Exp>;
};


export type Subscription_RootHackathon_Settings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Settings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Settings_Bool_Exp>;
};


export type Subscription_RootHackathon_Staking_CurrencyArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Staking_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Staking_Currency_Order_By>>;
  where?: InputMaybe<Hackathon_Staking_Currency_Bool_Exp>;
};


export type Subscription_RootHackathon_Staking_Currency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Staking_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Staking_Currency_Order_By>>;
  where?: InputMaybe<Hackathon_Staking_Currency_Bool_Exp>;
};


export type Subscription_RootHackathon_Staking_Currency_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootHackathon_Staking_Currency_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Staking_Currency_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Staking_Currency_Bool_Exp>;
};


export type Subscription_RootHackathon_Staking_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Staking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Staking_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Staking_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Staking_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Staking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Staking_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Staking_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Staking_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootHackathon_Staking_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Staking_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Staking_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_StakingsArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
};


export type Subscription_RootHackathon_Stakings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
};


export type Subscription_RootHackathon_Stakings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Stakings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Stakings_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
};


export type Subscription_RootHackathon_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Themes_Order_By>>;
  where?: InputMaybe<Hackathon_Themes_Bool_Exp>;
};


export type Subscription_RootHackathon_Themes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Themes_Order_By>>;
  where?: InputMaybe<Hackathon_Themes_Bool_Exp>;
};


export type Subscription_RootHackathon_Themes_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  theme_id: Scalars['Int'];
};


export type Subscription_RootHackathon_Themes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Themes_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Themes_Bool_Exp>;
};


export type Subscription_RootHackathon_TracksArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Tracks_Order_By>>;
  where?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
};


export type Subscription_RootHackathon_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Tracks_Order_By>>;
  where?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
};


export type Subscription_RootHackathon_Tracks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathon_Tracks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Tracks_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
};


export type Subscription_RootHackathon_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Type_Order_By>>;
  where?: InputMaybe<Hackathon_Type_Bool_Exp>;
};


export type Subscription_RootHackathon_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootHackathon_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathon_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathon_Type_Bool_Exp>;
};


export type Subscription_RootHackathonsArgs = {
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


export type Subscription_RootHackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathons_Order_By>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


export type Subscription_RootHackathons_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHackathons_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hackathons_Stream_Cursor_Input>>;
  where?: InputMaybe<Hackathons_Bool_Exp>;
};


export type Subscription_RootHashtagsArgs = {
  distinct_on?: InputMaybe<Array<Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hashtags_Order_By>>;
  where?: InputMaybe<Hashtags_Bool_Exp>;
};


export type Subscription_RootHashtags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hashtags_Order_By>>;
  where?: InputMaybe<Hashtags_Bool_Exp>;
};


export type Subscription_RootHashtags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHashtags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hashtags_Stream_Cursor_Input>>;
  where?: InputMaybe<Hashtags_Bool_Exp>;
};


export type Subscription_RootIdea_StatsArgs = {
  distinct_on?: InputMaybe<Array<Idea_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Idea_Stats_Order_By>>;
  where?: InputMaybe<Idea_Stats_Bool_Exp>;
};


export type Subscription_RootIdea_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Idea_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Idea_Stats_Order_By>>;
  where?: InputMaybe<Idea_Stats_Bool_Exp>;
};


export type Subscription_RootIdea_Stats_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootIdea_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Idea_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Idea_Stats_Bool_Exp>;
};


export type Subscription_RootIdeasArgs = {
  distinct_on?: InputMaybe<Array<Ideas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ideas_Order_By>>;
  where?: InputMaybe<Ideas_Bool_Exp>;
};


export type Subscription_RootIdeas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ideas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ideas_Order_By>>;
  where?: InputMaybe<Ideas_Bool_Exp>;
};


export type Subscription_RootIdeas_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootIdeas_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ideas_Stream_Cursor_Input>>;
  where?: InputMaybe<Ideas_Bool_Exp>;
};


export type Subscription_RootJudgesArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


export type Subscription_RootJudges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


export type Subscription_RootJudges_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootJudges_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Judges_Stream_Cursor_Input>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


export type Subscription_RootJudging_RoomsArgs = {
  distinct_on?: InputMaybe<Array<Judging_Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judging_Rooms_Order_By>>;
  where?: InputMaybe<Judging_Rooms_Bool_Exp>;
};


export type Subscription_RootJudging_Rooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Judging_Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judging_Rooms_Order_By>>;
  where?: InputMaybe<Judging_Rooms_Bool_Exp>;
};


export type Subscription_RootJudging_Rooms_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootJudging_Rooms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Judging_Rooms_Stream_Cursor_Input>>;
  where?: InputMaybe<Judging_Rooms_Bool_Exp>;
};


export type Subscription_RootMeArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootMe_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootNotification_TypesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Types_Order_By>>;
  where?: InputMaybe<Notification_Types_Bool_Exp>;
};


export type Subscription_RootNotification_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Types_Order_By>>;
  where?: InputMaybe<Notification_Types_Bool_Exp>;
};


export type Subscription_RootNotification_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootNotification_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Types_Bool_Exp>;
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootOauthArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Order_By>>;
  where?: InputMaybe<Oauth_Bool_Exp>;
};


export type Subscription_RootOauth_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Order_By>>;
  where?: InputMaybe<Oauth_Bool_Exp>;
};


export type Subscription_RootOauth_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOauth_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Providers_Order_By>>;
  where?: InputMaybe<Oauth_Providers_Bool_Exp>;
};


export type Subscription_RootOauth_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Providers_Order_By>>;
  where?: InputMaybe<Oauth_Providers_Bool_Exp>;
};


export type Subscription_RootOauth_Providers_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootOauth_Providers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Oauth_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Oauth_Providers_Bool_Exp>;
};


export type Subscription_RootOauth_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Oauth_Stream_Cursor_Input>>;
  where?: InputMaybe<Oauth_Bool_Exp>;
};


export type Subscription_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPermissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPrize_SponsorsArgs = {
  distinct_on?: InputMaybe<Array<Prize_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Sponsors_Order_By>>;
  where?: InputMaybe<Prize_Sponsors_Bool_Exp>;
};


export type Subscription_RootPrize_Sponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Sponsors_Order_By>>;
  where?: InputMaybe<Prize_Sponsors_Bool_Exp>;
};


export type Subscription_RootPrize_Sponsors_By_PkArgs = {
  prize_id: Scalars['Int'];
  sponsor_id: Scalars['Int'];
};


export type Subscription_RootPrize_Sponsors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Prize_Sponsors_Stream_Cursor_Input>>;
  where?: InputMaybe<Prize_Sponsors_Bool_Exp>;
};


export type Subscription_RootPrize_TracksArgs = {
  distinct_on?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Tracks_Order_By>>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};


export type Subscription_RootPrize_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Tracks_Order_By>>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};


export type Subscription_RootPrize_Tracks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPrize_Tracks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Prize_Tracks_Stream_Cursor_Input>>;
  where?: InputMaybe<Prize_Tracks_Bool_Exp>;
};


export type Subscription_RootPrizesArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Subscription_RootPrizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Subscription_RootPrizes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPrizes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Prizes_Stream_Cursor_Input>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Subscription_RootProfilesArgs = {
  distinct_on?: InputMaybe<Array<Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profiles_Order_By>>;
  where?: InputMaybe<Profiles_Bool_Exp>;
};


export type Subscription_RootProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profiles_Order_By>>;
  where?: InputMaybe<Profiles_Bool_Exp>;
};


export type Subscription_RootProfiles_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProfiles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Profiles_Stream_Cursor_Input>>;
  where?: InputMaybe<Profiles_Bool_Exp>;
};


export type Subscription_RootProject_CommitsArgs = {
  distinct_on?: InputMaybe<Array<Project_Commits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Commits_Order_By>>;
  where?: InputMaybe<Project_Commits_Bool_Exp>;
};


export type Subscription_RootProject_Commits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Commits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Commits_Order_By>>;
  where?: InputMaybe<Project_Commits_Bool_Exp>;
};


export type Subscription_RootProject_Commits_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Commits_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Commits_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Commits_Bool_Exp>;
};


export type Subscription_RootProject_Contribution_StickersArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Stickers_Order_By>>;
  where?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
};


export type Subscription_RootProject_Contribution_Stickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Stickers_Order_By>>;
  where?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
};


export type Subscription_RootProject_Contribution_Stickers_By_PkArgs = {
  project_contribution_id: Scalars['Int'];
  sticker_id: Scalars['Int'];
};


export type Subscription_RootProject_Contribution_Stickers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Contribution_Stickers_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Contribution_Stickers_Bool_Exp>;
};


export type Subscription_RootProject_Contribution_Tx_Network_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Order_By>>;
  where?: InputMaybe<Project_Contribution_Tx_Network_Type_Bool_Exp>;
};


export type Subscription_RootProject_Contribution_Tx_Network_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contribution_Tx_Network_Type_Order_By>>;
  where?: InputMaybe<Project_Contribution_Tx_Network_Type_Bool_Exp>;
};


export type Subscription_RootProject_Contribution_Tx_Network_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootProject_Contribution_Tx_Network_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Contribution_Tx_Network_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Contribution_Tx_Network_Type_Bool_Exp>;
};


export type Subscription_RootProject_ContributionsArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Order_By>>;
  where?: InputMaybe<Project_Contributions_Bool_Exp>;
};


export type Subscription_RootProject_Contributions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Order_By>>;
  where?: InputMaybe<Project_Contributions_Bool_Exp>;
};


export type Subscription_RootProject_Contributions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Contributions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Contributions_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Contributions_Bool_Exp>;
};


export type Subscription_RootProject_Contributions_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Type_Order_By>>;
  where?: InputMaybe<Project_Contributions_Type_Bool_Exp>;
};


export type Subscription_RootProject_Contributions_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contributions_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contributions_Type_Order_By>>;
  where?: InputMaybe<Project_Contributions_Type_Bool_Exp>;
};


export type Subscription_RootProject_Contributions_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootProject_Contributions_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Contributions_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Contributions_Type_Bool_Exp>;
};


export type Subscription_RootProject_HashtagsArgs = {
  distinct_on?: InputMaybe<Array<Project_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Hashtags_Order_By>>;
  where?: InputMaybe<Project_Hashtags_Bool_Exp>;
};


export type Subscription_RootProject_Hashtags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Hashtags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Hashtags_Order_By>>;
  where?: InputMaybe<Project_Hashtags_Bool_Exp>;
};


export type Subscription_RootProject_Hashtags_By_PkArgs = {
  hashtag_id: Scalars['Int'];
  project_id: Scalars['Int'];
};


export type Subscription_RootProject_Hashtags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Hashtags_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Hashtags_Bool_Exp>;
};


export type Subscription_RootProject_JudgesArgs = {
  distinct_on?: InputMaybe<Array<Project_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judges_Order_By>>;
  where?: InputMaybe<Project_Judges_Bool_Exp>;
};


export type Subscription_RootProject_Judges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judges_Order_By>>;
  where?: InputMaybe<Project_Judges_Bool_Exp>;
};


export type Subscription_RootProject_Judges_By_PkArgs = {
  judge_id: Scalars['Int'];
  project_id: Scalars['Int'];
};


export type Subscription_RootProject_Judges_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Judges_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Judges_Bool_Exp>;
};


export type Subscription_RootProject_Judging_Submission_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Judging_Submission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judging_Submission_Type_Order_By>>;
  where?: InputMaybe<Project_Judging_Submission_Type_Bool_Exp>;
};


export type Subscription_RootProject_Judging_Submission_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Judging_Submission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judging_Submission_Type_Order_By>>;
  where?: InputMaybe<Project_Judging_Submission_Type_Bool_Exp>;
};


export type Subscription_RootProject_Judging_Submission_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootProject_Judging_Submission_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Judging_Submission_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Judging_Submission_Type_Bool_Exp>;
};


export type Subscription_RootProject_JudgmentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judgments_Order_By>>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};


export type Subscription_RootProject_Judgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Judgments_Order_By>>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};


export type Subscription_RootProject_Judgments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Judgments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Judgments_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Judgments_Bool_Exp>;
};


export type Subscription_RootProject_Report_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Report_Type_Order_By>>;
  where?: InputMaybe<Project_Report_Type_Bool_Exp>;
};


export type Subscription_RootProject_Report_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Report_Type_Order_By>>;
  where?: InputMaybe<Project_Report_Type_Bool_Exp>;
};


export type Subscription_RootProject_Report_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootProject_Report_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Report_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Report_Type_Bool_Exp>;
};


export type Subscription_RootProject_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Project_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reports_Order_By>>;
  where?: InputMaybe<Project_Reports_Bool_Exp>;
};


export type Subscription_RootProject_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Reports_Order_By>>;
  where?: InputMaybe<Project_Reports_Bool_Exp>;
};


export type Subscription_RootProject_Reports_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Reports_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Reports_Bool_Exp>;
};


export type Subscription_RootProject_TracksArgs = {
  distinct_on?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Tracks_Order_By>>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};


export type Subscription_RootProject_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Tracks_Order_By>>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};


export type Subscription_RootProject_Tracks_By_PkArgs = {
  project_id: Scalars['Int'];
  track_id: Scalars['Int'];
};


export type Subscription_RootProject_Tracks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Tracks_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Tracks_Bool_Exp>;
};


export type Subscription_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootProjects_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProjects_FundingArgs = {
  distinct_on?: InputMaybe<Array<Projects_Funding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Funding_Order_By>>;
  where?: InputMaybe<Projects_Funding_Bool_Exp>;
};


export type Subscription_RootProjects_Funding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Funding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Funding_Order_By>>;
  where?: InputMaybe<Projects_Funding_Bool_Exp>;
};


export type Subscription_RootProjects_Funding_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProjects_Funding_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Projects_Funding_Stream_Cursor_Input>>;
  where?: InputMaybe<Projects_Funding_Bool_Exp>;
};


export type Subscription_RootProjects_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootQuadratic_VotingArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuadratic_Voting_ChainArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Chain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Chain_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Chain_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Chain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Chain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Chain_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Chain_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Chain_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootQuadratic_Voting_Chain_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quadratic_Voting_Chain_Stream_Cursor_Input>>;
  where?: InputMaybe<Quadratic_Voting_Chain_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_CurrencyArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Currency_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Currency_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Currency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Currency_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Currency_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Currency_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootQuadratic_Voting_Currency_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quadratic_Voting_Currency_Stream_Cursor_Input>>;
  where?: InputMaybe<Quadratic_Voting_Currency_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Projects_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Projects_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Projects_By_PkArgs = {
  project_id: Scalars['Int'];
  quadratic_voting_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootQuadratic_Voting_Projects_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quadratic_Voting_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Quadratic_Voting_Projects_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Request_AccessArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Request_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Request_Access_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Request_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Request_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Request_Access_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Request_Access_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuadratic_Voting_Request_Access_StatusArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Status_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Request_Access_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quadratic_Voting_Request_Access_Status_Order_By>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Status_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Request_Access_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootQuadratic_Voting_Request_Access_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quadratic_Voting_Request_Access_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Status_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_Request_Access_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quadratic_Voting_Request_Access_Stream_Cursor_Input>>;
  where?: InputMaybe<Quadratic_Voting_Request_Access_Bool_Exp>;
};


export type Subscription_RootQuadratic_Voting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quadratic_Voting_Stream_Cursor_Input>>;
  where?: InputMaybe<Quadratic_Voting_Bool_Exp>;
};


export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRoles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoom_JudgesArgs = {
  distinct_on?: InputMaybe<Array<Room_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Judges_Order_By>>;
  where?: InputMaybe<Room_Judges_Bool_Exp>;
};


export type Subscription_RootRoom_Judges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Judges_Order_By>>;
  where?: InputMaybe<Room_Judges_Bool_Exp>;
};


export type Subscription_RootRoom_Judges_By_PkArgs = {
  judge_id: Scalars['Int'];
  room_id: Scalars['Int'];
};


export type Subscription_RootRoom_Judges_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Room_Judges_Stream_Cursor_Input>>;
  where?: InputMaybe<Room_Judges_Bool_Exp>;
};


export type Subscription_RootSchwag_TracksArgs = {
  distinct_on?: InputMaybe<Array<Schwag_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwag_Tracks_Order_By>>;
  where?: InputMaybe<Schwag_Tracks_Bool_Exp>;
};


export type Subscription_RootSchwag_Tracks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schwag_Tracks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwag_Tracks_Order_By>>;
  where?: InputMaybe<Schwag_Tracks_Bool_Exp>;
};


export type Subscription_RootSchwag_Tracks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSchwag_Tracks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Schwag_Tracks_Stream_Cursor_Input>>;
  where?: InputMaybe<Schwag_Tracks_Bool_Exp>;
};


export type Subscription_RootSchwags_Allowed_Org_Winner_CountArgs = {
  distinct_on?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Order_By>>;
  where?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
};


export type Subscription_RootSchwags_Allowed_Org_Winner_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Order_By>>;
  where?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
};


export type Subscription_RootSchwags_Allowed_Org_Winner_Count_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Schwags_Allowed_Org_Winner_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
};


export type Subscription_RootSchwags_Get_Allowed_Org_Winner_CountArgs = {
  args: Schwags_Get_Allowed_Org_Winner_Count_Args;
  distinct_on?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Order_By>>;
  where?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
};


export type Subscription_RootSchwags_Get_Allowed_Org_Winner_Count_AggregateArgs = {
  args: Schwags_Get_Allowed_Org_Winner_Count_Args;
  distinct_on?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schwags_Allowed_Org_Winner_Count_Order_By>>;
  where?: InputMaybe<Schwags_Allowed_Org_Winner_Count_Bool_Exp>;
};


export type Subscription_RootShop_CountriesArgs = {
  distinct_on?: InputMaybe<Array<Shop_Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Countries_Order_By>>;
  where?: InputMaybe<Shop_Countries_Bool_Exp>;
};


export type Subscription_RootShop_Countries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Countries_Order_By>>;
  where?: InputMaybe<Shop_Countries_Bool_Exp>;
};


export type Subscription_RootShop_Countries_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShop_Countries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Countries_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Countries_Bool_Exp>;
};


export type Subscription_RootShop_Coupon_Discount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupon_Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupon_Discount_Type_Order_By>>;
  where?: InputMaybe<Shop_Coupon_Discount_Type_Bool_Exp>;
};


export type Subscription_RootShop_Coupon_Discount_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupon_Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupon_Discount_Type_Order_By>>;
  where?: InputMaybe<Shop_Coupon_Discount_Type_Bool_Exp>;
};


export type Subscription_RootShop_Coupon_Discount_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootShop_Coupon_Discount_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Coupon_Discount_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Coupon_Discount_Type_Bool_Exp>;
};


export type Subscription_RootShop_Coupon_TypeArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupon_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupon_Type_Order_By>>;
  where?: InputMaybe<Shop_Coupon_Type_Bool_Exp>;
};


export type Subscription_RootShop_Coupon_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupon_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupon_Type_Order_By>>;
  where?: InputMaybe<Shop_Coupon_Type_Bool_Exp>;
};


export type Subscription_RootShop_Coupon_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootShop_Coupon_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Coupon_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Coupon_Type_Bool_Exp>;
};


export type Subscription_RootShop_CouponsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupons_Order_By>>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};


export type Subscription_RootShop_Coupons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Coupons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupons_Order_By>>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};


export type Subscription_RootShop_Coupons_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShop_Coupons_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Coupons_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};


export type Subscription_RootShop_Get_CouponArgs = {
  args: Shop_Get_Coupon_Args;
  distinct_on?: InputMaybe<Array<Shop_Coupons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupons_Order_By>>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};


export type Subscription_RootShop_Get_Coupon_AggregateArgs = {
  args: Shop_Get_Coupon_Args;
  distinct_on?: InputMaybe<Array<Shop_Coupons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Coupons_Order_By>>;
  where?: InputMaybe<Shop_Coupons_Bool_Exp>;
};


export type Subscription_RootShop_HsnArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Bool_Exp>;
};


export type Subscription_RootShop_Hsn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Bool_Exp>;
};


export type Subscription_RootShop_Hsn_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShop_Hsn_MappingsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Mappings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Mappings_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
};


export type Subscription_RootShop_Hsn_Mappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Hsn_Mappings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Hsn_Mappings_Order_By>>;
  where?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
};


export type Subscription_RootShop_Hsn_Mappings_By_PkArgs = {
  country_id: Scalars['Int'];
  hsn_id: Scalars['Int'];
  state_id: Scalars['Int'];
};


export type Subscription_RootShop_Hsn_Mappings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Hsn_Mappings_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Hsn_Mappings_Bool_Exp>;
};


export type Subscription_RootShop_Hsn_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Hsn_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Hsn_Bool_Exp>;
};


export type Subscription_RootShop_Inventory_SkusArgs = {
  distinct_on?: InputMaybe<Array<Shop_Inventory_Skus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Inventory_Skus_Order_By>>;
  where?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
};


export type Subscription_RootShop_Inventory_Skus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Inventory_Skus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Inventory_Skus_Order_By>>;
  where?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
};


export type Subscription_RootShop_Inventory_Skus_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShop_Inventory_Skus_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Inventory_Skus_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Inventory_Skus_Bool_Exp>;
};


export type Subscription_RootShop_Order_Payment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Payment_Status_Order_By>>;
  where?: InputMaybe<Shop_Order_Payment_Status_Bool_Exp>;
};


export type Subscription_RootShop_Order_Payment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Payment_Status_Order_By>>;
  where?: InputMaybe<Shop_Order_Payment_Status_Bool_Exp>;
};


export type Subscription_RootShop_Order_Payment_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootShop_Order_Payment_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Order_Payment_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Order_Payment_Status_Bool_Exp>;
};


export type Subscription_RootShop_Order_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Products_Order_By>>;
  where?: InputMaybe<Shop_Order_Products_Bool_Exp>;
};


export type Subscription_RootShop_Order_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Order_Products_Order_By>>;
  where?: InputMaybe<Shop_Order_Products_Bool_Exp>;
};


export type Subscription_RootShop_Order_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShop_Order_Products_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Order_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Order_Products_Bool_Exp>;
};


export type Subscription_RootShop_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Shop_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Orders_Order_By>>;
  where?: InputMaybe<Shop_Orders_Bool_Exp>;
};


export type Subscription_RootShop_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Orders_Order_By>>;
  where?: InputMaybe<Shop_Orders_Bool_Exp>;
};


export type Subscription_RootShop_Orders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShop_Orders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Orders_Bool_Exp>;
};


export type Subscription_RootShop_Product_TypeArgs = {
  distinct_on?: InputMaybe<Array<Shop_Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Product_Type_Order_By>>;
  where?: InputMaybe<Shop_Product_Type_Bool_Exp>;
};


export type Subscription_RootShop_Product_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Product_Type_Order_By>>;
  where?: InputMaybe<Shop_Product_Type_Bool_Exp>;
};


export type Subscription_RootShop_Product_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootShop_Product_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Product_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Product_Type_Bool_Exp>;
};


export type Subscription_RootShop_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Shop_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Products_Order_By>>;
  where?: InputMaybe<Shop_Products_Bool_Exp>;
};


export type Subscription_RootShop_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Products_Order_By>>;
  where?: InputMaybe<Shop_Products_Bool_Exp>;
};


export type Subscription_RootShop_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShop_Products_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Products_Bool_Exp>;
};


export type Subscription_RootShop_Shipping_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Shop_Shipping_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Shipping_Addresses_Order_By>>;
  where?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
};


export type Subscription_RootShop_Shipping_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Shipping_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Shipping_Addresses_Order_By>>;
  where?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
};


export type Subscription_RootShop_Shipping_Addresses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShop_Shipping_Addresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_Shipping_Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
};


export type Subscription_RootShop_StatesArgs = {
  distinct_on?: InputMaybe<Array<Shop_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_States_Order_By>>;
  where?: InputMaybe<Shop_States_Bool_Exp>;
};


export type Subscription_RootShop_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_States_Order_By>>;
  where?: InputMaybe<Shop_States_Bool_Exp>;
};


export type Subscription_RootShop_States_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShop_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shop_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Shop_States_Bool_Exp>;
};


export type Subscription_RootSkillsArgs = {
  distinct_on?: InputMaybe<Array<Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Skills_Order_By>>;
  where?: InputMaybe<Skills_Bool_Exp>;
};


export type Subscription_RootSkills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Skills_Order_By>>;
  where?: InputMaybe<Skills_Bool_Exp>;
};


export type Subscription_RootSkills_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSkills_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Skills_Stream_Cursor_Input>>;
  where?: InputMaybe<Skills_Bool_Exp>;
};


export type Subscription_RootSpeaker_Slot_StatusArgs = {
  distinct_on?: InputMaybe<Array<Speaker_Slot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Speaker_Slot_Status_Order_By>>;
  where?: InputMaybe<Speaker_Slot_Status_Bool_Exp>;
};


export type Subscription_RootSpeaker_Slot_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Speaker_Slot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Speaker_Slot_Status_Order_By>>;
  where?: InputMaybe<Speaker_Slot_Status_Bool_Exp>;
};


export type Subscription_RootSpeaker_Slot_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSpeaker_Slot_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Speaker_Slot_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Speaker_Slot_Status_Bool_Exp>;
};


export type Subscription_RootSponsor_JudgmentsArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


export type Subscription_RootSponsor_Judgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Judgments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Judgments_Order_By>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


export type Subscription_RootSponsor_Judgments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSponsor_Judgments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sponsor_Judgments_Stream_Cursor_Input>>;
  where?: InputMaybe<Sponsor_Judgments_Bool_Exp>;
};


export type Subscription_RootSponsor_TiersArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Tiers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Tiers_Order_By>>;
  where?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
};


export type Subscription_RootSponsor_Tiers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Tiers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsor_Tiers_Order_By>>;
  where?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
};


export type Subscription_RootSponsor_Tiers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSponsor_Tiers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sponsor_Tiers_Stream_Cursor_Input>>;
  where?: InputMaybe<Sponsor_Tiers_Bool_Exp>;
};


export type Subscription_RootSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Subscription_RootSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Subscription_RootSponsors_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSponsors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sponsors_Stream_Cursor_Input>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Subscription_RootStickersArgs = {
  distinct_on?: InputMaybe<Array<Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stickers_Order_By>>;
  where?: InputMaybe<Stickers_Bool_Exp>;
};


export type Subscription_RootStickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stickers_Order_By>>;
  where?: InputMaybe<Stickers_Bool_Exp>;
};


export type Subscription_RootStickers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStickers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stickers_Stream_Cursor_Input>>;
  where?: InputMaybe<Stickers_Bool_Exp>;
};


export type Subscription_RootSumsub_ApplicantsArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
};


export type Subscription_RootSumsub_Applicants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
};


export type Subscription_RootSumsub_Applicants_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSumsub_Applicants_Review_StatusArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Review_Status_Bool_Exp>;
};


export type Subscription_RootSumsub_Applicants_Review_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Review_Status_Bool_Exp>;
};


export type Subscription_RootSumsub_Applicants_Review_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSumsub_Applicants_Review_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sumsub_Applicants_Review_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Sumsub_Applicants_Review_Status_Bool_Exp>;
};


export type Subscription_RootSumsub_Applicants_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sumsub_Applicants_Stream_Cursor_Input>>;
  where?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
};


export type Subscription_RootSynaps_Kyc_Session_StatusArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Session_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Session_Status_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Session_Status_Bool_Exp>;
};


export type Subscription_RootSynaps_Kyc_Session_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Session_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Session_Status_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Session_Status_Bool_Exp>;
};


export type Subscription_RootSynaps_Kyc_Session_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSynaps_Kyc_Session_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Synaps_Kyc_Session_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Synaps_Kyc_Session_Status_Bool_Exp>;
};


export type Subscription_RootSynaps_Kyc_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Sessions_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
};


export type Subscription_RootSynaps_Kyc_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Sessions_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
};


export type Subscription_RootSynaps_Kyc_Sessions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSynaps_Kyc_Sessions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Synaps_Kyc_Sessions_Stream_Cursor_Input>>;
  where?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
};


export type Subscription_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTeams_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootThemesArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Subscription_RootThemes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Subscription_RootThemes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootThemes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Themes_Stream_Cursor_Input>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Subscription_RootTwitter_CardsArgs = {
  distinct_on?: InputMaybe<Array<Twitter_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Twitter_Cards_Order_By>>;
  where?: InputMaybe<Twitter_Cards_Bool_Exp>;
};


export type Subscription_RootTwitter_Cards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Twitter_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Twitter_Cards_Order_By>>;
  where?: InputMaybe<Twitter_Cards_Bool_Exp>;
};


export type Subscription_RootTwitter_Cards_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTwitter_Cards_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Twitter_Cards_Stream_Cursor_Input>>;
  where?: InputMaybe<Twitter_Cards_Bool_Exp>;
};


export type Subscription_RootUser_Api_TokensArgs = {
  distinct_on?: InputMaybe<Array<User_Api_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Api_Tokens_Order_By>>;
  where?: InputMaybe<User_Api_Tokens_Bool_Exp>;
};


export type Subscription_RootUser_Api_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Api_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Api_Tokens_Order_By>>;
  where?: InputMaybe<User_Api_Tokens_Bool_Exp>;
};


export type Subscription_RootUser_Api_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Api_Tokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Api_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Api_Tokens_Bool_Exp>;
};


export type Subscription_RootUser_CommentsArgs = {
  distinct_on?: InputMaybe<Array<User_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Comments_Order_By>>;
  where?: InputMaybe<User_Comments_Bool_Exp>;
};


export type Subscription_RootUser_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Comments_Order_By>>;
  where?: InputMaybe<User_Comments_Bool_Exp>;
};


export type Subscription_RootUser_Comments_By_PkArgs = {
  comment_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Comments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Comments_Bool_Exp>;
};


export type Subscription_RootUser_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<User_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Extras_Order_By>>;
  where?: InputMaybe<User_Extras_Bool_Exp>;
};


export type Subscription_RootUser_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Extras_Order_By>>;
  where?: InputMaybe<User_Extras_Bool_Exp>;
};


export type Subscription_RootUser_Extras_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Extras_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Extras_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Extras_Bool_Exp>;
};


export type Subscription_RootUser_Feature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<User_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Feature_Flags_Order_By>>;
  where?: InputMaybe<User_Feature_Flags_Bool_Exp>;
};


export type Subscription_RootUser_Feature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Feature_Flags_Order_By>>;
  where?: InputMaybe<User_Feature_Flags_Bool_Exp>;
};


export type Subscription_RootUser_Feature_Flags_By_PkArgs = {
  feature_flag_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Feature_Flags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Feature_Flags_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Feature_Flags_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_BountiesArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_Bounty_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_Bounty_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_Bounty_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Hackathon_Bounties_Bounty_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Bounties_Bounty_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Hackathon_Bounties_CurrencyArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Currency_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_Currency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Currency_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_Currency_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Hackathon_Bounties_Currency_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Bounties_Currency_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Bounties_Currency_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Hackathon_Bounties_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Bounties_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Bounties_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Bounties_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Type_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Type_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Type_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Type_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Bounties_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Hackathon_Bounties_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Bounties_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Bounties_Type_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_ChecklistsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Checklists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Checklists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Checklists_Order_By>>;
  where?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Checklists_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Hackathon_Checklists_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Checklists_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Credentials_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Hackathon_Credentials_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Credentials_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Credentials_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Hackathon_Credentials_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Credentials_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Credentials_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Credentials_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Credentials_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Extras_Order_By>>;
  where?: InputMaybe<User_Hackathon_Extras_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Extras_Order_By>>;
  where?: InputMaybe<User_Hackathon_Extras_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Extras_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Hackathon_Extras_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Extras_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Extras_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_FeedbacksArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Feedbacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Feedbacks_By_PkArgs = {
  feedback_question_id: Scalars['Int'];
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Hackathon_Feedbacks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Feedbacks_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_RemindersArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Reminders_Order_By>>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Reminders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Reminders_Order_By>>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Reminders_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Hackathon_Reminders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Reminders_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_SchwagsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Schwags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Schwags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Hackathon_Schwags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Schwags_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Staking_Razorpay_Payment_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Staking_Razorpay_Payment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Staking_Razorpay_Payment_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Hackathon_Staking_Razorpay_Payment_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Staking_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Staking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Staking_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Staking_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Staking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Staking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Staking_Status_Order_By>>;
  where?: InputMaybe<User_Hackathon_Staking_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Staking_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Hackathon_Staking_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Staking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Staking_Status_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_StakingsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<User_Hackathon_Stakings_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Stakings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Stakings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Stakings_Order_By>>;
  where?: InputMaybe<User_Hackathon_Stakings_Bool_Exp>;
};


export type Subscription_RootUser_Hackathon_Stakings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Hackathon_Stakings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathon_Stakings_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathon_Stakings_Bool_Exp>;
};


export type Subscription_RootUser_HackathonsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


export type Subscription_RootUser_Hackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


export type Subscription_RootUser_Hackathons_By_PkArgs = {
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Hackathons_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Hackathons_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


export type Subscription_RootUser_Idea_StatsArgs = {
  distinct_on?: InputMaybe<Array<User_Idea_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Idea_Stats_Order_By>>;
  where?: InputMaybe<User_Idea_Stats_Bool_Exp>;
};


export type Subscription_RootUser_Idea_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Idea_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Idea_Stats_Order_By>>;
  where?: InputMaybe<User_Idea_Stats_Bool_Exp>;
};


export type Subscription_RootUser_Idea_Stats_By_PkArgs = {
  idea_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Idea_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Idea_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Idea_Stats_Bool_Exp>;
};


export type Subscription_RootUser_Kyc_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Kyc_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Kyc_Status_Order_By>>;
  where?: InputMaybe<User_Kyc_Status_Bool_Exp>;
};


export type Subscription_RootUser_Kyc_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Kyc_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Kyc_Status_Order_By>>;
  where?: InputMaybe<User_Kyc_Status_Bool_Exp>;
};


export type Subscription_RootUser_Kyc_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Kyc_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Kyc_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Kyc_Status_Bool_Exp>;
};


export type Subscription_RootUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Permissions_By_PkArgs = {
  permission_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Profile_Rss_Feed_PlatformsArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feed_Platforms_Bool_Exp>;
};


export type Subscription_RootUser_Profile_Rss_Feed_Platforms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feed_Platforms_Bool_Exp>;
};


export type Subscription_RootUser_Profile_Rss_Feed_Platforms_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Profile_Rss_Feed_Platforms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Profile_Rss_Feed_Platforms_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profile_Rss_Feed_Platforms_Bool_Exp>;
};


export type Subscription_RootUser_Profile_Rss_FeedsArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feeds_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
};


export type Subscription_RootUser_Profile_Rss_Feeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feeds_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
};


export type Subscription_RootUser_Profile_Rss_Feeds_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Profile_Rss_Feeds_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Profile_Rss_Feeds_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
};


export type Subscription_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_Profiles_By_PkArgs = {
  profile_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Profiles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Profiles_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_Project_MetaArgs = {
  distinct_on?: InputMaybe<Array<User_Project_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Project_Meta_Order_By>>;
  where?: InputMaybe<User_Project_Meta_Bool_Exp>;
};


export type Subscription_RootUser_Project_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Project_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Project_Meta_Order_By>>;
  where?: InputMaybe<User_Project_Meta_Bool_Exp>;
};


export type Subscription_RootUser_Project_Meta_By_PkArgs = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Project_Meta_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Project_Meta_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Project_Meta_Bool_Exp>;
};


export type Subscription_RootUser_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<User_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Projects_Order_By>>;
  where?: InputMaybe<User_Projects_Bool_Exp>;
};


export type Subscription_RootUser_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Projects_Order_By>>;
  where?: InputMaybe<User_Projects_Bool_Exp>;
};


export type Subscription_RootUser_Projects_By_PkArgs = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Projects_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Projects_Bool_Exp>;
};


export type Subscription_RootUser_Public_Profile_LayoutArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Layout_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
};


export type Subscription_RootUser_Public_Profile_Layout_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Layout_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
};


export type Subscription_RootUser_Public_Profile_Layout_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Public_Profile_Layout_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Public_Profile_Layout_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
};


export type Subscription_RootUser_Public_Profile_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Projects_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
};


export type Subscription_RootUser_Public_Profile_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Projects_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
};


export type Subscription_RootUser_Public_Profile_Projects_By_PkArgs = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Public_Profile_Projects_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Public_Profile_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
};


export type Subscription_RootUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Roles_By_PkArgs = {
  role_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Roles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Saved_SearchesArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Saved_Searches_Order_By>>;
  where?: InputMaybe<User_Saved_Searches_Bool_Exp>;
};


export type Subscription_RootUser_Saved_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Saved_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Saved_Searches_Order_By>>;
  where?: InputMaybe<User_Saved_Searches_Bool_Exp>;
};


export type Subscription_RootUser_Saved_Searches_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Saved_Searches_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Saved_Searches_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Saved_Searches_Bool_Exp>;
};


export type Subscription_RootUser_SkillsArgs = {
  distinct_on?: InputMaybe<Array<User_Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Skills_Order_By>>;
  where?: InputMaybe<User_Skills_Bool_Exp>;
};


export type Subscription_RootUser_Skills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Skills_Order_By>>;
  where?: InputMaybe<User_Skills_Bool_Exp>;
};


export type Subscription_RootUser_Skills_By_PkArgs = {
  skill_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Skills_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Skills_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Skills_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootWinnersArgs = {
  distinct_on?: InputMaybe<Array<Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Winners_Order_By>>;
  where?: InputMaybe<Winners_Bool_Exp>;
};


export type Subscription_RootWinners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Winners_Order_By>>;
  where?: InputMaybe<Winners_Bool_Exp>;
};


export type Subscription_RootWinners_By_PkArgs = {
  prize_id: Scalars['Int'];
  project_id: Scalars['Int'];
};


export type Subscription_RootWinners_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Winners_Stream_Cursor_Input>>;
  where?: InputMaybe<Winners_Bool_Exp>;
};

/** columns and relationships of "sumsub_applicants" */
export type Sumsub_Applicants = {
  __typename?: 'sumsub_applicants';
  applicant_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  inspection_id: Scalars['String'];
  review_details?: Maybe<Scalars['jsonb']>;
  review_status: Sumsub_Applicants_Review_Status_Enum;
  review_steps_details?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
};


/** columns and relationships of "sumsub_applicants" */
export type Sumsub_ApplicantsReview_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sumsub_applicants" */
export type Sumsub_ApplicantsReview_Steps_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sumsub_applicants" */
export type Sumsub_Applicants_Aggregate = {
  __typename?: 'sumsub_applicants_aggregate';
  aggregate?: Maybe<Sumsub_Applicants_Aggregate_Fields>;
  nodes: Array<Sumsub_Applicants>;
};

export type Sumsub_Applicants_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sumsub_Applicants_Aggregate_Bool_Exp_Count>;
};

export type Sumsub_Applicants_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sumsub_Applicants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sumsub_applicants" */
export type Sumsub_Applicants_Aggregate_Fields = {
  __typename?: 'sumsub_applicants_aggregate_fields';
  avg?: Maybe<Sumsub_Applicants_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sumsub_Applicants_Max_Fields>;
  min?: Maybe<Sumsub_Applicants_Min_Fields>;
  stddev?: Maybe<Sumsub_Applicants_Stddev_Fields>;
  stddev_pop?: Maybe<Sumsub_Applicants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sumsub_Applicants_Stddev_Samp_Fields>;
  sum?: Maybe<Sumsub_Applicants_Sum_Fields>;
  var_pop?: Maybe<Sumsub_Applicants_Var_Pop_Fields>;
  var_samp?: Maybe<Sumsub_Applicants_Var_Samp_Fields>;
  variance?: Maybe<Sumsub_Applicants_Variance_Fields>;
};


/** aggregate fields of "sumsub_applicants" */
export type Sumsub_Applicants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sumsub_Applicants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sumsub_applicants" */
export type Sumsub_Applicants_Aggregate_Order_By = {
  avg?: InputMaybe<Sumsub_Applicants_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sumsub_Applicants_Max_Order_By>;
  min?: InputMaybe<Sumsub_Applicants_Min_Order_By>;
  stddev?: InputMaybe<Sumsub_Applicants_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sumsub_Applicants_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sumsub_Applicants_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sumsub_Applicants_Sum_Order_By>;
  var_pop?: InputMaybe<Sumsub_Applicants_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sumsub_Applicants_Var_Samp_Order_By>;
  variance?: InputMaybe<Sumsub_Applicants_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sumsub_Applicants_Append_Input = {
  review_details?: InputMaybe<Scalars['jsonb']>;
  review_steps_details?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "sumsub_applicants" */
export type Sumsub_Applicants_Arr_Rel_Insert_Input = {
  data: Array<Sumsub_Applicants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sumsub_Applicants_On_Conflict>;
};

/** aggregate avg on columns */
export type Sumsub_Applicants_Avg_Fields = {
  __typename?: 'sumsub_applicants_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sumsub_applicants". All fields are combined with a logical 'AND'. */
export type Sumsub_Applicants_Bool_Exp = {
  _and?: InputMaybe<Array<Sumsub_Applicants_Bool_Exp>>;
  _not?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
  _or?: InputMaybe<Array<Sumsub_Applicants_Bool_Exp>>;
  applicant_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  inspection_id?: InputMaybe<String_Comparison_Exp>;
  review_details?: InputMaybe<Jsonb_Comparison_Exp>;
  review_status?: InputMaybe<Sumsub_Applicants_Review_Status_Enum_Comparison_Exp>;
  review_steps_details?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "sumsub_applicants" */
export enum Sumsub_Applicants_Constraint {
  /** unique or primary key constraint on columns "applicant_id" */
  SumsubApplicantsApplicantIdKey = 'sumsub_applicants_applicant_id_key',
  /** unique or primary key constraint on columns "id" */
  SumsubApplicantsPkey = 'sumsub_applicants_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sumsub_Applicants_Delete_At_Path_Input = {
  review_details?: InputMaybe<Array<Scalars['String']>>;
  review_steps_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sumsub_Applicants_Delete_Elem_Input = {
  review_details?: InputMaybe<Scalars['Int']>;
  review_steps_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sumsub_Applicants_Delete_Key_Input = {
  review_details?: InputMaybe<Scalars['String']>;
  review_steps_details?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sumsub_applicants" */
export type Sumsub_Applicants_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sumsub_applicants" */
export type Sumsub_Applicants_Insert_Input = {
  applicant_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  inspection_id?: InputMaybe<Scalars['String']>;
  review_details?: InputMaybe<Scalars['jsonb']>;
  review_status?: InputMaybe<Sumsub_Applicants_Review_Status_Enum>;
  review_steps_details?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Sumsub_Applicants_Max_Fields = {
  __typename?: 'sumsub_applicants_max_fields';
  applicant_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  inspection_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Max_Order_By = {
  applicant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sumsub_Applicants_Min_Fields = {
  __typename?: 'sumsub_applicants_min_fields';
  applicant_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  inspection_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Min_Order_By = {
  applicant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sumsub_applicants" */
export type Sumsub_Applicants_Mutation_Response = {
  __typename?: 'sumsub_applicants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sumsub_Applicants>;
};

/** on_conflict condition type for table "sumsub_applicants" */
export type Sumsub_Applicants_On_Conflict = {
  constraint: Sumsub_Applicants_Constraint;
  update_columns?: Array<Sumsub_Applicants_Update_Column>;
  where?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
};

/** Ordering options when selecting data from "sumsub_applicants". */
export type Sumsub_Applicants_Order_By = {
  applicant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  review_details?: InputMaybe<Order_By>;
  review_status?: InputMaybe<Order_By>;
  review_steps_details?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sumsub_applicants */
export type Sumsub_Applicants_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sumsub_Applicants_Prepend_Input = {
  review_details?: InputMaybe<Scalars['jsonb']>;
  review_steps_details?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "sumsub_applicants_review_status" */
export type Sumsub_Applicants_Review_Status = {
  __typename?: 'sumsub_applicants_review_status';
  value: Scalars['String'];
};

/** aggregated selection of "sumsub_applicants_review_status" */
export type Sumsub_Applicants_Review_Status_Aggregate = {
  __typename?: 'sumsub_applicants_review_status_aggregate';
  aggregate?: Maybe<Sumsub_Applicants_Review_Status_Aggregate_Fields>;
  nodes: Array<Sumsub_Applicants_Review_Status>;
};

/** aggregate fields of "sumsub_applicants_review_status" */
export type Sumsub_Applicants_Review_Status_Aggregate_Fields = {
  __typename?: 'sumsub_applicants_review_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sumsub_Applicants_Review_Status_Max_Fields>;
  min?: Maybe<Sumsub_Applicants_Review_Status_Min_Fields>;
};


/** aggregate fields of "sumsub_applicants_review_status" */
export type Sumsub_Applicants_Review_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "sumsub_applicants_review_status". All fields are combined with a logical 'AND'. */
export type Sumsub_Applicants_Review_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Bool_Exp>>;
  _not?: InputMaybe<Sumsub_Applicants_Review_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sumsub_applicants_review_status" */
export enum Sumsub_Applicants_Review_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  SumsubApplicantsReviewStatusPkey = 'sumsub_applicants_review_status_pkey'
}

export enum Sumsub_Applicants_Review_Status_Enum {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Init = 'INIT',
  OnHold = 'ON_HOLD',
  Pending = 'PENDING',
  PreChecked = 'PRE_CHECKED',
  Queued = 'QUEUED'
}

/** Boolean expression to compare columns of type "sumsub_applicants_review_status_enum". All fields are combined with logical 'AND'. */
export type Sumsub_Applicants_Review_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Sumsub_Applicants_Review_Status_Enum>;
  _in?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Sumsub_Applicants_Review_Status_Enum>;
  _nin?: InputMaybe<Array<Sumsub_Applicants_Review_Status_Enum>>;
};

/** input type for inserting data into table "sumsub_applicants_review_status" */
export type Sumsub_Applicants_Review_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Sumsub_Applicants_Review_Status_Max_Fields = {
  __typename?: 'sumsub_applicants_review_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Sumsub_Applicants_Review_Status_Min_Fields = {
  __typename?: 'sumsub_applicants_review_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "sumsub_applicants_review_status" */
export type Sumsub_Applicants_Review_Status_Mutation_Response = {
  __typename?: 'sumsub_applicants_review_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sumsub_Applicants_Review_Status>;
};

/** on_conflict condition type for table "sumsub_applicants_review_status" */
export type Sumsub_Applicants_Review_Status_On_Conflict = {
  constraint: Sumsub_Applicants_Review_Status_Constraint;
  update_columns?: Array<Sumsub_Applicants_Review_Status_Update_Column>;
  where?: InputMaybe<Sumsub_Applicants_Review_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "sumsub_applicants_review_status". */
export type Sumsub_Applicants_Review_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sumsub_applicants_review_status */
export type Sumsub_Applicants_Review_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "sumsub_applicants_review_status" */
export enum Sumsub_Applicants_Review_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "sumsub_applicants_review_status" */
export type Sumsub_Applicants_Review_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "sumsub_applicants_review_status" */
export type Sumsub_Applicants_Review_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sumsub_Applicants_Review_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sumsub_Applicants_Review_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "sumsub_applicants_review_status" */
export enum Sumsub_Applicants_Review_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Sumsub_Applicants_Review_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sumsub_Applicants_Review_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sumsub_Applicants_Review_Status_Bool_Exp;
};

/** select columns of table "sumsub_applicants" */
export enum Sumsub_Applicants_Select_Column {
  /** column name */
  ApplicantId = 'applicant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InspectionId = 'inspection_id',
  /** column name */
  ReviewDetails = 'review_details',
  /** column name */
  ReviewStatus = 'review_status',
  /** column name */
  ReviewStepsDetails = 'review_steps_details',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "sumsub_applicants" */
export type Sumsub_Applicants_Set_Input = {
  applicant_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  inspection_id?: InputMaybe<Scalars['String']>;
  review_details?: InputMaybe<Scalars['jsonb']>;
  review_status?: InputMaybe<Sumsub_Applicants_Review_Status_Enum>;
  review_steps_details?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Sumsub_Applicants_Stddev_Fields = {
  __typename?: 'sumsub_applicants_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sumsub_Applicants_Stddev_Pop_Fields = {
  __typename?: 'sumsub_applicants_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sumsub_Applicants_Stddev_Samp_Fields = {
  __typename?: 'sumsub_applicants_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sumsub_applicants" */
export type Sumsub_Applicants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sumsub_Applicants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sumsub_Applicants_Stream_Cursor_Value_Input = {
  applicant_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  inspection_id?: InputMaybe<Scalars['String']>;
  review_details?: InputMaybe<Scalars['jsonb']>;
  review_status?: InputMaybe<Sumsub_Applicants_Review_Status_Enum>;
  review_steps_details?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Sumsub_Applicants_Sum_Fields = {
  __typename?: 'sumsub_applicants_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "sumsub_applicants" */
export enum Sumsub_Applicants_Update_Column {
  /** column name */
  ApplicantId = 'applicant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InspectionId = 'inspection_id',
  /** column name */
  ReviewDetails = 'review_details',
  /** column name */
  ReviewStatus = 'review_status',
  /** column name */
  ReviewStepsDetails = 'review_steps_details',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Sumsub_Applicants_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sumsub_Applicants_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sumsub_Applicants_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sumsub_Applicants_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sumsub_Applicants_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sumsub_Applicants_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sumsub_Applicants_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sumsub_Applicants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sumsub_Applicants_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sumsub_Applicants_Var_Pop_Fields = {
  __typename?: 'sumsub_applicants_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sumsub_Applicants_Var_Samp_Fields = {
  __typename?: 'sumsub_applicants_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sumsub_Applicants_Variance_Fields = {
  __typename?: 'sumsub_applicants_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sumsub_applicants" */
export type Sumsub_Applicants_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "synaps_kyc_session_status" */
export type Synaps_Kyc_Session_Status = {
  __typename?: 'synaps_kyc_session_status';
  value: Scalars['String'];
};

/** aggregated selection of "synaps_kyc_session_status" */
export type Synaps_Kyc_Session_Status_Aggregate = {
  __typename?: 'synaps_kyc_session_status_aggregate';
  aggregate?: Maybe<Synaps_Kyc_Session_Status_Aggregate_Fields>;
  nodes: Array<Synaps_Kyc_Session_Status>;
};

/** aggregate fields of "synaps_kyc_session_status" */
export type Synaps_Kyc_Session_Status_Aggregate_Fields = {
  __typename?: 'synaps_kyc_session_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Synaps_Kyc_Session_Status_Max_Fields>;
  min?: Maybe<Synaps_Kyc_Session_Status_Min_Fields>;
};


/** aggregate fields of "synaps_kyc_session_status" */
export type Synaps_Kyc_Session_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Synaps_Kyc_Session_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "synaps_kyc_session_status". All fields are combined with a logical 'AND'. */
export type Synaps_Kyc_Session_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Synaps_Kyc_Session_Status_Bool_Exp>>;
  _not?: InputMaybe<Synaps_Kyc_Session_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Synaps_Kyc_Session_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "synaps_kyc_session_status" */
export enum Synaps_Kyc_Session_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  SynapsKycSessionStatusPkey = 'synaps_kyc_session_status_pkey'
}

export enum Synaps_Kyc_Session_Status_Enum {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  PendingVerification = 'PENDING_VERIFICATION',
  Rejected = 'REJECTED',
  ResubmissionRequired = 'RESUBMISSION_REQUIRED',
  SubmissionRequired = 'SUBMISSION_REQUIRED'
}

/** Boolean expression to compare columns of type "synaps_kyc_session_status_enum". All fields are combined with logical 'AND'. */
export type Synaps_Kyc_Session_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Synaps_Kyc_Session_Status_Enum>;
  _in?: InputMaybe<Array<Synaps_Kyc_Session_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Synaps_Kyc_Session_Status_Enum>;
  _nin?: InputMaybe<Array<Synaps_Kyc_Session_Status_Enum>>;
};

/** input type for inserting data into table "synaps_kyc_session_status" */
export type Synaps_Kyc_Session_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Synaps_Kyc_Session_Status_Max_Fields = {
  __typename?: 'synaps_kyc_session_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Synaps_Kyc_Session_Status_Min_Fields = {
  __typename?: 'synaps_kyc_session_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "synaps_kyc_session_status" */
export type Synaps_Kyc_Session_Status_Mutation_Response = {
  __typename?: 'synaps_kyc_session_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Synaps_Kyc_Session_Status>;
};

/** on_conflict condition type for table "synaps_kyc_session_status" */
export type Synaps_Kyc_Session_Status_On_Conflict = {
  constraint: Synaps_Kyc_Session_Status_Constraint;
  update_columns?: Array<Synaps_Kyc_Session_Status_Update_Column>;
  where?: InputMaybe<Synaps_Kyc_Session_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "synaps_kyc_session_status". */
export type Synaps_Kyc_Session_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: synaps_kyc_session_status */
export type Synaps_Kyc_Session_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "synaps_kyc_session_status" */
export enum Synaps_Kyc_Session_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "synaps_kyc_session_status" */
export type Synaps_Kyc_Session_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "synaps_kyc_session_status" */
export type Synaps_Kyc_Session_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Synaps_Kyc_Session_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Synaps_Kyc_Session_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "synaps_kyc_session_status" */
export enum Synaps_Kyc_Session_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Synaps_Kyc_Session_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Synaps_Kyc_Session_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Synaps_Kyc_Session_Status_Bool_Exp;
};

/** columns and relationships of "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions = {
  __typename?: 'synaps_kyc_sessions';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  kyc_completed_at?: Maybe<Scalars['timestamptz']>;
  session_details: Scalars['jsonb'];
  session_id: Scalars['String'];
  status: Synaps_Kyc_Session_Status_Enum;
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
};


/** columns and relationships of "synaps_kyc_sessions" */
export type Synaps_Kyc_SessionsSession_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Aggregate = {
  __typename?: 'synaps_kyc_sessions_aggregate';
  aggregate?: Maybe<Synaps_Kyc_Sessions_Aggregate_Fields>;
  nodes: Array<Synaps_Kyc_Sessions>;
};

export type Synaps_Kyc_Sessions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Synaps_Kyc_Sessions_Aggregate_Bool_Exp_Count>;
};

export type Synaps_Kyc_Sessions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Synaps_Kyc_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Aggregate_Fields = {
  __typename?: 'synaps_kyc_sessions_aggregate_fields';
  avg?: Maybe<Synaps_Kyc_Sessions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Synaps_Kyc_Sessions_Max_Fields>;
  min?: Maybe<Synaps_Kyc_Sessions_Min_Fields>;
  stddev?: Maybe<Synaps_Kyc_Sessions_Stddev_Fields>;
  stddev_pop?: Maybe<Synaps_Kyc_Sessions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Synaps_Kyc_Sessions_Stddev_Samp_Fields>;
  sum?: Maybe<Synaps_Kyc_Sessions_Sum_Fields>;
  var_pop?: Maybe<Synaps_Kyc_Sessions_Var_Pop_Fields>;
  var_samp?: Maybe<Synaps_Kyc_Sessions_Var_Samp_Fields>;
  variance?: Maybe<Synaps_Kyc_Sessions_Variance_Fields>;
};


/** aggregate fields of "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Synaps_Kyc_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Aggregate_Order_By = {
  avg?: InputMaybe<Synaps_Kyc_Sessions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Synaps_Kyc_Sessions_Max_Order_By>;
  min?: InputMaybe<Synaps_Kyc_Sessions_Min_Order_By>;
  stddev?: InputMaybe<Synaps_Kyc_Sessions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Synaps_Kyc_Sessions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Synaps_Kyc_Sessions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Synaps_Kyc_Sessions_Sum_Order_By>;
  var_pop?: InputMaybe<Synaps_Kyc_Sessions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Synaps_Kyc_Sessions_Var_Samp_Order_By>;
  variance?: InputMaybe<Synaps_Kyc_Sessions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Synaps_Kyc_Sessions_Append_Input = {
  session_details?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Arr_Rel_Insert_Input = {
  data: Array<Synaps_Kyc_Sessions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Synaps_Kyc_Sessions_On_Conflict>;
};

/** aggregate avg on columns */
export type Synaps_Kyc_Sessions_Avg_Fields = {
  __typename?: 'synaps_kyc_sessions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "synaps_kyc_sessions". All fields are combined with a logical 'AND'. */
export type Synaps_Kyc_Sessions_Bool_Exp = {
  _and?: InputMaybe<Array<Synaps_Kyc_Sessions_Bool_Exp>>;
  _not?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
  _or?: InputMaybe<Array<Synaps_Kyc_Sessions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  kyc_completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  session_details?: InputMaybe<Jsonb_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Synaps_Kyc_Session_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "synaps_kyc_sessions" */
export enum Synaps_Kyc_Sessions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SynapsKycSessionsPkey = 'synaps_kyc_sessions_pkey',
  /** unique or primary key constraint on columns "session_id" */
  SynapsKycSessionsSessionIdKey = 'synaps_kyc_sessions_session_id_key',
  /** unique or primary key constraint on columns "session_id", "user_id" */
  SynapsKycSessionsUserIdSessionIdKey = 'synaps_kyc_sessions_user_id_session_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Synaps_Kyc_Sessions_Delete_At_Path_Input = {
  session_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Synaps_Kyc_Sessions_Delete_Elem_Input = {
  session_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Synaps_Kyc_Sessions_Delete_Key_Input = {
  session_details?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  kyc_completed_at?: InputMaybe<Scalars['timestamptz']>;
  session_details?: InputMaybe<Scalars['jsonb']>;
  session_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Synaps_Kyc_Session_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Synaps_Kyc_Sessions_Max_Fields = {
  __typename?: 'synaps_kyc_sessions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  kyc_completed_at?: Maybe<Scalars['timestamptz']>;
  session_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kyc_completed_at?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Synaps_Kyc_Sessions_Min_Fields = {
  __typename?: 'synaps_kyc_sessions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  kyc_completed_at?: Maybe<Scalars['timestamptz']>;
  session_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kyc_completed_at?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Mutation_Response = {
  __typename?: 'synaps_kyc_sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Synaps_Kyc_Sessions>;
};

/** on_conflict condition type for table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_On_Conflict = {
  constraint: Synaps_Kyc_Sessions_Constraint;
  update_columns?: Array<Synaps_Kyc_Sessions_Update_Column>;
  where?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
};

/** Ordering options when selecting data from "synaps_kyc_sessions". */
export type Synaps_Kyc_Sessions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kyc_completed_at?: InputMaybe<Order_By>;
  session_details?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: synaps_kyc_sessions */
export type Synaps_Kyc_Sessions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Synaps_Kyc_Sessions_Prepend_Input = {
  session_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "synaps_kyc_sessions" */
export enum Synaps_Kyc_Sessions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  KycCompletedAt = 'kyc_completed_at',
  /** column name */
  SessionDetails = 'session_details',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  kyc_completed_at?: InputMaybe<Scalars['timestamptz']>;
  session_details?: InputMaybe<Scalars['jsonb']>;
  session_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Synaps_Kyc_Session_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Synaps_Kyc_Sessions_Stddev_Fields = {
  __typename?: 'synaps_kyc_sessions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Synaps_Kyc_Sessions_Stddev_Pop_Fields = {
  __typename?: 'synaps_kyc_sessions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Synaps_Kyc_Sessions_Stddev_Samp_Fields = {
  __typename?: 'synaps_kyc_sessions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Synaps_Kyc_Sessions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Synaps_Kyc_Sessions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  kyc_completed_at?: InputMaybe<Scalars['timestamptz']>;
  session_details?: InputMaybe<Scalars['jsonb']>;
  session_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Synaps_Kyc_Session_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Synaps_Kyc_Sessions_Sum_Fields = {
  __typename?: 'synaps_kyc_sessions_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "synaps_kyc_sessions" */
export enum Synaps_Kyc_Sessions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  KycCompletedAt = 'kyc_completed_at',
  /** column name */
  SessionDetails = 'session_details',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Synaps_Kyc_Sessions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Synaps_Kyc_Sessions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Synaps_Kyc_Sessions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Synaps_Kyc_Sessions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Synaps_Kyc_Sessions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Synaps_Kyc_Sessions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Synaps_Kyc_Sessions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Synaps_Kyc_Sessions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Synaps_Kyc_Sessions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Synaps_Kyc_Sessions_Var_Pop_Fields = {
  __typename?: 'synaps_kyc_sessions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Synaps_Kyc_Sessions_Var_Samp_Fields = {
  __typename?: 'synaps_kyc_sessions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Synaps_Kyc_Sessions_Variance_Fields = {
  __typename?: 'synaps_kyc_sessions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "synaps_kyc_sessions" */
export type Synaps_Kyc_Sessions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "teams" */
export type Teams = {
  __typename?: 'teams';
  ai_assisted_reason?: Maybe<Scalars['String']>;
  ai_assisted_score?: Maybe<Scalars['Int']>;
  ai_assisted_status?: Maybe<Scalars['teams_status_enum']>;
  code: Scalars['citext'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  /** Fetches a team's members */
  members?: Maybe<Array<Users>>;
  name: Scalars['String'];
  status?: Maybe<Scalars['teams_status_enum']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  /** An array relationship */
  user_hackathons: Array<User_Hackathons>;
  /** An aggregate relationship */
  user_hackathons_aggregate: User_Hackathons_Aggregate;
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};


/** columns and relationships of "teams" */
export type TeamsMembersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsUser_HackathonsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsUser_Hackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};

/** aggregated selection of "teams" */
export type Teams_Aggregate = {
  __typename?: 'teams_aggregate';
  aggregate?: Maybe<Teams_Aggregate_Fields>;
  nodes: Array<Teams>;
};

/** aggregate fields of "teams" */
export type Teams_Aggregate_Fields = {
  __typename?: 'teams_aggregate_fields';
  avg?: Maybe<Teams_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Teams_Max_Fields>;
  min?: Maybe<Teams_Min_Fields>;
  stddev?: Maybe<Teams_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Sum_Fields>;
  var_pop?: Maybe<Teams_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Var_Samp_Fields>;
  variance?: Maybe<Teams_Variance_Fields>;
};


/** aggregate fields of "teams" */
export type Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "teams" */
export type Teams_Aggregate_Order_By = {
  avg?: InputMaybe<Teams_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Max_Order_By>;
  min?: InputMaybe<Teams_Min_Order_By>;
  stddev?: InputMaybe<Teams_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Teams_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Teams_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Teams_Sum_Order_By>;
  var_pop?: InputMaybe<Teams_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Teams_Var_Samp_Order_By>;
  variance?: InputMaybe<Teams_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Teams_Avg_Fields = {
  __typename?: 'teams_avg_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "teams" */
export type Teams_Avg_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Bool_Exp>>;
  _not?: InputMaybe<Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Bool_Exp>>;
  ai_assisted_reason?: InputMaybe<String_Comparison_Exp>;
  ai_assisted_score?: InputMaybe<Int_Comparison_Exp>;
  ai_assisted_status?: InputMaybe<Teams_Status_Enum_Comparison_Exp>;
  code?: InputMaybe<Citext_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  members?: InputMaybe<Users_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Teams_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_hackathons?: InputMaybe<User_Hackathons_Bool_Exp>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams" */
export enum Teams_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkTeams = 'pk_teams',
  /** unique or primary key constraint on columns "code" */
  UniqueCodeTeams = 'unique_code_teams',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidTeams = 'unique_uuid_teams'
}

/** input type for incrementing numeric columns in table "teams" */
export type Teams_Inc_Input = {
  ai_assisted_score?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "teams" */
export type Teams_Insert_Input = {
  ai_assisted_reason?: InputMaybe<Scalars['String']>;
  ai_assisted_score?: InputMaybe<Scalars['Int']>;
  ai_assisted_status?: InputMaybe<Scalars['teams_status_enum']>;
  code?: InputMaybe<Scalars['citext']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['teams_status_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_hackathons?: InputMaybe<User_Hackathons_Arr_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Teams_Max_Fields = {
  __typename?: 'teams_max_fields';
  ai_assisted_reason?: Maybe<Scalars['String']>;
  ai_assisted_score?: Maybe<Scalars['Int']>;
  ai_assisted_status?: Maybe<Scalars['teams_status_enum']>;
  code?: Maybe<Scalars['citext']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['teams_status_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "teams" */
export type Teams_Max_Order_By = {
  ai_assisted_reason?: InputMaybe<Order_By>;
  ai_assisted_score?: InputMaybe<Order_By>;
  ai_assisted_status?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teams_Min_Fields = {
  __typename?: 'teams_min_fields';
  ai_assisted_reason?: Maybe<Scalars['String']>;
  ai_assisted_score?: Maybe<Scalars['Int']>;
  ai_assisted_status?: Maybe<Scalars['teams_status_enum']>;
  code?: Maybe<Scalars['citext']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['teams_status_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "teams" */
export type Teams_Min_Order_By = {
  ai_assisted_reason?: InputMaybe<Order_By>;
  ai_assisted_score?: InputMaybe<Order_By>;
  ai_assisted_status?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams" */
export type Teams_Mutation_Response = {
  __typename?: 'teams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams>;
};

/** input type for inserting object relation for remote table "teams" */
export type Teams_Obj_Rel_Insert_Input = {
  data: Teams_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** on_conflict condition type for table "teams" */
export type Teams_On_Conflict = {
  constraint: Teams_Constraint;
  update_columns?: Array<Teams_Update_Column>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "teams". */
export type Teams_Order_By = {
  ai_assisted_reason?: InputMaybe<Order_By>;
  ai_assisted_score?: InputMaybe<Order_By>;
  ai_assisted_status?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  members_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teams */
export type Teams_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "teams" */
export enum Teams_Select_Column {
  /** column name */
  AiAssistedReason = 'ai_assisted_reason',
  /** column name */
  AiAssistedScore = 'ai_assisted_score',
  /** column name */
  AiAssistedStatus = 'ai_assisted_status',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "teams" */
export type Teams_Set_Input = {
  ai_assisted_reason?: InputMaybe<Scalars['String']>;
  ai_assisted_score?: InputMaybe<Scalars['Int']>;
  ai_assisted_status?: InputMaybe<Scalars['teams_status_enum']>;
  code?: InputMaybe<Scalars['citext']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['teams_status_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "teams_status_enum". All fields are combined with logical 'AND'. */
export type Teams_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['teams_status_enum']>;
  _gt?: InputMaybe<Scalars['teams_status_enum']>;
  _gte?: InputMaybe<Scalars['teams_status_enum']>;
  _in?: InputMaybe<Array<Scalars['teams_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['teams_status_enum']>;
  _lte?: InputMaybe<Scalars['teams_status_enum']>;
  _neq?: InputMaybe<Scalars['teams_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['teams_status_enum']>>;
};

/** aggregate stddev on columns */
export type Teams_Stddev_Fields = {
  __typename?: 'teams_stddev_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "teams" */
export type Teams_Stddev_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Teams_Stddev_Pop_Fields = {
  __typename?: 'teams_stddev_pop_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "teams" */
export type Teams_Stddev_Pop_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Teams_Stddev_Samp_Fields = {
  __typename?: 'teams_stddev_samp_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "teams" */
export type Teams_Stddev_Samp_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "teams" */
export type Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Stream_Cursor_Value_Input = {
  ai_assisted_reason?: InputMaybe<Scalars['String']>;
  ai_assisted_score?: InputMaybe<Scalars['Int']>;
  ai_assisted_status?: InputMaybe<Scalars['teams_status_enum']>;
  code?: InputMaybe<Scalars['citext']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['teams_status_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Teams_Sum_Fields = {
  __typename?: 'teams_sum_fields';
  ai_assisted_score?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "teams" */
export type Teams_Sum_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "teams" */
export enum Teams_Update_Column {
  /** column name */
  AiAssistedReason = 'ai_assisted_reason',
  /** column name */
  AiAssistedScore = 'ai_assisted_score',
  /** column name */
  AiAssistedStatus = 'ai_assisted_status',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Teams_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_Var_Pop_Fields = {
  __typename?: 'teams_var_pop_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "teams" */
export type Teams_Var_Pop_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Teams_Var_Samp_Fields = {
  __typename?: 'teams_var_samp_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "teams" */
export type Teams_Var_Samp_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Teams_Variance_Fields = {
  __typename?: 'teams_variance_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "teams" */
export type Teams_Variance_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "themes" */
export type Themes = {
  __typename?: 'themes';
  created_at: Scalars['timestamptz'];
  desc?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['citext'];
  short_desc?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
  verified?: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "themes" */
export type Themes_Aggregate = {
  __typename?: 'themes_aggregate';
  aggregate?: Maybe<Themes_Aggregate_Fields>;
  nodes: Array<Themes>;
};

/** aggregate fields of "themes" */
export type Themes_Aggregate_Fields = {
  __typename?: 'themes_aggregate_fields';
  avg?: Maybe<Themes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Themes_Max_Fields>;
  min?: Maybe<Themes_Min_Fields>;
  stddev?: Maybe<Themes_Stddev_Fields>;
  stddev_pop?: Maybe<Themes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Themes_Stddev_Samp_Fields>;
  sum?: Maybe<Themes_Sum_Fields>;
  var_pop?: Maybe<Themes_Var_Pop_Fields>;
  var_samp?: Maybe<Themes_Var_Samp_Fields>;
  variance?: Maybe<Themes_Variance_Fields>;
};


/** aggregate fields of "themes" */
export type Themes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Themes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Themes_Avg_Fields = {
  __typename?: 'themes_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "themes". All fields are combined with a logical 'AND'. */
export type Themes_Bool_Exp = {
  _and?: InputMaybe<Array<Themes_Bool_Exp>>;
  _not?: InputMaybe<Themes_Bool_Exp>;
  _or?: InputMaybe<Array<Themes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  desc?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<Citext_Comparison_Exp>;
  short_desc?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "themes" */
export enum Themes_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkThemes = 'pk_themes',
  /** unique or primary key constraint on columns "name" */
  UniqueNameThemes = 'unique_name_themes',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidThemes = 'unique_uuid_themes'
}

/** input type for incrementing numeric columns in table "themes" */
export type Themes_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "themes" */
export type Themes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['citext']>;
  short_desc?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Themes_Max_Fields = {
  __typename?: 'themes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['citext']>;
  short_desc?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Themes_Min_Fields = {
  __typename?: 'themes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  desc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['citext']>;
  short_desc?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "themes" */
export type Themes_Mutation_Response = {
  __typename?: 'themes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Themes>;
};

/** input type for inserting object relation for remote table "themes" */
export type Themes_Obj_Rel_Insert_Input = {
  data: Themes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};

/** on_conflict condition type for table "themes" */
export type Themes_On_Conflict = {
  constraint: Themes_Constraint;
  update_columns?: Array<Themes_Update_Column>;
  where?: InputMaybe<Themes_Bool_Exp>;
};

/** Ordering options when selecting data from "themes". */
export type Themes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  desc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_desc?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: themes */
export type Themes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "themes" */
export enum Themes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  ShortDesc = 'short_desc',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "themes" */
export type Themes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['citext']>;
  short_desc?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Themes_Stddev_Fields = {
  __typename?: 'themes_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Themes_Stddev_Pop_Fields = {
  __typename?: 'themes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Themes_Stddev_Samp_Fields = {
  __typename?: 'themes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "themes" */
export type Themes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Themes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Themes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  desc?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['citext']>;
  short_desc?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Themes_Sum_Fields = {
  __typename?: 'themes_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "themes" */
export enum Themes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Desc = 'desc',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  ShortDesc = 'short_desc',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

export type Themes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Themes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Themes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Themes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Themes_Var_Pop_Fields = {
  __typename?: 'themes_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Themes_Var_Samp_Fields = {
  __typename?: 'themes_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Themes_Variance_Fields = {
  __typename?: 'themes_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "twitter_cards" */
export type Twitter_Cards = {
  __typename?: 'twitter_cards';
  author?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by: Scalars['Int'];
  discover: Scalars['Boolean'];
  id: Scalars['Int'];
  tweet: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "twitter_cards" */
export type Twitter_Cards_Aggregate = {
  __typename?: 'twitter_cards_aggregate';
  aggregate?: Maybe<Twitter_Cards_Aggregate_Fields>;
  nodes: Array<Twitter_Cards>;
};

/** aggregate fields of "twitter_cards" */
export type Twitter_Cards_Aggregate_Fields = {
  __typename?: 'twitter_cards_aggregate_fields';
  avg?: Maybe<Twitter_Cards_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Twitter_Cards_Max_Fields>;
  min?: Maybe<Twitter_Cards_Min_Fields>;
  stddev?: Maybe<Twitter_Cards_Stddev_Fields>;
  stddev_pop?: Maybe<Twitter_Cards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Twitter_Cards_Stddev_Samp_Fields>;
  sum?: Maybe<Twitter_Cards_Sum_Fields>;
  var_pop?: Maybe<Twitter_Cards_Var_Pop_Fields>;
  var_samp?: Maybe<Twitter_Cards_Var_Samp_Fields>;
  variance?: Maybe<Twitter_Cards_Variance_Fields>;
};


/** aggregate fields of "twitter_cards" */
export type Twitter_Cards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Twitter_Cards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Twitter_Cards_Avg_Fields = {
  __typename?: 'twitter_cards_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "twitter_cards". All fields are combined with a logical 'AND'. */
export type Twitter_Cards_Bool_Exp = {
  _and?: InputMaybe<Array<Twitter_Cards_Bool_Exp>>;
  _not?: InputMaybe<Twitter_Cards_Bool_Exp>;
  _or?: InputMaybe<Array<Twitter_Cards_Bool_Exp>>;
  author?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Int_Comparison_Exp>;
  discover?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tweet?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "twitter_cards" */
export enum Twitter_Cards_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkTwitterCards = 'pk_twitter_cards',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidTwitterCards = 'unique_uuid_twitter_cards'
}

/** input type for incrementing numeric columns in table "twitter_cards" */
export type Twitter_Cards_Inc_Input = {
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "twitter_cards" */
export type Twitter_Cards_Insert_Input = {
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  tweet?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Twitter_Cards_Max_Fields = {
  __typename?: 'twitter_cards_max_fields';
  author?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tweet?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Twitter_Cards_Min_Fields = {
  __typename?: 'twitter_cards_min_fields';
  author?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tweet?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "twitter_cards" */
export type Twitter_Cards_Mutation_Response = {
  __typename?: 'twitter_cards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Twitter_Cards>;
};

/** on_conflict condition type for table "twitter_cards" */
export type Twitter_Cards_On_Conflict = {
  constraint: Twitter_Cards_Constraint;
  update_columns?: Array<Twitter_Cards_Update_Column>;
  where?: InputMaybe<Twitter_Cards_Bool_Exp>;
};

/** Ordering options when selecting data from "twitter_cards". */
export type Twitter_Cards_Order_By = {
  author?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  discover?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tweet?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: twitter_cards */
export type Twitter_Cards_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "twitter_cards" */
export enum Twitter_Cards_Select_Column {
  /** column name */
  Author = 'author',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Discover = 'discover',
  /** column name */
  Id = 'id',
  /** column name */
  Tweet = 'tweet',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "twitter_cards" */
export type Twitter_Cards_Set_Input = {
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  tweet?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Twitter_Cards_Stddev_Fields = {
  __typename?: 'twitter_cards_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Twitter_Cards_Stddev_Pop_Fields = {
  __typename?: 'twitter_cards_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Twitter_Cards_Stddev_Samp_Fields = {
  __typename?: 'twitter_cards_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "twitter_cards" */
export type Twitter_Cards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Twitter_Cards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Twitter_Cards_Stream_Cursor_Value_Input = {
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  discover?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  tweet?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Twitter_Cards_Sum_Fields = {
  __typename?: 'twitter_cards_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "twitter_cards" */
export enum Twitter_Cards_Update_Column {
  /** column name */
  Author = 'author',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Discover = 'discover',
  /** column name */
  Id = 'id',
  /** column name */
  Tweet = 'tweet',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Twitter_Cards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Twitter_Cards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Twitter_Cards_Set_Input>;
  /** filter the rows which have to be updated */
  where: Twitter_Cards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Twitter_Cards_Var_Pop_Fields = {
  __typename?: 'twitter_cards_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Twitter_Cards_Var_Samp_Fields = {
  __typename?: 'twitter_cards_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Twitter_Cards_Variance_Fields = {
  __typename?: 'twitter_cards_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "ue_preferred_pronoun_enum". All fields are combined with logical 'AND'. */
export type Ue_Preferred_Pronoun_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ue_preferred_pronoun_enum']>;
  _gt?: InputMaybe<Scalars['ue_preferred_pronoun_enum']>;
  _gte?: InputMaybe<Scalars['ue_preferred_pronoun_enum']>;
  _in?: InputMaybe<Array<Scalars['ue_preferred_pronoun_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ue_preferred_pronoun_enum']>;
  _lte?: InputMaybe<Scalars['ue_preferred_pronoun_enum']>;
  _neq?: InputMaybe<Scalars['ue_preferred_pronoun_enum']>;
  _nin?: InputMaybe<Array<Scalars['ue_preferred_pronoun_enum']>>;
};

/** Boolean expression to compare columns of type "ue_t_shirt_size_enum". All fields are combined with logical 'AND'. */
export type Ue_T_Shirt_Size_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ue_t_shirt_size_enum']>;
  _gt?: InputMaybe<Scalars['ue_t_shirt_size_enum']>;
  _gte?: InputMaybe<Scalars['ue_t_shirt_size_enum']>;
  _in?: InputMaybe<Array<Scalars['ue_t_shirt_size_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ue_t_shirt_size_enum']>;
  _lte?: InputMaybe<Scalars['ue_t_shirt_size_enum']>;
  _neq?: InputMaybe<Scalars['ue_t_shirt_size_enum']>;
  _nin?: InputMaybe<Array<Scalars['ue_t_shirt_size_enum']>>;
};

/** Boolean expression to compare columns of type "uh_role_enum". All fields are combined with logical 'AND'. */
export type Uh_Role_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uh_role_enum']>;
  _gt?: InputMaybe<Scalars['uh_role_enum']>;
  _gte?: InputMaybe<Scalars['uh_role_enum']>;
  _in?: InputMaybe<Array<Scalars['uh_role_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uh_role_enum']>;
  _lte?: InputMaybe<Scalars['uh_role_enum']>;
  _neq?: InputMaybe<Scalars['uh_role_enum']>;
  _nin?: InputMaybe<Array<Scalars['uh_role_enum']>>;
};

/** Boolean expression to compare columns of type "uh_status_enum". All fields are combined with logical 'AND'. */
export type Uh_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uh_status_enum']>;
  _gt?: InputMaybe<Scalars['uh_status_enum']>;
  _gte?: InputMaybe<Scalars['uh_status_enum']>;
  _in?: InputMaybe<Array<Scalars['uh_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uh_status_enum']>;
  _lte?: InputMaybe<Scalars['uh_status_enum']>;
  _neq?: InputMaybe<Scalars['uh_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['uh_status_enum']>>;
};

export type Upvote_Comment_Args = {
  comment_uuid?: InputMaybe<Scalars['String']>;
  upvote_comment?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to compare columns of type "us_experience_enum". All fields are combined with logical 'AND'. */
export type Us_Experience_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['us_experience_enum']>;
  _gt?: InputMaybe<Scalars['us_experience_enum']>;
  _gte?: InputMaybe<Scalars['us_experience_enum']>;
  _in?: InputMaybe<Array<Scalars['us_experience_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['us_experience_enum']>;
  _lte?: InputMaybe<Scalars['us_experience_enum']>;
  _neq?: InputMaybe<Scalars['us_experience_enum']>;
  _nin?: InputMaybe<Array<Scalars['us_experience_enum']>>;
};

/** This table is used to store user api tokens */
export type User_Api_Tokens = {
  __typename?: 'user_api_tokens';
  created_at: Scalars['timestamptz'];
  expires_in: Scalars['Int'];
  id: Scalars['Int'];
  note: Scalars['String'];
  token: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "user_api_tokens" */
export type User_Api_Tokens_Aggregate = {
  __typename?: 'user_api_tokens_aggregate';
  aggregate?: Maybe<User_Api_Tokens_Aggregate_Fields>;
  nodes: Array<User_Api_Tokens>;
};

/** aggregate fields of "user_api_tokens" */
export type User_Api_Tokens_Aggregate_Fields = {
  __typename?: 'user_api_tokens_aggregate_fields';
  avg?: Maybe<User_Api_Tokens_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Api_Tokens_Max_Fields>;
  min?: Maybe<User_Api_Tokens_Min_Fields>;
  stddev?: Maybe<User_Api_Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<User_Api_Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Api_Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<User_Api_Tokens_Sum_Fields>;
  var_pop?: Maybe<User_Api_Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<User_Api_Tokens_Var_Samp_Fields>;
  variance?: Maybe<User_Api_Tokens_Variance_Fields>;
};


/** aggregate fields of "user_api_tokens" */
export type User_Api_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Api_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Api_Tokens_Avg_Fields = {
  __typename?: 'user_api_tokens_avg_fields';
  expires_in?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_api_tokens". All fields are combined with a logical 'AND'. */
export type User_Api_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<User_Api_Tokens_Bool_Exp>>;
  _not?: InputMaybe<User_Api_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<User_Api_Tokens_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_in?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_api_tokens" */
export enum User_Api_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserApiTokensPkey = 'user_api_tokens_pkey'
}

/** input type for incrementing numeric columns in table "user_api_tokens" */
export type User_Api_Tokens_Inc_Input = {
  expires_in?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_api_tokens" */
export type User_Api_Tokens_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_in?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Api_Tokens_Max_Fields = {
  __typename?: 'user_api_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_in?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Api_Tokens_Min_Fields = {
  __typename?: 'user_api_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_in?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_api_tokens" */
export type User_Api_Tokens_Mutation_Response = {
  __typename?: 'user_api_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Api_Tokens>;
};

/** on_conflict condition type for table "user_api_tokens" */
export type User_Api_Tokens_On_Conflict = {
  constraint: User_Api_Tokens_Constraint;
  update_columns?: Array<User_Api_Tokens_Update_Column>;
  where?: InputMaybe<User_Api_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "user_api_tokens". */
export type User_Api_Tokens_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expires_in?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_api_tokens */
export type User_Api_Tokens_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_api_tokens" */
export enum User_Api_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresIn = 'expires_in',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_api_tokens" */
export type User_Api_Tokens_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_in?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Api_Tokens_Stddev_Fields = {
  __typename?: 'user_api_tokens_stddev_fields';
  expires_in?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Api_Tokens_Stddev_Pop_Fields = {
  __typename?: 'user_api_tokens_stddev_pop_fields';
  expires_in?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Api_Tokens_Stddev_Samp_Fields = {
  __typename?: 'user_api_tokens_stddev_samp_fields';
  expires_in?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_api_tokens" */
export type User_Api_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Api_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Api_Tokens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_in?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Api_Tokens_Sum_Fields = {
  __typename?: 'user_api_tokens_sum_fields';
  expires_in?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_api_tokens" */
export enum User_Api_Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresIn = 'expires_in',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Api_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Api_Tokens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Api_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Api_Tokens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Api_Tokens_Var_Pop_Fields = {
  __typename?: 'user_api_tokens_var_pop_fields';
  expires_in?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Api_Tokens_Var_Samp_Fields = {
  __typename?: 'user_api_tokens_var_samp_fields';
  expires_in?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Api_Tokens_Variance_Fields = {
  __typename?: 'user_api_tokens_variance_fields';
  expires_in?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_comments" */
export type User_Comments = {
  __typename?: 'user_comments';
  /** An object relationship */
  comment?: Maybe<Comments>;
  comment_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
  upvote?: Maybe<Scalars['Boolean']>;
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "user_comments" */
export type User_Comments_Aggregate = {
  __typename?: 'user_comments_aggregate';
  aggregate?: Maybe<User_Comments_Aggregate_Fields>;
  nodes: Array<User_Comments>;
};

export type User_Comments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Comments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Comments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Comments_Aggregate_Bool_Exp_Count>;
};

export type User_Comments_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Comments_Select_Column_User_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Comments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Comments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Comments_Select_Column_User_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Comments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_comments" */
export type User_Comments_Aggregate_Fields = {
  __typename?: 'user_comments_aggregate_fields';
  avg?: Maybe<User_Comments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Comments_Max_Fields>;
  min?: Maybe<User_Comments_Min_Fields>;
  stddev?: Maybe<User_Comments_Stddev_Fields>;
  stddev_pop?: Maybe<User_Comments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Comments_Stddev_Samp_Fields>;
  sum?: Maybe<User_Comments_Sum_Fields>;
  var_pop?: Maybe<User_Comments_Var_Pop_Fields>;
  var_samp?: Maybe<User_Comments_Var_Samp_Fields>;
  variance?: Maybe<User_Comments_Variance_Fields>;
};


/** aggregate fields of "user_comments" */
export type User_Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_comments" */
export type User_Comments_Aggregate_Order_By = {
  avg?: InputMaybe<User_Comments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Comments_Max_Order_By>;
  min?: InputMaybe<User_Comments_Min_Order_By>;
  stddev?: InputMaybe<User_Comments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Comments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Comments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Comments_Sum_Order_By>;
  var_pop?: InputMaybe<User_Comments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Comments_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Comments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_comments" */
export type User_Comments_Arr_Rel_Insert_Input = {
  data: Array<User_Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Comments_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Comments_Avg_Fields = {
  __typename?: 'user_comments_avg_fields';
  comment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_comments" */
export type User_Comments_Avg_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_comments". All fields are combined with a logical 'AND'. */
export type User_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<User_Comments_Bool_Exp>>;
  _not?: InputMaybe<User_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<User_Comments_Bool_Exp>>;
  comment?: InputMaybe<Comments_Bool_Exp>;
  comment_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  upvote?: InputMaybe<Boolean_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_comments" */
export enum User_Comments_Constraint {
  /** unique or primary key constraint on columns "comment_id", "user_id" */
  UserCommentsPkey = 'user_comments_pkey',
  /** unique or primary key constraint on columns "uuid" */
  UserCommentsUuidKey = 'user_comments_uuid_key'
}

/** input type for incrementing numeric columns in table "user_comments" */
export type User_Comments_Inc_Input = {
  comment_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_comments" */
export type User_Comments_Insert_Input = {
  comment?: InputMaybe<Comments_Obj_Rel_Insert_Input>;
  comment_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upvote?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Comments_Max_Fields = {
  __typename?: 'user_comments_max_fields';
  comment_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_comments" */
export type User_Comments_Max_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Comments_Min_Fields = {
  __typename?: 'user_comments_min_fields';
  comment_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_comments" */
export type User_Comments_Min_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_comments" */
export type User_Comments_Mutation_Response = {
  __typename?: 'user_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Comments>;
};

/** on_conflict condition type for table "user_comments" */
export type User_Comments_On_Conflict = {
  constraint: User_Comments_Constraint;
  update_columns?: Array<User_Comments_Update_Column>;
  where?: InputMaybe<User_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "user_comments". */
export type User_Comments_Order_By = {
  comment?: InputMaybe<Comments_Order_By>;
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upvote?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_comments */
export type User_Comments_Pk_Columns_Input = {
  comment_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_comments" */
export enum User_Comments_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Upvote = 'upvote',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** select "user_comments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_comments" */
export enum User_Comments_Select_Column_User_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Upvote = 'upvote'
}

/** select "user_comments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_comments" */
export enum User_Comments_Select_Column_User_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Upvote = 'upvote'
}

/** input type for updating data in table "user_comments" */
export type User_Comments_Set_Input = {
  comment_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upvote?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Comments_Stddev_Fields = {
  __typename?: 'user_comments_stddev_fields';
  comment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_comments" */
export type User_Comments_Stddev_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Comments_Stddev_Pop_Fields = {
  __typename?: 'user_comments_stddev_pop_fields';
  comment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_comments" */
export type User_Comments_Stddev_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Comments_Stddev_Samp_Fields = {
  __typename?: 'user_comments_stddev_samp_fields';
  comment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_comments" */
export type User_Comments_Stddev_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_comments" */
export type User_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Comments_Stream_Cursor_Value_Input = {
  comment_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upvote?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Comments_Sum_Fields = {
  __typename?: 'user_comments_sum_fields';
  comment_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_comments" */
export type User_Comments_Sum_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_comments" */
export enum User_Comments_Update_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Upvote = 'upvote',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Comments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Comments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Comments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Comments_Var_Pop_Fields = {
  __typename?: 'user_comments_var_pop_fields';
  comment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_comments" */
export type User_Comments_Var_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Comments_Var_Samp_Fields = {
  __typename?: 'user_comments_var_samp_fields';
  comment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_comments" */
export type User_Comments_Var_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Comments_Variance_Fields = {
  __typename?: 'user_comments_variance_fields';
  comment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_comments" */
export type User_Comments_Variance_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_extras" */
export type User_Extras = {
  __typename?: 'user_extras';
  allergies?: Maybe<Scalars['String']>;
  ama_enabled: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  dietary_preferences?: Maybe<Scalars['String']>;
  domain_expertise?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_contact_number?: Maybe<Scalars['String']>;
  ethereum_address?: Maybe<Scalars['citext']>;
  ethereum_address_backup?: Maybe<Scalars['String']>;
  hackathon_joined_ref_count?: Maybe<Scalars['Int']>;
  hackathons_won: Scalars['jsonb'];
  id: Scalars['Int'];
  is_2586_labs_team_member?: Maybe<Scalars['Boolean']>;
  is_devfolio_team_member?: Maybe<Scalars['Boolean']>;
  is_education?: Maybe<Scalars['Boolean']>;
  is_student?: Maybe<Scalars['Boolean']>;
  kyc_status: User_Kyc_Status_Enum;
  max_kyc_attempts: Scalars['Int'];
  new_domain_expertise?: Maybe<Scalars['_text']>;
  no_work_exp?: Maybe<Scalars['Boolean']>;
  opportunities?: Maybe<Scalars['String']>;
  pref_submitted?: Maybe<Scalars['Boolean']>;
  preferred_pronoun?: Maybe<Scalars['ue_preferred_pronoun_enum']>;
  profile_onboarding_complete?: Maybe<Scalars['Boolean']>;
  project_submission_v2_onboarding_complete: Scalars['Boolean'];
  ref_code?: Maybe<Scalars['citext']>;
  ref_count?: Maybe<Scalars['Int']>;
  resume?: Maybe<Scalars['String']>;
  show_location_on_profile?: Maybe<Scalars['Boolean']>;
  show_public_profile?: Maybe<Scalars['Boolean']>;
  t_shirt_size?: Maybe<Scalars['ue_t_shirt_size_enum']>;
  total_funding_received: Scalars['float8'];
  total_hackathons_attended: Scalars['Int'];
  total_hackathons_won: Scalars['Int'];
  total_projects: Scalars['Int'];
  tour_taken?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  used_kyc_attempts: Scalars['Int'];
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};


/** columns and relationships of "user_extras" */
export type User_ExtrasHackathons_WonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_extras" */
export type User_Extras_Aggregate = {
  __typename?: 'user_extras_aggregate';
  aggregate?: Maybe<User_Extras_Aggregate_Fields>;
  nodes: Array<User_Extras>;
};

/** aggregate fields of "user_extras" */
export type User_Extras_Aggregate_Fields = {
  __typename?: 'user_extras_aggregate_fields';
  avg?: Maybe<User_Extras_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Extras_Max_Fields>;
  min?: Maybe<User_Extras_Min_Fields>;
  stddev?: Maybe<User_Extras_Stddev_Fields>;
  stddev_pop?: Maybe<User_Extras_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Extras_Stddev_Samp_Fields>;
  sum?: Maybe<User_Extras_Sum_Fields>;
  var_pop?: Maybe<User_Extras_Var_Pop_Fields>;
  var_samp?: Maybe<User_Extras_Var_Samp_Fields>;
  variance?: Maybe<User_Extras_Variance_Fields>;
};


/** aggregate fields of "user_extras" */
export type User_Extras_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Extras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Extras_Append_Input = {
  hackathons_won?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type User_Extras_Avg_Fields = {
  __typename?: 'user_extras_avg_fields';
  hackathon_joined_ref_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_kyc_attempts?: Maybe<Scalars['Float']>;
  ref_count?: Maybe<Scalars['Float']>;
  total_funding_received?: Maybe<Scalars['Float']>;
  total_hackathons_attended?: Maybe<Scalars['Float']>;
  total_hackathons_won?: Maybe<Scalars['Float']>;
  total_projects?: Maybe<Scalars['Float']>;
  used_kyc_attempts?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_extras". All fields are combined with a logical 'AND'. */
export type User_Extras_Bool_Exp = {
  _and?: InputMaybe<Array<User_Extras_Bool_Exp>>;
  _not?: InputMaybe<User_Extras_Bool_Exp>;
  _or?: InputMaybe<Array<User_Extras_Bool_Exp>>;
  allergies?: InputMaybe<String_Comparison_Exp>;
  ama_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dietary_preferences?: InputMaybe<String_Comparison_Exp>;
  domain_expertise?: InputMaybe<String_Comparison_Exp>;
  emergency_contact_name?: InputMaybe<String_Comparison_Exp>;
  emergency_contact_number?: InputMaybe<String_Comparison_Exp>;
  ethereum_address?: InputMaybe<Citext_Comparison_Exp>;
  ethereum_address_backup?: InputMaybe<String_Comparison_Exp>;
  hackathon_joined_ref_count?: InputMaybe<Int_Comparison_Exp>;
  hackathons_won?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_2586_labs_team_member?: InputMaybe<Boolean_Comparison_Exp>;
  is_devfolio_team_member?: InputMaybe<Boolean_Comparison_Exp>;
  is_education?: InputMaybe<Boolean_Comparison_Exp>;
  is_student?: InputMaybe<Boolean_Comparison_Exp>;
  kyc_status?: InputMaybe<User_Kyc_Status_Enum_Comparison_Exp>;
  max_kyc_attempts?: InputMaybe<Int_Comparison_Exp>;
  new_domain_expertise?: InputMaybe<_Text_Comparison_Exp>;
  no_work_exp?: InputMaybe<Boolean_Comparison_Exp>;
  opportunities?: InputMaybe<String_Comparison_Exp>;
  pref_submitted?: InputMaybe<Boolean_Comparison_Exp>;
  preferred_pronoun?: InputMaybe<Ue_Preferred_Pronoun_Enum_Comparison_Exp>;
  profile_onboarding_complete?: InputMaybe<Boolean_Comparison_Exp>;
  project_submission_v2_onboarding_complete?: InputMaybe<Boolean_Comparison_Exp>;
  ref_code?: InputMaybe<Citext_Comparison_Exp>;
  ref_count?: InputMaybe<Int_Comparison_Exp>;
  resume?: InputMaybe<String_Comparison_Exp>;
  show_location_on_profile?: InputMaybe<Boolean_Comparison_Exp>;
  show_public_profile?: InputMaybe<Boolean_Comparison_Exp>;
  t_shirt_size?: InputMaybe<Ue_T_Shirt_Size_Enum_Comparison_Exp>;
  total_funding_received?: InputMaybe<Float8_Comparison_Exp>;
  total_hackathons_attended?: InputMaybe<Int_Comparison_Exp>;
  total_hackathons_won?: InputMaybe<Int_Comparison_Exp>;
  total_projects?: InputMaybe<Int_Comparison_Exp>;
  tour_taken?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  used_kyc_attempts?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_extras" */
export enum User_Extras_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkUserExtras = 'pk_user_extras',
  /** unique or primary key constraint on columns "ref_code" */
  UniqueRefCodeUserExtras = 'unique_ref_code_user_extras',
  /** unique or primary key constraint on columns "user_id" */
  UniqueUserIdUserExtras = 'unique_user_id_user_extras',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidUserExtras = 'unique_uuid_user_extras'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Extras_Delete_At_Path_Input = {
  hackathons_won?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Extras_Delete_Elem_Input = {
  hackathons_won?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Extras_Delete_Key_Input = {
  hackathons_won?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_extras" */
export type User_Extras_Inc_Input = {
  hackathon_joined_ref_count?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_kyc_attempts?: InputMaybe<Scalars['Int']>;
  ref_count?: InputMaybe<Scalars['Int']>;
  total_funding_received?: InputMaybe<Scalars['float8']>;
  total_hackathons_attended?: InputMaybe<Scalars['Int']>;
  total_hackathons_won?: InputMaybe<Scalars['Int']>;
  total_projects?: InputMaybe<Scalars['Int']>;
  used_kyc_attempts?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_extras" */
export type User_Extras_Insert_Input = {
  allergies?: InputMaybe<Scalars['String']>;
  ama_enabled?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dietary_preferences?: InputMaybe<Scalars['String']>;
  domain_expertise?: InputMaybe<Scalars['String']>;
  emergency_contact_name?: InputMaybe<Scalars['String']>;
  emergency_contact_number?: InputMaybe<Scalars['String']>;
  ethereum_address?: InputMaybe<Scalars['citext']>;
  ethereum_address_backup?: InputMaybe<Scalars['String']>;
  hackathon_joined_ref_count?: InputMaybe<Scalars['Int']>;
  hackathons_won?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_2586_labs_team_member?: InputMaybe<Scalars['Boolean']>;
  is_devfolio_team_member?: InputMaybe<Scalars['Boolean']>;
  is_education?: InputMaybe<Scalars['Boolean']>;
  is_student?: InputMaybe<Scalars['Boolean']>;
  kyc_status?: InputMaybe<User_Kyc_Status_Enum>;
  max_kyc_attempts?: InputMaybe<Scalars['Int']>;
  new_domain_expertise?: InputMaybe<Scalars['_text']>;
  no_work_exp?: InputMaybe<Scalars['Boolean']>;
  opportunities?: InputMaybe<Scalars['String']>;
  pref_submitted?: InputMaybe<Scalars['Boolean']>;
  preferred_pronoun?: InputMaybe<Scalars['ue_preferred_pronoun_enum']>;
  profile_onboarding_complete?: InputMaybe<Scalars['Boolean']>;
  project_submission_v2_onboarding_complete?: InputMaybe<Scalars['Boolean']>;
  ref_code?: InputMaybe<Scalars['citext']>;
  ref_count?: InputMaybe<Scalars['Int']>;
  resume?: InputMaybe<Scalars['String']>;
  show_location_on_profile?: InputMaybe<Scalars['Boolean']>;
  show_public_profile?: InputMaybe<Scalars['Boolean']>;
  t_shirt_size?: InputMaybe<Scalars['ue_t_shirt_size_enum']>;
  total_funding_received?: InputMaybe<Scalars['float8']>;
  total_hackathons_attended?: InputMaybe<Scalars['Int']>;
  total_hackathons_won?: InputMaybe<Scalars['Int']>;
  total_projects?: InputMaybe<Scalars['Int']>;
  tour_taken?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_kyc_attempts?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Extras_Max_Fields = {
  __typename?: 'user_extras_max_fields';
  allergies?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dietary_preferences?: Maybe<Scalars['String']>;
  domain_expertise?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_contact_number?: Maybe<Scalars['String']>;
  ethereum_address?: Maybe<Scalars['citext']>;
  ethereum_address_backup?: Maybe<Scalars['String']>;
  hackathon_joined_ref_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_kyc_attempts?: Maybe<Scalars['Int']>;
  opportunities?: Maybe<Scalars['String']>;
  preferred_pronoun?: Maybe<Scalars['ue_preferred_pronoun_enum']>;
  ref_code?: Maybe<Scalars['citext']>;
  ref_count?: Maybe<Scalars['Int']>;
  resume?: Maybe<Scalars['String']>;
  t_shirt_size?: Maybe<Scalars['ue_t_shirt_size_enum']>;
  total_funding_received?: Maybe<Scalars['float8']>;
  total_hackathons_attended?: Maybe<Scalars['Int']>;
  total_hackathons_won?: Maybe<Scalars['Int']>;
  total_projects?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  used_kyc_attempts?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Extras_Min_Fields = {
  __typename?: 'user_extras_min_fields';
  allergies?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dietary_preferences?: Maybe<Scalars['String']>;
  domain_expertise?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_contact_number?: Maybe<Scalars['String']>;
  ethereum_address?: Maybe<Scalars['citext']>;
  ethereum_address_backup?: Maybe<Scalars['String']>;
  hackathon_joined_ref_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_kyc_attempts?: Maybe<Scalars['Int']>;
  opportunities?: Maybe<Scalars['String']>;
  preferred_pronoun?: Maybe<Scalars['ue_preferred_pronoun_enum']>;
  ref_code?: Maybe<Scalars['citext']>;
  ref_count?: Maybe<Scalars['Int']>;
  resume?: Maybe<Scalars['String']>;
  t_shirt_size?: Maybe<Scalars['ue_t_shirt_size_enum']>;
  total_funding_received?: Maybe<Scalars['float8']>;
  total_hackathons_attended?: Maybe<Scalars['Int']>;
  total_hackathons_won?: Maybe<Scalars['Int']>;
  total_projects?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  used_kyc_attempts?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_extras" */
export type User_Extras_Mutation_Response = {
  __typename?: 'user_extras_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Extras>;
};

/** input type for inserting object relation for remote table "user_extras" */
export type User_Extras_Obj_Rel_Insert_Input = {
  data: User_Extras_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Extras_On_Conflict>;
};

/** on_conflict condition type for table "user_extras" */
export type User_Extras_On_Conflict = {
  constraint: User_Extras_Constraint;
  update_columns?: Array<User_Extras_Update_Column>;
  where?: InputMaybe<User_Extras_Bool_Exp>;
};

/** Ordering options when selecting data from "user_extras". */
export type User_Extras_Order_By = {
  allergies?: InputMaybe<Order_By>;
  ama_enabled?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dietary_preferences?: InputMaybe<Order_By>;
  domain_expertise?: InputMaybe<Order_By>;
  emergency_contact_name?: InputMaybe<Order_By>;
  emergency_contact_number?: InputMaybe<Order_By>;
  ethereum_address?: InputMaybe<Order_By>;
  ethereum_address_backup?: InputMaybe<Order_By>;
  hackathon_joined_ref_count?: InputMaybe<Order_By>;
  hackathons_won?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_2586_labs_team_member?: InputMaybe<Order_By>;
  is_devfolio_team_member?: InputMaybe<Order_By>;
  is_education?: InputMaybe<Order_By>;
  is_student?: InputMaybe<Order_By>;
  kyc_status?: InputMaybe<Order_By>;
  max_kyc_attempts?: InputMaybe<Order_By>;
  new_domain_expertise?: InputMaybe<Order_By>;
  no_work_exp?: InputMaybe<Order_By>;
  opportunities?: InputMaybe<Order_By>;
  pref_submitted?: InputMaybe<Order_By>;
  preferred_pronoun?: InputMaybe<Order_By>;
  profile_onboarding_complete?: InputMaybe<Order_By>;
  project_submission_v2_onboarding_complete?: InputMaybe<Order_By>;
  ref_code?: InputMaybe<Order_By>;
  ref_count?: InputMaybe<Order_By>;
  resume?: InputMaybe<Order_By>;
  show_location_on_profile?: InputMaybe<Order_By>;
  show_public_profile?: InputMaybe<Order_By>;
  t_shirt_size?: InputMaybe<Order_By>;
  total_funding_received?: InputMaybe<Order_By>;
  total_hackathons_attended?: InputMaybe<Order_By>;
  total_hackathons_won?: InputMaybe<Order_By>;
  total_projects?: InputMaybe<Order_By>;
  tour_taken?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  used_kyc_attempts?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_extras */
export type User_Extras_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Extras_Prepend_Input = {
  hackathons_won?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_extras" */
export enum User_Extras_Select_Column {
  /** column name */
  Allergies = 'allergies',
  /** column name */
  AmaEnabled = 'ama_enabled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DietaryPreferences = 'dietary_preferences',
  /** column name */
  DomainExpertise = 'domain_expertise',
  /** column name */
  EmergencyContactName = 'emergency_contact_name',
  /** column name */
  EmergencyContactNumber = 'emergency_contact_number',
  /** column name */
  EthereumAddress = 'ethereum_address',
  /** column name */
  EthereumAddressBackup = 'ethereum_address_backup',
  /** column name */
  HackathonJoinedRefCount = 'hackathon_joined_ref_count',
  /** column name */
  HackathonsWon = 'hackathons_won',
  /** column name */
  Id = 'id',
  /** column name */
  Is_2586LabsTeamMember = 'is_2586_labs_team_member',
  /** column name */
  IsDevfolioTeamMember = 'is_devfolio_team_member',
  /** column name */
  IsEducation = 'is_education',
  /** column name */
  IsStudent = 'is_student',
  /** column name */
  KycStatus = 'kyc_status',
  /** column name */
  MaxKycAttempts = 'max_kyc_attempts',
  /** column name */
  NewDomainExpertise = 'new_domain_expertise',
  /** column name */
  NoWorkExp = 'no_work_exp',
  /** column name */
  Opportunities = 'opportunities',
  /** column name */
  PrefSubmitted = 'pref_submitted',
  /** column name */
  PreferredPronoun = 'preferred_pronoun',
  /** column name */
  ProfileOnboardingComplete = 'profile_onboarding_complete',
  /** column name */
  ProjectSubmissionV2OnboardingComplete = 'project_submission_v2_onboarding_complete',
  /** column name */
  RefCode = 'ref_code',
  /** column name */
  RefCount = 'ref_count',
  /** column name */
  Resume = 'resume',
  /** column name */
  ShowLocationOnProfile = 'show_location_on_profile',
  /** column name */
  ShowPublicProfile = 'show_public_profile',
  /** column name */
  TShirtSize = 't_shirt_size',
  /** column name */
  TotalFundingReceived = 'total_funding_received',
  /** column name */
  TotalHackathonsAttended = 'total_hackathons_attended',
  /** column name */
  TotalHackathonsWon = 'total_hackathons_won',
  /** column name */
  TotalProjects = 'total_projects',
  /** column name */
  TourTaken = 'tour_taken',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsedKycAttempts = 'used_kyc_attempts',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_extras" */
export type User_Extras_Set_Input = {
  allergies?: InputMaybe<Scalars['String']>;
  ama_enabled?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dietary_preferences?: InputMaybe<Scalars['String']>;
  domain_expertise?: InputMaybe<Scalars['String']>;
  emergency_contact_name?: InputMaybe<Scalars['String']>;
  emergency_contact_number?: InputMaybe<Scalars['String']>;
  ethereum_address?: InputMaybe<Scalars['citext']>;
  ethereum_address_backup?: InputMaybe<Scalars['String']>;
  hackathon_joined_ref_count?: InputMaybe<Scalars['Int']>;
  hackathons_won?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_2586_labs_team_member?: InputMaybe<Scalars['Boolean']>;
  is_devfolio_team_member?: InputMaybe<Scalars['Boolean']>;
  is_education?: InputMaybe<Scalars['Boolean']>;
  is_student?: InputMaybe<Scalars['Boolean']>;
  kyc_status?: InputMaybe<User_Kyc_Status_Enum>;
  max_kyc_attempts?: InputMaybe<Scalars['Int']>;
  new_domain_expertise?: InputMaybe<Scalars['_text']>;
  no_work_exp?: InputMaybe<Scalars['Boolean']>;
  opportunities?: InputMaybe<Scalars['String']>;
  pref_submitted?: InputMaybe<Scalars['Boolean']>;
  preferred_pronoun?: InputMaybe<Scalars['ue_preferred_pronoun_enum']>;
  profile_onboarding_complete?: InputMaybe<Scalars['Boolean']>;
  project_submission_v2_onboarding_complete?: InputMaybe<Scalars['Boolean']>;
  ref_code?: InputMaybe<Scalars['citext']>;
  ref_count?: InputMaybe<Scalars['Int']>;
  resume?: InputMaybe<Scalars['String']>;
  show_location_on_profile?: InputMaybe<Scalars['Boolean']>;
  show_public_profile?: InputMaybe<Scalars['Boolean']>;
  t_shirt_size?: InputMaybe<Scalars['ue_t_shirt_size_enum']>;
  total_funding_received?: InputMaybe<Scalars['float8']>;
  total_hackathons_attended?: InputMaybe<Scalars['Int']>;
  total_hackathons_won?: InputMaybe<Scalars['Int']>;
  total_projects?: InputMaybe<Scalars['Int']>;
  tour_taken?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_kyc_attempts?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Extras_Stddev_Fields = {
  __typename?: 'user_extras_stddev_fields';
  hackathon_joined_ref_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_kyc_attempts?: Maybe<Scalars['Float']>;
  ref_count?: Maybe<Scalars['Float']>;
  total_funding_received?: Maybe<Scalars['Float']>;
  total_hackathons_attended?: Maybe<Scalars['Float']>;
  total_hackathons_won?: Maybe<Scalars['Float']>;
  total_projects?: Maybe<Scalars['Float']>;
  used_kyc_attempts?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Extras_Stddev_Pop_Fields = {
  __typename?: 'user_extras_stddev_pop_fields';
  hackathon_joined_ref_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_kyc_attempts?: Maybe<Scalars['Float']>;
  ref_count?: Maybe<Scalars['Float']>;
  total_funding_received?: Maybe<Scalars['Float']>;
  total_hackathons_attended?: Maybe<Scalars['Float']>;
  total_hackathons_won?: Maybe<Scalars['Float']>;
  total_projects?: Maybe<Scalars['Float']>;
  used_kyc_attempts?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Extras_Stddev_Samp_Fields = {
  __typename?: 'user_extras_stddev_samp_fields';
  hackathon_joined_ref_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_kyc_attempts?: Maybe<Scalars['Float']>;
  ref_count?: Maybe<Scalars['Float']>;
  total_funding_received?: Maybe<Scalars['Float']>;
  total_hackathons_attended?: Maybe<Scalars['Float']>;
  total_hackathons_won?: Maybe<Scalars['Float']>;
  total_projects?: Maybe<Scalars['Float']>;
  used_kyc_attempts?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_extras" */
export type User_Extras_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Extras_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Extras_Stream_Cursor_Value_Input = {
  allergies?: InputMaybe<Scalars['String']>;
  ama_enabled?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dietary_preferences?: InputMaybe<Scalars['String']>;
  domain_expertise?: InputMaybe<Scalars['String']>;
  emergency_contact_name?: InputMaybe<Scalars['String']>;
  emergency_contact_number?: InputMaybe<Scalars['String']>;
  ethereum_address?: InputMaybe<Scalars['citext']>;
  ethereum_address_backup?: InputMaybe<Scalars['String']>;
  hackathon_joined_ref_count?: InputMaybe<Scalars['Int']>;
  hackathons_won?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_2586_labs_team_member?: InputMaybe<Scalars['Boolean']>;
  is_devfolio_team_member?: InputMaybe<Scalars['Boolean']>;
  is_education?: InputMaybe<Scalars['Boolean']>;
  is_student?: InputMaybe<Scalars['Boolean']>;
  kyc_status?: InputMaybe<User_Kyc_Status_Enum>;
  max_kyc_attempts?: InputMaybe<Scalars['Int']>;
  new_domain_expertise?: InputMaybe<Scalars['_text']>;
  no_work_exp?: InputMaybe<Scalars['Boolean']>;
  opportunities?: InputMaybe<Scalars['String']>;
  pref_submitted?: InputMaybe<Scalars['Boolean']>;
  preferred_pronoun?: InputMaybe<Scalars['ue_preferred_pronoun_enum']>;
  profile_onboarding_complete?: InputMaybe<Scalars['Boolean']>;
  project_submission_v2_onboarding_complete?: InputMaybe<Scalars['Boolean']>;
  ref_code?: InputMaybe<Scalars['citext']>;
  ref_count?: InputMaybe<Scalars['Int']>;
  resume?: InputMaybe<Scalars['String']>;
  show_location_on_profile?: InputMaybe<Scalars['Boolean']>;
  show_public_profile?: InputMaybe<Scalars['Boolean']>;
  t_shirt_size?: InputMaybe<Scalars['ue_t_shirt_size_enum']>;
  total_funding_received?: InputMaybe<Scalars['float8']>;
  total_hackathons_attended?: InputMaybe<Scalars['Int']>;
  total_hackathons_won?: InputMaybe<Scalars['Int']>;
  total_projects?: InputMaybe<Scalars['Int']>;
  tour_taken?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_kyc_attempts?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Extras_Sum_Fields = {
  __typename?: 'user_extras_sum_fields';
  hackathon_joined_ref_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_kyc_attempts?: Maybe<Scalars['Int']>;
  ref_count?: Maybe<Scalars['Int']>;
  total_funding_received?: Maybe<Scalars['float8']>;
  total_hackathons_attended?: Maybe<Scalars['Int']>;
  total_hackathons_won?: Maybe<Scalars['Int']>;
  total_projects?: Maybe<Scalars['Int']>;
  used_kyc_attempts?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_extras" */
export enum User_Extras_Update_Column {
  /** column name */
  Allergies = 'allergies',
  /** column name */
  AmaEnabled = 'ama_enabled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DietaryPreferences = 'dietary_preferences',
  /** column name */
  DomainExpertise = 'domain_expertise',
  /** column name */
  EmergencyContactName = 'emergency_contact_name',
  /** column name */
  EmergencyContactNumber = 'emergency_contact_number',
  /** column name */
  EthereumAddress = 'ethereum_address',
  /** column name */
  EthereumAddressBackup = 'ethereum_address_backup',
  /** column name */
  HackathonJoinedRefCount = 'hackathon_joined_ref_count',
  /** column name */
  HackathonsWon = 'hackathons_won',
  /** column name */
  Id = 'id',
  /** column name */
  Is_2586LabsTeamMember = 'is_2586_labs_team_member',
  /** column name */
  IsDevfolioTeamMember = 'is_devfolio_team_member',
  /** column name */
  IsEducation = 'is_education',
  /** column name */
  IsStudent = 'is_student',
  /** column name */
  KycStatus = 'kyc_status',
  /** column name */
  MaxKycAttempts = 'max_kyc_attempts',
  /** column name */
  NewDomainExpertise = 'new_domain_expertise',
  /** column name */
  NoWorkExp = 'no_work_exp',
  /** column name */
  Opportunities = 'opportunities',
  /** column name */
  PrefSubmitted = 'pref_submitted',
  /** column name */
  PreferredPronoun = 'preferred_pronoun',
  /** column name */
  ProfileOnboardingComplete = 'profile_onboarding_complete',
  /** column name */
  ProjectSubmissionV2OnboardingComplete = 'project_submission_v2_onboarding_complete',
  /** column name */
  RefCode = 'ref_code',
  /** column name */
  RefCount = 'ref_count',
  /** column name */
  Resume = 'resume',
  /** column name */
  ShowLocationOnProfile = 'show_location_on_profile',
  /** column name */
  ShowPublicProfile = 'show_public_profile',
  /** column name */
  TShirtSize = 't_shirt_size',
  /** column name */
  TotalFundingReceived = 'total_funding_received',
  /** column name */
  TotalHackathonsAttended = 'total_hackathons_attended',
  /** column name */
  TotalHackathonsWon = 'total_hackathons_won',
  /** column name */
  TotalProjects = 'total_projects',
  /** column name */
  TourTaken = 'tour_taken',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsedKycAttempts = 'used_kyc_attempts',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Extras_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Extras_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Extras_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Extras_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Extras_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Extras_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Extras_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Extras_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Extras_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Extras_Var_Pop_Fields = {
  __typename?: 'user_extras_var_pop_fields';
  hackathon_joined_ref_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_kyc_attempts?: Maybe<Scalars['Float']>;
  ref_count?: Maybe<Scalars['Float']>;
  total_funding_received?: Maybe<Scalars['Float']>;
  total_hackathons_attended?: Maybe<Scalars['Float']>;
  total_hackathons_won?: Maybe<Scalars['Float']>;
  total_projects?: Maybe<Scalars['Float']>;
  used_kyc_attempts?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Extras_Var_Samp_Fields = {
  __typename?: 'user_extras_var_samp_fields';
  hackathon_joined_ref_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_kyc_attempts?: Maybe<Scalars['Float']>;
  ref_count?: Maybe<Scalars['Float']>;
  total_funding_received?: Maybe<Scalars['Float']>;
  total_hackathons_attended?: Maybe<Scalars['Float']>;
  total_hackathons_won?: Maybe<Scalars['Float']>;
  total_projects?: Maybe<Scalars['Float']>;
  used_kyc_attempts?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Extras_Variance_Fields = {
  __typename?: 'user_extras_variance_fields';
  hackathon_joined_ref_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_kyc_attempts?: Maybe<Scalars['Float']>;
  ref_count?: Maybe<Scalars['Float']>;
  total_funding_received?: Maybe<Scalars['Float']>;
  total_hackathons_attended?: Maybe<Scalars['Float']>;
  total_hackathons_won?: Maybe<Scalars['Float']>;
  total_projects?: Maybe<Scalars['Float']>;
  used_kyc_attempts?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_feature_flags" */
export type User_Feature_Flags = {
  __typename?: 'user_feature_flags';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  feature_flag?: Maybe<Feature_Flags>;
  feature_flag_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['Int'];
};

/** aggregated selection of "user_feature_flags" */
export type User_Feature_Flags_Aggregate = {
  __typename?: 'user_feature_flags_aggregate';
  aggregate?: Maybe<User_Feature_Flags_Aggregate_Fields>;
  nodes: Array<User_Feature_Flags>;
};

/** aggregate fields of "user_feature_flags" */
export type User_Feature_Flags_Aggregate_Fields = {
  __typename?: 'user_feature_flags_aggregate_fields';
  avg?: Maybe<User_Feature_Flags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Feature_Flags_Max_Fields>;
  min?: Maybe<User_Feature_Flags_Min_Fields>;
  stddev?: Maybe<User_Feature_Flags_Stddev_Fields>;
  stddev_pop?: Maybe<User_Feature_Flags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Feature_Flags_Stddev_Samp_Fields>;
  sum?: Maybe<User_Feature_Flags_Sum_Fields>;
  var_pop?: Maybe<User_Feature_Flags_Var_Pop_Fields>;
  var_samp?: Maybe<User_Feature_Flags_Var_Samp_Fields>;
  variance?: Maybe<User_Feature_Flags_Variance_Fields>;
};


/** aggregate fields of "user_feature_flags" */
export type User_Feature_Flags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Feature_Flags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Feature_Flags_Avg_Fields = {
  __typename?: 'user_feature_flags_avg_fields';
  feature_flag_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_feature_flags". All fields are combined with a logical 'AND'. */
export type User_Feature_Flags_Bool_Exp = {
  _and?: InputMaybe<Array<User_Feature_Flags_Bool_Exp>>;
  _not?: InputMaybe<User_Feature_Flags_Bool_Exp>;
  _or?: InputMaybe<Array<User_Feature_Flags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  feature_flag?: InputMaybe<Feature_Flags_Bool_Exp>;
  feature_flag_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_feature_flags" */
export enum User_Feature_Flags_Constraint {
  /** unique or primary key constraint on columns "feature_flag_id", "user_id" */
  UserFeatureFlagsPkey = 'user_feature_flags_pkey'
}

/** input type for incrementing numeric columns in table "user_feature_flags" */
export type User_Feature_Flags_Inc_Input = {
  feature_flag_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_feature_flags" */
export type User_Feature_Flags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feature_flag?: InputMaybe<Feature_Flags_Obj_Rel_Insert_Input>;
  feature_flag_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Feature_Flags_Max_Fields = {
  __typename?: 'user_feature_flags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  feature_flag_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type User_Feature_Flags_Min_Fields = {
  __typename?: 'user_feature_flags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  feature_flag_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_feature_flags" */
export type User_Feature_Flags_Mutation_Response = {
  __typename?: 'user_feature_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Feature_Flags>;
};

/** on_conflict condition type for table "user_feature_flags" */
export type User_Feature_Flags_On_Conflict = {
  constraint: User_Feature_Flags_Constraint;
  update_columns?: Array<User_Feature_Flags_Update_Column>;
  where?: InputMaybe<User_Feature_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "user_feature_flags". */
export type User_Feature_Flags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feature_flag?: InputMaybe<Feature_Flags_Order_By>;
  feature_flag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_feature_flags */
export type User_Feature_Flags_Pk_Columns_Input = {
  feature_flag_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_feature_flags" */
export enum User_Feature_Flags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeatureFlagId = 'feature_flag_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_feature_flags" */
export type User_Feature_Flags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feature_flag_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Feature_Flags_Stddev_Fields = {
  __typename?: 'user_feature_flags_stddev_fields';
  feature_flag_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Feature_Flags_Stddev_Pop_Fields = {
  __typename?: 'user_feature_flags_stddev_pop_fields';
  feature_flag_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Feature_Flags_Stddev_Samp_Fields = {
  __typename?: 'user_feature_flags_stddev_samp_fields';
  feature_flag_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_feature_flags" */
export type User_Feature_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Feature_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Feature_Flags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feature_flag_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Feature_Flags_Sum_Fields = {
  __typename?: 'user_feature_flags_sum_fields';
  feature_flag_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_feature_flags" */
export enum User_Feature_Flags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeatureFlagId = 'feature_flag_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Feature_Flags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Feature_Flags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Feature_Flags_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Feature_Flags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Feature_Flags_Var_Pop_Fields = {
  __typename?: 'user_feature_flags_var_pop_fields';
  feature_flag_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Feature_Flags_Var_Samp_Fields = {
  __typename?: 'user_feature_flags_var_samp_fields';
  feature_flag_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Feature_Flags_Variance_Fields = {
  __typename?: 'user_feature_flags_variance_fields';
  feature_flag_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_hackathon_bounties" */
export type User_Hackathon_Bounties = {
  __typename?: 'user_hackathon_bounties';
  acknowledgment_pdf_path?: Maybe<Scalars['String']>;
  amount: Scalars['numeric'];
  bounty_type?: Maybe<User_Hackathon_Bounties_Bounty_Type_Enum>;
  created_at: Scalars['timestamptz'];
  currency?: Maybe<User_Hackathon_Bounties_Currency_Enum>;
  email_address?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  project_id?: Maybe<Scalars['Int']>;
  require_kyc_to_claim?: Maybe<Scalars['Boolean']>;
  safe_tx_hash?: Maybe<Scalars['String']>;
  status?: Maybe<User_Hackathon_Bounties_Status_Enum>;
  tx_hash?: Maybe<Scalars['String']>;
  tx_meta?: Maybe<Scalars['jsonb']>;
  tx_network?: Maybe<Scalars['String']>;
  type: User_Hackathon_Bounties_Type_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
  wallet_address?: Maybe<Scalars['String']>;
  winnings_breakdown: Scalars['jsonb'];
};


/** columns and relationships of "user_hackathon_bounties" */
export type User_Hackathon_BountiesTx_MetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_hackathon_bounties" */
export type User_Hackathon_BountiesWinnings_BreakdownArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Aggregate = {
  __typename?: 'user_hackathon_bounties_aggregate';
  aggregate?: Maybe<User_Hackathon_Bounties_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Bounties>;
};

export type User_Hackathon_Bounties_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Hackathon_Bounties_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Hackathon_Bounties_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Hackathon_Bounties_Aggregate_Bool_Exp_Count>;
};

export type User_Hackathon_Bounties_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Hackathon_Bounties_Select_Column_User_Hackathon_Bounties_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Hackathon_Bounties_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Hackathon_Bounties_Select_Column_User_Hackathon_Bounties_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Hackathon_Bounties_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Aggregate_Fields = {
  __typename?: 'user_hackathon_bounties_aggregate_fields';
  avg?: Maybe<User_Hackathon_Bounties_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Bounties_Max_Fields>;
  min?: Maybe<User_Hackathon_Bounties_Min_Fields>;
  stddev?: Maybe<User_Hackathon_Bounties_Stddev_Fields>;
  stddev_pop?: Maybe<User_Hackathon_Bounties_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Hackathon_Bounties_Stddev_Samp_Fields>;
  sum?: Maybe<User_Hackathon_Bounties_Sum_Fields>;
  var_pop?: Maybe<User_Hackathon_Bounties_Var_Pop_Fields>;
  var_samp?: Maybe<User_Hackathon_Bounties_Var_Samp_Fields>;
  variance?: Maybe<User_Hackathon_Bounties_Variance_Fields>;
};


/** aggregate fields of "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Aggregate_Order_By = {
  avg?: InputMaybe<User_Hackathon_Bounties_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Hackathon_Bounties_Max_Order_By>;
  min?: InputMaybe<User_Hackathon_Bounties_Min_Order_By>;
  stddev?: InputMaybe<User_Hackathon_Bounties_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Hackathon_Bounties_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Hackathon_Bounties_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Hackathon_Bounties_Sum_Order_By>;
  var_pop?: InputMaybe<User_Hackathon_Bounties_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Hackathon_Bounties_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Hackathon_Bounties_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Hackathon_Bounties_Append_Input = {
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  winnings_breakdown?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Arr_Rel_Insert_Input = {
  data: Array<User_Hackathon_Bounties_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Hackathon_Bounties_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Hackathon_Bounties_Avg_Fields = {
  __typename?: 'user_hackathon_bounties_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_hackathon_bounties". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Bounties_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Bounties_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Bounties_Bool_Exp>>;
  acknowledgment_pdf_path?: InputMaybe<String_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  bounty_type?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<User_Hackathon_Bounties_Currency_Enum_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  require_kyc_to_claim?: InputMaybe<Boolean_Comparison_Exp>;
  safe_tx_hash?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<User_Hackathon_Bounties_Status_Enum_Comparison_Exp>;
  tx_hash?: InputMaybe<String_Comparison_Exp>;
  tx_meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tx_network?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<User_Hackathon_Bounties_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  wallet_address?: InputMaybe<String_Comparison_Exp>;
  winnings_breakdown?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** columns and relationships of "user_hackathon_bounties_bounty_type" */
export type User_Hackathon_Bounties_Bounty_Type = {
  __typename?: 'user_hackathon_bounties_bounty_type';
  value: Scalars['String'];
};

/** aggregated selection of "user_hackathon_bounties_bounty_type" */
export type User_Hackathon_Bounties_Bounty_Type_Aggregate = {
  __typename?: 'user_hackathon_bounties_bounty_type_aggregate';
  aggregate?: Maybe<User_Hackathon_Bounties_Bounty_Type_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Bounties_Bounty_Type>;
};

/** aggregate fields of "user_hackathon_bounties_bounty_type" */
export type User_Hackathon_Bounties_Bounty_Type_Aggregate_Fields = {
  __typename?: 'user_hackathon_bounties_bounty_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Bounties_Bounty_Type_Max_Fields>;
  min?: Maybe<User_Hackathon_Bounties_Bounty_Type_Min_Fields>;
};


/** aggregate fields of "user_hackathon_bounties_bounty_type" */
export type User_Hackathon_Bounties_Bounty_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_hackathon_bounties_bounty_type". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Bounties_Bounty_Type_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_bounties_bounty_type" */
export enum User_Hackathon_Bounties_Bounty_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserHackathonBountiesBountyTypePkey = 'user_hackathon_bounties_bounty_type_pkey'
}

export enum User_Hackathon_Bounties_Bounty_Type_Enum {
  Sponsorship = 'SPONSORSHIP',
  Winnings = 'WINNINGS'
}

/** Boolean expression to compare columns of type "user_hackathon_bounties_bounty_type_enum". All fields are combined with logical 'AND'. */
export type User_Hackathon_Bounties_Bounty_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Enum>;
  _in?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Enum>;
  _nin?: InputMaybe<Array<User_Hackathon_Bounties_Bounty_Type_Enum>>;
};

/** input type for inserting data into table "user_hackathon_bounties_bounty_type" */
export type User_Hackathon_Bounties_Bounty_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Bounties_Bounty_Type_Max_Fields = {
  __typename?: 'user_hackathon_bounties_bounty_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Hackathon_Bounties_Bounty_Type_Min_Fields = {
  __typename?: 'user_hackathon_bounties_bounty_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_hackathon_bounties_bounty_type" */
export type User_Hackathon_Bounties_Bounty_Type_Mutation_Response = {
  __typename?: 'user_hackathon_bounties_bounty_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Bounties_Bounty_Type>;
};

/** on_conflict condition type for table "user_hackathon_bounties_bounty_type" */
export type User_Hackathon_Bounties_Bounty_Type_On_Conflict = {
  constraint: User_Hackathon_Bounties_Bounty_Type_Constraint;
  update_columns?: Array<User_Hackathon_Bounties_Bounty_Type_Update_Column>;
  where?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_bounties_bounty_type". */
export type User_Hackathon_Bounties_Bounty_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_bounties_bounty_type */
export type User_Hackathon_Bounties_Bounty_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_hackathon_bounties_bounty_type" */
export enum User_Hackathon_Bounties_Bounty_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_bounties_bounty_type" */
export type User_Hackathon_Bounties_Bounty_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_hackathon_bounties_bounty_type" */
export type User_Hackathon_Bounties_Bounty_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Bounties_Bounty_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Bounties_Bounty_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_hackathon_bounties_bounty_type" */
export enum User_Hackathon_Bounties_Bounty_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Bounties_Bounty_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Bounties_Bounty_Type_Bool_Exp;
};

/** unique or primary key constraints on table "user_hackathon_bounties" */
export enum User_Hackathon_Bounties_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserHackathonBountiesPkey = 'user_hackathon_bounties_pkey',
  /** unique or primary key constraint on columns "uuid" */
  UserHackathonBountiesUuidKey = 'user_hackathon_bounties_uuid_key'
}

/** columns and relationships of "user_hackathon_bounties_currency" */
export type User_Hackathon_Bounties_Currency = {
  __typename?: 'user_hackathon_bounties_currency';
  value: Scalars['String'];
};

/** aggregated selection of "user_hackathon_bounties_currency" */
export type User_Hackathon_Bounties_Currency_Aggregate = {
  __typename?: 'user_hackathon_bounties_currency_aggregate';
  aggregate?: Maybe<User_Hackathon_Bounties_Currency_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Bounties_Currency>;
};

/** aggregate fields of "user_hackathon_bounties_currency" */
export type User_Hackathon_Bounties_Currency_Aggregate_Fields = {
  __typename?: 'user_hackathon_bounties_currency_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Bounties_Currency_Max_Fields>;
  min?: Maybe<User_Hackathon_Bounties_Currency_Min_Fields>;
};


/** aggregate fields of "user_hackathon_bounties_currency" */
export type User_Hackathon_Bounties_Currency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_hackathon_bounties_currency". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Bounties_Currency_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Bounties_Currency_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_bounties_currency" */
export enum User_Hackathon_Bounties_Currency_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserHackathonBountiesCurrencyPkey = 'user_hackathon_bounties_currency_pkey'
}

export enum User_Hackathon_Bounties_Currency_Enum {
  Eth = 'ETH',
  Usd = 'USD'
}

/** Boolean expression to compare columns of type "user_hackathon_bounties_currency_enum". All fields are combined with logical 'AND'. */
export type User_Hackathon_Bounties_Currency_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Hackathon_Bounties_Currency_Enum>;
  _in?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Hackathon_Bounties_Currency_Enum>;
  _nin?: InputMaybe<Array<User_Hackathon_Bounties_Currency_Enum>>;
};

/** input type for inserting data into table "user_hackathon_bounties_currency" */
export type User_Hackathon_Bounties_Currency_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Bounties_Currency_Max_Fields = {
  __typename?: 'user_hackathon_bounties_currency_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Hackathon_Bounties_Currency_Min_Fields = {
  __typename?: 'user_hackathon_bounties_currency_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_hackathon_bounties_currency" */
export type User_Hackathon_Bounties_Currency_Mutation_Response = {
  __typename?: 'user_hackathon_bounties_currency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Bounties_Currency>;
};

/** on_conflict condition type for table "user_hackathon_bounties_currency" */
export type User_Hackathon_Bounties_Currency_On_Conflict = {
  constraint: User_Hackathon_Bounties_Currency_Constraint;
  update_columns?: Array<User_Hackathon_Bounties_Currency_Update_Column>;
  where?: InputMaybe<User_Hackathon_Bounties_Currency_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_bounties_currency". */
export type User_Hackathon_Bounties_Currency_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_bounties_currency */
export type User_Hackathon_Bounties_Currency_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_hackathon_bounties_currency" */
export enum User_Hackathon_Bounties_Currency_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_bounties_currency" */
export type User_Hackathon_Bounties_Currency_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_hackathon_bounties_currency" */
export type User_Hackathon_Bounties_Currency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Bounties_Currency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Bounties_Currency_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_hackathon_bounties_currency" */
export enum User_Hackathon_Bounties_Currency_Update_Column {
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Bounties_Currency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Bounties_Currency_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Bounties_Currency_Bool_Exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Hackathon_Bounties_Delete_At_Path_Input = {
  tx_meta?: InputMaybe<Array<Scalars['String']>>;
  winnings_breakdown?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Hackathon_Bounties_Delete_Elem_Input = {
  tx_meta?: InputMaybe<Scalars['Int']>;
  winnings_breakdown?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Hackathon_Bounties_Delete_Key_Input = {
  tx_meta?: InputMaybe<Scalars['String']>;
  winnings_breakdown?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Insert_Input = {
  acknowledgment_pdf_path?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  bounty_type?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<User_Hackathon_Bounties_Currency_Enum>;
  email_address?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  require_kyc_to_claim?: InputMaybe<Scalars['Boolean']>;
  safe_tx_hash?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<User_Hackathon_Bounties_Status_Enum>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<User_Hackathon_Bounties_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
  winnings_breakdown?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type User_Hackathon_Bounties_Max_Fields = {
  __typename?: 'user_hackathon_bounties_max_fields';
  acknowledgment_pdf_path?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_address?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  safe_tx_hash?: Maybe<Scalars['String']>;
  tx_hash?: Maybe<Scalars['String']>;
  tx_network?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Max_Order_By = {
  acknowledgment_pdf_path?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  safe_tx_hash?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  tx_network?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Hackathon_Bounties_Min_Fields = {
  __typename?: 'user_hackathon_bounties_min_fields';
  acknowledgment_pdf_path?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_address?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  safe_tx_hash?: Maybe<Scalars['String']>;
  tx_hash?: Maybe<Scalars['String']>;
  tx_network?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Min_Order_By = {
  acknowledgment_pdf_path?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  safe_tx_hash?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  tx_network?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Mutation_Response = {
  __typename?: 'user_hackathon_bounties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Bounties>;
};

/** on_conflict condition type for table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_On_Conflict = {
  constraint: User_Hackathon_Bounties_Constraint;
  update_columns?: Array<User_Hackathon_Bounties_Update_Column>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_bounties". */
export type User_Hackathon_Bounties_Order_By = {
  acknowledgment_pdf_path?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bounty_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  require_kyc_to_claim?: InputMaybe<Order_By>;
  safe_tx_hash?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  tx_meta?: InputMaybe<Order_By>;
  tx_network?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
  winnings_breakdown?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_bounties */
export type User_Hackathon_Bounties_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Hackathon_Bounties_Prepend_Input = {
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  winnings_breakdown?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_hackathon_bounties" */
export enum User_Hackathon_Bounties_Select_Column {
  /** column name */
  AcknowledgmentPdfPath = 'acknowledgment_pdf_path',
  /** column name */
  Amount = 'amount',
  /** column name */
  BountyType = 'bounty_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FullName = 'full_name',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RequireKycToClaim = 'require_kyc_to_claim',
  /** column name */
  SafeTxHash = 'safe_tx_hash',
  /** column name */
  Status = 'status',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  WalletAddress = 'wallet_address',
  /** column name */
  WinningsBreakdown = 'winnings_breakdown'
}

/** select "user_hackathon_bounties_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_hackathon_bounties" */
export enum User_Hackathon_Bounties_Select_Column_User_Hackathon_Bounties_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  RequireKycToClaim = 'require_kyc_to_claim'
}

/** select "user_hackathon_bounties_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_hackathon_bounties" */
export enum User_Hackathon_Bounties_Select_Column_User_Hackathon_Bounties_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  RequireKycToClaim = 'require_kyc_to_claim'
}

/** input type for updating data in table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Set_Input = {
  acknowledgment_pdf_path?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  bounty_type?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<User_Hackathon_Bounties_Currency_Enum>;
  email_address?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  require_kyc_to_claim?: InputMaybe<Scalars['Boolean']>;
  safe_tx_hash?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<User_Hackathon_Bounties_Status_Enum>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<User_Hackathon_Bounties_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
  winnings_breakdown?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "user_hackathon_bounties_status" */
export type User_Hackathon_Bounties_Status = {
  __typename?: 'user_hackathon_bounties_status';
  value: Scalars['String'];
};

/** aggregated selection of "user_hackathon_bounties_status" */
export type User_Hackathon_Bounties_Status_Aggregate = {
  __typename?: 'user_hackathon_bounties_status_aggregate';
  aggregate?: Maybe<User_Hackathon_Bounties_Status_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Bounties_Status>;
};

/** aggregate fields of "user_hackathon_bounties_status" */
export type User_Hackathon_Bounties_Status_Aggregate_Fields = {
  __typename?: 'user_hackathon_bounties_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Bounties_Status_Max_Fields>;
  min?: Maybe<User_Hackathon_Bounties_Status_Min_Fields>;
};


/** aggregate fields of "user_hackathon_bounties_status" */
export type User_Hackathon_Bounties_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Bounties_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_hackathon_bounties_status". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Bounties_Status_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Bounties_Status_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Bounties_Status_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Bounties_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_bounties_status" */
export enum User_Hackathon_Bounties_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserHackathonBountiesStatusPkey = 'user_hackathon_bounties_status_pkey'
}

export enum User_Hackathon_Bounties_Status_Enum {
  Eligible = 'ELIGIBLE',
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Proposed = 'PROPOSED',
  Rejected = 'REJECTED',
  UserAcknowledged = 'USER_ACKNOWLEDGED',
  Verified = 'VERIFIED'
}

/** Boolean expression to compare columns of type "user_hackathon_bounties_status_enum". All fields are combined with logical 'AND'. */
export type User_Hackathon_Bounties_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Hackathon_Bounties_Status_Enum>;
  _in?: InputMaybe<Array<User_Hackathon_Bounties_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Hackathon_Bounties_Status_Enum>;
  _nin?: InputMaybe<Array<User_Hackathon_Bounties_Status_Enum>>;
};

/** input type for inserting data into table "user_hackathon_bounties_status" */
export type User_Hackathon_Bounties_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Bounties_Status_Max_Fields = {
  __typename?: 'user_hackathon_bounties_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Hackathon_Bounties_Status_Min_Fields = {
  __typename?: 'user_hackathon_bounties_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_hackathon_bounties_status" */
export type User_Hackathon_Bounties_Status_Mutation_Response = {
  __typename?: 'user_hackathon_bounties_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Bounties_Status>;
};

/** on_conflict condition type for table "user_hackathon_bounties_status" */
export type User_Hackathon_Bounties_Status_On_Conflict = {
  constraint: User_Hackathon_Bounties_Status_Constraint;
  update_columns?: Array<User_Hackathon_Bounties_Status_Update_Column>;
  where?: InputMaybe<User_Hackathon_Bounties_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_bounties_status". */
export type User_Hackathon_Bounties_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_bounties_status */
export type User_Hackathon_Bounties_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_hackathon_bounties_status" */
export enum User_Hackathon_Bounties_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_bounties_status" */
export type User_Hackathon_Bounties_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_hackathon_bounties_status" */
export type User_Hackathon_Bounties_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Bounties_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Bounties_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_hackathon_bounties_status" */
export enum User_Hackathon_Bounties_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Bounties_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Bounties_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Bounties_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type User_Hackathon_Bounties_Stddev_Fields = {
  __typename?: 'user_hackathon_bounties_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Hackathon_Bounties_Stddev_Pop_Fields = {
  __typename?: 'user_hackathon_bounties_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Hackathon_Bounties_Stddev_Samp_Fields = {
  __typename?: 'user_hackathon_bounties_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Bounties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Bounties_Stream_Cursor_Value_Input = {
  acknowledgment_pdf_path?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  bounty_type?: InputMaybe<User_Hackathon_Bounties_Bounty_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<User_Hackathon_Bounties_Currency_Enum>;
  email_address?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  require_kyc_to_claim?: InputMaybe<Scalars['Boolean']>;
  safe_tx_hash?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<User_Hackathon_Bounties_Status_Enum>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<User_Hackathon_Bounties_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
  winnings_breakdown?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type User_Hackathon_Bounties_Sum_Fields = {
  __typename?: 'user_hackathon_bounties_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_hackathon_bounties_type" */
export type User_Hackathon_Bounties_Type = {
  __typename?: 'user_hackathon_bounties_type';
  value: Scalars['String'];
};

/** aggregated selection of "user_hackathon_bounties_type" */
export type User_Hackathon_Bounties_Type_Aggregate = {
  __typename?: 'user_hackathon_bounties_type_aggregate';
  aggregate?: Maybe<User_Hackathon_Bounties_Type_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Bounties_Type>;
};

/** aggregate fields of "user_hackathon_bounties_type" */
export type User_Hackathon_Bounties_Type_Aggregate_Fields = {
  __typename?: 'user_hackathon_bounties_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Bounties_Type_Max_Fields>;
  min?: Maybe<User_Hackathon_Bounties_Type_Min_Fields>;
};


/** aggregate fields of "user_hackathon_bounties_type" */
export type User_Hackathon_Bounties_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Bounties_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_hackathon_bounties_type". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Bounties_Type_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Bounties_Type_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Bounties_Type_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Bounties_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_bounties_type" */
export enum User_Hackathon_Bounties_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserHackathonBountiesTypePkey = 'user_hackathon_bounties_type_pkey'
}

export enum User_Hackathon_Bounties_Type_Enum {
  Crypto = 'CRYPTO',
  Fiat = 'FIAT'
}

/** Boolean expression to compare columns of type "user_hackathon_bounties_type_enum". All fields are combined with logical 'AND'. */
export type User_Hackathon_Bounties_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Hackathon_Bounties_Type_Enum>;
  _in?: InputMaybe<Array<User_Hackathon_Bounties_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Hackathon_Bounties_Type_Enum>;
  _nin?: InputMaybe<Array<User_Hackathon_Bounties_Type_Enum>>;
};

/** input type for inserting data into table "user_hackathon_bounties_type" */
export type User_Hackathon_Bounties_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Bounties_Type_Max_Fields = {
  __typename?: 'user_hackathon_bounties_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Hackathon_Bounties_Type_Min_Fields = {
  __typename?: 'user_hackathon_bounties_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_hackathon_bounties_type" */
export type User_Hackathon_Bounties_Type_Mutation_Response = {
  __typename?: 'user_hackathon_bounties_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Bounties_Type>;
};

/** on_conflict condition type for table "user_hackathon_bounties_type" */
export type User_Hackathon_Bounties_Type_On_Conflict = {
  constraint: User_Hackathon_Bounties_Type_Constraint;
  update_columns?: Array<User_Hackathon_Bounties_Type_Update_Column>;
  where?: InputMaybe<User_Hackathon_Bounties_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_bounties_type". */
export type User_Hackathon_Bounties_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_bounties_type */
export type User_Hackathon_Bounties_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_hackathon_bounties_type" */
export enum User_Hackathon_Bounties_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_bounties_type" */
export type User_Hackathon_Bounties_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_hackathon_bounties_type" */
export type User_Hackathon_Bounties_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Bounties_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Bounties_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_hackathon_bounties_type" */
export enum User_Hackathon_Bounties_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Bounties_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Bounties_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Bounties_Type_Bool_Exp;
};

/** update columns of table "user_hackathon_bounties" */
export enum User_Hackathon_Bounties_Update_Column {
  /** column name */
  AcknowledgmentPdfPath = 'acknowledgment_pdf_path',
  /** column name */
  Amount = 'amount',
  /** column name */
  BountyType = 'bounty_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FullName = 'full_name',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RequireKycToClaim = 'require_kyc_to_claim',
  /** column name */
  SafeTxHash = 'safe_tx_hash',
  /** column name */
  Status = 'status',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  WalletAddress = 'wallet_address',
  /** column name */
  WinningsBreakdown = 'winnings_breakdown'
}

export type User_Hackathon_Bounties_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Hackathon_Bounties_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Hackathon_Bounties_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Hackathon_Bounties_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Hackathon_Bounties_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Hackathon_Bounties_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Hackathon_Bounties_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Bounties_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Bounties_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Hackathon_Bounties_Var_Pop_Fields = {
  __typename?: 'user_hackathon_bounties_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Hackathon_Bounties_Var_Samp_Fields = {
  __typename?: 'user_hackathon_bounties_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Hackathon_Bounties_Variance_Fields = {
  __typename?: 'user_hackathon_bounties_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_hackathon_bounties" */
export type User_Hackathon_Bounties_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_hackathon_checklists" */
export type User_Hackathon_Checklists = {
  __typename?: 'user_hackathon_checklists';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_checklist_id: Scalars['Int'];
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Aggregate = {
  __typename?: 'user_hackathon_checklists_aggregate';
  aggregate?: Maybe<User_Hackathon_Checklists_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Checklists>;
};

export type User_Hackathon_Checklists_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Hackathon_Checklists_Aggregate_Bool_Exp_Count>;
};

export type User_Hackathon_Checklists_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Hackathon_Checklists_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Aggregate_Fields = {
  __typename?: 'user_hackathon_checklists_aggregate_fields';
  avg?: Maybe<User_Hackathon_Checklists_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Checklists_Max_Fields>;
  min?: Maybe<User_Hackathon_Checklists_Min_Fields>;
  stddev?: Maybe<User_Hackathon_Checklists_Stddev_Fields>;
  stddev_pop?: Maybe<User_Hackathon_Checklists_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Hackathon_Checklists_Stddev_Samp_Fields>;
  sum?: Maybe<User_Hackathon_Checklists_Sum_Fields>;
  var_pop?: Maybe<User_Hackathon_Checklists_Var_Pop_Fields>;
  var_samp?: Maybe<User_Hackathon_Checklists_Var_Samp_Fields>;
  variance?: Maybe<User_Hackathon_Checklists_Variance_Fields>;
};


/** aggregate fields of "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Checklists_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Aggregate_Order_By = {
  avg?: InputMaybe<User_Hackathon_Checklists_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Hackathon_Checklists_Max_Order_By>;
  min?: InputMaybe<User_Hackathon_Checklists_Min_Order_By>;
  stddev?: InputMaybe<User_Hackathon_Checklists_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Hackathon_Checklists_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Hackathon_Checklists_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Hackathon_Checklists_Sum_Order_By>;
  var_pop?: InputMaybe<User_Hackathon_Checklists_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Hackathon_Checklists_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Hackathon_Checklists_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Arr_Rel_Insert_Input = {
  data: Array<User_Hackathon_Checklists_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Hackathon_Checklists_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Hackathon_Checklists_Avg_Fields = {
  __typename?: 'user_hackathon_checklists_avg_fields';
  hackathon_checklist_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Avg_Order_By = {
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_hackathon_checklists". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Checklists_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Checklists_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Checklists_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_checklist_id?: InputMaybe<Int_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_checklists" */
export enum User_Hackathon_Checklists_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkUserHackathonChecklists = 'pk_user_hackathon_checklists',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidUserHackathonChecklists = 'unique_uuid_user_hackathon_checklists'
}

/** input type for incrementing numeric columns in table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Inc_Input = {
  hackathon_checklist_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_checklist_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Checklists_Max_Fields = {
  __typename?: 'user_hackathon_checklists_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_checklist_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Hackathon_Checklists_Min_Fields = {
  __typename?: 'user_hackathon_checklists_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_checklist_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Mutation_Response = {
  __typename?: 'user_hackathon_checklists_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Checklists>;
};

/** on_conflict condition type for table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_On_Conflict = {
  constraint: User_Hackathon_Checklists_Constraint;
  update_columns?: Array<User_Hackathon_Checklists_Update_Column>;
  where?: InputMaybe<User_Hackathon_Checklists_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_checklists". */
export type User_Hackathon_Checklists_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_checklists */
export type User_Hackathon_Checklists_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_hackathon_checklists" */
export enum User_Hackathon_Checklists_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonChecklistId = 'hackathon_checklist_id',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_checklist_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Hackathon_Checklists_Stddev_Fields = {
  __typename?: 'user_hackathon_checklists_stddev_fields';
  hackathon_checklist_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Stddev_Order_By = {
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Hackathon_Checklists_Stddev_Pop_Fields = {
  __typename?: 'user_hackathon_checklists_stddev_pop_fields';
  hackathon_checklist_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Stddev_Pop_Order_By = {
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Hackathon_Checklists_Stddev_Samp_Fields = {
  __typename?: 'user_hackathon_checklists_stddev_samp_fields';
  hackathon_checklist_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Stddev_Samp_Order_By = {
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Checklists_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Checklists_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_checklist_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Hackathon_Checklists_Sum_Fields = {
  __typename?: 'user_hackathon_checklists_sum_fields';
  hackathon_checklist_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Sum_Order_By = {
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_hackathon_checklists" */
export enum User_Hackathon_Checklists_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonChecklistId = 'hackathon_checklist_id',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Checklists_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Hackathon_Checklists_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Checklists_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Checklists_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Hackathon_Checklists_Var_Pop_Fields = {
  __typename?: 'user_hackathon_checklists_var_pop_fields';
  hackathon_checklist_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Var_Pop_Order_By = {
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Hackathon_Checklists_Var_Samp_Fields = {
  __typename?: 'user_hackathon_checklists_var_samp_fields';
  hackathon_checklist_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Var_Samp_Order_By = {
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Hackathon_Checklists_Variance_Fields = {
  __typename?: 'user_hackathon_checklists_variance_fields';
  hackathon_checklist_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_hackathon_checklists" */
export type User_Hackathon_Checklists_Variance_Order_By = {
  hackathon_checklist_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_hackathon_credentials" */
export type User_Hackathon_Credentials = {
  __typename?: 'user_hackathon_credentials';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  credential: Hackathon_Credentials;
  credential_id: Scalars['Int'];
  eas_details?: Maybe<Scalars['jsonb']>;
  eas_uuid?: Maybe<Scalars['String']>;
  /** An object relationship */
  hackathon: Hackathons;
  /** An object relationship */
  hackathon_credential: Hackathon_Credentials;
  hackathon_id: Scalars['Int'];
  id: Scalars['Int'];
  nft_ipfs_cid?: Maybe<Scalars['String']>;
  nft_metadata?: Maybe<Scalars['jsonb']>;
  status?: Maybe<User_Hackathon_Credentials_Status_Enum>;
  token_id?: Maybe<Scalars['String']>;
  tx_hash?: Maybe<Scalars['String']>;
  tx_meta?: Maybe<Scalars['jsonb']>;
  tx_network?: Maybe<Scalars['String']>;
  type: Hackathon_Credential_Eligible_Entities_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};


/** columns and relationships of "user_hackathon_credentials" */
export type User_Hackathon_CredentialsEas_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_hackathon_credentials" */
export type User_Hackathon_CredentialsNft_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_hackathon_credentials" */
export type User_Hackathon_CredentialsTx_MetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Aggregate = {
  __typename?: 'user_hackathon_credentials_aggregate';
  aggregate?: Maybe<User_Hackathon_Credentials_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Credentials>;
};

export type User_Hackathon_Credentials_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Hackathon_Credentials_Aggregate_Bool_Exp_Count>;
};

export type User_Hackathon_Credentials_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Hackathon_Credentials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Aggregate_Fields = {
  __typename?: 'user_hackathon_credentials_aggregate_fields';
  avg?: Maybe<User_Hackathon_Credentials_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Credentials_Max_Fields>;
  min?: Maybe<User_Hackathon_Credentials_Min_Fields>;
  stddev?: Maybe<User_Hackathon_Credentials_Stddev_Fields>;
  stddev_pop?: Maybe<User_Hackathon_Credentials_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Hackathon_Credentials_Stddev_Samp_Fields>;
  sum?: Maybe<User_Hackathon_Credentials_Sum_Fields>;
  var_pop?: Maybe<User_Hackathon_Credentials_Var_Pop_Fields>;
  var_samp?: Maybe<User_Hackathon_Credentials_Var_Samp_Fields>;
  variance?: Maybe<User_Hackathon_Credentials_Variance_Fields>;
};


/** aggregate fields of "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Credentials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Aggregate_Order_By = {
  avg?: InputMaybe<User_Hackathon_Credentials_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Hackathon_Credentials_Max_Order_By>;
  min?: InputMaybe<User_Hackathon_Credentials_Min_Order_By>;
  stddev?: InputMaybe<User_Hackathon_Credentials_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Hackathon_Credentials_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Hackathon_Credentials_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Hackathon_Credentials_Sum_Order_By>;
  var_pop?: InputMaybe<User_Hackathon_Credentials_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Hackathon_Credentials_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Hackathon_Credentials_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Hackathon_Credentials_Append_Input = {
  eas_details?: InputMaybe<Scalars['jsonb']>;
  nft_metadata?: InputMaybe<Scalars['jsonb']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Arr_Rel_Insert_Input = {
  data: Array<User_Hackathon_Credentials_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Hackathon_Credentials_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Hackathon_Credentials_Avg_Fields = {
  __typename?: 'user_hackathon_credentials_avg_fields';
  credential_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Avg_Order_By = {
  credential_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_hackathon_credentials". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Credentials_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Credentials_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Credentials_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credential?: InputMaybe<Hackathon_Credentials_Bool_Exp>;
  credential_id?: InputMaybe<Int_Comparison_Exp>;
  eas_details?: InputMaybe<Jsonb_Comparison_Exp>;
  eas_uuid?: InputMaybe<String_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_credential?: InputMaybe<Hackathon_Credentials_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nft_ipfs_cid?: InputMaybe<String_Comparison_Exp>;
  nft_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<User_Hackathon_Credentials_Status_Enum_Comparison_Exp>;
  token_id?: InputMaybe<String_Comparison_Exp>;
  tx_hash?: InputMaybe<String_Comparison_Exp>;
  tx_meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tx_network?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_credentials" */
export enum User_Hackathon_Credentials_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserHackathonCredentialsPkey = 'user_hackathon_credentials_pkey',
  /** unique or primary key constraint on columns "user_id", "hackathon_id", "credential_id" */
  UserHackathonCredentialsUserIdHackathonIdCredentialKey = 'user_hackathon_credentials_user_id_hackathon_id_credential__key',
  /** unique or primary key constraint on columns "uuid" */
  UserHackathonCredentialsUuidKey = 'user_hackathon_credentials_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Hackathon_Credentials_Delete_At_Path_Input = {
  eas_details?: InputMaybe<Array<Scalars['String']>>;
  nft_metadata?: InputMaybe<Array<Scalars['String']>>;
  tx_meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Hackathon_Credentials_Delete_Elem_Input = {
  eas_details?: InputMaybe<Scalars['Int']>;
  nft_metadata?: InputMaybe<Scalars['Int']>;
  tx_meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Hackathon_Credentials_Delete_Key_Input = {
  eas_details?: InputMaybe<Scalars['String']>;
  nft_metadata?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Inc_Input = {
  credential_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credential?: InputMaybe<Hackathon_Credentials_Obj_Rel_Insert_Input>;
  credential_id?: InputMaybe<Scalars['Int']>;
  eas_details?: InputMaybe<Scalars['jsonb']>;
  eas_uuid?: InputMaybe<Scalars['String']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_credential?: InputMaybe<Hackathon_Credentials_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nft_ipfs_cid?: InputMaybe<Scalars['String']>;
  nft_metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<User_Hackathon_Credentials_Status_Enum>;
  token_id?: InputMaybe<Scalars['String']>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Credentials_Max_Fields = {
  __typename?: 'user_hackathon_credentials_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credential_id?: Maybe<Scalars['Int']>;
  eas_uuid?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nft_ipfs_cid?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  tx_hash?: Maybe<Scalars['String']>;
  tx_network?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credential_id?: InputMaybe<Order_By>;
  eas_uuid?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nft_ipfs_cid?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  tx_network?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Hackathon_Credentials_Min_Fields = {
  __typename?: 'user_hackathon_credentials_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credential_id?: Maybe<Scalars['Int']>;
  eas_uuid?: Maybe<Scalars['String']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nft_ipfs_cid?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  tx_hash?: Maybe<Scalars['String']>;
  tx_network?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credential_id?: InputMaybe<Order_By>;
  eas_uuid?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nft_ipfs_cid?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  tx_network?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Mutation_Response = {
  __typename?: 'user_hackathon_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Credentials>;
};

/** on_conflict condition type for table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_On_Conflict = {
  constraint: User_Hackathon_Credentials_Constraint;
  update_columns?: Array<User_Hackathon_Credentials_Update_Column>;
  where?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_credentials". */
export type User_Hackathon_Credentials_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credential?: InputMaybe<Hackathon_Credentials_Order_By>;
  credential_id?: InputMaybe<Order_By>;
  eas_details?: InputMaybe<Order_By>;
  eas_uuid?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_credential?: InputMaybe<Hackathon_Credentials_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nft_ipfs_cid?: InputMaybe<Order_By>;
  nft_metadata?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  tx_meta?: InputMaybe<Order_By>;
  tx_network?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_credentials */
export type User_Hackathon_Credentials_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Hackathon_Credentials_Prepend_Input = {
  eas_details?: InputMaybe<Scalars['jsonb']>;
  nft_metadata?: InputMaybe<Scalars['jsonb']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_hackathon_credentials" */
export enum User_Hackathon_Credentials_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CredentialId = 'credential_id',
  /** column name */
  EasDetails = 'eas_details',
  /** column name */
  EasUuid = 'eas_uuid',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  NftIpfsCid = 'nft_ipfs_cid',
  /** column name */
  NftMetadata = 'nft_metadata',
  /** column name */
  Status = 'status',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credential_id?: InputMaybe<Scalars['Int']>;
  eas_details?: InputMaybe<Scalars['jsonb']>;
  eas_uuid?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nft_ipfs_cid?: InputMaybe<Scalars['String']>;
  nft_metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<User_Hackathon_Credentials_Status_Enum>;
  token_id?: InputMaybe<Scalars['String']>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user_hackathon_credentials_status" */
export type User_Hackathon_Credentials_Status = {
  __typename?: 'user_hackathon_credentials_status';
  value: Scalars['String'];
};

/** aggregated selection of "user_hackathon_credentials_status" */
export type User_Hackathon_Credentials_Status_Aggregate = {
  __typename?: 'user_hackathon_credentials_status_aggregate';
  aggregate?: Maybe<User_Hackathon_Credentials_Status_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Credentials_Status>;
};

/** aggregate fields of "user_hackathon_credentials_status" */
export type User_Hackathon_Credentials_Status_Aggregate_Fields = {
  __typename?: 'user_hackathon_credentials_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Credentials_Status_Max_Fields>;
  min?: Maybe<User_Hackathon_Credentials_Status_Min_Fields>;
};


/** aggregate fields of "user_hackathon_credentials_status" */
export type User_Hackathon_Credentials_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Credentials_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_hackathon_credentials_status". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Credentials_Status_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Credentials_Status_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Credentials_Status_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Credentials_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_credentials_status" */
export enum User_Hackathon_Credentials_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserHackathonCredentialsStatusPkey = 'user_hackathon_credentials_status_pkey'
}

export enum User_Hackathon_Credentials_Status_Enum {
  Claimed = 'CLAIMED',
  Eligible = 'ELIGIBLE',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

/** Boolean expression to compare columns of type "user_hackathon_credentials_status_enum". All fields are combined with logical 'AND'. */
export type User_Hackathon_Credentials_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Hackathon_Credentials_Status_Enum>;
  _in?: InputMaybe<Array<User_Hackathon_Credentials_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Hackathon_Credentials_Status_Enum>;
  _nin?: InputMaybe<Array<User_Hackathon_Credentials_Status_Enum>>;
};

/** input type for inserting data into table "user_hackathon_credentials_status" */
export type User_Hackathon_Credentials_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Credentials_Status_Max_Fields = {
  __typename?: 'user_hackathon_credentials_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Hackathon_Credentials_Status_Min_Fields = {
  __typename?: 'user_hackathon_credentials_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_hackathon_credentials_status" */
export type User_Hackathon_Credentials_Status_Mutation_Response = {
  __typename?: 'user_hackathon_credentials_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Credentials_Status>;
};

/** on_conflict condition type for table "user_hackathon_credentials_status" */
export type User_Hackathon_Credentials_Status_On_Conflict = {
  constraint: User_Hackathon_Credentials_Status_Constraint;
  update_columns?: Array<User_Hackathon_Credentials_Status_Update_Column>;
  where?: InputMaybe<User_Hackathon_Credentials_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_credentials_status". */
export type User_Hackathon_Credentials_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_credentials_status */
export type User_Hackathon_Credentials_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_hackathon_credentials_status" */
export enum User_Hackathon_Credentials_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_credentials_status" */
export type User_Hackathon_Credentials_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_hackathon_credentials_status" */
export type User_Hackathon_Credentials_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Credentials_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Credentials_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_hackathon_credentials_status" */
export enum User_Hackathon_Credentials_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Credentials_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Credentials_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Credentials_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type User_Hackathon_Credentials_Stddev_Fields = {
  __typename?: 'user_hackathon_credentials_stddev_fields';
  credential_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Stddev_Order_By = {
  credential_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Hackathon_Credentials_Stddev_Pop_Fields = {
  __typename?: 'user_hackathon_credentials_stddev_pop_fields';
  credential_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Stddev_Pop_Order_By = {
  credential_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Hackathon_Credentials_Stddev_Samp_Fields = {
  __typename?: 'user_hackathon_credentials_stddev_samp_fields';
  credential_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Stddev_Samp_Order_By = {
  credential_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Credentials_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Credentials_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credential_id?: InputMaybe<Scalars['Int']>;
  eas_details?: InputMaybe<Scalars['jsonb']>;
  eas_uuid?: InputMaybe<Scalars['String']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nft_ipfs_cid?: InputMaybe<Scalars['String']>;
  nft_metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<User_Hackathon_Credentials_Status_Enum>;
  token_id?: InputMaybe<Scalars['String']>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Hackathon_Credential_Eligible_Entities_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Hackathon_Credentials_Sum_Fields = {
  __typename?: 'user_hackathon_credentials_sum_fields';
  credential_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Sum_Order_By = {
  credential_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_hackathon_credentials" */
export enum User_Hackathon_Credentials_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CredentialId = 'credential_id',
  /** column name */
  EasDetails = 'eas_details',
  /** column name */
  EasUuid = 'eas_uuid',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  NftIpfsCid = 'nft_ipfs_cid',
  /** column name */
  NftMetadata = 'nft_metadata',
  /** column name */
  Status = 'status',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Hackathon_Credentials_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Hackathon_Credentials_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Hackathon_Credentials_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Hackathon_Credentials_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Hackathon_Credentials_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Hackathon_Credentials_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Hackathon_Credentials_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Credentials_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Credentials_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Hackathon_Credentials_Var_Pop_Fields = {
  __typename?: 'user_hackathon_credentials_var_pop_fields';
  credential_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Var_Pop_Order_By = {
  credential_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Hackathon_Credentials_Var_Samp_Fields = {
  __typename?: 'user_hackathon_credentials_var_samp_fields';
  credential_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Var_Samp_Order_By = {
  credential_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Hackathon_Credentials_Variance_Fields = {
  __typename?: 'user_hackathon_credentials_variance_fields';
  credential_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_hackathon_credentials" */
export type User_Hackathon_Credentials_Variance_Order_By = {
  credential_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_hackathon_extras" */
export type User_Hackathon_Extras = {
  __typename?: 'user_hackathon_extras';
  company_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  hackathon_id: Scalars['Int'];
  hackathon_scope_extra_id: Scalars['Int'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "user_hackathon_extras" */
export type User_Hackathon_Extras_Aggregate = {
  __typename?: 'user_hackathon_extras_aggregate';
  aggregate?: Maybe<User_Hackathon_Extras_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Extras>;
};

/** aggregate fields of "user_hackathon_extras" */
export type User_Hackathon_Extras_Aggregate_Fields = {
  __typename?: 'user_hackathon_extras_aggregate_fields';
  avg?: Maybe<User_Hackathon_Extras_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Extras_Max_Fields>;
  min?: Maybe<User_Hackathon_Extras_Min_Fields>;
  stddev?: Maybe<User_Hackathon_Extras_Stddev_Fields>;
  stddev_pop?: Maybe<User_Hackathon_Extras_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Hackathon_Extras_Stddev_Samp_Fields>;
  sum?: Maybe<User_Hackathon_Extras_Sum_Fields>;
  var_pop?: Maybe<User_Hackathon_Extras_Var_Pop_Fields>;
  var_samp?: Maybe<User_Hackathon_Extras_Var_Samp_Fields>;
  variance?: Maybe<User_Hackathon_Extras_Variance_Fields>;
};


/** aggregate fields of "user_hackathon_extras" */
export type User_Hackathon_Extras_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Extras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Hackathon_Extras_Avg_Fields = {
  __typename?: 'user_hackathon_extras_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_hackathon_extras". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Extras_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Extras_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Extras_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Extras_Bool_Exp>>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  hackathon_scope_extra_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_extras" */
export enum User_Hackathon_Extras_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkUserHackathonExtras = 'pk_user_hackathon_extras',
  /** unique or primary key constraint on columns "hackathon_scope_extra_id", "user_id", "hackathon_id" */
  UniqueUserIdHackathonIdHackathonScopeIdUhe = 'unique_user_id_hackathon_id_hackathon_scope_id_uhe',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidUserHackathonExtras = 'unique_uuid_user_hackathon_extras'
}

/** input type for incrementing numeric columns in table "user_hackathon_extras" */
export type User_Hackathon_Extras_Inc_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_scope_extra_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_hackathon_extras" */
export type User_Hackathon_Extras_Insert_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_scope_extra_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Extras_Max_Fields = {
  __typename?: 'user_hackathon_extras_max_fields';
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Hackathon_Extras_Min_Fields = {
  __typename?: 'user_hackathon_extras_min_fields';
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_hackathon_extras" */
export type User_Hackathon_Extras_Mutation_Response = {
  __typename?: 'user_hackathon_extras_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Extras>;
};

/** input type for inserting object relation for remote table "user_hackathon_extras" */
export type User_Hackathon_Extras_Obj_Rel_Insert_Input = {
  data: User_Hackathon_Extras_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Hackathon_Extras_On_Conflict>;
};

/** on_conflict condition type for table "user_hackathon_extras" */
export type User_Hackathon_Extras_On_Conflict = {
  constraint: User_Hackathon_Extras_Constraint;
  update_columns?: Array<User_Hackathon_Extras_Update_Column>;
  where?: InputMaybe<User_Hackathon_Extras_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_extras". */
export type User_Hackathon_Extras_Order_By = {
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hackathon_scope_extra_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_extras */
export type User_Hackathon_Extras_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_hackathon_extras" */
export enum User_Hackathon_Extras_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HackathonScopeExtraId = 'hackathon_scope_extra_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_extras" */
export type User_Hackathon_Extras_Set_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_scope_extra_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Hackathon_Extras_Stddev_Fields = {
  __typename?: 'user_hackathon_extras_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Hackathon_Extras_Stddev_Pop_Fields = {
  __typename?: 'user_hackathon_extras_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Hackathon_Extras_Stddev_Samp_Fields = {
  __typename?: 'user_hackathon_extras_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_hackathon_extras" */
export type User_Hackathon_Extras_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Extras_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Extras_Stream_Cursor_Value_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_scope_extra_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Hackathon_Extras_Sum_Fields = {
  __typename?: 'user_hackathon_extras_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_hackathon_extras" */
export enum User_Hackathon_Extras_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HackathonScopeExtraId = 'hackathon_scope_extra_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Extras_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Hackathon_Extras_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Extras_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Extras_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Hackathon_Extras_Var_Pop_Fields = {
  __typename?: 'user_hackathon_extras_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Hackathon_Extras_Var_Samp_Fields = {
  __typename?: 'user_hackathon_extras_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Hackathon_Extras_Variance_Fields = {
  __typename?: 'user_hackathon_extras_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_scope_extra_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks = {
  __typename?: 'user_hackathon_feedbacks';
  created_at: Scalars['timestamptz'];
  feedback_question_id: Scalars['Int'];
  hackathon_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Aggregate = {
  __typename?: 'user_hackathon_feedbacks_aggregate';
  aggregate?: Maybe<User_Hackathon_Feedbacks_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Feedbacks>;
};

export type User_Hackathon_Feedbacks_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Hackathon_Feedbacks_Aggregate_Bool_Exp_Count>;
};

export type User_Hackathon_Feedbacks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Hackathon_Feedbacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Aggregate_Fields = {
  __typename?: 'user_hackathon_feedbacks_aggregate_fields';
  avg?: Maybe<User_Hackathon_Feedbacks_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Feedbacks_Max_Fields>;
  min?: Maybe<User_Hackathon_Feedbacks_Min_Fields>;
  stddev?: Maybe<User_Hackathon_Feedbacks_Stddev_Fields>;
  stddev_pop?: Maybe<User_Hackathon_Feedbacks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Hackathon_Feedbacks_Stddev_Samp_Fields>;
  sum?: Maybe<User_Hackathon_Feedbacks_Sum_Fields>;
  var_pop?: Maybe<User_Hackathon_Feedbacks_Var_Pop_Fields>;
  var_samp?: Maybe<User_Hackathon_Feedbacks_Var_Samp_Fields>;
  variance?: Maybe<User_Hackathon_Feedbacks_Variance_Fields>;
};


/** aggregate fields of "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Feedbacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Aggregate_Order_By = {
  avg?: InputMaybe<User_Hackathon_Feedbacks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Hackathon_Feedbacks_Max_Order_By>;
  min?: InputMaybe<User_Hackathon_Feedbacks_Min_Order_By>;
  stddev?: InputMaybe<User_Hackathon_Feedbacks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Hackathon_Feedbacks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Hackathon_Feedbacks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Hackathon_Feedbacks_Sum_Order_By>;
  var_pop?: InputMaybe<User_Hackathon_Feedbacks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Hackathon_Feedbacks_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Hackathon_Feedbacks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Arr_Rel_Insert_Input = {
  data: Array<User_Hackathon_Feedbacks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Hackathon_Feedbacks_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Hackathon_Feedbacks_Avg_Fields = {
  __typename?: 'user_hackathon_feedbacks_avg_fields';
  feedback_question_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Avg_Order_By = {
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_hackathon_feedbacks". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Feedbacks_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Feedbacks_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Feedbacks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedback_question_id?: InputMaybe<Int_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_feedbacks" */
export enum User_Hackathon_Feedbacks_Constraint {
  /** unique or primary key constraint on columns "feedback_question_id", "user_id", "hackathon_id" */
  PkUserHackathonFeedbacks = 'pk_user_hackathon_feedbacks',
  /** unique or primary key constraint on columns "feedback_question_id", "user_id", "hackathon_id" */
  UniqueUhfIdUserHackathonFeedbacks = 'unique_uhf_id_user_hackathon_feedbacks'
}

/** input type for incrementing numeric columns in table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Inc_Input = {
  feedback_question_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feedback_question_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Feedbacks_Max_Fields = {
  __typename?: 'user_hackathon_feedbacks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  feedback_question_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Hackathon_Feedbacks_Min_Fields = {
  __typename?: 'user_hackathon_feedbacks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  feedback_question_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Mutation_Response = {
  __typename?: 'user_hackathon_feedbacks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Feedbacks>;
};

/** on_conflict condition type for table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_On_Conflict = {
  constraint: User_Hackathon_Feedbacks_Constraint;
  update_columns?: Array<User_Hackathon_Feedbacks_Update_Column>;
  where?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_feedbacks". */
export type User_Hackathon_Feedbacks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_feedbacks */
export type User_Hackathon_Feedbacks_Pk_Columns_Input = {
  feedback_question_id: Scalars['Int'];
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_hackathon_feedbacks" */
export enum User_Hackathon_Feedbacks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeedbackQuestionId = 'feedback_question_id',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feedback_question_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Hackathon_Feedbacks_Stddev_Fields = {
  __typename?: 'user_hackathon_feedbacks_stddev_fields';
  feedback_question_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Stddev_Order_By = {
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Hackathon_Feedbacks_Stddev_Pop_Fields = {
  __typename?: 'user_hackathon_feedbacks_stddev_pop_fields';
  feedback_question_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Stddev_Pop_Order_By = {
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Hackathon_Feedbacks_Stddev_Samp_Fields = {
  __typename?: 'user_hackathon_feedbacks_stddev_samp_fields';
  feedback_question_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Stddev_Samp_Order_By = {
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Feedbacks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Feedbacks_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feedback_question_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Hackathon_Feedbacks_Sum_Fields = {
  __typename?: 'user_hackathon_feedbacks_sum_fields';
  feedback_question_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Sum_Order_By = {
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_hackathon_feedbacks" */
export enum User_Hackathon_Feedbacks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeedbackQuestionId = 'feedback_question_id',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Feedbacks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Hackathon_Feedbacks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Feedbacks_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Feedbacks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Hackathon_Feedbacks_Var_Pop_Fields = {
  __typename?: 'user_hackathon_feedbacks_var_pop_fields';
  feedback_question_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Var_Pop_Order_By = {
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Hackathon_Feedbacks_Var_Samp_Fields = {
  __typename?: 'user_hackathon_feedbacks_var_samp_fields';
  feedback_question_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Var_Samp_Order_By = {
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Hackathon_Feedbacks_Variance_Fields = {
  __typename?: 'user_hackathon_feedbacks_variance_fields';
  feedback_question_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_hackathon_feedbacks" */
export type User_Hackathon_Feedbacks_Variance_Order_By = {
  feedback_question_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** This table is used to store the users that have asked to remind about hackathons */
export type User_Hackathon_Reminders = {
  __typename?: 'user_hackathon_reminders';
  created_at: Scalars['timestamptz'];
  email_reminder_sent: Scalars['Boolean'];
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  user_hackathon?: Maybe<User_Hackathons>;
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Aggregate = {
  __typename?: 'user_hackathon_reminders_aggregate';
  aggregate?: Maybe<User_Hackathon_Reminders_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Reminders>;
};

export type User_Hackathon_Reminders_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Hackathon_Reminders_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Hackathon_Reminders_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Hackathon_Reminders_Aggregate_Bool_Exp_Count>;
};

export type User_Hackathon_Reminders_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Hackathon_Reminders_Select_Column_User_Hackathon_Reminders_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Hackathon_Reminders_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Hackathon_Reminders_Select_Column_User_Hackathon_Reminders_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Hackathon_Reminders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Aggregate_Fields = {
  __typename?: 'user_hackathon_reminders_aggregate_fields';
  avg?: Maybe<User_Hackathon_Reminders_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Reminders_Max_Fields>;
  min?: Maybe<User_Hackathon_Reminders_Min_Fields>;
  stddev?: Maybe<User_Hackathon_Reminders_Stddev_Fields>;
  stddev_pop?: Maybe<User_Hackathon_Reminders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Hackathon_Reminders_Stddev_Samp_Fields>;
  sum?: Maybe<User_Hackathon_Reminders_Sum_Fields>;
  var_pop?: Maybe<User_Hackathon_Reminders_Var_Pop_Fields>;
  var_samp?: Maybe<User_Hackathon_Reminders_Var_Samp_Fields>;
  variance?: Maybe<User_Hackathon_Reminders_Variance_Fields>;
};


/** aggregate fields of "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Aggregate_Order_By = {
  avg?: InputMaybe<User_Hackathon_Reminders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Hackathon_Reminders_Max_Order_By>;
  min?: InputMaybe<User_Hackathon_Reminders_Min_Order_By>;
  stddev?: InputMaybe<User_Hackathon_Reminders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Hackathon_Reminders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Hackathon_Reminders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Hackathon_Reminders_Sum_Order_By>;
  var_pop?: InputMaybe<User_Hackathon_Reminders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Hackathon_Reminders_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Hackathon_Reminders_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Arr_Rel_Insert_Input = {
  data: Array<User_Hackathon_Reminders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Hackathon_Reminders_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Hackathon_Reminders_Avg_Fields = {
  __typename?: 'user_hackathon_reminders_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_hackathon_reminders". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Reminders_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Reminders_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Reminders_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_reminder_sent?: InputMaybe<Boolean_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_hackathon?: InputMaybe<User_Hackathons_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_reminders" */
export enum User_Hackathon_Reminders_Constraint {
  /** unique or primary key constraint on columns "user_id", "hackathon_id" */
  UserHackathonRemindersPkey = 'user_hackathon_reminders_pkey',
  /** unique or primary key constraint on columns "uuid" */
  UserHackathonRemindersUuidKey = 'user_hackathon_reminders_uuid_key'
}

/** input type for incrementing numeric columns in table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_reminder_sent?: InputMaybe<Scalars['Boolean']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_hackathon?: InputMaybe<User_Hackathons_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Reminders_Max_Fields = {
  __typename?: 'user_hackathon_reminders_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Hackathon_Reminders_Min_Fields = {
  __typename?: 'user_hackathon_reminders_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Mutation_Response = {
  __typename?: 'user_hackathon_reminders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Reminders>;
};

/** on_conflict condition type for table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_On_Conflict = {
  constraint: User_Hackathon_Reminders_Constraint;
  update_columns?: Array<User_Hackathon_Reminders_Update_Column>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_reminders". */
export type User_Hackathon_Reminders_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_reminder_sent?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_hackathon?: InputMaybe<User_Hackathons_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_reminders */
export type User_Hackathon_Reminders_Pk_Columns_Input = {
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_hackathon_reminders" */
export enum User_Hackathon_Reminders_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailReminderSent = 'email_reminder_sent',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** select "user_hackathon_reminders_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_hackathon_reminders" */
export enum User_Hackathon_Reminders_Select_Column_User_Hackathon_Reminders_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EmailReminderSent = 'email_reminder_sent'
}

/** select "user_hackathon_reminders_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_hackathon_reminders" */
export enum User_Hackathon_Reminders_Select_Column_User_Hackathon_Reminders_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EmailReminderSent = 'email_reminder_sent'
}

/** input type for updating data in table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_reminder_sent?: InputMaybe<Scalars['Boolean']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Hackathon_Reminders_Stddev_Fields = {
  __typename?: 'user_hackathon_reminders_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Hackathon_Reminders_Stddev_Pop_Fields = {
  __typename?: 'user_hackathon_reminders_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Hackathon_Reminders_Stddev_Samp_Fields = {
  __typename?: 'user_hackathon_reminders_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Reminders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Reminders_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_reminder_sent?: InputMaybe<Scalars['Boolean']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Hackathon_Reminders_Sum_Fields = {
  __typename?: 'user_hackathon_reminders_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_hackathon_reminders" */
export enum User_Hackathon_Reminders_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailReminderSent = 'email_reminder_sent',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Hackathon_Reminders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Hackathon_Reminders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Reminders_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Reminders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Hackathon_Reminders_Var_Pop_Fields = {
  __typename?: 'user_hackathon_reminders_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Hackathon_Reminders_Var_Samp_Fields = {
  __typename?: 'user_hackathon_reminders_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Hackathon_Reminders_Variance_Fields = {
  __typename?: 'user_hackathon_reminders_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_hackathon_reminders" */
export type User_Hackathon_Reminders_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_hackathon_schwags" */
export type User_Hackathon_Schwags = {
  __typename?: 'user_hackathon_schwags';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  order?: Maybe<Shop_Orders>;
  order_id?: Maybe<Scalars['Int']>;
  prizes: Scalars['jsonb'];
  status?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};


/** columns and relationships of "user_hackathon_schwags" */
export type User_Hackathon_SchwagsPrizesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Aggregate = {
  __typename?: 'user_hackathon_schwags_aggregate';
  aggregate?: Maybe<User_Hackathon_Schwags_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Schwags>;
};

export type User_Hackathon_Schwags_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Hackathon_Schwags_Aggregate_Bool_Exp_Count>;
};

export type User_Hackathon_Schwags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Hackathon_Schwags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Aggregate_Fields = {
  __typename?: 'user_hackathon_schwags_aggregate_fields';
  avg?: Maybe<User_Hackathon_Schwags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Schwags_Max_Fields>;
  min?: Maybe<User_Hackathon_Schwags_Min_Fields>;
  stddev?: Maybe<User_Hackathon_Schwags_Stddev_Fields>;
  stddev_pop?: Maybe<User_Hackathon_Schwags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Hackathon_Schwags_Stddev_Samp_Fields>;
  sum?: Maybe<User_Hackathon_Schwags_Sum_Fields>;
  var_pop?: Maybe<User_Hackathon_Schwags_Var_Pop_Fields>;
  var_samp?: Maybe<User_Hackathon_Schwags_Var_Samp_Fields>;
  variance?: Maybe<User_Hackathon_Schwags_Variance_Fields>;
};


/** aggregate fields of "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Schwags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Aggregate_Order_By = {
  avg?: InputMaybe<User_Hackathon_Schwags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Hackathon_Schwags_Max_Order_By>;
  min?: InputMaybe<User_Hackathon_Schwags_Min_Order_By>;
  stddev?: InputMaybe<User_Hackathon_Schwags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Hackathon_Schwags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Hackathon_Schwags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Hackathon_Schwags_Sum_Order_By>;
  var_pop?: InputMaybe<User_Hackathon_Schwags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Hackathon_Schwags_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Hackathon_Schwags_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Hackathon_Schwags_Append_Input = {
  prizes?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Arr_Rel_Insert_Input = {
  data: Array<User_Hackathon_Schwags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Hackathon_Schwags_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Hackathon_Schwags_Avg_Fields = {
  __typename?: 'user_hackathon_schwags_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Avg_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_hackathon_schwags". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Schwags_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Schwags_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Schwags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Shop_Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  prizes?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_schwags" */
export enum User_Hackathon_Schwags_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserHackathonSchwagsPkey = 'user_hackathon_schwags_pkey',
  /** unique or primary key constraint on columns "uuid" */
  UserHackathonSchwagsUuidKey = 'user_hackathon_schwags_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Hackathon_Schwags_Delete_At_Path_Input = {
  prizes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Hackathon_Schwags_Delete_Elem_Input = {
  prizes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Hackathon_Schwags_Delete_Key_Input = {
  prizes?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Shop_Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  prizes?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Schwags_Max_Fields = {
  __typename?: 'user_hackathon_schwags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Hackathon_Schwags_Min_Fields = {
  __typename?: 'user_hackathon_schwags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Mutation_Response = {
  __typename?: 'user_hackathon_schwags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Schwags>;
};

/** on_conflict condition type for table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_On_Conflict = {
  constraint: User_Hackathon_Schwags_Constraint;
  update_columns?: Array<User_Hackathon_Schwags_Update_Column>;
  where?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_schwags". */
export type User_Hackathon_Schwags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Shop_Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  prizes?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_schwags */
export type User_Hackathon_Schwags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Hackathon_Schwags_Prepend_Input = {
  prizes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_hackathon_schwags" */
export enum User_Hackathon_Schwags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Prizes = 'prizes',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  prizes?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Hackathon_Schwags_Stddev_Fields = {
  __typename?: 'user_hackathon_schwags_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Stddev_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Hackathon_Schwags_Stddev_Pop_Fields = {
  __typename?: 'user_hackathon_schwags_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Stddev_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Hackathon_Schwags_Stddev_Samp_Fields = {
  __typename?: 'user_hackathon_schwags_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Stddev_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Schwags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Schwags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  prizes?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Hackathon_Schwags_Sum_Fields = {
  __typename?: 'user_hackathon_schwags_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Sum_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_hackathon_schwags" */
export enum User_Hackathon_Schwags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Prizes = 'prizes',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Hackathon_Schwags_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Hackathon_Schwags_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Hackathon_Schwags_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Hackathon_Schwags_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Hackathon_Schwags_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Hackathon_Schwags_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Hackathon_Schwags_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Schwags_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Schwags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Hackathon_Schwags_Var_Pop_Fields = {
  __typename?: 'user_hackathon_schwags_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Var_Pop_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Hackathon_Schwags_Var_Samp_Fields = {
  __typename?: 'user_hackathon_schwags_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Var_Samp_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Hackathon_Schwags_Variance_Fields = {
  __typename?: 'user_hackathon_schwags_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_hackathon_schwags" */
export type User_Hackathon_Schwags_Variance_Order_By = {
  hackathon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** This table is used as an enum table to store the user hackathon staking razorpay payment status */
export type User_Hackathon_Staking_Razorpay_Payment_Status = {
  __typename?: 'user_hackathon_staking_razorpay_payment_status';
  value: Scalars['String'];
};

/** aggregated selection of "user_hackathon_staking_razorpay_payment_status" */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Aggregate = {
  __typename?: 'user_hackathon_staking_razorpay_payment_status_aggregate';
  aggregate?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Staking_Razorpay_Payment_Status>;
};

/** aggregate fields of "user_hackathon_staking_razorpay_payment_status" */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Aggregate_Fields = {
  __typename?: 'user_hackathon_staking_razorpay_payment_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status_Max_Fields>;
  min?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status_Min_Fields>;
};


/** aggregate fields of "user_hackathon_staking_razorpay_payment_status" */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_hackathon_staking_razorpay_payment_status". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_staking_razorpay_payment_status" */
export enum User_Hackathon_Staking_Razorpay_Payment_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserHackathonStakingRazorpayPaymentStatusPkey = 'user_hackathon_staking_razorpay_payment_status_pkey'
}

export enum User_Hackathon_Staking_Razorpay_Payment_Status_Enum {
  Authorized = 'authorized',
  Captured = 'captured',
  Created = 'created',
  Failed = 'failed',
  Refunded = 'refunded'
}

/** Boolean expression to compare columns of type "user_hackathon_staking_razorpay_payment_status_enum". All fields are combined with logical 'AND'. */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Enum>;
  _in?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Enum>;
  _nin?: InputMaybe<Array<User_Hackathon_Staking_Razorpay_Payment_Status_Enum>>;
};

/** input type for inserting data into table "user_hackathon_staking_razorpay_payment_status" */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Max_Fields = {
  __typename?: 'user_hackathon_staking_razorpay_payment_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Min_Fields = {
  __typename?: 'user_hackathon_staking_razorpay_payment_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_hackathon_staking_razorpay_payment_status" */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Mutation_Response = {
  __typename?: 'user_hackathon_staking_razorpay_payment_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Staking_Razorpay_Payment_Status>;
};

/** on_conflict condition type for table "user_hackathon_staking_razorpay_payment_status" */
export type User_Hackathon_Staking_Razorpay_Payment_Status_On_Conflict = {
  constraint: User_Hackathon_Staking_Razorpay_Payment_Status_Constraint;
  update_columns?: Array<User_Hackathon_Staking_Razorpay_Payment_Status_Update_Column>;
  where?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_staking_razorpay_payment_status". */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_staking_razorpay_payment_status */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_hackathon_staking_razorpay_payment_status" */
export enum User_Hackathon_Staking_Razorpay_Payment_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_staking_razorpay_payment_status" */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_hackathon_staking_razorpay_payment_status" */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Staking_Razorpay_Payment_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Staking_Razorpay_Payment_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_hackathon_staking_razorpay_payment_status" */
export enum User_Hackathon_Staking_Razorpay_Payment_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Staking_Razorpay_Payment_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Staking_Razorpay_Payment_Status_Bool_Exp;
};

/** This table is used as an enum table to store the types statuses for an hackathon stake */
export type User_Hackathon_Staking_Status = {
  __typename?: 'user_hackathon_staking_status';
  value: Scalars['String'];
};

/** aggregated selection of "user_hackathon_staking_status" */
export type User_Hackathon_Staking_Status_Aggregate = {
  __typename?: 'user_hackathon_staking_status_aggregate';
  aggregate?: Maybe<User_Hackathon_Staking_Status_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Staking_Status>;
};

/** aggregate fields of "user_hackathon_staking_status" */
export type User_Hackathon_Staking_Status_Aggregate_Fields = {
  __typename?: 'user_hackathon_staking_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Staking_Status_Max_Fields>;
  min?: Maybe<User_Hackathon_Staking_Status_Min_Fields>;
};


/** aggregate fields of "user_hackathon_staking_status" */
export type User_Hackathon_Staking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Staking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_hackathon_staking_status". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Staking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Staking_Status_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Staking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Staking_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_staking_status" */
export enum User_Hackathon_Staking_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserHackathonStakingStatusPkey = 'user_hackathon_staking_status_pkey'
}

export enum User_Hackathon_Staking_Status_Enum {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Incorrect = 'INCORRECT'
}

/** Boolean expression to compare columns of type "user_hackathon_staking_status_enum". All fields are combined with logical 'AND'. */
export type User_Hackathon_Staking_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Hackathon_Staking_Status_Enum>;
  _in?: InputMaybe<Array<User_Hackathon_Staking_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Hackathon_Staking_Status_Enum>;
  _nin?: InputMaybe<Array<User_Hackathon_Staking_Status_Enum>>;
};

/** input type for inserting data into table "user_hackathon_staking_status" */
export type User_Hackathon_Staking_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Staking_Status_Max_Fields = {
  __typename?: 'user_hackathon_staking_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Hackathon_Staking_Status_Min_Fields = {
  __typename?: 'user_hackathon_staking_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_hackathon_staking_status" */
export type User_Hackathon_Staking_Status_Mutation_Response = {
  __typename?: 'user_hackathon_staking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Staking_Status>;
};

/** on_conflict condition type for table "user_hackathon_staking_status" */
export type User_Hackathon_Staking_Status_On_Conflict = {
  constraint: User_Hackathon_Staking_Status_Constraint;
  update_columns?: Array<User_Hackathon_Staking_Status_Update_Column>;
  where?: InputMaybe<User_Hackathon_Staking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_staking_status". */
export type User_Hackathon_Staking_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_staking_status */
export type User_Hackathon_Staking_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_hackathon_staking_status" */
export enum User_Hackathon_Staking_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_hackathon_staking_status" */
export type User_Hackathon_Staking_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_hackathon_staking_status" */
export type User_Hackathon_Staking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Staking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Staking_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_hackathon_staking_status" */
export enum User_Hackathon_Staking_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type User_Hackathon_Staking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Staking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Staking_Status_Bool_Exp;
};

/** This table is used to store the staking information for a user_hackathon */
export type User_Hackathon_Stakings = {
  __typename?: 'user_hackathon_stakings';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_id: Scalars['Int'];
  /** An object relationship */
  hackathon_staking?: Maybe<Hackathon_Stakings>;
  hackathon_staking_id: Scalars['Int'];
  id: Scalars['Int'];
  razorpay_meta?: Maybe<Scalars['jsonb']>;
  razorpay_order_id?: Maybe<Scalars['citext']>;
  razorpay_payment_id?: Maybe<Scalars['citext']>;
  razorpay_payment_status?: Maybe<User_Hackathon_Staking_Razorpay_Payment_Status_Enum>;
  status: User_Hackathon_Staking_Status_Enum;
  tx_hash?: Maybe<Scalars['String']>;
  tx_meta?: Maybe<Scalars['jsonb']>;
  tx_network?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  user_hackathon?: Maybe<User_Hackathons>;
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};


/** This table is used to store the staking information for a user_hackathon */
export type User_Hackathon_StakingsRazorpay_MetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to store the staking information for a user_hackathon */
export type User_Hackathon_StakingsTx_MetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_hackathon_stakings" */
export type User_Hackathon_Stakings_Aggregate = {
  __typename?: 'user_hackathon_stakings_aggregate';
  aggregate?: Maybe<User_Hackathon_Stakings_Aggregate_Fields>;
  nodes: Array<User_Hackathon_Stakings>;
};

/** aggregate fields of "user_hackathon_stakings" */
export type User_Hackathon_Stakings_Aggregate_Fields = {
  __typename?: 'user_hackathon_stakings_aggregate_fields';
  avg?: Maybe<User_Hackathon_Stakings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Hackathon_Stakings_Max_Fields>;
  min?: Maybe<User_Hackathon_Stakings_Min_Fields>;
  stddev?: Maybe<User_Hackathon_Stakings_Stddev_Fields>;
  stddev_pop?: Maybe<User_Hackathon_Stakings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Hackathon_Stakings_Stddev_Samp_Fields>;
  sum?: Maybe<User_Hackathon_Stakings_Sum_Fields>;
  var_pop?: Maybe<User_Hackathon_Stakings_Var_Pop_Fields>;
  var_samp?: Maybe<User_Hackathon_Stakings_Var_Samp_Fields>;
  variance?: Maybe<User_Hackathon_Stakings_Variance_Fields>;
};


/** aggregate fields of "user_hackathon_stakings" */
export type User_Hackathon_Stakings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathon_Stakings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Hackathon_Stakings_Append_Input = {
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type User_Hackathon_Stakings_Avg_Fields = {
  __typename?: 'user_hackathon_stakings_avg_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_staking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_hackathon_stakings". All fields are combined with a logical 'AND'. */
export type User_Hackathon_Stakings_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathon_Stakings_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathon_Stakings_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathon_Stakings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  hackathon_staking?: InputMaybe<Hackathon_Stakings_Bool_Exp>;
  hackathon_staking_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  razorpay_meta?: InputMaybe<Jsonb_Comparison_Exp>;
  razorpay_order_id?: InputMaybe<Citext_Comparison_Exp>;
  razorpay_payment_id?: InputMaybe<Citext_Comparison_Exp>;
  razorpay_payment_status?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Enum_Comparison_Exp>;
  status?: InputMaybe<User_Hackathon_Staking_Status_Enum_Comparison_Exp>;
  tx_hash?: InputMaybe<String_Comparison_Exp>;
  tx_meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tx_network?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_hackathon?: InputMaybe<User_Hackathons_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathon_stakings" */
export enum User_Hackathon_Stakings_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserHackathonStakingsPkey = 'user_hackathon_stakings_pkey',
  /** unique or primary key constraint on columns "uuid" */
  UserHackathonStakingsUuidKey = 'user_hackathon_stakings_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Hackathon_Stakings_Delete_At_Path_Input = {
  razorpay_meta?: InputMaybe<Array<Scalars['String']>>;
  tx_meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Hackathon_Stakings_Delete_Elem_Input = {
  razorpay_meta?: InputMaybe<Scalars['Int']>;
  tx_meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Hackathon_Stakings_Delete_Key_Input = {
  razorpay_meta?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_hackathon_stakings" */
export type User_Hackathon_Stakings_Inc_Input = {
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_staking_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_hackathon_stakings" */
export type User_Hackathon_Stakings_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_staking?: InputMaybe<Hackathon_Stakings_Obj_Rel_Insert_Input>;
  hackathon_staking_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  razorpay_order_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_status?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Enum>;
  status?: InputMaybe<User_Hackathon_Staking_Status_Enum>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_hackathon?: InputMaybe<User_Hackathons_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathon_Stakings_Max_Fields = {
  __typename?: 'user_hackathon_stakings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hackathon_staking_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  razorpay_order_id?: Maybe<Scalars['citext']>;
  razorpay_payment_id?: Maybe<Scalars['citext']>;
  tx_hash?: Maybe<Scalars['String']>;
  tx_network?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Hackathon_Stakings_Min_Fields = {
  __typename?: 'user_hackathon_stakings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hackathon_staking_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  razorpay_order_id?: Maybe<Scalars['citext']>;
  razorpay_payment_id?: Maybe<Scalars['citext']>;
  tx_hash?: Maybe<Scalars['String']>;
  tx_network?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_hackathon_stakings" */
export type User_Hackathon_Stakings_Mutation_Response = {
  __typename?: 'user_hackathon_stakings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathon_Stakings>;
};

/** on_conflict condition type for table "user_hackathon_stakings" */
export type User_Hackathon_Stakings_On_Conflict = {
  constraint: User_Hackathon_Stakings_Constraint;
  update_columns?: Array<User_Hackathon_Stakings_Update_Column>;
  where?: InputMaybe<User_Hackathon_Stakings_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathon_stakings". */
export type User_Hackathon_Stakings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hackathon_staking?: InputMaybe<Hackathon_Stakings_Order_By>;
  hackathon_staking_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  razorpay_meta?: InputMaybe<Order_By>;
  razorpay_order_id?: InputMaybe<Order_By>;
  razorpay_payment_id?: InputMaybe<Order_By>;
  razorpay_payment_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  tx_meta?: InputMaybe<Order_By>;
  tx_network?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_hackathon?: InputMaybe<User_Hackathons_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathon_stakings */
export type User_Hackathon_Stakings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Hackathon_Stakings_Prepend_Input = {
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_hackathon_stakings" */
export enum User_Hackathon_Stakings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HackathonStakingId = 'hackathon_staking_id',
  /** column name */
  Id = 'id',
  /** column name */
  RazorpayMeta = 'razorpay_meta',
  /** column name */
  RazorpayOrderId = 'razorpay_order_id',
  /** column name */
  RazorpayPaymentId = 'razorpay_payment_id',
  /** column name */
  RazorpayPaymentStatus = 'razorpay_payment_status',
  /** column name */
  Status = 'status',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_hackathon_stakings" */
export type User_Hackathon_Stakings_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_staking_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  razorpay_order_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_status?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Enum>;
  status?: InputMaybe<User_Hackathon_Staking_Status_Enum>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Hackathon_Stakings_Stddev_Fields = {
  __typename?: 'user_hackathon_stakings_stddev_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_staking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Hackathon_Stakings_Stddev_Pop_Fields = {
  __typename?: 'user_hackathon_stakings_stddev_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_staking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Hackathon_Stakings_Stddev_Samp_Fields = {
  __typename?: 'user_hackathon_stakings_stddev_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_staking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_hackathon_stakings" */
export type User_Hackathon_Stakings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathon_Stakings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathon_Stakings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hackathon_staking_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  razorpay_meta?: InputMaybe<Scalars['jsonb']>;
  razorpay_order_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_id?: InputMaybe<Scalars['citext']>;
  razorpay_payment_status?: InputMaybe<User_Hackathon_Staking_Razorpay_Payment_Status_Enum>;
  status?: InputMaybe<User_Hackathon_Staking_Status_Enum>;
  tx_hash?: InputMaybe<Scalars['String']>;
  tx_meta?: InputMaybe<Scalars['jsonb']>;
  tx_network?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Hackathon_Stakings_Sum_Fields = {
  __typename?: 'user_hackathon_stakings_sum_fields';
  hackathon_id?: Maybe<Scalars['Int']>;
  hackathon_staking_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_hackathon_stakings" */
export enum User_Hackathon_Stakings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HackathonStakingId = 'hackathon_staking_id',
  /** column name */
  Id = 'id',
  /** column name */
  RazorpayMeta = 'razorpay_meta',
  /** column name */
  RazorpayOrderId = 'razorpay_order_id',
  /** column name */
  RazorpayPaymentId = 'razorpay_payment_id',
  /** column name */
  RazorpayPaymentStatus = 'razorpay_payment_status',
  /** column name */
  Status = 'status',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  TxMeta = 'tx_meta',
  /** column name */
  TxNetwork = 'tx_network',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Hackathon_Stakings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Hackathon_Stakings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Hackathon_Stakings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Hackathon_Stakings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Hackathon_Stakings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Hackathon_Stakings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Hackathon_Stakings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathon_Stakings_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathon_Stakings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Hackathon_Stakings_Var_Pop_Fields = {
  __typename?: 'user_hackathon_stakings_var_pop_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_staking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Hackathon_Stakings_Var_Samp_Fields = {
  __typename?: 'user_hackathon_stakings_var_samp_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_staking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Hackathon_Stakings_Variance_Fields = {
  __typename?: 'user_hackathon_stakings_variance_fields';
  hackathon_id?: Maybe<Scalars['Float']>;
  hackathon_staking_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_hackathons" */
export type User_Hackathons = {
  __typename?: 'user_hackathons';
  /** A computed field, executes function "user_hackathon_tabs" */
  _tabs?: Maybe<Scalars['jsonb']>;
  ai_assisted_reason?: Maybe<Scalars['String']>;
  ai_assisted_score?: Maybe<Scalars['Int']>;
  ai_assisted_status?: Maybe<Scalars['uh_status_enum']>;
  allow_data_export?: Maybe<Scalars['Boolean']>;
  allow_team_invites: Scalars['Boolean'];
  anon_aadhaar_nullifier?: Maybe<Scalars['String']>;
  application_apply_ip_country?: Maybe<Scalars['String']>;
  application_filled: Scalars['Boolean'];
  archive?: Maybe<Scalars['Boolean']>;
  campaign_nft_token_id?: Maybe<Scalars['Int']>;
  campaign_nft_traits?: Maybe<Scalars['_text']>;
  campaign_nft_tx_hash?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  conference_checkin?: Maybe<Scalars['Boolean']>;
  consent_form_submitted?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  currency?: Maybe<Scalars['String']>;
  discord_channel_joined: Scalars['Boolean'];
  duty?: Maybe<Scalars['String']>;
  feedback_reminder_sent_auto?: Maybe<Scalars['Boolean']>;
  feedback_reminder_sent_manual?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  feedbacks: Array<User_Hackathon_Feedbacks>;
  /** An aggregate relationship */
  feedbacks_aggregate: User_Hackathon_Feedbacks_Aggregate;
  /** An object relationship */
  hackathon?: Maybe<Hackathons>;
  hackathon_fare_id?: Maybe<Scalars['Int']>;
  hackathon_id: Scalars['Int'];
  hacker_certificate_path?: Maybe<Scalars['String']>;
  is_eligible_for_credentials?: Maybe<Scalars['Boolean']>;
  is_first_hackathon?: Maybe<Scalars['Boolean']>;
  is_travel?: Maybe<Scalars['Boolean']>;
  joined_ref_code?: Maybe<Scalars['citext']>;
  /** An object relationship */
  judge?: Maybe<Judges>;
  need_hardware?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  payment_mode?: Maybe<Scalars['String']>;
  payment_mode_value?: Maybe<Scalars['String']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Int']>;
  /** An object relationship */
  project?: Maybe<Projects>;
  project_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  quadratic_voting?: Maybe<Quadratic_Voting>;
  razorpay_id?: Maybe<Scalars['String']>;
  razorpay_refund_id?: Maybe<Scalars['String']>;
  razorpay_status?: Maybe<Scalars['String']>;
  referral_leaderboard_banned?: Maybe<Scalars['Boolean']>;
  reimbursement_amount?: Maybe<Scalars['numeric']>;
  role?: Maybe<Scalars['uh_role_enum']>;
  /** An object relationship */
  room?: Maybe<Judging_Rooms>;
  room_id?: Maybe<Scalars['Int']>;
  rsvp_missed_reminder_sent?: Maybe<Scalars['Boolean']>;
  rsvp_reminder_sent?: Maybe<Scalars['Boolean']>;
  rsvp_time?: Maybe<Scalars['timestamptz']>;
  season_partner_email_sent?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['uh_status_enum']>;
  sync_updated_at: Scalars['timestamptz'];
  tabs?: Maybe<Scalars['String']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['Int']>;
  ticket?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['Int']>;
  tokenproof_account?: Maybe<Scalars['String']>;
  tokenproof_nonce?: Maybe<Scalars['String']>;
  tokenproof_ticket_id?: Maybe<Scalars['String']>;
  tokenproof_verified: Scalars['Boolean'];
  /** An object relationship */
  track?: Maybe<Hackathon_Tracks>;
  track_id?: Maybe<Scalars['Int']>;
  unsubscribe_announcement?: Maybe<Scalars['Boolean']>;
  unsubscribe_submit_profile_review: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};


/** columns and relationships of "user_hackathons" */
export type User_Hackathons_TabsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_hackathons" */
export type User_HackathonsFeedbacksArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
};


/** columns and relationships of "user_hackathons" */
export type User_HackathonsFeedbacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Feedbacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Feedbacks_Order_By>>;
  where?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
};

/** aggregated selection of "user_hackathons" */
export type User_Hackathons_Aggregate = {
  __typename?: 'user_hackathons_aggregate';
  aggregate?: Maybe<User_Hackathons_Aggregate_Fields>;
  nodes: Array<User_Hackathons>;
};

export type User_Hackathons_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Hackathons_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Hackathons_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Hackathons_Aggregate_Bool_Exp_Count>;
};

export type User_Hackathons_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Hackathons_Select_Column_User_Hackathons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Hackathons_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Hackathons_Select_Column_User_Hackathons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Hackathons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Hackathons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_hackathons" */
export type User_Hackathons_Aggregate_Fields = {
  __typename?: 'user_hackathons_aggregate_fields';
  avg?: Maybe<User_Hackathons_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Hackathons_Max_Fields>;
  min?: Maybe<User_Hackathons_Min_Fields>;
  stddev?: Maybe<User_Hackathons_Stddev_Fields>;
  stddev_pop?: Maybe<User_Hackathons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Hackathons_Stddev_Samp_Fields>;
  sum?: Maybe<User_Hackathons_Sum_Fields>;
  var_pop?: Maybe<User_Hackathons_Var_Pop_Fields>;
  var_samp?: Maybe<User_Hackathons_Var_Samp_Fields>;
  variance?: Maybe<User_Hackathons_Variance_Fields>;
};


/** aggregate fields of "user_hackathons" */
export type User_Hackathons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_hackathons" */
export type User_Hackathons_Aggregate_Order_By = {
  avg?: InputMaybe<User_Hackathons_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Hackathons_Max_Order_By>;
  min?: InputMaybe<User_Hackathons_Min_Order_By>;
  stddev?: InputMaybe<User_Hackathons_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Hackathons_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Hackathons_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Hackathons_Sum_Order_By>;
  var_pop?: InputMaybe<User_Hackathons_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Hackathons_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Hackathons_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_hackathons" */
export type User_Hackathons_Arr_Rel_Insert_Input = {
  data: Array<User_Hackathons_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Hackathons_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Hackathons_Avg_Fields = {
  __typename?: 'user_hackathons_avg_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  campaign_nft_token_id?: Maybe<Scalars['Float']>;
  hackathon_fare_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  reimbursement_amount?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_hackathons" */
export type User_Hackathons_Avg_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_hackathons". All fields are combined with a logical 'AND'. */
export type User_Hackathons_Bool_Exp = {
  _and?: InputMaybe<Array<User_Hackathons_Bool_Exp>>;
  _not?: InputMaybe<User_Hackathons_Bool_Exp>;
  _or?: InputMaybe<Array<User_Hackathons_Bool_Exp>>;
  _tabs?: InputMaybe<Jsonb_Comparison_Exp>;
  ai_assisted_reason?: InputMaybe<String_Comparison_Exp>;
  ai_assisted_score?: InputMaybe<Int_Comparison_Exp>;
  ai_assisted_status?: InputMaybe<Uh_Status_Enum_Comparison_Exp>;
  allow_data_export?: InputMaybe<Boolean_Comparison_Exp>;
  allow_team_invites?: InputMaybe<Boolean_Comparison_Exp>;
  anon_aadhaar_nullifier?: InputMaybe<String_Comparison_Exp>;
  application_apply_ip_country?: InputMaybe<String_Comparison_Exp>;
  application_filled?: InputMaybe<Boolean_Comparison_Exp>;
  archive?: InputMaybe<Boolean_Comparison_Exp>;
  campaign_nft_token_id?: InputMaybe<Int_Comparison_Exp>;
  campaign_nft_traits?: InputMaybe<_Text_Comparison_Exp>;
  campaign_nft_tx_hash?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  conference_checkin?: InputMaybe<Boolean_Comparison_Exp>;
  consent_form_submitted?: InputMaybe<Boolean_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  discord_channel_joined?: InputMaybe<Boolean_Comparison_Exp>;
  duty?: InputMaybe<String_Comparison_Exp>;
  feedback_reminder_sent_auto?: InputMaybe<Boolean_Comparison_Exp>;
  feedback_reminder_sent_manual?: InputMaybe<Boolean_Comparison_Exp>;
  feedbacks?: InputMaybe<User_Hackathon_Feedbacks_Bool_Exp>;
  feedbacks_aggregate?: InputMaybe<User_Hackathon_Feedbacks_Aggregate_Bool_Exp>;
  hackathon?: InputMaybe<Hackathons_Bool_Exp>;
  hackathon_fare_id?: InputMaybe<Int_Comparison_Exp>;
  hackathon_id?: InputMaybe<Int_Comparison_Exp>;
  hacker_certificate_path?: InputMaybe<String_Comparison_Exp>;
  is_eligible_for_credentials?: InputMaybe<Boolean_Comparison_Exp>;
  is_first_hackathon?: InputMaybe<Boolean_Comparison_Exp>;
  is_travel?: InputMaybe<Boolean_Comparison_Exp>;
  joined_ref_code?: InputMaybe<Citext_Comparison_Exp>;
  judge?: InputMaybe<Judges_Bool_Exp>;
  need_hardware?: InputMaybe<Boolean_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  payment_mode?: InputMaybe<String_Comparison_Exp>;
  payment_mode_value?: InputMaybe<String_Comparison_Exp>;
  phase?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  quadratic_voting?: InputMaybe<Quadratic_Voting_Bool_Exp>;
  razorpay_id?: InputMaybe<String_Comparison_Exp>;
  razorpay_refund_id?: InputMaybe<String_Comparison_Exp>;
  razorpay_status?: InputMaybe<String_Comparison_Exp>;
  referral_leaderboard_banned?: InputMaybe<Boolean_Comparison_Exp>;
  reimbursement_amount?: InputMaybe<Numeric_Comparison_Exp>;
  role?: InputMaybe<Uh_Role_Enum_Comparison_Exp>;
  room?: InputMaybe<Judging_Rooms_Bool_Exp>;
  room_id?: InputMaybe<Int_Comparison_Exp>;
  rsvp_missed_reminder_sent?: InputMaybe<Boolean_Comparison_Exp>;
  rsvp_reminder_sent?: InputMaybe<Boolean_Comparison_Exp>;
  rsvp_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  season_partner_email_sent?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Uh_Status_Enum_Comparison_Exp>;
  sync_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  tabs?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  ticket?: InputMaybe<String_Comparison_Exp>;
  ticket_id?: InputMaybe<Int_Comparison_Exp>;
  tokenproof_account?: InputMaybe<String_Comparison_Exp>;
  tokenproof_nonce?: InputMaybe<String_Comparison_Exp>;
  tokenproof_ticket_id?: InputMaybe<String_Comparison_Exp>;
  tokenproof_verified?: InputMaybe<Boolean_Comparison_Exp>;
  track?: InputMaybe<Hackathon_Tracks_Bool_Exp>;
  track_id?: InputMaybe<Int_Comparison_Exp>;
  unsubscribe_announcement?: InputMaybe<Boolean_Comparison_Exp>;
  unsubscribe_submit_profile_review?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_hackathons" */
export enum User_Hackathons_Constraint {
  /** unique or primary key constraint on columns "user_id", "hackathon_id" */
  PkUserHackathons = 'pk_user_hackathons',
  /** unique or primary key constraint on columns "hackathon_id", "anon_aadhaar_nullifier" */
  UniqueHackathonIdAnonAadhaarNullifierUserHackathons = 'unique_hackathon_id_anon_aadhaar_nullifier_user_hackathons',
  /** unique or primary key constraint on columns "user_id", "hackathon_id" */
  UniqueUserIdHackathonIdUserHackathons = 'unique_user_id_hackathon_id_user_hackathons',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidUserHackathons = 'unique_uuid_user_hackathons'
}

/** input type for incrementing numeric columns in table "user_hackathons" */
export type User_Hackathons_Inc_Input = {
  ai_assisted_score?: InputMaybe<Scalars['Int']>;
  campaign_nft_token_id?: InputMaybe<Scalars['Int']>;
  hackathon_fare_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  reimbursement_amount?: InputMaybe<Scalars['numeric']>;
  room_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  ticket_id?: InputMaybe<Scalars['Int']>;
  track_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_hackathons" */
export type User_Hackathons_Insert_Input = {
  ai_assisted_reason?: InputMaybe<Scalars['String']>;
  ai_assisted_score?: InputMaybe<Scalars['Int']>;
  ai_assisted_status?: InputMaybe<Scalars['uh_status_enum']>;
  allow_data_export?: InputMaybe<Scalars['Boolean']>;
  allow_team_invites?: InputMaybe<Scalars['Boolean']>;
  anon_aadhaar_nullifier?: InputMaybe<Scalars['String']>;
  application_apply_ip_country?: InputMaybe<Scalars['String']>;
  application_filled?: InputMaybe<Scalars['Boolean']>;
  archive?: InputMaybe<Scalars['Boolean']>;
  campaign_nft_token_id?: InputMaybe<Scalars['Int']>;
  campaign_nft_traits?: InputMaybe<Scalars['_text']>;
  campaign_nft_tx_hash?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  conference_checkin?: InputMaybe<Scalars['Boolean']>;
  consent_form_submitted?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  discord_channel_joined?: InputMaybe<Scalars['Boolean']>;
  duty?: InputMaybe<Scalars['String']>;
  feedback_reminder_sent_auto?: InputMaybe<Scalars['Boolean']>;
  feedback_reminder_sent_manual?: InputMaybe<Scalars['Boolean']>;
  feedbacks?: InputMaybe<User_Hackathon_Feedbacks_Arr_Rel_Insert_Input>;
  hackathon?: InputMaybe<Hackathons_Obj_Rel_Insert_Input>;
  hackathon_fare_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hacker_certificate_path?: InputMaybe<Scalars['String']>;
  is_eligible_for_credentials?: InputMaybe<Scalars['Boolean']>;
  is_first_hackathon?: InputMaybe<Scalars['Boolean']>;
  is_travel?: InputMaybe<Scalars['Boolean']>;
  joined_ref_code?: InputMaybe<Scalars['citext']>;
  judge?: InputMaybe<Judges_Obj_Rel_Insert_Input>;
  need_hardware?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  payment_mode?: InputMaybe<Scalars['String']>;
  payment_mode_value?: InputMaybe<Scalars['String']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  quadratic_voting?: InputMaybe<Quadratic_Voting_Obj_Rel_Insert_Input>;
  razorpay_id?: InputMaybe<Scalars['String']>;
  razorpay_refund_id?: InputMaybe<Scalars['String']>;
  razorpay_status?: InputMaybe<Scalars['String']>;
  referral_leaderboard_banned?: InputMaybe<Scalars['Boolean']>;
  reimbursement_amount?: InputMaybe<Scalars['numeric']>;
  role?: InputMaybe<Scalars['uh_role_enum']>;
  room?: InputMaybe<Judging_Rooms_Obj_Rel_Insert_Input>;
  room_id?: InputMaybe<Scalars['Int']>;
  rsvp_missed_reminder_sent?: InputMaybe<Scalars['Boolean']>;
  rsvp_reminder_sent?: InputMaybe<Scalars['Boolean']>;
  rsvp_time?: InputMaybe<Scalars['timestamptz']>;
  season_partner_email_sent?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['uh_status_enum']>;
  sync_updated_at?: InputMaybe<Scalars['timestamptz']>;
  tabs?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  ticket?: InputMaybe<Scalars['String']>;
  ticket_id?: InputMaybe<Scalars['Int']>;
  tokenproof_account?: InputMaybe<Scalars['String']>;
  tokenproof_nonce?: InputMaybe<Scalars['String']>;
  tokenproof_ticket_id?: InputMaybe<Scalars['String']>;
  tokenproof_verified?: InputMaybe<Scalars['Boolean']>;
  track?: InputMaybe<Hackathon_Tracks_Obj_Rel_Insert_Input>;
  track_id?: InputMaybe<Scalars['Int']>;
  unsubscribe_announcement?: InputMaybe<Scalars['Boolean']>;
  unsubscribe_submit_profile_review?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Hackathons_Max_Fields = {
  __typename?: 'user_hackathons_max_fields';
  ai_assisted_reason?: Maybe<Scalars['String']>;
  ai_assisted_score?: Maybe<Scalars['Int']>;
  ai_assisted_status?: Maybe<Scalars['uh_status_enum']>;
  anon_aadhaar_nullifier?: Maybe<Scalars['String']>;
  application_apply_ip_country?: Maybe<Scalars['String']>;
  campaign_nft_token_id?: Maybe<Scalars['Int']>;
  campaign_nft_tx_hash?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  duty?: Maybe<Scalars['String']>;
  hackathon_fare_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hacker_certificate_path?: Maybe<Scalars['String']>;
  joined_ref_code?: Maybe<Scalars['citext']>;
  note?: Maybe<Scalars['String']>;
  payment_mode?: Maybe<Scalars['String']>;
  payment_mode_value?: Maybe<Scalars['String']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  razorpay_id?: Maybe<Scalars['String']>;
  razorpay_refund_id?: Maybe<Scalars['String']>;
  razorpay_status?: Maybe<Scalars['String']>;
  reimbursement_amount?: Maybe<Scalars['numeric']>;
  role?: Maybe<Scalars['uh_role_enum']>;
  room_id?: Maybe<Scalars['Int']>;
  rsvp_time?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['uh_status_enum']>;
  sync_updated_at?: Maybe<Scalars['timestamptz']>;
  tabs?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['Int']>;
  ticket?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['Int']>;
  tokenproof_account?: Maybe<Scalars['String']>;
  tokenproof_nonce?: Maybe<Scalars['String']>;
  tokenproof_ticket_id?: Maybe<Scalars['String']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_hackathons" */
export type User_Hackathons_Max_Order_By = {
  ai_assisted_reason?: InputMaybe<Order_By>;
  ai_assisted_score?: InputMaybe<Order_By>;
  ai_assisted_status?: InputMaybe<Order_By>;
  anon_aadhaar_nullifier?: InputMaybe<Order_By>;
  application_apply_ip_country?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  campaign_nft_tx_hash?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  duty?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hacker_certificate_path?: InputMaybe<Order_By>;
  joined_ref_code?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  payment_mode?: InputMaybe<Order_By>;
  payment_mode_value?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  razorpay_id?: InputMaybe<Order_By>;
  razorpay_refund_id?: InputMaybe<Order_By>;
  razorpay_status?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  rsvp_time?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sync_updated_at?: InputMaybe<Order_By>;
  tabs?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  tokenproof_account?: InputMaybe<Order_By>;
  tokenproof_nonce?: InputMaybe<Order_By>;
  tokenproof_ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Hackathons_Min_Fields = {
  __typename?: 'user_hackathons_min_fields';
  ai_assisted_reason?: Maybe<Scalars['String']>;
  ai_assisted_score?: Maybe<Scalars['Int']>;
  ai_assisted_status?: Maybe<Scalars['uh_status_enum']>;
  anon_aadhaar_nullifier?: Maybe<Scalars['String']>;
  application_apply_ip_country?: Maybe<Scalars['String']>;
  campaign_nft_token_id?: Maybe<Scalars['Int']>;
  campaign_nft_tx_hash?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  duty?: Maybe<Scalars['String']>;
  hackathon_fare_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  hacker_certificate_path?: Maybe<Scalars['String']>;
  joined_ref_code?: Maybe<Scalars['citext']>;
  note?: Maybe<Scalars['String']>;
  payment_mode?: Maybe<Scalars['String']>;
  payment_mode_value?: Maybe<Scalars['String']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  razorpay_id?: Maybe<Scalars['String']>;
  razorpay_refund_id?: Maybe<Scalars['String']>;
  razorpay_status?: Maybe<Scalars['String']>;
  reimbursement_amount?: Maybe<Scalars['numeric']>;
  role?: Maybe<Scalars['uh_role_enum']>;
  room_id?: Maybe<Scalars['Int']>;
  rsvp_time?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['uh_status_enum']>;
  sync_updated_at?: Maybe<Scalars['timestamptz']>;
  tabs?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['Int']>;
  ticket?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['Int']>;
  tokenproof_account?: Maybe<Scalars['String']>;
  tokenproof_nonce?: Maybe<Scalars['String']>;
  tokenproof_ticket_id?: Maybe<Scalars['String']>;
  track_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_hackathons" */
export type User_Hackathons_Min_Order_By = {
  ai_assisted_reason?: InputMaybe<Order_By>;
  ai_assisted_score?: InputMaybe<Order_By>;
  ai_assisted_status?: InputMaybe<Order_By>;
  anon_aadhaar_nullifier?: InputMaybe<Order_By>;
  application_apply_ip_country?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  campaign_nft_tx_hash?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  duty?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hacker_certificate_path?: InputMaybe<Order_By>;
  joined_ref_code?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  payment_mode?: InputMaybe<Order_By>;
  payment_mode_value?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  razorpay_id?: InputMaybe<Order_By>;
  razorpay_refund_id?: InputMaybe<Order_By>;
  razorpay_status?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  rsvp_time?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sync_updated_at?: InputMaybe<Order_By>;
  tabs?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  tokenproof_account?: InputMaybe<Order_By>;
  tokenproof_nonce?: InputMaybe<Order_By>;
  tokenproof_ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_hackathons" */
export type User_Hackathons_Mutation_Response = {
  __typename?: 'user_hackathons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Hackathons>;
};

/** input type for inserting object relation for remote table "user_hackathons" */
export type User_Hackathons_Obj_Rel_Insert_Input = {
  data: User_Hackathons_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Hackathons_On_Conflict>;
};

/** on_conflict condition type for table "user_hackathons" */
export type User_Hackathons_On_Conflict = {
  constraint: User_Hackathons_Constraint;
  update_columns?: Array<User_Hackathons_Update_Column>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};

/** Ordering options when selecting data from "user_hackathons". */
export type User_Hackathons_Order_By = {
  _tabs?: InputMaybe<Order_By>;
  ai_assisted_reason?: InputMaybe<Order_By>;
  ai_assisted_score?: InputMaybe<Order_By>;
  ai_assisted_status?: InputMaybe<Order_By>;
  allow_data_export?: InputMaybe<Order_By>;
  allow_team_invites?: InputMaybe<Order_By>;
  anon_aadhaar_nullifier?: InputMaybe<Order_By>;
  application_apply_ip_country?: InputMaybe<Order_By>;
  application_filled?: InputMaybe<Order_By>;
  archive?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  campaign_nft_traits?: InputMaybe<Order_By>;
  campaign_nft_tx_hash?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  conference_checkin?: InputMaybe<Order_By>;
  consent_form_submitted?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  discord_channel_joined?: InputMaybe<Order_By>;
  duty?: InputMaybe<Order_By>;
  feedback_reminder_sent_auto?: InputMaybe<Order_By>;
  feedback_reminder_sent_manual?: InputMaybe<Order_By>;
  feedbacks_aggregate?: InputMaybe<User_Hackathon_Feedbacks_Aggregate_Order_By>;
  hackathon?: InputMaybe<Hackathons_Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  hacker_certificate_path?: InputMaybe<Order_By>;
  is_eligible_for_credentials?: InputMaybe<Order_By>;
  is_first_hackathon?: InputMaybe<Order_By>;
  is_travel?: InputMaybe<Order_By>;
  joined_ref_code?: InputMaybe<Order_By>;
  judge?: InputMaybe<Judges_Order_By>;
  need_hardware?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  payment_mode?: InputMaybe<Order_By>;
  payment_mode_value?: InputMaybe<Order_By>;
  phase?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  quadratic_voting?: InputMaybe<Quadratic_Voting_Order_By>;
  razorpay_id?: InputMaybe<Order_By>;
  razorpay_refund_id?: InputMaybe<Order_By>;
  razorpay_status?: InputMaybe<Order_By>;
  referral_leaderboard_banned?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  room?: InputMaybe<Judging_Rooms_Order_By>;
  room_id?: InputMaybe<Order_By>;
  rsvp_missed_reminder_sent?: InputMaybe<Order_By>;
  rsvp_reminder_sent?: InputMaybe<Order_By>;
  rsvp_time?: InputMaybe<Order_By>;
  season_partner_email_sent?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sync_updated_at?: InputMaybe<Order_By>;
  tabs?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  tokenproof_account?: InputMaybe<Order_By>;
  tokenproof_nonce?: InputMaybe<Order_By>;
  tokenproof_ticket_id?: InputMaybe<Order_By>;
  tokenproof_verified?: InputMaybe<Order_By>;
  track?: InputMaybe<Hackathon_Tracks_Order_By>;
  track_id?: InputMaybe<Order_By>;
  unsubscribe_announcement?: InputMaybe<Order_By>;
  unsubscribe_submit_profile_review?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_hackathons */
export type User_Hackathons_Pk_Columns_Input = {
  hackathon_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_hackathons" */
export enum User_Hackathons_Select_Column {
  /** column name */
  AiAssistedReason = 'ai_assisted_reason',
  /** column name */
  AiAssistedScore = 'ai_assisted_score',
  /** column name */
  AiAssistedStatus = 'ai_assisted_status',
  /** column name */
  AllowDataExport = 'allow_data_export',
  /** column name */
  AllowTeamInvites = 'allow_team_invites',
  /** column name */
  AnonAadhaarNullifier = 'anon_aadhaar_nullifier',
  /** column name */
  ApplicationApplyIpCountry = 'application_apply_ip_country',
  /** column name */
  ApplicationFilled = 'application_filled',
  /** column name */
  Archive = 'archive',
  /** column name */
  CampaignNftTokenId = 'campaign_nft_token_id',
  /** column name */
  CampaignNftTraits = 'campaign_nft_traits',
  /** column name */
  CampaignNftTxHash = 'campaign_nft_tx_hash',
  /** column name */
  City = 'city',
  /** column name */
  ConferenceCheckin = 'conference_checkin',
  /** column name */
  ConsentFormSubmitted = 'consent_form_submitted',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DiscordChannelJoined = 'discord_channel_joined',
  /** column name */
  Duty = 'duty',
  /** column name */
  FeedbackReminderSentAuto = 'feedback_reminder_sent_auto',
  /** column name */
  FeedbackReminderSentManual = 'feedback_reminder_sent_manual',
  /** column name */
  HackathonFareId = 'hackathon_fare_id',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HackerCertificatePath = 'hacker_certificate_path',
  /** column name */
  IsEligibleForCredentials = 'is_eligible_for_credentials',
  /** column name */
  IsFirstHackathon = 'is_first_hackathon',
  /** column name */
  IsTravel = 'is_travel',
  /** column name */
  JoinedRefCode = 'joined_ref_code',
  /** column name */
  NeedHardware = 'need_hardware',
  /** column name */
  Note = 'note',
  /** column name */
  PaymentMode = 'payment_mode',
  /** column name */
  PaymentModeValue = 'payment_mode_value',
  /** column name */
  Phase = 'phase',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RazorpayId = 'razorpay_id',
  /** column name */
  RazorpayRefundId = 'razorpay_refund_id',
  /** column name */
  RazorpayStatus = 'razorpay_status',
  /** column name */
  ReferralLeaderboardBanned = 'referral_leaderboard_banned',
  /** column name */
  ReimbursementAmount = 'reimbursement_amount',
  /** column name */
  Role = 'role',
  /** column name */
  RoomId = 'room_id',
  /** column name */
  RsvpMissedReminderSent = 'rsvp_missed_reminder_sent',
  /** column name */
  RsvpReminderSent = 'rsvp_reminder_sent',
  /** column name */
  RsvpTime = 'rsvp_time',
  /** column name */
  SeasonPartnerEmailSent = 'season_partner_email_sent',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  SyncUpdatedAt = 'sync_updated_at',
  /** column name */
  Tabs = 'tabs',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketId = 'ticket_id',
  /** column name */
  TokenproofAccount = 'tokenproof_account',
  /** column name */
  TokenproofNonce = 'tokenproof_nonce',
  /** column name */
  TokenproofTicketId = 'tokenproof_ticket_id',
  /** column name */
  TokenproofVerified = 'tokenproof_verified',
  /** column name */
  TrackId = 'track_id',
  /** column name */
  UnsubscribeAnnouncement = 'unsubscribe_announcement',
  /** column name */
  UnsubscribeSubmitProfileReview = 'unsubscribe_submit_profile_review',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** select "user_hackathons_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_hackathons" */
export enum User_Hackathons_Select_Column_User_Hackathons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowDataExport = 'allow_data_export',
  /** column name */
  AllowTeamInvites = 'allow_team_invites',
  /** column name */
  ApplicationFilled = 'application_filled',
  /** column name */
  Archive = 'archive',
  /** column name */
  ConferenceCheckin = 'conference_checkin',
  /** column name */
  ConsentFormSubmitted = 'consent_form_submitted',
  /** column name */
  DiscordChannelJoined = 'discord_channel_joined',
  /** column name */
  FeedbackReminderSentAuto = 'feedback_reminder_sent_auto',
  /** column name */
  FeedbackReminderSentManual = 'feedback_reminder_sent_manual',
  /** column name */
  IsEligibleForCredentials = 'is_eligible_for_credentials',
  /** column name */
  IsFirstHackathon = 'is_first_hackathon',
  /** column name */
  IsTravel = 'is_travel',
  /** column name */
  NeedHardware = 'need_hardware',
  /** column name */
  ReferralLeaderboardBanned = 'referral_leaderboard_banned',
  /** column name */
  RsvpMissedReminderSent = 'rsvp_missed_reminder_sent',
  /** column name */
  RsvpReminderSent = 'rsvp_reminder_sent',
  /** column name */
  SeasonPartnerEmailSent = 'season_partner_email_sent',
  /** column name */
  TokenproofVerified = 'tokenproof_verified',
  /** column name */
  UnsubscribeAnnouncement = 'unsubscribe_announcement',
  /** column name */
  UnsubscribeSubmitProfileReview = 'unsubscribe_submit_profile_review'
}

/** select "user_hackathons_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_hackathons" */
export enum User_Hackathons_Select_Column_User_Hackathons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowDataExport = 'allow_data_export',
  /** column name */
  AllowTeamInvites = 'allow_team_invites',
  /** column name */
  ApplicationFilled = 'application_filled',
  /** column name */
  Archive = 'archive',
  /** column name */
  ConferenceCheckin = 'conference_checkin',
  /** column name */
  ConsentFormSubmitted = 'consent_form_submitted',
  /** column name */
  DiscordChannelJoined = 'discord_channel_joined',
  /** column name */
  FeedbackReminderSentAuto = 'feedback_reminder_sent_auto',
  /** column name */
  FeedbackReminderSentManual = 'feedback_reminder_sent_manual',
  /** column name */
  IsEligibleForCredentials = 'is_eligible_for_credentials',
  /** column name */
  IsFirstHackathon = 'is_first_hackathon',
  /** column name */
  IsTravel = 'is_travel',
  /** column name */
  NeedHardware = 'need_hardware',
  /** column name */
  ReferralLeaderboardBanned = 'referral_leaderboard_banned',
  /** column name */
  RsvpMissedReminderSent = 'rsvp_missed_reminder_sent',
  /** column name */
  RsvpReminderSent = 'rsvp_reminder_sent',
  /** column name */
  SeasonPartnerEmailSent = 'season_partner_email_sent',
  /** column name */
  TokenproofVerified = 'tokenproof_verified',
  /** column name */
  UnsubscribeAnnouncement = 'unsubscribe_announcement',
  /** column name */
  UnsubscribeSubmitProfileReview = 'unsubscribe_submit_profile_review'
}

/** input type for updating data in table "user_hackathons" */
export type User_Hackathons_Set_Input = {
  ai_assisted_reason?: InputMaybe<Scalars['String']>;
  ai_assisted_score?: InputMaybe<Scalars['Int']>;
  ai_assisted_status?: InputMaybe<Scalars['uh_status_enum']>;
  allow_data_export?: InputMaybe<Scalars['Boolean']>;
  allow_team_invites?: InputMaybe<Scalars['Boolean']>;
  anon_aadhaar_nullifier?: InputMaybe<Scalars['String']>;
  application_apply_ip_country?: InputMaybe<Scalars['String']>;
  application_filled?: InputMaybe<Scalars['Boolean']>;
  archive?: InputMaybe<Scalars['Boolean']>;
  campaign_nft_token_id?: InputMaybe<Scalars['Int']>;
  campaign_nft_traits?: InputMaybe<Scalars['_text']>;
  campaign_nft_tx_hash?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  conference_checkin?: InputMaybe<Scalars['Boolean']>;
  consent_form_submitted?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  discord_channel_joined?: InputMaybe<Scalars['Boolean']>;
  duty?: InputMaybe<Scalars['String']>;
  feedback_reminder_sent_auto?: InputMaybe<Scalars['Boolean']>;
  feedback_reminder_sent_manual?: InputMaybe<Scalars['Boolean']>;
  hackathon_fare_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hacker_certificate_path?: InputMaybe<Scalars['String']>;
  is_eligible_for_credentials?: InputMaybe<Scalars['Boolean']>;
  is_first_hackathon?: InputMaybe<Scalars['Boolean']>;
  is_travel?: InputMaybe<Scalars['Boolean']>;
  joined_ref_code?: InputMaybe<Scalars['citext']>;
  need_hardware?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  payment_mode?: InputMaybe<Scalars['String']>;
  payment_mode_value?: InputMaybe<Scalars['String']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  razorpay_id?: InputMaybe<Scalars['String']>;
  razorpay_refund_id?: InputMaybe<Scalars['String']>;
  razorpay_status?: InputMaybe<Scalars['String']>;
  referral_leaderboard_banned?: InputMaybe<Scalars['Boolean']>;
  reimbursement_amount?: InputMaybe<Scalars['numeric']>;
  role?: InputMaybe<Scalars['uh_role_enum']>;
  room_id?: InputMaybe<Scalars['Int']>;
  rsvp_missed_reminder_sent?: InputMaybe<Scalars['Boolean']>;
  rsvp_reminder_sent?: InputMaybe<Scalars['Boolean']>;
  rsvp_time?: InputMaybe<Scalars['timestamptz']>;
  season_partner_email_sent?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['uh_status_enum']>;
  sync_updated_at?: InputMaybe<Scalars['timestamptz']>;
  tabs?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['Int']>;
  ticket?: InputMaybe<Scalars['String']>;
  ticket_id?: InputMaybe<Scalars['Int']>;
  tokenproof_account?: InputMaybe<Scalars['String']>;
  tokenproof_nonce?: InputMaybe<Scalars['String']>;
  tokenproof_ticket_id?: InputMaybe<Scalars['String']>;
  tokenproof_verified?: InputMaybe<Scalars['Boolean']>;
  track_id?: InputMaybe<Scalars['Int']>;
  unsubscribe_announcement?: InputMaybe<Scalars['Boolean']>;
  unsubscribe_submit_profile_review?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Hackathons_Stddev_Fields = {
  __typename?: 'user_hackathons_stddev_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  campaign_nft_token_id?: Maybe<Scalars['Float']>;
  hackathon_fare_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  reimbursement_amount?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_hackathons" */
export type User_Hackathons_Stddev_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Hackathons_Stddev_Pop_Fields = {
  __typename?: 'user_hackathons_stddev_pop_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  campaign_nft_token_id?: Maybe<Scalars['Float']>;
  hackathon_fare_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  reimbursement_amount?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_hackathons" */
export type User_Hackathons_Stddev_Pop_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Hackathons_Stddev_Samp_Fields = {
  __typename?: 'user_hackathons_stddev_samp_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  campaign_nft_token_id?: Maybe<Scalars['Float']>;
  hackathon_fare_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  reimbursement_amount?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_hackathons" */
export type User_Hackathons_Stddev_Samp_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_hackathons" */
export type User_Hackathons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Hackathons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Hackathons_Stream_Cursor_Value_Input = {
  ai_assisted_reason?: InputMaybe<Scalars['String']>;
  ai_assisted_score?: InputMaybe<Scalars['Int']>;
  ai_assisted_status?: InputMaybe<Scalars['uh_status_enum']>;
  allow_data_export?: InputMaybe<Scalars['Boolean']>;
  allow_team_invites?: InputMaybe<Scalars['Boolean']>;
  anon_aadhaar_nullifier?: InputMaybe<Scalars['String']>;
  application_apply_ip_country?: InputMaybe<Scalars['String']>;
  application_filled?: InputMaybe<Scalars['Boolean']>;
  archive?: InputMaybe<Scalars['Boolean']>;
  campaign_nft_token_id?: InputMaybe<Scalars['Int']>;
  campaign_nft_traits?: InputMaybe<Scalars['_text']>;
  campaign_nft_tx_hash?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  conference_checkin?: InputMaybe<Scalars['Boolean']>;
  consent_form_submitted?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  discord_channel_joined?: InputMaybe<Scalars['Boolean']>;
  duty?: InputMaybe<Scalars['String']>;
  feedback_reminder_sent_auto?: InputMaybe<Scalars['Boolean']>;
  feedback_reminder_sent_manual?: InputMaybe<Scalars['Boolean']>;
  hackathon_fare_id?: InputMaybe<Scalars['Int']>;
  hackathon_id?: InputMaybe<Scalars['Int']>;
  hacker_certificate_path?: InputMaybe<Scalars['String']>;
  is_eligible_for_credentials?: InputMaybe<Scalars['Boolean']>;
  is_first_hackathon?: InputMaybe<Scalars['Boolean']>;
  is_travel?: InputMaybe<Scalars['Boolean']>;
  joined_ref_code?: InputMaybe<Scalars['citext']>;
  need_hardware?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  payment_mode?: InputMaybe<Scalars['String']>;
  payment_mode_value?: InputMaybe<Scalars['String']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  razorpay_id?: InputMaybe<Scalars['String']>;
  razorpay_refund_id?: InputMaybe<Scalars['String']>;
  razorpay_status?: InputMaybe<Scalars['String']>;
  referral_leaderboard_banned?: InputMaybe<Scalars['Boolean']>;
  reimbursement_amount?: InputMaybe<Scalars['numeric']>;
  role?: InputMaybe<Scalars['uh_role_enum']>;
  room_id?: InputMaybe<Scalars['Int']>;
  rsvp_missed_reminder_sent?: InputMaybe<Scalars['Boolean']>;
  rsvp_reminder_sent?: InputMaybe<Scalars['Boolean']>;
  rsvp_time?: InputMaybe<Scalars['timestamptz']>;
  season_partner_email_sent?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['uh_status_enum']>;
  sync_updated_at?: InputMaybe<Scalars['timestamptz']>;
  tabs?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['Int']>;
  ticket?: InputMaybe<Scalars['String']>;
  ticket_id?: InputMaybe<Scalars['Int']>;
  tokenproof_account?: InputMaybe<Scalars['String']>;
  tokenproof_nonce?: InputMaybe<Scalars['String']>;
  tokenproof_ticket_id?: InputMaybe<Scalars['String']>;
  tokenproof_verified?: InputMaybe<Scalars['Boolean']>;
  track_id?: InputMaybe<Scalars['Int']>;
  unsubscribe_announcement?: InputMaybe<Scalars['Boolean']>;
  unsubscribe_submit_profile_review?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Hackathons_Sum_Fields = {
  __typename?: 'user_hackathons_sum_fields';
  ai_assisted_score?: Maybe<Scalars['Int']>;
  campaign_nft_token_id?: Maybe<Scalars['Int']>;
  hackathon_fare_id?: Maybe<Scalars['Int']>;
  hackathon_id?: Maybe<Scalars['Int']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  reimbursement_amount?: Maybe<Scalars['numeric']>;
  room_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  ticket_id?: Maybe<Scalars['Int']>;
  track_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_hackathons" */
export type User_Hackathons_Sum_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_hackathons" */
export enum User_Hackathons_Update_Column {
  /** column name */
  AiAssistedReason = 'ai_assisted_reason',
  /** column name */
  AiAssistedScore = 'ai_assisted_score',
  /** column name */
  AiAssistedStatus = 'ai_assisted_status',
  /** column name */
  AllowDataExport = 'allow_data_export',
  /** column name */
  AllowTeamInvites = 'allow_team_invites',
  /** column name */
  AnonAadhaarNullifier = 'anon_aadhaar_nullifier',
  /** column name */
  ApplicationApplyIpCountry = 'application_apply_ip_country',
  /** column name */
  ApplicationFilled = 'application_filled',
  /** column name */
  Archive = 'archive',
  /** column name */
  CampaignNftTokenId = 'campaign_nft_token_id',
  /** column name */
  CampaignNftTraits = 'campaign_nft_traits',
  /** column name */
  CampaignNftTxHash = 'campaign_nft_tx_hash',
  /** column name */
  City = 'city',
  /** column name */
  ConferenceCheckin = 'conference_checkin',
  /** column name */
  ConsentFormSubmitted = 'consent_form_submitted',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DiscordChannelJoined = 'discord_channel_joined',
  /** column name */
  Duty = 'duty',
  /** column name */
  FeedbackReminderSentAuto = 'feedback_reminder_sent_auto',
  /** column name */
  FeedbackReminderSentManual = 'feedback_reminder_sent_manual',
  /** column name */
  HackathonFareId = 'hackathon_fare_id',
  /** column name */
  HackathonId = 'hackathon_id',
  /** column name */
  HackerCertificatePath = 'hacker_certificate_path',
  /** column name */
  IsEligibleForCredentials = 'is_eligible_for_credentials',
  /** column name */
  IsFirstHackathon = 'is_first_hackathon',
  /** column name */
  IsTravel = 'is_travel',
  /** column name */
  JoinedRefCode = 'joined_ref_code',
  /** column name */
  NeedHardware = 'need_hardware',
  /** column name */
  Note = 'note',
  /** column name */
  PaymentMode = 'payment_mode',
  /** column name */
  PaymentModeValue = 'payment_mode_value',
  /** column name */
  Phase = 'phase',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RazorpayId = 'razorpay_id',
  /** column name */
  RazorpayRefundId = 'razorpay_refund_id',
  /** column name */
  RazorpayStatus = 'razorpay_status',
  /** column name */
  ReferralLeaderboardBanned = 'referral_leaderboard_banned',
  /** column name */
  ReimbursementAmount = 'reimbursement_amount',
  /** column name */
  Role = 'role',
  /** column name */
  RoomId = 'room_id',
  /** column name */
  RsvpMissedReminderSent = 'rsvp_missed_reminder_sent',
  /** column name */
  RsvpReminderSent = 'rsvp_reminder_sent',
  /** column name */
  RsvpTime = 'rsvp_time',
  /** column name */
  SeasonPartnerEmailSent = 'season_partner_email_sent',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  SyncUpdatedAt = 'sync_updated_at',
  /** column name */
  Tabs = 'tabs',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketId = 'ticket_id',
  /** column name */
  TokenproofAccount = 'tokenproof_account',
  /** column name */
  TokenproofNonce = 'tokenproof_nonce',
  /** column name */
  TokenproofTicketId = 'tokenproof_ticket_id',
  /** column name */
  TokenproofVerified = 'tokenproof_verified',
  /** column name */
  TrackId = 'track_id',
  /** column name */
  UnsubscribeAnnouncement = 'unsubscribe_announcement',
  /** column name */
  UnsubscribeSubmitProfileReview = 'unsubscribe_submit_profile_review',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Hackathons_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Hackathons_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Hackathons_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Hackathons_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Hackathons_Var_Pop_Fields = {
  __typename?: 'user_hackathons_var_pop_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  campaign_nft_token_id?: Maybe<Scalars['Float']>;
  hackathon_fare_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  reimbursement_amount?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_hackathons" */
export type User_Hackathons_Var_Pop_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Hackathons_Var_Samp_Fields = {
  __typename?: 'user_hackathons_var_samp_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  campaign_nft_token_id?: Maybe<Scalars['Float']>;
  hackathon_fare_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  reimbursement_amount?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_hackathons" */
export type User_Hackathons_Var_Samp_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Hackathons_Variance_Fields = {
  __typename?: 'user_hackathons_variance_fields';
  ai_assisted_score?: Maybe<Scalars['Float']>;
  campaign_nft_token_id?: Maybe<Scalars['Float']>;
  hackathon_fare_id?: Maybe<Scalars['Float']>;
  hackathon_id?: Maybe<Scalars['Float']>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
  reimbursement_amount?: Maybe<Scalars['Float']>;
  room_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
  track_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_hackathons" */
export type User_Hackathons_Variance_Order_By = {
  ai_assisted_score?: InputMaybe<Order_By>;
  campaign_nft_token_id?: InputMaybe<Order_By>;
  hackathon_fare_id?: InputMaybe<Order_By>;
  hackathon_id?: InputMaybe<Order_By>;
  /** Stores the current active phase of the Google GenAI Exchange 2024 hackathon. */
  phase?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reimbursement_amount?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  track_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_idea_stats" */
export type User_Idea_Stats = {
  __typename?: 'user_idea_stats';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  idea?: Maybe<Ideas>;
  idea_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
  want?: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "user_idea_stats" */
export type User_Idea_Stats_Aggregate = {
  __typename?: 'user_idea_stats_aggregate';
  aggregate?: Maybe<User_Idea_Stats_Aggregate_Fields>;
  nodes: Array<User_Idea_Stats>;
};

/** aggregate fields of "user_idea_stats" */
export type User_Idea_Stats_Aggregate_Fields = {
  __typename?: 'user_idea_stats_aggregate_fields';
  avg?: Maybe<User_Idea_Stats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Idea_Stats_Max_Fields>;
  min?: Maybe<User_Idea_Stats_Min_Fields>;
  stddev?: Maybe<User_Idea_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<User_Idea_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Idea_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<User_Idea_Stats_Sum_Fields>;
  var_pop?: Maybe<User_Idea_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<User_Idea_Stats_Var_Samp_Fields>;
  variance?: Maybe<User_Idea_Stats_Variance_Fields>;
};


/** aggregate fields of "user_idea_stats" */
export type User_Idea_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Idea_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Idea_Stats_Avg_Fields = {
  __typename?: 'user_idea_stats_avg_fields';
  idea_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_idea_stats". All fields are combined with a logical 'AND'. */
export type User_Idea_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<User_Idea_Stats_Bool_Exp>>;
  _not?: InputMaybe<User_Idea_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<User_Idea_Stats_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  idea?: InputMaybe<Ideas_Bool_Exp>;
  idea_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  want?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_idea_stats" */
export enum User_Idea_Stats_Constraint {
  /** unique or primary key constraint on columns "idea_id", "user_id" */
  UserIdeaStatsPkey = 'user_idea_stats_pkey',
  /** unique or primary key constraint on columns "uuid" */
  UserIdeaStatsUuidKey = 'user_idea_stats_uuid_key'
}

/** input type for incrementing numeric columns in table "user_idea_stats" */
export type User_Idea_Stats_Inc_Input = {
  idea_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_idea_stats" */
export type User_Idea_Stats_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  idea?: InputMaybe<Ideas_Obj_Rel_Insert_Input>;
  idea_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  want?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type User_Idea_Stats_Max_Fields = {
  __typename?: 'user_idea_stats_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  idea_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Idea_Stats_Min_Fields = {
  __typename?: 'user_idea_stats_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  idea_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_idea_stats" */
export type User_Idea_Stats_Mutation_Response = {
  __typename?: 'user_idea_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Idea_Stats>;
};

/** on_conflict condition type for table "user_idea_stats" */
export type User_Idea_Stats_On_Conflict = {
  constraint: User_Idea_Stats_Constraint;
  update_columns?: Array<User_Idea_Stats_Update_Column>;
  where?: InputMaybe<User_Idea_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "user_idea_stats". */
export type User_Idea_Stats_Order_By = {
  created_at?: InputMaybe<Order_By>;
  idea?: InputMaybe<Ideas_Order_By>;
  idea_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  want?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_idea_stats */
export type User_Idea_Stats_Pk_Columns_Input = {
  idea_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_idea_stats" */
export enum User_Idea_Stats_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IdeaId = 'idea_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Want = 'want'
}

/** input type for updating data in table "user_idea_stats" */
export type User_Idea_Stats_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  want?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type User_Idea_Stats_Stddev_Fields = {
  __typename?: 'user_idea_stats_stddev_fields';
  idea_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Idea_Stats_Stddev_Pop_Fields = {
  __typename?: 'user_idea_stats_stddev_pop_fields';
  idea_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Idea_Stats_Stddev_Samp_Fields = {
  __typename?: 'user_idea_stats_stddev_samp_fields';
  idea_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_idea_stats" */
export type User_Idea_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Idea_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Idea_Stats_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  idea_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  want?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type User_Idea_Stats_Sum_Fields = {
  __typename?: 'user_idea_stats_sum_fields';
  idea_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_idea_stats" */
export enum User_Idea_Stats_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IdeaId = 'idea_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Want = 'want'
}

export type User_Idea_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Idea_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Idea_Stats_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Idea_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Idea_Stats_Var_Pop_Fields = {
  __typename?: 'user_idea_stats_var_pop_fields';
  idea_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Idea_Stats_Var_Samp_Fields = {
  __typename?: 'user_idea_stats_var_samp_fields';
  idea_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Idea_Stats_Variance_Fields = {
  __typename?: 'user_idea_stats_variance_fields';
  idea_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_kyc_status" */
export type User_Kyc_Status = {
  __typename?: 'user_kyc_status';
  value: Scalars['String'];
};

/** aggregated selection of "user_kyc_status" */
export type User_Kyc_Status_Aggregate = {
  __typename?: 'user_kyc_status_aggregate';
  aggregate?: Maybe<User_Kyc_Status_Aggregate_Fields>;
  nodes: Array<User_Kyc_Status>;
};

/** aggregate fields of "user_kyc_status" */
export type User_Kyc_Status_Aggregate_Fields = {
  __typename?: 'user_kyc_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Kyc_Status_Max_Fields>;
  min?: Maybe<User_Kyc_Status_Min_Fields>;
};


/** aggregate fields of "user_kyc_status" */
export type User_Kyc_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Kyc_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_kyc_status". All fields are combined with a logical 'AND'. */
export type User_Kyc_Status_Bool_Exp = {
  _and?: InputMaybe<Array<User_Kyc_Status_Bool_Exp>>;
  _not?: InputMaybe<User_Kyc_Status_Bool_Exp>;
  _or?: InputMaybe<Array<User_Kyc_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_kyc_status" */
export enum User_Kyc_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserKycStatusPkey = 'user_kyc_status_pkey'
}

export enum User_Kyc_Status_Enum {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  ResubmissionRequired = 'RESUBMISSION_REQUIRED',
  InProgress = 'IN_PROGRESS'
}

/** Boolean expression to compare columns of type "user_kyc_status_enum". All fields are combined with logical 'AND'. */
export type User_Kyc_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Kyc_Status_Enum>;
  _in?: InputMaybe<Array<User_Kyc_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Kyc_Status_Enum>;
  _nin?: InputMaybe<Array<User_Kyc_Status_Enum>>;
};

/** input type for inserting data into table "user_kyc_status" */
export type User_Kyc_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Kyc_Status_Max_Fields = {
  __typename?: 'user_kyc_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Kyc_Status_Min_Fields = {
  __typename?: 'user_kyc_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_kyc_status" */
export type User_Kyc_Status_Mutation_Response = {
  __typename?: 'user_kyc_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Kyc_Status>;
};

/** on_conflict condition type for table "user_kyc_status" */
export type User_Kyc_Status_On_Conflict = {
  constraint: User_Kyc_Status_Constraint;
  update_columns?: Array<User_Kyc_Status_Update_Column>;
  where?: InputMaybe<User_Kyc_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "user_kyc_status". */
export type User_Kyc_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_kyc_status */
export type User_Kyc_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_kyc_status" */
export enum User_Kyc_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_kyc_status" */
export type User_Kyc_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_kyc_status" */
export type User_Kyc_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Kyc_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Kyc_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_kyc_status" */
export enum User_Kyc_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type User_Kyc_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Kyc_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Kyc_Status_Bool_Exp;
};

/** columns and relationships of "user_permissions" */
export type User_Permissions = {
  __typename?: 'user_permissions';
  actions?: Maybe<Scalars['_text']>;
  created_at: Scalars['timestamptz'];
  json_actions?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  permission?: Maybe<Permissions>;
  permission_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};


/** columns and relationships of "user_permissions" */
export type User_PermissionsJson_ActionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_permissions" */
export type User_Permissions_Aggregate = {
  __typename?: 'user_permissions_aggregate';
  aggregate?: Maybe<User_Permissions_Aggregate_Fields>;
  nodes: Array<User_Permissions>;
};

/** aggregate fields of "user_permissions" */
export type User_Permissions_Aggregate_Fields = {
  __typename?: 'user_permissions_aggregate_fields';
  avg?: Maybe<User_Permissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Permissions_Max_Fields>;
  min?: Maybe<User_Permissions_Min_Fields>;
  stddev?: Maybe<User_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<User_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<User_Permissions_Sum_Fields>;
  var_pop?: Maybe<User_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<User_Permissions_Var_Samp_Fields>;
  variance?: Maybe<User_Permissions_Variance_Fields>;
};


/** aggregate fields of "user_permissions" */
export type User_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Permissions_Avg_Fields = {
  __typename?: 'user_permissions_avg_fields';
  permission_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_permissions". All fields are combined with a logical 'AND'. */
export type User_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<User_Permissions_Bool_Exp>>;
  _not?: InputMaybe<User_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<User_Permissions_Bool_Exp>>;
  actions?: InputMaybe<_Text_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  json_actions?: InputMaybe<Jsonb_Comparison_Exp>;
  permission?: InputMaybe<Permissions_Bool_Exp>;
  permission_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_permissions" */
export enum User_Permissions_Constraint {
  /** unique or primary key constraint on columns "user_id", "permission_id" */
  PkUserPermissions = 'pk_user_permissions',
  /** unique or primary key constraint on columns "uuid" */
  UserPermissionsUuidKey = 'user_permissions_uuid_key'
}

/** input type for incrementing numeric columns in table "user_permissions" */
export type User_Permissions_Inc_Input = {
  permission_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_permissions" */
export type User_Permissions_Insert_Input = {
  actions?: InputMaybe<Scalars['_text']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  permission?: InputMaybe<Permissions_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Permissions_Max_Fields = {
  __typename?: 'user_permissions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  permission_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Permissions_Min_Fields = {
  __typename?: 'user_permissions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  permission_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_permissions" */
export type User_Permissions_Mutation_Response = {
  __typename?: 'user_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Permissions>;
};

/** on_conflict condition type for table "user_permissions" */
export type User_Permissions_On_Conflict = {
  constraint: User_Permissions_Constraint;
  update_columns?: Array<User_Permissions_Update_Column>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "user_permissions". */
export type User_Permissions_Order_By = {
  actions?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  json_actions?: InputMaybe<Order_By>;
  permission?: InputMaybe<Permissions_Order_By>;
  permission_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_permissions */
export type User_Permissions_Pk_Columns_Input = {
  permission_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_permissions" */
export enum User_Permissions_Select_Column {
  /** column name */
  Actions = 'actions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  JsonActions = 'json_actions',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_permissions" */
export type User_Permissions_Set_Input = {
  actions?: InputMaybe<Scalars['_text']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  permission_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Permissions_Stddev_Fields = {
  __typename?: 'user_permissions_stddev_fields';
  permission_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Permissions_Stddev_Pop_Fields = {
  __typename?: 'user_permissions_stddev_pop_fields';
  permission_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Permissions_Stddev_Samp_Fields = {
  __typename?: 'user_permissions_stddev_samp_fields';
  permission_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_permissions" */
export type User_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Permissions_Stream_Cursor_Value_Input = {
  actions?: InputMaybe<Scalars['_text']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  json_actions?: InputMaybe<Scalars['jsonb']>;
  permission_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Permissions_Sum_Fields = {
  __typename?: 'user_permissions_sum_fields';
  permission_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_permissions" */
export enum User_Permissions_Update_Column {
  /** column name */
  Actions = 'actions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Permissions_Var_Pop_Fields = {
  __typename?: 'user_permissions_var_pop_fields';
  permission_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Permissions_Var_Samp_Fields = {
  __typename?: 'user_permissions_var_samp_fields';
  permission_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Permissions_Variance_Fields = {
  __typename?: 'user_permissions_variance_fields';
  permission_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_profile_rss_feed_platforms" */
export type User_Profile_Rss_Feed_Platforms = {
  __typename?: 'user_profile_rss_feed_platforms';
  value: Scalars['String'];
};

/** aggregated selection of "user_profile_rss_feed_platforms" */
export type User_Profile_Rss_Feed_Platforms_Aggregate = {
  __typename?: 'user_profile_rss_feed_platforms_aggregate';
  aggregate?: Maybe<User_Profile_Rss_Feed_Platforms_Aggregate_Fields>;
  nodes: Array<User_Profile_Rss_Feed_Platforms>;
};

/** aggregate fields of "user_profile_rss_feed_platforms" */
export type User_Profile_Rss_Feed_Platforms_Aggregate_Fields = {
  __typename?: 'user_profile_rss_feed_platforms_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Profile_Rss_Feed_Platforms_Max_Fields>;
  min?: Maybe<User_Profile_Rss_Feed_Platforms_Min_Fields>;
};


/** aggregate fields of "user_profile_rss_feed_platforms" */
export type User_Profile_Rss_Feed_Platforms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_profile_rss_feed_platforms". All fields are combined with a logical 'AND'. */
export type User_Profile_Rss_Feed_Platforms_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Bool_Exp>>;
  _not?: InputMaybe<User_Profile_Rss_Feed_Platforms_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profile_rss_feed_platforms" */
export enum User_Profile_Rss_Feed_Platforms_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserProfileRssFeedPlatformsPkey = 'user_profile_rss_feed_platforms_pkey'
}

export enum User_Profile_Rss_Feed_Platforms_Enum {
  Custom = 'custom',
  Hashnode = 'hashnode',
  Medium = 'medium'
}

/** Boolean expression to compare columns of type "user_profile_rss_feed_platforms_enum". All fields are combined with logical 'AND'. */
export type User_Profile_Rss_Feed_Platforms_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Profile_Rss_Feed_Platforms_Enum>;
  _in?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Profile_Rss_Feed_Platforms_Enum>;
  _nin?: InputMaybe<Array<User_Profile_Rss_Feed_Platforms_Enum>>;
};

/** input type for inserting data into table "user_profile_rss_feed_platforms" */
export type User_Profile_Rss_Feed_Platforms_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Profile_Rss_Feed_Platforms_Max_Fields = {
  __typename?: 'user_profile_rss_feed_platforms_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Profile_Rss_Feed_Platforms_Min_Fields = {
  __typename?: 'user_profile_rss_feed_platforms_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_profile_rss_feed_platforms" */
export type User_Profile_Rss_Feed_Platforms_Mutation_Response = {
  __typename?: 'user_profile_rss_feed_platforms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profile_Rss_Feed_Platforms>;
};

/** on_conflict condition type for table "user_profile_rss_feed_platforms" */
export type User_Profile_Rss_Feed_Platforms_On_Conflict = {
  constraint: User_Profile_Rss_Feed_Platforms_Constraint;
  update_columns?: Array<User_Profile_Rss_Feed_Platforms_Update_Column>;
  where?: InputMaybe<User_Profile_Rss_Feed_Platforms_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profile_rss_feed_platforms". */
export type User_Profile_Rss_Feed_Platforms_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_profile_rss_feed_platforms */
export type User_Profile_Rss_Feed_Platforms_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_profile_rss_feed_platforms" */
export enum User_Profile_Rss_Feed_Platforms_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_profile_rss_feed_platforms" */
export type User_Profile_Rss_Feed_Platforms_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_profile_rss_feed_platforms" */
export type User_Profile_Rss_Feed_Platforms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profile_Rss_Feed_Platforms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profile_Rss_Feed_Platforms_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_profile_rss_feed_platforms" */
export enum User_Profile_Rss_Feed_Platforms_Update_Column {
  /** column name */
  Value = 'value'
}

export type User_Profile_Rss_Feed_Platforms_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profile_Rss_Feed_Platforms_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profile_Rss_Feed_Platforms_Bool_Exp;
};

/** columns and relationships of "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds = {
  __typename?: 'user_profile_rss_feeds';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  platform: User_Profile_Rss_Feed_Platforms_Enum;
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Aggregate = {
  __typename?: 'user_profile_rss_feeds_aggregate';
  aggregate?: Maybe<User_Profile_Rss_Feeds_Aggregate_Fields>;
  nodes: Array<User_Profile_Rss_Feeds>;
};

export type User_Profile_Rss_Feeds_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Profile_Rss_Feeds_Aggregate_Bool_Exp_Count>;
};

export type User_Profile_Rss_Feeds_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Profile_Rss_Feeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Aggregate_Fields = {
  __typename?: 'user_profile_rss_feeds_aggregate_fields';
  avg?: Maybe<User_Profile_Rss_Feeds_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Profile_Rss_Feeds_Max_Fields>;
  min?: Maybe<User_Profile_Rss_Feeds_Min_Fields>;
  stddev?: Maybe<User_Profile_Rss_Feeds_Stddev_Fields>;
  stddev_pop?: Maybe<User_Profile_Rss_Feeds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Profile_Rss_Feeds_Stddev_Samp_Fields>;
  sum?: Maybe<User_Profile_Rss_Feeds_Sum_Fields>;
  var_pop?: Maybe<User_Profile_Rss_Feeds_Var_Pop_Fields>;
  var_samp?: Maybe<User_Profile_Rss_Feeds_Var_Samp_Fields>;
  variance?: Maybe<User_Profile_Rss_Feeds_Variance_Fields>;
};


/** aggregate fields of "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Profile_Rss_Feeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Aggregate_Order_By = {
  avg?: InputMaybe<User_Profile_Rss_Feeds_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Profile_Rss_Feeds_Max_Order_By>;
  min?: InputMaybe<User_Profile_Rss_Feeds_Min_Order_By>;
  stddev?: InputMaybe<User_Profile_Rss_Feeds_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Profile_Rss_Feeds_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Profile_Rss_Feeds_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Profile_Rss_Feeds_Sum_Order_By>;
  var_pop?: InputMaybe<User_Profile_Rss_Feeds_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Profile_Rss_Feeds_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Profile_Rss_Feeds_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Arr_Rel_Insert_Input = {
  data: Array<User_Profile_Rss_Feeds_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profile_Rss_Feeds_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Profile_Rss_Feeds_Avg_Fields = {
  __typename?: 'user_profile_rss_feeds_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_profile_rss_feeds". All fields are combined with a logical 'AND'. */
export type User_Profile_Rss_Feeds_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profile_Rss_Feeds_Bool_Exp>>;
  _not?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profile_Rss_Feeds_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  platform?: InputMaybe<User_Profile_Rss_Feed_Platforms_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profile_rss_feeds" */
export enum User_Profile_Rss_Feeds_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProfileRssFeedsPkey = 'user_profile_rss_feeds_pkey',
  /** unique or primary key constraint on columns "uuid" */
  UserProfileRssFeedsUuidKey = 'user_profile_rss_feeds_uuid_key'
}

/** input type for incrementing numeric columns in table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<User_Profile_Rss_Feed_Platforms_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Profile_Rss_Feeds_Max_Fields = {
  __typename?: 'user_profile_rss_feeds_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Profile_Rss_Feeds_Min_Fields = {
  __typename?: 'user_profile_rss_feeds_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Mutation_Response = {
  __typename?: 'user_profile_rss_feeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profile_Rss_Feeds>;
};

/** on_conflict condition type for table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_On_Conflict = {
  constraint: User_Profile_Rss_Feeds_Constraint;
  update_columns?: Array<User_Profile_Rss_Feeds_Update_Column>;
  where?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profile_rss_feeds". */
export type User_Profile_Rss_Feeds_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_profile_rss_feeds */
export type User_Profile_Rss_Feeds_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_profile_rss_feeds" */
export enum User_Profile_Rss_Feeds_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<User_Profile_Rss_Feed_Platforms_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Profile_Rss_Feeds_Stddev_Fields = {
  __typename?: 'user_profile_rss_feeds_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Profile_Rss_Feeds_Stddev_Pop_Fields = {
  __typename?: 'user_profile_rss_feeds_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Profile_Rss_Feeds_Stddev_Samp_Fields = {
  __typename?: 'user_profile_rss_feeds_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profile_Rss_Feeds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profile_Rss_Feeds_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<User_Profile_Rss_Feed_Platforms_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Profile_Rss_Feeds_Sum_Fields = {
  __typename?: 'user_profile_rss_feeds_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_profile_rss_feeds" */
export enum User_Profile_Rss_Feeds_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Profile_Rss_Feeds_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Profile_Rss_Feeds_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profile_Rss_Feeds_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profile_Rss_Feeds_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Profile_Rss_Feeds_Var_Pop_Fields = {
  __typename?: 'user_profile_rss_feeds_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Profile_Rss_Feeds_Var_Samp_Fields = {
  __typename?: 'user_profile_rss_feeds_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Profile_Rss_Feeds_Variance_Fields = {
  __typename?: 'user_profile_rss_feeds_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_profile_rss_feeds" */
export type User_Profile_Rss_Feeds_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_profiles" */
export type User_Profiles = {
  __typename?: 'user_profiles';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  profile?: Maybe<Profiles>;
  profile_id: Scalars['Int'];
  social_id?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  username?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "user_profiles" */
export type User_Profiles_Aggregate = {
  __typename?: 'user_profiles_aggregate';
  aggregate?: Maybe<User_Profiles_Aggregate_Fields>;
  nodes: Array<User_Profiles>;
};

export type User_Profiles_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Profiles_Aggregate_Bool_Exp_Count>;
};

export type User_Profiles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Profiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Profiles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_Fields = {
  __typename?: 'user_profiles_aggregate_fields';
  avg?: Maybe<User_Profiles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Profiles_Max_Fields>;
  min?: Maybe<User_Profiles_Min_Fields>;
  stddev?: Maybe<User_Profiles_Stddev_Fields>;
  stddev_pop?: Maybe<User_Profiles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Profiles_Stddev_Samp_Fields>;
  sum?: Maybe<User_Profiles_Sum_Fields>;
  var_pop?: Maybe<User_Profiles_Var_Pop_Fields>;
  var_samp?: Maybe<User_Profiles_Var_Samp_Fields>;
  variance?: Maybe<User_Profiles_Variance_Fields>;
};


/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Profiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_profiles" */
export type User_Profiles_Aggregate_Order_By = {
  avg?: InputMaybe<User_Profiles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Profiles_Max_Order_By>;
  min?: InputMaybe<User_Profiles_Min_Order_By>;
  stddev?: InputMaybe<User_Profiles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Profiles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Profiles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Profiles_Sum_Order_By>;
  var_pop?: InputMaybe<User_Profiles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Profiles_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Profiles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_profiles" */
export type User_Profiles_Arr_Rel_Insert_Input = {
  data: Array<User_Profiles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Profiles_Avg_Fields = {
  __typename?: 'user_profiles_avg_fields';
  profile_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_profiles" */
export type User_Profiles_Avg_Order_By = {
  profile_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export type User_Profiles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  _not?: InputMaybe<User_Profiles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  profile?: InputMaybe<Profiles_Bool_Exp>;
  profile_id?: InputMaybe<Int_Comparison_Exp>;
  social_id?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profiles" */
export enum User_Profiles_Constraint {
  /** unique or primary key constraint on columns "user_id", "profile_id" */
  PkUserProfiles = 'pk_user_profiles',
  /** unique or primary key constraint on columns "user_id", "profile_id" */
  UniqueUserIdProfileIdUserProfiles = 'unique_user_id_profile_id_user_profiles',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidUserProfiles = 'unique_uuid_user_profiles'
}

/** input type for incrementing numeric columns in table "user_profiles" */
export type User_Profiles_Inc_Input = {
  profile_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_profiles" */
export type User_Profiles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  profile?: InputMaybe<Profiles_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['Int']>;
  social_id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Profiles_Max_Fields = {
  __typename?: 'user_profiles_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  profile_id?: Maybe<Scalars['Int']>;
  social_id?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_profiles" */
export type User_Profiles_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  social_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Profiles_Min_Fields = {
  __typename?: 'user_profiles_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  profile_id?: Maybe<Scalars['Int']>;
  social_id?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_profiles" */
export type User_Profiles_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  social_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_profiles" */
export type User_Profiles_Mutation_Response = {
  __typename?: 'user_profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profiles>;
};

/** on_conflict condition type for table "user_profiles" */
export type User_Profiles_On_Conflict = {
  constraint: User_Profiles_Constraint;
  update_columns?: Array<User_Profiles_Update_Column>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profiles". */
export type User_Profiles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profiles_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  social_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_profiles */
export type User_Profiles_Pk_Columns_Input = {
  profile_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_profiles" */
export enum User_Profiles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SocialId = 'social_id',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_profiles" */
export type User_Profiles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  profile_id?: InputMaybe<Scalars['Int']>;
  social_id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Profiles_Stddev_Fields = {
  __typename?: 'user_profiles_stddev_fields';
  profile_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_profiles" */
export type User_Profiles_Stddev_Order_By = {
  profile_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Profiles_Stddev_Pop_Fields = {
  __typename?: 'user_profiles_stddev_pop_fields';
  profile_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_profiles" */
export type User_Profiles_Stddev_Pop_Order_By = {
  profile_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Profiles_Stddev_Samp_Fields = {
  __typename?: 'user_profiles_stddev_samp_fields';
  profile_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_profiles" */
export type User_Profiles_Stddev_Samp_Order_By = {
  profile_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_profiles" */
export type User_Profiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profiles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  profile_id?: InputMaybe<Scalars['Int']>;
  social_id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Profiles_Sum_Fields = {
  __typename?: 'user_profiles_sum_fields';
  profile_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_profiles" */
export type User_Profiles_Sum_Order_By = {
  profile_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_profiles" */
export enum User_Profiles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SocialId = 'social_id',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Value = 'value'
}

export type User_Profiles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Profiles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profiles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profiles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Profiles_Var_Pop_Fields = {
  __typename?: 'user_profiles_var_pop_fields';
  profile_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_profiles" */
export type User_Profiles_Var_Pop_Order_By = {
  profile_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Profiles_Var_Samp_Fields = {
  __typename?: 'user_profiles_var_samp_fields';
  profile_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_profiles" */
export type User_Profiles_Var_Samp_Order_By = {
  profile_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Profiles_Variance_Fields = {
  __typename?: 'user_profiles_variance_fields';
  profile_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_profiles" */
export type User_Profiles_Variance_Order_By = {
  profile_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_project_meta" */
export type User_Project_Meta = {
  __typename?: 'user_project_meta';
  created_at: Scalars['timestamptz'];
  like?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  project?: Maybe<Projects>;
  project_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "user_project_meta" */
export type User_Project_Meta_Aggregate = {
  __typename?: 'user_project_meta_aggregate';
  aggregate?: Maybe<User_Project_Meta_Aggregate_Fields>;
  nodes: Array<User_Project_Meta>;
};

/** aggregate fields of "user_project_meta" */
export type User_Project_Meta_Aggregate_Fields = {
  __typename?: 'user_project_meta_aggregate_fields';
  avg?: Maybe<User_Project_Meta_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Project_Meta_Max_Fields>;
  min?: Maybe<User_Project_Meta_Min_Fields>;
  stddev?: Maybe<User_Project_Meta_Stddev_Fields>;
  stddev_pop?: Maybe<User_Project_Meta_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Project_Meta_Stddev_Samp_Fields>;
  sum?: Maybe<User_Project_Meta_Sum_Fields>;
  var_pop?: Maybe<User_Project_Meta_Var_Pop_Fields>;
  var_samp?: Maybe<User_Project_Meta_Var_Samp_Fields>;
  variance?: Maybe<User_Project_Meta_Variance_Fields>;
};


/** aggregate fields of "user_project_meta" */
export type User_Project_Meta_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Project_Meta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Project_Meta_Avg_Fields = {
  __typename?: 'user_project_meta_avg_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_project_meta". All fields are combined with a logical 'AND'. */
export type User_Project_Meta_Bool_Exp = {
  _and?: InputMaybe<Array<User_Project_Meta_Bool_Exp>>;
  _not?: InputMaybe<User_Project_Meta_Bool_Exp>;
  _or?: InputMaybe<Array<User_Project_Meta_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  like?: InputMaybe<Boolean_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_project_meta" */
export enum User_Project_Meta_Constraint {
  /** unique or primary key constraint on columns "project_id", "user_id" */
  PkUserProjectMeta = 'pk_user_project_meta',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidUserProjectMeta = 'unique_uuid_user_project_meta'
}

/** input type for incrementing numeric columns in table "user_project_meta" */
export type User_Project_Meta_Inc_Input = {
  project_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_project_meta" */
export type User_Project_Meta_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  like?: InputMaybe<Scalars['Boolean']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Project_Meta_Max_Fields = {
  __typename?: 'user_project_meta_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Project_Meta_Min_Fields = {
  __typename?: 'user_project_meta_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_project_meta" */
export type User_Project_Meta_Mutation_Response = {
  __typename?: 'user_project_meta_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Project_Meta>;
};

/** on_conflict condition type for table "user_project_meta" */
export type User_Project_Meta_On_Conflict = {
  constraint: User_Project_Meta_Constraint;
  update_columns?: Array<User_Project_Meta_Update_Column>;
  where?: InputMaybe<User_Project_Meta_Bool_Exp>;
};

/** Ordering options when selecting data from "user_project_meta". */
export type User_Project_Meta_Order_By = {
  created_at?: InputMaybe<Order_By>;
  like?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_project_meta */
export type User_Project_Meta_Pk_Columns_Input = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_project_meta" */
export enum User_Project_Meta_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Like = 'like',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_project_meta" */
export type User_Project_Meta_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  like?: InputMaybe<Scalars['Boolean']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Project_Meta_Stddev_Fields = {
  __typename?: 'user_project_meta_stddev_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Project_Meta_Stddev_Pop_Fields = {
  __typename?: 'user_project_meta_stddev_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Project_Meta_Stddev_Samp_Fields = {
  __typename?: 'user_project_meta_stddev_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_project_meta" */
export type User_Project_Meta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Project_Meta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Project_Meta_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  like?: InputMaybe<Scalars['Boolean']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Project_Meta_Sum_Fields = {
  __typename?: 'user_project_meta_sum_fields';
  project_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_project_meta" */
export enum User_Project_Meta_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Like = 'like',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Project_Meta_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Project_Meta_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Project_Meta_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Project_Meta_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Project_Meta_Var_Pop_Fields = {
  __typename?: 'user_project_meta_var_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Project_Meta_Var_Samp_Fields = {
  __typename?: 'user_project_meta_var_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Project_Meta_Variance_Fields = {
  __typename?: 'user_project_meta_variance_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_projects" */
export type User_Projects = {
  __typename?: 'user_projects';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "user_projects" */
export type User_Projects_Aggregate = {
  __typename?: 'user_projects_aggregate';
  aggregate?: Maybe<User_Projects_Aggregate_Fields>;
  nodes: Array<User_Projects>;
};

export type User_Projects_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Projects_Aggregate_Bool_Exp_Count>;
};

export type User_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_projects" */
export type User_Projects_Aggregate_Fields = {
  __typename?: 'user_projects_aggregate_fields';
  avg?: Maybe<User_Projects_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Projects_Max_Fields>;
  min?: Maybe<User_Projects_Min_Fields>;
  stddev?: Maybe<User_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<User_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<User_Projects_Sum_Fields>;
  var_pop?: Maybe<User_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<User_Projects_Var_Samp_Fields>;
  variance?: Maybe<User_Projects_Variance_Fields>;
};


/** aggregate fields of "user_projects" */
export type User_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_projects" */
export type User_Projects_Aggregate_Order_By = {
  avg?: InputMaybe<User_Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Projects_Max_Order_By>;
  min?: InputMaybe<User_Projects_Min_Order_By>;
  stddev?: InputMaybe<User_Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Projects_Sum_Order_By>;
  var_pop?: InputMaybe<User_Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Projects_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_projects" */
export type User_Projects_Arr_Rel_Insert_Input = {
  data: Array<User_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Projects_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Projects_Avg_Fields = {
  __typename?: 'user_projects_avg_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_projects" */
export type User_Projects_Avg_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_projects". All fields are combined with a logical 'AND'. */
export type User_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<User_Projects_Bool_Exp>>;
  _not?: InputMaybe<User_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<User_Projects_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_projects" */
export enum User_Projects_Constraint {
  /** unique or primary key constraint on columns "project_id", "user_id" */
  PkUserProjects = 'pk_user_projects',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidUserProjects = 'unique_uuid_user_projects'
}

/** input type for incrementing numeric columns in table "user_projects" */
export type User_Projects_Inc_Input = {
  project_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_projects" */
export type User_Projects_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Projects_Max_Fields = {
  __typename?: 'user_projects_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_projects" */
export type User_Projects_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Projects_Min_Fields = {
  __typename?: 'user_projects_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_projects" */
export type User_Projects_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_projects" */
export type User_Projects_Mutation_Response = {
  __typename?: 'user_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Projects>;
};

/** on_conflict condition type for table "user_projects" */
export type User_Projects_On_Conflict = {
  constraint: User_Projects_Constraint;
  update_columns?: Array<User_Projects_Update_Column>;
  where?: InputMaybe<User_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "user_projects". */
export type User_Projects_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_projects */
export type User_Projects_Pk_Columns_Input = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_projects" */
export enum User_Projects_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_projects" */
export type User_Projects_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Projects_Stddev_Fields = {
  __typename?: 'user_projects_stddev_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_projects" */
export type User_Projects_Stddev_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Projects_Stddev_Pop_Fields = {
  __typename?: 'user_projects_stddev_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_projects" */
export type User_Projects_Stddev_Pop_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Projects_Stddev_Samp_Fields = {
  __typename?: 'user_projects_stddev_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_projects" */
export type User_Projects_Stddev_Samp_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_projects" */
export type User_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Projects_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Projects_Sum_Fields = {
  __typename?: 'user_projects_sum_fields';
  project_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_projects" */
export type User_Projects_Sum_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_projects" */
export enum User_Projects_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Projects_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Projects_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Projects_Var_Pop_Fields = {
  __typename?: 'user_projects_var_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_projects" */
export type User_Projects_Var_Pop_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Projects_Var_Samp_Fields = {
  __typename?: 'user_projects_var_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_projects" */
export type User_Projects_Var_Samp_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Projects_Variance_Fields = {
  __typename?: 'user_projects_variance_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_projects" */
export type User_Projects_Variance_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_public_profile_layout" */
export type User_Public_Profile_Layout = {
  __typename?: 'user_public_profile_layout';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  preferences: Scalars['jsonb'];
  size: Scalars['String'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};


/** columns and relationships of "user_public_profile_layout" */
export type User_Public_Profile_LayoutPreferencesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_public_profile_layout" */
export type User_Public_Profile_Layout_Aggregate = {
  __typename?: 'user_public_profile_layout_aggregate';
  aggregate?: Maybe<User_Public_Profile_Layout_Aggregate_Fields>;
  nodes: Array<User_Public_Profile_Layout>;
};

export type User_Public_Profile_Layout_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Public_Profile_Layout_Aggregate_Bool_Exp_Count>;
};

export type User_Public_Profile_Layout_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Public_Profile_Layout_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_public_profile_layout" */
export type User_Public_Profile_Layout_Aggregate_Fields = {
  __typename?: 'user_public_profile_layout_aggregate_fields';
  avg?: Maybe<User_Public_Profile_Layout_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Public_Profile_Layout_Max_Fields>;
  min?: Maybe<User_Public_Profile_Layout_Min_Fields>;
  stddev?: Maybe<User_Public_Profile_Layout_Stddev_Fields>;
  stddev_pop?: Maybe<User_Public_Profile_Layout_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Public_Profile_Layout_Stddev_Samp_Fields>;
  sum?: Maybe<User_Public_Profile_Layout_Sum_Fields>;
  var_pop?: Maybe<User_Public_Profile_Layout_Var_Pop_Fields>;
  var_samp?: Maybe<User_Public_Profile_Layout_Var_Samp_Fields>;
  variance?: Maybe<User_Public_Profile_Layout_Variance_Fields>;
};


/** aggregate fields of "user_public_profile_layout" */
export type User_Public_Profile_Layout_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Public_Profile_Layout_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Aggregate_Order_By = {
  avg?: InputMaybe<User_Public_Profile_Layout_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Public_Profile_Layout_Max_Order_By>;
  min?: InputMaybe<User_Public_Profile_Layout_Min_Order_By>;
  stddev?: InputMaybe<User_Public_Profile_Layout_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Public_Profile_Layout_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Public_Profile_Layout_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Public_Profile_Layout_Sum_Order_By>;
  var_pop?: InputMaybe<User_Public_Profile_Layout_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Public_Profile_Layout_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Public_Profile_Layout_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Public_Profile_Layout_Append_Input = {
  preferences?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Arr_Rel_Insert_Input = {
  data: Array<User_Public_Profile_Layout_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Public_Profile_Layout_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Public_Profile_Layout_Avg_Fields = {
  __typename?: 'user_public_profile_layout_avg_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_public_profile_layout". All fields are combined with a logical 'AND'. */
export type User_Public_Profile_Layout_Bool_Exp = {
  _and?: InputMaybe<Array<User_Public_Profile_Layout_Bool_Exp>>;
  _not?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
  _or?: InputMaybe<Array<User_Public_Profile_Layout_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  preferences?: InputMaybe<Jsonb_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_public_profile_layout" */
export enum User_Public_Profile_Layout_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPublicProfileLayoutPkey = 'user_public_profile_layout_pkey',
  /** unique or primary key constraint on columns "uuid" */
  UserPublicProfileLayoutUuidKey = 'user_public_profile_layout_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Public_Profile_Layout_Delete_At_Path_Input = {
  preferences?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Public_Profile_Layout_Delete_Elem_Input = {
  preferences?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Public_Profile_Layout_Delete_Key_Input = {
  preferences?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  size?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Public_Profile_Layout_Max_Fields = {
  __typename?: 'user_public_profile_layout_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Public_Profile_Layout_Min_Fields = {
  __typename?: 'user_public_profile_layout_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Mutation_Response = {
  __typename?: 'user_public_profile_layout_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Public_Profile_Layout>;
};

/** on_conflict condition type for table "user_public_profile_layout" */
export type User_Public_Profile_Layout_On_Conflict = {
  constraint: User_Public_Profile_Layout_Constraint;
  update_columns?: Array<User_Public_Profile_Layout_Update_Column>;
  where?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
};

/** Ordering options when selecting data from "user_public_profile_layout". */
export type User_Public_Profile_Layout_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  preferences?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_public_profile_layout */
export type User_Public_Profile_Layout_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Public_Profile_Layout_Prepend_Input = {
  preferences?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_public_profile_layout" */
export enum User_Public_Profile_Layout_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  size?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Public_Profile_Layout_Stddev_Fields = {
  __typename?: 'user_public_profile_layout_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Public_Profile_Layout_Stddev_Pop_Fields = {
  __typename?: 'user_public_profile_layout_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Public_Profile_Layout_Stddev_Samp_Fields = {
  __typename?: 'user_public_profile_layout_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Public_Profile_Layout_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Public_Profile_Layout_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  size?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Public_Profile_Layout_Sum_Fields = {
  __typename?: 'user_public_profile_layout_sum_fields';
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_public_profile_layout" */
export enum User_Public_Profile_Layout_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Public_Profile_Layout_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Public_Profile_Layout_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Public_Profile_Layout_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Public_Profile_Layout_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Public_Profile_Layout_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Public_Profile_Layout_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Public_Profile_Layout_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Public_Profile_Layout_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Public_Profile_Layout_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Public_Profile_Layout_Var_Pop_Fields = {
  __typename?: 'user_public_profile_layout_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Public_Profile_Layout_Var_Samp_Fields = {
  __typename?: 'user_public_profile_layout_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Public_Profile_Layout_Variance_Fields = {
  __typename?: 'user_public_profile_layout_variance_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_public_profile_layout" */
export type User_Public_Profile_Layout_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_public_profile_projects" */
export type User_Public_Profile_Projects = {
  __typename?: 'user_public_profile_projects';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "user_public_profile_projects" */
export type User_Public_Profile_Projects_Aggregate = {
  __typename?: 'user_public_profile_projects_aggregate';
  aggregate?: Maybe<User_Public_Profile_Projects_Aggregate_Fields>;
  nodes: Array<User_Public_Profile_Projects>;
};

export type User_Public_Profile_Projects_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Public_Profile_Projects_Aggregate_Bool_Exp_Count>;
};

export type User_Public_Profile_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Public_Profile_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_public_profile_projects" */
export type User_Public_Profile_Projects_Aggregate_Fields = {
  __typename?: 'user_public_profile_projects_aggregate_fields';
  avg?: Maybe<User_Public_Profile_Projects_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Public_Profile_Projects_Max_Fields>;
  min?: Maybe<User_Public_Profile_Projects_Min_Fields>;
  stddev?: Maybe<User_Public_Profile_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<User_Public_Profile_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Public_Profile_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<User_Public_Profile_Projects_Sum_Fields>;
  var_pop?: Maybe<User_Public_Profile_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<User_Public_Profile_Projects_Var_Samp_Fields>;
  variance?: Maybe<User_Public_Profile_Projects_Variance_Fields>;
};


/** aggregate fields of "user_public_profile_projects" */
export type User_Public_Profile_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Public_Profile_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Aggregate_Order_By = {
  avg?: InputMaybe<User_Public_Profile_Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Public_Profile_Projects_Max_Order_By>;
  min?: InputMaybe<User_Public_Profile_Projects_Min_Order_By>;
  stddev?: InputMaybe<User_Public_Profile_Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Public_Profile_Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Public_Profile_Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Public_Profile_Projects_Sum_Order_By>;
  var_pop?: InputMaybe<User_Public_Profile_Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Public_Profile_Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Public_Profile_Projects_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Arr_Rel_Insert_Input = {
  data: Array<User_Public_Profile_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Public_Profile_Projects_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Public_Profile_Projects_Avg_Fields = {
  __typename?: 'user_public_profile_projects_avg_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Avg_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_public_profile_projects". All fields are combined with a logical 'AND'. */
export type User_Public_Profile_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<User_Public_Profile_Projects_Bool_Exp>>;
  _not?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<User_Public_Profile_Projects_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_public_profile_projects" */
export enum User_Public_Profile_Projects_Constraint {
  /** unique or primary key constraint on columns "project_id", "user_id" */
  UserPublicProfileProjectsPkey = 'user_public_profile_projects_pkey',
  /** unique or primary key constraint on columns "uuid" */
  UserPublicProfileProjectsUuidKey = 'user_public_profile_projects_uuid_key'
}

/** input type for incrementing numeric columns in table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Inc_Input = {
  project_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Public_Profile_Projects_Max_Fields = {
  __typename?: 'user_public_profile_projects_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Public_Profile_Projects_Min_Fields = {
  __typename?: 'user_public_profile_projects_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Mutation_Response = {
  __typename?: 'user_public_profile_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Public_Profile_Projects>;
};

/** on_conflict condition type for table "user_public_profile_projects" */
export type User_Public_Profile_Projects_On_Conflict = {
  constraint: User_Public_Profile_Projects_Constraint;
  update_columns?: Array<User_Public_Profile_Projects_Update_Column>;
  where?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "user_public_profile_projects". */
export type User_Public_Profile_Projects_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_public_profile_projects */
export type User_Public_Profile_Projects_Pk_Columns_Input = {
  project_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_public_profile_projects" */
export enum User_Public_Profile_Projects_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Public_Profile_Projects_Stddev_Fields = {
  __typename?: 'user_public_profile_projects_stddev_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Stddev_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Public_Profile_Projects_Stddev_Pop_Fields = {
  __typename?: 'user_public_profile_projects_stddev_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Stddev_Pop_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Public_Profile_Projects_Stddev_Samp_Fields = {
  __typename?: 'user_public_profile_projects_stddev_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Stddev_Samp_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Public_Profile_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Public_Profile_Projects_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Public_Profile_Projects_Sum_Fields = {
  __typename?: 'user_public_profile_projects_sum_fields';
  project_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Sum_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_public_profile_projects" */
export enum User_Public_Profile_Projects_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Public_Profile_Projects_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Public_Profile_Projects_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Public_Profile_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Public_Profile_Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Public_Profile_Projects_Var_Pop_Fields = {
  __typename?: 'user_public_profile_projects_var_pop_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Var_Pop_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Public_Profile_Projects_Var_Samp_Fields = {
  __typename?: 'user_public_profile_projects_var_samp_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Var_Samp_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Public_Profile_Projects_Variance_Fields = {
  __typename?: 'user_public_profile_projects_variance_fields';
  project_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_public_profile_projects" */
export type User_Public_Profile_Projects_Variance_Order_By = {
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_roles" */
export type User_Roles = {
  __typename?: 'user_roles';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  role?: Maybe<Roles>;
  role_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['Int'];
};

/** aggregated selection of "user_roles" */
export type User_Roles_Aggregate = {
  __typename?: 'user_roles_aggregate';
  aggregate?: Maybe<User_Roles_Aggregate_Fields>;
  nodes: Array<User_Roles>;
};

export type User_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Roles_Aggregate_Bool_Exp_Count>;
};

export type User_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_Fields = {
  __typename?: 'user_roles_aggregate_fields';
  avg?: Maybe<User_Roles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Roles_Max_Fields>;
  min?: Maybe<User_Roles_Min_Fields>;
  stddev?: Maybe<User_Roles_Stddev_Fields>;
  stddev_pop?: Maybe<User_Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Roles_Stddev_Samp_Fields>;
  sum?: Maybe<User_Roles_Sum_Fields>;
  var_pop?: Maybe<User_Roles_Var_Pop_Fields>;
  var_samp?: Maybe<User_Roles_Var_Samp_Fields>;
  variance?: Maybe<User_Roles_Variance_Fields>;
};


/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_roles" */
export type User_Roles_Aggregate_Order_By = {
  avg?: InputMaybe<User_Roles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Roles_Max_Order_By>;
  min?: InputMaybe<User_Roles_Min_Order_By>;
  stddev?: InputMaybe<User_Roles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Roles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Roles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Roles_Sum_Order_By>;
  var_pop?: InputMaybe<User_Roles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Roles_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Roles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_roles" */
export type User_Roles_Arr_Rel_Insert_Input = {
  data: Array<User_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Roles_Avg_Fields = {
  __typename?: 'user_roles_avg_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_roles" */
export type User_Roles_Avg_Order_By = {
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type User_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Roles_Bool_Exp>>;
  _not?: InputMaybe<User_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Roles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_roles" */
export enum User_Roles_Constraint {
  /** unique or primary key constraint on columns "role_id", "user_id" */
  PkUserRoles = 'pk_user_roles',
  /** unique or primary key constraint on columns "role_id", "user_id" */
  UniqueUserIdRoleIdUserRoles = 'unique_user_id_role_id_user_roles'
}

/** input type for incrementing numeric columns in table "user_roles" */
export type User_Roles_Inc_Input = {
  role_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_roles" */
export type User_Roles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Roles_Max_Fields = {
  __typename?: 'user_roles_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  role_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_roles" */
export type User_Roles_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Roles_Min_Fields = {
  __typename?: 'user_roles_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  role_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_roles" */
export type User_Roles_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_roles" */
export type User_Roles_Mutation_Response = {
  __typename?: 'user_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Roles>;
};

/** on_conflict condition type for table "user_roles" */
export type User_Roles_On_Conflict = {
  constraint: User_Roles_Constraint;
  update_columns?: Array<User_Roles_Update_Column>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_roles". */
export type User_Roles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_roles */
export type User_Roles_Pk_Columns_Input = {
  role_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_roles" */
export enum User_Roles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_roles" */
export type User_Roles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  role_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Roles_Stddev_Fields = {
  __typename?: 'user_roles_stddev_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_roles" */
export type User_Roles_Stddev_Order_By = {
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Roles_Stddev_Pop_Fields = {
  __typename?: 'user_roles_stddev_pop_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_roles" */
export type User_Roles_Stddev_Pop_Order_By = {
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Roles_Stddev_Samp_Fields = {
  __typename?: 'user_roles_stddev_samp_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_roles" */
export type User_Roles_Stddev_Samp_Order_By = {
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_roles" */
export type User_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Roles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  role_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Roles_Sum_Fields = {
  __typename?: 'user_roles_sum_fields';
  role_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_roles" */
export type User_Roles_Sum_Order_By = {
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_roles" */
export enum User_Roles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Roles_Var_Pop_Fields = {
  __typename?: 'user_roles_var_pop_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_roles" */
export type User_Roles_Var_Pop_Order_By = {
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Roles_Var_Samp_Fields = {
  __typename?: 'user_roles_var_samp_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_roles" */
export type User_Roles_Var_Samp_Order_By = {
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Roles_Variance_Fields = {
  __typename?: 'user_roles_variance_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_roles" */
export type User_Roles_Variance_Order_By = {
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_saved_searches" */
export type User_Saved_Searches = {
  __typename?: 'user_saved_searches';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['String'];
  query: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  uuid: Scalars['String'];
};

/** aggregated selection of "user_saved_searches" */
export type User_Saved_Searches_Aggregate = {
  __typename?: 'user_saved_searches_aggregate';
  aggregate?: Maybe<User_Saved_Searches_Aggregate_Fields>;
  nodes: Array<User_Saved_Searches>;
};

/** aggregate fields of "user_saved_searches" */
export type User_Saved_Searches_Aggregate_Fields = {
  __typename?: 'user_saved_searches_aggregate_fields';
  avg?: Maybe<User_Saved_Searches_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Saved_Searches_Max_Fields>;
  min?: Maybe<User_Saved_Searches_Min_Fields>;
  stddev?: Maybe<User_Saved_Searches_Stddev_Fields>;
  stddev_pop?: Maybe<User_Saved_Searches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Saved_Searches_Stddev_Samp_Fields>;
  sum?: Maybe<User_Saved_Searches_Sum_Fields>;
  var_pop?: Maybe<User_Saved_Searches_Var_Pop_Fields>;
  var_samp?: Maybe<User_Saved_Searches_Var_Samp_Fields>;
  variance?: Maybe<User_Saved_Searches_Variance_Fields>;
};


/** aggregate fields of "user_saved_searches" */
export type User_Saved_Searches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Saved_Searches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Saved_Searches_Avg_Fields = {
  __typename?: 'user_saved_searches_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_saved_searches". All fields are combined with a logical 'AND'. */
export type User_Saved_Searches_Bool_Exp = {
  _and?: InputMaybe<Array<User_Saved_Searches_Bool_Exp>>;
  _not?: InputMaybe<User_Saved_Searches_Bool_Exp>;
  _or?: InputMaybe<Array<User_Saved_Searches_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  query?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_saved_searches" */
export enum User_Saved_Searches_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkUserSavedSearches = 'pk_user_saved_searches',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidUserSavedSearches = 'unique_uuid_user_saved_searches'
}

/** input type for incrementing numeric columns in table "user_saved_searches" */
export type User_Saved_Searches_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_saved_searches" */
export type User_Saved_Searches_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Saved_Searches_Max_Fields = {
  __typename?: 'user_saved_searches_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Saved_Searches_Min_Fields = {
  __typename?: 'user_saved_searches_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_saved_searches" */
export type User_Saved_Searches_Mutation_Response = {
  __typename?: 'user_saved_searches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Saved_Searches>;
};

/** on_conflict condition type for table "user_saved_searches" */
export type User_Saved_Searches_On_Conflict = {
  constraint: User_Saved_Searches_Constraint;
  update_columns?: Array<User_Saved_Searches_Update_Column>;
  where?: InputMaybe<User_Saved_Searches_Bool_Exp>;
};

/** Ordering options when selecting data from "user_saved_searches". */
export type User_Saved_Searches_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_saved_searches */
export type User_Saved_Searches_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_saved_searches" */
export enum User_Saved_Searches_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Query = 'query',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "user_saved_searches" */
export type User_Saved_Searches_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Saved_Searches_Stddev_Fields = {
  __typename?: 'user_saved_searches_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Saved_Searches_Stddev_Pop_Fields = {
  __typename?: 'user_saved_searches_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Saved_Searches_Stddev_Samp_Fields = {
  __typename?: 'user_saved_searches_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_saved_searches" */
export type User_Saved_Searches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Saved_Searches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Saved_Searches_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Saved_Searches_Sum_Fields = {
  __typename?: 'user_saved_searches_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_saved_searches" */
export enum User_Saved_Searches_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Query = 'query',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type User_Saved_Searches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Saved_Searches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Saved_Searches_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Saved_Searches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Saved_Searches_Var_Pop_Fields = {
  __typename?: 'user_saved_searches_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Saved_Searches_Var_Samp_Fields = {
  __typename?: 'user_saved_searches_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Saved_Searches_Variance_Fields = {
  __typename?: 'user_saved_searches_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_skills" */
export type User_Skills = {
  __typename?: 'user_skills';
  created_at: Scalars['timestamptz'];
  experience?: Maybe<Scalars['us_experience_enum']>;
  priority?: Maybe<Scalars['Int']>;
  /** An object relationship */
  skill?: Maybe<Skills>;
  skill_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
};

/** aggregated selection of "user_skills" */
export type User_Skills_Aggregate = {
  __typename?: 'user_skills_aggregate';
  aggregate?: Maybe<User_Skills_Aggregate_Fields>;
  nodes: Array<User_Skills>;
};

export type User_Skills_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Skills_Aggregate_Bool_Exp_Count>;
};

export type User_Skills_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Skills_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Skills_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_skills" */
export type User_Skills_Aggregate_Fields = {
  __typename?: 'user_skills_aggregate_fields';
  avg?: Maybe<User_Skills_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Skills_Max_Fields>;
  min?: Maybe<User_Skills_Min_Fields>;
  stddev?: Maybe<User_Skills_Stddev_Fields>;
  stddev_pop?: Maybe<User_Skills_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Skills_Stddev_Samp_Fields>;
  sum?: Maybe<User_Skills_Sum_Fields>;
  var_pop?: Maybe<User_Skills_Var_Pop_Fields>;
  var_samp?: Maybe<User_Skills_Var_Samp_Fields>;
  variance?: Maybe<User_Skills_Variance_Fields>;
};


/** aggregate fields of "user_skills" */
export type User_Skills_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Skills_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_skills" */
export type User_Skills_Aggregate_Order_By = {
  avg?: InputMaybe<User_Skills_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Skills_Max_Order_By>;
  min?: InputMaybe<User_Skills_Min_Order_By>;
  stddev?: InputMaybe<User_Skills_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Skills_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Skills_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Skills_Sum_Order_By>;
  var_pop?: InputMaybe<User_Skills_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Skills_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Skills_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_skills" */
export type User_Skills_Arr_Rel_Insert_Input = {
  data: Array<User_Skills_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Skills_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Skills_Avg_Fields = {
  __typename?: 'user_skills_avg_fields';
  priority?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_skills" */
export type User_Skills_Avg_Order_By = {
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_skills". All fields are combined with a logical 'AND'. */
export type User_Skills_Bool_Exp = {
  _and?: InputMaybe<Array<User_Skills_Bool_Exp>>;
  _not?: InputMaybe<User_Skills_Bool_Exp>;
  _or?: InputMaybe<Array<User_Skills_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  experience?: InputMaybe<Us_Experience_Enum_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  skill?: InputMaybe<Skills_Bool_Exp>;
  skill_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_skills" */
export enum User_Skills_Constraint {
  /** unique or primary key constraint on columns "skill_id", "user_id" */
  PkUserSkills = 'pk_user_skills',
  /** unique or primary key constraint on columns "skill_id", "user_id" */
  UniqueUserIdSkillIdUserSkills = 'unique_user_id_skill_id_user_skills'
}

/** input type for incrementing numeric columns in table "user_skills" */
export type User_Skills_Inc_Input = {
  priority?: InputMaybe<Scalars['Int']>;
  skill_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_skills" */
export type User_Skills_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  experience?: InputMaybe<Scalars['us_experience_enum']>;
  priority?: InputMaybe<Scalars['Int']>;
  skill?: InputMaybe<Skills_Obj_Rel_Insert_Input>;
  skill_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Skills_Max_Fields = {
  __typename?: 'user_skills_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  experience?: Maybe<Scalars['us_experience_enum']>;
  priority?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_skills" */
export type User_Skills_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Skills_Min_Fields = {
  __typename?: 'user_skills_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  experience?: Maybe<Scalars['us_experience_enum']>;
  priority?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_skills" */
export type User_Skills_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_skills" */
export type User_Skills_Mutation_Response = {
  __typename?: 'user_skills_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Skills>;
};

/** on_conflict condition type for table "user_skills" */
export type User_Skills_On_Conflict = {
  constraint: User_Skills_Constraint;
  update_columns?: Array<User_Skills_Update_Column>;
  where?: InputMaybe<User_Skills_Bool_Exp>;
};

/** Ordering options when selecting data from "user_skills". */
export type User_Skills_Order_By = {
  created_at?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  skill?: InputMaybe<Skills_Order_By>;
  skill_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_skills */
export type User_Skills_Pk_Columns_Input = {
  skill_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_skills" */
export enum User_Skills_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Experience = 'experience',
  /** column name */
  Priority = 'priority',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_skills" */
export type User_Skills_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  experience?: InputMaybe<Scalars['us_experience_enum']>;
  priority?: InputMaybe<Scalars['Int']>;
  skill_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Skills_Stddev_Fields = {
  __typename?: 'user_skills_stddev_fields';
  priority?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_skills" */
export type User_Skills_Stddev_Order_By = {
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Skills_Stddev_Pop_Fields = {
  __typename?: 'user_skills_stddev_pop_fields';
  priority?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_skills" */
export type User_Skills_Stddev_Pop_Order_By = {
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Skills_Stddev_Samp_Fields = {
  __typename?: 'user_skills_stddev_samp_fields';
  priority?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_skills" */
export type User_Skills_Stddev_Samp_Order_By = {
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_skills" */
export type User_Skills_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Skills_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Skills_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  experience?: InputMaybe<Scalars['us_experience_enum']>;
  priority?: InputMaybe<Scalars['Int']>;
  skill_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Skills_Sum_Fields = {
  __typename?: 'user_skills_sum_fields';
  priority?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_skills" */
export type User_Skills_Sum_Order_By = {
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_skills" */
export enum User_Skills_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Experience = 'experience',
  /** column name */
  Priority = 'priority',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Skills_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Skills_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Skills_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Skills_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Skills_Var_Pop_Fields = {
  __typename?: 'user_skills_var_pop_fields';
  priority?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_skills" */
export type User_Skills_Var_Pop_Order_By = {
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Skills_Var_Samp_Fields = {
  __typename?: 'user_skills_var_samp_fields';
  priority?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_skills" */
export type User_Skills_Var_Samp_Order_By = {
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Skills_Variance_Fields = {
  __typename?: 'user_skills_variance_fields';
  priority?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_skills" */
export type User_Skills_Variance_Order_By = {
  priority?: InputMaybe<Order_By>;
  skill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** This function is used to prefix the ASSETS_URL of cover_img */
  _cover_img?: Maybe<Scalars['String']>;
  /** This function is used to prefix the ASSETS_URL */
  _profile_image?: Maybe<Scalars['String']>;
  /** A computed field, executes function "retrieve_user_projects" */
  _projects?: Maybe<Array<Projects>>;
  /** An object relationship */
  address?: Maybe<Address>;
  bio?: Maybe<Scalars['String']>;
  builders_featured: Scalars['Boolean'];
  cover_img?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dob?: Maybe<Scalars['date']>;
  /** An array relationship */
  educations: Array<Educations>;
  /** An aggregate relationship */
  educations_aggregate: Educations_Aggregate;
  email: Scalars['citext'];
  email_verified?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  experiences: Array<Experiences>;
  /** An aggregate relationship */
  experiences_aggregate: Experiences_Aggregate;
  /** An object relationship */
  extra?: Maybe<User_Extras>;
  featured: Scalars['Boolean'];
  featured_description?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  fortmatic_user_id?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['users_gender_enum']>;
  google_id?: Maybe<Scalars['citext']>;
  google_token?: Maybe<Scalars['String']>;
  /** An array relationship */
  hackathon_notes: Array<Hackathon_Notes>;
  /** An aggregate relationship */
  hackathon_notes_aggregate: Hackathon_Notes_Aggregate;
  /** An array relationship */
  hackathon_schwags: Array<User_Hackathon_Schwags>;
  /** An aggregate relationship */
  hackathon_schwags_aggregate: User_Hackathon_Schwags_Aggregate;
  id: Scalars['Int'];
  /** An array relationship */
  judges: Array<Judges>;
  /** An aggregate relationship */
  judges_aggregate: Judges_Aggregate;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  oauth_providers: Array<Oauth>;
  /** An aggregate relationship */
  oauth_providers_aggregate: Oauth_Aggregate;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  phone_number_verified?: Maybe<Scalars['Boolean']>;
  profile_image?: Maybe<Scalars['String']>;
  /** An array relationship */
  profile_layout_elements: Array<User_Public_Profile_Layout>;
  /** An aggregate relationship */
  profile_layout_elements_aggregate: User_Public_Profile_Layout_Aggregate;
  /** An array relationship */
  profiles: Array<User_Profiles>;
  /** An aggregate relationship */
  profiles_aggregate: User_Profiles_Aggregate;
  /** An array relationship */
  public_profile_projects: Array<User_Public_Profile_Projects>;
  /** An aggregate relationship */
  public_profile_projects_aggregate: User_Public_Profile_Projects_Aggregate;
  /** An array relationship */
  roles: Array<User_Roles>;
  /** An aggregate relationship */
  roles_aggregate: User_Roles_Aggregate;
  /** An array relationship */
  rss_feeds: Array<User_Profile_Rss_Feeds>;
  /** An aggregate relationship */
  rss_feeds_aggregate: User_Profile_Rss_Feeds_Aggregate;
  salt?: Maybe<Scalars['String']>;
  /** An array relationship */
  shipping_addresses: Array<Shop_Shipping_Addresses>;
  /** An aggregate relationship */
  shipping_addresses_aggregate: Shop_Shipping_Addresses_Aggregate;
  short_bio?: Maybe<Scalars['String']>;
  /** An array relationship */
  skills: Array<User_Skills>;
  /** An aggregate relationship */
  skills_aggregate: User_Skills_Aggregate;
  status?: Maybe<Scalars['users_status_enum']>;
  /** An array relationship */
  sumsub_applicants: Array<Sumsub_Applicants>;
  /** An aggregate relationship */
  sumsub_applicants_aggregate: Sumsub_Applicants_Aggregate;
  /** An array relationship */
  synaps_kyc_sessions: Array<Synaps_Kyc_Sessions>;
  /** An aggregate relationship */
  synaps_kyc_sessions_aggregate: Synaps_Kyc_Sessions_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_hackathon_bounties: Array<User_Hackathon_Bounties>;
  /** An aggregate relationship */
  user_hackathon_bounties_aggregate: User_Hackathon_Bounties_Aggregate;
  /** An array relationship */
  user_hackathon_credentials: Array<User_Hackathon_Credentials>;
  /** An aggregate relationship */
  user_hackathon_credentials_aggregate: User_Hackathon_Credentials_Aggregate;
  /** An array relationship */
  user_hackathon_reminders: Array<User_Hackathon_Reminders>;
  /** An aggregate relationship */
  user_hackathon_reminders_aggregate: User_Hackathon_Reminders_Aggregate;
  /** An array relationship */
  user_hackathons: Array<User_Hackathons>;
  /** An aggregate relationship */
  user_hackathons_aggregate: User_Hackathons_Aggregate;
  username: Scalars['citext'];
  uuid: Scalars['String'];
  verified: Scalars['Boolean'];
};


/** columns and relationships of "users" */
export type Users_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEducationsArgs = {
  distinct_on?: InputMaybe<Array<Educations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educations_Order_By>>;
  where?: InputMaybe<Educations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEducations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Educations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Educations_Order_By>>;
  where?: InputMaybe<Educations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersExperiencesArgs = {
  distinct_on?: InputMaybe<Array<Experiences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experiences_Order_By>>;
  where?: InputMaybe<Experiences_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersExperiences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Experiences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Experiences_Order_By>>;
  where?: InputMaybe<Experiences_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersHackathon_NotesArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Notes_Order_By>>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersHackathon_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hackathon_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hackathon_Notes_Order_By>>;
  where?: InputMaybe<Hackathon_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersHackathon_SchwagsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersHackathon_Schwags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Schwags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Schwags_Order_By>>;
  where?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersJudgesArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersJudges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Judges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Judges_Order_By>>;
  where?: InputMaybe<Judges_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOauth_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Order_By>>;
  where?: InputMaybe<Oauth_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOauth_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oauth_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Oauth_Order_By>>;
  where?: InputMaybe<Oauth_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProfile_Layout_ElementsArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Layout_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProfile_Layout_Elements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Layout_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPublic_Profile_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Projects_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPublic_Profile_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Profile_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Profile_Projects_Order_By>>;
  where?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRss_FeedsArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feeds_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRss_Feeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Rss_Feeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profile_Rss_Feeds_Order_By>>;
  where?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersShipping_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Shop_Shipping_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Shipping_Addresses_Order_By>>;
  where?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersShipping_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shop_Shipping_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shop_Shipping_Addresses_Order_By>>;
  where?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSkillsArgs = {
  distinct_on?: InputMaybe<Array<User_Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Skills_Order_By>>;
  where?: InputMaybe<User_Skills_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSkills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Skills_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Skills_Order_By>>;
  where?: InputMaybe<User_Skills_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSumsub_ApplicantsArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSumsub_Applicants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sumsub_Applicants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sumsub_Applicants_Order_By>>;
  where?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSynaps_Kyc_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Sessions_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSynaps_Kyc_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Synaps_Kyc_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Synaps_Kyc_Sessions_Order_By>>;
  where?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Hackathon_BountiesArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Hackathon_Bounties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Bounties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Bounties_Order_By>>;
  where?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Hackathon_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Hackathon_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Credentials_Order_By>>;
  where?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Hackathon_RemindersArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Reminders_Order_By>>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Hackathon_Reminders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathon_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathon_Reminders_Order_By>>;
  where?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_HackathonsArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Hackathons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Hackathons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Hackathons_Order_By>>;
  where?: InputMaybe<User_Hackathons_Bool_Exp>;
};

export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _cover_img?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  _profile_image?: InputMaybe<String_Comparison_Exp>;
  _projects?: InputMaybe<Projects_Bool_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  bio?: InputMaybe<String_Comparison_Exp>;
  builders_featured?: InputMaybe<Boolean_Comparison_Exp>;
  cover_img?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dob?: InputMaybe<Date_Comparison_Exp>;
  educations?: InputMaybe<Educations_Bool_Exp>;
  educations_aggregate?: InputMaybe<Educations_Aggregate_Bool_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  experiences?: InputMaybe<Experiences_Bool_Exp>;
  experiences_aggregate?: InputMaybe<Experiences_Aggregate_Bool_Exp>;
  extra?: InputMaybe<User_Extras_Bool_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  featured_description?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  fortmatic_user_id?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Users_Gender_Enum_Comparison_Exp>;
  google_id?: InputMaybe<Citext_Comparison_Exp>;
  google_token?: InputMaybe<String_Comparison_Exp>;
  hackathon_notes?: InputMaybe<Hackathon_Notes_Bool_Exp>;
  hackathon_notes_aggregate?: InputMaybe<Hackathon_Notes_Aggregate_Bool_Exp>;
  hackathon_schwags?: InputMaybe<User_Hackathon_Schwags_Bool_Exp>;
  hackathon_schwags_aggregate?: InputMaybe<User_Hackathon_Schwags_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  judges?: InputMaybe<Judges_Bool_Exp>;
  judges_aggregate?: InputMaybe<Judges_Aggregate_Bool_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  middle_name?: InputMaybe<String_Comparison_Exp>;
  oauth_providers?: InputMaybe<Oauth_Bool_Exp>;
  oauth_providers_aggregate?: InputMaybe<Oauth_Aggregate_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  phone_number_verified?: InputMaybe<Boolean_Comparison_Exp>;
  profile_image?: InputMaybe<String_Comparison_Exp>;
  profile_layout_elements?: InputMaybe<User_Public_Profile_Layout_Bool_Exp>;
  profile_layout_elements_aggregate?: InputMaybe<User_Public_Profile_Layout_Aggregate_Bool_Exp>;
  profiles?: InputMaybe<User_Profiles_Bool_Exp>;
  profiles_aggregate?: InputMaybe<User_Profiles_Aggregate_Bool_Exp>;
  public_profile_projects?: InputMaybe<User_Public_Profile_Projects_Bool_Exp>;
  public_profile_projects_aggregate?: InputMaybe<User_Public_Profile_Projects_Aggregate_Bool_Exp>;
  roles?: InputMaybe<User_Roles_Bool_Exp>;
  roles_aggregate?: InputMaybe<User_Roles_Aggregate_Bool_Exp>;
  rss_feeds?: InputMaybe<User_Profile_Rss_Feeds_Bool_Exp>;
  rss_feeds_aggregate?: InputMaybe<User_Profile_Rss_Feeds_Aggregate_Bool_Exp>;
  salt?: InputMaybe<String_Comparison_Exp>;
  shipping_addresses?: InputMaybe<Shop_Shipping_Addresses_Bool_Exp>;
  shipping_addresses_aggregate?: InputMaybe<Shop_Shipping_Addresses_Aggregate_Bool_Exp>;
  short_bio?: InputMaybe<String_Comparison_Exp>;
  skills?: InputMaybe<User_Skills_Bool_Exp>;
  skills_aggregate?: InputMaybe<User_Skills_Aggregate_Bool_Exp>;
  status?: InputMaybe<Users_Status_Enum_Comparison_Exp>;
  sumsub_applicants?: InputMaybe<Sumsub_Applicants_Bool_Exp>;
  sumsub_applicants_aggregate?: InputMaybe<Sumsub_Applicants_Aggregate_Bool_Exp>;
  synaps_kyc_sessions?: InputMaybe<Synaps_Kyc_Sessions_Bool_Exp>;
  synaps_kyc_sessions_aggregate?: InputMaybe<Synaps_Kyc_Sessions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_hackathon_bounties?: InputMaybe<User_Hackathon_Bounties_Bool_Exp>;
  user_hackathon_bounties_aggregate?: InputMaybe<User_Hackathon_Bounties_Aggregate_Bool_Exp>;
  user_hackathon_credentials?: InputMaybe<User_Hackathon_Credentials_Bool_Exp>;
  user_hackathon_credentials_aggregate?: InputMaybe<User_Hackathon_Credentials_Aggregate_Bool_Exp>;
  user_hackathon_reminders?: InputMaybe<User_Hackathon_Reminders_Bool_Exp>;
  user_hackathon_reminders_aggregate?: InputMaybe<User_Hackathon_Reminders_Aggregate_Bool_Exp>;
  user_hackathons?: InputMaybe<User_Hackathons_Bool_Exp>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Bool_Exp>;
  username?: InputMaybe<Citext_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkUsers = 'pk_users',
  /** unique or primary key constraint on columns "email" */
  UniqueEmailUsers = 'unique_email_users',
  /** unique or primary key constraint on columns "google_id" */
  UniqueGoogleIdUsers = 'unique_google_id_users',
  /** unique or primary key constraint on columns "salt" */
  UniqueSaltUsers = 'unique_salt_users',
  /** unique or primary key constraint on columns "username" */
  UniqueUsernameUsers = 'unique_username_users',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidUsers = 'unique_uuid_users'
}

/** Boolean expression to compare columns of type "users_gender_enum". All fields are combined with logical 'AND'. */
export type Users_Gender_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['users_gender_enum']>;
  _gt?: InputMaybe<Scalars['users_gender_enum']>;
  _gte?: InputMaybe<Scalars['users_gender_enum']>;
  _in?: InputMaybe<Array<Scalars['users_gender_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['users_gender_enum']>;
  _lte?: InputMaybe<Scalars['users_gender_enum']>;
  _neq?: InputMaybe<Scalars['users_gender_enum']>;
  _nin?: InputMaybe<Array<Scalars['users_gender_enum']>>;
};

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  bio?: InputMaybe<Scalars['String']>;
  builders_featured?: InputMaybe<Scalars['Boolean']>;
  cover_img?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  dob?: InputMaybe<Scalars['date']>;
  educations?: InputMaybe<Educations_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['citext']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  experiences?: InputMaybe<Experiences_Arr_Rel_Insert_Input>;
  extra?: InputMaybe<User_Extras_Obj_Rel_Insert_Input>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featured_description?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  fortmatic_user_id?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['users_gender_enum']>;
  google_id?: InputMaybe<Scalars['citext']>;
  google_token?: InputMaybe<Scalars['String']>;
  hackathon_notes?: InputMaybe<Hackathon_Notes_Arr_Rel_Insert_Input>;
  hackathon_schwags?: InputMaybe<User_Hackathon_Schwags_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  judges?: InputMaybe<Judges_Arr_Rel_Insert_Input>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  oauth_providers?: InputMaybe<Oauth_Arr_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']>;
  profile_image?: InputMaybe<Scalars['String']>;
  profile_layout_elements?: InputMaybe<User_Public_Profile_Layout_Arr_Rel_Insert_Input>;
  profiles?: InputMaybe<User_Profiles_Arr_Rel_Insert_Input>;
  public_profile_projects?: InputMaybe<User_Public_Profile_Projects_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<User_Roles_Arr_Rel_Insert_Input>;
  rss_feeds?: InputMaybe<User_Profile_Rss_Feeds_Arr_Rel_Insert_Input>;
  salt?: InputMaybe<Scalars['String']>;
  shipping_addresses?: InputMaybe<Shop_Shipping_Addresses_Arr_Rel_Insert_Input>;
  short_bio?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<User_Skills_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['users_status_enum']>;
  sumsub_applicants?: InputMaybe<Sumsub_Applicants_Arr_Rel_Insert_Input>;
  synaps_kyc_sessions?: InputMaybe<Synaps_Kyc_Sessions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_hackathon_bounties?: InputMaybe<User_Hackathon_Bounties_Arr_Rel_Insert_Input>;
  user_hackathon_credentials?: InputMaybe<User_Hackathon_Credentials_Arr_Rel_Insert_Input>;
  user_hackathon_reminders?: InputMaybe<User_Hackathon_Reminders_Arr_Rel_Insert_Input>;
  user_hackathons?: InputMaybe<User_Hackathons_Arr_Rel_Insert_Input>;
  username?: InputMaybe<Scalars['citext']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  bio?: Maybe<Scalars['String']>;
  cover_img?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dob?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['citext']>;
  featured_description?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  fortmatic_user_id?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['users_gender_enum']>;
  google_id?: Maybe<Scalars['citext']>;
  google_token?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  profile_image?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  short_bio?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['users_status_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['citext']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  bio?: InputMaybe<Order_By>;
  cover_img?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  featured_description?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  fortmatic_user_id?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  google_id?: InputMaybe<Order_By>;
  google_token?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile_image?: InputMaybe<Order_By>;
  salt?: InputMaybe<Order_By>;
  short_bio?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  bio?: Maybe<Scalars['String']>;
  cover_img?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dob?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['citext']>;
  featured_description?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  fortmatic_user_id?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['users_gender_enum']>;
  google_id?: Maybe<Scalars['citext']>;
  google_token?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  profile_image?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  short_bio?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['users_status_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['citext']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  bio?: InputMaybe<Order_By>;
  cover_img?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  featured_description?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  fortmatic_user_id?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  google_id?: InputMaybe<Order_By>;
  google_token?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile_image?: InputMaybe<Order_By>;
  salt?: InputMaybe<Order_By>;
  short_bio?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  _cover_img?: InputMaybe<Order_By>;
  _profile_image?: InputMaybe<Order_By>;
  _projects_aggregate?: InputMaybe<Projects_Aggregate_Order_By>;
  address?: InputMaybe<Address_Order_By>;
  bio?: InputMaybe<Order_By>;
  builders_featured?: InputMaybe<Order_By>;
  cover_img?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  educations_aggregate?: InputMaybe<Educations_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  email_verified?: InputMaybe<Order_By>;
  experiences_aggregate?: InputMaybe<Experiences_Aggregate_Order_By>;
  extra?: InputMaybe<User_Extras_Order_By>;
  featured?: InputMaybe<Order_By>;
  featured_description?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  fortmatic_user_id?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  google_id?: InputMaybe<Order_By>;
  google_token?: InputMaybe<Order_By>;
  hackathon_notes_aggregate?: InputMaybe<Hackathon_Notes_Aggregate_Order_By>;
  hackathon_schwags_aggregate?: InputMaybe<User_Hackathon_Schwags_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  judges_aggregate?: InputMaybe<Judges_Aggregate_Order_By>;
  last_name?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  oauth_providers_aggregate?: InputMaybe<Oauth_Aggregate_Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  phone_number_verified?: InputMaybe<Order_By>;
  profile_image?: InputMaybe<Order_By>;
  profile_layout_elements_aggregate?: InputMaybe<User_Public_Profile_Layout_Aggregate_Order_By>;
  profiles_aggregate?: InputMaybe<User_Profiles_Aggregate_Order_By>;
  public_profile_projects_aggregate?: InputMaybe<User_Public_Profile_Projects_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<User_Roles_Aggregate_Order_By>;
  rss_feeds_aggregate?: InputMaybe<User_Profile_Rss_Feeds_Aggregate_Order_By>;
  salt?: InputMaybe<Order_By>;
  shipping_addresses_aggregate?: InputMaybe<Shop_Shipping_Addresses_Aggregate_Order_By>;
  short_bio?: InputMaybe<Order_By>;
  skills_aggregate?: InputMaybe<User_Skills_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  sumsub_applicants_aggregate?: InputMaybe<Sumsub_Applicants_Aggregate_Order_By>;
  synaps_kyc_sessions_aggregate?: InputMaybe<Synaps_Kyc_Sessions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_hackathon_bounties_aggregate?: InputMaybe<User_Hackathon_Bounties_Aggregate_Order_By>;
  user_hackathon_credentials_aggregate?: InputMaybe<User_Hackathon_Credentials_Aggregate_Order_By>;
  user_hackathon_reminders_aggregate?: InputMaybe<User_Hackathon_Reminders_Aggregate_Order_By>;
  user_hackathons_aggregate?: InputMaybe<User_Hackathons_Aggregate_Order_By>;
  username?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  BuildersFeatured = 'builders_featured',
  /** column name */
  CoverImg = 'cover_img',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Featured = 'featured',
  /** column name */
  FeaturedDescription = 'featured_description',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FortmaticUserId = 'fortmatic_user_id',
  /** column name */
  Gender = 'gender',
  /** column name */
  GoogleId = 'google_id',
  /** column name */
  GoogleToken = 'google_token',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified',
  /** column name */
  ProfileImage = 'profile_image',
  /** column name */
  Salt = 'salt',
  /** column name */
  ShortBio = 'short_bio',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  bio?: InputMaybe<Scalars['String']>;
  builders_featured?: InputMaybe<Scalars['Boolean']>;
  cover_img?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  dob?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['citext']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featured_description?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  fortmatic_user_id?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['users_gender_enum']>;
  google_id?: InputMaybe<Scalars['citext']>;
  google_token?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']>;
  profile_image?: InputMaybe<Scalars['String']>;
  salt?: InputMaybe<Scalars['String']>;
  short_bio?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['users_status_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['citext']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to compare columns of type "users_status_enum". All fields are combined with logical 'AND'. */
export type Users_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['users_status_enum']>;
  _gt?: InputMaybe<Scalars['users_status_enum']>;
  _gte?: InputMaybe<Scalars['users_status_enum']>;
  _in?: InputMaybe<Array<Scalars['users_status_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['users_status_enum']>;
  _lte?: InputMaybe<Scalars['users_status_enum']>;
  _neq?: InputMaybe<Scalars['users_status_enum']>;
  _nin?: InputMaybe<Array<Scalars['users_status_enum']>>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  bio?: InputMaybe<Scalars['String']>;
  builders_featured?: InputMaybe<Scalars['Boolean']>;
  cover_img?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  dob?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['citext']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  featured_description?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  fortmatic_user_id?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['users_gender_enum']>;
  google_id?: InputMaybe<Scalars['citext']>;
  google_token?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']>;
  profile_image?: InputMaybe<Scalars['String']>;
  salt?: InputMaybe<Scalars['String']>;
  short_bio?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['users_status_enum']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['citext']>;
  uuid?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  BuildersFeatured = 'builders_featured',
  /** column name */
  CoverImg = 'cover_img',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Featured = 'featured',
  /** column name */
  FeaturedDescription = 'featured_description',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FortmaticUserId = 'fortmatic_user_id',
  /** column name */
  Gender = 'gender',
  /** column name */
  GoogleId = 'google_id',
  /** column name */
  GoogleToken = 'google_token',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified',
  /** column name */
  ProfileImage = 'profile_image',
  /** column name */
  Salt = 'salt',
  /** column name */
  ShortBio = 'short_bio',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Verified = 'verified'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

export type Want_Idea_Args = {
  idea_uuid?: InputMaybe<Scalars['String']>;
  want_idea?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "winners" */
export type Winners = {
  __typename?: 'winners';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  prize?: Maybe<Prizes>;
  prize_id: Scalars['Int'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['String'];
};

/** aggregated selection of "winners" */
export type Winners_Aggregate = {
  __typename?: 'winners_aggregate';
  aggregate?: Maybe<Winners_Aggregate_Fields>;
  nodes: Array<Winners>;
};

export type Winners_Aggregate_Bool_Exp = {
  count?: InputMaybe<Winners_Aggregate_Bool_Exp_Count>;
};

export type Winners_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Winners_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Winners_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "winners" */
export type Winners_Aggregate_Fields = {
  __typename?: 'winners_aggregate_fields';
  avg?: Maybe<Winners_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Winners_Max_Fields>;
  min?: Maybe<Winners_Min_Fields>;
  stddev?: Maybe<Winners_Stddev_Fields>;
  stddev_pop?: Maybe<Winners_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Winners_Stddev_Samp_Fields>;
  sum?: Maybe<Winners_Sum_Fields>;
  var_pop?: Maybe<Winners_Var_Pop_Fields>;
  var_samp?: Maybe<Winners_Var_Samp_Fields>;
  variance?: Maybe<Winners_Variance_Fields>;
};


/** aggregate fields of "winners" */
export type Winners_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Winners_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "winners" */
export type Winners_Aggregate_Order_By = {
  avg?: InputMaybe<Winners_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Winners_Max_Order_By>;
  min?: InputMaybe<Winners_Min_Order_By>;
  stddev?: InputMaybe<Winners_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Winners_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Winners_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Winners_Sum_Order_By>;
  var_pop?: InputMaybe<Winners_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Winners_Var_Samp_Order_By>;
  variance?: InputMaybe<Winners_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "winners" */
export type Winners_Arr_Rel_Insert_Input = {
  data: Array<Winners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Winners_On_Conflict>;
};

/** aggregate avg on columns */
export type Winners_Avg_Fields = {
  __typename?: 'winners_avg_fields';
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "winners" */
export type Winners_Avg_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "winners". All fields are combined with a logical 'AND'. */
export type Winners_Bool_Exp = {
  _and?: InputMaybe<Array<Winners_Bool_Exp>>;
  _not?: InputMaybe<Winners_Bool_Exp>;
  _or?: InputMaybe<Array<Winners_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  prize?: InputMaybe<Prizes_Bool_Exp>;
  prize_id?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "winners" */
export enum Winners_Constraint {
  /** unique or primary key constraint on columns "project_id", "prize_id" */
  PkWinners = 'pk_winners',
  /** unique or primary key constraint on columns "uuid" */
  UniqueUuidWinners = 'unique_uuid_winners'
}

/** input type for incrementing numeric columns in table "winners" */
export type Winners_Inc_Input = {
  prize_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "winners" */
export type Winners_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  prize?: InputMaybe<Prizes_Obj_Rel_Insert_Input>;
  prize_id?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Winners_Max_Fields = {
  __typename?: 'winners_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  prize_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "winners" */
export type Winners_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Winners_Min_Fields = {
  __typename?: 'winners_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  prize_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "winners" */
export type Winners_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "winners" */
export type Winners_Mutation_Response = {
  __typename?: 'winners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Winners>;
};

/** on_conflict condition type for table "winners" */
export type Winners_On_Conflict = {
  constraint: Winners_Constraint;
  update_columns?: Array<Winners_Update_Column>;
  where?: InputMaybe<Winners_Bool_Exp>;
};

/** Ordering options when selecting data from "winners". */
export type Winners_Order_By = {
  created_at?: InputMaybe<Order_By>;
  prize?: InputMaybe<Prizes_Order_By>;
  prize_id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: winners */
export type Winners_Pk_Columns_Input = {
  prize_id: Scalars['Int'];
  project_id: Scalars['Int'];
};

/** select columns of table "winners" */
export enum Winners_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "winners" */
export type Winners_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Winners_Stddev_Fields = {
  __typename?: 'winners_stddev_fields';
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "winners" */
export type Winners_Stddev_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Winners_Stddev_Pop_Fields = {
  __typename?: 'winners_stddev_pop_fields';
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "winners" */
export type Winners_Stddev_Pop_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Winners_Stddev_Samp_Fields = {
  __typename?: 'winners_stddev_samp_fields';
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "winners" */
export type Winners_Stddev_Samp_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "winners" */
export type Winners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Winners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Winners_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  prize_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Winners_Sum_Fields = {
  __typename?: 'winners_sum_fields';
  prize_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "winners" */
export type Winners_Sum_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** update columns of table "winners" */
export enum Winners_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Winners_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Winners_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Winners_Set_Input>;
  /** filter the rows which have to be updated */
  where: Winners_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Winners_Var_Pop_Fields = {
  __typename?: 'winners_var_pop_fields';
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "winners" */
export type Winners_Var_Pop_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Winners_Var_Samp_Fields = {
  __typename?: 'winners_var_samp_fields';
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "winners" */
export type Winners_Var_Samp_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Winners_Variance_Fields = {
  __typename?: 'winners_variance_fields';
  prize_id?: Maybe<Scalars['Float']>;
  project_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "winners" */
export type Winners_Variance_Order_By = {
  prize_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

export type GetHackathonMicrositeQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type GetHackathonMicrositeQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, city?: string | null, country?: string | null, location?: string | null, tagline?: string | null, timezone?: string | null, desc?: string | null, apply_mode?: any | null, devfolio_official?: boolean | null, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, rating: any, edition?: number | null, team_min?: number | null, cover_img?: string | null, favicon?: string | null, team_max?: number | null, brand?: { __typename?: 'hackathon_brands', name: string, hackathons: Array<{ __typename?: 'hackathons', edition?: number | null, edition_name?: string | null, name: any, slug?: any | null, uuid: string, starts_at?: any | null, favicon?: string | null }> } | null, tracks: Array<{ __typename?: 'hackathon_tracks', uuid: string, name: string, desc?: string | null }>, settings?: { __typename?: 'hackathon_settings', reg_starts_at?: any | null, reg_ends_at?: any | null, winner_announce_at?: any | null, leaderboard_enabled: boolean, primary_color?: string | null, coc_url?: string | null, contact_email?: any | null, review?: boolean | null, site?: string | null, linkedin?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, farcaster?: string | null, quadratic_voting_enabled: boolean, quadratic_voting_ends_at?: any | null, quadratic_voting_starts_at?: any | null, quadratic_voting_prize_pool_amount?: number | null, quadratic_voting_results_announced: boolean, referral_prize_doc_link?: string | null, is_hybrid?: boolean | null, tokenproof_gating_enabled: boolean, quadratic_voting_currency?: Quadratic_Voting_Currency_Enum | null, winner_announced?: boolean | null, external_apply_url?: string | null, show_more_hackathons?: boolean | null, quadratic_voting_chain?: Quadratic_Voting_Chain_Enum | null, logo?: string | null } | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, faqs: Array<{ __typename?: 'hackathon_faq', uuid: string, question: string, answer: string, order?: number | null }>, judges: Array<{ __typename?: 'judges', uuid: string, name: string, job_title?: string | null, order: number, website?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, linkedin?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, farcaster?: string | null, featured: boolean, hidden: boolean, is_mentor?: boolean | null, profile_img?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, logo?: string | null } | null }>, events: Array<{ __typename?: 'hackathon_events', uuid: string, title: string, description?: string | null, type: Hackathon_Event_Type_Enum, starts_at: any, ends_at?: any | null, url?: string | null, meeting_url?: string | null, location?: string | null, sponsors: Array<{ __typename?: 'hackathon_event_sponsors', sponsor: { __typename?: 'sponsors', uuid: string, name?: string | null, logo?: string | null } }>, speakers: Array<{ __typename?: 'hackathon_event_speakers', speaker?: { __typename?: 'judges', uuid: string, name: string, job_title?: string | null, order: number, website?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, linkedin?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, farcaster?: string | null, featured: boolean, hidden: boolean, profile_img?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, logo?: string | null } | null } | null }> }>, hackathon_event_groups: Array<{ __typename?: 'hackathon_event_groups', name: string, uuid: string, hackathon_events: Array<{ __typename?: 'hackathon_events', uuid: string, title: string, description?: string | null, type: Hackathon_Event_Type_Enum, starts_at: any, ends_at?: any | null, url?: string | null, meeting_url?: string | null, location?: string | null, sponsors: Array<{ __typename?: 'hackathon_event_sponsors', sponsor: { __typename?: 'sponsors', uuid: string, name?: string | null, logo?: string | null } }>, speakers: Array<{ __typename?: 'hackathon_event_speakers', speaker?: { __typename?: 'judges', uuid: string, name: string, job_title?: string | null, order: number, website?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, linkedin?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, farcaster?: string | null, featured: boolean, hidden: boolean, profile_img?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, logo?: string | null } | null } | null }> }> }>, prizes: Array<{ __typename?: 'prizes', name: string, logo?: string | null, desc?: string | null, uuid: string, is_sponsor_prize?: boolean | null, currency?: string | null, amount?: any | null, quantity?: number | null, sponsors: Array<{ __typename?: 'prize_sponsors', uuid: string, sponsor?: { __typename?: 'sponsors', uuid: string, name?: string | null } | null }>, prize_track?: { __typename?: 'prize_tracks', uuid: string } | null, winners_aggregate: { __typename?: 'winners_aggregate', aggregate?: { __typename?: 'winners_aggregate_fields', count: number } | null } }>, prize_tracks: Array<{ __typename?: 'prize_tracks', uuid: string, name?: string | null, description?: string | null, sponsor?: { __typename?: 'sponsors', uuid: string, name?: string | null } | null }>, sponsor_tiers: Array<{ __typename?: 'sponsor_tiers', uuid: string, name?: string | null, position?: number | null, width?: number | null, sponsors: Array<{ __typename?: 'sponsors', uuid: string, name?: string | null, about?: string | null, position?: number | null, logo?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, favicon?: string | null } | null, prize_tracks: Array<{ __typename?: 'prize_tracks', prizes: Array<{ __typename?: 'prizes', amount?: any | null, currency?: string | null }> }> }> }>, stakings: Array<{ __typename?: 'hackathon_stakings', type: Hackathon_Staking_Type_Enum, amount: any, uuid: string }> }>, more_hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, devfolio_official?: boolean | null, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, rating: any, timezone?: string | null, participants_count?: number | null, participants_details?: any | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, settings?: { __typename?: 'hackathon_settings', reg_starts_at?: any | null, reg_ends_at?: any | null, primary_color?: string | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, logo?: string | null } | null }> };

export type HackathonTracksQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonTracksQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', tracks: Array<{ __typename?: 'hackathon_tracks', uuid: string, name: string, desc?: string | null }> }> };

export type HackathonLeaderboardQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonLeaderboardQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, name: any, slug?: any | null, type: Hackathon_Type_Enum, tagline?: string | null, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, rating: any, city?: string | null, country?: string | null, timezone?: string | null, location?: string | null, settings?: { __typename?: 'hackathon_settings', quadratic_voting_results_announced: boolean, quadratic_voting_prize_pool_amount?: number | null, quadratic_voting_currency?: Quadratic_Voting_Currency_Enum | null, quadratic_voting_chain?: Quadratic_Voting_Chain_Enum | null, leaderboard_enabled: boolean, referral_prize_doc_link?: string | null, reg_starts_at?: any | null, reg_ends_at?: any | null, is_hybrid?: boolean | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, telegram?: string | null, discord?: string | null, medium?: string | null, instagram?: string | null, slack?: string | null, tokenproof_gating_enabled: boolean, external_apply_url?: string | null } | null }> };

export type HackathonQvQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonQvQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, name: any, slug?: any | null, settings?: { __typename?: 'hackathon_settings', quadratic_voting_starts_at?: any | null, quadratic_voting_ends_at?: any | null, quadratic_voting_results_announced: boolean, quadratic_voting_prize_pool_amount?: number | null, quadratic_voting_currency?: Quadratic_Voting_Currency_Enum | null, quadratic_voting_chain?: Quadratic_Voting_Chain_Enum | null, twitter?: string | null, winner_announced?: boolean | null } | null }> };

export type HackathonScheduleQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonScheduleQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, name: any, slug?: any | null, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, timezone?: string | null, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, winner_announce_at?: any | null, quadratic_voting_starts_at?: any | null, quadratic_voting_ends_at?: any | null, quadratic_voting_enabled: boolean } | null, hackathon_event_groups: Array<{ __typename?: 'hackathon_event_groups', name: string, uuid: string, hackathon_events: Array<{ __typename?: 'hackathon_events', uuid: string, title: string, description?: string | null, type: Hackathon_Event_Type_Enum, starts_at: any, ends_at?: any | null, url?: string | null, meeting_url?: string | null, location?: string | null, sponsors: Array<{ __typename?: 'hackathon_event_sponsors', sponsor: { __typename?: 'sponsors', uuid: string, name?: string | null, logo?: string | null } }>, speakers: Array<{ __typename?: 'hackathon_event_speakers', speaker?: { __typename?: 'judges', uuid: string, name: string, job_title?: string | null, order: number, website?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, linkedin?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, farcaster?: string | null, featured: boolean, hidden: boolean, profile_img?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, logo?: string | null } | null } | null }> }> }>, events: Array<{ __typename?: 'hackathon_events', uuid: string, title: string, description?: string | null, type: Hackathon_Event_Type_Enum, starts_at: any, ends_at?: any | null, url?: string | null, meeting_url?: string | null, location?: string | null, sponsors: Array<{ __typename?: 'hackathon_event_sponsors', sponsor: { __typename?: 'sponsors', uuid: string, name?: string | null, logo?: string | null } }>, speakers: Array<{ __typename?: 'hackathon_event_speakers', speaker?: { __typename?: 'judges', uuid: string, name: string, job_title?: string | null, order: number, website?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, linkedin?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, farcaster?: string | null, featured: boolean, hidden: boolean, profile_img?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, logo?: string | null } | null } | null }> }> }> };

export type HackathonSpeakerJudgesQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonSpeakerJudgesQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, type: Hackathon_Type_Enum, timezone?: string | null, events: Array<{ __typename?: 'hackathon_events', uuid: string, title: string, description?: string | null, type: Hackathon_Event_Type_Enum, starts_at: any, ends_at?: any | null, url?: string | null, meeting_url?: string | null, location?: string | null, sponsors: Array<{ __typename?: 'hackathon_event_sponsors', sponsor: { __typename?: 'sponsors', uuid: string, name?: string | null, logo?: string | null } }>, speakers: Array<{ __typename?: 'hackathon_event_speakers', speaker?: { __typename?: 'judges', uuid: string, name: string, job_title?: string | null, order: number, website?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, linkedin?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, farcaster?: string | null, featured: boolean, hidden: boolean, profile_img?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, logo?: string | null } | null } | null }> }>, judges: Array<{ __typename?: 'judges', uuid: string, name: string, job_title?: string | null, order: number, website?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, linkedin?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, farcaster?: string | null, featured: boolean, hidden: boolean, is_mentor?: boolean | null, profile_img?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, logo?: string | null } | null }> }> };

export type DiscoverQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscoverQuery = { __typename?: 'query_root', discover: Array<{ __typename?: 'discover', articles?: any | null, builders?: any | null, hackathons?: any | null, ideas?: any | null, projects?: any | null, tweets?: any | null, events?: any | null }> };

export type DiscoverByStatusQueryVariables = Exact<{
  status: Scalars['discover_status_enum'];
}>;


export type DiscoverByStatusQuery = { __typename?: 'query_root', discover: Array<{ __typename?: 'discover', uuid: string, status: any, created_at: any, updated_at: any, articles?: any | null, builders?: any | null, hackathons?: any | null, ideas?: any | null, projects?: any | null, tweets?: any | null, events?: any | null }> };

export type SearchIdeasQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchIdeasQuery = { __typename?: 'query_root', ideas: Array<{ __typename?: 'ideas', uuid: string, name?: string | null }> };

export type SearchUsersQueryVariables = Exact<{
  query: Scalars['citext'];
}>;


export type SearchUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', username: any, uuid: string, featured_description?: string | null, cover_img?: string | null }> };

export type UserHackathonStatsQueryVariables = Exact<{
  slugs?: InputMaybe<Array<Scalars['citext']> | Scalars['citext']>;
}>;


export type UserHackathonStatsQuery = { __typename?: 'query_root', user_hackathons: Array<{ __typename?: 'user_hackathons', role?: any | null, status?: any | null, team?: { __typename?: 'teams', status?: any | null } | null, hackathon?: { __typename?: 'hackathons', uuid: string, slug?: any | null } | null }>, user_hackathon_reminders: Array<{ __typename?: 'user_hackathon_reminders', email_reminder_sent: boolean, uuid: string, hackathon?: { __typename?: 'hackathons', uuid: string, slug?: any | null } | null }> };

export type UserIdeaStatsQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type UserIdeaStatsQuery = { __typename?: 'query_root', user_idea_stats: Array<{ __typename?: 'user_idea_stats', want?: boolean | null, idea?: { __typename?: 'ideas', uuid: string } | null }> };

export type UserLikedProjectStatsQueryVariables = Exact<{
  slugs?: InputMaybe<Array<Scalars['citext']> | Scalars['citext']>;
}>;


export type UserLikedProjectStatsQuery = { __typename?: 'query_root', user_project_meta: Array<{ __typename?: 'user_project_meta', like?: boolean | null, project?: { __typename?: 'projects', slug?: any | null, uuid: string } | null }> };

export type GetProductDetailsQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type GetProductDetailsQuery = { __typename?: 'query_root', shop_products: Array<{ __typename?: 'shop_products', uuid: string, name: string, type: Shop_Product_Type_Enum, price: number, is_available: boolean, maximum_allowed_quantity: number, skus: Array<{ __typename?: 'shop_inventory_skus', uuid: string, name: string, is_available: boolean }> }> };

export type GetCouponQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetCouponQuery = { __typename?: 'query_root', shop_get_coupon?: { __typename?: 'shop_coupons', discount_type: Shop_Coupon_Discount_Type_Enum, discount_value: number, name: string } | null };

export type GetOrderDetailsQueryVariables = Exact<{
  orderID: Scalars['String'];
}>;


export type GetOrderDetailsQuery = { __typename?: 'query_root', shop_orders: Array<{ __typename?: 'shop_orders', order_id: string, amount: number, shipping_address_details: any, coupon_details?: any | null, waybill?: string | null, invoice?: string | null, products: Array<{ __typename?: 'shop_order_products', quantity: number, sku_details: any, product_details: any }> }> };

export type GetAllShopProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllShopProductsQuery = { __typename?: 'query_root', shop_products: Array<{ __typename?: 'shop_products', uuid: string, name: string, price: number, type: Shop_Product_Type_Enum, images: any, is_available: boolean, maximum_allowed_quantity: number, skus: Array<{ __typename?: 'shop_inventory_skus', uuid: string, name: string, is_available: boolean }> }> };

export type ProjectsBySlugsQueryVariables = Exact<{
  slugs?: InputMaybe<Array<Scalars['citext']> | Scalars['citext']>;
}>;


export type ProjectsBySlugsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', uuid: string, slug?: any | null, name: string, tagline?: string | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', name: string }> | null, builders?: Array<{ __typename?: 'users', uuid: string, username: any, firstName?: string | null, lastName?: string | null, profileImage?: string | null }> | null }> };

export type PublishedProjectBySlugQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type PublishedProjectBySlugQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', uuid: string, slug?: any | null, name: string, tagline?: string | null, description?: any | null, pictures?: string | null, links?: string | null, likes?: number | null, views?: number | null, quadratic_voting_prize_pool_distribution?: any | null, quadratic_voting_votes?: any | null, quadratic_voting_quadratic_votes?: any | null, flagged: boolean, createdAt: any, favicon?: string | null, coverImage?: string | null, videoUrl?: string | null, sourceCodeURL?: string | null, demoURL?: string | null, expoLocation?: string | null, hashtags: Array<{ __typename?: 'project_hashtags', hashtag?: { __typename?: 'hashtags', uuid: string, name: any, verified?: boolean | null } | null }>, commits: Array<{ __typename?: 'project_commits', uuid: string, message: string, isProjectStateAvailable?: boolean | null, createdAt: any }>, hackathons?: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, edition?: number | null, brand?: { __typename?: 'hackathon_brands', name: string } | null, settings?: { __typename?: 'hackathon_settings', quadratic_voting_enabled: boolean, quadratic_voting_prize_pool_amount?: number | null, quadratic_voting_results_announced: boolean, quadratic_voting_currency?: Quadratic_Voting_Currency_Enum | null, quadratic_voting_chain?: Quadratic_Voting_Chain_Enum | null, twitter?: string | null, logo?: string | null } | null }> | null, prizes: Array<{ __typename?: 'winners', prize?: { __typename?: 'prizes', uuid: string, name: string, desc?: string | null, sponsors: Array<{ __typename?: 'prize_sponsors', sponsor?: { __typename?: 'sponsors', uuid: string, name?: string | null } | null }> } | null }>, teams?: Array<{ __typename?: 'teams', name: string }> | null, builders?: Array<{ __typename?: 'users', uuid: string, username: any, status?: any | null, firstName?: string | null, lastName?: string | null, profileImage?: string | null }> | null, funding?: { __typename?: 'projects_funding', public_contribution_amount?: number | null, devfolio_matched_amount?: number | null, amount_eth: any, accepting_funding?: boolean | null, contributions_aggregate: { __typename?: 'project_contributions_aggregate', aggregate?: { __typename?: 'project_contributions_aggregate_fields', count: number } | null } } | null, quadratic_votings_aggregate: { __typename?: 'quadratic_voting_projects_aggregate', aggregate?: { __typename?: 'quadratic_voting_projects_aggregate_fields', count: number } | null }, report?: { __typename?: 'project_reports', type: Project_Report_Type_Enum } | null, project_tracks: Array<{ __typename?: 'project_tracks', uuid: string, description?: string | null, prize_track: { __typename?: 'prize_tracks', name?: string | null, sponsor?: { __typename?: 'sponsors', name?: string | null, company?: { __typename?: 'company', name: string, logo?: string | null, favicon?: string | null } | null } | null } }> }> };

export type FetchProjectCheerAttestationDataQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type FetchProjectCheerAttestationDataQuery = { __typename?: 'query_root', project_contributions: Array<{ __typename?: 'project_contributions', eas_uuid?: string | null, tx_network?: Project_Contribution_Tx_Network_Type_Enum | null, project?: { __typename?: 'projects', name: string, hackathons?: Array<{ __typename?: 'hackathons', name: any }> | null } | null }> };

export type GetUserHackathonQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
  username?: InputMaybe<Scalars['citext']>;
}>;


export type GetUserHackathonQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', user_hackathons: Array<{ __typename?: 'user_hackathons', status?: any | null, team?: { __typename?: 'teams', status?: any | null } | null }> }> };

export type HackathonPrizeTracksQueryVariables = Exact<{
  hackathonUUID: Scalars['String'];
  hackathonSlug: Scalars['citext'];
}>;


export type HackathonPrizeTracksQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', prize_tracks: Array<{ __typename?: 'prize_tracks', uuid: string, name?: string | null, description?: string | null, prizes: Array<{ __typename?: 'prizes', desc?: string | null, amount?: any | null, currency?: string | null }>, sponsor?: { __typename?: 'sponsors', uuid: string, name?: string | null, company?: { __typename?: 'company', name: string, logo?: string | null, uuid: string, favicon?: string | null } | null } | null }> }> };

export type UserProjectCommitsQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type UserProjectCommitsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', commits: Array<{ __typename?: 'project_commits', uuid: string, status?: string | null, message: string, createdAt: any, isProjectStateAvailable?: boolean | null }> }> };

export type InsertTweetCardsOneMutationVariables = Exact<{
  tweet: Twitter_Cards_Insert_Input;
}>;


export type InsertTweetCardsOneMutation = { __typename?: 'mutation_root', insert_twitter_cards_one?: { __typename?: 'twitter_cards', uuid: string } | null };

export type UpdateTwitterCardsMutationVariables = Exact<{
  uuid: Scalars['String'];
  discover: Scalars['Boolean'];
}>;


export type UpdateTwitterCardsMutation = { __typename?: 'mutation_root', update_twitter_cards?: { __typename?: 'twitter_cards_mutation_response', returning: Array<{ __typename?: 'twitter_cards', uuid: string }> } | null };

export type UpdateDiscoverFlagForIdeasMutationVariables = Exact<{
  uuid: Scalars['String'];
  discover: Scalars['Boolean'];
}>;


export type UpdateDiscoverFlagForIdeasMutation = { __typename?: 'mutation_root', update_ideas?: { __typename?: 'ideas_mutation_response', returning: Array<{ __typename?: 'ideas', uuid: string }> } | null };

export type UpdateDiscoverFlagForProjectMutationVariables = Exact<{
  uuid: Scalars['String'];
  discover: Scalars['Boolean'];
}>;


export type UpdateDiscoverFlagForProjectMutation = { __typename?: 'mutation_root', update_projects?: { __typename?: 'projects_mutation_response', returning: Array<{ __typename?: 'projects', uuid: string }> } | null };

export type UpdateDiscoverFlagForHackathonMutationVariables = Exact<{
  uuid: Scalars['String'];
  discover: Scalars['Boolean'];
}>;


export type UpdateDiscoverFlagForHackathonMutation = { __typename?: 'mutation_root', update_hackathons?: { __typename?: 'hackathons_mutation_response', returning: Array<{ __typename?: 'hackathons', uuid: string }> } | null };

export type InsertArticlesOneMutationVariables = Exact<{
  article: Articles_Insert_Input;
}>;


export type InsertArticlesOneMutation = { __typename?: 'mutation_root', insert_articles_one?: { __typename?: 'articles', uuid: string } | null };

export type UpdateArticlesOneMutationVariables = Exact<{
  article: Articles_Set_Input;
  uuid: Scalars['String'];
}>;


export type UpdateArticlesOneMutation = { __typename?: 'mutation_root', update_articles?: { __typename?: 'articles_mutation_response', returning: Array<{ __typename?: 'articles', uuid: string, title: string }> } | null };

export type UpdateFeaturedFlagForArticleMutationVariables = Exact<{
  uuid: Scalars['String'];
  featured: Scalars['Boolean'];
}>;


export type UpdateFeaturedFlagForArticleMutation = { __typename?: 'mutation_root', update_articles?: { __typename?: 'articles_mutation_response', returning: Array<{ __typename?: 'articles', uuid: string }> } | null };

export type UpdateFeaturedFlagForUsersMutationVariables = Exact<{
  uuid: Scalars['String'];
  featured: Scalars['Boolean'];
}>;


export type UpdateFeaturedFlagForUsersMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', uuid: string }> } | null };

export type UpdateDiscoverStatusMutationVariables = Exact<{
  uuid: Scalars['String'];
  status: Scalars['discover_status_enum'];
}>;


export type UpdateDiscoverStatusMutation = { __typename?: 'mutation_root', update_discover?: { __typename?: 'discover_mutation_response', returning: Array<{ __typename?: 'discover', uuid: string }> } | null };

export type WantIdeaMutationVariables = Exact<{
  ideaUUID: Scalars['String'];
  wantIdea?: InputMaybe<Scalars['Boolean']>;
}>;


export type WantIdeaMutation = { __typename?: 'mutation_root', want_idea: Array<{ __typename?: 'user_idea_stats', want?: boolean | null, idea?: { __typename?: 'ideas', uuid: string } | null }> };

export type LikeProjectMutationVariables = Exact<{
  projectUUID: Scalars['String'];
  like: Scalars['Boolean'];
}>;


export type LikeProjectMutation = { __typename?: 'mutation_root', like_project: Array<{ __typename?: 'user_project_meta', like?: boolean | null, project?: { __typename?: 'projects', uuid: string } | null }> };

export type SubmitShippingAddressMutationVariables = Exact<{
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  fullName: Scalars['String'];
  phoneNumber: Scalars['String'];
  pincode: Scalars['String'];
  state: Scalars['String'];
  tShirtSize: Scalars['String'];
  token: Scalars['String'];
}>;


export type SubmitShippingAddressMutation = { __typename?: 'mutation_root', submitSchwagShippingAddress?: { __typename?: 'SubmitSchwagShippingAddressOutput', form_submitted: boolean } | null };

export type SubmitShopShippingAddressMutationVariables = Exact<{
  fullName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  address: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
}>;


export type SubmitShopShippingAddressMutation = { __typename?: 'mutation_root', insert_shop_shipping_addresses?: { __typename?: 'shop_shipping_addresses_mutation_response', returning: Array<{ __typename?: 'shop_shipping_addresses', uuid: string }> } | null };

export type PlaceOrderMutationVariables = Exact<{
  products: Array<Shop_PlaceOrderInputProducts> | Shop_PlaceOrderInputProducts;
  shippingAddressUUID: Scalars['String'];
  couponCode?: InputMaybe<Scalars['String']>;
}>;


export type PlaceOrderMutation = { __typename?: 'mutation_root', shop_placeOrder?: { __typename?: 'shop_placeOrderOutput', razorpay_order_id: string, order_id: string } | null };

export type SaveSearchMutationVariables = Exact<{
  name: Scalars['String'];
  query: Scalars['String'];
}>;


export type SaveSearchMutation = { __typename?: 'mutation_root', insert_user_saved_searches_one?: { __typename?: 'user_saved_searches', uuid: string, name: string, query: string } | null };

export type UpdateFeaturedBuilderDataMutationVariables = Exact<{
  uuid: Scalars['String'];
  featuredDescription: Scalars['String'];
  coverImg: Scalars['String'];
}>;


export type UpdateFeaturedBuilderDataMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', uuid: string }> } | null };

export type RsvpStakeMutationVariables = Exact<{
  hackathonStakingUUID: Scalars['String'];
  txHash?: InputMaybe<Scalars['String']>;
}>;


export type RsvpStakeMutation = { __typename?: 'mutation_root', rsvpStaking: { __typename?: 'RsvpStakingOutput', user_hackathon_staking_uuid: string, razorpay_order_id?: string | null } };

export type UserHackathonStakingSubscriptionVariables = Exact<{
  userHackathonStakingUUID: Scalars['String'];
}>;


export type UserHackathonStakingSubscription = { __typename?: 'subscription_root', user_hackathon_stakings: Array<{ __typename?: 'user_hackathon_stakings', uuid: string, tx_hash?: string | null, status: User_Hackathon_Staking_Status_Enum }> };

export type AddDiscoverEventMutationVariables = Exact<{
  object: Discover_Events_Insert_Input;
}>;


export type AddDiscoverEventMutation = { __typename?: 'mutation_root', insert_discover_events_one?: { __typename?: 'discover_events', uuid: string } | null };

export type UpdateDiscoverEventMutationVariables = Exact<{
  event: Discover_Events_Set_Input;
  uuid: Scalars['String'];
}>;


export type UpdateDiscoverEventMutation = { __typename?: 'mutation_root', update_discover_events?: { __typename?: 'discover_events_mutation_response', returning: Array<{ __typename?: 'discover_events', uuid: string }> } | null };

export type DeleteDiscoverEventMutationVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type DeleteDiscoverEventMutation = { __typename?: 'mutation_root', update_discover_events?: { __typename?: 'discover_events_mutation_response', returning: Array<{ __typename?: 'discover_events', title: string }> } | null };

export type EmailVerifiedStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailVerifiedStatusQuery = { __typename?: 'query_root', me?: { __typename?: 'users', email_verified?: boolean | null } | null };

export type ReportCommentMutationVariables = Exact<{
  commentUUID: Scalars['String'];
  reportType: Scalars['String'];
  description: Scalars['String'];
  reportedByEmail: Scalars['String'];
  projectUUID?: InputMaybe<Scalars['String']>;
}>;


export type ReportCommentMutation = { __typename?: 'mutation_root', reportComment: { __typename?: 'ReportCommentOutput', form_submitted: boolean } };

export type InsertShopShippingAddressMutationVariables = Exact<{
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
}>;


export type InsertShopShippingAddressMutation = { __typename?: 'mutation_root', insert_shop_shipping_addresses?: { __typename?: 'shop_shipping_addresses_mutation_response', returning: Array<{ __typename?: 'shop_shipping_addresses', uuid: string }> } | null };

export type UpdateShopShippingAddressMutationVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
  shippingDetails?: InputMaybe<Shop_Shipping_Addresses_Set_Input>;
}>;


export type UpdateShopShippingAddressMutation = { __typename?: 'mutation_root', update_shop_shipping_addresses?: { __typename?: 'shop_shipping_addresses_mutation_response', returning: Array<{ __typename?: 'shop_shipping_addresses', uuid: string }> } | null };

export type CommentOnProjectMutationVariables = Exact<{
  projectUUID: Scalars['String'];
  parentCommentUUID?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  isAuthenticated: Scalars['Boolean'];
}>;


export type CommentOnProjectMutation = { __typename?: 'mutation_root', add_comment_to_project: Array<{ __typename?: 'comments', uuid: string, upvote_count?: number | null, downvote_count?: number | null, created_at: any, value?: string | null, descendants_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, user?: { __typename?: 'users', uuid: string, username: any, profile_image?: string | null } | null, user_comment?: Array<{ __typename?: 'user_comments', uuid: string, upvote?: boolean | null }> }> };

export type BuilderAmaMutationVariables = Exact<{
  uuid: Scalars['String'];
  message: Scalars['String'];
}>;


export type BuilderAmaMutation = { __typename?: 'mutation_root', builderAma: { __typename?: 'AmaOutput', message_sent: boolean } };

export type CheerProjectMutationVariables = Exact<{
  project_uuid: Scalars['String'];
  stickers: Array<CheerProjectSticker> | CheerProjectSticker;
  message?: InputMaybe<Scalars['String']>;
  chain: CheerProjectChain;
}>;


export type CheerProjectMutation = { __typename?: 'mutation_root', cheerProject: { __typename?: 'CheerProjectOutput', project_contribution_uuid: string, attestation: { __typename?: 'CheerProjectOutputAttestation', attester: string, schema: string, data: any, signature: any, deadline: any }, eas: { __typename?: 'CheerProjectOutputEASDetails', eas_contract_address: string, eas_proxy_contract_address: string, chain: CheerProjectChain } } };

export type ClaimHackathonCredentialMutationVariables = Exact<{
  credentialUUID: Scalars['String'];
}>;


export type ClaimHackathonCredentialMutation = { __typename?: 'mutation_root', claimHackathonCredential: { __typename?: 'HackathonCredentialClaimOutput', user_hackathon_credential_uuid: string, attestation: { __typename?: 'HackathonCredentialOutputAttestation', attester: string, data: any, deadline: any, schema: string, signature: any } } };

export type DeleteCommentMutationVariables = Exact<{
  commentUUID: Scalars['String'];
}>;


export type DeleteCommentMutation = { __typename?: 'mutation_root', update_comments?: { __typename?: 'comments_mutation_response', affected_rows: number } | null };

export type DeleteShoppingAddressMutationVariables = Exact<{
  shippingAddressUUID?: InputMaybe<Scalars['String']>;
}>;


export type DeleteShoppingAddressMutation = { __typename?: 'mutation_root', delete_shop_shipping_addresses?: { __typename?: 'shop_shipping_addresses_mutation_response', affected_rows: number } | null };

export type NominateBuilderMutationVariables = Exact<{
  uuid: Scalars['String'];
  reason: Scalars['String'];
}>;


export type NominateBuilderMutation = { __typename?: 'mutation_root', nominateBuilder: { __typename?: 'NominateBuilderOutput', form_submitted: boolean } };

export type ReportProjectMutationVariables = Exact<{
  uuid: Scalars['String'];
  reportType: ReportType;
  description: Scalars['String'];
  reportedByEmail: Scalars['String'];
  hackathonUuid?: InputMaybe<Scalars['String']>;
  linkToOriginal?: InputMaybe<Scalars['String']>;
}>;


export type ReportProjectMutation = { __typename?: 'mutation_root', reportProject: { __typename?: 'ReportProjectOutput', form_submitted: boolean } };

export type SubmitQvVotesMutationVariables = Exact<{
  hackathon_uuid: Scalars['String'];
  projects: Array<QuadraticVotingProject> | QuadraticVotingProject;
  anonAadhaarPCD?: InputMaybe<Scalars['String']>;
}>;


export type SubmitQvVotesMutation = { __typename?: 'mutation_root', quadraticVoting: { __typename?: 'QuadraticVotingOutput', quadratic_voting_uuid: string } };

export type AddHackathonReminderMutationVariables = Exact<{
  hackathonUUID: Scalars['String'];
}>;


export type AddHackathonReminderMutation = { __typename?: 'mutation_root', add_hackathon_reminder: Array<{ __typename?: 'user_hackathon_reminders', uuid: string, email_reminder_sent: boolean }> };

export type RemoveHackathonReminderMutationVariables = Exact<{
  hackathonUUID: Scalars['String'];
}>;


export type RemoveHackathonReminderMutation = { __typename?: 'mutation_root', remove_hackathon_reminder: Array<{ __typename?: 'user_hackathon_reminders', uuid: string, email_reminder_sent: boolean }> };

export type UpvoteCommentMutationVariables = Exact<{
  comment_uuid: Scalars['String'];
  upvote_comment?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpvoteCommentMutation = { __typename?: 'mutation_root', upvote_comment: Array<{ __typename?: 'user_comments', upvote?: boolean | null }> };

export type GetUserHackathonApplicationStatusQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
  uuid: Scalars['String'];
}>;


export type GetUserHackathonApplicationStatusQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', user_hackathons: Array<{ __typename?: 'user_hackathons', status?: any | null, team?: { __typename?: 'teams', status?: any | null } | null }> }> };

export type GetUserHackathonDashboardStatusQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
  uuid: Scalars['String'];
}>;


export type GetUserHackathonDashboardStatusQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', user_hackathons: Array<{ __typename?: 'user_hackathons', status?: any | null, team?: { __typename?: 'teams', status?: any | null } | null }> }> };

export type HackathonJudgingAuthInfoQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonJudgingAuthInfoQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', name: any, uuid: string, edition?: number | null, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', judging_factors?: string | null, judging_starts_at?: any | null, judging_ends_at?: any | null, contact_email?: any | null, logo?: string | null } | null }> };

export type HackathonJudgingOfflineInfoQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonJudgingOfflineInfoQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', name: any, uuid: string, edition?: number | null, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', judging_factors?: string | null, judging_starts_at?: any | null, judging_ends_at?: any | null, judging_enabled: boolean, logo?: string | null } | null }> };

export type JudgeRoomInfoQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type JudgeRoomInfoQuery = { __typename?: 'query_root', user_hackathons: Array<{ __typename?: 'user_hackathons', room?: { __typename?: 'judging_rooms', uuid: string, name: string, hackathon?: { __typename?: 'hackathons', settings?: { __typename?: 'hackathon_settings', max_judges_per_project?: number | null } | null } | null } | null, judge?: { __typename?: 'judges', uuid: string, name: string } | null }> };

export type HackathonJudgingOnlineInfoQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonJudgingOnlineInfoQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', name: any, uuid: string, edition?: number | null, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', judging_factors?: string | null, judging_starts_at?: any | null, judging_ends_at?: any | null, online_judging_enabled: boolean, logo?: string | null } | null }> };

export type JudgeInfoQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
}>;


export type JudgeInfoQuery = { __typename?: 'query_root', me?: { __typename?: 'users', user_hackathons: Array<{ __typename?: 'user_hackathons', user?: { __typename?: 'users', username: any, uuid: string } | null, judge?: { __typename?: 'judges', uuid: string, name: string } | null }> } | null };

export type GetJudgeProjectsQueryVariables = Exact<{
  judgeUUID: Scalars['String'];
}>;


export type GetJudgeProjectsQuery = { __typename?: 'query_root', project_judges_aggregate: { __typename?: 'project_judges_aggregate', aggregate?: { __typename?: 'project_judges_aggregate_fields', count: number } | null } };

export type HackathonJudgingSponsorInfoQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
}>;


export type HackathonJudgingSponsorInfoQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', name: any, devfolio_official?: boolean | null, edition?: number | null, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', sponsor_judging_enabled: boolean, logo?: string | null, judgingStartsAt?: any | null, judgingEndsAt?: any | null } | null }> };

export type GetJudgeSponsorQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
  username?: InputMaybe<Scalars['citext']>;
}>;


export type GetJudgeSponsorQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', judges: Array<{ __typename?: 'judges', name: string, sponsor?: { __typename?: 'sponsors', uuid: string, winners_confirmed: boolean } | null }> }> };

export type HackathonJudgingInfoQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonJudgingInfoQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', name: any, uuid: string, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', judging_factors?: string | null, judging_starts_at?: any | null, judging_ends_at?: any | null, logo?: string | null } | null }> };

export type HackathonOnlineJudgingInfoQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type HackathonOnlineJudgingInfoQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', name: any, uuid: string, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', judging_factors?: string | null, judging_starts_at?: any | null, judging_ends_at?: any | null, logo?: string | null } | null }> };

export type GetBasicHackathonInfoQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
}>;


export type GetBasicHackathonInfoQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', name: any, devfolio_official?: boolean | null, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', logo?: string | null, judgingStartsAt?: any | null, judgingEndsAt?: any | null } | null }> };

export type LoggedInUserStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedInUserStatusQuery = { __typename?: 'query_root', me?: { __typename?: 'users', status?: any | null } | null };

export type PublishedProjectByCommitQueryVariables = Exact<{
  slug: Scalars['citext'];
  commitUUID: Scalars['String'];
}>;


export type PublishedProjectByCommitQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', uuid: string, slug?: any | null, flagged: boolean, createdAt: any, currentCommit: Array<{ __typename?: 'project_commits', uuid: string, state_available?: boolean | null, message: string, projectState?: any | null, createdAt: any }>, commits: Array<{ __typename?: 'project_commits', uuid: string, message: string, isProjectStateAvailable?: boolean | null, createdAt: any }>, hackathons?: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, edition?: number | null, brand?: { __typename?: 'hackathon_brands', name: string } | null, settings?: { __typename?: 'hackathon_settings', logo?: string | null } | null }> | null, prizes: Array<{ __typename?: 'winners', prize?: { __typename?: 'prizes', uuid: string, name: string, desc?: string | null } | null }>, teams?: Array<{ __typename?: 'teams', name: string }> | null, builders?: Array<{ __typename?: 'users', uuid: string, username: any, firstName?: string | null, lastName?: string | null, profileImage?: string | null }> | null, funding?: { __typename?: 'projects_funding', public_contribution_amount?: number | null, devfolio_matched_amount?: number | null } | null, report?: { __typename?: 'project_reports', type: Project_Report_Type_Enum } | null }> };

export type UserStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type UserStatusQuery = { __typename?: 'query_root', me?: { __typename?: 'users', status?: any | null, email: any } | null };

export type UserReferralCodeAndHackathonSlugQueryVariables = Exact<{
  userUUID: Scalars['String'];
  hackathonUUID: Scalars['String'];
}>;


export type UserReferralCodeAndHackathonSlugQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', slug?: any | null, user_hackathons: Array<{ __typename?: 'user_hackathons', user?: { __typename?: 'users', username: any, extra?: { __typename?: 'user_extras', ref_code?: any | null } | null } | null }> }> };

export type GetHackathonNameQueryVariables = Exact<{
  hackathonUUID: Scalars['String'];
}>;


export type GetHackathonNameQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', name: any }> };

export type OAuthProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type OAuthProvidersQuery = { __typename?: 'query_root', me?: { __typename?: 'users', oauth_providers: Array<{ __typename?: 'oauth', uuid: string, provider_name: Oauth_Providers_Enum, user_info_id?: string | null, user_info?: any | null }> } | null };

export type AllUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserDetailsQuery = { __typename?: 'query_root', me?: { __typename?: 'users', uuid: string, username: any, first_name?: string | null, last_name?: string | null, bio?: string | null, gender?: any | null, email: any, phone_number?: string | null, email_verified?: boolean | null, address?: { __typename?: 'address', city?: string | null, state?: string | null, country?: string | null } | null, extra?: { __typename?: 'user_extras', resume?: string | null, is_education?: boolean | null, is_student?: boolean | null, new_domain_expertise?: any | null, no_work_exp?: boolean | null, t_shirt_size?: any | null, emergency_contact_name?: string | null, emergency_contact_number?: string | null } | null, educations: Array<{ __typename?: 'educations', uuid: string, degree_type?: any | null, current_college?: boolean | null, graduation_year?: any | null, college?: { __typename?: 'colleges', uuid: string, name: string } | null, field?: { __typename?: 'education_fields', uuid: string, name: any } | null }>, skills: Array<{ __typename?: 'user_skills', skill?: { __typename?: 'skills', uuid: string, name: any, logo?: string | null } | null }>, experiences: Array<{ __typename?: 'experiences', uuid: string, title?: string | null, start?: any | null, type?: Experience_Type_Enum | null, current_company?: boolean | null, end?: any | null, description?: string | null, company?: { __typename?: 'company', uuid: string, name: string, logo?: string | null, domain?: any | null, favicon?: string | null } | null }>, profiles: Array<{ __typename?: 'user_profiles', uuid: string, value: string, profile?: { __typename?: 'profiles', uuid: string, name: any } | null }>, oauth_providers: Array<{ __typename?: 'oauth', user_info_id?: string | null }> } | null };

export type GetContributorAvatarsQueryVariables = Exact<{
  projectUUID: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetContributorAvatarsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', funding?: { __typename?: 'projects_funding', contributions: Array<{ __typename?: 'project_contributions', user?: { __typename?: 'users', username: any, profile_image?: string | null } | null }>, contributions_aggregate: { __typename?: 'project_contributions_aggregate', aggregate?: { __typename?: 'project_contributions_aggregate_fields', count: number } | null } } | null }> };

export type GetCheerStickersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheerStickersQuery = { __typename?: 'query_root', stickers: Array<{ __typename?: 'stickers', uuid: string, name: string, description: string, amount_eth: any, image?: string | null }> };

export type FetchRepliesByCommentUuidQueryVariables = Exact<{
  commentUUID: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  isAuthenticated: Scalars['Boolean'];
}>;


export type FetchRepliesByCommentUuidQuery = { __typename?: 'query_root', comments: Array<{ __typename?: 'comments', uuid: string, descendants_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, descendants: Array<{ __typename?: 'comments', uuid: string, depth?: number | null, upvote_count?: number | null, downvote_count?: number | null, created_at: any, deleted: boolean, is_project_flag_comment: boolean, report_resolved: boolean, value?: string | null, user?: { __typename?: 'users', uuid: string, username: any, status?: any | null, verified: boolean, profile_image?: string | null } | null, descendants_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, user_comment?: Array<{ __typename?: 'user_comments', uuid: string, upvote?: boolean | null }> }> }> };

export type UserEligibleBountyClaimsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEligibleBountyClaimsQuery = { __typename?: 'query_root', me?: { __typename?: 'users', username: any, user_hackathon_bounties: Array<{ __typename?: 'user_hackathon_bounties', uuid: string, status?: User_Hackathon_Bounties_Status_Enum | null, type: User_Hackathon_Bounties_Type_Enum, wallet_address?: string | null, full_name?: string | null, email_address?: string | null, tx_hash?: string | null, tx_network?: string | null, tx_meta?: any | null, winnings_breakdown: any, bounty_type?: User_Hackathon_Bounties_Bounty_Type_Enum | null, require_kyc_to_claim?: boolean | null, acknowledgment_pdf_path?: string | null, hackathon?: { __typename?: 'hackathons', uuid: string, name: any, type: Hackathon_Type_Enum, desc?: string | null, starts_at?: any | null, ends_at?: any | null, slug?: any | null, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', primary_color?: string | null } | null } | null }> } | null };

export type UserEligibleCredentialClaimsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEligibleCredentialClaimsQuery = { __typename?: 'query_root', me?: { __typename?: 'users', username: any, user_hackathon_credentials: Array<{ __typename?: 'user_hackathon_credentials', uuid: string, status?: User_Hackathon_Credentials_Status_Enum | null, tx_hash?: string | null, token_id?: string | null, nft_metadata?: any | null, credential: { __typename?: 'hackathon_credentials', uuid: string, eligible_entity: Hackathon_Credential_Eligible_Entities_Enum, nft_contract_address?: string | null, nft_hero_text?: string | null }, hackathon: { __typename?: 'hackathons', uuid: string, name: any, type: Hackathon_Type_Enum, desc?: string | null, starts_at?: any | null, ends_at?: any | null, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', on_chain_credentials_gasless?: boolean | null } | null } }> } | null };

export type GetSchwagsForUserQueryVariables = Exact<{
  username: Scalars['citext'];
  limit: Scalars['Int'];
}>;


export type GetSchwagsForUserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', uuid: string, username: any, hackathon_schwags: Array<{ __typename?: 'user_hackathon_schwags', uuid: string, prizes: any, status?: string | null, type: string, hackathon?: { __typename?: 'hackathons', name: any, type: Hackathon_Type_Enum, desc?: string | null, starts_at?: any | null, ends_at?: any | null, favicon?: string | null } | null, order?: { __typename?: 'shop_orders', ready_for_shipment: boolean, clickpost_status?: any | null, waybill?: string | null } | null }> }> };

export type FeaturedBuildersQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturedBuildersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', uuid: string, username: any, first_name?: string | null, last_name?: string | null, featured_description?: string | null, profile_image?: string | null, cover_image?: string | null, profiles: Array<{ __typename?: 'user_profiles', value: string, profile?: { __typename?: 'profiles', name: any } | null }> }> };

export type FetchAllEligibleClaimsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllEligibleClaimsCountQuery = { __typename?: 'query_root', me?: { __typename?: 'users', hackathon_schwags_aggregate: { __typename?: 'user_hackathon_schwags_aggregate', aggregate?: { __typename?: 'user_hackathon_schwags_aggregate_fields', count: number } | null }, user_hackathon_credentials_aggregate: { __typename?: 'user_hackathon_credentials_aggregate', aggregate?: { __typename?: 'user_hackathon_credentials_aggregate_fields', count: number } | null }, user_hackathon_bounties_aggregate: { __typename?: 'user_hackathon_bounties_aggregate', aggregate?: { __typename?: 'user_hackathon_bounties_aggregate_fields', count: number } | null } } | null };

export type HackathonTypeFragment = { __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, rating: any, timezone?: string | null, participants_count?: number | null, participants_details?: any | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, telegram?: string | null, discord?: string | null, medium?: string | null, instagram?: string | null, slack?: string | null, featured_cover_img?: string | null, featured_cover_img_v2?: string | null, external_apply_url?: string | null } | null };

export type GetAllHackathonTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllHackathonTypesQuery = { __typename?: 'query_root', open_hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, rating: any, timezone?: string | null, participants_count?: number | null, participants_details?: any | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, telegram?: string | null, discord?: string | null, medium?: string | null, instagram?: string | null, slack?: string | null, featured_cover_img?: string | null, featured_cover_img_v2?: string | null, external_apply_url?: string | null } | null }>, past_hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, rating: any, timezone?: string | null, participants_count?: number | null, participants_details?: any | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, telegram?: string | null, discord?: string | null, medium?: string | null, instagram?: string | null, slack?: string | null, featured_cover_img?: string | null, featured_cover_img_v2?: string | null, external_apply_url?: string | null } | null }>, upcoming_hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, rating: any, timezone?: string | null, participants_count?: number | null, participants_details?: any | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, telegram?: string | null, discord?: string | null, medium?: string | null, instagram?: string | null, slack?: string | null, featured_cover_img?: string | null, featured_cover_img_v2?: string | null, external_apply_url?: string | null } | null }>, featured_hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, rating: any, timezone?: string | null, participants_count?: number | null, participants_details?: any | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, telegram?: string | null, discord?: string | null, medium?: string | null, instagram?: string | null, slack?: string | null, featured_cover_img?: string | null, featured_cover_img_v2?: string | null, external_apply_url?: string | null } | null }> };

export type FetchCredentialDetailsQueryVariables = Exact<{
  credentialUUID?: InputMaybe<Scalars['String']>;
}>;


export type FetchCredentialDetailsQuery = { __typename?: 'query_root', me?: { __typename?: 'users', user_hackathon_credentials: Array<{ __typename?: 'user_hackathon_credentials', uuid: string, status?: User_Hackathon_Credentials_Status_Enum | null, tx_hash?: string | null, eas_uuid?: string | null, token_id?: string | null, nft_metadata?: any | null, credential: { __typename?: 'hackathon_credentials', uuid: string, nft_contract_address?: string | null, eligible_entity: Hackathon_Credential_Eligible_Entities_Enum, credential_type?: Hackathon_Credential_Type_Enum | null }, hackathon: { __typename?: 'hackathons', name: any, slug?: any | null, settings?: { __typename?: 'hackathon_settings', on_chain_credentials_gasless?: boolean | null, hackathon_credentials_chain?: Hackathon_Credentials_Chain_Enum | null, twitter?: string | null } | null } }> } | null };

export type GetFeaturedHackathonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturedHackathonsQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, rating: any, timezone?: string | null, participants_count?: number | null, participants_details?: any | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, telegram?: string | null, discord?: string | null, medium?: string | null, instagram?: string | null, slack?: string | null, featured_cover_img?: string | null, featured_cover_img_v2?: string | null, external_apply_url?: string | null } | null }> };

export type GetHackathonPrizesQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type GetHackathonPrizesQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, name: any, slug?: any | null, favicon?: string | null, settings?: { __typename?: 'hackathon_settings', winner_announced?: boolean | null } | null, prizes: Array<{ __typename?: 'prizes', name: string, logo?: string | null, desc?: string | null, uuid: string, is_sponsor_prize?: boolean | null, currency?: string | null, amount?: any | null, quantity?: number | null, sponsors: Array<{ __typename?: 'prize_sponsors', uuid: string, sponsor?: { __typename?: 'sponsors', uuid: string, name?: string | null } | null }>, prize_track?: { __typename?: 'prize_tracks', uuid: string } | null, winners_aggregate: { __typename?: 'winners_aggregate', aggregate?: { __typename?: 'winners_aggregate_fields', count: number } | null } }>, prize_tracks: Array<{ __typename?: 'prize_tracks', uuid: string, name?: string | null, description?: string | null, sponsor?: { __typename?: 'sponsors', uuid: string, name?: string | null } | null }>, sponsor_tiers: Array<{ __typename?: 'sponsor_tiers', uuid: string, name?: string | null, position?: number | null, width?: number | null, sponsors: Array<{ __typename?: 'sponsors', uuid: string, name?: string | null, about?: string | null, position?: number | null, logo?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, favicon?: string | null } | null, prize_tracks: Array<{ __typename?: 'prize_tracks', prizes: Array<{ __typename?: 'prizes', amount?: any | null, currency?: string | null }> }> }> }> }> };

export type HackathonStakingsQueryVariables = Exact<{
  hackathonUUID: Scalars['String'];
}>;


export type HackathonStakingsQuery = { __typename?: 'query_root', hackathon_stakings: Array<{ __typename?: 'hackathon_stakings', type: Hackathon_Staking_Type_Enum, amount: any, uuid: string }> };

export type FetchJudgingEventsQueryVariables = Exact<{
  hackathonSlug: Scalars['citext'];
  judgingType: Hackathon_Event_Type_Enum;
}>;


export type FetchJudgingEventsQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', timezone?: string | null, settings?: { __typename?: 'hackathon_settings', judging_starts_at?: any | null, judging_ends_at?: any | null } | null, events: Array<{ __typename?: 'hackathon_events', title: string, description?: string | null, starts_at: any, ends_at?: any | null, url?: string | null, google_maps_location_url?: string | null, speakers: Array<{ __typename?: 'hackathon_event_speakers', speaker?: { __typename?: 'judges', name: string, profile_image?: string | null } | null }> }> }> };

export type GetHackathonMicrositeHeaderQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type GetHackathonMicrositeHeaderQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, city?: string | null, country?: string | null, location?: string | null, tagline?: string | null, timezone?: string | null, desc?: string | null, apply_mode?: any | null, devfolio_official?: boolean | null, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, rating: any, edition?: number | null, cover_img?: string | null, favicon?: string | null, brand?: { __typename?: 'hackathon_brands', name: string, hackathons: Array<{ __typename?: 'hackathons', edition?: number | null, edition_name?: string | null, name: any, slug?: any | null, uuid: string, starts_at?: any | null, favicon?: string | null }> } | null, tracks: Array<{ __typename?: 'hackathon_tracks', uuid: string, name: string, desc?: string | null }>, settings?: { __typename?: 'hackathon_settings', reg_starts_at?: any | null, reg_ends_at?: any | null, external_apply_url?: string | null, leaderboard_enabled: boolean, quadratic_voting_enabled: boolean, quadratic_voting_results_announced: boolean, quadratic_voting_starts_at?: any | null, quadratic_voting_ends_at?: any | null, v2_application_enabled?: boolean | null, logo?: string | null } | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, prizes: Array<{ __typename?: 'prizes', uuid: string }>, judges: Array<{ __typename?: 'judges', uuid: string }> }> };

export type GetHackathonMicrositeOverviewQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type GetHackathonMicrositeOverviewQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, name: any, slug?: any | null, type: Hackathon_Type_Enum, tagline?: string | null, desc?: string | null, team_min?: number | null, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, rating: any, city?: string | null, country?: string | null, timezone?: string | null, location?: string | null, team_max?: number | null, cover_img?: string | null, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, external_apply_url?: string | null, is_hybrid?: boolean | null, review?: boolean | null, site?: string | null, twitter?: string | null, slack?: string | null, facebook?: string | null, instagram?: string | null, telegram?: string | null, discord?: string | null, medium?: string | null, tokenproof_gating_enabled: boolean, coc_url?: string | null, contact_email?: any | null, show_more_hackathons?: boolean | null, v2_application_enabled?: boolean | null, paid?: boolean | null } | null, stakings: Array<{ __typename?: 'hackathon_stakings', type: Hackathon_Staking_Type_Enum, amount: any, uuid: string }>, faqs: Array<{ __typename?: 'hackathon_faq', uuid: string, question: string, answer: string, order?: number | null }>, sponsor_tiers: Array<{ __typename?: 'sponsor_tiers', uuid: string, name?: string | null, position?: number | null, width?: number | null, sponsors: Array<{ __typename?: 'sponsors', uuid: string, name?: string | null, about?: string | null, position?: number | null, logo?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, favicon?: string | null } | null, prize_tracks: Array<{ __typename?: 'prize_tracks', prizes: Array<{ __typename?: 'prizes', amount?: any | null, currency?: string | null }> }> }> }> }>, more_hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, devfolio_official?: boolean | null, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, rating: any, timezone?: string | null, participants_count?: number | null, participants_details?: any | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, settings?: { __typename?: 'hackathon_settings', reg_starts_at?: any | null, reg_ends_at?: any | null, primary_color?: string | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, logo?: string | null } | null }> };

export type FetchOngoingUserHackathonQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchOngoingUserHackathonQuery = { __typename?: 'query_root', me?: { __typename?: 'users', user_hackathons: Array<{ __typename?: 'user_hackathons', status?: any | null, hackathon?: { __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, is_online?: boolean | null } | null }> } | null };

export type FetchCurrentSponsorQueryVariables = Exact<{
  hackathonSlug: Scalars['citext'];
}>;


export type FetchCurrentSponsorQuery = { __typename?: 'query_root', me?: { __typename?: 'users', judges: Array<{ __typename?: 'judges', uuid: string, sponsor?: { __typename?: 'sponsors', name?: string | null } | null }> } | null };

export type FetchUserKycSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUserKycSessionQuery = { __typename?: 'query_root', me?: { __typename?: 'users', sumsub_applicants: Array<{ __typename?: 'sumsub_applicants', applicant_id: string, review_status: Sumsub_Applicants_Review_Status_Enum, review_details?: any | null, review_steps_details?: any | null }> } | null };

export type FetchUserKycStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUserKycStatusQuery = { __typename?: 'query_root', me?: { __typename?: 'users', extra?: { __typename?: 'user_extras', kyc_status: User_Kyc_Status_Enum, max_kyc_attempts: number, used_kyc_attempts: number } | null } | null };

export type UserKycStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserKycStatusSubscription = { __typename?: 'subscription_root', me?: { __typename?: 'users', extra?: { __typename?: 'user_extras', kyc_status: User_Kyc_Status_Enum, max_kyc_attempts: number, used_kyc_attempts: number } | null } | null };

export type UserRssFeedQueryVariables = Exact<{
  platform: User_Profile_Rss_Feed_Platforms_Enum;
}>;


export type UserRssFeedQuery = { __typename?: 'query_root', me?: { __typename?: 'users', rss_feeds: Array<{ __typename?: 'user_profile_rss_feeds', uuid: string }> } | null };

export type GetCurrentJudgeUuidQueryVariables = Exact<{
  hackathonSlug: Scalars['citext'];
}>;


export type GetCurrentJudgeUuidQuery = { __typename?: 'query_root', me?: { __typename?: 'users', judges: Array<{ __typename?: 'judges', uuid: string, hackathon: { __typename?: 'hackathons', uuid: string } }> } | null };

export type GetHackathonJudgingDashboardInfoQueryVariables = Exact<{
  slug: Scalars['citext'];
  judging_type: Hackathon_Faq_Type_Enum;
}>;


export type GetHackathonJudgingDashboardInfoQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, city?: string | null, country?: string | null, tagline?: string | null, timezone?: string | null, desc?: string | null, devfolio_official?: boolean | null, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, rating: any, edition?: number | null, favicon?: string | null, faqs: Array<{ __typename?: 'hackathon_faq', uuid: string, question: string, answer: string, order?: number | null }>, settings?: { __typename?: 'hackathon_settings', coc_url?: string | null, contact_email?: any | null, review?: boolean | null, site?: string | null, linkedin?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, judging_ends_at?: any | null, judging_starts_at?: any | null, judging_factors?: string | null, logo?: string | null } | null }> };

export type GetPrizeTracksByHackathonQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type GetPrizeTracksByHackathonQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', prize_tracks: Array<{ __typename?: 'prize_tracks', uuid: string, name?: string | null }> }> };

export type HackathonScopeQueryVariables = Exact<{
  hackathonSlug: Scalars['citext'];
}>;


export type HackathonScopeQuery = { __typename?: 'query_root', user_hackathons: Array<{ __typename?: 'user_hackathons', hackathon?: { __typename?: 'hackathons', scope?: { __typename?: 'hackathon_scopes', processed_scopes?: any | null } | null, scopeExtras: Array<{ __typename?: 'hackathon_scope_extras', uuid: string, name?: string | null, type?: any | null, desc?: string | null, placeholder?: string | null, hint?: string | null, required?: boolean | null, options?: string | null, fileType?: any | null, userHackathonScopeExtra?: { __typename?: 'user_hackathon_extras', value?: string | null } | null }> } | null }> };

export type UserHackathonDataQueryVariables = Exact<{
  hackathonSlug: Scalars['citext'];
}>;


export type UserHackathonDataQuery = { __typename?: 'query_root', me?: { __typename?: 'users', user_hackathons: Array<{ __typename?: 'user_hackathons', status?: any | null, application_filled: boolean, allow_team_invites: boolean, discord_channel_joined: boolean, track?: { __typename?: 'hackathon_tracks', name: string } | null }> } | null, hackathons: Array<{ __typename?: 'hackathons', uuid: string, name: any, slug?: any | null, starts_at?: any | null, ends_at?: any | null, participants_count?: number | null, team_min?: number | null, team_size?: number | null, is_online?: boolean | null, settings?: { __typename?: 'hackathon_settings', reg_starts_at?: any | null, reg_ends_at?: any | null, paid?: boolean | null, staking_for_rsvp: boolean, contact_email?: any | null, coc_url?: string | null, tnc_url?: string | null, logo?: string | null } | null, prizes: Array<{ __typename?: 'prizes', amount?: any | null }>, tracks: Array<{ __typename?: 'hackathon_tracks', uuid: string }> }> };

export type UserHackathonTeamQueryVariables = Exact<{
  hackathonSlug: Scalars['citext'];
}>;


export type UserHackathonTeamQuery = { __typename?: 'query_root', me?: { __typename?: 'users', user_hackathons: Array<{ __typename?: 'user_hackathons', team?: { __typename?: 'teams', name: string, uuid: string, code: any, status?: any | null, admin: { __typename?: 'users', uuid: string, username: any, first_name?: string | null, last_name?: string | null, profileImage?: string | null }, members?: Array<{ __typename?: 'users', uuid: string, username: any, first_name?: string | null, last_name?: string | null, profileImage?: string | null }> | null } | null }> } | null };

export type FetchSponsorJudgmentsCountQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
  sponsorUUID?: InputMaybe<Scalars['String']>;
}>;


export type FetchSponsorJudgmentsCountQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', sponsor_tiers: Array<{ __typename?: 'sponsor_tiers', sponsors: Array<{ __typename?: 'sponsors', uuid: string, winners_confirmed: boolean, sponsor_judgments_aggregate: { __typename?: 'sponsor_judgments_aggregate', aggregate?: { __typename?: 'sponsor_judgments_aggregate_fields', count: number } | null } }> }> }> };

export type JudgingProjectQueryVariables = Exact<{
  projectSlug: Scalars['citext'];
  hackathonSlug: Scalars['citext'];
}>;


export type JudgingProjectQuery = { __typename?: 'query_root', project_judgments: Array<{ __typename?: 'project_judgments', uuid: string, score?: any | null }>, projects: Array<{ __typename?: 'projects', uuid: string, links?: string | null, name: string, slug?: any | null, video_url?: string | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', name: string }> | null, project_tracks: Array<{ __typename?: 'project_tracks', prize_track: { __typename?: 'prize_tracks', name?: string | null } }>, builders?: Array<{ __typename?: 'users', uuid: string, username: any, firstName?: string | null }> | null }> };

export type GetMoreHackathonsQueryVariables = Exact<{
  slug: Scalars['citext'];
}>;


export type GetMoreHackathonsQuery = { __typename?: 'query_root', more_hackathons: Array<{ __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, devfolio_official?: boolean | null, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, rating: any, timezone?: string | null, participants_count?: number | null, participants_details?: any | null, themes: Array<{ __typename?: 'hackathon_themes', theme?: { __typename?: 'themes', name: any } | null }>, settings?: { __typename?: 'hackathon_settings', reg_starts_at?: any | null, reg_ends_at?: any | null, primary_color?: string | null, review?: boolean | null, site?: string | null, twitter?: string | null, facebook?: string | null, instagram?: string | null, medium?: string | null, telegram?: string | null, slack?: string | null, discord?: string | null, logo?: string | null } | null }> };

export type MyTopPublicProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTopPublicProjectsQuery = { __typename?: 'query_root', me?: { __typename?: 'users', public_profile_projects: Array<{ __typename?: 'user_public_profile_projects', project: { __typename?: 'projects', name: string, uuid: string, tagline?: string | null, favicon?: string | null, cover_img?: string | null } }> } | null };

export type PastJudgedProjectsQueryVariables = Exact<{
  hackathonSlug: Scalars['citext'];
}>;


export type PastJudgedProjectsQuery = { __typename?: 'query_root', project_judgments: Array<{ __typename?: 'project_judgments', uuid: string, notes?: string | null, score?: any | null, tags?: string | null, flagged: boolean, project?: { __typename?: 'projects', uuid: string, links?: string | null, name: string, slug?: any | null, video_url?: string | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', name: string }> | null, project_tracks: Array<{ __typename?: 'project_tracks', prize_track: { __typename?: 'prize_tracks', name?: string | null } }>, builders?: Array<{ __typename?: 'users', uuid: string, username: any, firstName?: string | null }> | null } | null }> };

export type PastOnlineJudgedProjectsQueryVariables = Exact<{
  hackathonSlug: Scalars['citext'];
}>;


export type PastOnlineJudgedProjectsQuery = { __typename?: 'query_root', me?: { __typename?: 'users', username: any, judges: Array<{ __typename?: 'judges', name: string, project_judgments: Array<{ __typename?: 'project_judgments', uuid: string, notes?: string | null, score?: any | null, tags?: string | null, flagged: boolean, project?: { __typename?: 'projects', uuid: string, links?: string | null, name: string, slug?: any | null, video_url?: string | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', name: string }> | null, project_tracks: Array<{ __typename?: 'project_tracks', prize_track: { __typename?: 'prize_tracks', name?: string | null } }>, builders?: Array<{ __typename?: 'users', uuid: string, username: any, firstName?: string | null }> | null } | null }> }> } | null };

export type GetPrizesByTrackQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
  trackUUID?: InputMaybe<Scalars['String']>;
}>;


export type GetPrizesByTrackQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', prize_tracks: Array<{ __typename?: 'prize_tracks', name?: string | null, prizes: Array<{ __typename?: 'prizes', uuid: string, name: string }> }> }> };

export type GetProjectFundingContributionsQueryVariables = Exact<{
  projectUUID: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetProjectFundingContributionsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', name: string, slug?: any | null, funding?: { __typename?: 'projects_funding', contributions: Array<{ __typename?: 'project_contributions', eas_uuid?: string | null, tx_network?: Project_Contribution_Tx_Network_Type_Enum | null, user?: { __typename?: 'users', username: any } | null, stickers: Array<{ __typename?: 'project_contribution_stickers', quantity: number, sticker?: { __typename?: 'stickers', name: string } | null }> }>, contributions_aggregate: { __typename?: 'project_contributions_aggregate', aggregate?: { __typename?: 'project_contributions_aggregate_fields', count: number } | null } } | null }> };

export type FetchProjectCommentsByUuidCommentFragment = { __typename?: 'comments', uuid: string, is_project_flag_comment: boolean, report_resolved: boolean, upvote_count?: number | null, downvote_count?: number | null, created_at: any, deleted: boolean, value?: string | null, descendants_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, user?: { __typename?: 'users', uuid: string, username: any, status?: any | null, verified: boolean, profile_image?: string | null } | null, user_comment?: Array<{ __typename?: 'user_comments', uuid: string, upvote?: boolean | null }>, project_contribution?: { __typename?: 'project_contributions', tx_network?: Project_Contribution_Tx_Network_Type_Enum | null, eas_uuid?: string | null, stickers: Array<{ __typename?: 'project_contribution_stickers', sticker?: { __typename?: 'stickers', name: string } | null }> } | null };

export type FetchProjectCommentsByUuidQueryVariables = Exact<{
  uuid: Scalars['String'];
  commentUUID: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  isAuthenticated: Scalars['Boolean'];
}>;


export type FetchProjectCommentsByUuidQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', uuid: string, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, commentsByUUID: Array<{ __typename?: 'comments', uuid: string, is_project_flag_comment: boolean, report_resolved: boolean, upvote_count?: number | null, downvote_count?: number | null, created_at: any, deleted: boolean, value?: string | null, descendants_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, user?: { __typename?: 'users', uuid: string, username: any, status?: any | null, verified: boolean, profile_image?: string | null } | null, user_comment?: Array<{ __typename?: 'user_comments', uuid: string, upvote?: boolean | null }>, project_contribution?: { __typename?: 'project_contributions', tx_network?: Project_Contribution_Tx_Network_Type_Enum | null, eas_uuid?: string | null, stickers: Array<{ __typename?: 'project_contribution_stickers', sticker?: { __typename?: 'stickers', name: string } | null }> } | null }>, comments: Array<{ __typename?: 'comments', uuid: string, is_project_flag_comment: boolean, report_resolved: boolean, upvote_count?: number | null, downvote_count?: number | null, created_at: any, deleted: boolean, value?: string | null, descendants_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, user?: { __typename?: 'users', uuid: string, username: any, status?: any | null, verified: boolean, profile_image?: string | null } | null, user_comment?: Array<{ __typename?: 'user_comments', uuid: string, upvote?: boolean | null }>, project_contribution?: { __typename?: 'project_contributions', tx_network?: Project_Contribution_Tx_Network_Type_Enum | null, eas_uuid?: string | null, stickers: Array<{ __typename?: 'project_contribution_stickers', sticker?: { __typename?: 'stickers', name: string } | null }> } | null }> }> };

export type ProjectQuadraticVotingsQueryVariables = Exact<{
  projectUUID: Scalars['String'];
}>;


export type ProjectQuadraticVotingsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', uuid: string, name: string, slug?: any | null, quadratic_voting_prize_pool_distribution?: any | null, quadratic_voting_votes?: any | null, quadratic_voting_quadratic_votes?: any | null, hackathons?: Array<{ __typename?: 'hackathons', slug?: any | null, settings?: { __typename?: 'hackathon_settings', quadratic_voting_currency?: Quadratic_Voting_Currency_Enum | null } | null }> | null, quadratic_votings_aggregate: { __typename?: 'quadratic_voting_projects_aggregate', aggregate?: { __typename?: 'quadratic_voting_projects_aggregate_fields', count: number } | null } }> };

export type QuadraticVotingAttestationsQueryVariables = Exact<{
  projectUUID: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type QuadraticVotingAttestationsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', uuid: string, quadratic_votings_aggregate: { __typename?: 'quadratic_voting_projects_aggregate', aggregate?: { __typename?: 'quadratic_voting_projects_aggregate_fields', count: number } | null }, quadratic_votings: Array<{ __typename?: 'quadratic_voting_projects', uuid: string, votes: number, quadratic_voting?: { __typename?: 'quadratic_voting', eas_uuid?: string | null, created_at: any, uuid: string } | null }> }> };

export type ShowUserPublicProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowUserPublicProfileQuery = { __typename?: 'query_root', me?: { __typename?: 'users', uuid: string, username: any, extra?: { __typename?: 'user_extras', show_public_profile?: boolean | null } | null } | null };

export type QuadraticVotingLeaderBoardQueryVariables = Exact<{
  hackathonUUID: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type QuadraticVotingLeaderBoardQuery = { __typename?: 'query_root', projects_aggregate: { __typename?: 'projects_aggregate', aggregate?: { __typename?: 'projects_aggregate_fields', count: number } | null }, projects: Array<{ __typename?: 'projects', uuid: string, name: string, slug?: any | null, quadratic_voting_prize_pool_distribution?: any | null, quadratic_voting_votes?: any | null, quadratic_voting_quadratic_votes?: any | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', name: string }> | null, hackathons?: Array<{ __typename?: 'hackathons', settings?: { __typename?: 'hackathon_settings', quadratic_voting_currency?: Quadratic_Voting_Currency_Enum | null } | null }> | null, builders?: Array<{ __typename?: 'users', uuid: string, first_name?: string | null, last_name?: string | null, username: any }> | null }> };

export type ShouldUserAccessKycQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ShouldUserAccessKycQueryQuery = { __typename?: 'query_root', me?: { __typename?: 'users', user_hackathon_bounties: Array<{ __typename?: 'user_hackathon_bounties', uuid: string }>, user_hackathons: Array<{ __typename?: 'user_hackathons', uuid: string }> } | null };

export type SponsorJudgmentsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
  sponsorUUID?: InputMaybe<Scalars['String']>;
}>;


export type SponsorJudgmentsQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', uuid: string, sponsor_tiers: Array<{ __typename?: 'sponsor_tiers', uuid: string, sponsors: Array<{ __typename?: 'sponsors', uuid: string, name?: string | null, prize_tracks: Array<{ __typename?: 'prize_tracks', uuid: string, name?: string | null, no_winners_reasons?: any | null, sponsor_judgments: Array<{ __typename?: 'sponsor_judgments', notes?: string | null, prize?: { __typename?: 'prizes', name: string, uuid: string } | null, project?: { __typename?: 'projects', uuid: string, name: string, author: Array<{ __typename?: 'user_hackathons', user?: { __typename?: 'users', first_name?: string | null } | null, team?: { __typename?: 'teams', name: string } | null }> } | null }> }> }> }> }> };

export type GetSponsorProjectTracksQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['citext']>;
  sponsorUUID?: InputMaybe<Scalars['String']>;
}>;


export type GetSponsorProjectTracksQuery = { __typename?: 'query_root', hackathons: Array<{ __typename?: 'hackathons', prize_tracks: Array<{ __typename?: 'prize_tracks', name?: string | null, uuid: string, project_tracks_aggregate: { __typename?: 'project_tracks_aggregate', aggregate?: { __typename?: 'project_tracks_aggregate_fields', count: number } | null } }> }> };

export type UserExperiencesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserExperiencesQuery = { __typename?: 'query_root', me?: { __typename?: 'users', experiences: Array<{ __typename?: 'experiences', uuid: string, title?: string | null, start?: any | null, type?: Experience_Type_Enum | null, current_company?: boolean | null, end?: any | null, description?: string | null, company?: { __typename?: 'company', uuid: string, name: string, logo?: string | null, domain?: any | null, favicon?: string | null } | null }> } | null };

export type UserHackathonHackathonTypeFragment = { __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, timezone?: string | null, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, v2_application_enabled?: boolean | null } | null };

export type UserHackathonTypeFragment = { __typename: 'user_hackathons', uuid: string, role?: any | null, status?: any | null, rsvp_time?: any | null, team?: { __typename?: 'teams', uuid: string, name: string, status?: any | null, members?: Array<{ __typename?: 'users', first_name?: string | null, username: any }> | null } | null, project?: { __typename?: 'projects', name: string, status?: any | null, slug?: any | null } | null, hackathon?: { __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, timezone?: string | null, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, v2_application_enabled?: boolean | null } | null } | null, feedbacks_aggregate: { __typename?: 'user_hackathon_feedbacks_aggregate', aggregate?: { __typename?: 'user_hackathon_feedbacks_aggregate_fields', count: number } | null } };

export type FetchMyHackathonsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMyHackathonsQuery = { __typename?: 'query_root', me?: { __typename?: 'users', ongoing_hackathons: Array<{ __typename: 'user_hackathons', uuid: string, role?: any | null, status?: any | null, rsvp_time?: any | null, team?: { __typename?: 'teams', uuid: string, name: string, status?: any | null, members?: Array<{ __typename?: 'users', first_name?: string | null, username: any }> | null } | null, project?: { __typename?: 'projects', name: string, status?: any | null, slug?: any | null } | null, hackathon?: { __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, timezone?: string | null, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, v2_application_enabled?: boolean | null } | null } | null, feedbacks_aggregate: { __typename?: 'user_hackathon_feedbacks_aggregate', aggregate?: { __typename?: 'user_hackathon_feedbacks_aggregate_fields', count: number } | null } }>, past_hackathons: Array<{ __typename: 'user_hackathons', uuid: string, role?: any | null, status?: any | null, rsvp_time?: any | null, team?: { __typename?: 'teams', uuid: string, name: string, status?: any | null, members?: Array<{ __typename?: 'users', first_name?: string | null, username: any }> | null } | null, project?: { __typename?: 'projects', name: string, status?: any | null, slug?: any | null } | null, hackathon?: { __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, timezone?: string | null, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, v2_application_enabled?: boolean | null } | null } | null, feedbacks_aggregate: { __typename?: 'user_hackathon_feedbacks_aggregate', aggregate?: { __typename?: 'user_hackathon_feedbacks_aggregate_fields', count: number } | null } }>, upcoming_hackathons: Array<{ __typename: 'user_hackathons', uuid: string, role?: any | null, status?: any | null, rsvp_time?: any | null, team?: { __typename?: 'teams', uuid: string, name: string, status?: any | null, members?: Array<{ __typename?: 'users', first_name?: string | null, username: any }> | null } | null, project?: { __typename?: 'projects', name: string, status?: any | null, slug?: any | null } | null, hackathon?: { __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, timezone?: string | null, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, v2_application_enabled?: boolean | null } | null } | null, feedbacks_aggregate: { __typename?: 'user_hackathon_feedbacks_aggregate', aggregate?: { __typename?: 'user_hackathon_feedbacks_aggregate_fields', count: number } | null } }>, hackathon_reminders: Array<{ __typename: 'user_hackathon_reminders', hackathon?: { __typename?: 'hackathons', uuid: string, slug?: any | null, name: any, type: Hackathon_Type_Enum, starts_at?: any | null, ends_at?: any | null, is_online?: boolean | null, devfolio_official?: boolean | null, timezone?: string | null, settings?: { __typename?: 'hackathon_settings', reg_ends_at?: any | null, reg_starts_at?: any | null, review?: boolean | null, v2_application_enabled?: boolean | null } | null } | null }> } | null };

export type UserProjectVotesQueryVariables = Exact<{
  hackathonUUID: Scalars['String'];
}>;


export type UserProjectVotesQuery = { __typename?: 'query_root', me?: { __typename?: 'users', user_hackathons: Array<{ __typename?: 'user_hackathons', uuid: string, project?: { __typename?: 'projects', uuid: string, name: string, slug?: any | null, quadratic_voting_prize_pool_distribution?: any | null, quadratic_voting_votes?: any | null, quadratic_voting_quadratic_votes?: any | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', name: string }> | null, builders?: Array<{ __typename?: 'users', uuid: string, first_name?: string | null, last_name?: string | null, username: any }> | null, hackathons?: Array<{ __typename?: 'hackathons', settings?: { __typename?: 'hackathon_settings', quadratic_voting_currency?: Quadratic_Voting_Currency_Enum | null } | null }> | null, quadratic_votings_aggregate: { __typename?: 'quadratic_voting_projects_aggregate', aggregate?: { __typename?: 'quadratic_voting_projects_aggregate_fields', count: number } | null } } | null }> } | null };

export type MyProjectTypeFragment = { __typename?: 'projects', uuid: string, name: string, slug?: any | null, status?: any | null, tagline?: string | null, likes?: number | null, views?: number | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', uuid: string, name: string }> | null, user_hackathons: Array<{ __typename?: 'user_hackathons', uuid: string }>, hackathons?: Array<{ __typename?: 'hackathons', name: any, slug?: any | null }> | null, winning_prizes: Array<{ __typename?: 'winners', prize?: { __typename?: 'prizes', uuid: string, name: string, amount?: any | null, currency?: string | null, desc?: string | null, logo?: string | null, sponsors: Array<{ __typename?: 'prize_sponsors', sponsor?: { __typename?: 'sponsors', name?: string | null, uuid: string } | null }> } | null }> };

export type FetchMyProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMyProjectsQuery = { __typename?: 'query_root', me?: { __typename?: 'users', published_projects?: Array<{ __typename?: 'projects', uuid: string, name: string, slug?: any | null, status?: any | null, tagline?: string | null, likes?: number | null, views?: number | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', uuid: string, name: string }> | null, user_hackathons: Array<{ __typename?: 'user_hackathons', uuid: string }>, hackathons?: Array<{ __typename?: 'hackathons', name: any, slug?: any | null }> | null, winning_prizes: Array<{ __typename?: 'winners', prize?: { __typename?: 'prizes', uuid: string, name: string, amount?: any | null, currency?: string | null, desc?: string | null, logo?: string | null, sponsors: Array<{ __typename?: 'prize_sponsors', sponsor?: { __typename?: 'sponsors', name?: string | null, uuid: string } | null }> } | null }> }> | null, draft_projects?: Array<{ __typename?: 'projects', uuid: string, name: string, slug?: any | null, status?: any | null, tagline?: string | null, likes?: number | null, views?: number | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', uuid: string, name: string }> | null, user_hackathons: Array<{ __typename?: 'user_hackathons', uuid: string }>, hackathons?: Array<{ __typename?: 'hackathons', name: any, slug?: any | null }> | null, winning_prizes: Array<{ __typename?: 'winners', prize?: { __typename?: 'prizes', uuid: string, name: string, amount?: any | null, currency?: string | null, desc?: string | null, logo?: string | null, sponsors: Array<{ __typename?: 'prize_sponsors', sponsor?: { __typename?: 'sponsors', name?: string | null, uuid: string } | null }> } | null }> }> | null } | null };

export type UserPublicProfileQueryVariables = Exact<{
  username: Scalars['citext'];
}>;


export type UserPublicProfileQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', uuid: string, username: any, first_name?: string | null, last_name?: string | null, bio?: string | null, short_bio?: string | null, profile_image?: string | null, profiles: Array<{ __typename?: 'user_profiles', uuid: string, value: string, profile?: { __typename?: 'profiles', uuid: string, name: any } | null }>, skills: Array<{ __typename?: 'user_skills', skill?: { __typename?: 'skills', uuid: string, status?: any | null, name: any, logo?: string | null } | null }>, experiences: Array<{ __typename?: 'experiences', uuid: string, start?: any | null, end?: any | null, current_company?: boolean | null, description?: string | null, location?: string | null, title?: string | null, company?: { __typename?: 'company', uuid: string, name: string, domain?: any | null, verified?: boolean | null, _favicon?: string | null, logo?: string | null } | null }>, address?: { __typename?: 'address', city?: string | null, country?: string | null } | null, extra?: { __typename?: 'user_extras', is_2586_labs_team_member?: boolean | null, show_location_on_profile?: boolean | null, profile_onboarding_complete?: boolean | null, show_public_profile?: boolean | null } | null, profile_layout_elements: Array<{ __typename?: 'user_public_profile_layout', uuid: string, type: string, size: string, order: number, preferences: any }>, public_profile_projects: Array<{ __typename?: 'user_public_profile_projects', project: { __typename?: 'projects', name: string, uuid: string, slug?: any | null, tagline?: string | null, description?: any | null, pictures?: string | null, links?: string | null, source_code_url?: string | null, favicon?: string | null, winning_prizes_aggregate: { __typename?: 'winners_aggregate', aggregate?: { __typename?: 'winners_aggregate_fields', count: number } | null } } }>, rss_feeds: Array<{ __typename?: 'user_profile_rss_feeds', uuid: string, platform: User_Profile_Rss_Feed_Platforms_Enum, url: string }> }> };

export type QvRequestAccessStatusQueryVariables = Exact<{
  hackathonUUID: Scalars['String'];
  userUUID: Scalars['String'];
}>;


export type QvRequestAccessStatusQuery = { __typename?: 'query_root', quadratic_voting_request_access: Array<{ __typename?: 'quadratic_voting_request_access', status: Quadratic_Voting_Request_Access_Status_Enum }> };

export type UserQuadraticVotesQueryVariables = Exact<{
  hackathonUUID: Scalars['String'];
}>;


export type UserQuadraticVotesQuery = { __typename?: 'query_root', me?: { __typename?: 'users', user_hackathons: Array<{ __typename?: 'user_hackathons', uuid: string, quadratic_voting?: { __typename?: 'quadratic_voting', uuid: string, eas_uuid?: string | null, tx_hash?: string | null, projects: Array<{ __typename?: 'quadratic_voting_projects', uuid: string, votes: number, project?: { __typename?: 'projects', uuid: string, name: string, slug?: any | null, favicon?: string | null, teams?: Array<{ __typename?: 'teams', name: string }> | null, builders?: Array<{ __typename?: 'users', uuid: string, first_name?: string | null, last_name?: string | null, username: any }> | null } | null }> } | null }> } | null };

export type UserReferralCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserReferralCodeQuery = { __typename?: 'query_root', me?: { __typename?: 'users', extra?: { __typename?: 'user_extras', ref_code?: any | null } | null } | null };

export type GetShippingAddressesForUserQueryVariables = Exact<{
  username: Scalars['citext'];
}>;


export type GetShippingAddressesForUserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', uuid: string, username: any, shipping_addresses: Array<{ __typename?: 'shop_shipping_addresses', uuid: string, full_name: string, address: string, pincode: string, city: string, state: string, country: string, phone_number: string, email: string }> }> };

export type UserTwitterProfileQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type UserTwitterProfileQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', profiles: Array<{ __typename?: 'user_profiles', value: string }> }> };

export type QuadraticVotesEasuuidSubscriptionVariables = Exact<{
  votesUUID: Scalars['String'];
}>;


export type QuadraticVotesEasuuidSubscription = { __typename?: 'subscription_root', quadratic_voting: Array<{ __typename?: 'quadratic_voting', uuid: string, eas_uuid?: string | null }> };

export type EmailVerifiedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type EmailVerifiedSubscription = { __typename?: 'subscription_root', me?: { __typename?: 'users', email_verified?: boolean | null } | null };

export type SubscribeCredentialDetailsSubscriptionVariables = Exact<{
  credentialUUID?: InputMaybe<Scalars['String']>;
}>;


export type SubscribeCredentialDetailsSubscription = { __typename?: 'subscription_root', me?: { __typename?: 'users', user_hackathon_credentials: Array<{ __typename?: 'user_hackathon_credentials', token_id?: string | null }> } | null };

export type CurrentUserStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserStatusSubscription = { __typename?: 'subscription_root', me?: { __typename?: 'users', status?: any | null } | null };

// ------ Copy this and add back after autogen deletes this (todo: move this to some other file)

export type SiweGenerateNonceMutationVariables = Exact<{ [key: string]: never }>;

export type SiweGenerateNonceMutation = {
  __typename?: 'mutation_root';
  siwe_generateNonce: { __typename?: 'SiweGenerateNonceOutput'; nonce: string };
};


export type PublishedProjectBySlugsQueryVariables = Exact<{
  slugs?: Array<Scalars['citext']>;
}>;

export type PublishedProjectBySlugsQuery = {
  __typename?: 'query_root';
  projects: Array<{
    __typename?: 'projects';
    uuid: string;
    slug: string;
    name: string;
    tagline?: string | null;
    favicon?: string;
    teams: {
      name: string;
    }[];
    builders: {
      uuid: string;
      username: string;
      firstName: string;
      lastName: string;
      profileImage: string;
    }[];
  }>;
};

// ----- END OF BLOCK

